/**
 * Dark Mode Initialization Script
 *
 * This script runs BEFORE Angular app initialization to prevent
 * flash of wrong theme (FOUT - Flash of Unstyled Theme).
 *
 * It applies the dark theme class immediately based on:
 * 1. localStorage preference
 * 2. Device preference (prefers-color-scheme)
 *
 * This should be loaded as early as possible in index.html
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'endeksa-dark-mode';

    /**
     * Get dark mode preference from query string, localStorage, or device
     */
    function shouldUseDarkMode() {
        // 1. Check query string first (highest priority - for deep links, sharing, etc.)
        try {
            var queryString = new URL(window.location.toString()).searchParams;
            var themeParam = queryString.get('theme');

            if (themeParam === 'dark') {
                // Store in localStorage for persistence
                localStorage.setItem(STORAGE_KEY, 'dark');
                return true;
            }
            if (themeParam === 'light') {
                // Store in localStorage for persistence
                localStorage.setItem(STORAGE_KEY, 'light');
                return false;
            }
        } catch (e) {
            // URL parsing failed - continue to next check
            console.warn('Unable to parse URL for theme parameter');
        }

        // 2. Check localStorage (manual user preference)
        try {
            var storedPreference = localStorage.getItem(STORAGE_KEY);
            if (storedPreference === 'dark') {
                return true;
            }
            if (storedPreference === 'light') {
                return false;
            }
        } catch (e) {
            // localStorage not available (privacy mode, etc.)
            console.warn('localStorage not available for dark mode');
        }

        // 3. Check device preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return true;
        }

        // 4. Default to light mode
        return false;
    }

    /**
     * Apply dark theme class immediately
     */
    function applyDarkMode() {
        var darkMode = shouldUseDarkMode();
        var htmlElement = document.documentElement;
        var bodyElement = document.body;

        if (darkMode) {
            htmlElement.classList.add('dark-mode');
            // Body class will be added when body element is available
            if (bodyElement) {
                bodyElement.classList.add('dark-mode');
            } else {
                // Add body class when DOM is ready
                document.addEventListener('DOMContentLoaded', function () {
                    document.body.classList.add('dark-mode');
                });
            }
            window.darkMode = true;
        } else {
            htmlElement.classList.remove('dark-mode');
            if (bodyElement) {
                bodyElement.classList.remove('dark-mode');
            }
            window.darkMode = false;
        }
    }

    // Apply theme immediately
    applyDarkMode();

    // Listen for storage changes from other tabs
    window.addEventListener('storage', function (e) {
        if (e.key === STORAGE_KEY) {
            applyDarkMode();
        }
    });

    // Expose utility for debugging
    window.darkModeUtil = {
        isActive: function () {
            return document.documentElement.classList.contains('dark-mode');
        },
        enable: function () {
            localStorage.setItem(STORAGE_KEY, 'dark');
            applyDarkMode();
        },
        disable: function () {
            localStorage.setItem(STORAGE_KEY, 'light');
            applyDarkMode();
        },
        reset: function () {
            localStorage.removeItem(STORAGE_KEY);
            applyDarkMode();
        }
    };
})();

angular.module('app.core', []);
angular.module('app.security', ['angular-ladda', 'ngDialog', 'hl.sticky']);
// angular.module('app.security').run(["$rootScope", "MetaTags",
//     function ($rootScope, MetaTags) {
//         $rootScope.MetaTags = MetaTags;
//     }
// ]);
(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('signin', {
                url: '/:langcode/signin?status?info?type?code?email',
                templateUrl: 'app/security/auth-signin/auth-signin.html',
                controller: 'SignInController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    info: null,
                    type: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'securityExternal');
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_signin').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_signin_desc').then(function (res) {
                            return res;
                        });
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info && $transition$.params().status !== 'guard') {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }]
                },
                metaTags: {
                    title: '{{title}}',
                    robots: 'noindex, nofollow',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })

            .state('code', {
                url: '/:langcode/signin/code?code',
                templateUrl: 'app/security/auth-two-factor/auth-two-factor.html',
                controller: 'TwoFactorController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info && $transition$.params().status !== 'guard') {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('unblock', {
                url: '/:langcode/unblockuser?token&email',
                templateUrl: 'app/security/auth-unblock-user/auth-unblock-user.html',
                controller: 'UnblockUserController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('register', {
                url: '/:langcode/register',
                templateUrl: 'app/security/auth-register/auth-register.html',
                controller: 'RegisterController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'securityExternal');
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_register').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_register_desc').then(function (res) {
                            return res;
                        });
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info) {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }],
                    //
                    // translations: function ($translatePartialLoader, $translate) {
                    //     $translatePartialLoader.addPart("contract_agreement");
                    //     return $translate.refresh();
                    // }
                },
                metaTags: {
                    title: '{{title}}',
                    robots: 'noindex, nofollow',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })

            .state('confirmEmail', {
                url: '/:langcode/confirm?email',
                templateUrl: 'app/security/auth-confirm-email/auth-confirm-email.html',
                controller: 'ConfirmEmailController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('activateEmail', {
                url: '/:langcode/activation?email',
                templateUrl: 'app/security/auth-activate-email/auth-activate-email.html',
                controller: 'ActivateEmailController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('forgotPassword', {
                url: '/:langcode/forgot',
                templateUrl: 'app/security/auth-forgot-password/auth-forgot-password.html',
                controller: 'ForgotPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('resetPassword', {
                url: '/:langcode/resetpassword?key?email?token',
                templateUrl: 'app/security/auth-reset-password/auth-reset-password.html',
                controller: 'ResetPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    token: null,
                    email: null,
                    key: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('newPassword', {
                url: '/:langcode/createpassword?token?email?key',
                templateUrl: 'app/security/auth-new-password/auth-new-password.html',
                controller: 'NewPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    token: null,
                    email: null,
                    key: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                // Additional resolves can be added here: {
                //
                // translations: function ($translatePartialLoader, $translate) {
                //     $translatePartialLoader.addPart("contract_agreement");
                //     return $translate.refresh();
                // }
                // },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('externalauth', {
                url: '/externalauth/:function'
            }).state('confirmuser', {
                url: '/:langcode/confirmuser',
                params: {
                    langcode: { squash: true, value: null },
                }
            }).state('renew', {
                url: '/resetpassword'
            }).state('sso', {
                url: '/:langcode/sso/:guid',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    guid: null
                },
                resolve: {
                    verify: ['auth_factory', '$transition$', 'restoreUrlService', '$window', 'notifierSvc', '$translate', 'CacheFactory', 'userSvc',
                        function (auth_factory, $transition$, restoreUrlService, $window, notifierSvc, $translate, CacheFactory, userSvc) {
                            auth_factory.verify_partner_login({ VerificationToken: $transition$.params().guid })
                                .$promise.then(function (result) {
                                    $window.localStorage.setItem('accessToken', result.accessToken);
                                    $window.localStorage.setItem('accessTokenExpires', result.accessTokenExpiration);
                                    $window.localStorage.setItem('refreshToken', result.refreshToken);
                                    $window.localStorage.setItem('refreshTokenExpires', result.refreshTokenExpiration);
                                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                    userSvc.getUserInfo().then((res) => {
                                        restoreUrlService.returnTo(true);
                                    });

                                }, function () {
                                    notifierSvc.show({ message: $translate.instant('sso_error'), type: 'error' });
                                    $transition$.router.stateService.go('signin', { langcode: window.lang });
                                });
                        }]
                }
            });
    }]);
})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider

            .state('BlogList', {
                url: "/:langcode/blog{dummyParam:any}?p?q",
                templateUrl: './app/blog/blog-list.html',
                controller: "BlogListController",
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blog');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }],

                    title: ['$translate', function ($translate) {
                        return $translate('c_blog_title').then(function (res) {
                            return res;
                        });
                    }],

                    description: ['$translate', function ($translate) {
                        return $translate('c_blog_desc').then(function (res) {
                            return res;
                        });
                    }]
                },
                metaTags: {
                    title: '{{title}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg'
                    }
                }
            })


            .state('blogKategori', {
                url: '/:langcode/blog/c/:kategori?p?q',
                templateUrl: './app/blog/blog-list.html',
                controller: "BlogListController",
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blog');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],

                    titleAdres: ['getCat', '$translate', function (getCat, $translate) {
                        if (getCat)
                            for (var i = 0; i < getCat.length; i++) {
                                if (getCat[i].selected)
                                    return getCat[i].name;
                            }
                        else
                            return $translate.instant('c_blog_title');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }],
                    // title: function ($translate) {
                    //     return $translate('c_blog_title').then(function (res) {
                    //         return res;
                    //     });
                    // },

                    description: ['$translate', function ($translate) {
                        return $translate('c_blog_desc').then(function (res) {
                            return res;
                        });
                    }]
                },
                metaTags: {
                    title: '{{titleAdres}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg'
                    }
                }
            })

            .state('blogDuzenle', {
                url: '/:langcode/blog/edit/:name',
                templateUrl: 'app/blog/blog-edit.html',
                controller: 'BlogEditController',
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blogEditor');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    guard: ['guardSvc', function (guardSvc) {
                        return guardSvc.guardRouteRole([20, 50, 40]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                }

            })

            .state('blogEkle', {
                url: '/:langcode/blog/add/',
                templateUrl: 'app/blog/blog-edit.html',
                controller: 'BlogEditController',
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blogEditor');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    guard: ['guardSvc', function (guardSvc) {
                        return guardSvc.guardRouteRole([20, 50, 40]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                }

            })

            .state('blogDetail', {
                url: "/:langcode/blog/{path:article|yazi|artigo|articulo}/:name",
                templateUrl: './app/blog/blog-detail.html',
                controller: "BlogDetailController",
                controllerAs: "vm",
                params: {
                    path: ['$translate', function ($translate) {
                        return $translate.instant("blogDetail");
                    }],
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        var bundles = ['blogDetail'];
                        return lazyLoadSvc.load($transition$, bundles);
                    }],

                    LangProtect: ['routeHelpers', function (routeHelpers) {
                        return routeHelpers.langProtect();
                    }],

                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    blogPost: ['blog_factory', '$transition$', '$translate', '$timeout', '$rootScope', '$q', function (blog_factory, $transition$, $translate, $timeout, $rootScope, $q) {
                        var blogDetay = blog_factory.get({ name: $transition$.params().name, language: window.langCode() });
                        var deferred = $q.defer();
                        blogDetay.$promise.then(
                            function (resp) {
                                if (resp) {
                                    if (resp.statusCode === 301) {
                                        $timeout(function () {
                                            $rootScope.MetaTags.prerender.statusCode = 301;
                                            window.redirected = "Location: " + $transition$.router.stateService.href("blogDetail", { langcode: $transition$.params().langcode, name: resp.redirectToActionActiveSlug, path: $translate.instant("blogDetail") });
                                            $rootScope.MetaTags.prerender.header = window.redirected;
                                        });
                                        $transition$.abort();
                                        $transition$.router.stateService.go("blogDetail", { langcode: $transition$.params().langcode, name: resp.redirectToActionActiveSlug, path: $translate.instant("blogDetail") });
                                        deferred.resolve();
                                    }
                                    else {
                                        if (resp.urlHistory && resp.urlHistory.length)
                                            window.blogUrls = resp.urlHistory.filter(m => m.isActive);

                                        if (!resp || !resp.details.length) {
                                            $transition$.abort();
                                            $transition$.router.stateService.go("BlogList", { langcode: $transition$.params().langcode });
                                        }
                                        deferred.resolve(resp);
                                    }
                                } else {
                                    $translate('c_blog1').then(function (res) {
                                        deferred.resolve(res);
                                    });
                                }
                            },
                            function (rej) {
                                // if (rej.status === 404) {
                                $translate('c_blog2').then(function (res) {
                                    deferred.resolve(res);
                                });
                                // } else {
                                //     $translate('c_blog1').then(function (res) {
                                //         deferred.resolve(res);
                                //     });
                                // }
                            });

                        return deferred.promise;
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                },
                metaTags: {

                    title: ['blogPost', function (blogPost) {
                        return blogPost.details && blogPost.details[0].title;
                    }],

                    description: ['blogPost', function (blogPost) {
                        return blogPost.details && blogPost.details[0].metaDescription;
                    }],
                    prerender: {

                        statusCode: ['blogPost', function (blogPost) {
                            return blogPost.details ? 200 : 302;
                        }],

                        header: ['blogPost', function (blogPost) {
                            return blogPost.details ? null : 'Location: https://www.endeksa.com/blog';
                        }]
                    },
                    properties: {
                        // 'og:image': ['blogPost', function (blogPost) {
                        //     return blogPost.OneCikanResimPath.replace('https', 'http');
                        // }],
                        'og:image': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].featuredPhoto.replace('https://', 'http://');
                        }],
                        'og:image:secure_url': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].featuredPhoto.replace('http://', 'https://');
                        }],
                        // 'og:image:type': 'image/jpeg',
                        'fb:admins': '504791212',
                        'og:type': 'article',
                        'article:published_time': '{{blogPost.createDate}}',
                        'article:tag': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].metas;
                        }]
                    }
                }
            });

    }]);

})();

(function () {
    "use strict";

    angular.module("app.core").config([
        "$stateProvider",
        function ($stateProvider) {
            /*
             *
             *   make sure you write new-states under:
             *   address, province, county & neighbourhood
             *
             * */
            $stateProvider
                .state("analysis", {
                    abstract: true,
                    url: "/:langcode/{path:analiz|analysis|analisis|analise}",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },

                        path: ['$translate', function ($translate) {
                            return $translate.instant("analysis");
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/layout.html",
                    controller: "LayoutController",
                    controllerAs: "vm",
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Load base regional analysis bundle
                            return lazyLoadSvc.load($transition$, 'regionalAnalysis').then(function () {

                                return guardSvc.hasPackage([
                                    "eco-package",
                                    "seller-lead-package",
                                    "premium-package",
                                    "premiumplus-package",
                                    "pro-ee-package",
                                    "flex-package",
                                    "gold-package",
                                    "terminal-flex-package",
                                    "terminal-pro-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package",
                                    "location-package",
                                    "real-estate-package"
                                ]).then(function (HasProPackage) {
                                    if (HasProPackage) {
                                        return lazyLoadSvc.load($transition$, 'regionalAnalysisMember');
                                    }
                                }).then(function () {
                                    // Check for premium packages and load additional bundles
                                    return guardSvc.hasPackage([
                                        "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "location-package",
                                        "real-estate-package"
                                    ]).then(function (HasPremiumPlus) {
                                        if (HasPremiumPlus) {
                                            return lazyLoadSvc.load($transition$, 'regionalAnalysisPremium');
                                        }
                                    }).then(function () {
                                        return guardSvc.hasPackage([
                                            "platinum-package",
                                            "premium-ee-package",
                                            "terminal-premium-package",
                                            "terminal-package",
                                            "location-package",
                                            "real-estate-package"
                                        ]).then(function (HasPlatinumOrRealEstate) {
                                            if (HasPlatinumOrRealEstate) {
                                                return lazyLoadSvc.load($transition$, 'regionalAnalysisPlatinum');
                                            }
                                        });
                                    });
                                });
                            });
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect('analysis');
                        }],
                        TypeProtect: ['$transition$', '$translate', '$rootScope', '$timeout', function ($transition$, $translate, $rootScope, $timeout) {
                            const satilik = $transition$.params().satilik;
                            const konut = $transition$.params().konut;


                            var redirect = false;
                            if (satilik && satilik !== $translate.instant('kiralik') && satilik !== $translate.instant('satilik')) {
                                redirect = true;
                            }
                            if (konut && konut !== $translate.instant('konut')
                                && konut !== $translate.instant('ticari')
                                && konut !== $translate.instant('arazi')
                                && konut !== $translate.instant('arsa')) {
                                redirect = true;
                            }
                            if (redirect) {

                                // console.error(konut, $translate.instant('konut'), $translate.instant('ticari'), $translate.instant('arsa'), $translate.instant('arazi'));
                                // console.error(satilik, $translate.instant('satilik'), $translate.instant('kiralik'));
                                // $transition$.abort();
                                // $transition$.router.stateService.go("404", { langcode: $transition$.params().langcode });

                                var rental = satilik !== $translate.instant('kiralik') ? "satilik" : "kiralik";
                                var type;
                                if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("ticari") ||
                                    $transition$.params().konut === $translate.instant("plaza") ||
                                    $transition$.params().konut === $translate.instant("industrial") ||
                                    $transition$.params().konut === $translate.instant("ofis") ||
                                    $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                    $transition$.params().konut === $translate.instant("dukkan"))
                                    type = $translate.instant("ticari");
                                else if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("tarla") ||
                                    $transition$.params().konut === $translate.instant("arazi") ||
                                    $transition$.params().konut === $translate.instant("bahce"))
                                    type = $translate.instant("arazi");
                                else if ($transition$.params().konut &&
                                    $transition$.params().konut === $translate.instant("arsa"))
                                    type = $translate.instant("arsa");
                                else
                                    type = $translate.instant("konut");

                                $timeout(function () {
                                    $rootScope.MetaTags.prerender.statusCode = 301;
                                    window.redirected = "Location: " + $transition$.router.stateService.href($transition$.to().name, { konut: $translate.instant(type), satilik: $translate.instant(rental), langcode: $transition$.params().langcode, country: $transition$.params().country, province: $transition$.params().province, county: $transition$.params().county, neighbourhood: $transition$.params().neighbourhood, address: $transition$.params().address, path: $transition$.params().path, path3: $transition$.params().path3 });
                                    $rootScope.MetaTags.prerender.header = window.redirected;
                                });
                                $transition$.abort();
                                $transition$.router.stateService.go($transition$.to().name, { konut: $translate.instant(type), satilik: $translate.instant(rental), langcode: $transition$.params().langcode, country: $transition$.params().country, province: $transition$.params().province, county: $transition$.params().county, neighbourhood: $transition$.params().neighbourhood, address: $transition$.params().address, path: $transition$.params().path, path3: $transition$.params().path3 });
                            }
                        }],

                        HasPackage: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage();
                        }],

                        HasDemo: ['guardSvc', 'HasPackage', function (guardSvc, HasPackage) {
                            return !HasPackage ? guardSvc.hasDemo('analysis') : false;
                        }],

                        HasRealEstate: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "real-estate-package",
                                "location-package",
                            ]);
                        }],

                        HasPlatinum: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "location-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package"
                            ]);
                        }],

                        HasPro: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "basic-package",
                                "eco-package",
                                "seller-lead-package",
                                "premium-package",
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasPremium: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "basic-package",
                                "eco-package",
                                "seller-lead-package",
                                "premium-package",
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasPremiumPlus: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage([
                                "premiumplus-package",
                                "pro-ee-package",
                                "flex-package",
                                "gold-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasLocation: ['guardSvc', function (guardSvc) {
                            return guardSvc.hasPackage(["location-package"]);
                        }],

                        // MonthlyPackage: ['guardSvc', function (guardSvc) {
                        //     return guardSvc.monthlyPackage();
                        // }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_layout");
                            $translatePartialLoader.addPart("authentication");
                            $translatePartialLoader.addPart("endeks_modal");
                            // $translatePartialLoader.addPart("contract_agreement");
                            return $translate.refresh();
                        }]
                    },
                })
                .state("analysis.address", {
                    abstract: true,
                    url: "/l/:address",
                    params: {
                        address: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleAdres: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().address && $transition$.params().address.indexOf(";") === -1 &&
                                $transition$.params().address.indexOf("%252C") === -1
                            )
                                return (
                                    $transition$
                                        .params()
                                        .address.replaceAllString("-", ", ")
                                        .toLocaleProperCase2("tr-tr") + ", "
                                );
                            return "";//$translate.instant('title_nolocation');
                        }],
                    },
                })
                .state("analysis.address.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?rad?top?ref?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        l: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionValue: ['$translate', function ($translate) {
                            return $translate('c_an_keygen').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleAdres}}{{satilikTitle}} {{type}} {{fiyatlari}}, {{descriptionValue}} {{fiyatlari}}, {{descriptionValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.demographics", {
                    url: "/{path3:demografi|demography|demografia}?rad?top?ref?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleAddressDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressDemo}}",
                        description: "{{titleAdres}}{{descriptionAddressDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }]
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec3').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressElec}}",
                        description: "{{titleAdres}}{{descriptionAddressElec}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.address.competition", {
                    url: "/competition?oi?rad?d?ti?le",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],
                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.find", {
                    url: "/find?p?q?le",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        }
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_find1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.comparables", {
                    url: "/comparables?rad?top?ref?le?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",

                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }

                })
                .state("analysis.address.investment", {
                    url: "/investment?rad?top?ref?le?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",

                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        description: "{{titleAdres}}{{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }

                })

                .state("analysis.address.locations", {
                    url: "/locations?rad?d?ti?oi?le",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAdressEdu}}",
                        description: "{{titleAdres}}{{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {


                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} {{titleAddressTrans}}",
                        description: "{{titleAdres}}{{descriptionAddressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website"
                        },
                    },
                })
                .state("analysis.address.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressLife}}",
                        description: "{{titleAdres}}{{descriptionAddressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },

                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressHealth}}",
                        description: "{{titleAdres}}{{descriptionAddressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressEntertain}}",
                        description: "{{titleAdres}}{{descriptionAddressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.agents", {
                    url: "/agents?p?c?rad?top?ref?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleAddressOpporPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAddressOpporPrepend}}{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?rad?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],


                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        }
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.address.malls", {
                    url: "/malls?p?o?s?str?c?a?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if (!$transition$.params().address && $transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressOppor: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}}{{titleAddressOppor}}",
                        description: "{{titleAdres}}{{descriptionAddressOppor}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}",
                    // params: {
                    //     country: {
                    //         value: null,
                    //     }
                    // },
                    resolve: {

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            function (searchParserService, $transition$) {
                                return searchParserService.parseSearchForController(
                                    $transition$.params(),
                                    $transition$
                                );
                            },
                        ],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                var title = resolveAPIs.Country;
                                title = title === "world" ? $translate.instant("World") : $translate.instant(title);
                                return title;
                            },
                        ],
                    },
                })
                .state("analysis.country.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        titleProvValueDescription2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{titleProvValueDescription2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.country.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvDemo}}",
                        description: "{{titleProvince}}{{descriptionProvDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'world' ? 'noindex, nofollow' : 'index', 'follow'; }]
                    },
                })
                .state("analysis.country.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }]
                    },
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            // if ($transition$.params().country !== 'turkiye') {
                            $transition$.abort();
                            $transition$.router.stateService.go("404", { langcode: window.lang });
                            // }
                        }],

                        titleProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvElec}}",
                        description: "{{titleProvince}}{{descriptionProvElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: 'noindex, nofollow'
                    }
                })

                .state("analysis.country.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        description: "{{titleProvince}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleProvOpportPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvOpportPrepend}}{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.country.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?name?ct?ppt?pt?lt?room?areamax?areamin?pricemax?pricemin?age?bosp?city?lake?nature?sea?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            function (searchParserService, $transition$) {
                                return searchParserService.parseSearchForController(
                                    $transition$.params(),
                                    $transition$
                                );
                            },
                        ],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],
                    },
                })
                .state("analysis.province.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        titleProvValueDescription2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{titleProvValueDescription2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.province.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvDemo}}",
                        description: "{{titleProvince}}{{descriptionProvDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionProvElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvElec}}",
                        description: "{{titleProvince}}{{descriptionProvElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })

                .state("analysis.province.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],
                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{return}}",
                        description: "{{titleProvince}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleProvRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleProvOpportPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvOpportPrepend}}{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        description: "{{titleProvince}}{{descProvOpport}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleProvOpport: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}}{{titleProvOpport}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.province.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?name?ct?ppt?pt?lt?room?areamax?areamin?pricemax?pricemin?age?bosp?city?lake?nature?sea?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],
                    },
                })
                .state("analysis.county.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionCountyValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionCountyValue2}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.county.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleCountyDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyDemo}}",
                        description: "{{titleProvince}} {{titleCounty}}{{descriptionCountyDemo}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyElec}}",
                        description: "{{titleProvince}} {{titleCounty}}{{descriptionCountyElec}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })

                .state("analysis.county.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleCountyRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyRetail}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyReal}}",
                        robots: "noindex, nofollow",
                        keyword: "{{keywordCountyReal}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleCountyOppPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCountyOppPrepend}}{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}}{{titleCountyOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.county.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionCountyOpp: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleCountyOpp}}",
                        description: "{{titleProvince}} {{titleCounty}} {{descriptionCountyOpp}}",

                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })

                .state("analysis.neighbourhood", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', function (resolveAPIs) {
                            var district = resolveAPIs.Quarter || resolveAPIs.District;
                            return district; //$transition$.params().neighbourhood.toLocaleProperCase2("tr-tr");
                        }],

                    },
                })
                .state("analysis.neighbourhood.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],





                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.neighbourhood.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Check for premium packages and load additional bundles
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisLocation');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.earthquake", {
                    url: "/earthquake?p?c?s?map",
                    templateUrl: "app/bolgesel-analiz/views/deprem.html",
                    controller: "EarthquakeController",
                    controllerAs: "vm",

                    resolve: {

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_eq1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_eq2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_quake");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: ['resolveAPIs', function (resolveAPIs) {
                            if (resolveAPIs && resolveAPIs.Population && resolveAPIs.Population >= 5000)
                                return "index, follow";
                            return "noindex, nofollow";
                        }],
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        // robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.neighbourhood.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        // robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood/:block",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        },
                        block: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', '$transition$', function (resolveAPIs, $transition$) {
                            if ($transition$.params().country === 'espana' && resolveAPIs.Quarter) {
                                return resolveAPIs.Quarter + ' ' + resolveAPIs.District;
                            }
                            var langKey = $transition$.params().langcode || 'tr';
                            var result;
                            if (langKey === 'tr')
                                result = resolveAPIs.BlockNo + ' Ada';
                            else
                                result = resolveAPIs.BlockNo + ' Block';
                            var district = resolveAPIs.District + ' ' + result;
                            return district;
                        }],

                    },
                })
                .state("analysis.block.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],

                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],




                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.block.competition", {
                    url: "/competition?oi",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        // Conditional bundle loading based on user package
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            // Check for premium packages and load additional bundles
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisLocation');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.comparables", {
                    url: "/comparables?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.investment", {
                    url: "/investment?top?ref?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
                .state("analysis.block.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.block.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel", {
                    abstract: true,
                    url: "/{country:world|turkiye|espana|portugal}/:province/:county/:neighbourhood/:block/:parcel",
                    params: {
                        country: {
                            value: null,
                        },
                        province: {
                            value: null
                        },
                        county: {
                            value: null
                        },
                        neighbourhood: {
                            value: null
                        },
                        block: {
                            value: null
                        },
                        parcel: {
                            value: null
                        }
                    },
                    resolve: {

                        resolveAPIs: ['searchParserService', '$transition$', function (searchParserService, $transition$) {
                            return searchParserService.parseSearchForController(
                                $transition$.params(),
                                $transition$
                            );
                        }],

                        titleProvince: [
                            "resolveAPIs",
                            "$translate",
                            function (resolveAPIs, $translate) {
                                return $translate.instant(resolveAPIs.City);
                            },
                        ],

                        titleCounty: ['resolveAPIs', function (resolveAPIs) {
                            var county = resolveAPIs.County;
                            return county; //$transition$.params().county.toLocaleProperCase2("tr-tr");
                        }],

                        titleNeighbourhood: ['resolveAPIs', '$transition$', function (resolveAPIs, $transition$) {
                            var langKey = $transition$.params().langcode || 'tr';
                            var result;
                            if (langKey === 'tr')
                                result = resolveAPIs.BlockNo + ' Ada/' + resolveAPIs.ParcelNo + ' Parsel';
                            else
                                result = resolveAPIs.BlockNo + ' Block/' + resolveAPIs.ParcelNo + ' Plot';

                            var district = resolveAPIs.District + ' ' + result;
                            return district;
                        }],
                    }
                })
                .state("analysis.parcel.value", {
                    url: "/{path3:endeks|index|indice}/:satilik/:konut?t?d?ti?oi?rad",
                    controller: "ValueController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("value");
                        }],
                        satilik: {
                            value: ['$translate', function ($translate) { return $translate.instant('satilik'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        konut: {
                            value: ['$translate', function ($translate) { return $translate.instant('konut'); }],
                            // squash: true,
                            dynamic: true,
                            //type: 'any',
                            //raw: true
                        },
                        t: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        satilikTitle: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                return $translate('c_an_kiralik').then(function (res) {
                                    return res;
                                });
                            } else
                                return $translate('c_an_satilik').then(function (res) {
                                    return res;
                                });
                        }],

                        fiyatlari: ['$transition$', '$translate', function ($transition$, $translate) {
                            if ($transition$.params().satilik &&
                                $transition$.params().satilik === $translate.instant("kiralik")
                            ) {
                                // return $translate('c_an_kira').then(function (res) {
                                //     return res;
                                // });
                                return "";
                            } else
                                return $translate('c_an_fiyat').then(function (res) {
                                    return res;
                                });
                        }],

                        type: ['$transition$', '$translate', function ($transition$, $translate) {
                            if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("ticari") ||
                                $transition$.params().konut === $translate.instant("plaza") ||
                                $transition$.params().konut === $translate.instant("industrial") ||
                                $transition$.params().konut === $translate.instant("ofis") ||
                                $transition$.params().konut === $translate.instant("mustakil-ofis") ||
                                $transition$.params().konut === $translate.instant("dukkan")
                            ) {
                                return $translate('c_an_commercial').then(function (res) {
                                    return res;
                                });
                            }
                            else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arsa")
                            ) {
                                return $translate('c_an_land').then(function (res) {
                                    return res;
                                });
                            } else if (
                                $transition$.params().konut &&
                                $transition$.params().konut === $translate.instant("arazi")
                            ) {
                                return $translate('c_an_field2').then(function (res) {
                                    return res;
                                });
                            } else {
                                return $translate('c_an_house').then(function (res) {
                                    return res;
                                });
                            }
                        }],
                        type2: ['$transition$', '$translate', 'satilikTitle', function ($transition$, $translate, satilikTitle) {
                            if (
                                $transition$.params().konut &&
                                ($transition$.params().konut === $translate.instant("daire") || $transition$.params().konut === $translate.instant("konut") || $transition$.params().konut === $translate.instant("villa-mustakil"))
                            ) {
                                return $translate('c_an_house2').then(function (res) {
                                    return ", " + satilikTitle + " " + res;
                                });
                            } else
                                return "";
                        }],


                        descriptionNeighValue2: ['$translate', function ($translate) {
                            return $translate('c_an_desc').then(function (res) {
                                return res;
                            });
                        }],



                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            return $translate.refresh();
                        }],
                    },
                    templateUrl: "app/bolgesel-analiz/views/value.html",
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{satilikTitle}} {{type}}{{type2}} {{fiyatlari}} {{descriptionNeighValue2}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.demographics", {
                    url: "/{path3:demografi|demography|demografia}?d?ti?oi?rad",
                    templateUrl: "app/bolgesel-analiz/views/demographics.html",
                    controller: "DemographicsController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("demographics");
                        }],
                        d: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        ti: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                        oi: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighDemo: ['$translate', function ($translate) {
                            return $translate('c_an_demo2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighDemo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighDemo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.election", {
                    url: "/{path3:secim|elections|elecciones|eleicoes}",
                    templateUrl: "app/bolgesel-analiz/views/election.html",
                    controller: "ElectionController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("election");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighElec: ['$translate', function ($translate) {
                            return $translate('c_an_elec1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighEle: ['$translate', function ($translate) {
                            return $translate('c_an_elec2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_election");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighElec}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighEle}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                        robots: ["$transition$", function ($transition$) { $transition$.params().country === 'turkiye' ? 'index, follow' : 'noindex', 'nofollow'; }]
                    },
                })
                .state("analysis.parcel.competition", {
                    url: "/competition?oi?rad",
                    templateUrl: "app/bolgesel-analiz/views/competition.html",
                    controller: "CompetitionController",
                    params: {
                        key: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                    "terminal-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.education", {
                    url: "/{path3:okul|school|escuela|escola}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/education.html",
                    controller: "EducationController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("education");
                        }]
                    },
                    resolve: {

                        titleAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAdressEdu: ['$translate', function ($translate) {
                            return $translate('c_an_edu2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEdu}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEdu}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.transportation", {
                    url: "/{path3:ulasim|transport|transporte}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/transportation.html",
                    controller: "TransportationController",
                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("transportation");
                        }]
                    },
                    resolve: {

                        titleAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressTrans: ['$translate', function ($translate) {
                            return $translate('c_an_tra2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_transportation");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressTrans}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressTrans}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.life", {
                    url: "/{path3:yasam|living|vivendo|vivir}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/life.html",
                    controller: "LifeController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("life");
                        }]
                    },
                    resolve: {

                        titleAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressLife: ['$translate', function ($translate) {
                            return $translate('c_an_life2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_life");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressLife}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressLife}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.health", {
                    url: "/{path3:saglik|healthcare|saude|sanidad}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/health.html",
                    controller: "HealthController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("health");
                        }]
                    },
                    resolve: {

                        titleAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressHealth: ['$translate', function ($translate) {
                            return $translate('c_an_hlt2').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_health");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressHealth}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressHealth}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.entertainment", {
                    url: "/{path3:eglence|entertainment|ocio|entretenimento}?rad?top?ref",
                    templateUrl: "app/bolgesel-analiz/views/entertainment.html",
                    controller: "EntertainmentController",

                    params: {
                        path3: ['$translate', function ($translate) {
                            return $translate.instant("entertainment");
                        }]
                    },
                    resolve: {

                        titleAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAddressEntertain: ['$translate', function ($translate) {
                            return $translate('c_an_enter2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_education");
                            $translatePartialLoader.addPart("analysis_entertainment");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleAdressEntertain}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionAdressEntertain}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.find", {
                    url: "/find?p?q?l",
                    templateUrl: "app/bolgesel-analiz/views/find.html",
                    controller: "FindController",
                    params: {
                        q: {
                            value: null,
                            squash: true,
                            dynamic: false,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_com1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_demographic");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.comparables", {
                    url: "/comparables?top?ref?rad?p",
                    templateUrl: "app/bolgesel-analiz/views/comparables.html",
                    controller: "ComparablesController",
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package",
                                        "unlimited-comparable"]);
                            },
                        ],

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_comp1').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.investment", {
                    url: "/investment?top?ref?rad?p",
                    templateUrl: "app/bolgesel-analiz/views/investment.html",
                    controller: "InvestmentController",
                    resolve: {

                        return: ['$translate', function ($translate) {
                            return $translate('c_an_inv1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionInvestment: ['$translate', function ($translate) {
                            return $translate('c_an_inv2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{return}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionInvestment}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.locations", {
                    url: "/locations",
                    templateUrl: "app/bolgesel-analiz/views/locations.html",
                    controller: "LocationsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', 'guardSvc', function ($transition$, lazyLoadSvc, guardSvc) {
                            return guardSvc.hasPackage([
                                "platinum-package",
                                "premium-ee-package",
                                "terminal-premium-package",
                                "terminal-package",
                                "location-package"
                            ]).then(function (HasPlatinum) {
                                if (HasPlatinum) {
                                    return lazyLoadSvc.load($transition$, 'regionalAnalysisCompetition');
                                }
                            });
                        }],

                        guard: [
                            "guardSvc",
                            function (guardSvc) {
                                return guardSvc.guardRoute([
                                    "location-package"
                                ]);
                            },
                        ],

                        titleNeighRetail: ['$translate', function ($translate) {
                            return $translate('c_an_loc1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleCounty}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighRetail}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.agents", {
                    url: "/agents?p?c?s",
                    templateUrl: "app/bolgesel-analiz/views/agents.html",
                    controller: "AgentsController",
                    controllerAs: "vm",
                    resolve: {

                        titleNeighOppoPrepend: ['$translate', function ($translate) {
                            return $translate('c_an_agent1_prepend').then(function (res) {
                                return res;
                            });
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_agent2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_agents");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{descriptionNeighOppoPrepend}}{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.opportunity", {
                    url: "/listings?p?c?r?tp?min?max?age?o?s",
                    templateUrl: "app/bolgesel-analiz/views/houseOpportunity.html",
                    controller: "HouseOpportunityController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisListings');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_opport2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_houseOpportunity");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.portfolio", {
                    url: "/portfolio?p?c?r?tp?pt?o?s?rad?t",
                    templateUrl: "app/bolgesel-analiz/views/portfolio.html",
                    controller: "PortfolioController",
                    controllerAs: "vm",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'regionalAnalysisCharts');
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_valu').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_portfolio");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.alarm", {
                    url: "/alarm/:idm?addressed?t?lat?lng?p?s",
                    templateUrl: "app/bolgesel-analiz/views/alarms.html",
                    controller: "alarmsController",
                    params: {
                        idm: {
                            value: null,
                            squash: true,
                            type: "any",
                            raw: true,
                            dynamic: true,
                        },
                        p: {
                            value: null,
                            squash: true,
                            dynamic: true,
                        },
                    },
                    resolve: {

                        guard: [
                            "guardSvc",
                            "$window",
                            function (guardSvc, $window) {
                                if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                    return true;
                                else
                                    return guardSvc.guardRoute([
                                        "real-estate-package",
                                        "location-package",
                                        "eco-package",
                                        "seller-lead-package",
                                        "premium-package", "premiumplus-package",
                                        "pro-ee-package",
                                        "flex-package",
                                        "gold-package",
                                        "terminal-flex-package",
                                        "terminal-pro-package",
                                        "platinum-package",
                                        "premium-ee-package",
                                        "terminal-premium-package",
                                        "terminal-package"]);
                            },
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("alarm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAdres}} Endeksa Alarm",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.projects", {
                    url: "/projects?p?min?max?amin?amax?o?s",
                    templateUrl: "app/bolgesel-analiz/views/projects.html",
                    controller: "ProjectsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_proj2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                })
                .state("analysis.parcel.malls", {
                    url: "/malls?p?o?s?str?c?a",
                    templateUrl: "app/bolgesel-analiz/views/malls.html",
                    controller: "MallsController",
                    controllerAs: "vm",
                    resolve: {
                        featureProtect: ['$transition$', function ($transition$) {
                            if ($transition$.params().country !== 'turkiye') {
                                $transition$.abort();
                                $transition$.router.stateService.go("404", { langcode: window.lang });
                            }
                        }],

                        titleNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall1').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionNeighOppo: ['$translate', function ($translate) {
                            return $translate('c_an_mall2').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{titleNeighOppo}}",
                        description: "{{titleProvince}} {{titleCounty}} {{titleNeighbourhood}} {{descriptionNeighOppo}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    },
                });


        }
    ]);
})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        // $httpProvider.interceptors.push('secureHttpInterceptor');

        $stateProvider
            .state('admin', {
                url: "/:langcode/management",
                templateUrl: 'app/admin/admin.content.html',
                controller: 'AdminController',
                abstract: true,
                resolve: {
                    // Lazy load admin bundle - replaces old lazyLoad function
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'admin');
                    }],
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_account');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.membership-list', {
                url: '/user?page',
                templateUrl: 'app/admin/admin.membership-list.html',
                controller: 'MembershipListController'
            })
            .state('admin.membership-detail', {
                url: '/user/:id',
                templateUrl: 'app/admin/admin.membership-detail.html',
                controller: 'MembershipDetailController'
            })
            .state('admin.company-list', {
                url: '/company',
                templateUrl: 'app/admin/admin.company-list.html',
                controller: 'CompanyListController'
            })
            .state('admin.company-create', {
                url: '/company/update?id',
                templateUrl: 'app/admin/admin.company-create.html',
                controller: 'CompanyCreateController',
                params: {
                    id: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                }
            })
            .state('admin.feature-access-list', {
                url: '/feature-access?page',
                templateUrl: 'app/admin/admin.feature-access-list.html',
                controller: 'FeatureAccessListController'
            })
            .state('admin.promo-list', {
                url: '/promo',
                templateUrl: 'app/admin/admin.promo-list.html',
                controller: 'CompanyPromoController'
            })
            .state('admin.promo-create', {
                url: '/promo/create?id',
                templateUrl: 'app/admin/admin.promo-create.html',
                controller: 'CompanyPromoCreateController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([30, 50, 70, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.consultant-create', {
                url: '/consultant/create',
                templateUrl: 'app/admin/admin.consultant-create.html',
                controller: 'AdminConsultantCreateController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.order-list', {
                url: '/order?userId?page',
                templateUrl: 'app/admin/admin.order-list.html',
                controller: 'AdminOrderListController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.consultant-list', {
                url: '/consultant?userId',
                templateUrl: 'app/admin/admin.consultant-list.html',
                controller: 'AdminConsultantListController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.agent-segmentation-list', {
                url: '/segment',
                templateUrl: 'app/admin/admin.agent-segmentation-list.html',
                controller: 'AdminAgentSegmentationListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.agent-segmentation-detail', {
                url: '/segment?agentId',
                templateUrl: 'app/admin/admin.agent-segmentation-detail.html',
                controller: 'AdminAgentSegmentationDetailController',
                params: {
                    agentId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([25, 30, 50, 80, 90]);
                        }
                    ]
                }
            })
            .state('admin.comment-list', {
                url: '/comment',
                templateUrl: 'app/admin/admin.comment-list.html',
                controller: 'AdminCommentListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50]);
                        }
                    ]
                }
            })
            .state('admin.comment-detail', {
                url: '/comment?id',
                templateUrl: 'app/admin/admin.comment-detail.html',
                controller: 'AdminCommentDetailController',
                params: {
                    id: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                },
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50]);
                        }
                    ]
                }
            })
            .state('admin.renta-list', {
                url: '/renta',
                templateUrl: 'app/admin/admin.renta-list.html',
                controller: 'AdminRentaListController'
            })
            // .state('admin.lead-list', {
            //     url: '/lead',
            //     templateUrl: 'app/admin/admin.lead-list.html',
            //     controller: 'LeadListController'
            // })
            .state('admin.order-create', {
                url: '/order/create?userId',
                templateUrl: 'app/admin/admin.order-create.html',
                controller: 'AdminOrderCreateController',
                params: {
                    userId: {
                        value: null,
                        squash: true,
                        dynamic: true,
                    }
                }
            })
            .state('admin.order-detail', {
                url: '/order/detail/:id',
                templateUrl: 'app/admin/admin.order-detail.html',
                controller: 'AdminOrderDetailController'
            })
            .state('admin.consultant-detail', {
                url: '/consultant/detail/:id',
                templateUrl: 'app/admin/admin.consultant-detail.html',
                controller: 'AdminConsultantDetailController'
            })
            .state('admin.payment-list', {
                url: '/payment?page',
                templateUrl: 'app/admin/admin.payment-list.html',
                controller: 'AdminPaymentListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([50, 80, 90, 100]);
                        }
                    ]
                }
            })
            .state('admin.campaign-list', {
                url: '/campaign?page',
                templateUrl: 'app/admin/admin.campaign-list.html',
                controller: 'AdminCampaignListController',
                resolve: {
                    guard: [
                        'guardSvc', function (guardSvc) {
                            return guardSvc.guardRouteRole([20, 25, 30, 50, 70, 80, 90]);
                        }
                    ]
                }
            })

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('order-payment',
                {
                    url: '/:langcode/order/payment/:orderId?sellerId?paymentPrice',
                    templateUrl: 'app/satis/satis.odeme.html',
                    controller: 'SatisOdemeController',
                    metaTags: {
                        robots: 'noindex, nofollow'
                    },
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        orderId: { type: 'any', raw: true },
                        sellerId: { type: 'any', raw: true },
                        paymentPrice: { type: 'any', raw: true }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'salesPayment');
                        }],
                        order_result: ['orders_factory', '$transition$', function (orders_factory, $transition$) {
                            return orders_factory.get({ id: $transition$.params().orderId }).$promise;
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('factura_address');
                            $translatePartialLoader.addPart('satis_odeme');
                            return $translate.refresh();
                        }]
                    }
                })


    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('agent-detail',
                {
                    url: '/:langcode/{path:agents|danisman|agentes}/:name/:id',
                    templateUrl: 'app/agents/agent-detail.html',
                    controller: 'AgentDetailController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        id: { type: 'any', raw: true },
                        name: { type: 'any', raw: true },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-detail");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'agents');
                        }],

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        user: ["userSvc", "$q", function (userSvc, $q) {
                            var defer = $q.defer();
                            userSvc.getUserInfo().then(function () {
                                defer.resolve(userSvc.info);
                            }, function () {
                                defer.resolve(null);
                            });
                            return defer.promise;
                        }],
                        agent: [
                            "agentApi",
                            "$transition$",
                            "user",
                            "$q",
                            "historyService",
                            function (agentApi, $transition$, user, $q, historyService) {
                                var defer = $q.defer();
                                // ID parametresinin boş olup olmadığını kontrol et
                                if (!$transition$.params().id || $transition$.params().id.toString().trim() === '') {
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                    defer.reject("ID parameter cannot be empty.");
                                    return defer.promise;
                                }

                                agentApi.get({ Language: window.langCode(), Id: $transition$.params().id, UserId: user ? user.Id : null }).$promise.then(function (result) {
                                    if (result.Results.length && (result.Results[0].ShareProfile || (user && user.Id === result.Results[0].Id))) {
                                        defer.resolve(result.Results[0]);
                                        historyService.set('agent', $transition$.params().id);
                                    }
                                    else {
                                        $transition$.abort();
                                        $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                    }
                                }, function () {
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                });
                                return defer.promise;
                            }
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("agents");
                            $translatePartialLoader.addPart('consult_expert');
                            return $translate.refresh();
                        }],
                        title: ['agent', '$translate', function (agent, $translate) {
                            return $translate("c_agent1").then(function (res) {
                                if (agent && agent.Regions && agent.Regions.features.length) {
                                    let activeRegion = agent.Regions.features.find(f => !f.properties.isManuelRegion);
                                    return activeRegion.properties.CityName + " " + activeRegion.properties.CountyName + " " + res + " " + agent.Name + " " + agent.Surname;
                                }
                                else
                                    return res + " " + agent.Name + " " + agent.Surname;
                            });
                        }],
                        description: ['agent', '$translate', function (agent, $translate) {
                            if (agent && agent.Regions && agent.Regions.features.length) {
                                return $translate("c_agent2").then(function (res) {
                                    return $translate("c_agent3").then(function (res2) {
                                        let activeRegion = agent.Regions.features.find(f => !f.properties.isManuelRegion);
                                        return activeRegion.properties.CityName + " " + activeRegion.properties.CountyName + " " + res + " " + agent.Name + " " + agent.Surname + " " + res2;
                                    });
                                });
                            }
                            else
                                return $translate("c_agent4").then(function (res) {
                                    return $translate("c_agent3").then(function (res2) {
                                        return res + " " + agent.Name + " " + agent.Surname + " " + res2;
                                    });
                                });
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'index, follow',
                        description: '{{description}}',
                        properties: {
                            'og:image': ['agent', function (agent) { return agent && agent.AvatarUrl ? agent.AvatarUrl.replace('https://', 'http://') : "http://www.endeksa.com/share3.jpg"; }],
                            'og:image:secure_url': ['agent', function (agent) { return agent && agent.AvatarUrl ? agent.AvatarUrl.replace('http://', 'https://') : "https://www.endeksa.com/share3.jpg"; }],
                            'og:type': 'website'
                        }
                    }
                })
            .state('agent-profile',
                {
                    url: '/:langcode/{path:agents|danisman|agentes}/profil',
                    params: {
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-profile");
                        }],
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        user: ["userSvc", "$q", "$transition$", "$translate", function (userSvc, $q, $transition$, $translate) {
                            var defer = $q.defer();
                            userSvc.getUserInfo().then(function () {
                                $transition$.abort();
                                $transition$.router.stateService.go("agent-detail", { name: normalizeAddress(userSvc.info.Details.profile.name.trim()) + '-' + normalizeAddress(userSvc.info.Details.profile.surName.trim()), path: $translate.instant("agent-detail"), id: userSvc.info.Id, langcode: $transition$.params().langcode });
                                deferred.resolve();
                            }, function () {
                                $transition$.abort();
                                $transition$.router.stateService.go("signin", { langcode: $transition$.params().langcode });
                                defer.resolve(null);
                            });
                            return defer.promise;
                        }]
                    },
                    metaTags: {
                        robots: 'noindex, nofollow'
                    }
                });
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('lead',
                {
                    url: '/:langcode/lead/:id',
                    templateUrl: 'app/history/lead.html',
                    controller: 'LeadController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        finger: { type: 'any', raw: true },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-detail");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'leadHistory');
                        }],

                        lead: [
                            "$transition$",
                            "$q",
                            "consultancy_factory",
                            "historyService",
                            "notifierSvc",
                            "$translate",
                            "$rootScope",
                            "$window",
                            "userSvc",
                            "restoreUrlService",
                            function ($transition$, $q, consultancy_factory, historyService, notifierSvc, $translate, $rootScope, $window, userSvc, restoreUrlService) {
                                var defer = $q.defer();

                                userSvc.getUserInfo(null, true).then(function () {
                                    const id = $transition$.params().id;
                                    if (!id) defer.resolve({consultancy: null, detail: ''});
                                    consultancy_factory.detailForAgent({ consultancyId: id }).$promise.then(function (result) {
                                        if (result && result.consultancy) {
                                            historyService.get({ fingerPrint: result.consultancy.fingerPrint }).then(function (data) {
                                                const lead = Object.assign(result, {history: data});
                                                defer.resolve(lead);
                                            }).finally(() => defer.resolve(result));
                                        }
                                        else
                                            defer.resolve(result);
                                    }, function (err) {
                                        let msg;
                                        if (err.data.detail.indexOf('You have no permission') !== -1 ||
                                        err.data.detail.indexOf('request is unavailable') !== -1)
                                            msg = $translate.instant('no_lead_permission');
                                        else if (err.data.detail.indexOf('has been accepted by another user') !== -1)
                                            msg = $translate.instant('accept_another');
                                        else if (err.data.detail.indexOf('Consultancy not found') !== -1)
                                            msg = $translate.instant('lead_not_found');

                                        notifierSvc.show({message: msg, type: 'error'});
                                        $transition$.abort();
                                        restoreUrlService.returnTo();
                                        $('.before-load').addClass("ng-hide");
                                        $rootScope.hideBar = false;
                                        $window.barLoaded = true;
                                        defer.resolve();
                                    });
                                },
                                function () {
                                    $transition$.router.stateService.go('signin', { langcode: $window.lang });
                                });

                                return defer.promise;
                            }
                        ],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("agents");
                            $translatePartialLoader.addPart('consult_expert');
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                             return $translate('lead_requests').then(function (res){
                                return  res
                            })
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('property',
                {
                    url: '/:langcode/{path:property|emlak|inmueble|imovel}/:name?s',
                    templateUrl: 'app/property/property.html',
                    controller: 'PropertyController',
                    controllerAs: "vm",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("property_path");
                        }],
                        name: { type: 'any', raw: true },
                        s: { type: 'any', raw: true },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'property');
                        }],

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect('property_path');
                        }],
                        endeksaId: ['$window', '$transition$', function ($window, $transition$) {
                            const path = $transition$.params().name;
                            return path.split('-')[path.split('-').length - 2] + '-' + path.split('-')[path.split('-').length - 1]
                        }],
                        property: [
                            "comparablesApiCached",
                            "$window",
                            "endeksaId",
                            "$transition$",
                            "$q",
                            function (
                                comparablesApiCached,
                                $window,
                                endeksaId,
                                $transition$,
                                $q
                            ) {
                                var deferred = $q.defer();
                                comparablesApiCached.detail({EndeksaId: endeksaId}).$promise.then(function (result) {
                                    deferred.resolve(result);
                                }, function () {
                                    deferred.reject($transition$.router.stateService.go($transition$.to().name, { langcode: $transition$.params().langcode }));
                                })
                                return deferred.promise;
                            },
                        ],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("properties");
                            $translatePartialLoader.addPart("analysis_houseOpportDetail");
                            $translatePartialLoader.addPart("opportunity");
                            $translatePartialLoader.addPart("property_details");
                            $translatePartialLoader.addPart("analysis_layout");
                            $translatePartialLoader.addPart("analysis_projects");
                            return $translate.refresh();
                        }],
                        title: ['property', function (property) {
                            return property.Title;
                        }],
                        description: ['$translate', function ($translate) {
                            return $translate('p_description').then(function (res){
                               return  res
                           })
                       }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        description: '{{description}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('bank',
                {
                    url: '/:langcode/bank',
                    templateUrl: 'app/bank/bank.html',
                    controller: 'BankController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'bank');
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("bank");
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                            return $translate('intro_screen').then(function (res) {
                                return res;
                            });
                        }],
                        redirect: ['auth_factory', '$rootScope', '$transition$', '$q', 'userSvc', function (auth_factory, $rootScope, $transition$, $q, userSvc) {
                            var deferred = $q.defer();
                            if ($rootScope.isTop) {
                                var utmSource = window.getUrlParameter('utm_source');
                                var token = null;

                                if (window.hasAllowance === 'bank') {
                                    $rootScope.isBank = true;
                                    // Set source based on bank: isbankasi=5, yapikredi=4, akbank=12
                                    var bankSource = null;
                                    if (utmSource === 'isbankasi') {
                                        bankSource = 5;
                                    } else if (utmSource === 'yapikredi') {
                                        bankSource = 4;
                                        token = window.getUrlParameter('authorizationCode');
                                    } else if (utmSource === 'akbank') {
                                        bankSource = 12;
                                        token = window.getUrlParameter('id');
                                    }
                                    $rootScope.clientData = {
                                        name: null,
                                        surName: null,
                                        phoneNumber: null,
                                        email: null,
                                        ip: null,
                                        source: bankSource
                                    };
                                    userSvc.getUserInfo(null, true).then(function (res) {
                                        if (utmSource === 'yapikredi') {
                                            //var sessionToken = window.getUrlParameter('authorizationCode') ? window.getUrlParameter('authorizationCode') : "PSPTACE4815BA73B45EAA9EB1CA223872EDA";

                                            auth_factory.getBankUserDetails({ token: token }).$promise.then(function (response) {
                                                $rootScope.clientData = Object.assign($rootScope.clientData, {
                                                    name: response.Name,
                                                    surName: response.Surname,
                                                    phoneNumber: response.PhoneNumber,
                                                    email: response.Email,
                                                    source: 4
                                                });
                                                $rootScope.yapiKrediSessionToken = response.SessionToken;

                                            }).finally(() => {
                                                $transition$.abort();
                                                deferred.resolve($transition$.router.stateService.go('analysis.country.portfolio', { langcode: window.lang, country: $rootScope.country }));
                                            });
                                        } else {
                                            $transition$.abort();
                                            deferred.resolve($transition$.router.stateService.go('analysis.country.portfolio', { langcode: window.lang, country: $rootScope.country }));
                                            return deferred.promise;
                                        }

                                    }, function () {
                                        if (utmSource === 'isbankasi') {
                                            function postAppMessage(msg) {
                                                if (window.webkit != undefined) {
                                                    if (window.webkit.messageHandlers.miniapp != undefined) {
                                                        window.webkit.messageHandlers.miniapp.postMessage(msg);
                                                    }
                                                }
                                                else if (window.miniapp != undefined) {
                                                    window.miniapp.postMessage(msg);
                                                } else {
                                                    console.log('window.webkit and window.miniapp not defined!');
                                                }
                                                deferred.resolve();
                                            }

                                            function getClientInfo(fName) {
                                                try {
                                                    let message = {
                                                        "callFunction": {
                                                            "functionName": fName,
                                                            "param": {/*
                                                                            "paramA" : 123,
                                                                            "paramB" : 234,
                                                                            "paramC" : "str"*/
                                                            },
                                                            // "callback": "functionCallback"
                                                        }
                                                    };
                                                    postAppMessage(JSON.stringify(message));
                                                } catch (err) {
                                                    console.log('Error occurred calling native method');
                                                    deferred.reject();
                                                }

                                            }

                                            window.functionCallback = function (functionName, result) {
                                                /*
                                                {   "isSuccess": true,
                                                    "retVal": { "funcRetVal": {"ClientIp" : "127.0.0.1"},
                                                                "consentName" : "GetClientIp",
                                                                "isApproved" : true
                                                            }
                                                }
                                                */
                                                try {
                                                    let parsedResult = JSON.parse(result);
                                                    if (parsedResult.isSuccess && parsedResult.retVal.isApproved) {
                                                        if (parsedResult.retVal.funcRetVal.ClientIp)
                                                            $rootScope.clientData.ip = parsedResult.retVal.funcRetVal.ClientIp;

                                                        if (parsedResult.retVal.funcRetVal.Email)
                                                            $rootScope.clientData.email = parsedResult.retVal.funcRetVal.Email;

                                                        if (parsedResult.retVal.funcRetVal.PhoneNumber)
                                                            $rootScope.clientData.phoneNumber = parsedResult.retVal.funcRetVal.PhoneNumber;

                                                        if (parsedResult.retVal.funcRetVal.Name)
                                                            $rootScope.clientData.name = parsedResult.retVal.funcRetVal.Name;
                                                        if (parsedResult.retVal.funcRetVal.Name)
                                                            $rootScope.clientData.name = parsedResult.retVal.funcRetVal.Name;

                                                        if (parsedResult.retVal.funcRetVal.Surname)
                                                            $rootScope.clientData.surName = parsedResult.retVal.funcRetVal.Surname;
                                                    }
                                                    if ($rootScope.clientData.phoneNumber && $rootScope.clientData.name && $rootScope.clientData.surName) {
                                                        $rootScope.clientData.source = 5;
                                                        if (window.localStorage.getItem('first_visit'))
                                                            $transition$.router.stateService.go('valuation-wrapper', { langcode: window.lang });
                                                    }
                                                } catch (error) {
                                                    console.error("JSON verisi işlenirken bir hata oluştu:", error);
                                                    deferred.reject();
                                                }
                                            };

                                            // getClientInfo('GetClientIP');
                                            // getClientInfo('GetMailAddress');
                                            getClientInfo('GetPhoneNumber');
                                            getClientInfo('GetIdentity');

                                        } else if (utmSource === 'yapikredi' || utmSource === 'akbank') {
                                            //var sessionToken = window.getUrlParameter('authorizationCode') ? window.getUrlParameter('authorizationCode') : "PSPTACE4815BA73B45EAA9EB1CA223872EDA";

                                            auth_factory.getBankUserDetails({ token: token }).$promise.then(function (response) {
                                                $rootScope.clientData = Object.assign($rootScope.clientData, {
                                                    name: response.Name,
                                                    surName: response.Surname,
                                                    phoneNumber: response.PhoneNumber,
                                                    email: response.Email,
                                                    source: utmSource === 'yapikredi' ? 4 : 12
                                                });
                                                if (utmSource === 'yapikredi') {
                                                    $rootScope.yapiKrediSessionToken = response.SessionToken;
                                                }

                                            }).finally(() => {
                                                if (!window.localStorage.getItem('first_visit')) {
                                                    deferred.resolve();
                                                } else {
                                                    deferred.resolve($transition$.router.stateService.go('valuation-wrapper', { langcode: window.lang }, { reload: true }));
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                            return deferred.promise;
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                });
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('mall-detail', {
                url: '/:langcode/malls/:name/:id',
                templateUrl: 'app/malls/mall-detail.html',
                controller: 'MallDetailController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'malls');
                    }],

                    HasPremium: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package",
                            "eco-package",
                            'seller-lead-package',
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package"
                        ]);
                    }],

                    HasLocation: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage(["location-package"]);
                    }],
                    mall: ["notifierSvc", "mallsAPI", "$translate", "$transition$", "$rootScope", "$timeout", "historyService", function (notifierSvc, mallsAPI, $translate, $transition$, $rootScope, $timeout, historyService) {
                        return mallsAPI.get({ id: $transition$.params().id }).$promise.then(function (result) {
                            historyService.set('mall', $transition$.params().id);
                            return result;
                        }, function () {
                            $translate('c_mall1').then(function (res) {
                                notifierSvc.show({ message: res, type: "info" });
                            });
                            $timeout(function () {
                                $rootScope.MetaTags.prerender.statusCode = 301;
                                window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.malls", { langcode: $transition$.params().langcode, country: "world" });
                                $rootScope.MetaTags.prerender.header = window.redirected;
                            }, 0);
                            $transition$.abort();
                            $transition$.router.stateService.go("analysis.country.malls", { langcode: $transition$.params().langcode, country: "world" });
                        });
                    }],

                    geo: ['geoApi', 'mall', function (geoApi, mall) {
                        if (mall && mall.Lat) {
                            var geoAp = geoApi.get({ lat: +mall.Lat, long: +mall.Lon, level: 3 });
                            return geoAp.$promise.then(function (resb) {
                                return resb;
                            });
                        }
                    }],

                    name: ['mall', function (mall) {
                        return mall ? mall.Title : "";
                    }],

                    description: ['mall', function (mall) {
                        return mall ? mall.Description : "";
                    }],

                    location: ['mall', function (mall) {
                        return mall ? mall.Location : "";
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('analysis_projects');
                        $translatePartialLoader.addPart('analysis_election');
                        $translatePartialLoader.addPart('analysis_value');
                        return $translate.refresh();
                    }]
                },
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    name: { type: 'any', raw: true },
                    id: { type: 'any', raw: true }
                },
                metaTags: {
                    title: '{{name}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': ['mall', function (mall) {
                            return mall ? mall.Photo.replace('https://', 'http://') : "";
                        }],
                        'og:image:secure_url': ['mall', function (mall) {
                            return mall ? mall.Photo.replace('http://', 'https://') : "";
                        }],
                        'og:type': 'website'
                    }
                }
            });
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('project-detail', {
                url: '/:langcode/projects/:name/:id',

                templateUrl: 'app/projeler/projeler-detay.html',
                controller: 'ProjelerDetayController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'projects');
                    }],
                    project: ["notifierSvc", "projectsApi", "$translate", "$transition$", "$rootScope", "$timeout", "historyService", function (notifierSvc, projectsApi, $translate, $transition$, $rootScope, $timeout, historyService) {
                        return projectsApi.get({ id: $transition$.params().id }).$promise.then(function (result) {
                            historyService.set('project', $transition$.params().id);
                            return result;
                        }, function () {
                            $translate('c_prj1').then(function (res) {
                                notifierSvc.show({ message: res, type: "info" });
                            });
                            $timeout(function () {
                                $rootScope.MetaTags.prerender.statusCode = 301;
                                window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.projects", { langcode: $transition$.params().langcode, country: "world" });
                                $rootScope.MetaTags.prerender.header = window.redirected;
                            }, 0);
                            $transition$.abort();
                            $transition$.router.stateService.go("analysis.country.projects", { langcode: $transition$.params().langcode, country: "world" });
                        });
                    }],

                    geo: ['geoApi', 'project', function (geoApi, project) {
                        if (project && project.Latitude) {
                            var geoAp = geoApi.get({ lat: +project.Latitude, long: +project.Longitude, level: 3 });
                            return geoAp.$promise.then(function (resb) {
                                return resb;
                            });
                        }
                    }],

                    HasRealEstate: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package"
                        ]);
                    }],

                    name: ['project', function (project) {
                        return project ? project.Name : "";
                    }],

                    description: ['project', function (project) {
                        return project ? project.Description : "";
                    }],


                    location: ['project', function (project) {
                        return project ? project.Location : "";
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('analysis_projects');
                        $translatePartialLoader.addPart('analysis_election');
                        $translatePartialLoader.addPart('analysis_value');
                        return $translate.refresh();
                    }]
                },
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    name: { type: 'any', raw: true },
                    id: { type: 'any', raw: true }
                },
                metaTags: {
                    title: '{{name}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': ['project', function (project) {
                            return project ? project.Image.replace('https://', 'http://') : "";
                        }],
                        'og:image:secure_url': ['project', function (project) {
                            return project ? project.Image.replace('http://', 'https://') : "";
                        }],
                        'og:type': 'website'
                    }
                }
            });
    }]);

})();

(function () {
    "use strict";

    angular.module("app.core").config([
        "$stateProvider",
        "$urlRouterProvider",
        function ($stateProvider, $urlRouterProvider) {
            $urlRouterProvider.otherwise(function ($injector) {
                var $location = $injector.get("$location");
                var $window = $injector.get("$window");
                const langKey = window.lang || "en";
                const path = $location.path().toLowerCase();
                const hash = $location.hash().toLowerCase();
                // /externalauth/* (e.g. /externalauth/login) excluded above; no /:lang/login route.
                if (
                    path.indexOf("/externallogin") === -1 &&
                    path.indexOf("/externalauth") === -1 &&
                    path.indexOf("/confirmoop") === -1 &&
                    path.indexOf("/token") === -1 &&
                    path.indexOf("/renew") === -1 &&
                    hash !== "mobile-widget" &&
                    path !== "/"
                ) {
                    // Full page redirect to get proper 404 HTTP status code from server
                    $window.location.replace("/" + langKey + "/404");
                }
            });
            $stateProvider
                .state("search", {
                    url: "/:langcode/{path:ara|search|buscar}?q",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("ara");
                        }],
                        q: {
                            value: null,
                            squash: false
                        }
                    },
                    resolve: {
                        // Redirect to proper analysis URL format
                        redirectToAnalysis: ['$transition$', '$state', function ($transition$, $state) {
                            var searchTerm = $transition$.params().q;
                            var langcode = $transition$.params().langcode || window.lang;

                            if (searchTerm) {
                                // Redirect to analysis.address.investment with proper format
                                // /l/{{searchTerm}}/investment
                                $transition$.abort();
                                $transition$.router.stateService.go('analysis.address.investment', {
                                    langcode: langcode,
                                    address: searchTerm,
                                    satilik: $transition$.injector().get('$translate').instant('satilik'),
                                    konut: $transition$.injector().get('$translate').instant('konut')
                                });
                            } else {
                                // No search term, go to landing
                                $transition$.abort();
                                $transition$.router.stateService.go('default', { langcode: langcode });
                            }
                        }]
                    }
                })
                .state("default", {
                    url: "/:langcode/?force&ara",
                    templateUrl: "app/content/landing/landing.html",
                    controller: "LandingController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        force: {
                            value: null
                        }
                    },
                    resolve: {
                        // Lazy load landing bundle
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'landing');
                        }],


                        HasPackage: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage();
                        }],

                        HasRealEstate: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage([
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasLocation: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage(["location-package"]);
                        }],

                        RedirectIfLogin: [
                            "HasPackage",
                            "HasRealEstate",
                            "HasLocation",
                            "$transition$",
                            "$window",
                            "$q",
                            "userSvc",
                            "$rootScope",
                            "$translate",
                            function (
                                HasPackage,
                                HasRealEstate,
                                HasLocation,
                                $transition$,
                                $window,
                                $q,
                                userSvc,
                                $rootScope,
                                $translate
                            ) {
                                var deferred = $q.defer();
                                var force = $transition$.params().force;
                                if (force === 'redirect') {
                                    userSvc.getUserInfo().then(function () {
                                        try {
                                            if (userSvc.info.SignedIn) {
                                                var start = $window.userStorage.getItem('map_location');
                                                var open = $window.userStorage.getItem('map_open');
                                                var tag = null;
                                                if (open) {
                                                    switch (+open) {
                                                        case 0:
                                                            tag = "value";
                                                            break;
                                                        case 1:
                                                            tag = "demographics";
                                                            break;
                                                        case 2:
                                                            tag = "election";
                                                            break;
                                                        case 3:
                                                            tag = "comparables";
                                                            break;
                                                        case 4:
                                                            tag = "find";
                                                            break;
                                                        case 5:
                                                            tag = "competition";
                                                            break;
                                                        case 6:
                                                            tag = "opportunity";
                                                            break;
                                                        case 7:
                                                            tag = "projects";
                                                            break;
                                                        case 8:
                                                            tag = "malls";
                                                            break;
                                                        case 9:
                                                            tag = "locations";
                                                            break;
                                                        case 10:
                                                            tag = "alarm";
                                                            break;
                                                        case 11:
                                                            tag = "portfolio";
                                                            break;
                                                    }
                                                }

                                                var langKey = $transition$.params().langcode;

                                                var startObject = start ? JSON.parse(start) : { country: null, city: null, county: null, district: null };

                                                var tagCity = "country";
                                                var gObject = {
                                                    langcode: langKey,
                                                    country: $rootScope.country,
                                                };
                                                if (startObject.country) {
                                                    tagCity = "country";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                }
                                                if (startObject.city) {
                                                    tagCity = "province";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                }
                                                if (startObject.county) {
                                                    tagCity = "county";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                    gObject.county = normalizeAddress(startObject.county.split(':')[1]);
                                                }
                                                if (startObject.district) {
                                                    tagCity = "neighbourhood";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                    gObject.county = normalizeAddress(startObject.county.split(':')[1]);
                                                    gObject.neighbourhood = normalizeAddress(startObject.district.split(':')[1]);
                                                }

                                                //map_location may hold localized country names ("Spain") that the
                                                //{country:world|turkiye|espana|portugal} url matcher rejects -> invalid transition
                                                var validCountries = ['world', 'turkiye', 'espana', 'portugal'];
                                                var countryAliases = { spain: 'espana', turkey: 'turkiye' };
                                                if (validCountries.indexOf(gObject.country) === -1)
                                                    gObject.country = countryAliases[gObject.country] || $rootScope.country;

                                                gObject.satilik = $translate.instant($rootScope.satilik);
                                                gObject.konut = $translate.instant($rootScope.konut);

                                                //invalid transitions skip onError hooks; without a catch the user is
                                                //left on the splash spinner forever (ES-4559)
                                                var safeGo = function (state, params) {
                                                    $transition$.router.stateService.go(state, params)
                                                        .catch(function (err) {
                                                            console.error('ES-4559 post-login redirect failed', err);
                                                            $transition$.router.stateService.go('default', { langcode: langKey });
                                                        });
                                                };


                                                tag = tag ? tag : HasLocation ? 'demographics' : (HasRealEstate || !HasPackage) ? 'portfolio' : 'value';
                                                var direction = "analysis." + tagCity + "." + tag;

                                                if (open && +open === 100) {
                                                    // Eğer open 100 ise ana sayfaya yönlendir
                                                    $transition$.router.stateService.go('default', { langcode: langKey });
                                                    deferred.resolve();
                                                } else if (open && +open !== 100 || !open || force === 'redirect') {
                                                    //son sekmeyi hatırlayıp eğer ön tanımlı bir sekme yoksa oraya yönlendirilmesi sağlanıyor

                                                    //!!!! UYARI BU ALAN SADECE PANELE YÖNLENDİRME İÇİN KULLANILIYOR. BAŞKA SAYFALAR İÇİN KULLANILAMAZ !!!!
                                                    var lastPanelState = $window.localStorage.getItem("lastVisitedPanel");
                                                    lastPanelState = lastPanelState ? JSON.parse(lastPanelState) : null;
                                                    if (lastPanelState && langKey === lastPanelState.param.langcode) {
                                                        lastPanelState.param.top = null;
                                                        lastPanelState.param.ref = null;
                                                        lastPanelState.param.e = null;
                                                        lastPanelState.param.t = null;
                                                        lastPanelState.param.d = null;
                                                        lastPanelState.param.ti = null;
                                                        lastPanelState.param.oi = null;
                                                        lastPanelState.param.l = null;

                                                        if (lastPanelState.name.indexOf('election') > -1 && lastPanelState.param.country && !lastPanelState.param.province)
                                                            lastPanelState.name = lastPanelState.name.replace('election', 'value');
                                                        else if (lastPanelState.name.indexOf('demographics') > -1 && lastPanelState.param.country && !lastPanelState.param.province)
                                                            lastPanelState.name = lastPanelState.name.replace('demographics', 'value');
                                                        else if ((lastPanelState.name.indexOf('comparables') > -1 ||
                                                            lastPanelState.name.indexOf('health') > -1 ||
                                                            lastPanelState.name.indexOf('life') > -1 ||
                                                            lastPanelState.name.indexOf('entertainment') > -1 ||
                                                            lastPanelState.name.indexOf('transportation') > -1 ||
                                                            lastPanelState.name.indexOf('education') > -1) && !lastPanelState.param.address) {
                                                            lastPanelState.name = 'analysis.country.value';
                                                            lastPanelState.param.country = $rootScope.country;
                                                        }

                                                        $transition$.abort();
                                                        if (lastPanelState && (!open || (open && +open === 100))) {
                                                            safeGo(lastPanelState.name, lastPanelState.param);
                                                        }
                                                        else
                                                            safeGo(direction, gObject);

                                                        deferred.resolve();
                                                    }
                                                    else {
                                                        $transition$.abort();
                                                        safeGo(direction, gObject);
                                                        deferred.resolve();
                                                    }
                                                }
                                                else {
                                                    deferred.resolve();
                                                }
                                            }
                                            else {
                                                deferred.resolve();
                                            }
                                        }
                                        catch (err) {
                                            console.log(err);
                                            deferred.resolve();
                                        }
                                    }, function () {
                                        deferred.resolve();
                                    });
                                }
                                else {
                                    // if (force == 'redirect') {
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go('analysis.country.value', { langcode: window.lang, country: $rootScope.country, satilik: $translate.instant('satilik'), konut: $translate.instant('konut') });
                                    // }
                                    deferred.resolve();
                                }
                                return deferred.promise;
                            }
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('landing');
                            return $translate.refresh();
                        }],

                        titleLanding: ['$translate', function ($translate) {
                            return $translate('c_landing_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionLanding: ['$translate', function ($translate) {
                            return $translate('c_landing_desc').then(function (res) {
                                return res;
                            });
                        }],

                    },
                    metaTags: {
                        title: "{{titleLanding}}",
                        description: "{{descriptionLanding}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        }
                        // prerender: {
                        //     statusCode: ['langcode', function (langcode) {
                        //         return langcode ? 200 : 301;
                        //     }],
                        //     header: ['langcode', function (langcode) {
                        //         return langcode ? null : 'Location: https://www.endeksa.com/' + (window.lang ? window.lang : 'tr') + '/';
                        //     }]
                        // }
                    },
                })



                .state("atlas", {
                    url: "/:langcode/atlas",
                    templateUrl: "app/content/atlas/atlas.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "AtlasController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleAtlas: ['$translate', function ($translate) {
                            return $translate('atlas_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionAtlas: ['$translate', function ($translate) {
                            return $translate('atlas_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("atlas");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAtlas}}",
                        description: "{{descriptionAtlas}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("crm", {
                    url: "/:langcode/crm",
                    templateUrl: "app/content/crm/crm.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "CrmController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleCrm: ['$translate', function ($translate) {
                            return $translate('crm_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCrm: ['$translate', function ($translate) {
                            return $translate('crm_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("crm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCrm}}",
                        description: "{{descriptionCrm}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("startups", {
                    url: "/:langcode/e4s",
                    templateUrl: "app/content/startups/startups.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "StartupsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleStartups: ['$translate', function ($translate) {
                            return $translate('startups_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionStartups: ['$translate', function ($translate) {
                            return $translate('startups_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("startups");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleStartups}}",
                        description: "{{descriptionStartups}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("hakkimizda", {
                    url: "/:langcode/{path:about|hakkimizda|sobre}",
                    templateUrl: "app/content/hakkimizda.html",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("hakkimizda");
                        }],
                    },
                    controller: "HakkimizdaController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        // Using helper - much cleaner!
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleAboutUs: ['$translate', function ($translate) {
                            return $translate('c_about_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAboutUs: ['$translate', function ($translate) {
                            return $translate('c_about_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("why_appraisal");

                            return $translate.refresh();
                        }],
                    },

                    metaTags: {
                        title: "{{titleAboutUs}}",
                        description: "{{descriptionAboutUs}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })

                .state("nasil", {
                    url: "/:langcode/{path:nasil|how|como}",
                    templateUrl: "app/content/howto.html",
                    controller: "HowToController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("nasil");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleHow: ['$translate', function ($translate) {
                            return $translate('c_how_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionHow: ['$translate', function ($translate) {
                            return $translate('c_how_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_edr");
                            $translatePartialLoader.addPart("howTo");

                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleHow}}",
                        description: "{{descriptionHow}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("iletisim", {
                    url: "/:langcode/{path:iletisim|contact|contactar|contato}",
                    templateUrl: "app/content/iletisim.html",
                    controller: "IletisimController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("iletisim");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleContact: ['$translate', function ($translate) {
                            return $translate('c_contact_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionContact: ['$translate', function ($translate) {
                            return $translate('c_contact_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("contact");

                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleContact}}",
                        description: "{{descriptionContact}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("kullanim", {
                    url: "/:langcode/{path:kullanim|terms|termos|terminos}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/kullanim.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("kullanim");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_terms_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_terms_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })

                .state("cagri", {
                    url: "/:langcode/{path:cagri-merkezi|call-center|centro-de-llamadas|centro-de-atendimento}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/cagri.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cagri");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_call_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_call_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("rehber", {
                    url: "/:langcode/{path:rehber-aktarim|directory-transfer|transferencia-de-diretorio|agenda-transferencia}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/rehber.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("rehber");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_book_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_book_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                // .state("mortgageaydinlatma-tr", {
                //     url: "/tr/mortgage-aydinlatma",

                //     templateUrl: "app/content/sozlesme/mortgage-aydinlatma.html",
                //     lazyLoad: function ($transition$) {
                //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
                //         lazyLoad.inject('ngAnimate');
                //         lazyLoad.load([
                //             "/assets/css/main.content.min.css?v=" + window.appVersion
                //         ]);
                //         // lazyLoad.load({
                //         //     serie: true,
                //         //     delay: true,
                //         //     files: [
                //         //         "/assets/js/vendor.timekit.min.js?v=" + window.appVersion]
                //         // });
                //         return lazyLoad.load(
                //             {
                //                 serie: true,
                //                 files: [

                //                     "/assets/js/main.content.min.js?v=" + window.appVersion
                //                 ], insertBefore: '#last_script'
                //             }
                //         );
                //     },
                //     resolve: {
                //         titleUse: function () {
                //             return "Kişisel Verilerin Korunması Kanunu Hakkında Aydınlatma Metni";
                //         },
                //         descriptionUse: function () {
                //             return "Kişisel Verilerin Korunması Hakkında Aydınlatma Metni";
                //         },
                //     },
                //     metaTags: {
                //         title: "{{titleUse}}",
                //         robots: "noindex, nofollow",
                //         description: "{{descriptionUse}}",
                //         properties: {
                //             "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                //             "og:type": "website",
                //         },
                //     },
                // })
                .state("gizlilik", {
                    url: "/:langcode/{path:gizlilik|privacy|privacidad|privacidade}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/gizlilik.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("gizlilik");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_privacy_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_privacy_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("musteri-yonlendirme", {
                    url: "/:langcode/{path:danismanlik|consultancy|consultoria}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/lead.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("musteri-yonlendirme");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_consultancy_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_consultancy_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("cerez", {
                    url: "/:langcode/{path:cerez|cookie|biscoito}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/cerez.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cerez");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_cookie_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_cookie_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("hizmetler", {
                    abstract: true,
                    url: "/:langcode/{path:hizmetler|services|servicios|servicos}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("hizmetler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'servicesPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('table_prices');
                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }]
                    },
                })
                .state("hizmetler.otomatik", {
                    url: "/{path2:otomatik-degerleme|automated-valuation|valoracion-automatica|avaliacao-automatica}?ad",
                    templateUrl: "app/content/hizmet-otomatikdegerleme/hizmet-edr.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('otomatik');
                        }]
                    },
                    resolve: {

                        // Using two-path helper - much cleaner!
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_edr_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_edr_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_edr");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "EdrController",
                })
                .state("hizmetler.location", {
                    url: "/{path2:lokasyon-analizi|analisis-de-localizacion|analise-da-localizacao|location-analytics}?ad",
                    templateUrl: "app/content/hizmet-location/hizmet-location.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('location');
                        }]
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_location_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_location_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_location");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "LocationController",
                })
                .state("hizmetler.region", {
                    url: "/{path2:bolge-analizi|analisis-de-region|analise-da-regiao|region-analytics}?ad",
                    templateUrl: "app/content/hizmet-region/hizmet-region.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('region');
                        }]
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'servicesRegion');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_region_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_region_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_region");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "RegionController",
                })
                .state("hizmetler.guvenle-sat", {
                    url: "/lead?ad",
                    templateUrl: "app/content/hizmet-guvenle-sat/hizmet-guvenle-sat.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('danisman');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("consultant");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "ConfidenceController",
                })
                .state("hizmetler.danisman", {
                    url: "/{path2:guvenle-sat|vender-con-confianza|vender-com-confianca|sell-with-confidence}?ad",
                    templateUrl: "app/content/hizmet-danisman/hizmet-danisman.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('danisman');
                        }]
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("consultant");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "DanismanController",
                })
                // .state("hizmetler-tr.mortgage", {
                //     url: "/mortgage?ad",
                //     templateUrl: "app/content/hizmet-mortgage/hizmet-mortgage.html",
                //     resolve: {
                //         titleEdr: function () {
                //             return "Kolay Konut Kredisi";
                //         },
                //         descriptionEdr: function () {
                //             return "Kolay konut kredisi çözümleri ile hemen, hızlı mortgage, eviniz için kullanın.";
                //         },
                //         keywordsEdr: function () {
                //             return "konut kredisi, hazır konut kredisi, ön onaylı kredi, mortgage, mortgage kullanma, hızlı kredi, hemen kredi";
                //         },
                //
                //translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                //             $translatePartialLoader.addPart("mortgage");
                //             $translatePartialLoader.addPart("product_report");
                //             return $translate.refresh();
                //         }],
                //     },
                //     metaTags: {
                //         title: "{{titleEdr}}",
                //         description: "{{descriptionEdr}}",
                //         robots: "index, follow",
                //         properties: {
                //             "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                //             "og:type": "website",
                //         },
                //     },
                //     controller: "MortgageServiceController",
                // })
                .state("urunler", {
                    abstract: true,
                    url: "/:langcode/{path:urunler|productos|produtos|products}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("urunler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'productsPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("urunler.kurumsal", {
                    url: "/api-widget?ad",
                    templateUrl: "app/content/urun-kurumsal/urun-kurumsal.html",
                    resolve: {
                        titleCoorporate: ['$translate', function ($translate) {
                            return $translate('c_api_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCoorporate: ['$translate', function ($translate) {
                            return $translate('c_api_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_enterprise");
                            $translatePartialLoader.addPart('table_prices');
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCoorporate}}",
                        description: "{{descriptionCoorporate}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "KurumsalController",
                })
                .state("urunler.uyelik", {
                    url: "/{path2:uyelik|packages|paquetes|pacotes}?ad?promo",
                    templateUrl: "app/content/urun-uyelik/urun-uyelik.html",
                    controller: "PackagesController",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('uyelik');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleProdMembership: ['$translate', function ($translate) {
                            return $translate('c_pack_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionProdMembership: ['$translate', function ($translate) {
                            return $translate('c_pack_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_integration");
                            $translatePartialLoader.addPart('table_prices');
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProdMembership}}",
                        description: "{{descriptionProdMembership}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("urunler.roket", {
                    url: "/{path2:roket|rocket|cohete|foguete}?ad",
                    templateUrl: "app/content/urun-roket/urun-roket.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant("roket");
                        }],
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleCoorporate: ['$translate', function ($translate) {
                            return $translate('c_rocket_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCoorporate: ['$translate', function ($translate) {
                            return $translate('c_rocket_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_rocket");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCoorporate}}",
                        description: "{{descriptionCoorporate}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "RoketController",
                })

                .state("cozumler", {
                    abstract: true,
                    url: "/:langcode/{path:cozumler|solutions|soluciones|solucoes}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cozumler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'solutionsPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {

                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("cozumler.emlak-danismani", {
                    url: "/{path2:emlak-danismani|agents|agentes}?ad",
                    templateUrl: "app/content/kullanicilar-emlak-uzmanlari/emlak-uzmanlari.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('emlak-danismani');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleConsultant: ['$translate', function ($translate) {
                            return $translate('c_agent_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionConsultant: ['$translate', function ($translate) {
                            return $translate('c_agent_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("experts");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleConsultant}}",
                        description: "{{descriptionConsultant}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "EmlakUzmaniController",
                })
                .state("cozumler.degerleme", {
                    url: "/{path2:degerleme-kuruluslari|appraisers|tasadores|avaliadores}?ad",
                    templateUrl: "app/content/kullanicilar-degerleme-uzmanlari/degerleme-uzmanlari.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('degerleme');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleProfessional: ['$translate', function ($translate) {
                            return $translate('c_app_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionProfessional: ['$translate', function ($translate) {
                            return $translate('c_app_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("evaluation_experts");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleProfessional}}",
                        description: "{{descriptionProfessional}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "DegerlemeUzmaniController",
                })
                .state("cozumler.yatirimci", {
                    url: "/{path2:bireysel|individuals|individuos|particulares}?ad?promo",
                    templateUrl: "app/content/kullanicilar-yatirimci/yatirimci.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('yatirimci');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        trans: "$transition$",
                        titleInvestors: ['$translate', function ($translate) {
                            return $translate('c_ind_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionInvestors: ['$translate', function ($translate) {
                            return $translate('c_ind_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            $translatePartialLoader.addPart("investors");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleInvestors}}",
                        description: "{{descriptionInvestors}}",
                        robots: [
                            "$transition$",
                            function ($transition$) {
                                if ($transition$.params().ad) return "noindex, nofollow";
                                else return "index, follow";
                            },
                        ],
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "YatirimciController",
                })

                .state("cozumler.perakende", {
                    url: "/{path2:kurumsal|enterprise|empresa|empreendimento}?ad?promo",
                    templateUrl: "app/content/kullanicilar-perakende/perakende.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('perakende');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleDeveloper: ['$translate', function ($translate) {
                            return $translate('c_enter_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionDeveloper: ['$translate', function ($translate) {
                            return $translate('c_enter_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("retail");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleDeveloper}}",
                        description: "{{descriptionDeveloper}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "PerakendeController",
                })
                .state("investment", {
                    url: "/:langcode/investment-detail?propertyId&propertyCategory",
                    templateUrl: "app/content/investment/investmentDetail.html",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("content");
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                            return $translate('c_an_find1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{title}}",
                        description: "{{description}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    //controller: "PerakendeController",
                })
                .state("404", {
                    url: "/:langcode/404",
                    templateUrl: "app/content/404.html",
                    title: "404",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        titleError404: ['$translate', function ($translate) {
                            return $translate('c_404').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleError404}}",
                        robots: "noindex, nofollow",
                        prerender: {

                            statusCode: "404",
                        },
                    },
                });


        }
    ]);

})();

(function () {


    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('geocoding-data', {
            url: "/:langcode/address-validation",
            templateUrl: 'app/geocoding/geocoding.html',
            controller: 'GeocodingController',
            params: {
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'geocoding');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('address_validation');
                    return $translate.refresh();
                }]
            }

        });
    }]);

})();

(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('valuation-wrapper', {
                url: '/:langcode/{path:property-value|emlak-degeri|valor-de-la-propiedad|valor-da-propriedade}/:address?name?rent',
                templateUrl: 'app/valuation-wrapper/valuation-wrapper.html',
                controller: 'ValuationWrapperController',
                params: {
                    address: {
                        value: null,
                        squash: true,
                        type: 'any',
                        raw: true
                    },
                    name: {
                        value: null
                    },
                    path: ['$translate', function ($translate) {
                        return $translate.instant("valuation-wrapper");
                    }],
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'valuationWrapper');
                    }],

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtect();
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_val_wrap_title').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_val_wrap_desc').then(function (res) {
                            return res;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_wrap');
                        return $translate.refresh();
                    }]
                },

                metaTags: {
                    title: '{{title}}',
                    robots: [
                        '$transition$',
                        function ($transition$) {
                            if ($transition$.params().address)
                                return 'noindex, nofollow';
                            else
                                return 'index, follow';
                        }
                    ],
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            });
    }]);
    angular.module("app.wrap", ["app.common"]);
})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('resident-valuation', {
            url: "/:langcode/{path:evimin-degeri|value-of-my-home|valor-de-mi-casa|valor-da-minha-casa}",
            params: {
                path: ['$translate', function ($translate) {
                    return $translate.instant("resident-valuation");
                }],
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            templateUrl: 'app/valuation/valuation.html',
            controller: 'YeniKonutController',
            abstract: true,
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'valuation');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('endeks_modal');
                    return $translate.refresh();
                }]
            }

        })
            .state('resident-valuation.step1', {
                url: "/{path2:ogren|learn|aprender|saber}/:address?top?room?living?bath?area?age?floor?heat?total?tid?nam?e?w?n?s?bosp?city?lake?nature?sea?mn?rd?sp?pl?el?gn?gk?sc?pi?po?si?so?hi?ac?fp?st?mortgage?rent",
                template: '<ed-yeni-konut-step1></ed-yeni-konut-step1>',
                params: {
                    selectedProducts: null,
                    address: {
                        value: null,
                        squash: true,
                        type: 'any',
                        raw: true
                    },
                    top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step1');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep1: ['$translate', function ($translate) {
                        return $translate('c_val_home1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep1: ['$translate', function ($translate) {
                        return $translate('c_val_home1_desc').then(function (res) {
                            return res;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step1');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep1}}',
                    description: '{{descriptionStep1}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    },
                    robots: [
                        '$transition$',
                        function ($transition$) {
                            if ($transition$.params().address)
                                return 'noindex, nofollow';
                            else
                                return 'index, follow';
                        }
                    ]
                }
            })
            .state('resident-valuation.step2', {
                url: "/{path2:ozellikler|properties|propiedades|propriedades}",
                template: '<ed-yeni-konut-step2></ed-yeni-konut-step2>',
                params: {
                    selectedProducts: null,
                    top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step2');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    // guard: ['$rootScope', '$transition$', 'restoreUrlService', function ($rootScope, $transition$, restoreUrlService) {
                    //     restoreUrlService.saveLastState('resident-valuation.step1', { langcode: window.lang });
                    //     if ($rootScope.SignedIn)
                    //         return true;
                    //     else {
                    //         $transition$.abort();
                    //         $transition$.router.stateService.go('register', { langcode: window.lang });
                    //     }
                    // }],
                    titleStep2: ['$translate', function ($translate) {
                        return $translate('c_val_home1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep2: ['$translate', function ($translate) {
                        return $translate('c_val_home1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step2');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep2}}',
                    description: '{{descriptionStep2}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('resident-valuation.step3', {
                url: "/{path2:ek-ozellikler|additionals|complementos|adicionais}",
                template: '<ed-yeni-konut-step3></ed-yeni-konut-step3>',
                params: {
                    selectedProducts: null,
                    top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step3');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep3: ['$translate', function ($translate) {
                        return $translate('c_val_home1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep3: ['$translate', function ($translate) {
                        return $translate('c_val_home1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step3');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep3}}',
                    description: '{{descriptionStep3}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('resident-valuation.step4', {
                url: "/{path2:olanaklar|facilities|instalacoes|instalaciones}",
                template: '<ed-yeni-konut-step4></ed-yeni-konut-step4>',
                params: {
                    selectedProducts: null,
                    top: null,
                    calculate: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step4');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep4: ['$translate', function ($translate) {
                        return $translate('c_val_home1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep4: ['$translate', function ($translate) {
                        return $translate('c_val_home1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step4');
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep4}}',
                    description: '{{descriptionStep4}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('resident-valuation.step5', {
                url: "/{path2:sonuc-tercihi|result-choice|eleccion-de-resultados|escolha-de-resultado}",
                template: '<ed-yeni-konut-step5></ed-yeni-konut-step5>',
                params: {
                    selectedProducts: null,
                    calculate: null,
                    top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step5');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep5: ['$translate', function ($translate) {
                        return $translate('c_val_home1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep5: ['$translate', function ($translate) {
                        return $translate('c_val_home1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep5}}',
                    description: '{{descriptionStep5}}',
                    robots: 'noindex, nofollow'

                }
            });

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('land-valuation', {
            url: "/:langcode/{path:arsamin-degeri|value-of-my-land|valor-de-mi-parcela|valor-do-meu-terreno}",
            params: {
                path: ['$translate', function ($translate) {
                    return $translate.instant("land-valuation");
                }],
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            templateUrl: 'app/valuation-land/valuation.html',
            controller: 'NewLandController',
            abstract: true,
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'valuation');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('endeks_modal');
                    return $translate.refresh();
                }]
            }
        })
            .state('land-valuation.step1', {
                url: "/{path2:ogren|learn|aprender}/:address?top?nam?tid?taks?kaks?hmax?floor?area?e?w?s?n?bosp?city?lake?nature?sea?el?wa?ro?cp?ex?bf?ns",
                template: '<land-val-step1></land-val-step1>',
                params: {
                    selectedProducts: null, top: null,
                    address: {
                        value: null,
                        squash: true,
                        type: 'any',
                        raw: true
                    },
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step1');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep1: ['$translate', function ($translate) {
                        return $translate('c_val_land1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep1: ['$translate', function ($translate) {
                        return $translate('c_val_land1_desc').then(function (res) {
                            return res;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step1');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep1}}',
                    robots: [
                        '$transition$',
                        function ($transition$) {
                            if ($transition$.params().address)
                                return 'noindex, nofollow';
                            else
                                return 'index, follow';
                        }
                    ],
                    description: '{{descriptionStep1}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })
            .state('land-valuation.step2', {
                url: "/{path2:ozellikler|properties|propiedades|propriedades}",
                template: '<land-val-step2></land-val-step2>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step2');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    // guard: ['$rootScope', '$transition$', function ($rootScope, $transition$) {
                    //     if ($rootScope.SignedIn)
                    //         return true;
                    //     else {
                    //         $transition$.abort();
                    //         $transition$.router.stateService.go('register', { langcode: window.lang });
                    //     }
                    // }],
                    titleStep2: ['$translate', function ($translate) {
                        return $translate('c_val_land1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep2: ['$translate', function ($translate) {
                        return $translate('c_val_land1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step2');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep2}}',
                    description: '{{descriptionStep2}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('land-valuation.step3', {
                url: "/{path2:ek-ozellikler|additionals|complementos|adicionais}",
                template: '<land-val-step3></land-val-step3>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step3');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep3: ['$translate', function ($translate) {
                        return $translate('c_val_land1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep3: ['$translate', function ($translate) {
                        return $translate('c_val_land1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step3');
                        $translatePartialLoader.addPart('valuation_step4');
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep3}}',
                    description: '{{descriptionStep3}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('land-valuation.step5', {
                url: "/{path2:sonuc-tercihi|result-choice|eleccion-de-resultados|escolha-de-resultado}",
                template: '<land-val-step4></land-val-step4>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step5');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep4: ['$translate', function ($translate) {
                        return $translate('c_val_land1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep4: ['$translate', function ($translate) {
                        return $translate('c_val_land1_title').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep4}}',
                    description: '{{descriptionStep4}}',
                    robots: 'noindex, nofollow'

                }
            });

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('field-valuation', {
            url: "/:langcode/{path:arazimin-degeri|value-of-my-field|valor-de-mi-terreno|valor-do-meu-campo}",
            params: {
                path: ['$translate', function ($translate) {
                    return $translate.instant("field-valuation");
                }],
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            templateUrl: 'app/valuation-field/valuation.html',
            controller: 'NewFieldController',
            abstract: true,
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'valuation');
                }],


                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('endeks_modal');
                    return $translate.refresh();
                }]
            }
        })
            .state('field-valuation.step1', {
                url: "/{path2:ogren|learn|aprender}/:address?top?nam?tid?kaks?hmax?area?e?w?s?n?bosp?city?lake?nature?sea?el?wa?ro?bf?ns?ng?ph?sw?ss?nr",
                template: '<field-val-step1></field-val-step1>',
                params: {
                    selectedProducts: null, top: null,
                    address: {
                        value: null,
                        squash: true,
                        type: 'any',
                        raw: true
                    },
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step1');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep1: ['$translate', function ($translate) {
                        return $translate('c_val_field1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep1: ['$translate', function ($translate) {
                        return $translate('c_val_field1_desc').then(function (res) {
                            return res;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step1');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep1}}',
                    robots: [
                        '$transition$',
                        function ($transition$) {
                            if ($transition$.params().address)
                                return 'noindex, nofollow';
                            else
                                return 'index, follow';
                        }
                    ],
                    description: '{{descriptionStep1}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })
            .state('field-valuation.step2', {
                url: "/{path2:ozellikler|properties|propiedades|propriedades}",
                template: '<field-val-step2></field-val-step2>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step2');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    // guard: ['$rootScope', '$transition$', function ($rootScope, $transition$) {
                    //     if ($rootScope.SignedIn)
                    //         return true;
                    //     else {
                    //         $transition$.abort();
                    //         $transition$.router.stateService.go('register', { langcode: window.lang });
                    //     }
                    // }],
                    titleStep2: ['$translate', function ($translate) {
                        return $translate('c_val_field1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep2: ['$translate', function ($translate) {
                        return $translate('c_val_field1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step2');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep2}}',
                    description: '{{descriptionStep2}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('field-valuation.step3', {
                url: "/{path2:ek-ozellikler|additionals|complementos|adicionais}",
                template: '<field-val-step3></field-val-step3>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step3');
                    }]
                },
                resolve: {
                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep3: ['$translate', function ($translate) {
                        return $translate('c_val_field1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep3: ['$translate', function ($translate) {
                        return $translate('c_val_field1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step3');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep3}}',
                    description: '{{descriptionStep3}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('field-valuation.step4', {
                url: "/{path2:olanaklar|facilities|instalacoes|instalaciones}",
                template: '<field-val-step4></field-val-step4>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step4');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep4: ['$translate', function ($translate) {
                        return $translate('c_val_field1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep4: ['$translate', function ($translate) {
                        return $translate('c_val_field1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step4');
                        $translatePartialLoader.addPart('valuation_step3');
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep4}}',
                    description: '{{descriptionStep4}}',
                    robots: 'noindex, nofollow'

                }
            })
            .state('field-valuation.step5', {
                url: "/{path2:sonuc-tercihi|result-choice|eleccion-de-resultados|escolha-de-resultado}",
                template: '<field-val-step5></field-val-step5>',
                params: {
                    selectedProducts: null, top: null,
                    path2: ['$translate', function ($translate) {
                        return $translate.instant('step5');
                    }]
                },
                resolve: {

                    LangProtect: ['routeHelpers', function(routeHelpers) {
                        return routeHelpers.langProtectTwoPath();
                    }],

                    titleStep5: ['$translate', function ($translate) {
                        return $translate('c_val_field1_title').then(function (res) {
                            return res;
                        });
                    }],
                    descriptionStep5: ['$translate', function ($translate) {
                        return $translate('c_val_field1_desc').then(function (res) {
                            return res;
                        });
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('valuation_step5');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    title: '{{titleStep5}}',
                    description: '{{descriptionStep5}}',
                    robots: 'noindex, nofollow'

                }
            });

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('commercial-valuation', {
            url: "/:langcode/{path:ticarimin-degeri|value-of-my-commercial|valor-de-mi-comercio|valor-do-meu-comercial}",
            params: {
                path: ['$translate', function ($translate) {
                    return $translate.instant("commercial-valuation");
                }],
                langcode: {
                    value: ['$translate', function ($translate) {
                        return $translate.use();
                    }]
                }
            },
            templateUrl: 'app/valuation-commercial/valuation.html',
            controller: 'NewLandController',
            abstract: true,
            resolve: {
                lazyLoad: ['$transition$', 'lazyLoadSvc', function($transition$, lazyLoadSvc) {
                    return lazyLoadSvc.load($transition$, 'valuationCommercial');
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('endeks_modal');
                    return $translate.refresh();
                }]
            }

        }).state('commercial-valuation.step1', {
            url: "/{path2:ogren|learn|aprender}/:address?top?room?living?bath?area?age?floor?heat?total?tid?nam?e?w?n?s?bosp?city?lake?nature?sea?mn?rd?sp?pl?el?gn?gk?sc?pi?po?si?so?hi?ac?fp?st",
            template: '<commercial-val-step1></commercial-val-step1>',
            params: {
                selectedProducts: null, top: null,
                address: {
                    value: null,
                    squash: true,
                    type: 'any',
                    raw: true
                },
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step1');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep1: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep1: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],


                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step1');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep1}}',
                robots: [
                    '$transition$',
                    function ($transition$) {
                        if ($transition$.params().address)
                            return 'noindex, nofollow';
                        else
                            return 'index, follow';
                    }
                ],
                description: '{{descriptionStep1}}',
                properties: {
                    'og:image': 'http://www.endeksa.com/share3.jpg',
                    'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                    'og:type': 'website'
                }
            }
        }).state('commercial-valuation.step2', {
            url: "/{path2:ozellikler|properties|propiedades|propriedades}",
            template: '<commercial-val-step2></commercial-val-step2>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step2');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                // guard: ['$rootScope', '$transition$', function ($rootScope, $transition$) {
                //     if ($rootScope.SignedIn)
                //         return true;
                //     else {
                //         $transition$.abort();
                //         $transition$.router.stateService.go('register', { langcode: window.lang });
                //     }
                // }],
                titleStep2: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep2: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step2');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep2}}',
                description: '{{descriptionStep2}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step3', {
            url: "/{path2:ek-ozellikler|additionals|adicionais|complementos}",
            template: '<commercial-val-step3></commercial-val-step3>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step3');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep3: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep3: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step2');
                    $translatePartialLoader.addPart('valuation_step3');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep3}}',
                description: '{{descriptionStep3}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step4', {
            url: "/{path2:olanaklar|facilities|instalacoes|instalaciones}",
            template: '<commercial-val-step4></commercial-val-step4>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step4');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep4: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep4: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step4');
                    $translatePartialLoader.addPart('valuation_step5');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep4}}',
                description: '{{descriptionStep4}}',
                robots: 'noindex, nofollow'

            }
        }).state('commercial-valuation.step5', {
            url: "/{path2:sonuc-tercihi|result-choice|eleccion-de-resultados|escolha-de-resultado}",
            template: '<commercial-val-step5></commercial-val-step5>',
            params: {
                selectedProducts: null, top: null,
                path2: ['$translate', function ($translate) {
                    return $translate.instant('step5');
                }]
            },
            resolve: {

                LangProtect: ['routeHelpers', function(routeHelpers) {
                    return routeHelpers.langProtectTwoPath();
                }],

                titleStep5: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_title').then(function (res) {
                        return res;
                    });
                }],
                descriptionStep5: ['$translate', function ($translate) {
                    return $translate('c_val_comm1_desc').then(function (res) {
                        return res;
                    });
                }],

                translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                    $translatePartialLoader.addPart('valuation_step5');
                    return $translate.refresh();
                }]
            },
            metaTags: {
                title: '{{titleStep5}}',
                description: '{{descriptionStep5}}',
                robots: 'noindex, nofollow'

            }
        });

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('property-detail', {
                url: "/:langcode/properties/:id/:name?item?rent",
                templateUrl: '/app/endeks/houses-detail.html',
                controller: 'PropertyDetailController',
                controllerAs: "vm",
                metaTags: {
                    robots: 'noindex, nofollow'
                },
                params: {

                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    id: { type: 'any', raw: true },
                    name: { type: 'any', raw: true },
                    item: { type: 'any', raw: true }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        // Load propertyDetail bundle + maps bundle for Google Maps API
                        var bundles = ['propertyDetail', 'maps'];
                        return lazyLoadSvc.load($transition$, bundles);
                    }],
                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],
                    HasPro: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "eco-package",
                            'seller-lead-package',
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart("valuation_house_details");
                        $translatePartialLoader.addPart("analysis_value");
                        $translatePartialLoader.addPart("endeks_modal");
                        $translatePartialLoader.addPart("property_details");
                        $translatePartialLoader.addPart("properties"); // Investment analysis translations
                        $translatePartialLoader.addPart("valuation_step1");
                        $translatePartialLoader.addPart("valuation_step2");
                        $translatePartialLoader.addPart("valuation_step3");
                        $translatePartialLoader.addPart("valuation_step4");
                        $translatePartialLoader.addPart("product_report");
                        $translatePartialLoader.addPart("payment");
                        return $translate.refresh();
                    }]
                }

            });
    }]);


})();

(function () {
	'use strict';

	angular.module('app.core').config([
		'$stateProvider',
		function ($stateProvider) {
			$stateProvider
				.state('neighbourSection', {
					url: '/:langcode/n', //n is required for SEO
					params: {
						langcode: {
				            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
						}
					},
					abstract: true,
					templateUrl: 'app/neighbourhood/views/neighbourhood.html',
					controller: 'NeighbourhoodController',
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'neighbourhood');
						}],

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart("analysis_houseOpportDetail");
							$translatePartialLoader.addPart("analysis_layout");
							$translatePartialLoader.addPart("analysis_value");
							return $translate.refresh();
						}]
					}
				})
				.state('neighbourSection.details', {
					url: '/:neighbourhood/:id',
					templateUrl: 'app/neighbourhood/views/neighbourhoodDetail/neighbourhoodDetail.html',
					controller: 'NeighbourhoodDetailController',
					params: {
						neighbourhood: {
							value: null,
							dynamic: true
						},
						id: {
							value: null,
							dynamic: true
						}
					},
					resolve: {

						getNeighbourhoodById: [
							'geoApi',
							'$transition$',
							'$q',
							function (geoApi, $transition$, $q) {
								var deferred = $q.defer();
								var tempId = +$transition$.params().id;
								var res = geoApi.getById({ districtId: tempId, countyId: 0, cityId: 0, countryId: 1, level: 3 });
								res.$promise.then(
									function (result) {
										deferred.resolve(result);
									},
									function (err) {
										deferred.reject(err);
									}
								);
								return deferred.promise;
							}
						],

						titleCase: ['getNeighbourhoodById', function (getNeighbourhoodById) {
							return getNeighbourhoodById && getNeighbourhoodById.features ? getNeighbourhoodById.features[0].properties.District : "";
						}],

						titleCase2: ['getNeighbourhoodById', function (getNeighbourhoodById) {
							return getNeighbourhoodById && getNeighbourhoodById.features ? (getNeighbourhoodById.features[0].properties.City + ' ' + getNeighbourhoodById.features[0].properties.County) : "";
						}],
						title: ['$translate', function ($translate) {
							return $translate('c_nbr1').then(function (res) {
								return res;
							});
						}],
						description: ['$translate', function ($translate) {
							return $translate('c_nbr2').then(function (res) {
								return res;
							});
						}],


						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('neighbourhood_detail');
							return $translate.refresh();
						}]
					},
					metaTags: {
						title: '{{titleCase2}} {{titleCase}} {{title}}',
						description: '{{titleCase2}} {{titleCase}} {{description}}',
						robots: 'noindex, nofollow',
						properties: {
							'og:image': 'http://www.endeksa.com/og_image3.png',
							'og:image:secure_url': 'https://www.endeksa.com/og_image3.png',
							'og:type': 'website'
						}
					}
				})
				/* .state('neighbourSection.details.explore', {
					views: {
						mapData: {
							templateUrl:
								'app/neighbourhood/views/neighbourhoodDetail/neighbourhoodDetailExplore/neighbourhoodDetailExplore.html',
							controller: 'NeighbourhoodDetailExploreController'
						}
					},
					metaTags: {
						title: '{{titleCase2}} {{titleCase}} {{title}}',
						description: '{{titleCase2}} {{titleCase}} {{description}}',
						robots: 'noindex, nofollow',
						properties: {
							'og:image': 'http://www.endeksa.com/og_image3.png',
							'og:image:secure_url': 'https://www.endeksa.com/og_image3.png',
							'og:type': 'website'
						}
					}
				}); */
		}
	]);

})();

(function () {
    "use strict";
    angular.module("app.core").config([
        "$stateProvider",
        function ($stateProvider) {
            $stateProvider
                .state("localInfo", {
                    url: "/:langcode",
                    abstract: true,
                    templateUrl: "app/localInformation/views/localInfo.html",
                    controller: "LocalInfoController",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'localInfo');
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_projects");
                            $translatePartialLoader.addPart("property_details");
                            $translatePartialLoader.addPart("analysis_houseOpportDetail");
                            $translatePartialLoader.addPart("opportunity");
                            $translatePartialLoader.addPart("valuation_house_details");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("localInfo.property", {
                    // Property LocalInfo
                    url: "/{path:listing|firsat-emlak-ilan|anuncio}/:name/:id",

                    views: {
                        main: {
                            templateUrl: "app/localInformation/views/localProperties/localProperties.html",
                            controller: "LocalPropertiesController",
                            controllerAs: "vm",
                        },
                        // child modules for property page
                        "propertyHeader@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyHeader/propertyHeader.html",
                            controller: "PropertyHeaderController",
                            controllerAs: "vm",
                        },
                        "propertyInfoMain@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyMainInfo/propertyMainInfo.html",
                            controller: "LocalMainInfoController",
                            controllerAs: "vm",
                        },
                        "propertyDetails@localInfo.property": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyDetails/propertyDetails.html",
                            controller: "PropertyDetailsController",
                            controllerAs: "vm",
                        },
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect('localInfo');
                        }],
                        comparable: function () { return null; },
                        geo: function () { return null; },

                        opportById: [
                            "opportunitiesGetApi",
                            "$transition$",
                            "$q",
                            "$rootScope",
                            "$translate",
                            "$timeout",
                            "historyService",
                            function (opportunitiesGetApi, $transition$, $q, $rootScope, $translate, $timeout, historyService) {
                                var deferrer = $q.defer();
                                if (!$transition$.params().id) deferrer.resolve(null);
                                else {
                                    var isIdString = typeof $transition$.params().id !== "number" ? $transition$.params().id.split("-").pop() : $transition$.params().id;
                                    var isId = parseInt(isIdString);
                                    // $http
                                    //     .get("https://pro.ip-api.com/json/?key=oeEJpK6wjHS9CN2")
                                    //     .then(
                                    //         function (res) {
                                    //             portfolioById
                                    //                 .getByIdIp(res.data.query)
                                    //                 .query({ portfolioId: isId })
                                    //                 .$promise.then(
                                    //                     function (result) {
                                    //                         deferrer.resolve(result);
                                    //                     },
                                    //                     function () {
                                    //                         deferrer.resolve(null);
                                    //                     }
                                    //                 );
                                    //         },
                                    //         function () {
                                    opportunitiesGetApi
                                        .getById({ portfolioId: isId })
                                        .$promise.then(
                                            function (result) {
                                                if (result && result.Details && result.Details.length) {
                                                    const currentDetails = result.Details.find(m => m.Language === window.langCode());
                                                    if (currentDetails)
                                                        if (currentDetails.Url !== $transition$.params().name) {
                                                            $timeout(function () {
                                                                $rootScope.MetaTags.prerender.statusCode = 301;
                                                                window.redirected = "Location: " + $transition$.router.stateService.href("localInfo.property", { langcode: $transition$.params().langcode, name: currentDetails.Url, path: $translate.instant("localInfo"), id: $transition$.params().id });
                                                                $rootScope.MetaTags.prerender.header = window.redirected;
                                                            });
                                                            $transition$.abort();
                                                            $transition$.router.stateService.go("localInfo.property", { langcode: $transition$.params().langcode, name: currentDetails.Url, path: $translate.instant("localInfo"), id: $transition$.params().id });
                                                            deferred.resolve();
                                                        }
                                                        else {
                                                            if (result.UrlHistory && result.UrlHistory.length)
                                                                window.listingUrls = result.UrlHistory.filter(m => m.IsActive);

                                                            historyService.set('opportunity', isId);

                                                            deferrer.resolve(result);
                                                        }
                                                    else
                                                        deferrer.resolve(null);
                                                }
                                                else {
                                                    deferrer.resolve(null);
                                                }
                                            },
                                            function () {
                                                deferrer.resolve(null);
                                            }
                                        );
                                    //     }
                                    // );
                                }
                                return deferrer.promise;
                            }
                        ],

                        // user: [
                        //     "user_factory",
                        //     "$transition$",
                        //     "$q",
                        //     "opportById",
                        //     function (user_factory, $transition$, $q, opportById) {
                        //         var deferrer = $q.defer();
                        //         var uid = $transition$.params().uid;
                        //         if (!uid && opportById.UserId) {
                        //             user_factory.get({ userId: opportById.UserId }).$promise.then(function (result) {
                        //                 deferrer.resolve(result.information);
                        //             }).catch(() => {
                        //                 deferrer.resolve(null);
                        //             });
                        //         }
                        //         else {
                        //             user_factory.get({ userId: uid }).$promise.then(function (result) {
                        //                 deferrer.resolve(result.information);
                        //             }).catch(() => {
                        //                 deferrer.resolve(null);
                        //             });
                        //         }
                        //         return deferrer.promise;
                        //     },
                        // ],

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            "opportById",
                            // "notifierSvc",
                            //"$rootScope",
                            // "$timeout",
                            function (
                                searchParserService,
                                $transition$,
                                opportById,
                                // notifierSvc,
                                //$rootScope
                                // $timeout
                            ) {
                                if (!opportById) {
                                    // $transition$.abort();
                                    // $transition$.router.stateService.go("404", { langcode: $transition$.params().langcode });
                                    // $timeout(function () {
                                    //     $rootScope.MetaTags.prerender.statusCode = 301;
                                    //     window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.opportunity", { langcode: $transition$.params().langcode, country: "world" });
                                    //     $rootScope.MetaTags.prerender.header = window.redirected;
                                    // }, 0);
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.opportunity", { langcode: $transition$.params().langcode, country: "world" });

                                    // var translation = $transition$.params().langcode === 'tr' ? "Bu fırsat yayından kalktı. Aynı bölgedeki diğer fırsatları inceleyebilirsiniz." : "This property is not available anymore. You can check other opportunities around.";
                                    // notifierSvc.show({ message: translation, type: "info" });

                                    // var keys = $transition$.params().id.split("-");
                                    // if (keys.length > 2) {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });

                                    // } else {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    // }
                                } else {
                                    return searchParserService.parseSearchForOpportunity(
                                        opportById,
                                        $transition$.params()
                                    );
                                }
                            },
                        ],

                        titleOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else {
                                return opportById.Details.find(m => m.Language === window.langCode()).Title;
                            }
                        }],

                        descOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else {
                                return opportById.Details.find(m => m.Language === window.langCode()).Description;
                            }
                        }],

                        imgOpp: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else return opportById.Photos.length ? opportById.Photos[0].replace("https://", "http://") : "";
                        }],
                        imgOppSecure: ['opportById', function (opportById) {
                            if (!opportById) {
                                return "";
                            } else return opportById.Photos.length ? opportById.Photos[0].replace("http://", "https://") : "";
                        }],

                    },
                    metaTags: {
                        title: "{{titleOpp}}",
                        description: "{{descOpp}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "{{imgOpp}}",
                            "og:image:secure_url": "{{imgOppSecure}}",
                            "og:type": "website",
                        },
                    },
                    params: {
                        path: ['$translate', function ($translate) {
                            return $translate.instant("localInfo");
                        }],
                        id: {
                            type: "any",
                            raw: true,
                            dynamic: false
                        },
                        name: {
                            type: "any",
                            raw: true,
                            dynamic: false
                        },
                    }
                })
                .state("localInfo.share", {
                    // Property LocalInfo
                    url: "/ps/:uid/:sid/:cid",
                    views: {
                        main: {
                            templateUrl: "app/localInformation/views/localProperties/localProperties.html",
                            controller: "LocalPropertiesController",
                            controllerAs: "vm",
                        },
                        // child modules for property page
                        "propertyHeader@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyHeader/propertyHeader.html",
                            controller: "PropertyHeaderController",
                            controllerAs: "vm",
                        },
                        "propertyInfoMain@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyMainInfo/propertyMainInfo.html",
                            controller: "LocalMainInfoController",
                            controllerAs: "vm",
                        },
                        "propertyDetails@localInfo.share": {
                            templateUrl: "app/localInformation/views/localProperties/PropertyDetails/propertyDetails.html",
                            controller: "PropertyDetailsController",
                            controllerAs: "vm",
                        },
                    },
                    resolve: {
                        opportById: function () { return null; },

                        comparable: [
                            "shareAPI",
                            "$transition$",
                            "$q",
                            "comparablesApi",
                            function (shareAPI, $transition$, $q, comparablesApi) {
                                var deferrer = $q.defer();
                                var cid = $transition$.params().cid;
                                var sid = $transition$.params().sid;
                                if (!cid || !sid) deferrer.resolve(null);
                                else {
                                    shareAPI
                                        .view({ sharedId: sid, comparableId: cid.substring(5) })
                                        .$promise.then(function () { });
                                    shareAPI.get({ sharedId: sid }).$promise.then(
                                        function (result) {
                                            for (var y = 0; y < result.Comparables.length; y++) {
                                                var comp = result.Comparables[y];
                                                if (comp.EndeksaId == cid) {
                                                    comparablesApi.detail({EndeksaId: comp.EndeksaId, captchaTokenCustom: window.ecSec()}).$promise.then(function (detailResult) {
                                                        detailResult.ShowSellerAgent = comp.ShowSellerAgent;
                                                        deferrer.resolve(detailResult);
                                                    });
                                                    return;
                                                }
                                            }

                                            deferrer.resolve(null);
                                        },
                                        function () {
                                            deferrer.resolve(null);
                                        }
                                    );

                                    //urlSearchApi.get({ listingurl: +cid }).$promise.then(function (result) {
                                    //    deferrer.resolve(result);
                                    //}, function () {
                                    //    deferrer.resolve(null);
                                    //});
                                }
                                return deferrer.promise;
                            },
                        ],

                        geo: [
                            "geoApi",
                            "$q",
                            "comparable",
                            function (geoApi, $q, comparable) {
                                var deferrer = $q.defer();
                                if (!comparable) deferrer.resolve(null);
                                else {
                                    var geoAp = geoApi.get({
                                        lat: +comparable.Latitude,
                                        long: +comparable.Longitude,
                                        level: 3
                                    });
                                    geoAp.$promise.then(
                                        function (resb) {
                                            deferrer.resolve(resb);
                                        },
                                        function () {
                                            deferrer.resolve(null);
                                        }
                                    );
                                }
                                return deferrer.promise;
                            },
                        ],

                        resolveAPIs: [
                            "searchParserService",
                            "$transition$",
                            "comparable",
                            // "notifierSvc",
                            // "$rootScope",
                            // "$timeout",
                            function (
                                searchParserService,
                                $transition$,
                                comparable
                                // notifierSvc,
                                // $rootScope,
                                // $timeout
                            ) {
                                if (!comparable) {

                                    // var translation = $transition$.params().langcode === 'tr' ? "Bu forsat yayından kalktı. Aynı bölgedeki diğer fırsatları inceleyebilirsiniz." : "This deal is not available anymore. You can check other opportunities around.";
                                    // notifierSvc.show({ message: translation, type: "info" });

                                    // var keys = $transition$.params().id.split("-");
                                    // if (keys.length > 2) {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: keys[0], county: keys[1] });

                                    // } else {
                                    //     $timeout(function () {
                                    //         $rootScope.MetaTags.prerender.statusCode = 301;
                                    //         window.redirected = "Location: " + $transition$.router.stateService.href("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    //         $rootScope.MetaTags.prerender.header = window.redirected;
                                    //     }, 0);
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go("analysis.province.opportunity", { langcode: $transition$.params().langcode, province: "turkiye" });
                                    // }
                                } else {
                                    return searchParserService.parseSearchForOpportunity(
                                        comparable,
                                        $transition$.params()
                                    );
                                }
                            },
                        ],

                        titleOpp: ['comparable', function (comparable) {
                            return comparable.Title;
                        }],

                        descOpp: ['comparable', function (comparable) {
                            return comparable.Description;
                        }],

                        imgOpp: ['comparable', function (comparable) {
                            return comparable.Image.replace("https://", "http://");
                        }],
                        imgOppSecure: ['comparable', function (comparable) {
                            return comparable.Image.replace("http://", "https://");
                        }]
                    },
                    metaTags: {
                        title: "{{titleOpp}}",
                        description: "{{descOpp}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "{{imgOpp}}",
                            "og:image:secure_url": "{{imgOppSecure}}",
                            "og:type": "website",
                        },
                    },
                    params: {
                        cid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                        uid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                        sid: {
                            type: "any",
                            raw: true,
                            dynamic: false,
                        },
                    }
                });
        },
    ]);
})();

(function () {
  "use strict";

  angular.module("app.core").config([
    "$stateProvider",
    function ($stateProvider) {
      $stateProvider.state("share-portfolio", {
        url: "/:langcode/sizin-icin-buldum/:id",
        templateUrl: "app/share/share.html",
        controller: "ShareController",
        params: {
          langcode: {
            value: ['$translate', function ($translate) {
              return $translate.use();
          }]
          }
        },
        resolve: {
          lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
            return lazyLoadSvc.load($transition$, 'share');
          }],

          title: [
            "$stateParams",
            function ($stateParams) {
              return $stateParams.langcode === "tr"
                ? "Sizin İçin Bulduğum Portföyler"
                : "I Found For You";
            },
          ],

          description: [
            "$stateParams",
            function ($stateParams) {
              return $stateParams.langcode === "tr"
                ? "Bulduğum portföyleri buradan inceleyebilir, bulundukları mahalle hakkında bilgilere ulaşabilir ve gayrimenkul piyasa detaylarını görebilirsiniz."
                : "You can see portfolio details, photos, neighborhood information and real estate market details from here.";
            },
          ],

          translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
            $translatePartialLoader.addPart("share");
            return $translate.refresh();
          }],
          shared: [
            "shareAPI",
            "$transition$",
            function (shareAPI, $transition$) {
              var id = $transition$.params().id;
              return shareAPI.get({ sharedId: id }).$promise;
            },
          ],
        },
        metaTags: {
          robots: "noindex, nofollow",
          title: "{{title}}",
          description: "{{description}}"
        }
      });
    },
  ]);
})();

(function () {
    'use strict';

    angular.module('app.common', []);

    //shell.config(['$routeProvider', function ($routeProvider) {
    //}]); 

})();
(function () {
	'use strict';

	angular.module('app.core').config([
		'$stateProvider',
		function ($stateProvider) {
			$stateProvider
				.state('oppor', {
					url: '/:langcode',
					abstract: true,
					templateUrl: 'app/opportunity/views/opportunity.html',
					controller: 'OpportunityController',
					controllerAs: 'vm',
					params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'opportunity');
						}],

						trans: '$transition$',

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							$translatePartialLoader.addPart('analysis_houseOpportunity');
							return $translate.refresh();
						}]
					}
				})
				.state('oppor.listing', {
					url: '/opportunities/f/:id/:name?portfolio',
					views: {
						main: {
							templateUrl: '/app/opportunity/views/opportunity-listing/opporListing.html',
							controller: 'OpporListingController',
							controllerAs: 'vm'
						},
						// child-views
						'formGeolocation@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormGeolocation/opportunityGeolocation.html',
							controller: 'OpportunityGeoController',
							controllerAs: 'vm'
						},
						'formPropertyLand@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormPropertyLand/opportunityPropertyLand.html',
							controller: 'OpportunityPropertyLandController',
							controllerAs: 'vm'
						},
						'formPropertyCommercial@oppor.listing': {
							templateUrl: '/app/opportunity/views/opportunity-listing/opportunityFormPropertyCommercial/opportunityPropertyCommercial.html',
							controller: 'OpportunityPropertyCommercialController',
							controllerAs: 'vm'
						},
						'formPropertyResidential@oppor.listing': {
							templateUrl: '/app/opportunity/views/opportunity-listing/opportunityFormPropertyResidential/opportunityFormPropertyResidential.html',
							controller: 'OpportunityPropertyResidentialController',
							controllerAs: 'vm'
						},
						'formValue@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormValue/opportunityValue.html',
							controller: 'OpportunityValueController',
							controllerAs: 'vm'
						},
						'formPhoto@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormPhoto/opportunityPhoto.html',
							controller: 'OpportunityPhotoController',
							controllerAs: 'vm'
						},
						'formDescription@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormDescription/opportunityDescription.html',
							controller: 'OpportunityDescriptionController',
							controllerAs: 'vm'
						},
						'formTitle@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormTitle/opportunityTitle.html',
							controller: 'OpportunityTitleController',
							controllerAs: 'vm'
						},
						'formUser@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormUser/opportunityUser.html',
							controller: 'OpportunityUserController',
							controllerAs: 'vm'
						},
						'formZoning@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormZoning/opportunityZoning.html',
							controller: 'OpportunityZoningController',
							controllerAs: 'vm'
						}
					},
					resolve: {

						trans: '$transition$',

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							return $translate.refresh();
						}]
					},
					params: {
						id: { type: 'any', raw: true },
						name: { type: 'any', raw: true }
					},
					metaTag: {
						robots: 'noindex, nofollow',
						description: '{{descriptionListing}}',
					}
				}).state('publishlisting', {
					url: '/publishlisting?yetkiKodu&durum',
					templateUrl: 'app/opportunity/views/publishlisting.html',
					controller: 'PublishlistingController',
					controllerAs: 'vm',
					params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
						yetkiKodu: { type: 'any', raw: true },
						durum: { type: 'any', raw: true },
                    },
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'opportunity');
						}],

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							$translatePartialLoader.addPart('analysis_houseOpportunity');
							return $translate.refresh();
						}]
					}
				});
		}
	]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('profile', {
                url: "/:langcode/account",
                templateUrl: 'app/profile/profile.html',
                controller: 'ProfileController',
                abstract: true,
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profile');
                    }],
                    guard: [
                        'guardSvc',
                        function (guardSvc) {
                            return guardSvc.guardRoute();
                        }
                    ],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('menu_profile');
                        $translatePartialLoader.addPart('profile_account');
                        return $translate.refresh();
                    }]
                }
            })
            .state('profile.account', {
                url: '/user',
                templateUrl: 'app/profile/profile-account.html',
                controller: 'ProfileAccountController',
                resolve: {
                    userInfo: ['userSvc', 'CacheFactory', function (userSvc, CacheFactory) {
                        // Clear all user-related caches before fetching fresh data
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        // Force fetch user info from API on each page load (bypass cache)
                        return userSvc.getUserInfo(true);
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.billing', {
                url: '/billing',
                templateUrl: 'app/profile/profile-billing.html',
                controller: 'ProfileBillingController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profileBilling');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_billing');
                        $translatePartialLoader.addPart('payment');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            // .state('profile.subscription', {
            //     url: '/subscription',
            //     templateUrl: 'app/profile/profile-subscription.html',
            //     controller: 'ProfileSubscriptionController',
            //     // lazyLoad: function ($transition$) {
            //     //     var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
            //     //     lazyLoad.inject('ngAnimate');
            //     //     lazyLoad.load([
            //     //         "/assets/css/main.payment.min.css?v=" + window.appVersion
            //     //     ]);
            //     //     return lazyLoad.load(
            //     //         {
            //     //             serie: false,
            //     //             files: [
            //     //                 "/assets/js/main.payment.min.js?v=" + window.appVersion
            //     //             ], insertBefore: '#last_script'
            //     //         }
            //     //     );
            //     // },
            //     resolve: {
            //
            //         translations: function ($translatePartialLoader, $translate) {
            //             $translatePartialLoader.addPart('profile_billing');
            //             return $translate.refresh();
            //         }
            //     },
            //     metaTags: {
            //         robots: 'noindex, nofollow'
            //     }
            // })
            // .state('profile.cards', {
            //     url: '/cards',
            //     templateUrl: 'app/profile/profile-cards.html',
            //     controller: 'ProfileCardsController',
            //     constrollerAs: 'vm',
            //     lazyLoad: function ($transition$) {
            //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
            //         lazyLoad.inject('ngAnimate');
            //         lazyLoad.load([
            //             "/assets/css/vendor.payment.min.css?v=" + window.appVersion,
            //             "/assets/css/main.payment.min.css?v=" + window.appVersion
            //         ]);
            //         return lazyLoad.load(
            //             {
            //                 serie: false,
            //                 files: [
            //                     "/assets/js/vendor.payment.min.js?v=" + window.appVersion,
            //                     "/assets/js/main.payment.min.js?v=" + window.appVersion,
            //                 ], insertBefore: '#last_script'
            //             }
            //         );
            //     },
            //     resolve: {
            //         cCart: ['paymentService', function (paymentService) {
            //             paymentService.clearCart();
            //         }],
            //
            //         translations: function ($translatePartialLoader, $translate) {
            //             $translatePartialLoader.addPart('profile_billing');
            //             $translatePartialLoader.addPart('payment');
            //             return $translate.refresh();
            //         }
            //     },
            //     metaTags: {
            //         robots: 'noindex, nofollow'
            //     }
            // })
            .state('profile.experience', {
                url: '/settings',
                templateUrl: 'app/profile/profile-experience.html',
                controller: 'ProfileExperienceController',
                resolve: {

                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],

                    HasPlatinum: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "location-package",
                        ]);
                    }],

                    HasPremium: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "eco-package",
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    HasRealEstate: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    HasLocation: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage(["location-package"]);
                    }],

                    HasAlarm: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package"
                        ]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_experience');
                        $translatePartialLoader.addPart('analysis_layout');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.company', {
                url: '/company',
                templateUrl: 'app/profile/profile-company.html',
                controller: 'ProfileCompanyController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profileCompany');
                    }],
                    guard: [
                        "guardSvc",
                        "$window",
                        function (guardSvc, $window) {
                            if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                return true;
                            else
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package",
                                    "eco-package",
                                    'seller-lead-package',
                                    "premium-package",
                                    "premiumplus-package",
                                    "pro-ee-package",
                                    "flex-package",
                                    "gold-package",
                                    "terminal-flex-package",
                                    "terminal-pro-package",
                                    "terminal-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                ]);
                        },
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('consultant_profile');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.userManagement', {
                url: '/user-management',
                templateUrl: 'app/profile/profile-user-management.html',
                controller: 'ProfileUserManagementController',
                resolve: {
                    guard: [
                        "guardSvc",
                        function (guardSvc) {
                            return guardSvc.guardRoute([
                                "terminal-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "terminal-premium-package"
                            ]);
                        },
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_user_management');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            });

        // .state('profile.registrationManagement', {
        //     url: '/membership',
        //     templateUrl: 'app/profile/profile-registration-management.html',
        //     controller: 'ProfileRegistrationManagementController',
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('registration_management');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // })
        // .state('profile.billingAdres', {
        //     url: '/billing-address',
        //     templateUrl: 'app/profile/profile-address.html',
        //     controller: 'ProfileAddressController',
        //     lazyLoad: function ($transition$) {
        //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
        //         lazyLoad.inject('ngAnimate');
        //         return lazyLoad.load(
        //             {
        //                 files: [
        //                     "/assets/js/main.payment.min.js?v=" + window.appVersion
        //                 ], insertBefore: '#last_script'
        //             }
        //         );
        //     },
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('profile_account');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // })
        // .state('profile.creditCardEdit', {
        //     url: '/payment-options',
        //     template: '<credit-card-edit></credit-card-edit>',
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('profile_account');
        //             $translatePartialLoader.addPart('payment');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // });

    }]);

})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider

            .state('odeme-success', {
                url: "/:langcode/payment/success/:id?utm_source",
                template: '<payment-success></payment-success>',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    id: {
                        type: 'any',
                        raw: true,
                        value: null,
                        squash: true,
                        dynamic: true
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'payment');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('payment');
                        return $translate.refresh();
                    }],
                    bankInit: ['$rootScope', '$q', '$transition$', function ($rootScope, $q, $transition$) {
                        var deferred = $q.defer();
                        // Bank integration check
                        if ($rootScope.isTop && window.hasAllowance === 'bank') {
                            $rootScope.isBank = true;
                            var utmSource = $transition$.params().utm_source;
                            var bankSource = null;
                            // Set source based on bank: isbankasi=5, yapikredi=4, akbank=12
                            if (utmSource === 'isbankasi') {
                                bankSource = 5;
                            } else if (utmSource === 'yapikredi') {
                                bankSource = 4;
                            } else if (utmSource === 'akbank') {
                                bankSource = 12;
                            }
                            // Initialize clientData for bank mode
                            if (!$rootScope.clientData)
                                $rootScope.clientData = {
                                    name: null,
                                    surName: null,
                                    phoneNumber: null,
                                    email: null,
                                    ip: null,
                                    source: bankSource

                                }
                        } deferred.resolve();
                        return deferred.promise;
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('odeme-onepage', {
                url: "/:langcode/payment/:code?currency?promo?type?is_commitment?country?city?county?district?level?error",
                templateUrl: 'app/payment/payment-onepage.html',
                controller: 'PaymentOnePageController',
                controllerAs: 'vm',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    code: { type: 'any', raw: true }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'paymentExternal');
                    }],

                    products: ['paymentService', function (paymentService) {
                        return paymentService.getProducts();
                    }],
                    isProduct: ['$transition$', '$location', 'products', 'paymentService', function ($transition$, $location, products, paymentService) {
                        var checkId = false;
                        for (var j = 0; j < products.data.length; j++) {
                            if ($transition$.params().code === products.data[j].code && ($transition$.params().type ? products.data[j].productType === +$transition$.params().type : true)) {
                                paymentService.clearCart();
                                paymentService.addToCart(products.data[j]);
                                checkId = true;
                            }
                        }
                        if (!checkId) {
                            var langKey = window.lang || 'tr';
                            $location.replace().path('/' + langKey + '/404'); //state olunca history'e mevcut sayfay� ekledi�inden browser geri tu�u �al��m�yor b�yle y�nlendirmelerde bu nedenle location.replace
                        }
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('payment');
                        $translatePartialLoader.addPart('factura_address');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            });
        //http://localhost:8080/tr/payment/kira-trink/NDc0Mzg1/facbfe00-9689-49d0-99c4-08d94219ad66
        // .state('odeme-renta', {
        //     url: "/:langcode/payment/kira-trink/:propertyId/:paymentId",
        //     templateUrl: 'app/payment/payment-onepage.html',
        //     controller: 'PaymentOnePageController',
        //     controllerAs: 'vm',
        //     params: {
        //         langcode: {
        //             value: function ($translate) {
        //                 return $translate.use();
        //             }
        //         },
        //         propertyId: { type: 'any', raw: true },
        //         paymentId: { type: 'any', raw: true }
        //     },
        //     lazyLoad: function ($transition$) {
        //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
        //         lazyLoad.inject('ngAnimate');
        //         lazyLoad.load([
        //             "/assets/css/vendor.payment.min.css?v=" + window.appVersion,
        //             "/assets/css/main.payment.min.css?v=" + window.appVersion
        //         ]);
        //         return lazyLoad.load(
        //             {
        //                 serie: false,
        //                 files: [
        //                     "https://www.google.com/recaptcha/api.js?render=6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS",
        //                     "/assets/js/vendor.payment.min.js?v=" + window.appVersion,
        //                     "/assets/js/main.payment.min.js?v=" + window.appVersion,
        //                 ], insertBefore: '#last_script'
        //             }
        //         );
        //     },
        //     resolve: {
        //
        //         products: ['paymentService', function (paymentService) {
        //             return paymentService.getProducts();
        //         }],
        //         renta: ['paymentService', '$transition$', function (paymentService, $transition$) {
        //             return paymentService.getRenta($transition$.params().propertyId);
        //         }],
        //         payment: ['renta', '$transition$', function (renta, $transition$) {
        //             if (renta && renta.data && renta.data.payments)
        //                 return renta.data.payments.find(pay => pay.id === $transition$.params().paymentId);
        //             else
        //                 return null;
        //         }],
        //         isProduct: ['$location', 'products', 'payment', 'paymentService', function ($location, products, payment, paymentService) {
        //             const productCode = payment.paymentType === 2 ? 'kira-trink-subscription' : 'kira-trink';
        //             var product = products.data.find(product => product.code === productCode);
        //             if (payment && product) {
        //                 paymentService.clearCart();
        //                 product.manuelPrice = payment.amount;
        //                 paymentService.addToCart(product);
        //             }
        //             else {
        //                 var langKey = window.lang || 'tr';
        //                 $location.replace().path('/' + langKey + '/404'); //state olunca history'e mevcut sayfay� ekledi�inden browser geri tu�u �al��m�yor b�yle y�nlendirmelerde bu nedenle location.replace
        //             }
        //         }],
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('payment');
        //             $translatePartialLoader.addPart('factura_address');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // });


    }]);
})();

(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('rapor-dogrulama', {
                url: "/:langcode/rapor-dogrulama?kod",
                templateUrl: 'app/report/rapor-dogrulama.html',
                controller: 'RaporDogrulamaController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'report');
                    }],

                    trans: '$transition$',

                    langcode: ['$stateParams', function ($stateParams) {
                        document.cookie = 'langcode=' + $stateParams.langcode;
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart("report_order");
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow',
                    title: ['$translate', function ($translate) {
                        return $translate('c_an_rep').then(function (res) {
                            return res;
                        });
                    }]
                }
            });
    }]);
})();

window.appVersion = "16.13.3 (26)";
window.prerenderReady = false;

"use strict";
(function () {

    // Dynamic Manifest Selection for Multi-Language PWA Support
    window.setDynamicManifest = function () {
        var manifestLink = document.getElementById('app-manifest');
        if (!manifestLink) return;

        var lang = getManifestLanguage();

        // Map language to appropriate manifest file
        var manifestMap = {
            'en': '/site-en.webmanifest',
            'es-ES': '/site-es.webmanifest',
            'pt-PT': '/site-pt.webmanifest',
            'tr': '/site.webmanifest'
        };

        manifestLink.href = manifestMap[lang] || '/site.webmanifest';
    };

    function getManifestLanguage() {
        // Priority 1: Check URL path (e.g., /en/..., /tr/..., /es-ES/..., /pt-PT/...)
        var path = window.location.pathname;
        var urlLangMatch = path.match(/^\/(tr|en|es-ES|pt-PT)\//);
        if (urlLangMatch) {
            return urlLangMatch[1];
        }

        // Priority 2: Check localStorage (user preference or from main app)
        var storedLang = localStorage.getItem('endeksaLanguage') || localStorage.getItem('language');
        if (storedLang && (storedLang === 'tr' || storedLang === 'en' || storedLang === 'es-ES' || storedLang === 'pt-PT')) {
            return storedLang;
        }

        // Priority 3: Check browser language
        var browserLang = navigator.language || navigator.userLanguage;
        if (browserLang) {
            // Check exact match
            if (browserLang === 'tr' || browserLang === 'en' || browserLang === 'es-ES' || browserLang === 'pt-PT') {
                return browserLang;
            }
            // Check base language (e.g., 'en' from 'en-US')
            var baseLang = browserLang.split('-')[0];
            if (baseLang === 'en') return 'en';
            if (baseLang === 'es') return 'es-ES';
            if (baseLang === 'pt') return 'pt-PT';
            if (baseLang === 'tr') return 'tr';
        }

        // Default: Turkish
        return 'tr';
    }


    // window.interestValues = {
    //     rates: [
    //         { min: 10000, max: 150000, barrier: 120, lowerRate: 0.0277, higherRate: 0.0333 },
    //         { min: 150001, max: 750000, barrier: 120, lowerRate: 0.0273, higherRate: 0.0329 },
    //         { min: 750001, max: 3000000, barrier: 120, lowerRate: 0.0277, higherRate: 0.0333 }
    //     ],
    //     lowest: 10000,
    //     highest: 5000000,
    //     ratio: 0.80,
    //     apprisal: 2850,
    //     process: 0.005,
    //     expense: 300
    // };

    window.interestValuesAkbank = {
        types: [
            {
                type: 'insured',
                rates: [
                    { barrier: 36, rate: 4.35 },
                    { barrier: 72, rate: 3.50 },
                    { barrier: 120, rate: 3.05 }
                ]
            },
            {
                type: 'uninsured',
                rates: [
                    { barrier: 36, rate: 4.58 },
                    { barrier: 72, rate: 3.73 },
                    { barrier: 120, rate: 3.28 }
                ]
            }
        ],
        lowest: 10000,
        highest: 5000000,
        appraisal: 7700,
        fee: 1620
    };

    window.getMortgageRate = function (obj, type, term) {
        let typeObj = obj.types.find(function (t) {
            return t.type === type;
        });

        let mortgageRate = null;

        if (typeObj) {
            for (let i = 0; i < typeObj.rates.length; i++) {
                if (term <= typeObj.rates[i].barrier) {
                    mortgageRate = typeObj.rates[i].rate;
                    break;
                }
            }
        }

        return mortgageRate;
    };

    window.PopupCenter = function (url, title, w, h) {
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,noreferrer,noopener,popup');

        if (window.focus && newWindow) {
            newWindow.focus();
        }
    };

    // window.Timer = function (callback, delay) {
    //     var timerId, start, remaining = delay;

    //     this.pause = function () {
    //         window.clearTimeout(timerId);
    //         remaining -= Date.now() - start;
    //     };

    //     this.resume = function () {
    //         start = Date.now();
    //         window.clearTimeout(timerId);
    //         timerId = window.setTimeout(callback, remaining);
    //     };

    //     this.resume();
    // };

    window.makeid = function (length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    };

    window.getImgDimensions = function (data) {
        return new Promise(function (resolve, reject) {
            let img = new Image();
            img.src = data;
            img.decode().then(() => {
                let width = img.width;
                let height = img.height;
                resolve({
                    width: width,
                    height: height
                });
            }).catch(function (err) {
                resolve({});
            });
        });
    };

    window.getUrlParameter = function (sParam, decodedResponse = false) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                if (sParameterName[1] === undefined) {
                    return true;
                }
                return decodedResponse ? decodeURIComponent(sParameterName[1]) : sParameterName[1];
            }
        }
    };

    if (typeof Object.defineProperty === 'function') {
        try { Object.defineProperty(Array.prototype, 'sortBy', { value: sb }); } catch (e) {
            //ignored
        }
    }
    if (!Array.prototype.sortBy) Array.prototype.sortBy = sb;

    function sb(f) {
        for (var i = this.length; i;) {
            var o = this[--i];
            this[i] = [].concat(f.call(o, o, i), o);
        }
        this.sort(function (a, b) {
            for (var i = 0, len = a.length; i < len; ++i) {
                if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
            }
            return 0;
        });
        for (var u = this.length; u;) {
            this[--u] = this[u][this[u].length - 1];
        }
        return this;
    }

    Array.prototype.sortByProperty = function (a) {
        return this.sortBy(function (o) { return !o[a]; });
    };

    // locale specific chars
    // IMPORTANT: name of locale must be always in lower case (for "tr-TR" locale - "tr-tr") !!!
    var localeInfos = {
        "tr-tr": {
            lower: { "i": "İ", "ı": "I", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ç": "Ç", "ö": "Ö", 'í': "İ" },
            upper: { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ç": "ç", "Ö": "ö", 'İ̇': "i" }
        }
    },
        localeInfo;

    // helper vars
    var mask_local = "\\s:\\-", // add additional delimeters chars to the mask if needed
        rg_local = new RegExp("([^" + mask_local + "])([^" + mask_local + "]*)", "g");
    var fnToLocaleLower = function (s) {
        if (localeInfo) {
            var localeInfosKeys = Object.keys(localeInfos);
            for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
            }
        }
        return localeInfo.upper[s];
    },
        fnToLocaleUpper = function (s) {
            if (localeInfo) {
                var localeInfosKeys = Object.keys(localeInfos);
                for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                    localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                    localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
                }
            }
            return localeInfo.lower[s];

        },
        fnToProper = function ($0, $1, $2) {
            if (localeInfo) {
                var localeInfosKeys = Object.keys(localeInfos);
                for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                    localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                    localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
                }
                if (localeInfo.lower.hasOwnProperty($1)) $1 = localeInfo.lower[$1];
                $2 = $2.replace(localeInfo.upperSearchRegExp, fnToLocaleLower);
            }
            return $1.toUpperCase() + $2.toLowerCase();
        };

    // extending String.prototype
    String.prototype.toLocaleProperCase2 = function toLocaleProperCase2(locale) {
        localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null];
        return this.replace(rg_local, fnToProper).replace(/i̇/g, 'i').replace(/undefined/g, '');
    };
    String.prototype.toLocaleLowerCase2 = function toLocaleLowerCase2(locale) {
        return ((localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null]) ?
            this.replace(localeInfo.upperSearchRegExp, fnToLocaleLower) :
            this).replace(/i̇/g, 'i').toLowerCase();
    };
    String.prototype.toLocaleUpperCase2 = function toLocaleUpperCase2(locale) {
        return ((localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null]) ?
            this.replace(localeInfo.lowerSearchRegExp, fnToLocaleUpper) :
            this).replace(/i̇/g, 'i').toUpperCase();
    };

    Number.prototype.countDecimals = function () {
        if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
        return this.toString().split(".")[1].length || 0;
    };

    Number.prototype.formatMoney = function (c, d, t) {
        var n = this;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d == undefined ? "," : d;
        t = t == undefined ? "." : t;
        var s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    String.prototype.toUnicode = function () {
        var theString = this;
        var unicodeString = '';
        for (var i = 0; i < theString.length; i++) {
            var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
            while (theUnicode.length < 4) {
                theUnicode = '0' + theUnicode;
            }
            theUnicode = '\\u' + theUnicode;
            unicodeString += theUnicode;
        }
        return unicodeString;
    };

    Number.prototype.countDecimals = function () {
        if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
        return this.toString().split(".")[1].length || 0;
    };

    String.prototype.norm_to_ascii = function () { return unescape(encodeURIComponent(this)); };
    String.prototype.norm_to_unicode = function () { return decodeURIComponent(escape(this)); };
    String.prototype.crypt_sym = function (k) { return String.fromCharCode.apply(undefined, this.split("").map(function (c) { return c.charCodeAt(0) ^ (k || 13); })); };

    // window.encryptObject = function (osd) {
    //     try {
    //         var cryption = JSON.stringify(osd).replace(/\,/g, 'DD').replace(/\"/g, 'RR').replace(/\./g, 'PP').replace(/\(/g, 'UU').replace(/\)/g, 'VV').replaceAllString('{', 'ZZ').replaceAllString('}', 'XX').replaceAllString(':', 'YY');
    //         var e = encodeURIComponent(btoa(cryption.norm_to_ascii().crypt_sym()));
    //         return e;
    //     } catch (err) {
    //         return null;
    //     }
    // };
    // window.decryptObject = function (e) {
    //     try {
    //         var z = decodeURIComponent(e);
    //         return JSON.parse(atob(z).norm_to_unicode().crypt_sym().replaceAllString('DD', ',').replaceAllString('RR', '"').replaceAllString('PP', '.').replaceAllString('UU', '(').replaceAllString('VV', ')').replaceAllString('ZZ', '{').replaceAllString('XX', '}').replaceAllString('YY', ':'));
    //     } catch (err) {
    //         return null;
    //     }
    // };

    window.isMobileOrTablet = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        if (navigator && navigator.platform && navigator.maxTouchPoints && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
            check = true;
        return check;
    };

    window.isMobile = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    window.isHeadless = function () {
        return /HeadlessChrome/.test(window.navigator.userAgent) || (eval.toString().length == 33 && !window.chrome);
    };

    window.compressBase64Image = function (data, quality = 1, width = 800, height = 800) {
        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");
        let image = new Image();
        image.src = data;

        ctx.drawImage(image, 0, 0);

        let url = canvas.toDataURL('image/jpeg', quality);

        return url;
    };

    Array.prototype.contains = function (needle) {
        for (i = 0; i < this.length; i++) {
            if (this[i].indexOf(needle) > -1) return this[i];
        }
        return null;
    };


    Array.prototype.sum = function (prop, timeStart, timeEnd) {
        var total = 0;
        for (var i = 0, _len = this.length; i < _len; i++) {
            if (this[i].date && timeStart && timeEnd) {
                var compare = moment(this[i].date, 'DD.MM.YYYY');
                if (timeStart > compare || timeEnd < compare)
                    continue;
            }
            total += this[i][prop];
        }
        return total;
    };

    Array.prototype.groupBy = function (key, count, timeStart, timeEnd) {
        var xs = this;
        return xs.reduce(function (rv, x) {
            if (x.date && timeStart && timeEnd) {
                var compare = moment(x.date, 'DD.MM.YYYY');
                if (timeStart > compare || timeEnd < compare)
                    return rv;
            }

            var array = (rv[x[key]] = rv[x[key]] || {});
            array.text = x[key];
            array.nodes = array.nodes || [];
            array.nodes.push(x);
            if (count)
                array.sum = array.nodes.sum(count);
            return rv;
        }, {});
    };

    Array.prototype.groupByDate = function (key, count, format, timeStart, timeEnd) {
        var xs = this;
        return xs.reduce(function (rv, x) {
            format = format || 'MM-YYYY';
            var compare = moment(x[key], 'DD.MM.YYYY');
            var t = compare.format(format);
            if (timeStart && timeEnd && (timeStart > compare || timeEnd < compare))
                return rv;
            var array = (rv[t] = rv[t] || {});
            array.text = x[key];
            array.format = t;
            array.nodes = array.nodes || [];
            array.nodes.push(x);
            if (count)
                array.sum = array.nodes.sum(count);
            return rv;
        }, {});
    };

    Array.prototype.diff = function (a) {
        return this.filter(function (i) { return a.indexOf(i) < 0; });
    };

    Array.prototype.sortOn = function (key) {
        this.sort(function (a, b) {
            if (a[key] < b[key]) {
                return -1;
            } else if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    };

    Array.prototype.clean = function (deleteValue) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] === deleteValue) {
                this.splice(i, 1);
                i--;
            }
        }
        return this;
    };

    String.prototype.replaceAllString = function (search, replacement) {
        var target = this;
        // return target.replace(new RegExp(search, 'g'), replacement);
        var escapedSearch = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        return target.replace(new RegExp(escapedSearch, 'g'), replacement);
    };

    String.prototype.replaceHtmlEntities = function () {
        var translate_re = /&(nbsp|amp|quot|lt|gt|rsquo);/g,
            translate = {
                'nbsp': String.fromCharCode(160),
                'amp': '&',
                'quot': '"',
                'lt': '<',
                'gt': '>',
                'rsquo': String.fromCharCode(39)
            },
            translator = function ($0, $1) {
                return translate[$1];
            };
        var target = this;
        return target.replace(translate_re, translator);
    };

    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }



    window.exportWord = function (wrapperId, filename) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header + document.getElementById(wrapperId).innerHTML + footer;

        var dataType = 'application/vnd.ms-word';

        // Specify file name
        filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.doc' : 'document.doc';

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);


        if (navigator.msSaveOrOpenBlob) {
            var blob = new Blob(['\ufeff', sourceHTML], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            fileDownload.href = source;
            fileDownload.download = filename;
            fileDownload.click();
            document.body.removeChild(fileDownload);
        }
    };


    window.exportExcel = function (table, name) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))); },
            format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }); };


        if (!table.nodeType) table = document.getElementById(table);

        var filename = name ? 'Endeksa - ' + document.getElementById(name).innerText.trim() : 'excel_data';

        name = name ? document.getElementById(name).innerText.trim() : 'analysis';

        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };

        //window.location.href = uri + base64(format(template, ctx))

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        // Create a link to the file
        downloadLink.href = uri + base64(format(template, ctx));

        // Setting the file name
        downloadLink.download = filename + ".xls";



        //triggering the function
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    window.exportPNG = function (tableID, filename, el) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        $(el).hide();
        modernScreenshot.domToPng(document.getElementById(tableID))
            .then(function (dataUrl) {
                var link = document.createElement('a');
                $(el).show();
                // Specify file name
                filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.png' : 'image.png';

                link.download = filename;
                link.href = dataUrl;
                link.click();
            }).catch(function (error) {
                $(el).show();
                console.error('oops, something went wrong!', error);
            });

    };

    window.exportJpeg = function (tableID, filename, el) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        $(el).hide();
        modernScreenshot.domToJpeg(document.getElementById(tableID), { quality: 1 })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                $(el).show();
                // Specify file name
                filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.jpeg' : 'image.jpeg';

                link.download = filename;
                link.href = dataUrl;
                link.click();
            }).catch(function (error) {
                $(el).show();
                console.error('oops, something went wrong!', error);
            });

    };

    // window.checkCookie_eu = function () {

    //     var consent = getCookie_eu("cookies_consent");

    //     if ((consent == null || consent == "" || consent == undefined) && window.location.href.indexOf('quake') === -1) {
    //         // show notification bar
    //         $('#cookie_directive_container').fadeIn();
    //     }
    //     else {
    //         $('#cookie_directive_container').remove();
    //     }

    // };

    window.setTimeout(function () {
        // if (!window.isHeadless())
        //     window.checkCookie_eu();

        if (window.getUrlParameter('top') || window.isHeadless()) {
            var sheet = window.document.styleSheets[0];
            sheet.insertRule('#loading-bar { display: none !important; }', sheet.cssRules.length);
        }

        if (window.isHeadless()) {
            //Prerendered page css fix
            const date = new Date();
            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();
            const newdate = year + "." + month;
            $('#css-fonts').attr('href', 'https://cdn.endeksa.com/fonts/fonts.min.css?d=' + newdate);
            $('#css-vendor').attr('href', 'https://cdn.endeksa.com/css/vendor.core.min.css?d=' + newdate);
            $('#css-main').attr('href', 'https://cdn.endeksa.com/css/main.core.min.css?d=' + newdate);
        }
    }, 100);

    // function setCookie_eu(c_name, value, exdays) {

    //     var exdate = new Date();
    //     exdate.setDate(exdate.getDate() + exdays);
    //     var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    //     document.cookie = c_name + "=" + c_value + "; path=/";

    //     $('#cookie_directive_container').fadeOut(function () {
    //         $('#cookie_directive_container').remove();
    //     });
    // }


    // function getCookie_eu(c_name) {
    //     var i, x, y, ARRcookies = document.cookie.split(";");
    //     for (i = 0; i < ARRcookies.length; i++) {
    //         x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    //         y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    //         x = x.replace(/^\s+|\s+$/g, "");
    //         if (x == c_name) {
    //             return unescape(y);
    //         }
    //     }
    // }

    // $("#cookie_accept a").click(function () {
    //     setCookie_eu("cookies_consent", 1, 30);
    // });
})();


var logonkey_ = [
    { ref: 'bank', top: '6896DRB2NNZUIELS', type: "bank" },
    { ref: 'gdys', top: '6896DRB2NNZJPLQD', type: "premium" },
    // { ref: 'ebis', top: 'FEHUBNX5TBCV2PC4', type: "advance" },
    { ref: 'geodi', top: 'UYLR0L4K03LU3GMG', type: "advance" },
    { ref: null, top: '6896DRB2NNZJPLQD', type: "none" },
    { ref: 'intern', top: '6896DRB2NNZJPLQD', type: "intern" },
    { ref: 'cbs', top: '9F4FF3SEHQ2A66YX', type: "intern" },
];

var toper_ = window.getUrlParameter('top');
var referer_ = window.getUrlParameter('ref');

for (var y = 0; y < logonkey_.length; y++) {
    var current = logonkey_[y];
    if (referer_ && current.ref === referer_ && current.top === toper_) {
        window.hasAllowance = current.type;
        window.topKey = current.top;
    }
    else if (!referer_ && current.top === toper_) {
        window.hasAllowance = current.type;
        window.topKey = current.top;
    }
}

window.ecSec = function () {
    var cliTime = Math.floor(new Date().getTime() / 1000);
    var timeDiff = (window.localStorage.getItem('time_diff') && !isNaN(window.localStorage.getItem('time_diff'))) ? +window.localStorage.getItem('time_diff') : 0;
    cliTime = cliTime - timeDiff;
    cliTime = cliTime.toString().slice(4);
    var rndSuffix = Math.floor(1000 + Math.random() * 9000);
    if (rndSuffix % 2 === 0) {
        var fPart = cliTime.slice(0, 3).split('').reverse().join('');
        var sPart = cliTime.slice(3).split('').reverse().join('');
        cliTime = fPart + sPart + rndSuffix;
    } else {
        cliTime += rndSuffix;
    }
    return cliTime;
};

function removeElementsWithValue(arr, val) {
    var i = arr.length;
    while (i--) {
        if (arr[i] === val) {
            arr.splice(i, 1);
        }
    }
    return arr;
}

function toWKT(layer) {
    var lng, lat, coords = [];
    if (L && (layer instanceof L.Polygon || layer instanceof L.Polyline)) {
        var latlngs = layer.getLatLngs();
        if (latlngs.length === 1)
            latlngs = layer.getLatLngs()[0];
        for (var i = 0; i < latlngs.length; i++) {
            // latlngs[i];
            coords.push(latlngs[i].lng + " " + latlngs[i].lat);
            if (i === 0) {
                lng = latlngs[i].lng;
                lat = latlngs[i].lat;
            }
        }
        if (layer instanceof L.Polygon) {
            return "POLYGON((" + coords.join(",") + "," + lng + " " + lat + "))";
        } else if (layer instanceof L.Polyline) {
            return "LINESTRING(" + coords.join(",") + ")";
        }
    } else if (L && layer instanceof L.Marker) {
        return "POINT(" + layer.getLatLng().lng + " " + layer.getLatLng().lat + ")";
    }
    else
        return "";
}

function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/Ğ/gim, "g")
        .replace(/Ü/gim, "u")
        .replace(/Ş/gim, "s")
        .replace(/I/gim, "i")
        .replace(/İ/gim, "i")
        .replace(/Ö/gim, "o")
        .replace(/Ç/gim, "c")
        .replace(/ğ/gim, "g")
        .replace(/ü/gim, "u")
        .replace(/ş/gim, "s")
        .replace(/ı/gim, "i")
        .replace(/ö/gim, "o")
        .replace(/ç/gim, "c")
        .replace(/i̇/gim, 'i');
    // var defaultDiacriticsRemovalMap = [
    //     { 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
    //     { 'base': 'AA', 'letters': /[\uA732]/g },
    //     { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g },
    //     { 'base': 'AO', 'letters': /[\uA734]/g },
    //     { 'base': 'AU', 'letters': /[\uA736]/g },
    //     { 'base': 'AV', 'letters': /[\uA738\uA73A]/g },
    //     { 'base': 'AY', 'letters': /[\uA73C]/g },
    //     { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
    //     { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
    //     { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
    //     { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g },
    //     { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g },
    //     { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
    //     { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
    //     { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
    //     { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
    //     { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
    //     { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
    //     { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
    //     { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
    //     { 'base': 'LJ', 'letters': /[\u01C7]/g },
    //     { 'base': 'Lj', 'letters': /[\u01C8]/g },
    //     { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
    //     { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
    //     { 'base': 'NJ', 'letters': /[\u01CA]/g },
    //     { 'base': 'Nj', 'letters': /[\u01CB]/g },
    //     { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
    //     { 'base': 'OI', 'letters': /[\u01A2]/g },
    //     { 'base': 'OO', 'letters': /[\uA74E]/g },
    //     { 'base': 'OU', 'letters': /[\u0222]/g },
    //     { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
    //     { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
    //     { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
    //     { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
    //     { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
    //     { 'base': 'TZ', 'letters': /[\uA728]/g },
    //     { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
    //     { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
    //     { 'base': 'VY', 'letters': /[\uA760]/g },
    //     { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
    //     { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
    //     { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
    //     { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
    //     { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
    //     { 'base': 'aa', 'letters': /[\uA733]/g },
    //     { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g },
    //     { 'base': 'ao', 'letters': /[\uA735]/g },
    //     { 'base': 'au', 'letters': /[\uA737]/g },
    //     { 'base': 'av', 'letters': /[\uA739\uA73B]/g },
    //     { 'base': 'ay', 'letters': /[\uA73D]/g },
    //     { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
    //     { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
    //     { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
    //     { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g },
    //     { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
    //     { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
    //     { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
    //     { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
    //     { 'base': 'hv', 'letters': /[\u0195]/g },
    //     { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
    //     { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
    //     { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
    //     { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
    //     { 'base': 'lj', 'letters': /[\u01C9]/g },
    //     { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
    //     { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
    //     { 'base': 'nj', 'letters': /[\u01CC]/g },
    //     { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
    //     { 'base': 'oi', 'letters': /[\u01A3]/g },
    //     { 'base': 'ou', 'letters': /[\u0223]/g },
    //     { 'base': 'oo', 'letters': /[\uA74F]/g },
    //     { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
    //     { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
    //     { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
    //     { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
    //     { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
    //     { 'base': 'tz', 'letters': /[\uA729]/g },
    //     { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
    //     { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
    //     { 'base': 'vy', 'letters': /[\uA761]/g },
    //     { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
    //     { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
    //     { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
    //     { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
    //     { 'base': '', 'letters': /[\(\)]/g },
    // ];

    // for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    //     str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    // }

    // return str.replace(/i̇/g, 'i');

}

function normalizeAddress(add) {
    if (!add)
        return "";
    return removeDiacritics(add.replace(', Türkiye', ''))
        .replaceAllString('\"', '')
        .replaceAllString('\“', '')
        .replaceAllString('\”', '')
        .replaceAllString('\«', '')
        .replaceAllString('\»', '')
        .replaceAllString('\'', '')
        .replaceAllString(',', '')
        .replaceAllString(':', ' ')
        .replace(/\./g, '')
        .replaceAllString('/', ' ')
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-'); // replace spaces with hyphens
}

function getURLParam(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}


$(document).ready(function () {
    $(document).on('click', function (e) {
        $('[data-toggle="popover"],[data-original-title]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false; // fix for BS 3.3.6
            }

        });
    });

});

// var OneSignal = OneSignal || [];


window.updateQueryStringParameter = function (uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
        if (uri.match(re)) {
            return uri.replace(re, '$1$2').replace(/[?&]$/, '').replaceAll(/([?&])&+/g, '$1').replace(/[?&]#/, '#');
        } else {
            return uri;
        }
    } else {
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            var hash = '';
            if (uri.indexOf('#') !== -1) {
                hash = uri.replace(/.*#/, '#');
                uri = uri.replace(/#.*/, '');
            }
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            return uri + separator + key + "=" + value + hash;
        }
    }
};

window.encodeResponse = function (cipher) {
    if (cipher === null || cipher === undefined)
        return cipher;
    let secret = "3ND3KS4B4CK3ND24";
    let key = CryptoJS.enc.Utf8.parse(secret);
    let decryptedBytes = CryptoJS.AES.decrypt(cipher, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
};

window.urlfx2 = window.location.host.indexOf('www') > -1 ? 'api' : (window.location.host.indexOf('beta') > -1 ? 'apibeta' : 'api');
window.userStorage = {
    synced: false,
    items: [],
    getItem: function (key) {
        var that = this;
        if (window.endeksa && window.endeksa.id && that.synced) {
            for (var y = 0; y < that.items.length; y++) {
                if (that.items[y].Key === key)
                    return that.items[y].Value;
            }
            return null;
        }
        else
            return window.localStorage.getItem(key);
    },
    setItem: function (key, value) {
        var that = this;
        var val = typeof value !== 'string' ? JSON.stringify(value) : value;
        if (key && val && window.endeksa && window.endeksa.id)
            $.ajax({
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id + '&key=' + key.toString() + '&value=' + val,
                success: function () {
                    var index = null;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key === key)
                            index = y;
                    }
                    if (index) {
                        that.items.splice(index, 1);
                    }
                    that.items.push({ Key: key.toString(), Value: val });
                }
            });
        window.localStorage.setItem(key, val);
    },
    removeItem: function (key) {
        var that = this;
        if (key && window.endeksa && window.endeksa.id)
            $.ajax({
                type: 'DELETE',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id + '&key=' + key.toString(),
                success: function () {
                    var index = null;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key === key)
                            index = y;
                    }
                    if (index) {
                        that.items.splice(index, 1);
                    }
                }
            });
        window.localStorage.removeItem(key);
    },
    sync: function () {
        var that = this;
        if (window.endeksa && window.endeksa.id) {
            $.ajax({
                type: 'GET',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id,
                success: function (data) {
                    that.items = data;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key.indexOf('leadshown') === -1)
                            window.localStorage.setItem(that.items[y].Key, that.items[y].Value);
                        else
                            that.removeItem(that.items[y].Key);
                    }
                    var keys = Object.keys(window.localStorage);
                    var itemkeys = that.items.map(function (a) { return a.Key; });
                    for (var j = 0; j < keys.length; j++) {
                        if (itemkeys.indexOf(keys[j]) === -1 && keys[j].indexOf('angular-cache') === -1 && (keys[j].indexOf('intro') > -1 || keys[j].indexOf('navstate') > -1 || keys[j].indexOf('map_') > -1 || keys[j].indexOf('top_') > -1))
                            that.setItem(keys[j], window.localStorage.getItem(keys[j]));
                    }
                    that.synced = true;
                }
            });
        }
    }
};


// Speed up calls to hasOwnProperty
window.isEmpty = function (obj) {
    if (!obj) return true;
    if (obj.length) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
};

$.fn.followTo = function (top, fix) {
    if (this.length === 0)
        return false;
    var $this = this,
        $window = $(window),
        $startPos = $this.offset().top,
        $top = $this.css('top'),
        $position = $this.css('position'),
        $width = $this.css('width'),
        setPosition = function () {
            if ($window.scrollTop() < $startPos - top) {
                $this.css({
                    position: $position,
                    top: $top,
                    width: $width
                });
            } else {
                $this.css({
                    position: 'fixed',
                    top: top,
                    backgroundColor: 'white',
                    width: fix,
                    zIndex: 20000
                });
            }
        };
    $window.resize(function () {
        setPosition();
    });
    $window.scroll(setPosition);
    setPosition();
};

window.isHighDensity = function () {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
};


window.isRetina = function () {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

//=======================================
//              CHECK TC ID             =
//=======================================
window.checkTcNum = function (TCNO) {

    var tek = 0,
        cift = 0,
        sonuc = 0,
        TCToplam = 0,
        i = 0,
        hatali = [11111111110, 22222222220, 33333333330, 44444444440, 55555555550, 66666666660, 7777777770, 88888888880, 99999999990];

    if (isNaN(TCNO)) return false;

    TCNO = TCNO.toString();

    if (TCNO.length != 11) return false;
    if (TCNO[0] == 0) return false;

    tek = parseInt(TCNO[0]) + parseInt(TCNO[2]) + parseInt(TCNO[4]) + parseInt(TCNO[6]) + parseInt(TCNO[8]);
    cift = parseInt(TCNO[1]) + parseInt(TCNO[3]) + parseInt(TCNO[5]) + parseInt(TCNO[7]);

    tek = tek * 7;
    sonuc = Math.abs(tek - cift);
    if (sonuc % 10 != TCNO[9]) return false;

    for (var t = 0; t < 10; t++) {
        TCToplam += parseInt(TCNO[t]);
    }

    if (TCToplam % 10 != TCNO[10]) return false;

    if (hatali.toString().indexOf(TCNO) != -1) return false;

    return true;
};
//--------  End of check tc id  ---------//


window.isTaxNoValid = function vergikimlik(kno) {
    var v1 = 0;
    var v2 = 0;
    var v3 = 0;
    var v4 = 0;
    var v5 = 0;
    var v6 = 0;
    var v7 = 0;
    var v8 = 0;
    var v9 = 0;
    var v11 = 0;
    var v22 = 0;
    var v33 = 0;
    var v44 = 0;
    var v55 = 0;
    var v66 = 0;
    var v77 = 0;
    var v88 = 0;
    var v99 = 0;
    var v_last_digit = 0;
    var toplam = 0;


    if (kno.length === 10) {

        v1 = (Number(kno.charAt(0)) + 9) % 10;

        v2 = (Number(kno.charAt(1)) + 8) % 10;

        v3 = (Number(kno.charAt(2)) + 7) % 10;

        v4 = (Number(kno.charAt(3)) + 6) % 10;

        v5 = (Number(kno.charAt(4)) + 5) % 10;

        v6 = (Number(kno.charAt(5)) + 4) % 10;
        v7 = (Number(kno.charAt(6)) + 3) % 10;
        v8 = (Number(kno.charAt(7)) + 2) % 10;
        v9 = (Number(kno.charAt(8)) + 1) % 10;
        v_last_digit = Number(kno.charAt(9));

        v11 = (v1 * 512) % 9;
        v22 = (v2 * 256) % 9;
        v33 = (v3 * 128) % 9;
        v44 = (v4 * 64) % 9;
        v55 = (v5 * 32) % 9;
        v66 = (v6 * 16) % 9;
        v77 = (v7 * 8) % 9;
        v88 = (v8 * 4) % 9;
        v99 = (v9 * 2) % 9;

        if (v1 != 0 && v11 == 0) v11 = 9;
        if (v2 != 0 && v22 == 0) v22 = 9;
        if (v3 != 0 && v33 == 0) v33 = 9;
        if (v4 != 0 && v44 == 0) v44 = 9;
        if (v5 != 0 && v55 == 0) v55 = 9;
        if (v6 != 0 && v66 == 0) v66 = 9;
        if (v7 != 0 && v77 == 0) v77 = 9;
        if (v8 != 0 && v88 == 0) v88 = 9;
        if (v9 != 0 && v99 == 0) v99 = 9;
        toplam = v11 + v22 + v33 + v44 + v55 + v66 + v77 + v88 + v99;


        if (toplam % 10 == 0) toplam = 0;
        else toplam = (10 - (toplam % 10));

        if (toplam == v_last_digit) {


            return true;
        } else return false;

    } else return false;

};


window.getCookieValue = function (a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
};


window.cekimEki = function (metin, ekler) {
    if (window.lang !== 'tr')
        return metin;
    else if (window.lang !== 'tr' && ekler === 'de')
        ekler = 's';
    if (!metin || !ekler)
        return "";
    ekler = ekler.replace(/\s/g, '');
    var ekler_dizisi = ekler.split(",");
    var cogul_mu = false;
    var kesme_isareti = false;
    var ozel_isim_mi = false;
    var yabanci_mi = false;

    var metin_dizisi = metin.split("|");

    if (typeof metin_dizisi[1] !== "undefined") {
        if (metin_dizisi[1] == "y") {
            yabanci_mi = true;
        }
    }

    metin = metin_dizisi[0];

    ekler_dizisi = ekleriSirala(ekler_dizisi);

    if (/^[A-ZİÖÜĞŞÇ]/.test(metin)) {
        metin = metin.replace(/[A-ZİÖÜĞŞÇ]\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        ozel_isim_mi = true;
    }

    for (var i = 0; i < ekler_dizisi.length; i++) {

        if (ekler_dizisi[i] == "lar" || ekler_dizisi[i] == "ler") {
            metin = _ler(metin, ozel_isim_mi);
            cogul_mu = true;
        }
        if (ekler_dizisi[i] == "ın" || ekler_dizisi[i] == "in" || ekler_dizisi[i] == "un" || ekler_dizisi[i] == "ün") { metin = _in(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "a" || ekler_dizisi[i] == "e" || ekler_dizisi[i] == "u" || ekler_dizisi[i] == "ü") { metin = _e(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "ı" || ekler_dizisi[i] == "i" || ekler_dizisi[i] == "u" || ekler_dizisi[i] == "ü") { metin = _i(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "da" || ekler_dizisi[i] == "de" || ekler_dizisi[i] == "ta" || ekler_dizisi[i] == "te" || ekler_dizisi[i] == "s" ||
            ekler_dizisi[i] == "dan" || ekler_dizisi[i] == "den" || ekler_dizisi[i] == "tan" || ekler_dizisi[i] == "ten") { metin = _de_den(metin, ekler_dizisi[i], ozel_isim_mi); }
    }

    return metin;


    function _ler(metin) { // Çokluk (Çoğul) Eki (-lar / -ler)

        if (ozel_isim_mi && !kesme_isareti) {
            metin = ozelIsim(metin, true);
            kesme_isareti = true;
        }

        if (metin.match(/[aıou]$|[aıou][bcçdfgğhjklmnprsştvwxyz']$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz]$/i)) {
            metin += "lar";
        }
        if (metin.match(/[eiöü]$|[eiöü][bcçdfgğhjklmnprsştvwxyz']$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz]$/i)) {
            metin += "ler";
        }

        return metin;
    }


    function _in(metin, ozel_isim_mi, yabanci_mi) { // İlgi (Tamlama) Ekleri (-ın / -in / -un / -ün)
        if (metin === "ben") { return "benim"; } // Özel Kural
        if (metin === "biz") { return "bizim"; } // Özel Kural
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "n";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/[aı].$|[aı][bcçdfgğhjklmnprsştvwxyz'].$|[aı][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ın";
        }
        if (metin.match(/[ei].$|[ei][bcçdfgğhjklmnprsştvwxyz'].$|[ei][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "in";
        }
        if (metin.match(/[ou].$|[ou][bcçdfgğhjklmnprsştvwxyz'].$|[ou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "un";
        }
        if (metin.match(/[öü].$|[öü][bcçdfgğhjklmnprsştvwxyz'].$|[öü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ün";
        }

        return metin;
    }


    function _e(metin, ozel_isim_mi, yabanci_mi) { // Yönelme durumu eki:(-e / -a)
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "y";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/(?=.*[aıou].$)|(?=.*[aıou]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz'].$)|(?=.*[aıou]...$)(?=.*[bcçdfgğhjklmnprsştvwxyz]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz].$)/i)) {
            metin += "a";
        }
        if (metin.match(/(?=.*[eiöü].$)|(?=.*[eiöü]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz'].$)|(?=.*[eiöü]...$)(?=.*[bcçdfgğhjklmnprsştvwxyz]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz].$)/i)) {
            metin += "e";
        }

        return metin;
    }


    function _i(metin, ozel_isim_mi, yabanci_mi) { // Belirtme durumu eki (-i / -ı / -u / -ü)
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "y";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/[aı].$|[aı][bcçdfgğhjklmnprsştvwxyz'].$|[aı][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ı";
        }
        if (metin.match(/[ei].$|[ei][bcçdfgğhjklmnprsştvwxyz'].$|[ei][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "i";
        }
        if (metin.match(/[ou].$|[ou][bcçdfgğhjklmnprsştvwxyz'].$|[ou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "u";
        }
        if (metin.match(/[öü].$|[öü][bcçdfgğhjklmnprsştvwxyz'].$|[öü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ü";
        }

        return metin;
    }


    function _de_den(metin, ek, ozel_isim_mi, yabanci_mi) { // Bulunma durumu eki: (-de / -da / -te / -ta) / Ayrılma (Çıkma) durumu eki: (-den / -dan / -ten / -tan)

        metin = metin;
        if (metin.match(/.*[çfhksştp]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            if (ek !== "s")
                metin += "t";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            if (ek !== "s")
                metin += "d";
        }
        if (ek !== "s" && metin.match(/[aıou].$|[aıou][bcçdfgğhjklmnprsştvwxyz'].$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$/i)) {
            metin += "a";
        } else if (ek !== "s" && metin.match(/[eiöü].$|[eiöü][bcçdfgğhjklmnprsştvwxyz'].$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$/i)) {
            metin += "e";
        }

        if (ek === "s") {
            return metin + "s";
        } else if (ek === "dan" || ek === "den" || ek === "tan" || ek === "ten") {
            return metin + "n";
        } else {
            return metin;
        }
    }

    function ozelIsim(ozel_isim, cogul_mu) {
        if (!cogul_mu) {
            ozel_isim += "'";
        }
        return ozel_isim;
    }

    function ekleriSirala(ekler_dizisi) {
        var temp_array = [],
            ordered_array = [];

        for (var i = 0; i < ekler_dizisi.length; i++) {
            if (ekler_dizisi[i] === "ler" || ekler_dizisi[i] === "lar") {
                temp_array.push(ekler_dizisi[i]);
                ekler_dizisi.splice(i, 1);
            }
        }
        for (var it = 0; it < ekler_dizisi.length; it++) {
            if (ekler_dizisi[it] === "in" || ekler_dizisi[it] === "ın") {
                temp_array.push(ekler_dizisi[it]);
                ekler_dizisi.splice(it, 1);
            }
        }

        ordered_array = temp_array.concat(ekler_dizisi);
        return ordered_array;
    }

    function unsuzYumusamasi(metin) {
        metin = metin.replace(/[ç]$/i, "c");
        metin = metin.replace(/[p]$/i, "b");
        metin = metin.replace(/[t]$/i, "d");
        if (metin.match(/[aeıioöuü][k]$/i)) {
            metin = metin.replace(/k$/, "ğ");
        } else if (metin.match(/[bcçdfgğhjklmnprsştvwxyz][k]$/i)) {
            metin = metin.replace(/k$/, "g");
        }
        return metin;
    }
};
if ((window.location.host === 'www.endeksa.com' || window.location.host === 'preprod.endeksa.com') && window.location.href.indexOf('top=') === -1 && !window.isHeadless()) {

    // COOKIE YES MIGRATED TO GTM
    // !function (d, l, t, s) {
    //     t = d.createElement('script');
    //     t.defer = 1;
    //     t.id = 'cookieyes';
    //     t.type = 'text/javascript';
    //     // t.setAttribute('delay', l);
    //     t.src = l;
    //     s = d.getElementsByTagName('script')[0];
    //     s.parentNode.insertBefore(t, s);
    // }(document, 'https://cdn-cookieyes.com/client_data/600192bf797d3203041c165a/script.js');

    // TRIGGERED ON TAG MANAGER
    //!function (e, a, n, d, g) { e.dengage = e.dengage || function () { (e.dengage.q = e.dengage.q || []).push(arguments) }, d = a.getElementsByTagName("head")[0], (g = a.createElement("script")).async = 1, g.setAttribute('delay', 'https://pcdn.dengage.com/p/push/501/08bc4d75-52b1-4e9d-1249-b28ef2aecb37/dengage_sdk.js'), d.appendChild(g) }(window, document);

    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        // t.src = v;
        t.setAttribute('delay', v);
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '233175853836342');

    // (function (c, l, a, r, i, t, y) {
    //     c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    //     t = l.createElement(r); t.async = 1;
    //     t.setAttribute("delay", "https://www.clarity.ms/tag/" + i);
    //     // t.src = "https://www.clarity.ms/tag/" + i;
    //     y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    // })(window, document, "clarity", "script", "h5s6ba9uqt");

    (function (w, u, d) {
        var i = function () { i.c(arguments); };
        i.q = [];
        i.c = function (args) { i.q.push(args); };
        var l = function () {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.setAttribute('delay', 'https://code.upscope.io/FxExxXKUYp.js');
            // s.src = 'https://code.upscope.io/FxExxXKUYp.js';
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        };
        if (typeof u !== "function") {
            w.Upscope = i;
            l();
        }
    })(window, window.Upscope, document);

    (function () {
        var gaconnect = document.createElement('script'); gaconnect.type = 'text/javascript'; gaconnect.async = true;
        gaconnect.src = 'https://track.gaconnector.com/gaconnector.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gaconnect, s);
    })();

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        // j.setAttribute('delay', 'https://www.googletagmanager.com/gtm.js?id=' + i + dl);
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-TTLPBLN');

    var tryNumber = 0;
    var interCookie = setInterval(function () {
        tryNumber++;
        if (typeof performBannerAction !== 'undefined') {
            if (window.refMobile) {
                performBannerAction("accept_all");
                clearInterval(interCookie);
            }
            else {
                clearInterval(interCookie);
            }
        }
        else if (tryNumber > 50) {
            clearInterval(interCookie);
        }
    }, 100);
}

window.dataLayer = window.dataLayer || [];

(function () {
    window.ybug_settings = { "id": "v81ja739j46sxzdm9523", widget_position: 'center', hide_launcher: true };
    var ybug = document.createElement('script'); ybug.type = 'text/javascript'; ybug.async = true;
    // ybug.src = 'https://widget.ybug.io/button/'+window.ybug_settings.id+'.js';
    ybug.setAttribute('delay', 'https://widget.ybug.io/button/' + window.ybug_settings.id + '.js');
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ybug, s);
})();

// ============================================================================
// PERFORMANCE MONITORING - Web Vitals & Resource Timing
// ============================================================================
(function () {
    'use strict';

    var host = window.location.host;
    var isProd = host === 'www.endeksa.com' || host === 'preprod.endeksa.com';

    if (!window.performance || !window.performance.timing) return;

    window.addEventListener('load', function () {
        setTimeout(function () {
            var t = performance.timing;

            var metrics = {
                dns: t.domainLookupEnd - t.domainLookupStart,
                tcp: t.connectEnd - t.connectStart,
                ttfb: t.responseStart - t.requestStart,
                response: t.responseEnd - t.responseStart,
                dom: t.domContentLoadedEventEnd - t.domContentLoadedEventStart,
                total: t.loadEventEnd - t.navigationStart
            };

            if (!isProd) {
                console.log('📊 Performance Metrics:', metrics);
                console.log('DNS: ' + metrics.dns + 'ms');
                console.log('TCP: ' + metrics.tcp + 'ms');
                console.log('TTFB: ' + metrics.ttfb + 'ms');
                console.log('Response: ' + metrics.response + 'ms');
                console.log('DOM: ' + metrics.dom + 'ms');
                console.log('Total Load: ' + metrics.total + 'ms');
            }

            if (window.gtag && metrics.total < 30000) {
                gtag('event', 'timing_complete', {
                    name: 'page_load',
                    value: Math.round(metrics.total),
                    event_category: 'Performance',
                    event_label: window.location.pathname
                });

                gtag('event', 'timing_complete', {
                    name: 'ttfb',
                    value: Math.round(metrics.ttfb),
                    event_category: 'Performance',
                    event_label: window.location.pathname
                });
            }

            if (window.performance.getEntriesByType) {
                var resources = performance.getEntriesByType('resource');
                var slowResources = resources
                    .filter(function (r) { return r.duration > 1000; })
                    .map(function (r) {
                        return {
                            name: r.name.split('/').pop(),
                            duration: Math.round(r.duration)
                        };
                    });

                if (slowResources.length > 0 && !isProd) {
                    console.warn('⚠️  Slow Resources (>1s):', slowResources);
                }
            }
        }, 0);
    });

    if ('PerformanceObserver' in window) {
        try {
            var lcpObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                var lastEntry = entries[entries.length - 1];
                var lcp = lastEntry.renderTime || lastEntry.loadTime;

                if (!isProd) {
                    console.log('📈 LCP (Largest Contentful Paint):', Math.round(lcp) + 'ms');
                }

                if (window.gtag && lcp < 10000) {
                    gtag('event', 'web_vitals', {
                        name: 'LCP',
                        value: Math.round(lcp),
                        event_category: 'Web Vitals',
                        event_label: window.location.pathname
                    });
                }
            });
            lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

            var fidObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                entries.forEach(function (entry) {
                    var fid = entry.processingStart - entry.startTime;

                    if (!isProd) {
                        console.log('📈 FID (First Input Delay):', Math.round(fid) + 'ms');
                    }

                    if (window.gtag && fid < 1000) {
                        gtag('event', 'web_vitals', {
                            name: 'FID',
                            value: Math.round(fid),
                            event_category: 'Web Vitals',
                            event_label: window.location.pathname
                        });
                    }
                });
            });
            fidObserver.observe({ entryTypes: ['first-input'] });

            var clsValue = 0;
            var clsObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                entries.forEach(function (entry) {
                    if (!entry.hadRecentInput) {
                        clsValue += entry.value;
                    }
                });
            });
            clsObserver.observe({ entryTypes: ['layout-shift'] });

            window.addEventListener('beforeunload', function () {
                if (!isProd && clsValue > 0) {
                    console.log('📈 CLS (Cumulative Layout Shift):', clsValue.toFixed(3));
                }

                if (window.gtag && clsValue < 1) {
                    gtag('event', 'web_vitals', {
                        name: 'CLS',
                        value: Math.round(clsValue * 1000),
                        event_category: 'Web Vitals',
                        event_label: window.location.pathname
                    });
                }
            });

        } catch (e) {
            if (!isProd) {
                console.log('Web Vitals monitoring not supported or failed:', e.message);
            }
        }
    }
})();

// ============================================================================
// SERVICE WORKER REGISTRATION & UPDATE HANDLING
// ============================================================================
(function () {
    'use strict';

    if (!('serviceWorker' in navigator)) {
        console.log('ℹ️ Service Worker not supported');
        return;
    }

    // Prevent duplicate setup (important for www.endeksa.com with GTM)
    if (window.__swSetupComplete) {
        console.log('ℹ️ SW already setup - skipping duplicate initialization');
        return;
    }
    window.__swSetupComplete = true;

    var updateAvailable = false;
    var newWorker = null;
    var refreshing = false;
    var updateCheckInProgress = false;
    var lastUpdateCheck = 0;
    var UPDATE_DEBOUNCE = 5000; // Don't process updates more than once per 5 seconds
    var host = window.location.host;
    var isDev = host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1;
    var pageLoadTime = Date.now(); // Track when page loaded

    console.log('🌐 Service Worker Environment:');
    console.log('   Host:', host);
    console.log('   isDev:', isDev);
    console.log('   Update behavior: Auto-activate on page load, show notification mid-session');
    console.log('   💡 Updates detected within 3s of page load = auto-activate');

    window.addEventListener('load', function () {
        // Prevent duplicate registrations
        navigator.serviceWorker.getRegistration('/sw.js').then(function (existingReg) {
            if (existingReg) {
                console.log('✅ SW already registered, using existing');
                console.log('   Current state:', existingReg.active?.state);
                console.log('   Waiting:', existingReg.waiting?.state);
                console.log('   Installing:', existingReg.installing?.state);

                // ⚡ CRITICAL: Check if there's already a waiting worker on page load
                if (existingReg.waiting) {
                    console.log('⚡⚡⚡ UPDATE ALREADY WAITING ON PAGE LOAD! ⚡⚡⚡');
                    newWorker = existingReg.waiting;
                    updateAvailable = true;

                    // ⚡ AUTO-UPDATE ON PAGE LOAD
                    // Update waiting when page loads = auto-activate immediately
                    // (User loaded/refreshed, they want latest content)
                    console.log('🔄 Page load with waiting update - auto-activating...');
                    console.log('   (Update was waiting - activating on page load)');
                    refreshing = true;
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    // controllerchange event will reload the page
                }

                setupUpdateListeners(existingReg);
                return existingReg;
            }

            // ⚡ CRITICAL: Register with updateViaCache: 'none' to bypass HTTP cache
            return navigator.serviceWorker.register('/sw.js', {
                updateViaCache: 'none'  // Always fetch fresh sw.js, never use HTTP cache
            }).then(function (r) {
                console.log('✅ SW registered (updateViaCache: none)');
                setupUpdateListeners(r);
                return r;
            });
        }).catch(function (e) {
            console.log('SW failed:', e);
        });
    });

    function setupUpdateListeners(r) {
        if (r._listenersSetup) {
            console.log('ℹ️ Update listeners already setup');
            return;
        }
        r._listenersSetup = true;

        // ⚡ CRITICAL: Attach updatefound listener BEFORE calling r.update()
        // This ensures we catch the event when it fires
        console.log('📡 Attaching updatefound listener...');

        // Listen for updates (attach this FIRST, before calling r.update())
        r.addEventListener('updatefound', function () {
            console.log('🔔 updatefound event fired!');

            // Debounce: Prevent rapid-fire update events (common with GTM/analytics)
            var now = Date.now();
            if (now - lastUpdateCheck < UPDATE_DEBOUNCE) {
                console.log('⏱️ Update event debounced - too soon after last check (' + (now - lastUpdateCheck) + 'ms)');
                return;
            }
            lastUpdateCheck = now;

            // Prevent multiple simultaneous update checks
            if (updateCheckInProgress) {
                console.log('ℹ️ Update check already in progress - skipping');
                return;
            }

            updateCheckInProgress = true;
            newWorker = r.installing;
            console.log('🔄 New version detected - installing...', newWorker ? 'Worker found' : 'No worker');

            if (!newWorker) {
                console.log('⚠️ No new worker found in r.installing!');
                updateCheckInProgress = false;
                return;
            }

            // Helper function to handle the update notification
            function handleUpdateReady() {
                if (navigator.serviceWorker.controller) {
                    // This is an UPDATE (existing controller means there's already a SW)
                    updateAvailable = true;
                    console.log('✅✅✅ NEW VERSION READY TO ACTIVATE! ✅✅✅');
                    console.log('   📍 Current controller:', navigator.serviceWorker.controller.scriptURL);
                    console.log('   📍 New worker:', newWorker.scriptURL);
                    console.log('   📍 Environment:', isDev ? 'Development' : 'Production');
                    console.log('   📍 Host:', host);

                    // ⚡ TIME-BASED AUTO-ACTIVATION
                    // If update detected within 3 seconds of page load, auto-activate
                    // This handles: hard refresh, regular refresh, first load
                    var timeSincePageLoad = Date.now() - pageLoadTime;
                    console.log('   📍 Time since page load:', timeSincePageLoad + 'ms');

                    if (timeSincePageLoad < 3000) {
                        // Update detected very soon after page load = user just loaded/refreshed
                        console.log('🔄 Update detected within 3s of page load - auto-activating...');
                        console.log('   (User just loaded/refreshed - no notification needed)');
                        refreshing = true;
                        newWorker.postMessage({ type: 'SKIP_WAITING' });
                        updateCheckInProgress = false;
                        return;
                    }

                    // Update detected later (user has been browsing) - show notification
                    console.log('📢 Update detected during browsing session - showing notification...');
                    console.log('   (User has been on page for ' + Math.round(timeSincePageLoad / 1000) + 's)');
                    try {
                        showUpdateNotification();
                        console.log('✅ showUpdateNotification() completed successfully');
                    } catch (err) {
                        console.error('❌ showUpdateNotification() failed:', err);
                    }

                    updateCheckInProgress = false;
                } else {
                    // This is a FIRST INSTALL (no existing controller)
                    console.log('✅ Service Worker installed for the first time (no update needed)');
                    console.log('   (No existing controller - this is the initial install)');
                    updateCheckInProgress = false;
                }
            }

            // ⚡ RACE CONDITION FIX: Check if worker is already installed
            // (state might have changed before we added the listener)
            if (newWorker.state === 'installed') {
                console.log('⚡ Worker already in "installed" state - handling immediately');
                handleUpdateReady();
            }

            // Listen for state changes
            newWorker.addEventListener('statechange', function () {
                console.log('🔄 SW state changed to:', newWorker.state);
                console.log('   Has controller?', !!navigator.serviceWorker.controller);
                console.log('   Update available?', updateAvailable);
                console.log('   Refreshing?', refreshing);

                if (newWorker.state === 'installed') {
                    handleUpdateReady();
                } else {
                    console.log('   State:', newWorker.state, '- waiting for "installed"...');
                }
            });
        });

        // ⚡ NOW that listener is attached, set up update checks
        console.log('✅ updatefound listener attached');

        // Check for updates - less aggressive in development
        if (!isDev) {
            // Production: Check every hour
            setInterval(function () {
                r.update().then(function () {
                    console.log('🔍 Periodic SW update check');
                });
            }, 3600000);

            // Check for updates when user returns to tab (but debounced)
            var visibilityTimer;
            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) {
                    clearTimeout(visibilityTimer);
                    visibilityTimer = setTimeout(function () {
                        console.log('👀 Tab visible - checking for updates');
                        r.update();
                    }, 1000);
                }
            });
        } else {
            console.log('🔧 DEV MODE: Periodic update checks disabled');
        }

        // ⚡ CRITICAL: Check for updates IMMEDIATELY (now that listener is attached)
        console.log('🔍 Triggering immediate SW update check...');
        console.log('   Note: updateViaCache=none should bypass HTTP cache');

        setTimeout(function () {
            // Call update() to check for new sw.js
            r.update().then(function () {
                console.log('✅ Initial SW update check complete');

                // Log current state for debugging
                console.log('   Active:', r.active?.state);
                console.log('   Waiting:', r.waiting?.state);
                console.log('   Installing:', r.installing?.state);

                if (r.waiting) {
                    console.log('   ⚡ Waiting worker exists after update check!');
                } else if (r.installing) {
                    console.log('   🔄 Worker is installing...');
                } else {
                    console.log('   ℹ️ No update found (same version)');
                }
            }).catch(function (err) {
                console.log('⚠️ Update check failed:', err);
            });
        }, 2000); // 2 second delay to ensure SW is fully ready

        // ⚡ BACKUP MECHANISM: Poll for waiting worker (catches cases where updatefound doesn't fire)
        // This is a safety net for edge cases
        var pollCount = 0;
        var pollInterval = setInterval(function () {
            pollCount++;

            if (pollCount > 10) {
                // Stop polling after 20 seconds
                clearInterval(pollInterval);
                console.log('⏹️ Stopped polling for updates (no update found after 20 seconds)');
                return;
            }

            // Check if there's a waiting worker
            if (r.waiting && !updateAvailable) {
                console.log('⚡ POLLING: Found waiting worker that was missed by updatefound!');
                newWorker = r.waiting;
                updateAvailable = true;
                clearInterval(pollInterval);

                // ⚡ TIME-BASED CHECK: Auto-activate if within 3s of page load
                var timeSincePageLoad = Date.now() - pageLoadTime;
                if (timeSincePageLoad < 3000) {
                    console.log('🔄 POLLING: Within 3s of page load - auto-activating...');
                    refreshing = true;
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                } else {
                    console.log('📢 POLLING: Showing notification (user has been browsing)...');
                    showUpdateNotification();
                }
            }
        }, 2000); // Check every 2 seconds
    }

    // Handle SW controller change (new version activated)
    navigator.serviceWorker.addEventListener('controllerchange', function () {
        console.log('🔄 controllerchange event fired!');
        console.log('   Refreshing flag:', refreshing);
        console.log('   New controller:', navigator.serviceWorker.controller);

        if (refreshing) {
            console.log('✅ User confirmed reload - reloading page now...');
            window.location.reload();
        } else {
            console.log('ℹ️ Controller changed but not refreshing (might be first install or skipWaiting called)');
        }
    });

    // Handle messages from SW
    navigator.serviceWorker.addEventListener('message', function (e) {
        if (!e.data) return;

        if (e.data.type === 'CACHE_CLEARED') {
            console.log('✅ SW cache cleared');
        }

        // ⚡ SW_ACTIVATED: New version is active with cleared caches
        if (e.data.type === 'SW_ACTIVATED' && e.data.cacheCleared) {
            console.log('✅ New SW version activated (v' + e.data.version + ') - all caches cleared');
            console.log('   ℹ️ Page will reload via controllerchange event when user clicks "Reload Now"');
            // Note: No auto-reload here - user must click "Reload Now" button
            // The controllerchange event handler will reload the page
        }
    });

    // Show update notification (permanent toast with manual reload) - Multilingual
    function showUpdateNotification() {
        // Don't show update notification for bank users
        if (window.hasAllowance === 'bank') {
            console.log('ℹ️ Update notification suppressed for bank user');
            return;
        }

        // Prevent duplicate notifications
        if (document.getElementById('update-toast')) {
            console.log('ℹ️ Update notification already showing');
            return;
        }

        // Detect language from URL
        var lang = window.location.pathname.split('/')[1] || 'tr';

        var messages = {
            'tr': {
                title: '🎉 Yeni Sürüm Hazır!',
                message: 'Yeni özellikleri görmek için sayfayı yenileyin.',
                reloadBtn: 'Şimdi Yenile',
                dismissBtn: 'Daha Sonra'
            },
            'en': {
                title: '🎉 New Version Ready!',
                message: 'Reload the page to see new features.',
                reloadBtn: 'Reload Now',
                dismissBtn: 'Later'
            },
            'es-ES': {
                title: '🎉 Nueva Versión Lista!',
                message: 'Recarga la página para ver nuevas funciones.',
                reloadBtn: 'Recargar Ahora',
                dismissBtn: 'Más Tarde'
            },
            'pt-PT': {
                title: '🎉 Nova Versão Pronta!',
                message: 'Recarregue a página para ver novos recursos.',
                reloadBtn: 'Recarregar Agora',
                dismissBtn: 'Mais Tarde'
            }
        };

        var msg = messages[lang] || messages['tr'];

        var toast = document.createElement('div');
        toast.id = 'update-toast';
        toast.innerHTML = '<div style="position:fixed;top:20px;right:20px;background:#FF0550;color:#fff;padding:20px;border-radius:12px;box-shadow:0 4px 20px rgba(0,0,0,0.4);z-index:9999999;font-family:Inter,sans-serif;font-size:14px;max-width:340px;animation:slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);"><strong style="display:block;margin-bottom:8px;font-size:16px;">' + msg.title + '</strong><p style="margin:0 0 16px 0;opacity:0.95;line-height:1.4;">' + msg.message + '</p><div style="display:flex;gap:8px;"><button id="reload-now-btn" style="flex:1;background:#fff;color:#FF0550;border:none;padding:10px 16px;border-radius:6px;cursor:pointer;font-weight:600;font-size:13px;transition:all 0.2s ease;font-family:Inter,sans-serif;">' + msg.reloadBtn + '</button><button id="dismiss-update-btn" style="background:rgba(255,255,255,0.15);color:#fff;border:none;padding:10px 16px;border-radius:6px;cursor:pointer;font-weight:500;font-size:13px;transition:all 0.2s ease;font-family:Inter,sans-serif;">' + msg.dismissBtn + '</button></div></div>';

        var style = document.createElement('style');
        style.textContent = '@keyframes slideIn{from{transform:translateX(400px);opacity:0}to{transform:translateX(0);opacity:1}}#reload-now-btn:hover{background:#f5f5f5;transform:translateY(-1px);box-shadow:0 2px 8px rgba(0,0,0,0.15)}#dismiss-update-btn:hover{background:rgba(255,255,255,0.25)}';
        document.head.appendChild(style);

        document.body.appendChild(toast);

        // ⚡ VERIFY the notification is actually visible
        setTimeout(function () {
            var check = document.getElementById('update-toast');
            if (check) {
                var rect = check.getBoundingClientRect();
                var innerDiv = check.querySelector('div');
                var computedStyle = window.getComputedStyle(innerDiv);

                console.log('🔍 NOTIFICATION VERIFICATION:');
                console.log('   ✅ Element exists in DOM:', !!check);
                console.log('   📍 Position:', 'top=' + rect.top + 'px, right=' + rect.right + 'px');
                console.log('   📍 Size:', rect.width + 'x' + rect.height + 'px');
                console.log('   📍 Z-index:', computedStyle.zIndex);
                console.log('   📍 Visibility:', computedStyle.visibility);
                console.log('   📍 Display:', computedStyle.display);
                console.log('   📍 Opacity:', computedStyle.opacity);
                console.log('   📍 Background:', computedStyle.backgroundColor);
                console.log('');

                if (rect.top < 0 || rect.right > window.innerWidth || rect.width === 0) {
                    console.warn('⚠️ NOTIFICATION MIGHT BE OFF-SCREEN!');
                    console.warn('   Window size:', window.innerWidth + 'x' + window.innerHeight);
                    console.warn('   Notification position:', rect);
                }

                if (computedStyle.zIndex < 999999) {
                    console.warn('⚠️ Z-index might be too low:', computedStyle.zIndex);
                }

                console.log('🎯 If you CANNOT see a red box in the top-right corner:');
                console.log('   1. Check browser zoom (should be 100%)');
                console.log('   2. Scroll to top of page');
                console.log('   3. Check if another element is covering it');
                console.log('   4. Try making window wider');
                console.log('   5. Run: document.getElementById("update-toast").scrollIntoView()');
            } else {
                console.error('❌ NOTIFICATION ELEMENT NOT FOUND IN DOM!');
                console.error('   Something removed it immediately after creation');
            }
        }, 200);

        // Reload button handler - triggers update and reload
        document.getElementById('reload-now-btn').addEventListener('click', function () {
            if (updateAvailable && !refreshing) {
                refreshing = true;
                console.log('🔄 User clicked "Reload Now" - activating new Service Worker...');
                toast.querySelector('div').innerHTML = '<div style="text-align:center;padding:10px;"><strong>' + (lang === 'tr' ? 'Yükleniyor...' : lang === 'es-ES' ? 'Cargando...' : lang === 'pt-PT' ? 'Carregando...' : 'Loading...') + '</strong></div>';

                // ⚡ CRITICAL: Tell the waiting Service Worker to activate
                if (newWorker && newWorker.state === 'installed') {
                    console.log('📤 Sending SKIP_WAITING message to new Service Worker...');
                    newWorker.postMessage({ type: 'SKIP_WAITING' });

                    // The controllerchange event will trigger the reload
                    // (see handler at line ~1872)
                } else if (navigator.serviceWorker.controller) {
                    // Fallback: clear caches and reload
                    console.log('⚠️ No waiting worker found, clearing caches and reloading...');
                    if ('caches' in window) {
                        caches.keys().then(function (names) {
                            return Promise.all(
                                names.map(function (name) {
                                    console.log('🗑️ Clearing cache:', name);
                                    return caches.delete(name);
                                })
                            );
                        }).then(function () {
                            console.log('✅ All caches cleared - hard reloading...');
                            window.location.reload(true);
                        }).catch(function () {
                            window.location.reload(true);
                        });
                    } else {
                        window.location.reload(true);
                    }
                } else {
                    // No SW at all - just reload
                    window.location.reload(true);
                }
            }
        });

        // Dismiss button handler - user can update later
        document.getElementById('dismiss-update-btn').addEventListener('click', function () {
            updateAvailable = false;
            refreshing = false;
            updateCheckInProgress = false;
            toast.remove();
            console.log('ℹ️ Update dismissed by user - won\'t show again this session');
        });
    }

    // Utility to clear SW cache
    window.clearSWCache = function () {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
        }
    };
})();

/**
 * This file defines the AngularJS module 'app.resources' and its run block.
 * It also initializes various caches using CacheFactory for caching data.
 * @module app.resources
 */
(function () {
    'use strict';

    function sanitizeDynamicTrendParams(params) {
        var trendParams = angular.extend({}, params);

        // ComplexCategory is only supported at point/radius level for housing
        if (+trendParams.Level !== 0 || +trendParams.PropertyCategory !== 1)
            delete trendParams.ComplexCategory;

        // dynamictrend never accepts ParcelId; parcel level (7) is housing-only
        delete trendParams.ParcelId;
        if (+trendParams.Level === 7 && +trendParams.PropertyCategory !== 1)
            trendParams.Level = 3;

        switch (+trendParams.Level) {
            case 9:
                delete trendParams.CityId;
                delete trendParams.CountyId;
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 1:
                delete trendParams.CountyId;
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 2:
                delete trendParams.DistrictId;
                delete trendParams.BlockId;
                break;
            case 6:
                delete trendParams.BlockId;
                break;
        }

        return trendParams;
    }

    angular
        .module('app.resources', [])
        .run(['CacheFactory', function (CacheFactory) {
            var storageImpl = {
                getItem: function (key) { return localStorage.getItem(key); },
                setItem: function (key, value) {
                    try {
                        return localStorage.setItem(key, value);
                    } catch (err) {
                        const accessToken = localStorage.getItem('accessToken');
                        const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                        const refreshToken = localStorage.getItem('refreshToken');
                        const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                        localStorage.clear();
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('accessTokenExpires', accessTokenExpires);
                        localStorage.setItem('refreshToken', refreshToken);
                        localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                        window.userStorage.sync();
                        return localStorage.setItem(key, value);
                    }
                },
                removeItem: function (key) { return localStorage.removeItem(key); },
            };
            if (!CacheFactory.get('Exchanges')) {
                CacheFactory('Exchanges', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('ExchangesTrend')) {
                CacheFactory('ExchangesTrend', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 12 * 60 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 12 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('Uavts')) {
                CacheFactory('Uavts', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Valuations')) {
                CacheFactory('Valuations', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsAdmin')) {
                CacheFactory('ValuationsAdmin', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsDetail')) {
                CacheFactory('ValuationsDetail', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsInside')) {
                CacheFactory('ValuationsInside', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsComparable')) {
                CacheFactory('ValuationsComparable', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsHistory')) {
                CacheFactory('ValuationsHistory', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Demographies')) {
                CacheFactory('Demographies', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Elections')) {
                CacheFactory('Elections', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Fellows')) {
                CacheFactory('Fellows', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Arabic')) {
                CacheFactory('Arabic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesList')) {
                CacheFactory('OpportunitiesList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Agents')) {
                CacheFactory('Agents', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsGet')) {
                CacheFactory('AgentsGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsSearch')) {
                CacheFactory('AgentsSearch', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsSuggestion')) {
                CacheFactory('AgentsSuggestion', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsById')) {
                CacheFactory('AgentsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportsById')) {
                CacheFactory('OpportsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 5 * 60 * 1000,
                    storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos')) {
                CacheFactory('Geos', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos2')) {
                CacheFactory('Geos2', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Geos3')) {
                CacheFactory('Geos3', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('GeoNames')) {
                CacheFactory('GeoNames', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            // if (!CacheFactory.get('Geos4')) {
            //     CacheFactory('Geos4', {
            //         deleteOnExpire: 'aggressive',
            //         maxAge: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
            //     });
            // }
            if (!CacheFactory.get('Indices')) {
                CacheFactory('Indices', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Ngbhrs')) {
                CacheFactory('Ngbhrs', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsThematic')) {
                CacheFactory('ValuationsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AgentsThematic')) {
                CacheFactory('AgentsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesThematic')) {
                CacheFactory('OpportunitiesThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsThematic')) {
                CacheFactory('ProjectsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsThematic')) {
                CacheFactory('MallsThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Pois')) {
                CacheFactory('Pois', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Trade')) {
                CacheFactory('Trade', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('TKGM')) {
                CacheFactory('TKGM', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Zoning')) {
                CacheFactory('Zoning', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Risks')) {
                CacheFactory('Risks', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Megas')) {
                CacheFactory('Megas', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Projects')) {
                CacheFactory('Projects', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsList')) {
                CacheFactory('ProjectsList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ProjectsListById')) {
                CacheFactory('ProjectsListById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Comparables')) {
                CacheFactory('Comparables', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('TotalRooms')) {
                CacheFactory('TotalRooms', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets')) {
                CacheFactory('RetailStreets', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets3')) {
                CacheFactory('RetailStreets3', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets4')) {
                CacheFactory('RetailStreets4', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RetailStreets5')) {
                CacheFactory('RetailStreets5', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 15 * 60 * 1000,
                    cacheFlushInterval: 15 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('StreetViews')) {
                CacheFactory('StreetViews', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Malls')) {
                CacheFactory('Malls', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    cacheFlushInterval: 48 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsGet')) {
                CacheFactory('MallsGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('MallsById')) {
                CacheFactory('MallsById', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 30 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('OpportunitiesGet')) {
                CacheFactory('OpportunitiesGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsAssets')) {
                CacheFactory('ValuationsAssets', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('ValuationsSimple')) {
                CacheFactory('ValuationsSimple', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    cacheFlushInterval: 24 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('AreaCache')) {
                CacheFactory('AreaCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('CommentCache')) {
                CacheFactory('CommentCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000//, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RegionCheckCache')) {
                CacheFactory('RegionCheckCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('RoomTypes')) {
                CacheFactory('RoomTypes', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentDetail')) {
                CacheFactory('InvestmentDetail', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('Investment')) {
                CacheFactory('Investment', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentTrend')) {
                CacheFactory('InvestmentTrend', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
            if (!CacheFactory.get('InvestmentThematic')) {
                CacheFactory('InvestmentThematic', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 6 * 60 * 60 * 1000,
                    cacheFlushInterval: 6 * 60 * 60 * 1000, storageImpl: storageImpl
                });
            }
        }])
        .factory('Exchange', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Exchanges');
                var cache2 = CacheFactory.get('ExchangesTrend');
                return $resource(appSettingsSvc.NEWCACHE + '/currency/:dest', {}, {
                    currency: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            date: '@date'
                        },
                        isArray: false,

                    },
                    trend: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: "trend",
                        },
                        isArray: true,
                    }
                });

            }
        ])
        .factory('area_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('AreaCache');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    getMetrics: {
                        method: 'GET',
                        params: { dest: "EndeksaValuationSummary", isValuationValueFilterActive: '@isValuationValueFilterActive' },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('nps_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache2 = CacheFactory.get('CommentCache');
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: { root: "EndeksaComments", dest: "GetList" },
                        isArray: false,
                        cache: cache2,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('report_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.REPORT + '/:dest/:endpoint', {}, {
                    raporDogrula: {
                        method: 'GET',
                        params: { dest: "RaporDogrula" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    tasinmazreport: {
                        method: 'GET',
                        params: { dest: "tasinmazreport", TasinmazId: '@TasinmazId' },
                        isArray: false,
                        cache: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    getReport: {
                        method: 'POST',
                        params: {
                            dest: "GenerateReport",
                            ProductId: "@ProductId",
                            TasinmazId: "@TasinmazId",
                            UserId: "@UserId",
                            Lang: "@Lang",
                            IsRent: "@IsRent"
                        },
                        isArray: false
                    },
                    getReportAdmin: {
                        method: 'POST',
                        params: {
                            dest: "GenerateReport",
                            endpoint: "AdminReport",
                            ProductId: "@ProductId",
                            TasinmazId: "@TasinmazId",
                            UserId: "@UserId",
                            Lang: "@Lang",
                            IsRent: "@IsRent"
                        },
                        isArray: false
                    },
                });

            }
        ])
        .factory('Uavt', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Uavts');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "uavt",
                            id: '@id'
                        },
                        isArray: false,

                    }
                });

            }
        ])
        .factory('valuationGETAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Valuations');
                var cache2 = CacheFactory.get('ValuationsDetail');
                var cache3 = CacheFactory.get('ValuationsInside');
                var cache4 = CacheFactory.get('ValuationsComparable');
                var cache5 = CacheFactory.get('ValuationsHistory');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: {
                            root: "tasinmazliste",
                            UserId: "@UserId",
                            ActivePageNumber: "@ActivePageNumber",
                            ItemSize: "@ItemSize",
                            Sort: 2,
                            Search: "@Search",
                            OrderBy: 1,
                            DataLevel: "@DataLevel",
                            CityId: "@CityId",
                            CountyId: "@CountyId",
                            DistrictId: "@DistrictId",
                            QuarterId: "@QuarterId",
                            Radius: "@Radius",
                            Lat: "@Lat",
                            Long: "@Long"
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    },
                    details: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            propertyid: "@propertyid",
                            name: "@name"
                        },
                        isArray: false,
                        cache: cache2
                    },
                    changeName: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            propertyid: "@propertyid",
                            name: "@name"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    getFiles: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "filelist",
                            propertyid: "@propertyid"
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    getNote: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "note",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false
                    },
                    deleteNote: {
                        method: 'DELETE',
                        params: {
                            root: "tasinmaz",
                            dest: "note",
                            propertyid: "@propertyid"
                        },
                        isArray: false
                    },
                    updateState: {
                        method: 'POST',
                        params: {
                            root: "tasinmazupdatestate",
                            propertyid: "@propertyid",
                            value: "@value",
                            date: "@date",
                            status: "@status"
                        },
                        isArray: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: {
                            root: "tasinmaz",
                            id: "@id"
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            propertyid: "@propertyid"
                        },
                        isArray: true,
                        cache: cache3
                    },
                    getAutoValuationInfo: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            dest: "GetAutoValuationInfo",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false
                    },
                    getQueue: {
                        method: 'GET',
                        params: {
                            root: "valuationqueue",
                            propertyid: "@propertyid"
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    history: {
                        method: 'GET',
                        params: {
                            root: "valuation",
                            propertyid: "@propertyid",
                            history: "@history"
                        },
                        isArray: false,
                        cache: cache5,
                        ignoreLoadingBar: true
                    },
                    select: {
                        method: 'POST',
                        params: {
                            root: "selectvaluation",
                            valuationid: "@valuationid"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    comparables: {
                        method: 'GET',
                        params: {
                            root: "comparables",
                            valuationid: "@valuationid",
                            propertyid: "@propertyid",
                            propertycategory: "@propertycategory",
                            countryid: "@countryid"
                        },
                        isArray: false,
                        cache: cache4,
                        ignoreLoadingBar: true
                    },
                    valuationsById: {
                        method: 'POST',
                        params: {
                            root: "tasinmazliste",
                            dest: "GetByValuationIds"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    getNote: {
                        method: 'GET',
                        params: {
                            root: "tasinmaz",
                            dest: "note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    recalculate: {
                        method: 'POST',
                        params: {
                            root: 'investment',
                            dest: 'RecalculateScore'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('investmentAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Investment');
                var cache2 = CacheFactory.get('InvestmentTrend');
                return $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            root: "investment"
                        },
                        isArray: true,
                        cancellable: true,
                        cache: cache2,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    },
                    search: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: 'investment',
                            dest: 'search'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('valuationGETADMINAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('ValuationsAdmin');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: {
                            root: "Tasinmazliste",
                            dest: "GetTasinmazListe",
                            UserId: "@UserId",
                            ActivePageNumber: "@ActivePageNumber",
                            ItemSize: "@ItemSize",
                            Sort: 2,
                            Search: "@Search",
                            OrderBy: 1,
                            DataLevel: "@DataLevel",
                            CityId: "@CityId",
                            CountyId: "@CountyId",
                            DistrictId: "@DistrictId"
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    }
                });
            }
        ])
        .factory('valuationPOSTAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.VALUATION + '/:root/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            root: "valuation"
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    setQueue: {
                        method: 'POST',
                        params: {
                            root: "valuationqueue",
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    createAutoValuationInfo: {
                        method: 'POST',
                        params: {
                            root: "valuation",
                            dest: "CreateAutoValuationInfo"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    deleteAutoValuationInfo: {
                        method: 'DELETE',
                        params: {
                            root: "valuation",
                            dest: "DeleteAutoValuationInfo"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    addNote: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            dest: "note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    changeFiles: {
                        method: 'POST',
                        params: {
                            root: "tasinmaz",
                            dest: "filelist"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    changeNote: {
                        method: 'POST',
                        params: {
                            root: "tasinmaznote",
                            propertyid: "@propertyid",
                            note: "@note"
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('demographyApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Demographies');
                var api = $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    _get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "demography",
                            dest: "Values"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    }
                });

                return {
                    get: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._get(params);
                    }
                };
            }
        ])
        .factory('demographyApiNoCache', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                var api = $resource(appSettingsSvc.NONPROXIED + '/:root/:dest', {}, {
                    _get: {
                        method: 'GET',
                        params: {
                            root: "demography",
                            dest: "Values"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    }
                });

                return {
                    get: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._get(params);
                    }
                };
            }
        ])
        .factory('electionApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Elections');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: "election"
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('fellowApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Fellows');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        method: 'GET',
                        cache: cache,
                        params: {
                            root: "fellowcountryman"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('arabicApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('Arabic');
                return $resource(appSettingsSvc.CACHE + '/:root', {}, {
                    get: {
                        method: 'GET',
                        cache: cache,
                        params: {
                            root: "arabiccomparables"
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('opportunitiesApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var Cache = CacheFactory.get('OpportunitiesList');
                return $resource(appSettingsSvc.NONCACHE + '/portfoliosearch', {}, {
                    getAll: {
                        method: 'GET',
                        cache: Cache,
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('agentApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var agentCache = CacheFactory.get('Agents');
                var agentCache2 = CacheFactory.get('AgentsGet');
                var agentCache3 = CacheFactory.get('AgentsSearch');
                var agentCache4 = CacheFactory.get('AgentsSuggestion');
                var cacheById = CacheFactory.get('AgentsById');
                return $resource(appSettingsSvc.CACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: agentCache,
                        params: {
                            func: "GetAgentList",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    suggest: {
                        method: 'GET',
                        cache: agentCache4,
                        params: {
                            func: "SuggestedAgentListForValuation",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        cache: agentCache2,
                        params: {
                            func: "GetAgentDetail",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        // ignoreLoadingBar: true
                    },
                    agentListings: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "GetComparablesForAgentDetail",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    search: {
                        method: 'GET',
                        cache: agentCache3,
                        params: {
                            func: "AgentSearch",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    },
                    userRegions: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "OnlyRegions",
                            root: "RealtorRegions"
                        },
                        isArray: true,
                        responseType: "json",
                        cancellable: false
                    },
                    agentsById: {
                        method: 'POST',
                        cache: cacheById,
                        params: {
                            func: "GetAgentListByAgentIds",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    }
                });
            }
        ])
        .factory('agentApiNonCache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var regionCache = CacheFactory.get('RegionCheckCache');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:func', {}, {
                    listByAdmin: {
                        method: 'GET',
                        cache: false,
                        params: {
                            func: "GetAgentListByAdmin",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    agentsByIdAdmin: {
                        method: 'POST',
                        cache: false,
                        params: {
                            func: "GetAgentListByAgentIdsByAdmin",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false
                    },
                    regionCheck: {
                        method: 'GET',
                        cache: regionCache,
                        params: {
                            func: "regioncheck",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false,
                        ignoreLoadingBar: true
                    },
                    regionUpdate: {
                        method: 'GET',
                        params: {
                            func: "UpdateRegion",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: false,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('agentApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var agentCache = CacheFactory.get('Agents');
                // var agentCache2 = CacheFactory.get('AgentsGet');
                // var agentCache3 = CacheFactory.get('AgentsSearch');
                return $resource(appSettingsSvc.CACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: agentCache,
                        params: {
                            func: "GetAgentList",
                            root: "RealtorRegions"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('quakeApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                // var agentCache = CacheFactory.get('Agents');
                // var agentCache3 = CacheFactory.get('AgentsSearch');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:func', {}, {
                    list: {
                        method: 'GET',
                        cache: false,
                        params: {
                            root: "earthquake",
                            func: "gettweets"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    map: {
                        method: 'GET',
                        cache: false,
                        params: {
                            root: "earthquake",
                            func: "getearthquakes"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('geoApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var geoCache = CacheFactory.get('Geos');
                var geo2Cache = CacheFactory.get('Geos2');
                var geo3Cache = CacheFactory.get('Geos3');
                var geoNamesCache = CacheFactory.get('GeoNames');
                // var geo4Cache = CacheFactory.get('Geos4');
                return $resource(appSettingsSvc.CACHE + '/:root/:dest', {}, {
                    getRaw: {
                        cache: geoCache,
                        method: 'GET',
                        params: {
                            root: "geomap"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true

                    },
                    getByIdRaw: {
                        cache: geo2Cache,
                        method: 'GET',
                        params: {
                            root: "geomap"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true
                    },
                    get: {
                        cache: geoCache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "map"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            return JSON.parse(window.encodeResponse(response));
                        }
                    },
                    getById: {
                        cache: geo2Cache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "map"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true,
                        transformResponse: function (response) {
                            return JSON.parse(window.encodeResponse(response));
                        }

                    },
                    getListById: {
                        cache: geo3Cache,
                        method: 'GET',
                        params: {
                            root: "geolistbyid"
                        },
                        isArray: false,
                        responseType: "json",
                        cancellable: true,
                        skipAuthorization: true

                    },
                    getCountries: {
                        cache: false,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "allcountries"
                        },
                        isArray: true,
                        skipAuthorization: true
                    },
                    getNamesByCountryId: {
                        cache: geoNamesCache,
                        method: 'GET',
                        params: {
                            root: "geo",
                            dest: "GetGeoNamesByCountryId"
                        },
                        isArray: false,
                        skipAuthorization: true
                    }
                    // getByIds: {
                    //     cache: geo4Cache,
                    //     method: 'POST',
                    //     params: {
                    //         root: "getgeomapbyids"
                    //     },
                    //     isArray: false,
                    //     responseType: "json",
                    //     cancellable: true

                    // },
                });

            }
        ])
        /* .factory('customRegionApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: false,
                        responseType: "json",

                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: true,
                        cache: false

                    },
                    del: {
                        method: 'DELETE',
                        params: {
                            root: "geocustomregion"
                        },
                        isArray: false,
                        responseType: "json",

                    }
                });

            }
        ]) */

        // New Api for Dynamic Indices
        .factory('indicesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var indicesCache = CacheFactory.get('Indices');
                var api = $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    _trendAnalysis: {
                        cache: indicesCache,
                        method: 'GET',
                        params: {
                            dest: "dynamictrend"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        skipAuthorization: true,
                        isArray: false,
                        cancellable: true,
                        // ignoreLoadingBar: true
                    }
                });

                return {
                    trendAnalysis: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._trendAnalysis(params);
                    }
                };
            }
        ])
        .factory('indicesAPINoCache', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                var api = $resource(appSettingsSvc.NONPROXIED + '/:dest', {}, {
                    _trendAnalysis: {
                        method: 'GET',
                        params: {
                            dest: "dynamictrend"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        // ignoreLoadingBar: true
                    }
                });

                return {
                    trendAnalysis: function (params) {
                        params = angular.extend(sanitizeDynamicTrendParams(params), { captchaTokenCustom: window.ecSec() });
                        return api._trendAnalysis(params);
                    }
                };
            }
        ])
        .factory('landAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: "landvaluation"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])

        // New Api for Report
        .factory('rpaApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    GenerateRpa: {
                        method: 'POST',
                        params: {
                            dest: "GenerateRpa"
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])

        // .factory('retailApi', [
        //     '$resource', 'appSettingsSvc',
        //     function ($resource, appSettingsSvc) {
        //         return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
        //             types: {
        //                 method: 'GET',
        //                 params: {
        //                     dest: "RegionalAnalysisCompanyType"
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: true,
        //                 cancellable: true
        //             },
        //             get: {
        //                 method: 'POST',
        //                 params: {
        //                     dest: "RegionalAnalysisCompany"
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: true,
        //                 cancellable: true
        //             }
        //         });
        //     }
        // ])

        // Neighbourhoods API
        .factory('neighbourAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Ngbhrs');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'neighborhoods'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true

                    }
                });
            }
        ])
        // Lead API
        .factory('leadAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'leadform'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    }
                });
            }
        ])
        // Lead API
        .factory('pollAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    district: {
                        method: 'GET',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,

                    },
                    post: {
                        method: 'POST',
                        params: {
                            dest: 'survey'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,

                    }
                });
            }
        ])
        .factory('alertAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'alert'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: false
                    },
                    history: {
                        method: 'GET',
                        params: {
                            dest: 'alertcomparablehistory'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true

                    },
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'alert',
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    reactivate: {
                        method: 'POST',
                        params: {
                            dest: 'alert',
                            Id: '@Id'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    delete: {
                        method: 'DELETE',
                        params: {
                            dest: 'alert'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    },
                    filter: {
                        method: 'GET',
                        params: {
                            dest: 'alertfilter',
                            dest2: 'getalertmatches'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: false
                    },
                    list: {
                        method: 'GET',
                        params: {
                            dest: 'alertlist'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('thematicAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ValuationsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'tasinmazthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicAgentsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('AgentsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'RealtorRegionsThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicQuakesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                // var cache = CacheFactory.get('AgentsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'EarthquakeThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicOpportunitiesAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('OpportunitiesThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'PortfolioThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicProjectsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ProjectsThematic');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'HousingProjectThematicMap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicLocationsAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'excelthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('thematicMallsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('MallsThematic');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'shoppingcenterthematicmap'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiOptions', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root', {}, {
                    post: {
                        method: 'POST',
                        params: {
                            root: "userpoioptions"
                        },
                        isArray: false,

                    },
                    get: {
                        method: 'GET',
                        params: {
                            root: "userpoioptions"
                        },
                        isArray: true,
                        ignoreLoadingBar: true

                    }
                });

            }
        ])
        .factory('thematicInvestmentAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('InvestmentThematic');
                return $resource(appSettingsSvc.CACHE + '/:dest/:dest2', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'Investment',
                            dest2: 'Thematic'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Pois');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    catalog: {
                        method: 'GET',
                        params: {
                            dest: 'poi'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('poiAPICache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'poi'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('placesAPINew', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'places'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: false
                    }
                });
            }
        ])
        .factory('wktAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    set: {
                        method: 'POST',
                        params: {
                            dest: 'wkt'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'wkt'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('layerApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'layeranalysis'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('tradeApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Trade');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'TradePotentialIndex'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache
                    }
                });
            }
        ])
        .factory('tkgmApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('TKGM');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'salesdata'
                        },
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('urlSearchApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('salesApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'SalesLayer'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,

                    }
                });
            }
        ])
        .factory('excelApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    updateRow: {
                        method: 'POST',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'excelsearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    addRow: {
                        method: 'GET',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    delRow: {
                        method: 'DELETE',
                        params: {
                            dest: 'excel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    getSales: {
                        method: 'GET',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    delSales: {
                        method: 'DELETE',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    postSales: {
                        method: 'POST',
                        params: {
                            dest: 'excelsales'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    salesPivot: {
                        method: 'GET',
                        params: {
                            dest: 'excelsalespivot'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    }
                });
            }
        ])
        .factory('commonFeatures', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'commonfeatures'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('zoningApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Zoning');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'imar'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true,
                        skipAuthorization: true
                    }
                });
            }
        ])
        .factory('riskApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Risks');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'risk'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true,
                        skipAuthorization: true
                    }
                });
            }
        ])
        // .factory('megaProjectApi', [
        //     '$resource', 'appSettingsSvc', 'CacheFactory',
        //     function ($resource, appSettingsSvc, CacheFactory) {

        //         var cache = CacheFactory.get('Megas');
        //         return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
        //             get: {
        //                 cache: cache,
        //                 method: 'GET',
        //                 params: {
        //                     dest: 'megaprojects'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false,
        //                 cancellable: true
        //             }
        //         });
        //     }
        // ])
        .factory('demographySearchApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'demographysearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        skipAuthorization: true,
                        isArray: false
                    }
                });
            }
        ])
        .factory('ownerRentedApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'OwnerRented'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('purchasingPowerApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            dest: 'purchasingpower'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('findRegionApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    catalog: {
                        method: 'GET',
                        params: {
                            dest: 'searchsimilardistricts'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true
                    },
                    search: {
                        method: 'POST',
                        params: {
                            dest: 'searchsimilardistricts'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    group: {
                        method: 'POST',
                        params: {
                            dest: 'searchdistrictsbygroup'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('reportStatusApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            root: 'reportrequests'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    url: {
                        method: 'GET',
                        params: {
                            root: 'reportrequests',
                            dest: '@dest'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('regionReportApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.REPORT + '/:dest/:endpoint', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'regionreport'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                    },
                    del: {
                        method: 'DELETE',
                        params: {
                            dest: 'regionreport'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                });
            }
        ])
        .factory('legalApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'legalquery'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                    }
                });
            }
        ])
        .factory('revenueApi', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: {
                            dest: 'dynamicmodel'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                    }
                });
            }
        ])
        .factory('projectsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Projects');
                var cacheList = CacheFactory.get('ProjectsList');
                var cacheById = CacheFactory.get('ProjectsListById');
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    list: {
                        cache: cacheList,
                        method: 'GET',
                        params: {
                            root: 'housingprojects'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            root: 'housingprojects'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    projectsById: {
                        cache: cacheById,
                        method: 'POST',
                        params: {
                            root: 'housingprojects',
                            dest: 'GetByHousingProjectIds'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('comparablesApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Comparables');
                var cache2 = CacheFactory.get('TotalRooms');
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    get: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    getByRef: {
                        cache: cache,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearchByRef'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    detail: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'searchdetail'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    },
                    getRooms: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'GetCommonRoomTypes'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('comparablesApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('RoomTypes');
                return $resource(appSettingsSvc.NONCACHE + '/:dest/:dest2', {}, {
                    getRooms: {
                        cache: cache2,
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'GetCommonRoomTypes'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('comparablesApiCached', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var cache = CacheFactory.get('InvestmentDetail');
                return $resource(appSettingsSvc.CACHE + '/:dest/:dest2', {}, {
                    detail: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            dest2: 'searchdetail'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache
                    },
                });
            }
        ])
        .factory('retailStreetsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('RetailStreets');
                var cache3 = CacheFactory.get('RetailStreets3');
                var cache4 = CacheFactory.get('RetailStreets4');
                return $resource(appSettingsSvc.CACHE + '/:dest', {}, {
                    get: {
                        cache: cache,
                        method: 'POST',
                        params: {
                            dest: 'retailstreets'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    search: {
                        cache: cache3,
                        method: 'POST',
                        params: {
                            dest: 'retailstreetsearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    poi_match: {
                        cache: cache4,
                        method: 'POST',
                        params: {
                            dest: 'streetpoimatch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('retailStreetsApiNonCache', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache5 = CacheFactory.get('RetailStreets5');
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    buffer: {
                        cache: cache5,
                        method: 'POST',
                        params: {
                            dest: 'retailstreetbuffer'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('isochroneAPI', [
            '$resource',
            function ($resource) {
                return $resource('https://api.mapbox.com/isochrone/v1/mapbox/:type/:lng,:lat?contours_minutes=:minutes&contours_colors=:colors&polygons=true&access_token=pk.eyJ1IjoiZW5kZWtzYSIsImEiOiJja21kdWZvcjMxdXk2MnBwaGVneHJjeXB3In0.jsYPQYIVhGIYF4AXFS5O7A', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            type: '@type',
                            lat: '@lat',
                            lng: '@lng',
                            minutes: '@minutes',
                            colors: '@colors'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])

        // .factory('geocodeAPI', [
        //     '$resource',
        //     function ($resource) {
        //         return $resource('https://api.tomtom.com/search/2/geocode/:search.json?countrySet=TR&key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0', {}, {
        //             get: {
        //                 method: 'GET',
        //                 params: {
        //                     search: '@search'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false
        //             }
        //         });
        //     }
        // ])
        // .factory('reverseGeocodeAPI', [
        //     '$resource',
        //     function ($resource) {
        //         return $resource('https://api.tomtom.com/search/2/reverseGeocode/:lat,:lng.json?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0', {}, {
        //             get: {
        //                 method: 'GET',
        //                 params: {
        //                     lat: '@lat',
        //                     lng: '@lng'
        //                 },
        //                 headers: {
        //                     'Content-Type': 'application/json'
        //                 },
        //                 isArray: false
        //             }
        //         });
        //     }
        // ])
        .factory('streetViewAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('StreetViews');
                return $resource(appSettingsSvc.CACHE + '/streetview', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            lat: '@lat',
                            lon: '@lon',
                            size: '@size',
                            propertyid: '@propertyid'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('shareAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:end', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            end: 'ContactsShared'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    },
                    view: {
                        method: 'POST',
                        params: {
                            end: 'ContactsSharedViewCount'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ])
        .factory('updateThemeAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(
                    appSettingsSvc.NONCACHE + '/updatetheme/:theme', {}, {
                    get: {
                        method: 'GET',
                        params: {
                            theme: '@theme'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                }
                );
            }
        ]).factory('mallsAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Malls');
                var cache2 = CacheFactory.get('MallsGet');
                var cacheById = CacheFactory.get('MallsById');
                return $resource(
                    appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                    storeCategories: {
                        method: 'GET',
                        params: {
                            operation: 'StoreCategories'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    stores: {
                        method: 'GET',
                        params: {
                            operation: 'StoreSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    atms: {
                        method: 'GET',
                        params: {
                            operation: 'ATMSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    list: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenters'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: false
                    },
                    get: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenters'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        cache: cache2,
                        ignoreLoadingBar: false
                    },
                    search: {
                        method: 'GET',
                        params: {
                            operation: 'ShoppingCenterSearch'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false
                    },
                    mallsById: {
                        method: 'POST',
                        params: {
                            operation: 'ShoppingCenters',
                            dest: 'GetByShoppingCenterIds'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: false,
                        cache: cacheById
                    }
                }
                );
            }
        ]).factory('opportListURLAPI', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest?ListingURL=:urlData', {}, {
                    urlListGet: {
                        method: 'GET',
                        params: {
                            dest: 'comparablesearch',
                            urlData: '@urlData'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    }
                });
            }
        ]).factory('opportListAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                // appSettingsSvc.NONCACHE
                var cache = CacheFactory.get('OpportsById');
                return $resource(appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                    residentialAdd: {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfoliohouse'
                        },
                        isArray: false
                    },
                    landAdd: {
                        method: 'POST',
                        headers: { 'Content-type': 'application/json' },
                        params: {
                            operation: 'portfolioland'
                        },
                        isArray: false
                    },
                    commercialAdd: {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfoliocommercial'
                        },
                        isArray: false
                    },
                    opportDelete: {
                        method: 'DELETE',
                        params: { operation: "portfolio", portfolioId: '@portfolioId' },
                    },
                    opportUpdate: {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'portfolio'
                        },
                        isArray: false
                    },
                    opportsById: {
                        cache: cache,
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        params: {
                            operation: 'opportunity',
                            dest: 'GetByOpportunityIds'
                        },
                        isArray: false
                    },
                });
            }
        ]).factory('opportunitiesGetApi', ['$resource', 'appSettingsSvc', 'CacheFactory', function ($resource, appSettingsSvc, CacheFactory) {

            var cache = CacheFactory.get('OpportunitiesGet');

            // appSettingsSvc.NONCACHE
            return $resource(appSettingsSvc.NONCACHE + '/:operation/:dest', {}, {
                // getByIdIp: {
                //     method: 'GET',
                //     headers: { 'Content-Type': 'application/json', ClientIp: ip },
                //     params: {
                //         operation: 'portfolio',
                //         portfolioId: '@portfolioId',
                //     },
                //     cache: cache2
                // },
                getById: {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        operation: 'portfolio',
                        portfolioId: '@portfolioId'
                    },
                    cache: cache
                },
                getOwnById: {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        operation: 'portfolio',
                        dest: 'GetWithDetail',
                        portfolioId: '@portfolioId'
                    },
                    cache: false
                }
            });
        }]).factory('assetsApi', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                // appSettingsSvc.NONCACHE

                var cache = CacheFactory.get('ValuationsAssets');
                return $resource(appSettingsSvc.CACHE + '/assetmanagement', {}, {
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: true,
                        cache: cache
                    }
                });
            }
        ]).factory('opportPropertyId', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/:operation?Propertyid=:Propertyid&Language=:Language', {}, {
                    propertyById: {
                        method: 'GET',
                        params: {
                            operation: 'portfolio',
                            Propertyid: '@PropertyId',
                            Language: '@Language'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ]).factory('s3Files', ['$resource', 'appSettingsSvc', function ($resource, appSettingsSvc) {
            return {
                uploadImg: function () {
                    return $resource(appSettingsSvc.NONCACHE + '/:operation', {}, {
                        query: {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'imageupload',
                                FileName: '@fileName',
                                Path: '@stringPath',
                                ImageBase64: '@imageBase64'
                            },
                            isArray: false
                        },
                        queryFile: {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'fileupload',
                                FileName: '@fileName',
                                Path: '@stringPath',
                                ImageBase64: '@imageBase64'
                            },
                            isArray: false
                        },
                        delete: {
                            method: 'DELETE',
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                operation: 'imageupload',
                                url: '@url'
                            },
                            isArray: false
                        }
                    });
                }
            };
        }]).factory('valuationData', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('ValuationsSimple');
                return $resource(appSettingsSvc.NONCACHE + '/:operation?propertyid=:propertyid', {}, {
                    getValuationByPropertyId: {
                        method: 'GET',
                        params: {
                            operation: 'tasinmazsimple',
                            propertyid: '@propertyid'
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: cache,
                        ignoreLoadingBar: true
                    }
                });
            }
        ]).factory('addressValidatorAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/AddressValidator', {}, {
                    post: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ]).factory('complexAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/complexsearchpoint', {}, {
                    get: {
                        cache: true,
                        method: 'GET',
                        isArray: false,
                    }
                });

            }
        ]).factory('addressAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/AdresSorgu/:dest', {}, {
                    getCities: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetCities' }
                    },
                    getCounties: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetCountiesByCityId' }
                    },
                    getDistricts: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetDistrictsByCountyId' }
                    },
                    getStreets: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetStreetsByDistrictId' }
                    },
                    getBuildings: {
                        cache: false,
                        method: 'GET',
                        isArray: true,
                        params: { dest: 'GetBuildingsByStreetId' }
                    }
                });

            }
        ]).factory('priceAPI', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.CACHE + '/RegionalPrice/:dest', {}, {
                    getRegionalPriceRatio: {
                        cache: false,
                        method: 'GET',
                        isArray: false,
                        params: { dest: 'GetRegionalPrice' }
                    },
                    getRegionalPrice: {
                        cache: false,
                        method: 'GET',
                        isArray: false,
                        params: { dest: 'GetRegionalPricebyCoefficients' }
                    },
                });

            }
        ]);
})();

/**
 * @fileoverview This file contains the definition of AngularJS module 'app.newresources' and its factories.
 * The module provides caching functionality using CacheFactory and defines two factories: 'auth_factory' and 'user_factory'.
 * The 'auth_factory' factory provides methods for authentication-related API calls.
 * The 'user_factory' factory provides methods for user-related API calls and utilizes caching.
 */
(function () {
    'use strict';

    angular
        .module('app.newresources', []).run(['CacheFactory', function (CacheFactory) {
            var storageImpl = {
                getItem: function (key) { return localStorage.getItem(key); },
                setItem: function (key, value, storage) {
                    try {
                        return localStorage.setItem(key, value);
                    } catch (err) {
                        const accessToken = localStorage.getItem('accessToken');
                        const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                        const refreshToken = localStorage.getItem('refreshToken');
                        const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                        localStorage.clear();
                        localStorage.setItem('accessToken', accessToken);
                        localStorage.setItem('accessTokenExpires', accessTokenExpires);
                        localStorage.setItem('refreshToken', refreshToken);
                        localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                        window.userStorage.sync();
                        return localStorage.setItem(key, value);
                    }
                },
                removeItem: function (key) { return localStorage.removeItem(key); },
            };
            if (!CacheFactory.get('Products')) {
                CacheFactory('Products', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 48 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogList')) {
                CacheFactory('BlogList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogGet')) {
                CacheFactory('BlogGet', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 24 * 60 * 60 * 1000,
                    // storageImpl: storageImpl,
                    cacheFlushInterval: 24 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('BlogCategory')) {
                CacheFactory('BlogCategory', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 48 * 60 * 60 * 1000,
                    storageImpl: storageImpl,
                    cacheFlushInterval: 48 * 60 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserCache')) {
                CacheFactory('UserCache', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserInfo')) {
                CacheFactory('UserInfo', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('NotificationList')) {
                CacheFactory('NotificationList', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
            if (!CacheFactory.get('UserProducts')) {
                CacheFactory('UserProducts', {
                    deleteOnExpire: 'aggressive',
                    maxAge: 5 * 60 * 1000, storageImpl: storageImpl,
                    cacheFlushInterval: 5 * 60 * 1000
                });
            }
        }])
        .factory('auth_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    login: {
                        method: 'POST',
                        params: { dest: "", root: "auth" },
                        isArray: false
                    },
                    registerandlogin: {
                        method: 'POST',
                        params: { dest: "registerandlogin", root: "auth" },
                        isArray: false
                    },
                    login2fa: {
                        method: 'POST',
                        params: { dest: "login", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    refresh: {
                        method: 'POST',
                        params: { dest: "refreshtoken", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    externallogins: {
                        method: 'GET',
                        params: { dest: "externallogins", root: "auth" },
                        isArray: true,
                        ignoreLoadingBar: true
                    },
                    logout: {
                        method: 'POST',
                        params: { dest: "logout", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    del_info_finger: {
                        method: 'DELETE',
                        params: { root: "authuserfingerprint", dest: "deleteuserfingerprintinfo" },
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_info_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint", dest: "getuserfingerprintinfo" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    set_info_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint", dest: "setuserfingerprintinfo" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    get_finger: {
                        method: 'GET',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    set_finger: {
                        method: 'POST',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    delete_finger: {
                        method: 'DELETE',
                        params: { root: "authuserfingerprint" },
                        isArray: false,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    get_confirm: {
                        method: 'GET',
                        params: { root: "useremailconfirmation" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    set_confirm: {
                        method: 'POST',
                        params: { root: "useremailconfirmation" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    forgot_password: {
                        method: 'POST',
                        params: { dest: "newtoken", root: "userforgotpassword" },
                        isArray: false
                    },
                    change_password: {
                        method: 'POST',
                        params: { dest: "changepassword", root: "userforgotpassword" },
                        isArray: false
                    },
                    verify_token: {
                        method: 'POST',
                        params: { dest: "verifyexternallogin", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    external_login_confirm: {
                        method: 'POST',
                        params: { dest: "IsExternalLoginAdditionalConfirmationRequired", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false,
                        transformResponse: function (response) {
                            return { isRequired: response === "true" };
                        }
                    },
                    sendverificationcode: {
                        method: 'POST',
                        params: { dest: "sendverificationcode", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    verification2fa: {
                        method: 'POST',
                        params: { dest: "verification", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    sendcode: {
                        method: 'POST',
                        params: { dest: "sevc", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    checkuserandverifycode: {
                        method: 'POST',
                        params: { dest: "checkuserandverifycode", root: "auth" },
                        isArray: false,
                        ignoreLoadingBar: false
                    },
                    verify_partner_login: {
                        method: 'POST',
                        params: {
                            root: 'auth',
                            dest: 'VerifyPartnerLogin',
                        },
                        isArray: false
                    },
                    getBankUserDetails: {
                        method: 'GET',
                        params: { root: 'auth', dest: 'GetBankUserDetails', token: '@token' },
                        cache: false,
                        isArray: false,
                        transformResponse: function (response) {
                            let cipherText = JSON.parse(response);
                            return JSON.parse(window.encodeResponse(cipherText));
                        }
                    },
                    emlakjetLogin: {
                        method: 'GET',
                        params: { root: 'auth', dest: 'EmlakjetLogin' },
                        cache: false,
                        isArray: false
                    },
                    emlakjetCallback: {
                        method: 'POST',
                        params: { root: 'auth', dest: 'emlakjetcallback' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ])
        .factory('oauth_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/oauth/:root/:dest', {}, {
                    oauthAuthorize: {
                        method: 'GET',
                        params: { root: 'authorize' },
                        cache: false,
                        isArray: false
                    },
                    oauthApprove: {
                        method: 'POST',
                        params: { root: 'authorize', dest: 'approve' },
                        cache: false,
                        isArray: false
                    },
                    oauthDeny: {
                        method: 'POST',
                        params: { root: 'authorize', dest: 'deny' },
                        cache: false,
                        isArray: false
                    },
                    checkConsent: {
                        method: 'GET',
                        params: { root: 'authorize', dest: 'check-consent' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ])
        .factory('captcha_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/ImageCaptcha', {}, {
                    getCaptcha: {
                        method: 'GET',
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    validateCaptcha: {
                        method: 'POST',
                        isArray: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('user_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var UserCache = CacheFactory.get('UserCache');

                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    eids_confirm: {
                        method: 'POST',
                        params: { root: "users", dest: "eids" },
                        isArray: false,
                    },
                    eids_check: {
                        method: 'GET',
                        params: { root: "users", dest: "EidsStatus" },
                        isArray: false,
                        cache: false
                    },
                    eids_property_check: {
                        method: 'POST',
                        params: { root: "users", dest: "EidsPropertyVerification" },
                        isArray: false,
                        cache: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "users" },
                        isArray: false,
                        cache: false
                    },
                    create: {
                        method: 'POST',
                        params: { root: "users" },
                        isArray: false
                    },
                    create_external: {
                        method: 'POST',
                        params: { root: "users", dest: "createuserfromexternal" },
                        isArray: false
                    },
                    update: {
                        method: 'PUT',
                        params: { root: "users" },
                        isArray: false
                    },
                    update_byid: {
                        method: 'PUT',
                        params: { root: "users", dest: "updateuserbyid" },
                        isArray: false
                    },
                    update_phone: {
                        method: 'POST',
                        params: { root: "verification", dest: "sevc" },
                        isArray: false,
                    },
                    verify_phone: {
                        method: 'POST',
                        params: { root: "verification", dest: "validatecode" },
                        isArray: false,
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "users" },
                        isArray: false
                    },
                    delete_byid: {
                        method: 'DELETE',
                        params: { root: "users", dest: "deleteuserbyid" },
                        isArray: false
                    },
                    me: {
                        method: 'GET',
                        params: { root: "users", dest: "me" },
                        isArray: false,
                        cache: UserCache,
                        ignoreLoadingBar: true,
                        timeout: 3000
                    },
                    search: {
                        method: 'POST',
                        params: { root: "users", dest: "search" },
                        isArray: false
                    },
                    any: {
                        method: 'GET',
                        params: { root: "users", dest: "anyuser" },
                        isArray: false,
                        cache: false
                    },
                    update_role: {
                        method: 'POST',
                        params: { root: "users", dest: "updateuserrole" },
                        isArray: false
                    },
                    create_api: {
                        method: 'POST',
                        params: { root: "users", dest: "createapitoken" },
                        isArray: false
                    },
                    update_api: {
                        method: 'POST',
                        params: { root: "users", dest: "updateapitoken" },
                        isArray: false
                    },
                    delete_api: {
                        method: 'POST',
                        params: { root: "users", dest: "deleteapitoken" },
                        isArray: false
                    },
                    change_password: {
                        method: 'POST',
                        params: { root: "users", dest: "changepassword" },
                        isArray: false
                    },
                    unblock: {
                        method: 'GET',
                        params: { root: "users", dest: "unblock" },
                        isArray: false,
                        cache: false
                    },
                    send_unblock_mail: {
                        method: 'POST',
                        params: { root: "users", dest: "sendunblockemail" },
                        isArray: false
                    },
                    last_logins: {
                        method: 'GET',
                        params: { root: "users", dest: "lastlogins" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    user_last_logins: {
                        method: 'GET',
                        params: { root: "users", dest: "userlastlogins" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_address: {
                        method: 'POST',
                        params: { root: "useraddresses" },
                        isArray: false
                    },
                    get_user_address: {
                        method: 'GET',
                        params: { root: "useraddresses", dest: "byuser" },
                        isArray: true,
                        cache: false
                    },
                    list_address: {
                        method: 'GET',
                        params: { root: "useraddresses", dest: "list" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    set_address: {
                        method: 'POST',
                        params: { root: "useraddresses", dest: "" },
                        isArray: false
                    },
                    set_address_external: {
                        method: 'POST',
                        params: { root: "useraddresses", dest: "createaddressfromexternal" },
                        isArray: false
                    },
                    del_address: {
                        params: { root: "useraddresses" },
                        method: 'DELETE'
                    },
                    upload_avatar: {
                        method: 'POST',
                        params: { dest: "", root: "useravatarupload" },
                        isArray: false
                    },
                    upload_certificate: {
                        method: 'POST',
                        params: { dest: "", root: "usercertificateupload" },
                        isArray: false
                    },
                    upload_certificate_by_userid: {
                        method: 'POST',
                        params: { dest: "adminpost", root: "usercertificateupload" },
                        isArray: false
                    },
                    submit_certificates: {
                        method: 'POST',
                        params: { dest: "addcertificates", root: "users" },
                        isArray: false
                    },
                    submit_certificates_by_userid: {
                        method: 'POST',
                        params: { dest: "addcertificatesbyuserid", root: "users" },
                        isArray: false
                    },
                    list_certificates: {
                        method: 'GET',
                        params: { dest: "getcertificatesbyuserid", root: "users" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    delete_certificate: {
                        method: 'DELETE',
                        params: { dest: "deletecertificate", root: "users" },
                        isArray: false
                    },
                    delete_certificate_by_userid: {
                        method: 'DELETE',
                        params: { dest: "deletecertificatebyuserid", root: "users" },
                        isArray: false
                    },
                    upload_logo: {
                        method: 'POST',
                        params: { dest: "", root: "userofficelogoupload" },
                        isArray: false
                    },
                    get_all_notes: {
                        method: 'POST',
                        params: { root: "usernotes", dest: "list" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get_notes: {
                        method: 'GET',
                        params: { root: "usernotes" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    update_notes: {
                        method: 'PUT',
                        params: { root: "usernotes" },
                        isArray: false
                    },
                    set_notes: {
                        method: 'POST',
                        params: { root: "usernotes" },
                        isArray: false
                    },
                    del_notes: {
                        params: { root: "usernotes" },
                        method: 'DELETE'
                    },
                    get_products: {
                        method: 'GET',
                        params: { root: "userproducts" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    get_product: {
                        method: 'GET',
                        params: { dest: "details", root: "userproducts" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    listing_profiles: {
                        method: 'GET',
                        params: { root: "users", dest: "listingprofiles" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    add_profile: {
                        method: 'POST',
                        params: { root: "users", dest: "addlistingprofile" },
                        isArray: false,
                        cache: false
                    },
                    delete_profile: {
                        method: 'DELETE',
                        params: { root: "users", dest: "deletelistingprofile" },
                        isArray: false,
                        cache: false
                    },
                    password_status: {
                        method: 'GET',
                        params: { root: "users", dest: "getpasswordexpiredstatus" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    language: {
                        method: 'PUT',
                        params: { root: "users", dest: "language" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    currency: {
                        method: 'PUT',
                        params: { root: "users", dest: "currency" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    sendTempPassword: {
                        method: 'PUT',
                        params: { root: "users", dest: "settemppassword" },
                        hasBody: false,
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    getPhoneData: {
                        method: 'GET',
                        params: { root: "users", dest: "getuserphoneshowntrends" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    refreshClientId: {
                        method: 'PUT',
                        params: { root: "users", dest: "GoogleClientId" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    getConsInfo: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "getconsultancyuserinfo" }
                    },
                    getForOpp: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "GetUserForOpportunityDetails" }
                    },
                    getRegion: {
                        method: 'GET',
                        isArray: false,
                        params: { root: "users", dest: "GetUserRegionPreference" },
                        ignoreLoadingBar: true
                    },
                    updateRegion: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateRegionPreference" },
                        ignoreLoadingBar: true
                    },
                    getUsersBySameIp: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getUsersBySameIp" },
                        ignoreLoadingBar: true
                    },
                    updateUserPermission: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateuserpermission" },
                        cache: false
                    },
                    updateProfileVisibility: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateprofilevisibility"},
                        cache: false
                    },
                    updateUserProfileInfo: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateuserprofileinfo"},
                        cache: false
                    },
                    updateUserDetail: {
                        method: 'PUT',
                        isArray: false,
                        params: {root: "users", dest: "updateuserprofiledetail"},
                        cache: false
                    },
                    searchForTerminal: {
                        method: 'POST',
                        isArray: false,
                        params: { root: "users", dest: "searchterminaluser" },
                        cache: false,
                        interceptor: {
                            response: function (response) {
                                var result = response.resource;
                                result.$status = response.status;
                                return result;
                            }
                        }
                    },
                    addOrUpdateTerminalUser: {
                        method: 'POST',
                        isArray: false,
                        params: { root: "users", dest: "AddOrUpdateTerminalUser" },
                        cache: false
                    },
                    GetMyTerminalUsers: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getmyterminalusers" },
                        cache: false
                    },
                    GetTerminalUsersByOrderId: {
                        method: 'GET',
                        isArray: true,
                        params: { root: "users", dest: "getterminalusersbyorderid" },
                        cache: false
                    },
                    deleteTerminalUser: {
                        method: 'DELETE',
                        isArray: false,
                        params: { root: "users", dest: "deleteterminaluser" },
                        cache: false
                    },
                    updateUserPermissionByUserId: {
                        method: 'PUT',
                        isArray: false,
                        params: { root: "users", dest: "updateuserpermissionbyuserid" },
                        cache: false
                    },
                });
            }
        ])
        .factory('feature_access_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    getListByAdmin: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses", dest: "list" },
                        isArray: false,
                    },
                    getByAdmin: {
                        method: 'GET',
                        params: { root: "userfeatureaccesses", dest: "getuserfeatureaccessesbyuserid" },
                        isArray: true,
                    },
                    updateByAdmin: {
                        method: 'PUT',
                        params: { root: "userfeatureaccesses", dest: "updatebyinternalusers" },
                        isArray: false,
                    },
                    createByAdmin: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses", dest: "createexternalfeatureaccess" },
                        isArray: false,
                    },
                    post: {
                        method: 'POST',
                        params: { root: "userfeatureaccesses" },
                        isArray: false,
                    },
                });
            }
        ])
        .factory('comment_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    create: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "post" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "usercomments", dest: "getcomment" },
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "list" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    like: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "like" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    feedback: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "feedback" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "usercomments", dest: "delete" },
                        isArray: false
                    },
                    admin_list: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "adminlist" },
                        isArray: false
                    },
                    status: {
                        method: 'POST',
                        params: { root: "usercomments", dest: "statusupdate" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('blog_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('BlogList');
                var cache2 = CacheFactory.get('BlogGet');
                var cache3 = CacheFactory.get('BlogCategory');
                return $resource(appSettingsSvc.NEW + '/blog/:dest/:root', {}, {
                    post: {
                        method: 'POST',
                        params: { dest: "" },
                        isArray: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: { dest: "" },
                        isArray: false
                    },
                    list: {
                        method: 'GET',
                        params: { dest: "listv2" },
                        isArray: false,
                        cancellable: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        params: { dest: "detailv2" },
                        isArray: false,
                        cache: cache2,
                        ignoreLoadingBar: true
                    },
                    category_list: {
                        method: 'GET',
                        params: { dest: "category", root: "listv2" },
                        isArray: false,
                        cache: cache3,
                        ignoreLoadingBar: true
                    },
                    category_post: {
                        method: 'POST',
                        params: { dest: "category" },
                        isArray: false
                    },
                    category_delete: {
                        method: 'DELETE',
                        params: { dest: "category" },
                        isArray: false
                    },
                    related: {
                        method: 'GET',
                        params: { dest: "relatedpostsv2" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    check_url: {
                        method: 'GET',
                        params: { dest: "checkslugavailability" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    },
                    // latest: {
                    //     method: 'GET',
                    //     params: { dest: "latestpostsv2" },
                    //     isArray: false,
                    //     cancellable: true
                    // },
                    random: {
                        method: 'GET',
                        params: { dest: "randompostsv2" },
                        isArray: false,
                        cancellable: true,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('translate_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {

                return $resource(appSettingsSvc.NEW + '/translate', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('mortgage_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/mortgage/:dest', {}, {
                    get: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "approve" }
                    },
                    post: {
                        method: 'POST',
                        isArray: false
                    },
                    put: {
                        method: 'PUT',
                        isArray: false
                    }
                });
            }
        ])
        .factory('akbank_mortgage_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/AkbankMortgage', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('bank_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    generateBankForm: {
                        method: 'POST',
                        params: { root: 'bank', dest: 'generatebankform' },
                        isArray: false
                    }
                });
            }
        ])
        .factory('userview_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/userviewing/:dest', {}, {
                    post: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "phoneviewing" },
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "phoneviewingcounts" },
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('consultancy_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/consultancy/:dest', {}, {
                    post: {
                        method: 'POST',
                        isArray: false
                    },
                    update: {
                        method: 'PUT',
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "list" },
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        cache: false
                    },
                    changeStatus: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "changestatus" }
                    },
                    changeNote: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "updateconsultancydescription" }
                    },
                    setAgent: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setagent" }
                    },
                    deleteTransaction: {
                        method: 'DElETE',
                        isArray: false,
                        params: { dest: "transaction" }
                    },
                    addTransaction: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "transaction" }
                    },
                    redirectAgents: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "assignconsultancytoagents" }
                    },
                    detailForAgent: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getconsultancydetailsforagent" },
                        cache: false
                    },
                    myAllLeads: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getallmyassignments" },
                        cache: false
                    },
                    closeConsultancy: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancystatusclosed" }
                    },
                    consultancyStatusContacted: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancystatuscontacted" }
                    },
                    consultancyStatusAcquired: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setstatussalesauthorityacquired" }
                    },
                    createLead: {
                        method: 'POST',
                        isArray: false
                    },
                    setHasContract: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setconsultancycontract" }
                    },
                    getConsultancyByAgentAndOwner: {
                        method: 'GET',
                        isArray: false,
                        params: { dest: "getconsultancyidsbyagentidandownerinfo", agentId: '@agentId', fingerPrint: '@fingerPrint' }
                    },
                });
            }
        ])
        .factory('segmentation_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    list: {
                        method: 'POST',
                        params: { root: "agents", dest: "list" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    changeStatus: {
                        method: 'POST',
                        params: { root: "agents", dest: "agentstatusupdate" },
                        isArray: false,
                        cache: false
                    },
                    assignSeller: {
                        method: 'POST',
                        params: { root: "agents", dest: "assignsellerforagent" },
                        isArray: false,
                        cache: false
                    },
                    detail: {
                        method: 'GET',
                        params: { root: "agents", dest: "getagentdetail" },
                        isArray: false,
                        cache: false
                    },
                    deleteNote: {
                        method: 'DELETE',
                        params: { root: "agentnotes" },
                        isArray: false,
                        cache: false
                    },
                    addNote: {
                        method: 'POST',
                        params: { root: "agentnotes" },
                        isArray: false,
                        cache: false
                    },
                    listNote: {
                        method: 'POST',
                        params: { root: "agentnotes", dest: "list" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('cards_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/cards/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "list" },
                        isArray: true,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    get: {
                        method: 'GET',
                        params: { dest: "" },
                        isArray: true,
                        cache: false
                    },
                    bin: {
                        method: 'POST',
                        params: { dest: "binsearch" },
                        isArray: false
                    },
                    remove: {
                        method: 'DELETE',
                        isArray: false
                    },
                    new: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "" }
                    },
                    setAsDefault: {
                        method: 'PUT',
                        isArray: false,
                        params: { dest: "setasdefault" }
                    },
                });
            }
        ])
        .factory('company_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/company/:dest', {}, {
                    get: {
                        method: 'GET',
                        cache: false
                    },
                    update: {
                        method: 'POST',
                        isArray: false
                    },
                    relate: {
                        method: 'POST',
                        params: { dest: "relatewithuser" },
                        isArray: false
                    },
                    break_relate: {
                        method: 'POST',
                        params: { dest: "breakuserrelationship" },
                        isArray: false
                    },
                    list: {
                        method: 'POST',
                        isArray: false,
                        params: { dest: "list" },
                        ignoreLoadingBar: true
                    },
                    delete: {
                        method: 'DELETE',
                        isArray: false,
                    }
                });
            }
        ])
        .factory('orders_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var UserProducts = CacheFactory.get('UserProducts');
                return $resource(appSettingsSvc.NEW + '/:root/:dest', {}, {
                    post: {
                        method: 'POST',
                        params: { root: "orders" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "orders" },
                        isArray: false,
                        cache: false
                    },
                    list: {
                        method: 'POST',
                        params: { root: "orders", dest: "list" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    my: {
                        method: 'GET',
                        params: { root: "orders", dest: "my" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    complete: {
                        method: 'POST',
                        params: { root: "orders", dest: "complete" },
                        isArray: false
                    },
                    freeze: {
                        method: 'POST',
                        params: { root: "orders", dest: "freeze" },
                        isArray: false
                    },
                    changedate: {
                        method: 'POST',
                        params: { root: "orders", dest: "changepaymentduedate" },
                        isArray: false
                    },
                    fast: {
                        method: 'POST',
                        params: { root: "fastorder" },
                        isArray: false
                    },
                    calculate: {
                        method: 'POST',
                        params: { root: "orderpricecalculator" },
                        isArray: false,
                        ignoreLoadingBar: true
                    },
                    cancel: {
                        method: 'POST',
                        params: { root: "orders", dest: "cancel" },
                        isArray: false
                    },
                    user_subscriptions: {
                        method: 'GET',
                        params: { root: "subscriptions" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    subscriptions: {
                        method: 'GET',
                        params: { root: "subscriptions", dest: "my" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    },
                    subscriptionCancel: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "cancel" },
                        isArray: false
                    },
                    subscriptionCancelByAdmin: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "cancelbyadmin" },
                        isArray: false
                    },
                    subscriptionRenewError: {
                        method: 'GET',
                        params: { root: "subscriptions", dest: "getlastrenewerrorlog" },
                        isArray: false,
                        cache: false
                    },
                    subscriptionRepay: {
                        method: 'POST',
                        params: { root: "subscriptions", dest: "retrytogetpaid" },
                        isArray: false
                    },
                    orderContract: {
                        method: 'POST',
                        params: { root: "orders", dest: "setordercontract" },
                        isArray: false
                    },
                    openForPayment: {
                        method: 'POST',
                        params: { root: "orders", dest: "openforpayment" },
                        isArray: false
                    },
                    backDown: {
                        method: 'POST',
                        params: { root: "orders", dest: "backdown" },
                        isArray: false
                    },
                    addOrUpdateTags: {
                        method: 'POST',
                        params: { root: "orders", dest: "addorupdateordertags" },
                        isArray: false
                    },
                    schedule: {
                        method: 'PUT',
                        params: { root: "orders", dest: "rescheduleinstallmentdate" },
                        isArray: false
                    },
                    scheduleAll: {
                        method: 'PUT',
                        params: { root: "orders", dest: "rescheduleallinstallmentdates" },
                        isArray: false
                    },
                    getRelateds: {
                        method: 'GET',
                        params: { root: "orders", dest: "getrelatedorderssummary" },
                        isArray: true,
                        cache: false
                    },
                    getContract: {
                        method: 'GET',
                        params: { root: "orders", dest: "getordercontract" },
                        isArray: false,
                        cache: false
                    },
                    getMyContract: {
                        method: 'GET',
                        params: { root: "orders", dest: "getmyordercontract" },
                        isArray: false,
                        cache: false
                    },
                    setPaymentCouldNotBeReceived: {
                        method: 'POST',
                        params: { root: "orders", dest: "setorderstatuspaymentcouldnotbereceived" },
                        isArray: false,
                        cache: false
                    },
                    transferToIvr: {
                        method: 'POST',
                        params: { root: "orders", dest: "transferordertoivr" },
                        isArray: false,
                        cache: false
                    },
                    updateInvoice: {
                        method: 'POST',
                        params: { root: "orders", dest: "invoiceStatusUpdate" },
                        isArray: false,
                        cache: false
                    },
                    updateSeller: {
                        method: 'PUT',
                        params: { root: "orders", dest: "changeselleridfororder" },
                        isArray: false,
                        cache: false
                    },
                    setIWalletAmount: {
                        method: 'PUT',
                        params: { root: "orders", dest: "setiwalletamountfororder" },
                        isArray: false,
                        cache: false
                    },
                    updateBillingInformation: {
                        method: 'PUT',
                        params: { root: "orders", dest: "updateorderbillinginformation" },
                        isArray: false,
                        cache: false
                    },
                    myProducts: {
                        method: 'GET',
                        params: { root: "userProducts", dest: "my" },
                        isArray: false,
                        cache: UserProducts,
                        ignoreLoadingBar: true
                    },
                });
            }
        ])
        .factory('order_tags_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/:root', {}, {
                    post: {
                        method: 'POST',
                        params: { root: "tags" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        params: { root: "tags" },
                        isArray: true,
                        cache: false
                    },
                    delete: {
                        method: 'DELETE',
                        params: { root: "tags" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('history_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.HISTORY + '/userhistories', {}, {
                    set: {
                        method: 'POST',
                        isArray: false
                    }
                });
            }
        ])
        .factory('history_factory_v3', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/userhistories', {}, {
                    get: {
                        method: 'GET',
                        isArray: true,
                        cache: false
                    }
                });
            }
        ])
        .factory('administrators_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/administrators/:dest', {}, {
                    list: {
                        method: 'POST',
                        params: { dest: "getcampaignlist" },
                        isArray: false
                    },
                    detail: {
                        method: 'POST',
                        params: { dest: "getcampaigndetail" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('payment_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/payment/:dest', {}, {
                    refund: {
                        method: 'POST',
                        params: { dest: "refund" },
                        isArray: false
                    },
                    self: {
                        method: 'POST',
                        params: { dest: "payitself" },
                        isArray: false
                    },
                    team: {
                        method: 'POST',
                        params: { dest: "paybysalesteam" },
                        isArray: false
                    },
                    payWithCard: {
                        method: 'POST',
                        params: { dest: "paywithsavedcard" },
                        isArray: false
                    },
                    allowPayItSelf: {
                        method: 'POST',
                        params: { dest: "AllowPayItSelfForPaymentCouldNotBeReceivedOrder" },
                        isArray: false
                    },
                    payWithPartner: {
                        method: 'POST',
                        params: { dest: "PayWithPartner" },
                        isArray: false
                    },
                    transactions: {
                        method: 'POST',
                        params: { dest: "paymenttransactions" },
                        isArray: false
                    }
                });
            }
        ])
        .factory('notification_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var NotificationList = CacheFactory.get('NotificationList');
                return $resource(appSettingsSvc.NEW + '/usernotification/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "getnotifications" },
                        isArray: false,
                        cache: NotificationList,
                        ignoreLoadingBar: true
                    },
                    read: {
                        method: 'POST',
                        params: { dest: "notificationreadstatus" },
                        isArray: false
                    },
                    readAll: {
                        method: 'GET',
                        params: { dest: "notificationreadstatusforall" },
                        isArray: false
                    }
                });
            }
        ])

        .factory('user_info', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {
                var UserInfo = CacheFactory.get('UserInfo');

                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    get: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "userinfo" },
                        isArray: false,
                        cancellable: true,
                        cache: UserInfo
                    },
                    checkName: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "User" },
                        isArray: false,
                        cache: false
                    }
                });
            }
        ])
        .factory('user_check', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:root/:dest', {}, {
                    checkName: {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { root: "User", dest: "CheckName" },
                        isArray: false,
                        cache: false,
                        ignoreLoadingBar: true
                    }
                });
            }
        ])
        .factory('lead_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NONCACHE + '/:dest', {}, {
                    list: {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        params: { dest: "comparablelist" },
                        isArray: false,
                        cancellable: true
                    }
                });
            }
        ])
        .factory('products_factory', [
            '$resource', 'appSettingsSvc', 'CacheFactory',
            function ($resource, appSettingsSvc, CacheFactory) {

                var cache = CacheFactory.get('Products');
                var cacheProductsForFilter = CacheFactory.get('Productsforfilter');
                return $resource(appSettingsSvc.NEW + '/products/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "" },
                        isArray: true,
                        cache: cache,
                        ignoreLoadingBar: true
                    },
                    listForFilter: {
                        method: 'GET',
                        params: { dest: "listingproducts" },
                        isArray: true,
                        cache: cacheProductsForFilter,
                        ignoreLoadingBar: true
                    }
                });

            }
        ])
        .factory('promo_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/promo/:dest', {}, {
                    list: {
                        method: 'GET',
                        params: { dest: "list" },
                        isArray: false,
                        cache: false
                    },
                    create: {
                        method: 'POST',
                        params: { dest: "" },
                        isArray: false
                    },
                    get: {
                        method: 'GET',
                        isArray: false,
                        cache: false
                    },
                    delete: {
                        method: 'DELETE'
                    },
                    validate: {
                        method: 'POST',
                        params: { dest: "checkpromocodeusability" },
                        isArray: false
                    }

                });
            }
        ]).factory('logo_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/erp/:dest', {}, {
                    get: {
                        method: 'POST',
                        params: { orderId: '@orderId' },
                        cache: false
                    },
                    sendInvoiceEmail: {
                        method: 'POST',
                        params: { dest: 'SendOrderInvoiceEmail', orderId: '@orderId' },
                        cache: false
                    }
                });
            }
        ]).factory('zoho_factory', [
            '$resource', 'appSettingsSvc',
            function ($resource, appSettingsSvc) {
                return $resource(appSettingsSvc.NEW + '/orderzoho/:dest', {}, {
                    getDeals: {
                        method: 'GET',
                        params: { dest: 'getdealsbyuserid' },
                        cache: false,
                        isArray: false
                    },
                    matchDeal: {
                        method: 'GET',
                        params: { dest: 'matchorderwithdealid' },
                        cache: false,
                        isArray: false
                    }
                });
            }
        ]);
})();

/**
 * @fileoverview This file contains the definition of the 'LocaleService' service, which is responsible for managing the application's locale settings.
 * @module app.locale
 */

/**
 * @namespace app.locale
 */

/**
 * @typedef {Object} LocaleService
 * @property {function(): string} getLocaleDisplayName - Retrieves the display name of the current locale.
 * @property {function(localeDisplayName: string): Promise} setLocaleByDisplayName - Sets the locale based on its display name.
 * @property {function(): string[]} getLocalesDisplayNames - Retrieves an array of all available locale display names.
 */

/**
 * @function
 * @name LocaleService
 * @description AngularJS service that handles the application's locale settings.
 * @param {Object} $translate - AngularJS translation service.
 * @param {Object} LOCALES - Object containing locale information.
 * @param {Object} $rootScope - AngularJS root scope object.
 * @param {Object} tmhDynamicLocale - AngularJS dynamic locale service.
 * @param {Object} $http - AngularJS HTTP service.
 * @param {Object} $window - AngularJS window service.
 * @param {Object} $q - AngularJS promise service.
 * @returns {LocaleService} The LocaleService object.
 */
(function () {
    'use strict';
    angular.module('app.locale', [])
        .service('LocaleService', ['$translate', 'LOCALES', '$rootScope', 'tmhDynamicLocale', '$http', '$window', '$q', function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $http, $window, $q) {
            // PREPARING LOCALES INFO
            var localesObj = LOCALES.locales;

            // locales and locales display names
            var _LOCALES = Object.keys(localesObj);
            if (!_LOCALES || _LOCALES.length === 0) {
                console.error('There are no _LOCALES provided');
            }
            var _LOCALES_DISPLAY_NAMES = [];
            _LOCALES.forEach(function (locale) {
                _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
            });


            // METHODS
            var checkLocaleIsValid = function (locale) {
                return _LOCALES.indexOf(locale) !== -1;
            };

            var setLocale = function (locale) {
                var deferred = $q.defer();
                if (!checkLocaleIsValid(locale)) {
                    console.error('Locale name "' + locale + '" is invalid');
                    deferred.reject();
                    return;
                }

                $rootScope.lang = locale;
                $window.lang = locale;
                $window.wootricSettings = {
                    account_token: "NPS-66c1ee71",
                    language: window.lang.split('-')[0].toUpperCase()
                };
                 $window.ybug_settings.language_override = locale.split('-')[0];
                 $window.ybug_settings.translations = {
                    "tr": {
                        "feedbackForm.Types.1": "Hata",
                        "feedbackForm.Types.2": "Geliştirme",
                        "feedbackForm.Types.3": "Soru",
                        "feedbackForm.Types.4": "Geri Bildirim",
                    } 
                 }
                document.tidioChatLang = locale === 'pt-PT' ? 'pt' : locale === 'es-ES' ? 'es' : locale;
                try {
                    $window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', locale);
                    $window.localStorage.setItem('Language', locale);
                } catch (err) {
                    //ignored
                }
                $http.defaults.headers.common["Accept-Language"] = locale;
                document.cookie = 'langcode=' + locale;

                // asking angular-translate to load and apply proper translations

                $translate.use(locale).then(function () {
                    $translate.refresh();
                    deferred.resolve();
                });
                return deferred.promise;
            };

            // EVENTS
            // on successful applying translations by angular-translate
            $rootScope.$on('$translateChangeSuccess', function (event, data) {
                document.documentElement.setAttribute('lang', data.language.toLowerCase().replace(/_/g, '-')); // sets "lang" attribute to html
                moment.locale(data.language.toLowerCase().replace(/_/g, '-'));
                // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
                tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
            });

            return {
                getLocaleDisplayName: function () {
                    var currentLocale = "tr";
                    try {
                        currentLocale = $window.localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                    } catch (err) {
                        //ignored
                    }
                    return localesObj[currentLocale];
                },
                setLocaleByDisplayName: function (localeDisplayName) {
                    return setLocale(
                        _LOCALES[
                        _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
                        ]
                    );
                },
                getLocalesDisplayNames: function () {
                    return _LOCALES_DISPLAY_NAMES;
                }
            };
        }]);
})();
(function () {
    'use strict';

    var shell = angular.module('app.shell', ['ui.router.metatags']);

    shell.run(['externalAuthSvc', 'appStatusSvc', 'restoreUserSvc', 'ngDialog', '$timeout', 'userSvc', '$rootScope', '$window', '$translate', '$state', 'userview_factory', 'endeksService', 'bolgeselDataService', '$ocLazyLoad', '$http', 'appSettingsSvc', '$transitions', '$interval', 'valuationGETAPI', 'alertAPI', 'notificationService', 'auth_factory', 'user_factory', 'CacheFactory', 'notifierSvc', 'comparablesApi', '$cookies',
        'orders_factory', 'mcpService',
        function (externalAuthSvc, appStatusSvc, restoreUserSvc, ngDialog, $timeout, userSvc, $rootScope, $window, $translate, $state, userview_factory, endeksService, bolgeselDataService, $ocLazyLoad, $http, appSettingsSvc, $transitions, $interval, valuationGETAPI, alertAPI, notificationService, auth_factory, user_factory, CacheFactory, notifierSvc, comparablesApi, $cookies, orders_factory, mcpService) {

            // Save HangiKredi campaign to rootScope flag
            if (sessionStorage.getItem('utm_campaign_hangi_kredi') === 'HangiKrediEndeksa50') {
                $rootScope.isHangiKrediCampaign = true;
            }

            externalAuthSvc.handleAuthResponse().then(
                function () {
                    return appStatusSvc.isReady(true);
                },
                function () {
                    restoreUserSvc.restore()['finally'](
                        function () {
                            return appStatusSvc.isReady(true);
                        });
                });

            $rootScope.SignedIn = userSvc.info.SignedIn;

            // Check if this is an MCP OAuth request and save parameters
            if (mcpService.checkMcpFromResourceUrl()) {
                // Initialize and save OAuth params to session storage
                mcpService.initializeOAuthParams();
            }

            // Initialize upcomingPayment object and manage cookie
            $rootScope.upcomingPayment = null;

            // Function to update body class based on payment warning visibility
            function updateBodyClass() {
                $timeout(function () {
                    var showWarning = $rootScope.upcomingPayment &&
                        $rootScope.upcomingPayment.unpaidPrice > 0 &&
                        $rootScope.upcomingPayment.paymentDaysRemaining <= $rootScope.upcomingPayment.paymentBarTreshold &&
                        !$rootScope.upcomingPayment.closedByUser;

                    if (showWarning) {
                        document.body.classList.add('has-payment-warning');
                    } else {
                        document.body.classList.remove('has-payment-warning');
                    }
                }, 100);
            }

            // Function to get upcomingPayment from cookie
            function getUpcomingPaymentFromCookie() {
                var cookieData = $cookies.get('upcomingPayment');

                if (cookieData) {
                    try {
                        $rootScope.upcomingPayment = JSON.parse(cookieData);
                        updateBodyClass();
                    } catch (e) {
                        console.warn('Error parsing upcomingPayment cookie:', e);
                        $rootScope.upcomingPayment = null;
                    }
                } else {
                    orders_factory.my().$promise.then(function (response) {
                        // Filter orders that meet specified conditions
                        if (response && response.orders) {
                            var filteredOrder = response.orders.find(function (order) {
                                // Check order level conditions
                                var orderConditions = order.completedPayment === false &&
                                    order.orderCancellationReason === null &&
                                    order.hasContract === true &&
                                    [50, 80].indexOf(order.status) !== -1 &&
                                    (order.installmentType !== 20 || order.amountPaid > 0);

                                // Check if order has the specific product type
                                var hasTargetProduct = order.products && order.products.some(function (product) {
                                    return product.isPackageProduct === false && product.productType === 20;
                                });

                                return orderConditions && hasTargetProduct;
                            });

                            if (filteredOrder) {
                                $rootScope.upcomingPayment = {
                                    paymentOrderId: filteredOrder.orderId,
                                    paymentDate: null,
                                    unpaidPrice: null,
                                    product: null,
                                    paymentDaysRemaining: null,
                                    closedByUser: false,
                                    notificationIsRead: false,
                                    notificationCreatedDate: new Date().toISOString(),
                                    paymentBarTreshold: 3,
                                    notificationTreshold: 7
                                };
                                // Determine which date to use based on installmentType
                                if (filteredOrder.installmentType === 20) {
                                    // Taksitli ödeme - isPayed false olan ilk taksiti bul
                                    var unpaidInstallment = null;
                                    if (filteredOrder.installments && filteredOrder.installments.length > 0) {
                                        unpaidInstallment = filteredOrder.installments.find(function (installment) {
                                            return installment.isPayed === false;
                                        });
                                    }

                                    if (unpaidInstallment) {
                                        $rootScope.upcomingPayment.paymentDate = unpaidInstallment.paymentDate;
                                        $rootScope.upcomingPayment.unpaidPrice = unpaidInstallment.price;
                                    } else {
                                        $rootScope.upcomingPayment.paymentDate = filteredOrder.paymentDueDate;
                                        $rootScope.upcomingPayment.unpaidPrice = 0;
                                    }
                                } else {
                                    // Cash payment – use the due date.
                                    $rootScope.upcomingPayment.paymentDate = filteredOrder.paymentDueDate;
                                    $rootScope.upcomingPayment.unpaidPrice = (filteredOrder.orderPrice - filteredOrder.amountPaid);
                                }

                                // Get product details
                                if (filteredOrder.products && filteredOrder.products.length > 0) {
                                    var pendingPaymentProduct = filteredOrder.products.find(function (product) {
                                        return product.isPackageProduct === false && product.productType === 20;
                                    });

                                    if (pendingPaymentProduct) {
                                        $rootScope.upcomingPayment.product = pendingPaymentProduct;
                                    }
                                }

                                // Calculate remaining days until target date
                                if ($rootScope.upcomingPayment.unpaidPrice && $rootScope.upcomingPayment.product) {
                                    var today = moment().startOf('day');
                                    // Parse database date as UTC and convert to user's local timezone
                                    var dueDateLocal = moment.utc($rootScope.upcomingPayment.paymentDate).local();
                                    var dueDate = dueDateLocal.startOf('day');
                                    // Calculate difference in days
                                    var daysDifference = dueDate.diff(today, 'days');

                                    // Assign to $rootScope
                                    $rootScope.upcomingPayment.paymentDaysRemaining = daysDifference;

                                    $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                                }
                            } else {
                                $rootScope.setUpcomingPaymentToCookie(null);
                            }
                        }
                    }, function (error) {
                        // console.error('Orders verisi alınırken hata oluştu:', error);
                    });
                }
            }

            // Function to set upcomingPayment to cookie
            $rootScope.setUpcomingPaymentToCookie = function (paymentData) {
                var expiryDate = new Date();
                expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000)); // 24 hours
                $cookies.put('upcomingPayment', JSON.stringify(paymentData), { expires: expiryDate });
                $rootScope.upcomingPayment = paymentData;
                updateBodyClass();
            };

            $rootScope.deleteUpcomingPaymentFromCookie = function () {
                $cookies.remove('upcomingPayment');
                $rootScope.upcomingPayment = null;
            };

            // Function to close payment warning and update cookie
            $rootScope.closePaymentWarning = function () {
                $rootScope.upcomingPayment.closedByUser = true;
                $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                updateBodyClass();
            };

            userSvc.getUserInfo(true).then(function (result) {

                if ($rootScope.SignedIn)
                    getUpcomingPaymentFromCookie();
                if (window.location.pathname.indexOf('/account') === -1)
                    if (!window.localStorage.getItem('profile_completion_notifier') && $rootScope.SignedIn && ($rootScope.recommendedFieldsToFill.isAgent ? !$rootScope.recommendedFieldsToFill.isComplete : false)) {
                        $ocLazyLoad.load([
                            "https://cdn.endeksa.com/js/vendor.phone.min.js?v=" + window.appVersion,
                            "https://cdn.endeksa.com/js/vendor.wizard.min.js?v=" + window.appVersion,
                            "https://cdn.endeksa.com/js/vendor.upload.min.js?v=" + window.appVersion,
                            "https://cdn.endeksa.com/css/vendor.summernote.min.css?v=" + window.appVersion,
                            "https://cdn.endeksa.com/js/vendor.summernote.min.js?v=" + window.appVersion,
                        ]).then(function () {
                            ngDialog.open({
                                templateUrl: "app/shell/profile-completion.modal.html",
                                controller: [
                                    "$scope",
                                    "userSvc",
                                    "$timeout",
                                    "notificationService",
                                    function ($scope, userSvc, $timeout) {
                                        $scope.userData = angular.copy(userSvc.info);

                                        $scope.accountFields = [
                                            "isPhoneNumberFilled",
                                            "isPhoneConfirmed",
                                            "isEmailFilled",
                                            "isEmailConfirmed",
                                            "hasAvatar"
                                        ];
                                        $scope.companyFields = [
                                            "isAboutFilled",
                                            "isSloganFilled"
                                        ];

                                        var charLimitAbout = 1500;

                                        $scope.accountComplete = false;
                                        $scope.companyComplete = false;

                                        function updateCompletionStatus() {
                                            $scope.accountComplete = $scope.accountFields.every(
                                                field => $rootScope.recommendedFieldsToFill[field] === true
                                            );

                                            $scope.companyComplete = $scope.companyFields.every(
                                                field => $rootScope.recommendedFieldsToFill[field] === true
                                            );

                                        };

                                        updateCompletionStatus();

                                        $scope.noteLang = window.lang === 'tr' ? 'tr-TR' : window.lang === 'en' ? 'en-US' : window.lang;
                                        $scope.noteOptions = {
                                            height: 300,
                                            focus: false,
                                            airMode: false,
                                            styleWithSpan: false,
                                            enterMode: 'br',
                                            toolbar: [
                                                ['edit', ['undo', 'redo']],
                                                ['style', ['bold', 'italic', 'underline', 'clear']],
                                            ],
                                            callbacks: {
                                                onChange: function (contents, $editable) {
                                                    if (contents.length > charLimitAbout) {
                                                        $scope.aboutErr = true;
                                                    } else {
                                                        $scope.aboutErr = false;
                                                    }
                                                    $($editable).find('p').removeAttr('style');
                                                },
                                                onPaste: function (e) {
                                                    var text = e.originalEvent.clipboardData.getData('text');
                                                    e.preventDefault();
                                                    document.execCommand('insertText', false, text);
                                                },
                                            }
                                        };

                                        $scope.image = {
                                            // src: null, /* { fileType: "image/png"; imageData: "data:image/png;base64,..." } */
                                            src: null,
                                            dst: null /* "data:image/png;base64,..." */
                                        };

                                        $scope.loadImage = function (file) {
                                            var fileReader = new FileReader();
                                            fileReader.readAsDataURL(file);
                                            fileReader.onload = function (e) {
                                                var dataUrl = e.target.result;
                                                $scope.$apply(function () { $scope.image.src = dataUrl; });
                                            };
                                        };

                                        $scope.imgUpdating = false;

                                        $scope.updateMyAvatar = function () {
                                            $scope.imgUpdating = true;
                                            userSvc.updateAvatar($scope.image).then(function (result) {
                                                $scope.userData = result;
                                                $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;
                                            }).finally(function () {
                                                $scope.image.dst = null;
                                                $scope.image.src = null;
                                                $scope.imgUpdating = false;
                                            });
                                        };


                                        $scope.mailValidation = {
                                            valid: true,
                                            registered: false,
                                            changed: false,
                                            waitingOtp: false
                                        };
                                        $scope.phoneValidation = {
                                            valid: true,
                                            registered: false,
                                            changed: false,
                                            waitingOtp: false
                                        };

                                        // Captcha state
                                        $scope.ETToken = null;
                                        $scope.captchaVerified = false;
                                        $scope.isTurkishPhone = true;
                                        $scope.eimageCaptchaKey = null;
                                        $scope.eimageCaptchaValue = null;

                                        $scope.selectedLanguage = window.langCode();
                                        $scope.sourceLang = window.langCode();

                                        $scope.aboutDetails = [];
                                        $scope.selectedLanguage = window.langCode();

                                        $scope.userData.Details.profile.aboutDetails.forEach(element => {
                                            $scope.aboutDetails[element.language] = element;
                                        });

                                        $scope.goProfile = function goProfile() {
                                            ngDialog.close();
                                            $state.go('profile.account', { langcode: window.lang });
                                        };

                                        $scope.updateProfile = function () {
                                            // Prevent function execution if the button should be disabled based on validation rules
                                            if ($scope.aboutErr ||
                                                ($scope.userData.Details.phoneNumber && ($scope.phoneValidation.waitingOtp || $scope.phoneValidation.registered || !$scope.phoneValidation.valid)) ||
                                                ($scope.userData.Details.email && ($scope.mailValidation.waitingOtp || $scope.mailValidation.registered || !$scope.mailValidation.valid))) {
                                                return;
                                            }

                                            if (!$scope.userData.Details.phoneNumber) { $scope.userData.Details.phoneNumber = null; }
                                            else {
                                                $scope.userData.Details.phoneNumber = $scope.userData.Details.phoneNumber.replace(/\s+/g, '');
                                            }

                                            $scope.updateLoading = true;

                                            $scope.userData.Details.profile.aboutDetails = [];
                                            var elArr = [];
                                            $scope.userData.Details.profile.SpokenLanguages.forEach(element => {
                                                elArr.push(+element);
                                            });

                                            $scope.aboutDetails.forEach(element => {
                                                if (element) {
                                                    element.language = element.language ? element.language : $scope.aboutDetails.indexOf(element);
                                                    var cleanedContents = element.about ? element.about.replace(/`/g, '\'') : '';
                                                    element.about = cleanedContents;
                                                    $scope.userData.Details.profile.aboutDetails.push(element);
                                                }
                                            });

                                            updateUser();

                                        };

                                        function updateUser() {
                                            user_factory.update($scope.userData.Details).$promise.then(
                                                function (result) {
                                                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                                    CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                                                    CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                                                    CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                                                    $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;

                                                    notifierSvc.show({ message: $translate.instant('account_updated'), type: "success" });
                                                    userSvc.getUserInfo(true).then(function (result) {
                                                        $scope.userData = angular.copy(userSvc.info);
                                                        window.oldPhoneNumber = $scope.userData.Details.phoneNumber;
                                                        window.oldMailAddress = $scope.userData.Details.email;
                                                    });
                                                    ngDialog.close();

                                                },
                                                function (err) {
                                                    console.log(err);
                                                    if (err.data.detail.includes("updated with newer")) {
                                                        notifierSvc.show({ message: $translate.instant('account_update_error'), type: "error" });
                                                    } else {
                                                        notifierSvc.show({ message: $translate.instant('account_error'), type: "error" });
                                                    }
                                                }
                                            ).finally(() => $scope.updateLoading = false);
                                        }

                                        window.localStorage.setItem('profile_completion_notifier', 1);
                                    },
                                ],
                                closeByNavigation: false,
                                closeByDocument: false,
                                closeByEscape: false,
                            });

                        });
                    };
            });

            $timeout(function () {
                if ($rootScope.SignedIn) {
                    notificationService.purgeCache();
                    notificationService.getNotifications();

                    // Lazy load Socket.io library (only for signed-in users)
                    if (typeof io === 'undefined') {
                        var script = document.createElement('script');
                        script.src = '/assets/js/vendor.socket.min.js?v=' + window.appVersion;
                        script.async = false;  // Load synchronously to ensure io is available
                        script.onload = function () {
                            initializeSocket();
                        };
                        document.head.appendChild(script);
                    } else {
                        initializeSocket();
                    }
                }

                function initializeSocket() {
                    var socketUrl = location.host === "beta.endeksa.com"
                        ? "wss://noti-beta.endeksa.com"
                        : "wss://noti.endeksa.com";

                    window.socket = io(socketUrl, {
                        reconnection: true,
                        reconnectionDelayMax: 10000,
                        transports: ['websocket'],
                        auth: {
                            token: 'M05EM0tTNEZSME5UM05E'
                        }
                    });



                    window.socket.on('connect', function (data) {
                        console.log("connect", data);
                        $window.socket.emit('join', { userid: userSvc.info.Id });

                        window.socket.on('signalClient', function (data) {
                            console.log("socket serverdata", data);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                        });
                    });

                    window.socket.on("disconnect", (reason) => {
                        if (window.socket.active) {
                            // temporary disconnection, the socket will automatically try to reconnect
                        } else {
                            // the connection was forcefully closed by the server or the client itself
                            // in that case, `socket.connect()` must be manually called in order to reconnect
                            console.log("Endeksa socket disconnected: " + reason);
                        }
                    });

                    // ⚡ BFCache optimization: Properly manage WebSocket connections
                    // Disconnect when page enters bfcache, reconnect when restored
                    // Reference: https://web.dev/bfcache/#optimize-your-pages-for-bfcache
                    window.addEventListener('pagehide', function (event) {
                        if (event.persisted && window.socket) {
                            console.log('[BFCache] Page entering bfcache, disconnecting socket');
                            window.socket.disconnect();
                        }
                    });

                    window.addEventListener('pageshow', function (event) {
                        if (event.persisted && window.socket && !window.socket.connected) {
                            console.log('[BFCache] Page restored from bfcache, reconnecting socket');
                            window.socket.connect();
                        }
                    });
                } // end initializeSocket()
            });

            $rootScope.normalizeAddress = $window.normalizeAddress;

            $rootScope.hasHistory = function () {
                return $window.referrer && $window.referrer !== $window.location.href;
            };

            $rootScope.proceedBack = function () {
                $window.history.back();
                endeksService.clearTempEndeks();
            };

            $rootScope.isMobileOrTablet = $window.isMobileOrTablet;

            $rootScope.agentAddress = function (agent) {
                if (!agent)
                    return "";
                if (agent.UserInfo)
                    return normalizeAddress(agent.UserInfo.UserName.trim() + '-' + agent.UserInfo.UserSurname.trim());
                else if (agent.Details)
                    return normalizeAddress(agent.Details.profile.name.trim() + '-' + agent.Details.profile.surName.trim());
                else if (agent.Name)
                    return normalizeAddress(agent.Name.trim() + '-' + agent.Surname.trim());
            };

            $rootScope.toggleNotifications = function (showAnnouncements = false) {
                $rootScope.isVisible = !$rootScope.isVisible;
                if ($rootScope.isVisible) {
                    if (showAnnouncements)
                        $rootScope.$broadcast('nc_visible_80');

                    $rootScope.$broadcast('nc_visible');
                }
            };

            $rootScope.unreadNotifications = 0;

            $rootScope.mallAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang;
                return $state.href("mall-detail", {
                    langcode: langKey,
                    id: propertiesInfo.Id,
                    name: normalizeAddress(propertiesInfo.Title.trim()),
                });
            };

            $rootScope.projectAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang;
                return $state.href("project-detail", {
                    langcode: langKey,
                    id: propertiesInfo.Id,
                    name: normalizeAddress(propertiesInfo.Name.trim()),
                });
            };

            $rootScope.districtAddress = function (propertiesNeighbourhood) {
                if (!propertiesNeighbourhood)
                    return "javascript:void(0);";
                var neighbourhood = normalizeAddress(
                    propertiesNeighbourhood.City +
                    "-" +
                    propertiesNeighbourhood.County +
                    "-" +
                    propertiesNeighbourhood.District
                );
                var langKey = $window.lang;
                return $state.href("neighbourSection.details", {
                    langcode: langKey,
                    id: propertiesNeighbourhood.DistrictId,
                    neighbourhood: neighbourhood,
                });
            };


            $rootScope.opportunityUrlCreator = function (propertiesInfo, lang = null) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = lang ? lang : (window.lang || 'tr');
                var ev =
                    propertiesInfo.PropertyCategory === 2 ?
                        $translate.instant("ticari", {}, null, langKey || null) : propertiesInfo.PropertyCategory === 3 ?
                            $translate.instant("arsa", {}, null, langKey || null) : propertiesInfo.PropertyType === null ?
                                $translate.instant("konut", {}, null, langKey || null) :
                                +propertiesInfo.PropertyType === 10 ?
                                    $translate.instant("daire", {}, null, langKey || null) :
                                    $translate.instant("mustakil-ev", {}, null, langKey || null);
                var name = normalizeAddress(propertiesInfo.GeoLocation.CityName) + '-' + normalizeAddress(propertiesInfo.GeoLocation.CountyName) + '-' + normalizeAddress(propertiesInfo.GeoLocation.Name) + '-' + $translate.instant("satilik", {}, null, langKey || null) + "-" + ev;
                return $state.href('localInfo.property', { langcode: langKey, id: propertiesInfo.PortfolioId, name: name });
            };

            $rootScope.opportunityAddress = function (propertiesInfo) {
                if (!propertiesInfo)
                    return "javascript:void(0);";
                var langKey = $window.lang || 'en';
                const currentUrl = propertiesInfo.Details ? propertiesInfo.Details.find(m => m.Language === window.langCode())?.Url || '' : '';
                return $state.href('localInfo.property', { langcode: langKey, id: propertiesInfo.PortfolioId, name: currentUrl });
            };

            $rootScope.durationCalc = function (time) {
                return time <= 30 ? '0-30' : time > 30 && time <= 60 ? '30-60' : time > 60 && time < 90 ? '60-90' : '90'; //time < 180 ? time : 180;
            };

            // $rootScope.openMemberCalendar = function (type) {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-member.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //             $scope.type = type;
            //         }]
            //     });
            // };
            var actionDialog = null;
            var actionDisplayed = false;
            $rootScope.actionType = function (country, city, county, district, address) {
                if (!$rootScope.SignedIn)
                    $state.go('valuation-wrapper', { langcode: $window.lang, address: address });
                else
                    if (!actionDisplayed && !actionDialog)
                        actionDialog = ngDialog.open({
                            showClose: false,
                            closeByEscape: false,
                            closeByNavigation: false,
                            template: "./app/shell/action-type.html",
                            data: {
                                showClose: false,
                            },
                            preCloseCallback: function () {
                                actionDialog = null;
                                actionDisplayed = false;
                            },
                            controller: [
                                "$scope",
                                function ($scope) {
                                    actionDisplayed = true;
                                    $scope.analysis_country = country;
                                    $scope.analysis_city = city;
                                    $scope.analysis_county = county;
                                    $scope.analysis_district = district;
                                    $scope.analysis_address = address;

                                    $scope.analysis_level = 'country';
                                    if (city)
                                        $scope.analysis_level = 'province';
                                    if (county)
                                        $scope.analysis_level = 'county';
                                    if (district)
                                        $scope.analysis_level = 'neighbourhood';
                                    if (address)
                                        $scope.analysis_level = 'address';


                                    var currentstate = $window.localStorage.getItem('currentState');
                                    $scope.analysis_state = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

                                },
                            ],
                        });
            };

            $transitions.onSuccess({}, function () { if (actionDialog) actionDialog.close(); });

            var askDisplayed = false;
            var askMemberDialog = null;
            $rootScope.askMembership = function (passDisplayed, fromDetail = false) {
                if (!askDisplayed && $state.current.name.indexOf("opportunity") === -1 &&
                    !$rootScope.unRegisteredUser &&
                    $state.current.name.indexOf("projects") === -1 &&
                    $state.current.name.indexOf("malls") === -1 &&
                    $state.current.name.indexOf("alarm") === -1 &&
                    $state.current.name.indexOf("agents") === -1 &&
                    $state.current.name.indexOf("portfolio") === -1 &&
                    $rootScope.SignedIn && !askMemberDialog)
                    askMemberDialog = ngDialog.open({
                        showClose: false,
                        // overlay: false,
                        closeByEscape: false,
                        closeByNavigation: false,
                        template: "./app/shell/modal-buy-package.html",
                        data: {
                            showClose: false,
                        },
                        preCloseCallback: function () {
                            askMemberDialog = null;
                        },
                        controller: [
                            "$scope",
                            "$state",
                            "paymentService",
                            "$filter",
                            function ($scope, $state, paymentService, $filter) {
                                $scope.fromDetail = fromDetail;
                                askDisplayed = !passDisplayed ? true : false;
                                paymentService.getProducts().then(
                                    function (response) {
                                        var packages = $filter('filter')(response.data, { code: "basic-package", productType: 40 })[0];
                                        var pack = $filter('filter')(packages.prices, { currency: $rootScope.currencyKey })[0];
                                        $scope.packPrice = pack.monthlyPrice;
                                        $scope.currencySymbol = $window.currencySymbolByEndeksaCode(pack.currency);
                                    });

                                $scope.proceedBuy = function () {
                                    $state.go('odeme-onepage', { code: 'basic-package', langcode: $window.lang, type: 40 });
                                };
                            },
                        ],
                    });
            };

            $rootScope.cleanInput = function (item) {
                item = item || $rootScope.address;
                item = null;
                $rootScope.address = null;
                $rootScope.$broadcast("input_cleaned", {});
                if (typeHead)
                    $(typeHead).typeahead('close');
                $rootScope.debounce = false;
            };

            var typeHead;
            $rootScope.initAutoComplete = function (id, btn) {
                typeHead = id;
                var debounceTiemout;

                $timeout(function () {
                    var that = this;

                    $(id).typeahead({
                        source: function (query, process) {
                            if (debounceTiemout) {
                                clearTimeout(debounceTiemout);
                            }
                            debounceTiemout = setTimeout(function () {
                                $rootScope.debounce = true;
                                if (query.indexOf('http') > -1 || query.indexOf('www') > -1) {
                                    $rootScope.$broadcast("link_defined", { query: query });
                                    return process([]);
                                }
                                var end = process(["loading"]);
                                var results1 = [];
                                var results2 = [];
                                var results4 = [];
                                var results5 = [];
                                var results6 = [];
                                var results7 = [];
                                var results8 = [];
                                var results9 = [];
                                var results10 = [];

                                const countryId = ($rootScope.country === 'turkiye' || bolgeselDataService.country === 'turkiye') ? 1 : ($rootScope.country === 'espana' || bolgeselDataService.country === 'espana') ? 2 : ($rootScope.country === 'portugal' || bolgeselDataService.country === 'portugal') ? 3 : 0;
                                const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

                                const bbox = bolgeselDataService.cityBounds && bolgeselDataService.cityBounds.southWest && countryId > 0 ? bolgeselDataService.cityBounds.southWest.lng + "," + bolgeselDataService.cityBounds.southWest.lat + "~" + bolgeselDataService.cityBounds.northEast.lng + "," + bolgeselDataService.cityBounds.northEast.lat : undefined;

                                if (query.length > 2) {
                                    if (countryId !== 1) {
                                        $ocLazyLoad.load([
                                            'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                                        ]).then(function () {
                                            var service = new google.maps.places.AutocompleteService();
                                            service.getPlacePredictions({
                                                input: query,
                                                componentRestrictions: { country: langu.split('_')[0] },
                                                language: langu.split('_')[0]
                                            }, function (predicts, status) {
                                                results1.length = 0;
                                                if (status === google.maps.places.PlacesServiceStatus.OK) {
                                                    var predictions = [];

                                                    for (var i = 0; i < predicts.length; i++) {
                                                        const country_name = predicts[i].terms[predicts[i].terms.length - 1].value;
                                                        var item = {
                                                            name: predicts[i].description.replace(', ' + country_name, '').replace('/', ', '),
                                                            description: ', ' + country_name,
                                                            longlat: null,
                                                            country: country_name,
                                                            place: predicts[i].place_id,
                                                            type: predicts[i].type ? predicts[i].type : predicts[i].types[0],
                                                            alt_type: predicts[i].alt_type ? predicts[i].alt_type : predicts[i].types[1],
                                                            alt_type2: predicts[i].types[2]
                                                        };
                                                        predictions.push(item);
                                                    }
                                                    if (predictions && predictions.length) {
                                                        results1 = $.map(predictions,
                                                            function (prediction) {
                                                                if (prediction.name !== prediction.description) {
                                                                    var dest = prediction.name + prediction.description;
                                                                    dest = dest.replace(', Eyüp', ', Eyüpsultan');
                                                                    dest = '||' + prediction.country + '||' + dest;

                                                                    if (prediction.type !== "shopping_mall" && prediction.name.indexOf('Gar') === -1 && (prediction.type !== "administrative_area_level_4" && (prediction.name.indexOf('Sokağı') > -1 || prediction.name.indexOf('Cadde') > -1 || prediction.name.indexOf('Sokak') > -1 || prediction.type === "route" || prediction.type === "street_address")) && prediction.name.indexOf(' no ') === -1 && prediction.name.indexOf('Otopark') === -1 && prediction.alt_type2 !== "establishment") {
                                                                        dest = "6>" + dest + "|sokak|p:" + prediction.place;
                                                                    }
                                                                    else if ((prediction.name.indexOf('Calle') > -1 || prediction.name.indexOf('Sokağı') > -1 || prediction.name.indexOf('Cadde') > -1 || prediction.name.indexOf('Sokak') > -1) && prediction.name.indexOf(' no ') > -1) {
                                                                        dest = "0>" + dest + "|konut|p:" + prediction.place;
                                                                    }
                                                                    else if ((prediction.type === "establishment" || prediction.alt_type === "establishment" ||
                                                                        prediction.alt_type2 === "establishment" || prediction.alt_type === "health" || prediction.alt_type === "gym")
                                                                        && prediction.name.indexOf('Muhtar') === -1
                                                                        && (prediction.type === "shopping_mall")
                                                                        && prediction.alt_type) {
                                                                        dest = "4>" + dest + "|site|p:" + prediction.place;
                                                                    }
                                                                    else if (prediction.type === "neighborhood") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_4" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_3" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "3>" + dest + "|mahalle|p:" + prediction.place;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_2" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "2>" + dest + "|ilce|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "administrative_area_level_1" &&
                                                                        prediction.alt_type === "political") {
                                                                        dest = "1>" + dest + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && prediction.name.indexOf(',') === -1) {
                                                                        dest = "1>" + dest + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && dest.split(',').length > 2) {
                                                                        var isCity = false;
                                                                        if (dest.split(',')[0].trim() === dest.split(',')[2].trim()) {
                                                                            //dest = dest.replace(dest.split(',')[0].trim(), dest.split(',')[1].trim());
                                                                            isCity = true;
                                                                        }
                                                                        else if (dest.split(',').length > 3 && dest.split(',')[0].trim() === dest.split(',')[3].trim()) {
                                                                            dest = dest.replace(dest.split(',')[0].trim() + ', ', '');
                                                                        }
                                                                        else if (dest.split(',').length > 3 && dest.split(',')[1].trim().indexOf(dest.split(',')[0].trim()) > -1) {
                                                                            dest = dest.replace(dest.split(',')[0].trim() + ', ', '');
                                                                        }
                                                                        dest = !isCity ? "3>" + dest + "|mahalle|p:" + prediction.place : "1>" + dest.split(',')[0] + "|vilayet|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "locality" &&
                                                                        prediction.alt_type === "political" && dest.indexOf(',') > -1) {
                                                                        dest = "2>" + dest + "|ilce|p:" + prediction.place;
                                                                        //return null;
                                                                    }
                                                                    else if (prediction.type === "colloquial_area" && prediction.name.indexOf("Mahallesi") !== -1) {
                                                                        dest = "3>" + dest + "|mahalle|p:";
                                                                    }
                                                                    else {
                                                                        dest = "7>" + dest + "|other|p:" + prediction.place;
                                                                    }

                                                                    //dest = "8>" + dest + "|other|p:" + prediction.place;

                                                                    if (dest.indexOf('|sokak|') === -1
                                                                        && dest.indexOf('|konut|') === -1
                                                                        && dest.indexOf('|other|') === -1
                                                                        && dest.indexOf('|mahalle|') === -1
                                                                        && dest.indexOf('|site|') === -1
                                                                        && $(that).attr('data-from') === "alarm")
                                                                        return null;

                                                                    return dest;
                                                                } else
                                                                    return null;
                                                            });
                                                    }
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                            });
                                        });
                                    }
                                    else {
                                        const jsonUrl = 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&results=5' + (bbox ? ('&bbox=' + bbox) : '') + '&format=json&lang=' + langu + (bbox ? '&rspn=1' : '') + '&geocode=' +
                                            encodeURI(query);

                                        $.getJSON(jsonUrl, function (data) {
                                            results2.length = 0;
                                            var predictions2 = [];
                                            for (var i = 0; i < data.response.GeoObjectCollection.featureMember.length; i++) {
                                                var item = {
                                                    name: data.response.GeoObjectCollection.featureMember[i].GeoObject.name,
                                                    description: data.response.GeoObjectCollection.featureMember[i].GeoObject.description,
                                                    longlat: data.response.GeoObjectCollection.featureMember[i].GeoObject.Point.pos,
                                                    type: data.response.GeoObjectCollection.featureMember[i].GeoObject.metaDataProperty.GeocoderMetaData.kind,
                                                    alt_type: data.response.GeoObjectCollection.featureMember[i].GeoObject.metaDataProperty.GeocoderMetaData
                                                };
                                                if (!item || !item.description)
                                                    continue;
                                                predictions2.push(item);
                                            }
                                            if (predictions2 && predictions2.length) {
                                                results2 = $.map(predictions2,
                                                    function (prediction) {

                                                        if (prediction.name !== prediction.description) {
                                                            var dest = prediction.name + ", " + prediction.description;
                                                            dest = '||' + prediction.alt_type.Address.country_code + '||' + dest;
                                                            dest = dest.replace(', ' + prediction.alt_type.AddressDetails.Country.CountryName, '');

                                                            if (prediction.type === "district" &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea
                                                                    .Locality.DependentLocality.DependentLocality) {
                                                                dest = "4>" + dest + "|site|l:" + prediction.longlat;
                                                            } else if (dest.indexOf('Yenikapı') === -1 && prediction.type === "district" &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea) {
                                                                dest = "3>" + dest + "|mahalle|l:" + prediction.longlat;
                                                            }
                                                            else if (prediction.type === "other" && prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea &&
                                                                prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                    .SubAdministrativeArea.Locality.Premise) {
                                                                return null;
                                                            }
                                                            else if (prediction.type === "area") {
                                                                dest = "2>" + dest + "|ilce|l:" + prediction.longlat;
                                                            } else if (prediction.type === "locality") {
                                                                if (prediction.alt_type.AddressDetails && prediction.alt_type.AddressDetails.Country.AdministrativeArea &&
                                                                    prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea) {
                                                                    if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality &&
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.DependentLocality
                                                                            .DependentLocality && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                                .SubAdministrativeArea.Locality.DependentLocality
                                                                                .DependentLocalityName.indexOf('Municipios') === -1) {
                                                                        dest = "3>" + dest + "|mahalle|l:" + prediction.longlat;
                                                                    }
                                                                    else if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality &&
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.DependentLocality
                                                                            .DependentLocality && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                                .SubAdministrativeArea.Locality.DependentLocality
                                                                                .DependentLocalityName.indexOf('Municipios') > -1) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (prediction.alt_type.AddressDetails.Country
                                                                        .AdministrativeArea
                                                                        .SubAdministrativeArea.Locality.DependentLocality) {
                                                                        //TODO: köyleri şimdilik ihmal edelim.
                                                                        return null;
                                                                    } else if (prediction.alt_type.AddressDetails.Country
                                                                        .AdministrativeArea.AdministrativeAreaName ===
                                                                        prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.Locality.LocalityName) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                        .SubAdministrativeArea && prediction.alt_type.AddressDetails.Country.AdministrativeArea
                                                                            .SubAdministrativeArea.SubAdministrativeAreaName.indexOf('Provincia') > -1) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else if (dest.length <= 14) {
                                                                        dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                    } else {
                                                                        dest = "2>" + dest + "|ilce|l:" + prediction.longlat;
                                                                    }
                                                                } else { //All those come here are provinces always, still being tested on preprod
                                                                    dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                                }
                                                            }
                                                            else if (prediction.type === "street") {
                                                                dest = "6>" + dest + "|sokak|l:" + prediction.longlat;
                                                            }
                                                            else if (prediction.type === "house") {
                                                                dest = "0>" + dest + "|konut|l:" + prediction.longlat;
                                                            } else if (prediction.type === "province") {
                                                                dest = "1>" + dest + "|vilayet|l:" + prediction.longlat;
                                                            } else {
                                                                dest = "13>" + dest + "|other|l:" + prediction.longlat;
                                                            }
                                                            if (dest.indexOf('|mahalle|') === -1 &&
                                                                dest.indexOf('|sokak|') === -1 &&
                                                                dest.indexOf('|konut|') === -1 &&
                                                                dest.indexOf('|other|') === -1 &&
                                                                dest.indexOf('|site|') === -1 &&
                                                                $(that).attr('id') === 'alarm-input')
                                                                return null;
                                                            return dest;
                                                        } else
                                                            return null;
                                                    });

                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                            else {
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                        });
                                    }
                                    // $.ajax({
                                    //     type: 'GET',
                                    //     contentType: "application/json",
                                    //     dataType: 'json',
                                    //     url: 'https://' + $window.urlfx2 + '.endeksa.com/retailstreets?SearchTerm=' + query,
                                    //     success: function (data) {
                                    //         var predictions = data;
                                    //         if (predictions && predictions.length) {
                                    //             results9.length = 0;
                                    //             results9 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '5>' + prediction.StreetName.toLocaleProperCase2("tr-tr") + ', ' + prediction.DistrictName.toLocaleProperCase2("tr-tr") + ', ' + prediction.CountyName.toLocaleProperCase2("tr-tr") + ', ' + prediction.CityName.toLocaleProperCase2("tr-tr") + '|street|' + prediction.Id + '|l:' + prediction.Lon + ' ' + prediction.Lat;
                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     }

                                    // });
                                    // if (countryId)
                                    //     $http.get(appSettingsSvc.CACHE + '/searchhousingprojectname?name=' + encodeURI(query) + '&countryId=' + countryId).then(function (data) {
                                    //         var predictions = data.data.Data;
                                    //         if (predictions && predictions.length) {
                                    //             results4.length = 0;
                                    //             results4 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '||TR||8>' + prediction.Name + '|proje|' + prediction.Id + '|l:' + prediction.Longitude + ' ' + prediction.Latitude;

                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //         else {
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     });

                                    // if (countryId)
                                    //     $http.get(appSettingsSvc.CACHE + '/shoppingcentersearch?title=' + encodeURI(query) + '&countryId=' + countryId).then(function (data) {
                                    //         var predictions = data.data.Data;
                                    //         if (predictions && predictions.length) {
                                    //             results5.length = 0;
                                    //             results5 = $.map(predictions.slice(0, 2),
                                    //                 function (prediction) {
                                    //                     var dest = '||TR||9>' + prediction.Title + '|avm|' + prediction.Id + '|l:' + prediction.Lon + ' ' + prediction.Lat;

                                    //                     return dest;
                                    //                 });
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //         else {
                                    //             var results = [];
                                    //             results = results.concat(results1);
                                    //             results = results.concat(results2);
                                    //             results = results.concat(results4);
                                    //             results = results.concat(results5);
                                    //             results = results.concat(results6);
                                    //             results = results.concat(results7);
                                    //             results = results.concat(results8);
                                    //             results = results.concat(results9);
                                    //             results = results.concat(results10);
                                    //             results.sort(function (a, b) {
                                    //                 var nameA = (+a.split('>')[0]),
                                    //                     nameB = (+b.split('>')[0]);
                                    //                 if (nameA < nameB)
                                    //                     return -1;
                                    //                 if (nameA > nameB)
                                    //                     return 1;
                                    //                 return 0;
                                    //             });
                                    //             end = process(results);
                                    //         }
                                    //     });

                                    if ($rootScope.SignedIn) {
                                        $http.post(appSettingsSvc.NONCACHE + '/tasinmazliste', JSON.stringify({
                                            "UserId": userSvc.info.Id,
                                            "Search": query,
                                            // "CountryId": countryId,
                                            "DataLevel": 9,
                                            "ItemSize": 2,
                                            "ActivePageNumber": 1,
                                            "OrderBy": 1,
                                            "Sort": 2
                                        })).then(function (data) {
                                            var predictions = data.data.Properties;

                                            if (predictions && predictions.length) {
                                                results6.length = 0;
                                                results6 = $.map(predictions.slice(0, 2),
                                                    function (prediction) {
                                                        var countryTag = prediction.CountryName === 'Türkiye' ? 'TR' : prediction.CountryName === 'Portugal' ? 'PT' : 'ES';
                                                        var dest = '||' + countryTag + '||11>' + prediction.Name + ', ' + prediction.DistrictName + ', ' + prediction.CountyName + ', ' + prediction.CityName + '|endeksa|' + prediction.Id + '|l:' + prediction.Longitude + ' ' + prediction.Latitude;

                                                        return dest;
                                                    });
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                            else {
                                                var results = [];
                                                results = results.concat(results1);
                                                results = results.concat(results2);
                                                results = results.concat(results4);
                                                results = results.concat(results5);
                                                results = results.concat(results6);
                                                results = results.concat(results7);
                                                results = results.concat(results8);
                                                results = results.concat(results9);
                                                results = results.concat(results10);
                                                results.sort(function (a, b) {
                                                    var nameA = (+a.split('>')[0]),
                                                        nameB = (+b.split('>')[0]);
                                                    if (nameA < nameB)
                                                        return -1;
                                                    if (nameA > nameB)
                                                        return 1;
                                                    return 0;
                                                });
                                                end = process(results);
                                            }
                                        });
                                    }

                                    // if (countryId)
                                    //     $http.post(appSettingsSvc.NONCACHE + '/portfoliosearch',
                                    //         JSON.stringify({
                                    //             "SearchTerm": query,
                                    //             "CountryId": countryId,
                                    //             "ItemSize": 2,
                                    //             "Level": 9,
                                    //             "PriceMax": 2147483647,
                                    //             "Language": $window.langCode()
                                    //         })).then(function (data) {
                                    //             var predictions = data.data.OpportunityList;
                                    //             if (predictions && predictions.length) {
                                    //                 results8.length = 0;
                                    //                 results8 = $.map(predictions.slice(0, 2),
                                    //                     function (prediction) {
                                    //                         var countryTag = prediction.GeoLocation.CountryId === 1 ? 'TR' : prediction.GeoLocation.CountryId === 3 ? 'PT' : 'ES';
                                    //                         var dest = '||' + countryTag + '||7>' + prediction.GeoLocation.Name + ', ' + prediction.GeoLocation.DistrictName + ', ' + prediction.GeoLocation.CountyName + ', ' + prediction.GeoLocation.CityName + '|opport|' + prediction.PortfolioId + '-' + prediction.PropertyCategory + '-' + prediction.PropertyType + '|l:' + prediction.GeoLocation.Longitude + ' ' + prediction.GeoLocation.Latitude;

                                    //                         return dest;
                                    //                     });
                                    //                 var results = [];
                                    //                 results = results.concat(results1);
                                    //                 results = results.concat(results2);
                                    //                 results = results.concat(results4);
                                    //                 results = results.concat(results5);
                                    //                 results = results.concat(results6);
                                    //                 results = results.concat(results7);
                                    //                 results = results.concat(results8);
                                    //                 results = results.concat(results9);
                                    //                 results = results.concat(results10);
                                    //                 results.sort(function (a, b) {
                                    //                     var nameA = (+a.split('>')[0]),
                                    //                         nameB = (+b.split('>')[0]);
                                    //                     if (nameA < nameB)
                                    //                         return -1;
                                    //                     if (nameA > nameB)
                                    //                         return 1;
                                    //                     return 0;
                                    //                 });
                                    //                 end = process(results);
                                    //             }
                                    //             else {
                                    //                 var results = [];
                                    //                 results = results.concat(results1);
                                    //                 results = results.concat(results2);
                                    //                 results = results.concat(results4);
                                    //                 results = results.concat(results5);
                                    //                 results = results.concat(results6);
                                    //                 results = results.concat(results7);
                                    //                 results = results.concat(results8);
                                    //                 results = results.concat(results9);
                                    //                 results = results.concat(results10);
                                    //                 results.sort(function (a, b) {
                                    //                     var nameA = (+a.split('>')[0]),
                                    //                         nameB = (+b.split('>')[0]);
                                    //                     if (nameA < nameB)
                                    //                         return -1;
                                    //                     if (nameA > nameB)
                                    //                         return 1;
                                    //                     return 0;
                                    //                 });
                                    //                 end = process(results);
                                    //             }
                                    //         });

                                    if (countryId)
                                        $.getJSON(appSettingsSvc.CACHE + '/realtorregions/agentsearch?keyword=' + encodeURI(query) + '&countryId=' + countryId,
                                            function (data) {
                                                var predictions = data.Results;
                                                if (predictions && predictions.length) {
                                                    results10.length = 0;
                                                    results10 = $.map(predictions.slice(0, 2),
                                                        function (prediction) {
                                                            var countryTag = prediction.CountryName === 'Türkiye' ? 'TR' : prediction.CountryName === 'Portugal' ? 'PT' : 'ES';
                                                            var dest = '||' + countryTag + '||13>' + prediction.Name.toLocaleProperCase2("tr-tr") + ' ' + prediction.Surname.toLocaleProperCase2("tr-tr") + (prediction.OfficeName ? ' (' + prediction.OfficeName.toLocaleProperCase2("tr-tr") + ') ' : ' ') + prediction.CityName.toLocaleProperCase2("tr-tr") + ', ' + prediction.CountyName.toLocaleProperCase2("tr-tr") + '|agent|' + prediction.Id + '|l:' + prediction.CenterLon + ' ' + prediction.CenterLat;

                                                            return dest;
                                                        });
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                                else {
                                                    var results = [];
                                                    results = results.concat(results1);
                                                    results = results.concat(results2);
                                                    results = results.concat(results4);
                                                    results = results.concat(results5);
                                                    results = results.concat(results6);
                                                    results = results.concat(results7);
                                                    results = results.concat(results8);
                                                    results = results.concat(results9);
                                                    results = results.concat(results10);
                                                    results.sort(function (a, b) {
                                                        var nameA = (+a.split('>')[0]),
                                                            nameB = (+b.split('>')[0]);
                                                        if (nameA < nameB)
                                                            return -1;
                                                        if (nameA > nameB)
                                                            return 1;
                                                        return 0;
                                                    });
                                                    end = process(results);
                                                }
                                            });
                                }
                                // }
                                return end;
                            }, 1000);

                        },
                        afterSelect: function (evt, item) {
                            let wait = setInterval(function () {
                                if (window.updater_resolved) {
                                    setTimeout(function () {
                                        $(id).typeahead('close');
                                        $(id + ':visible').blur();
                                    }, 100);
                                    $(btn).click();
                                    clearInterval(wait);
                                }
                            });
                        },
                        highlighter: function (item) {
                            const countrySplit = item.split('||');
                            if (countrySplit.length) {
                                $window.country_code = countrySplit[1];
                                item = countrySplit[0] + countrySplit[2];
                            }

                            if (!item) {
                                return item;
                            } else if (item.indexOf('loading') > -1) {
                                item = $translate.instant('search_loading');
                            } else if (item.indexOf('notfound') > -1) {
                                item = $translate.instant('search_notfound');
                            } else if (item.indexOf('error') > -1) {
                                item = $translate.instant('search_tryagain');
                            } else if (item.indexOf('|mahalle|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|mahalle|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-neighbourhood pull-right item-label">' + $translate.instant('search_district') + '</span>';
                                } else item = null;
                            }
                            else if (item.indexOf('|ilce|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|ilce|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-county pull-right item-label">' + $translate.instant('search_county') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|vilayet|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|vilayet|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-city pull-right item-label">' + $translate.instant('search_city') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|sokak|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|sokak|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-avenue pull-right item-label">' + $translate.instant('search_street') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|konut|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|konut|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-house pull-right item-label">' + $translate.instant('search_property') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|site|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|site|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-residencia-avm pull-right item-label">' + $translate.instant('search_gated') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|proje|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|proje|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-housing-project pull-right item-label">' + $translate.instant('search_project') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|avm|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|avm|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-housing-project pull-right item-label">' + $translate.instant('search_mall') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|country|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|country|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-country pull-right item-label">' + $translate.instant('search_country') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|endeksa|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|endeksa|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-endeksa pull-right item-label">' + $translate.instant('search_archive') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|street|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|street|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-street pull-right item-label">' + $translate.instant('search_street') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|opport|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|opport|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-opport2 pull-right item-label">' + $translate.instant('search_listing') + '</span>';
                                } else item = null;
                            } else if (item.indexOf('|agent|') > -1) {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|agent|')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-endeksa2 pull-right item-label">' + $translate.instant('search_agent') + '</span>';
                                } else item = null;
                            } else {
                                item = item.split('>')[1];
                                if (item) {
                                    item = item.split('|other')[0];
                                    item = '<span class="pull-left adrname">' + item + '</span>';
                                    item = item + '<span class="label label-location pull-right item-label">' + $translate.instant('search_address') + '</span>';
                                } else item = null;
                            }
                            if (item)
                                item = '<span class="item-address">' + item + '</span>';

                            console.log(undefined); //DO NOT DELETE BABEL COMPILER HACK
                            return item;
                        },
                        minLength: 3,
                        hint: true,
                        fitToElement: true,
                        matcher: function () {
                            if ($(id).val())
                                return true;
                            else
                                return false;
                        },
                        updater: function (item) {
                            $window.mallId = null;
                            $window.endeksaId = null;
                            $window.agentId = null;
                            $window.opportId = null;
                            $window.regionId = undefined;
                            $window.projectId = null;
                            $window.rememberProperty = null;
                            $window.selectedLocation = null;
                            $window.gatheredLocation = null;
                            $window.parcelRecord = null;

                            const countrySplit = item.split('||');
                            if (countrySplit.length) {
                                $window.country_code = countrySplit[1];
                                item = countrySplit[0] + countrySplit[2];

                                var country = $window.country_code === 'PT' || $window.country_code === 'Portugal' ? 'portugal' : $window.country_code === 'TR' ? 'turkiye' : $window.country_code === 'ES' ? 'espana' : 'world';
                                $rootScope.country = country;
                            }

                            if (item.indexOf('loading') > -1) {
                                item = "";
                            }
                            if (item.indexOf('notfound') > -1) {
                                item = "";
                            } else if (item.indexOf('error') > -1) {
                                item = '';
                            } else if (item.indexOf('|vilayet') > -1) {
                                $window.lastLevel = 1;
                            } else if (item.indexOf('|ilce') > -1) {
                                $window.lastLevel = 2;
                            } else if (item.indexOf('|mahalle') > -1) {
                                $window.lastLevel = 3;
                            } else if (item.indexOf('|semt') > -1) {
                                $window.lastLevel = 3;
                            } else if (item.indexOf('|sokak') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|konut') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|site') > -1) {
                                $window.lastLevel = 0;
                            } else if (item.indexOf('|proje') > -1) {
                                $window.lastLevel = 6;
                            } else if (item.indexOf('|street') > -1) {
                                //TODO: Street leveli düzeltip tekrar devreye alalım
                                $window.lastLevel = 5;
                            } else if (item.indexOf('|avm') > -1) {
                                $window.lastLevel = 7;
                            } else if (item.indexOf('|country') > -1) {
                                $window.lastLevel = 9;
                            } else if (item.indexOf('|region') > -1) {
                                $window.lastLevel = 11;
                            } else if (item.indexOf('|agent') > -1) {
                                $window.lastLevel = 2;
                            } else {
                                $window.lastLevel = 0;
                            }

                            item = item.split('>')[1];
                            if (item.indexOf('|proje|') > -1)
                                $window.projectId = +item.split('|proje|')[1].split('|l')[0];
                            else
                                $window.projectId = null;

                            if (item.indexOf('|avm|') > -1)
                                $window.mallId = +item.split('|avm|')[1].split('|l')[0];
                            else
                                $window.mallId = null;

                            if (item.indexOf('|endeksa|') > -1) {
                                $window.endeksaId = item.split('|endeksa|')[1].split('|l')[0];
                            } else
                                $window.endeksaId = null;

                            if (item.indexOf('|agent|') > -1) {
                                $window.agentId = item.split('|agent|')[1].split('|l')[0];
                            } else
                                $window.agentId = null;

                            if (item.indexOf('|opport|') > -1) {
                                $window.opportId = item.split('|opport|')[1].split('|l')[0];
                            } else
                                $window.opportId = null;

                            if (item.indexOf('|region|') > -1) {
                                $window.regionId = item.split('|region|')[1].split('|l')[0];
                            } else
                                $window.regionId = undefined;

                            try {
                                if (item.split('|l:')[1] !== 'NaN NaN' && item.split('|l:')[1] !== 'null' && item.split('|l:')[1] !== 'null null' && item.split('|l:')[1]) {
                                    var lat = item.split('|l:')[1].split(' ')[1];
                                    var lng = item.split('|l:')[1].split(' ')[0];
                                    if (lat - 40.965544 === 0) { //<= 0.002) {
                                        lat = lat - 0.061;
                                    }
                                    if (lng - 29.106000 === 0) { //} <= 0.002) {
                                        lng = lng + 0.000290;
                                    } else if (lng - 29.052037 === 0) {
                                        lng = lng - 0.01;
                                    }

                                    //yandexten gelen alanya merkez koordinatı bizdeki shapein dışında kalıyor.
                                    if (item.split('|')[0] === 'Alanya, Antalya') {
                                        lat = 36.5919877276;
                                        lng = 32.1493611265;
                                    }

                                    $window.selectedLocation = lng + ' ' + lat;
                                    $window.updater_resolved = true;
                                }
                                else if (item.split('|p:')[1] !== 'NaN NaN' && item.split('|p:')[1] !== 'null' && item.split('|p:')[1] !== 'null null' && item.split('|p:')[1]) {
                                    var place_id = item.split('|p:')[1].replace('undefined', '');
                                    var geocoder = new google.maps.Geocoder();
                                    geocoder
                                        .geocode({ placeId: place_id })
                                        .then(({ results }) => {
                                            $window.selectedLocation = results[0].geometry.location.lng() + ' ' + results[0].geometry.location.lat();
                                            $window.updater_resolved = true;
                                        });
                                }
                                else {
                                    $window.selectedLocation = null;
                                    $window.updater_resolved = true;
                                }
                                item = item.split('|mahalle')[0];
                                item = item.split('|semt')[0];
                                item = item.split('|vilayet')[0];
                                item = item.split('|ilce')[0];
                                item = item.split('|sokak')[0];
                                item = item.split('|konut')[0];
                                item = item.split('|site')[0];
                                item = item.split('|proje')[0];
                                item = item.split('|endeksa')[0];
                                item = item.split('|avm')[0];
                                item = item.split('|agent')[0];
                                item = item.split('|other')[0];
                                item = item.split('|country')[0];
                                item = item.split('|opport')[0];
                                item = item.split('|region')[0];
                                item = item.split('|street')[0];
                                $rootScope.address = item;

                                $window.searchHistory.setItem($rootScope.address, $window.selectedLocation, $window.lastLevel, $rootScope.country, $window.endeksaId, $window.opportId, $window.mallId, $window.projectId, $window.agentId, $window.regionId, $rootScope.selectedMethod);

                            } catch (err) {
                                $window.selectedLocation = null;
                                item = item.split('|other')[0];
                            }
                            return item;
                        }
                    });
                    // });
                });
            };

            $window.searchHistory = {
                list: [],
                setItem: function (item, location, level, country, endeksa, opportunity, mall, project, agent, region, method) {

                    if (typeof $window.fbq != "undefined")
                        try {
                            $window.fbq('track', 'Search');
                        } catch (err) { }

                    $window.dataLayer.push({
                        event: "search",
                        currency: window.currency,
                        language: window.lang.split('-')[0],
                        search_term: item
                    });

                    const log = { id: window.makeid(3), item: item, location: location, level: level, country: country, endeksa: endeksa, opportunity: opportunity, mall: mall, project: project, agent: agent, region: region, method: method };

                    $window.searchHistory.list.reverse();
                    $window.searchHistory.list.push(log);
                    if ($window.searchHistory.list.length > 3)
                        $window.searchHistory.list.shift();
                    $window.searchHistory.list.reverse();

                    $window.localStorage.removeItem('searchHistoryLogId');
                    $window.localStorage.setItem('searchHistoryLogId', JSON.stringify(window.searchHistory.list));

                    $rootScope.searchHistory = $window.searchHistory;

                },
                removeItem: function (item) {
                    var listItem = $window.searchHistory.list.find(m => m.item === item.item);
                    const index = $window.searchHistory.list.indexOf(listItem);
                    if (index > -1) {
                        $window.searchHistory.list.splice(index, 1);
                    }
                    $window.localStorage.removeItem('searchHistoryLogId');
                    $window.localStorage.setItem('searchHistoryLogId', JSON.stringify(window.searchHistory.list));
                    if ($window.searchHistory.list.length)
                        $timeout(function () {
                            $rootScope.searchFocused = 1;
                        }, 301);

                    $rootScope.searchHistory = $window.searchHistory;

                },
                sync: function () {
                    var list = $window.localStorage.getItem('searchHistoryLogId');
                    $window.searchHistory.list = JSON.parse(list) || [];
                },
                goTo: function (item) {
                    $window.updater_resolved = true;
                    $window.selectedLocation = item.location;
                    $window.gatheredLocation = null;
                    $window.lastLevel = item.level;
                    $window.endeksaId = item.endeksa;
                    $window.opportId = item.opportunity;
                    $window.mallId = item.mall;
                    $window.projectId = item.project;
                    $window.agentId = item.agent;
                    $window.regionId = item.region;
                    $rootScope.selectedMethod = item.method ? item.method : 1;
                    $rootScope.address = item.item;
                    $rootScope.country = item.country;
                    $rootScope.parserSearchfromInputTop($rootScope.selectedMethod);

                    $rootScope.searchHistory = $window.searchHistory;

                }
            };
            $window.searchHistory.sync();
            $rootScope.searchHistory = $window.searchHistory;


            // $rootScope.openReportCalendar = function () {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-report.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //         }]
            //     });
            // };

            // $rootScope.openAdvanceCalendar = function () {
            //     ngDialog.open({
            //         templateUrl: $window.lang === 'tr' ? 'app/shell/calendar-advance.html' : 'app/shell/calendar-english.html',
            //         overlay: true,
            //         closeByEscape: true,
            //         showClose: false,
            //         closeByNavigation: true,
            //         closeByDocument: true,
            //         controller: ['$scope', 'userSvc', function ($scope, userSvc) {
            //             if (userSvc.info.SignedIn)
            //                 userSvc.getUserInfo().then(function (account) {
            //                     $scope.account = account.information;
            //                 });
            //             else
            //                 $scope.account = { profile: {} };
            //         }]
            //     });
            // };

            $rootScope.isIntercomVisible = function () {
                return angular.element('.intercom-messenger-frame').length;
            };

            $rootScope.leadModal = function () {
                ngDialog.open({
                    templateUrl: 'app/shell/lead-modal.html',
                    overlay: true,
                    closeByEscape: true,
                    showClose: false,
                    closeByNavigation: true,
                    closeByDocument: true,
                    controller: ['$scope', 'consultancy_factory', 'notifierSvc', '$translate', '$window', function ($scope, consultancy_factory, notifierSvc, $translate, $window) {
                        $scope.hideClose = false;
                        $scope.contact = {
                            name: "",
                            phone: "",
                            sent: false,
                        };
                        $scope.acikRiza = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/mortgage-riza-modal.html'
                            });
                        };
                        // provinceListService.getProvinces().then(function (response) { $scope.Cities = response.List; });

                        // $scope.isConsultancy = $state.current.name.indexOf('danisman') > -1;

                        // $scope.loadCounties = function () {
                        //     $scope.contact.county = null;
                        //     $scope.contact.district = null;
                        //     provinceListService.CountiesOfProvince($scope.contact.city.CityId).then(function (response) { $scope.Counties = response.List; });
                        // };
                        // $scope.loadDistricts = function () {
                        //     if ($scope.contact.city && $scope.contact.county) {
                        //         $scope.contact.district = null;
                        //         provinceListService.NeighbourhoodsOfCounty($scope.contact.city.CityId, $scope.contact.county.CountyId).then(function (response) { $scope.Districts = response.List; });
                        //     }
                        // };
                        $scope.hideMenu = function () {
                            $("#mobile-menu").hide();
                            $scope.closeThisDialog();
                        };

                        // Captcha state
                        $scope.ETToken = null;
                        $scope.captchaVerified = false;
                        $scope.isTurkishPhone = true;
                        $scope.eimageCaptchaKey = null;
                        $scope.eimageCaptchaValue = null;

                        $scope.contact = {
                            name: "",
                            surname: "",
                            phone: "",
                            sent: false,
                            privacy: false,
                            consultancyType: 10,
                            agentId: agent.Id,
                            agentName: agent.Name,
                            agentSurname: agent.Surname
                        };

                        $scope.call = function () {
                            if ($scope.contact.phone < 13 || !$scope.contact.name || !$scope.contact.privacy || agent.Id === user.Id)
                                return false;
                            $scope.closeThisDialog();
                            $("#mobile-menu").hide();
                            consultancy_factory
                                .post($scope.contact)
                                .$promise.then(function () {
                                    var recieved = $translate.instant('realtors_recieved');
                                    notifierSvc.show({ title: $translate.instant('consult_title'), message: recieved, type: 'success' });
                                    $scope.contact = {
                                        name: "",
                                        surname: "",
                                        phone: "",
                                        sent: false,
                                        consultancyType: 10,
                                        agentId: agent.Id,
                                        agentName: agent.Name,
                                        agentagentSurname: agent.Surname
                                    };
                                });
                        };


                        // $scope.call = function () {
                        //     if ($scope.contact.phone < 13 || !$scope.contact.name || !$scope.contact.privacy)
                        //         return false;
                        //     $scope.closeThisDialog();
                        //     $("#mobile-menu").hide();
                        //     // var content =
                        //     //     ' <br> ' +
                        //     //     $scope.contact.name +
                        //     //     ' <br> ' +
                        //     //     $scope.contact.phone +
                        //     //     // ' <br> ' +
                        //     //     // ($scope.contact.city ? $scope.contact.city.CityName : "") + ' ' + ($scope.contact.county ? $scope.contact.county.CountyName : "") + ' ' + ($scope.contact.district ? $scope.contact.district.DistrictName : "") +
                        //     //     ' <br> Yardım İstediğim Konu: ' + $scope.contact.type +
                        //     //     ' <br> Bulunduğu Sayfa: ' + $window.location.href;

                        //     // var url = '';
                        //     // if ($scope.contact.city && $scope.contact.county && $scope.contact.district)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/' + normalizeAddress($scope.contact.county.CountyName) + '/' + normalizeAddress($scope.contact.district.DistrictName) + '/endeks/satilik/konut';
                        //     // else if ($scope.contact.city && $scope.contact.county)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/' + normalizeAddress($scope.contact.county.CountyName) + '/endeks/satilik/konut';
                        //     // else if ($scope.contact.city)
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/' + normalizeAddress($scope.contact.city.CityName) + '/endeks/satilik/konut';
                        //     // else
                        //     //     url = ' <br>https://www.endeksa.com/tr/analiz/turkiye/endeks/satilik/konut';

                        //     // content = content + url;
                        //     // var title = 'Arkadaşımı Öneriyorum';
                        //     // leadAPI
                        //     //     .set({
                        //     //         Email: 'referral@endeksa.com',
                        //     //         Source: 'Arkadaşımı Öneriyorum',
                        //     //         Content: [{ Value: content, Title: title }]
                        //     //     })
                        //     //     .$promise.then(function () {
                        //     //         var recieved = $translate.instant('realtors_recieved');
                        //     //         notifierSvc.show({ title: $translate.instant('consult_title'), message: recieved, type: 'success' });
                        //     //         $scope.contact = {
                        //     //             name: "",
                        //     //             phone: "",
                        //     //             sent: false,
                        //     //             city: null,
                        //     //             county: null,
                        //     //             district: null,
                        //     //             type: "Satmak"
                        //     //         };
                        //     //     });
                        // };
                    }]
                });
            };

            // if ($location.search().lead) {
            //     $rootScope.callRealtor();
            // }

            $rootScope.Number = Number;

            var iframeOpen, tns_wrapper;
            $rootScope.frameModal = function (url, list, proper, tab, small, scale, user, startIndex) {
                if (!iframeOpen || !ngDialog.isOpen(iframeOpen.id)) {
                    iframeOpen = ngDialog.open({
                        templateUrl: 'app/shell/iframe.html',
                        overlay: true,
                        closeByEscape: true,
                        showClose: false,
                        closeByNavigation: true,
                        closeByDocument: true,
                        preCloseCallback: function () {
                            if (tns_wrapper && tns_wrapper.events) {
                                tns_wrapper.destroy();
                                iframeOpen = null;
                            }
                        },
                        className: 'ngdialog-theme-default iframe-dialog',
                        controller: ['$scope', '$timeout', function ($scope, $timeout) {
                            if (proper) {
                                $scope.property = proper; // property data
                                if (proper.Images)
                                    proper.Images = proper.Images.filter(p => p !== '');
                                else if (proper.Photos)
                                    proper.Photos = proper.Photos.filter(p => p !== '');
                            }

                            $scope.small = small;
                            $scope.scale = scale;
                            $scope.tabSelected = tab ? tab : 1;
                            if (!proper || (proper.Images && proper.Images.length == 0) || (proper.Photos && proper.Photos.length == 0))
                                $scope.tabSelected = 2;
                            $scope.url = url;
                            $scope.itlist = list;
                            $scope.startIndex = startIndex !== undefined ? startIndex : 0; // Store start index for carousel

                            function transitionEnd() {
                                var totalItems = $('.tns-indicators li').length;
                                var currentIndex = $('.tns-indicators li.tns-nav-active').index() + 1;
                                $('.carousel-trad .image-count span').html('' + currentIndex + '/' + totalItems + '');
                            }

                            $scope.changeTab = function (tab) {
                                $scope.tabSelected = tab;

                                if (tab == 1)
                                    $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                        $timeout(function () {
                                            var initialIndex = $scope.startIndex || 0;
                                            tns_wrapper = tns({
                                                container: '.image-tns',
                                                items: 1,
                                                slideBy: 1,
                                                autoplay: false,
                                                autoWidth: false,
                                                loop: true,
                                                rewind: false,
                                                gutter: 0,
                                                swipeAngle: 15,
                                                preventScrollOnTouch: 'auto',
                                                nav: true,
                                                navContainer: '.tns-indicators',
                                                lazyload: true,
                                                controlsContainer: '.tns-ctrl-image',
                                                prevButton: '.tns-ctrl-image .left',
                                                nextButton: '.tns-ctrl-image .right',
                                                startIndex: initialIndex
                                            });
                                            tns_wrapper.events.on('transitionEnd', transitionEnd);
                                            // Broadcast on index change for carousel sync
                                            tns_wrapper.events.on('indexChanged', function (info) {
                                                $timeout(function () {
                                                    $rootScope.$broadcast('modal:carouselIndexChanged', {
                                                        index: info.index,
                                                        displayIndex: info.displayIndex
                                                    });
                                                }, 0);
                                            });
                                        });
                                    });
                            };


                            const plainPhone = user ? user.phoneNumber : proper.UserInfo.UserTel;

                            $scope.phoneFormated = $window.phoneFormat(plainPhone, proper ? proper.CountryId : null);
                            if ($scope.phoneFormated && proper) {
                                $scope.phoneHidden = $scope.phoneFormated.slice(0, 7);
                            }


                            $scope.userAgent = user ? user.officeName : proper.UserInfo.UserAgent;
                            $scope.userName = user ? user.name : proper.UserInfo.UserName;
                            $scope.userSurname = user ? user.surName : proper.UserInfo.UserSurname;
                            $scope.userLogo = user ? user.logoUrl : proper.UserInfo.UserLogo;
                            $scope.userAvatar = user ? user.avatarUrl : null;
                            $scope.userSlogan = user ? user.userSlogan : null;

                            $scope.showNumber = false;
                            $scope.show = function () {
                                userview_factory.post({ userId: { value: proper.UserId }, Phone: plainPhone }).$promise.then(function () {
                                    $scope.showNumber = true;
                                }, function () {
                                    $scope.showNumber = true;
                                });
                                $window.dataLayer.push({
                                    event: "select_content",
                                    currency: window.currency,
                                    language: window.lang.split('-')[0],
                                    content_type: "agent",
                                    item_id: proper.UserId,
                                    item_name: $scope.userName + ' ' + $scope.userSurname
                                });
                                // $window.gtag("event", "select_content", {
                                //     content_type: "agent",
                                //     item_id: proper.UserId,
                                //     item_name: $scope.userName + ' ' + $scope.userSurname
                                // });
                            };

                            $scope.updateDate = proper.UpdateDate;

                            if (proper.OwnerName) {
                                $scope.ownerName = proper.OwnerName.split(' Danışman :')[0];
                                $scope.ownerAgent = proper.OwnerName.split(' Danışman :')[1];
                                $scope.ownerLogo = proper.OwnerLogo;
                            }

                            $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                $timeout(function () {
                                    var totalItems = $('.tns-indicators li').length;
                                    var initialIndex = $scope.startIndex || 0;
                                    $('.carousel-trad .image-count span').html((initialIndex + 1) + '/' + totalItems + '');
                                    tns_wrapper = tns({
                                        container: '.image-tns',
                                        slideBy: 1,
                                        autoplay: true,
                                        autoplayHoverPause: true,
                                        autoplayButton: false,
                                        autoplayButtonOutput: false,
                                        autoWidth: false,
                                        loop: false,
                                        rewind: true,
                                        gutter: 15,
                                        nav: true,
                                        swipeAngle: false,
                                        navContainer: '.tns-indicators',
                                        lazyload: true,
                                        controlsContainer: '.tns-ctrl-image',
                                        prevButton: '.tns-ctrl-image .left',
                                        nextButton: '.tns-ctrl-image .right',
                                        startIndex: initialIndex
                                    });
                                    tns_wrapper.events.on('transitionEnd', transitionEnd);
                                    // Broadcast on index change for carousel sync
                                    tns_wrapper.events.on('indexChanged', function (info) {
                                        $timeout(function () {
                                            $rootScope.$broadcast('modal:carouselIndexChanged', {
                                                index: info.index,
                                                displayIndex: info.displayIndex
                                            });
                                        }, 0);
                                    });
                                }, 100);
                            });
                            // listing site
                            $scope.goToListingSite = function (url) {
                                $window.PopupCenter(url, 'İlan', $window.innerWidth * 0.8, $window.innerHeight * 0.9);
                            };
                        }]
                    });
                }
            };

            $rootScope.isNumber = function (number) {
                if (number && $window.isFinite(number) && +number !== 0)
                    return true;
                return false;
            };

            $window.phoneFormat = function (phone, country) {
                if (!phone) return '';
                let countryCode;
                switch (country) {
                    case 1:
                        countryCode = 'TR';
                        break;
                    case 2:
                        countryCode = 'ES';
                        break;
                    case 3:
                        countryCode = 'PT';
                        break;
                    default:
                        countryCode = 'TR';
                }
                let isValid = window.libphonenumber.isValidPhoneNumber(phone, countryCode);
                if (isValid)
                    return window.libphonenumber.parsePhoneNumber(phone, countryCode).formatInternational();
                else return '';
                /* const countryCode = country === 3 ? '+351' : country === 2 ? '+34' : '+90';
                if (phone && phone.toString().charAt(0) !== "0" && phone.toString().charAt(0) !== "+")
                    phone = countryCode + phone;
                else if (phone && phone.toString().charAt(0) === "0")
                    phone = "+9" + phone;

                phone = phone ? phone.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "") : null;

                phone = phone ? "+" + phone.split(',')[0].split('+')[1] : phone;

                if (phone && country === 2) {
                    return phone.replace(/^(.{3})(.{3})(.{3})(.{3})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else if (phone && country === 3) {
                    return phone.replace(/^(.{4})(.{3})(.{3})(.{3})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else if (phone) {
                    return phone.replace(/^(.{3})(.{3})(.{3})(.{2})(.*)$/, "$1 $2 $3 $4 $5");
                }
                else {
                    return phone;
                } */
            };
            $rootScope.phoneFormat = $window.phoneFormat;

            $rootScope.history = function (alarm) {
                $rootScope.historyList = [];
                $rootScope.historyLoading = true;
                ngDialog.open({
                    templateUrl: "app/bolgesel-analiz/views/alarm-history.html",
                    scope: $rootScope,
                    overlay: true,
                    closeByEscape: false,
                    showClose: false,
                    closeByNavigation: false,
                    disableAnimation: true,
                    closeByDocument: false,
                    controller: [
                        "$scope",
                        function ($scope) {
                            $scope.alarmItem = alarm;
                            valuationGETAPI.comparables({
                                EndeksaId: alarm.EndeksaId,
                                /* propertycategory: alarm.PropertyCategory,
                                countryid: alarm.CountryId */
                            })
                                .$promise.then(function (list) {
                                    if (list.History.length > 0) {
                                        $rootScope.historyList = list.History;
                                    } else {
                                        $rootScope.historyList = [{ ListingActive: alarm.ListingActive, Price: alarm.RealtyPrice, Date: alarm.CreateDate }];
                                    }
                                    $rootScope.historyLoading = false;
                                });
                        },
                    ],
                });
            };

            $rootScope.usageStatusList = function (comparable) {
                switch (comparable.UsageStatus) {
                    case 1:
                        return $translate.instant('usage_owner');
                    case 2:
                        return $translate.instant('usage_tenant');
                    case 3:
                        return $translate.instant('step2_empty');
                    default:
                        return '';
                }
            };

            $rootScope.comparablesModal = function (comparable) {
                if (!comparable.CurrencyId && comparable.Currency)
                    comparable.CurrencyId = comparable.Currency;
                comparablesApi.detail({ EndeksaId: comparable.EndeksaId, captchaTokenCustom: window.ecSec() }).$promise.then(function (result) {
                    $rootScope.currentComparable = result;
                }, function () {
                    $rootScope.currentComparable = comparable;
                }).finally(() => {
                    if (!iframeOpen || !ngDialog.isOpen(iframeOpen.id)) {
                        iframeOpen = ngDialog.open({
                            templateUrl: 'app/shell/comparables-modal.html',
                            overlay: true,
                            closeByEscape: true,
                            showClose: false,
                            closeByNavigation: true,
                            closeByDocument: true,
                            preCloseCallback: function () {
                                if (tns_wrapper && tns_wrapper.events) {
                                    tns_wrapper.destroy();
                                }
                            },
                            className: 'ngdialog-theme-default iframe-dialog',
                            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                                $ocLazyLoad.load("/assets/js/tiny-slider.js?v=" + $window.appVersion).then(function () {
                                    $timeout(function () {
                                        tns_wrapper = tns({
                                            container: '.comparable-tns',
                                            autoWidth: false,
                                            loop: false,
                                            rewind: true,
                                            nav: true,
                                            swipeAngle: false,
                                            navContainer: '.tns-indicators',
                                            controlsContainer: '.tns-ctrl-comparable',
                                            prevButton: '.tns-ctrl-comparable .left',
                                            nextButton: '.tns-ctrl-comparable .right'
                                        });
                                        tns_wrapper.events.on('transitionEnd', transitionEnd);
                                        $('#comparable-modal').scrollTop(0, 0);
                                        $window.scrollTo(0, 0);
                                    }, 100);
                                });
                                function transitionEnd() {
                                    var totalItems = $('.tns-indicators li').length;
                                    var currentIndex = $('.tns-indicators li.tns-nav-active').index() + 1;
                                    $('.carousel-wrapper .image-count span').html('' + currentIndex + '/' + totalItems + '');
                                }


                                $scope.formatPhone = function (phone) {
                                    return $window.phoneFormat(phone, $scope.currentComparable.CountryId);
                                };

                                $scope.getPriceType = function () {
                                    if (!angular.isString($scope.currentComparable.PropertyPriceTypeId))
                                        return $scope.currentComparable.PropertyPriceTypeId === 1 ? $translate.instant("value_filter_model_1") : $translate.instant("value_filter_model_2");
                                    return $scope.currentComparable.PropertyPriceType.toLocaleProperCase2();
                                };

                                $scope.getFrontage = function () {
                                    let frontages = [];
                                    if ($scope.currentComparable.FrontageEast)
                                        frontages.push($translate.instant("frontage_east"));
                                    if ($scope.currentComparable.FrontageWest)
                                        frontages.push($translate.instant("frontage_west"));
                                    if ($scope.currentComparable.FrontageSouth)
                                        frontages.push($translate.instant("frontage_south"));
                                    if ($scope.currentComparable.FrontageNorth)
                                        frontages.push($translate.instant("frontage_north"));

                                    return frontages;
                                };



                                $rootScope.viewData = $rootScope.getCompViewData($rootScope.currentComparable);
                                $rootScope.attrData = $rootScope.getCompAttrData($rootScope.currentComparable);






                            }]
                        });
                    }
                });


            };



            function heatingSystemList() {
                return [
                    {
                        label: $translate.instant('propertyHeatingNone'),
                        value: 10
                    },
                    {
                        label: $translate.instant('propertyHeatingStove'),
                        value: 20
                    },
                    {
                        label: $translate.instant('propertyHeatingGasNatural'),
                        value: 30
                    },
                    {
                        label: $translate.instant('propertyHeatingHeater'),
                        value: 40
                    },
                    {
                        label: $translate.instant('propertyHeatingCombi'),
                        value: 50
                    },
                    {
                        label: $translate.instant('propertyHeatingCentral'),
                        value: 60
                    },
                    {
                        label: $translate.instant('propertyHeatingMeater'),
                        value: 70
                    },
                    {
                        label: $translate.instant('propertyHeatingFloor'),
                        value: 80
                    },
                    {
                        label: $translate.instant('propertyHeatingAirConditioner'),
                        value: 90
                    },
                    {
                        label: $translate.instant('propertyHeatingGeo'),
                        value: 100
                    },
                    {
                        label: $translate.instant('propertyHeatingSolar'),
                        value: 110
                    },
                    {
                        label: $translate.instant('VRF'),
                        value: 130
                    },
                    {
                        label: $translate.instant('FanCoil'),
                        value: 140
                    },
                    {
                        label: $translate.instant('Akaryakıt'),
                        value: 150
                    },
                    {
                        label: $translate.instant('Elektrik'),
                        value: 160
                    },
                    {
                        label: $translate.instant('Propan/Butan Gazı'),
                        value: 170
                    },
                    {
                        label: $translate.instant('list_other'),
                        value: 120
                    }
                ];
            }

            $rootScope.getCompAttrData = (comparable) => {
                const attributes = comparable.Attributes;
                let attrList;
                if (!attributes || !attributes.length) attrList = [];

                attrList = [
                    {
                        label: $translate.instant('propertyPossMainRoad'),
                        value: attributes.find((x) => x === 10) || false,
                        icon: 'listing-road'
                    },
                    {
                        label: $translate.instant('Cadde Üzerinde'),
                        value: attributes.find((x) => x === 15) || false,
                        icon: 'listing-wideroad'
                    },
                    {
                        label: $translate.instant('in_complex'),
                        value: attributes.find((x) => x === 20) || false,
                        icon: 'apartment'
                    },
                    {
                        label: $translate.instant('propertyPossSport'),
                        value: attributes.find((x) => x === 30) || false,
                        icon: 'listing-gym'
                    },
                    {
                        label: $translate.instant('Çocuk Oyun Parkı'),
                        value: attributes.find((x) => x === 40) || false,
                        icon: 'listing-playground'
                    },
                    {
                        label: $translate.instant('elevator'),
                        value: attributes.find((x) => x === 50) || false,
                        icon: 'listing-elevator'
                    },
                    {
                        label: $translate.instant('propertyPossGenerator'),
                        value: attributes.find((x) => x === 60) || false,
                        icon: 'listing-generator'
                    },
                    {
                        label: $translate.instant('propertyPossBuilding'),
                        value: attributes.find((x) => x === 70) || false,
                        icon: 'listing-gatekeeper'
                    },
                    {
                        label: $translate.instant('security'),
                        value: attributes.find((x) => x === 80) || false,
                        icon: 'listing-security'
                    },
                    {
                        label: $translate.instant('propertyPossOutDoor'),
                        value: attributes.find((x) => x === 90) || false,
                        icon: 'listing-parking'
                    },
                    {
                        label: $translate.instant('indoor_parking'),
                        value: attributes.find((x) => x === 100) || false,
                        icon: 'listing-garage'
                    },
                    {
                        label: $translate.instant('indoor_pool'),
                        value: attributes.find((x) => x === 110) || false,
                        icon: 'listing-indoorpool'
                    },
                    {
                        label: $translate.instant('Havuz'),
                        value: attributes.find((x) => x === 120) || false,
                        icon: 'listing-pool'
                    },
                    {
                        label: $translate.instant('Isı Yalıtımı'),
                        value: attributes.find((x) => x === 130) || false,
                        icon: 'listing-wall'
                    },
                    {
                        label: $translate.instant('Klima'),
                        value: attributes.find((x) => x === 150) || false,
                        icon: 'listing-heating'
                    },
                    {
                        label: $translate.instant('Şömine'),
                        value: attributes.find((x) => x === 155) || false,
                        icon: 'listing-fireplace'
                    },
                    {
                        label: $translate.instant('Elektrik'),
                        value: attributes.find((x) => x === 170) || false,
                        icon: 'listing-generator'
                    },
                    {
                        label: $translate.instant('Su'),
                        value: attributes.find((x) => x === 175) || false,
                        icon: 'listing-water'
                    },
                    {
                        label: $translate.instant('Yolu Açık'),
                        value: attributes.find((x) => x === 180) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Köşe Parsel'),
                        value: attributes.find((x) => x === 185) || false,
                        icon: 'listing-corner'
                    },
                    {
                        label: $translate.instant('İfraz Görmüş'),
                        value: attributes.find((x) => x === 190) || false,
                        icon: 'listing-divide'
                    },
                    {
                        label: $translate.instant('Denize Sıfır'),
                        value: attributes.find((x) => x === 195) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Denize Yakın'),
                        value: attributes.find((x) => x === 200) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Toplu Ulaşıma Yakın'),
                        value: attributes.find((x) => x === 201) || false,
                        icon: 'transportation'
                    },
                    {
                        label: $translate.instant('Havaalanına Yakın'),
                        value: attributes.find((x) => x === 202) || false,
                        icon: 'listing-airport'
                    },
                    {
                        label: $translate.instant('Doğalgaz Altyapısı'),
                        value: attributes.find((x) => x === 210) || false,
                        icon: 'listing-gas'
                    },
                    {
                        label: $translate.instant('p_telephone'),
                        value: attributes.find((x) => x === 220) || false,
                        icon: 'phone'
                    },
                    {
                        label: $translate.instant('drain'),
                        value: attributes.find((x) => x === 230) || false,
                        icon: 'listing-sewer'
                    },
                    {
                        label: $translate.instant('ground_survey'),
                        value: attributes.find((x) => x === 240) || false,
                        icon: 'listing-survey'
                    },
                    {
                        label: $translate.instant('close_to_the_road'),
                        value: attributes.find((x) => x === 250) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Sokak Üzerinde'),
                        value: attributes.find((x) => x === 260) || false,
                        icon: 'listing-open-road'
                    },
                    {
                        label: $translate.instant('Denizle İlişkisi Yok'),
                        value: attributes.find((x) => x === 270) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Hidrofor'),
                        value: attributes.find((x) => x === 280) || false,
                        icon: 'listing-pump'
                    },
                    {
                        label: $translate.instant('Su Deposu'),
                        value: attributes.find((x) => x === 290) || false,
                        icon: 'listing-watertank'
                    },
                    {
                        label: $translate.instant('Hırsız Alarmı'),
                        value: attributes.find((x) => x === 300) || false,
                        icon: 'listing-alarm'
                    },
                    {
                        label: $translate.instant('Yangın Alarmı'),
                        value: attributes.find((x) => x === 310) || false,
                        icon: 'listing-sensor-fire'
                    },
                    {
                        label: $translate.instant('İnternet Altyapısı'),
                        value: attributes.find((x) => x === 320) || false,
                        icon: 'listing-home-internet'
                    },
                    {
                        label: $translate.instant('Yangın Merdiveni'),
                        value: attributes.find((x) => x === 330) || false,
                        icon: 'listing-stairs'
                    },
                    {
                        label: $translate.instant('Güvenlik Kamerası'),
                        value: attributes.find((x) => x === 340) || false,
                        icon: 'listing-cctv'
                    },
                    {
                        label: $translate.instant('TV-Uydu Altyapısı'),
                        value: attributes.find((x) => x === 350) || false,
                        icon: 'listing-tv'
                    },
                    {
                        label: $translate.instant('Yeşil Alan'),
                        value: attributes.find((x) => x === 360) || false,
                        icon: 'listing-park'
                    },
                    {
                        label: $translate.instant('Balkon'),
                        value: attributes.find((x) => x === 370) || false,
                        icon: 'listing-balcony'
                    }
                ];

                const heatType = heatingSystemList().find(
                    (i) => i.value === comparable.HeatType || i.value === comparable.Heating
                );

                if (heatType)
                    attrList.push({
                        label: heatType.label,
                        value: heatType.value,
                        icon: 'listing-isolation'
                    });

                if (comparable.UsageStatus) {
                    attrList.push({
                        label: $rootScope.usageStatusList(comparable),
                        value: 1,
                        icon: 'tenant'
                    });
                }

                return attrList;
            };

            $rootScope.getCompViewData = function (comparable) {
                const views = comparable.Views;
                if (!views || !views.length) return [];

                return [
                    {
                        label: $translate.instant('Şehir Manzarası'),
                        value: views.find((x) => x === 50) || false,
                        icon: 'listing-city'
                    },
                    {
                        label: $translate.instant('Doğa Manzarası'),
                        value: views.find((x) => x === 60) || false,
                        icon: 'listing-nature'
                    },
                    {
                        label: $translate.instant('Göl Manzarası'),
                        value: views.find((x) => x === 70) || false,
                        icon: 'listing-lake'
                    },
                    {
                        label: $translate.instant('Deniz Manzarası'),
                        value: views.find((x) => x === 80) || false,
                        icon: 'listing-sea'
                    },
                    {
                        label: $translate.instant('Boğaz'),
                        value: views.find((x) => x === 90) || false,
                        icon: 'listing-bridge'
                    }
                ];


            };

            $rootScope.getFromWho = function (id) {
                switch (id) {
                    case -1:
                        return 'Endeksa ' + $translate.instant('layout_menu51');
                    case 1:
                        return $translate.instant('list_owner2');
                    case 2:
                        return $translate.instant('list_agent');
                    case 4:
                        return $translate.instant('list_bank');
                    case 3:
                        return $translate.instant('list_company');
                    default:
                        return $translate.instant('list_other');
                }
            };

            /* $rootScope.getCompPhoneList = function (item) {
                if (item.OwnerTel)
                    if (!angular.isObject(item.OwnerTel) && item.OwnerTel.indexOf(', ') > -1)
                        return item.OwnerTel.split(', ');
                    else if (!angular.isObject(item.OwnerTel) && item.OwnerTel.match(/\+/g) && item.OwnerTel.match(/\+/g).length > 1)
                        return item.OwnerTel.split(' ');
                    else if (angular.isObject(item.OwnerTel)) {
                        return item.OwnerTel;
                    }
                return [item.OwnerTel];
            }; */

            $rootScope.getPropertyTypeName = function (id) {
                switch (id) {
                    //Konut
                    case 1:
                        return 'Müstakil Ev';
                    case 2:
                    case 10000201:
                        return 'Apartman Dairesi';

                    //Ticari
                    case 10000202:
                        return 'value_filter_ofis_imalat';
                    case 10000203:
                        return 'AVM';
                    case 10000204:
                        return 'Komple Bina';
                    case 10000205:
                        return 'Depo & Antrepo';
                    case 10000206:
                        return 'Dükkan & Mağaza';
                    case 10000207:
                        return 'value_filter_ofis_fabrika';
                    case 10000208:
                        return 'Genel';
                    case 10000209:
                        return 'Sağlık Merkezi';
                    case 10000211:
                        return 'İş Hanı Katı & Ofisi';
                    case 10000212:
                        return 'Tatil Köyü';
                    case 10000213:
                        return 'Kaplıca Tesisi';
                    case 10000214:
                        return 'Büro & Ofis';
                    case 10000215:
                        return 'Plaza Katı & Ofisi';
                    case 10000216:
                        return 'Komple Plaza';
                    case 10000217:
                        return 'Müstakil İşyeri';
                    case 10000219:
                        return 'Turistik İşletme';
                    case 10000222:
                        return 'Eczane & Medikal';
                    case 10000223:
                        return 'Taksi Durağı';
                    case 10000224:
                        return 'Pazar Yeri';
                    case 10000226:
                        return 'Villa Katı';
                    case 10000227:
                        return 'value_filter_ofis_otel';
                    case 10000228:
                        return 'Benzin İstasyonu';
                    case 10000229:
                        return 'value_filter_ofis_mulk';
                    case 10000231:
                        return 'Büfe & Market';
                    case 10000303:
                    case 10000232:
                        return 'Çiftlik';
                    case 10000233:
                        return 'Yeme & İçme';
                    case 10000234:
                        return 'Yurt & Pansiyon';
                    case 10000235:
                        return 'Kamp Yeri (Mocamp)';

                    //Arsa & Tarla
                    case 10:
                        return 'value_filter_land4';
                    case 20:
                        return 'Tarla';
                    case 30:
                        return 'Zeytinlik';
                    case 40:
                        return 'Tarla, Bağ, Bahçe';
                    case 50:
                        return 'Konut';
                    case 60:
                        return 'Villa İmarlı';
                    case 70:
                        return 'Konut İmarlı';
                    case 10000304:
                        return 'Depo, Antrepo İzinli';
                    case 10000305:
                        return 'Hastane (Sağlık Tesisi)';
                    case 10000307:
                        return 'Sanayi İmarlı';
                    case 10000308:
                        return 'ticariimar';
                    case 10000309:
                        return 'Konut + Ticari';
                    case 10000310:
                        return 'Maden Ocağı';
                    case 10000311:
                        return 'Muhtelif Arsa';
                    case 10000312:
                        return 'Okul (Eğitim Tesisi)';
                    case 10000313:
                        return 'Özel Kullanım';
                    case 10000314:
                        return 'Sit Alanı';
                    case 10000316:

                    case 10000317:
                        return 'Turizm İmarlı';
                    case 10000401:
                        return 'Ada - Toprak Parçası';
                    case 10000402:
                        return 'A-Lejantlı';
                    case 10000403:
                        return 'Enerji Depolama';
                    case 10000404:
                        return 'Sera';
                    case 10000405:
                        return 'Spor Alanı';
                    case 10000406:
                        return 'Turizm + Konut';
                    case 10000407:
                        return 'Turizm + Ticari';

                    case 99:
                    case 10000236:
                    case 10000400:
                        return 'list_other';

                    default:
                        return 'list_other';
                }
            };

            $rootScope.calculateDaysWithComp = function (comp) {
                let lastDate;
                if (comp.ListingActive) {
                    lastDate = new Date();
                } else {
                    lastDate = new Date(comp.LastActivityDate);
                }
                var end = moment(lastDate);
                var start = moment(comp.CreateDate);
                var duration = moment.duration(end.diff(start));
                var days = duration.asDays();
                return Math.ceil(days);
            };

            $rootScope.lastUpdateDate = function (comparable) {
                if (!comparable.LastActivityDate) {
                    return comparable.UpdateDate;
                }
                return comparable.UpdateDate > comparable.LastActivityDate
                    ? comparable.UpdateDate
                    : comparable.LastActivityDate;
            };

            var isTop = $window.hasAllowance;
            if (isTop) {
                $('body').css('padding-top', '0');
                $('#top-nav-bar').remove();
                $rootScope.isTop = true;
            }

            $rootScope.showOptIn = false;
            $rootScope.setDengagePermission = function (perm) {
                $rootScope.showOptIn = false;
                if (perm === 'granted')
                    dengage('showNativePrompt');
                else {
                    let now = new Date();

                    let item = {
                        value: perm,
                        expiry: now.getTime() + (60000 * 60 * 48),
                    };
                    $window.localStorage.setItem('webPushDeny', JSON.stringify(item));
                }
            };
            if ((window.location.host === 'www.endeksa.com' || $window.location.host === 'preprod.endeksa.com') && $window.location.href.indexOf('top=') === -1 && !window.isHeadless()) {
                var engageCheck = $interval(function () {
                    let itemStr = $window.localStorage.getItem('webPushDeny');
                    let requestPerm = false;

                    if (!itemStr) {
                        requestPerm = true;
                    }

                    if (!requestPerm) {
                        let item = JSON.parse(itemStr);
                        let now = new Date();

                        if (now.getTime() > item.expiry) {
                            $window.localStorage.removeItem('webPushDeny');
                            requestPerm = true;
                        }
                    }


                    if (typeof dengage !== 'undefined') {
                        dengage('initialize');
                        dengage('isPushNotificationsSupported', function (isSupported) {
                            if (isSupported && $('.cky-overlay').hasClass('cky-hide')) { //cookie modalı yoksa gösterelim
                                dengage('getNotificationPermission', function (permission) {
                                    if (requestPerm && permission === 'default') {
                                        $rootScope.showOptIn = true;
                                    }
                                });
                            }
                        });
                        $interval.cancel(engageCheck);
                    }
                }, 500);
            }

            // if (!$rootScope.ad && $rootScope.SignedIn && !isTop)
            //     $timeout(function () {
            //         if ($window.location.pathname.indexOf('payment') === -1 &&
            //             $window.location.pathname.indexOf('cozumler') === -1 &&
            //             $window.location.pathname.indexOf('urunler') === -1 &&
            //             $window.location.pathname.indexOf('register') === -1 &&
            //             $window.location.pathname.indexOf('signin') === -1 &&
            //             $window.location.pathname.indexOf('solutions') === -1 &&
            //             $window.location.pathname.indexOf('products') === -1) {
            //             try {
            //                 var remindDate = $window.userStorage.getItem('survey_date');
            //                 var a = moment();
            //                 var b = moment(remindDate);
            //                 var diff = a.diff(b, 'days');
            //                 var opened = ngDialog.getOpenDialogs();
            //                 var survey = $window.userStorage.getItem('survey');
            //                 if (!opened.length && $window.lang === 'tr' && !survey && (!remindDate || diff >= 1) && !$window.selectedLocation)
            //                     if (userSvc.info.SignedIn)
            //                         userSvc.getUserInfo().then(function (account) {
            //                             if (account && account.information.id.value) {
            //                                 var id = account.information.id.value;
            //                                 continueList(id);
            //                             }
            //                         }, function (err) {
            //                             deferred.reject(err);
            //                         });
            //                     else
            //                         continueList('');
            //             } catch (err) {
            //                 //ignored
            //             }
            //         }
            //     }, 20000);



            // var continueList = function (id) {
            //     var finger;
            //     var options = {
            //         excludes: {
            //             'enumerateDevices': true,
            //             'pixelRatio': true,
            //             'doNotTrack': true,
            //             'fontsFlash': true,
            //             'webgl': true,
            //             'webglVendorAndRenderer': true
            //         }
            //     };
            //     try {
            //         $window.Fingerprint2.get(options, function (components) {
            //             var values = components.map(function (component) { return component.value; });
            //             finger = $window.Fingerprint2.x64hash128(values.join(''), 31);
            //             pollAPI.get({ userid: id, userfinger: finger, lang: $window.lang }).$promise.then(function (result) {
            //                 var question = result.Questions[0];
            //                 var district = result.DistrictId;
            //                 if (question)
            //                     ngDialog.open({
            //                         templateUrl: 'app/shell/poll-question.html',
            //                         className: 'ng-dialog-bottom',
            //                         bodyClassName: '',
            //                         overlay: false,
            //                         closeByEscape: false,
            //                         showClose: false,
            //                         closeByNavigation: false,
            //                         disableAnimation: true,
            //                         closeByDocument: true,
            //                         controller: ['$scope', 'pollAPI', '$timeout', 'geoApi', 'yandexGeocode', function ($scope, pollAPI, $timeout, geoApi, yandexGeocode) {
            //                             $scope.useLocationPoll = function () {
            //                                 if (navigator.geolocation) {
            //                                     navigator.geolocation.getCurrentPosition(function (position) {
            //                                         if (position) {
            //                                             $window.selectedLocation = position.coords.longitude + ' ' + position.coords.latitude;
            //                                             $timeout(function () {
            //                                                 $scope.findDistrict();
            //                                             }, 100);
            //                                         }
            //                                     }, function () { }, {
            //                                         enableHighAccuracy: true,
            //                                         timeout: 5000,
            //                                         maximumAge: 0
            //                                     });
            //                                 }
            //                             };
            //                             $scope.address = "";
            //                             $scope.question = question.Question;
            //                             $scope.showDistrict = !district;
            //                             $scope.no = function () {
            //                                 if ($window.selectedLocation && $scope.showDistrict) {
            //                                     $scope.findDistrict();
            //                                 }

            //                                 pollAPI.post({ UserId: id, UserFinger: finger, Answer: false, QuestionId: question.QuestionId, DistrictId: district }).$promise.then(function () {

            //                                 });
            //                             };
            //                             $scope.remind = function () {
            //                                 $window.userStorage.setItem('survey_date', moment());
            //                             };
            //                             $scope.yes = function () {
            //                                 if ($window.selectedLocation && $scope.showDistrict) {
            //                                     $scope.findDistrict();
            //                                 }
            //                                 pollAPI.post({ UserId: id, UserFinger: finger, Answer: true, QuestionId: question.QuestionId, DistrictId: district }).$promise.then(function () {

            //                                 });
            //                             };

            //                             $scope.findDistrict = function () {
            //                                 if ($window.selectedLocation || $scope.address) {
            //                                     var lat, lng;
            //                                     if ($window.selectedLocation) {
            //                                         lat = +window.selectedLocation.split(' ')[1];
            //                                         lng = +window.selectedLocation.split(' ')[0];
            //                                     }
            //                                     yandexGeocode.geocodeAddress($scope.address, null, lat).then(function (location) {
            //                                         var geoAp = geoApi.get({ Lat: lat ? +lat : location.lat(), Long: lng ? +lng : location.lng(), Level: 3 });
            //                                         geoAp.$promise.then(function (resb) {
            //                                             district = resb.features[0].id;
            //                                             $scope.showDistrict = false;
            //                                         }, function (err) { console.log(err); });
            //                                     });
            //                                 }
            //                             };
            //                         }]
            //                     });
            //                 else {
            //                     $window.userStorage.setItem('survey', 1);
            //                 }
            //             });
            //         });
            //     } catch (err) {
            //         //ignored
            //     }
            // };

            // Currency conversion function - moved from controllers to $rootScope
            $rootScope.convertCurrency = function (value, sourceCurrency, targetCurrency) {
                value = value || 0;

                if (typeof sourceCurrency === 'number') {
                    sourceCurrency = $window.currencyIso(sourceCurrency);
                }

                if (typeof targetCurrency === 'number') {
                    targetCurrency = $window.currencyIso(targetCurrency);
                }

                if ($window.currencyRates) {
                    if (sourceCurrency === "TRY") {
                        if (targetCurrency === "USD")
                            value = value / $window.currencyRates.usd;
                        else if (targetCurrency === "EUR")
                            value = value / $window.currencyRates.eur;
                        else
                            value = value;
                    }
                    else if (sourceCurrency === "USD") {
                        if (targetCurrency === "TRY")
                            value = value * $window.currencyRates.usd;
                        else if (targetCurrency === "EUR")
                            value = value * $window.currencyRates.usd / $window.currencyRates.eur;
                        else
                            value = value;
                    }
                    else if (sourceCurrency === "EUR") {
                        if (targetCurrency === "TRY")
                            value = value * $window.currencyRates.eur;
                        else if (targetCurrency === "USD")
                            value = value * $window.currencyRates.eur / $window.currencyRates.usd;
                        else
                            value = value;
                    }
                }

                return Math.round(value);
            };
        }]);

})();

/**
 * This file contains the configuration and initialization of the AngularJS app.
 * It defines the modules, constants, providers, and configuration settings used by the app.
 * The file also includes the definition of the global colors array and exception handling logic.
 * Additionally, it configures the translation and localization settings for the app.
 */
(function () {
    "use strict";

    var app = angular.module("app", [
        "ui.router",
        "angular.filter",
        // "angulartics",
        // "angulartics.google.analytics",
        // "angulartics.google.tagmanager",
        "pascalprecht.translate",
        "tmh.dynamicLocale",
        "ui.bootstrap.pagination",
        // "angulartics.mixpanel",
        // "angulartics.intercom",
        "ngAnimate",
        "ngResource",
        "ngLocale",
        "cleave.js",
        "angularMoment",
        "ui.router.metatags",
        "angular-cache",
        "ngDialog",
        "oc.lazyLoad",
        "angular-loading-bar",
        "ngCookies",
        "LocalStorageModule",
        "angular.bind.notifier",
        "app.resources",
        "app.newresources",
        "app.locale",
        "app.core",
        "app.shell",
        "app.common",
        "app.security"
    ]);

    app.constant("LOCALES", {
        locales: {
            "tr": "Türkçe",
            "en": "English",
            "es-ES": "Español",
            "pt-PT": "Português"
        },
        preferredLocale: "en",
    });

    app.config([
        "$httpProvider",
        "$anchorScrollProvider",
        "$qProvider",
        "$locationProvider",
        "$logProvider",
        "$compileProvider",
        "UIRouterMetatagsProvider",
        // "$analyticsProvider",
        "$urlMatcherFactoryProvider",
        "$sceDelegateProvider",
        "$provide",
        "$translateProvider",
        "$translatePartialLoaderProvider",
        "tmhDynamicLocaleProvider",
        "cfpLoadingBarProvider",
        "$ocLazyLoadProvider",
        // "DoubleClickProvider",
        "CacheFactoryProvider",
        "$animateProvider",
        function (
            $httpProvider,
            $anchorScrollProvider,
            $qProvider,
            $locationProvider,
            $logProvider,
            $compileProvider,
            UIRouterMetatagsProvider,
            // $analyticsProvider,
            $urlMatcherFactoryProvider,
            $sceDelegateProvider,
            $provide,
            $translateProvider,
            $translatePartialLoaderProvider,
            tmhDynamicLocaleProvider,
            cfpLoadingBarProvider,
            $ocLazyLoadProvider,
            // DoubleClickProvider,
            CacheFactoryProvider,
            $animateProvider
        ) {
            $httpProvider.interceptors.push('secureHttpInterceptor');


            window.globalColors = [
                // "#798897", // light grey
                // "#FF0550", // red
                // "#0087E1", // blue
                // "#009C00",
                // "#FF5897", // yellow
                // "#574141", // dark gray
                // "#98A4AE", // grey
                // "#FD2000", // tomato
                // "#54BAC1", // steel blue
                // "#006B72", // dark blue
                // "#E29898", // dark magenta
                // "#BFA5A5", // gray
                // "#0087A0", // green
                // "#688D00",
                '#FF0550', // Brand Red - Primary brand color
                '#58B1FF', // Brand Blue - Secondary brand color
                '#4CAF50', // Success Green - Modern vibrant green
                '#FF9800', // Warm Orange - Complementary to blue
                '#9C27B0', // Purple - Modern purple for variety
                '#00BCD4', // Cyan - Fresh and modern
                '#FF5722', // Deep Orange - Energetic and warm
                '#2196F3', // Bright Blue - Clean and professional
                '#8BC34A', // Light Green - Natural and fresh
                '#E91E63', // Pink - Vibrant and attention-grabbing
                '#795548', // Brown - Earthy and grounded
                '#607D8B', // Blue Grey - Professional and modern
                '#FFC107', // Amber - Warm and optimistic
                '#3F51B5', // Indigo - Deep and trustworthy
                '#FF6B35', // Coral Orange - Warm and inviting
                '#26A69A', // Teal - Balanced and calming
                '#AB47BC', // Medium Purple - Sophisticated
                '#42A5F5', // Sky Blue - Fresh and open
                '#66BB6A', // Forest Green - Natural and stable
                '#FFA726', // Orange - Energetic and friendly
                '#EC407A', // Rose Pink - Soft and appealing
                '#5C6BC0', // Slate Blue - Professional and modern
                '#78909C', // Cool Grey - Neutral and balanced
                '#FFB300', // Golden Yellow - Bright and optimistic
                '#8D6E63', // Warm Brown - Earthy and reliable
                '#00ACC1', // Turquoise - Fresh and modern
                '#7E57C2', // Deep Purple - Rich and elegant
                '#29B6F6', // Light Blue - Clean and trustworthy
                '#9CCC65', // Lime Green - Vibrant and natural
                '#FF7043', // Burnt Orange - Warm and energetic
                '#F06292', // Soft Pink - Gentle and approachable
                '#5E35B1', // Purple Blue - Deep and sophisticated
                '#90A4AE', // Silver Grey - Modern and neutral
                '#FFCA28', // Bright Yellow - Cheerful and attention-grabbing
                '#A1887F', // Taupe - Sophisticated and warm
                '#4DB6AC', // Mint Teal - Fresh and calming
                '#9575CD', // Lavender - Soft and elegant
                '#64B5F6', // Powder Blue - Light and airy
                '#AED581', // Pale Green - Soft and natural
                '#FFB74D', // Peach - Warm and friendly
                '#F8BBD9', // Blush Pink - Delicate and soft
                '#7986CB', // Periwinkle - Calm and trustworthy
                '#B0BEC5', // Light Grey - Neutral and clean
                '#FFF176', // Pale Yellow - Bright and cheerful
                '#BCAAA4', // Mushroom - Earthy and subtle
                '#80CBC4', // Seafoam - Fresh and soothing
                '#BA68C8', // Orchid - Vibrant and elegant
                '#81C784', // Mint Green - Fresh and balanced
                '#FFAB91', // Salmon - Warm and inviting
                '#CE93D8' // Lilac - Soft and sophisticated
            ];

            // window.onerror = function (message, url, line, column, error) {
            //     console.error(message, url, line, column, error);
            // };
            $provide.decorator("$exceptionHandler", [
                "$delegate",
                "$window",
                function ($delegate, $window) {
                    return function (exception, cause) {
                        if (typeof $window.TrackJS !== "undefined")
                            $window.TrackJS && $window.TrackJS.track(exception);

                        // $window.gtag('event', 'exception', {
                        //     'description': exception,
                        //     'fatal': false
                        // });

                        // console.log(exception);
                        // window.dataLayer.push({
                        //     event: "exception",
                        //     exception: {
                        //         'description': exception,
                        //         'fatal': false
                        //     }
                        // });

                        // In *non-production* environments you may still want the error sent to the console.
                        // You can delegate to the original handler (console.error) if you would like.
                        // Warning, this can cause double tracking of errors, so do not use in production.
                        if ($window.location.host !== "www.endeksa.com")
                            $delegate(exception, cause);
                    };
                },
            ]);

            angular.extend(CacheFactoryProvider.defaults, {
                maxAge: 15 * 60 * 1000,
                cacheFlushInterval: 15 * 60 * 1000,
                deleteOnExpire: 'aggresive'
            });


            $httpProvider.useApplyAsync(true);
            $compileProvider.aHrefSanitizationWhitelist(
                /^\s*(https?|ftp|mailto|tel|javascript|http?):/
            );
            // $compileProvider.preAssignBindingsEnabled(true);
            //$compileProvider.strictComponentBindingsEnabled(true);

            // spiner provieder
            cfpLoadingBarProvider.includeSpinner = false;
            cfpLoadingBarProvider.includeBar = true;
            cfpLoadingBarProvider.latencyThreshold = 200;

            // $analyticsProvider.virtualPageviews(false);
            // $analyticsProvider.trackStates(false);
            // $analyticsProvider.trackRoutes(false);
            // $analyticsProvider.firstPageview(false);
            // $analyticsProvider.withAutoBase(false);

            $anchorScrollProvider.disableAutoScrolling();

            $qProvider.errorOnUnhandledRejections(false);

            $urlMatcherFactoryProvider.strictMode(false);
            $urlMatcherFactoryProvider.caseInsensitive(true);
            // $urlMatcherFactoryProvider.defaultSquashPolicy('nosquash');

            // DoubleClickProvider.defineSlot('/21155722/endeksa_web/endeksa_w_anasayfa', [[728, 90], [970, 90], 'fluid'], 'div-gpt-ad-1646319323246-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_anasayfa', [[320, 100], 'fluid'], 'div-gpt-ad-1646319558735-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_blog_anasayfa', ['fluid', [728, 90], [970, 90]], 'div-gpt-ad-1646319280660-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_blog_anasayfa', ['fluid', [320, 100]], 'div-gpt-ad-1646319514606-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_blog_detay', [[728, 90], 'fluid'], 'div-gpt-ad-1646319230642-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_blog_haberdetay', ['fluid', [320, 100]], 'div-gpt-ad-1646319467089-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_edo', [[300, 250], 'fluid'], 'div-gpt-ad-1646319178221-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_edo', [[320, 100], 'fluid'], 'div-gpt-ad-1646319412113-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_kdh', [[300, 250], 'fluid'], 'div-gpt-ad-1646319094131-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_kdh', ['fluid', [300, 250]], 'div-gpt-ad-1646319372037-0');

            // set languageKey
            var urlPath = window.location.pathname;
            var urlPathString = urlPath.split("/");
            var keyLanguage = urlPathString[1] === "tr" ? "tr" : urlPathString[1] === "es-ES" ? "es-ES" : urlPathString[1] === "pt-PT" ? "pt-PT" : "en";

            // Set window.lang early for meta tag generation
            window.lang = keyLanguage;

            // try {
            //     var langDefined = window.localStorage.getItem("Language");
            //     if (!langDefined) {
            window.localStorage.setItem("Language", keyLanguage);
            window.localStorage.setItem("NG_TRANSLATE_LANG_KEY", keyLanguage);
            //     }
            //     else {
            //         keyLanguage = langDefined;
            //     }
            // }
            // catch (err) {
            //     //ignored
            //     console.log(err);
            // }


            // translations
            // Core translations are now merged into a single file to reduce HTTP requests
            // Previously loaded 7 separate files (url, fatFooter, navigation_top, register_user, authentication, content, cities)
            // Now loads 1 merged file: locale_core.json
            // The merged file is loaded as a 'part' called 'core' through the partial loader
            $translatePartialLoaderProvider.addPart('core');

            var urlLocal = "/assets/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            if (window.location.host === 'www.endeksa.com')
                urlLocal = "https://cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            else if (window.location.host === 'beta.endeksa.com')
                urlLocal = "https://beta-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            else if (window.location.host === 'preprod.endeksa.com')
                urlLocal = "https://preprod-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            // translation Logic
            // NOTE: Removed .useLocalStorage() to prevent loading all 4 languages unnecessarily
            // This reduces critical request chain by 600-800ms by only loading current language
            // Browser HTTP cache (Cache-Control: max-age=31536000) handles caching efficiently
            $translateProvider
                .useLoader("$translatePartialLoader", {
                    urlTemplate: urlLocal,
                })
                .preferredLanguage(keyLanguage)  // Use detected language from URL
                .fallbackLanguage('en')
                .useSanitizeValueStrategy("escape");


            var urlAngLocal = "/assets/locale/angular-locale_{{locale}}.js";
            if (window.location.host === 'www.endeksa.com')
                urlAngLocal = "https://cdn.endeksa.com/locale/angular-locale_{{locale}}.js";
            else if (window.location.host === 'beta.endeksa.com')
                urlAngLocal = "https://beta-cdn.endeksa.com/locale/angular-locale_{{locale}}.js";
            else if (window.location.host === 'preprod.endeksa.com')
                urlAngLocal = "https://preprod-cdn.endeksa.com/locale/angular-locale_{{locale}}.js";

            tmhDynamicLocaleProvider
                .localeLocationPattern(
                    urlAngLocal
                );

            //orderBy Turkish Character support
            // $provide.decorator("orderByFilter", [
            //     function () {
            //         var decoratedFilter = function (items, field, reverse) {
            //             var filtered = [];
            //             if (items && items.length)
            //                 items.forEach(function (item) {
            //                     filtered.push(item);
            //                 });
            //             filtered.sort(function (a, b) {
            //                 var aa =
            //                     typeof a[field] === "string" ?
            //                         a[field].toLocaleLowerCase() :
            //                         a[field];
            //                 var bb =
            //                     typeof b[field] === "string" ?
            //                         b[field].toLocaleLowerCase() :
            //                         b[field];
            //                 if (typeof aa === "string") return aa.localeCompare(bb);
            //                 else if (bb > aa) return (reverse ? -1 : 1);
            //                 else if (bb < aa) return (reverse ? 1 : -1);
            //                 else return 0;
            //             });
            //             return filtered;
            //         };
            //         return decoratedFilter;
            //     },
            // ]);

            //secure configuration for widget do not delete
            $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                "self",
                // Allow loading from our assets domain.  Notice the difference between * and **.
                "https://beta.endeksa.com/api/**",
                "https://**.endeksa.com/**",
                "http://localhost:6476/**",
                "http://localhost:8080/**",
                "http://localhost:8082/**",
                "https://endeksa-beta-storage.s3.eu-central-1.amazonaws.com/**",
                "https://endeksa-storage.s3.eu-central-1.amazonaws.com/**"
            ]);
            UIRouterMetatagsProvider.setTitleSuffix(" - Endeksa")
                .setDefaultTitle("Endeksa")
                .setDefaultRobots(
                    window.location.host === "www.endeksa.com" || window.location.host === "localhost:8080" ?
                        "index, follow" :
                        "noindex, nofollow"
                )
                .setStaticProperties({
                    "fb:app_id": "691540207677953",
                    "og:site_name": "Endeksa",
                })
                .setOGURL(true);


            // Set default meta description based on detected language
            if (keyLanguage === 'tr')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "Gayrimenkulünüzün bulunduğu bölgede satış ve kira değerleri ne kadar? Kimler yaşıyor? Olanaklar neler? Tüm bu sorularınıza tek tık ile cevap alın!"
                );
            else if (keyLanguage === 'es-ES')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "¿Cuáles son las ventas y alquileres en la región donde se ubica su propiedad? ¿Cuáles son las posibilidades? ¡Obtenga respuestas a todas estas preguntas!"
                );
            else if (keyLanguage === 'pt-PT')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "Quais são as vendas e aluguéis na região onde seu imóvel está localizado? Quais são as possibilidades? Obtenha respostas para todas essas perguntas!"
                );
            else
                UIRouterMetatagsProvider.setDefaultDescription(
                    "What are the sales and rentals in the region your property located? What are the possibilities? Get answers to all these questions!"
                );



            // if (keyLanguage == 'tr')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, evimin değeri, evimin değeri ne kadar, nereye yatırım yapmalıyım, evimi nasıl değerlerim, konut endeksi, konut fiyatları, gayrimenkul değerleme, eksper, ekspertiz, gayrimenkul endeksi, rayiç, rayiç bedeller, fiyat trendi"
            //     );
            // else if (keyLanguage === 'es-ES')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, el valor de mi casa, cuanto vale mi casa, donde debo invertir, como valoro mi casa, indice de vivienda, precio de la vivienda, avalúo inmobiliario, avalúo, avalúo, índice inmobiliario, valores actuales de mercado, precio tendencia"
            //     );
            // else if (keyLanguage === 'pt-PT')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, o valor da minha casa, quanto vale a minha casa, onde devo investir, como valorizo minha casa, índice habitacional, preços das casas, avaliação imobiliária, avaliação, avaliação, índice imobiliário, valores atuais de mercado, preço tendência"
            //     );
            // else
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, the value of my house, how much is my house worth, where should I invest, how do I value my house, housing index, house prices, real estate appraisal, appraisal, appraisal, real estate index, current market values, price trend"
            //     );



            $locationProvider.hashPrefix("");
            $locationProvider.html5Mode(true);
            $animateProvider.classNameFilter(/angular-animate|fade|menu/);
            $compileProvider.commentDirectivesEnabled(false);

            if (window.location.host !== 'www.endeksa.com' && window.location.host !== 'preprod.endeksa.com') {
                $logProvider.debugEnabled(true);
                $compileProvider.debugInfoEnabled(true);

                $ocLazyLoadProvider.config({
                    debug: false,
                    events: true
                });
            }
            else {
                $logProvider.debugEnabled(false);
                $compileProvider.debugInfoEnabled(false);
            }
        },
    ]);
    var CACHE = "";
    var NONCACHE = "";
    var NONPROXIED = "";
    var NEW = "";
    var NEWCACHE = "";
    var VALUATION = "";
    var REPORT = "";
    var HISTORY = "";
    function getEndpoints(env) {
        switch (env) {
            case 'prod':
                NEW = "https://apiv3.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apinonproxied.endeksa.com";
                VALUATION = 'https://api-valuation.endeksa.com';
                REPORT = 'https://api-report.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
                break;
            case 'beta':
                NEW = "https://apiv3beta.endeksa.com";
                NEWCACHE = "https://apiv3beta.endeksa.com";
                CACHE = 'https://appbeta.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://apibeta.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apibetanonproxied.endeksa.com";
                VALUATION = 'https://apibeta.endeksa.com';
                REPORT = 'https://apibeta.endeksa.com';
                HISTORY = 'https://apiv3beta.endeksa.com';
                break;
            case 'preprod':
                NEW = "https://apiv3-preprod.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app-preprod.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api-preprod.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://api-preprod.endeksa.com";
                VALUATION = 'https://api-preprod.endeksa.com';
                REPORT = 'https://api-preprod.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
                break;
            default:
                NEW = "https://apiv3.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apinonproxied.endeksa.com";
                VALUATION = 'https://api-valuation.endeksa.com';
                REPORT = 'https://api-report.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
        }
    }

    function setAPIUrl() {
        if (location.host === "www.endeksa.com") {
            NEW = "https://apiv3.endeksa.com";
            NEWCACHE = "https://appv3.endeksa.com";
            CACHE = "https://app.endeksa.com";
            NONCACHE = "https://api.endeksa.com";
            NONPROXIED = "https://apinonproxied.endeksa.com";
            VALUATION = 'https://api-valuation.endeksa.com';
            REPORT = 'https://api-report.endeksa.com';
            HISTORY = 'https://apihistory.endeksa.com';
        } else if (location.host === "beta.endeksa.com") {
            NEW = "https://apiv3beta.endeksa.com";
            NEWCACHE = "https://apiv3beta.endeksa.com";
            CACHE = "https://appbeta.endeksa.com";
            NONCACHE = "https://apibeta.endeksa.com";
            NONPROXIED = "https://apibetanonproxied.endeksa.com";
            VALUATION = 'https://apibeta.endeksa.com';
            REPORT = 'https://apibeta.endeksa.com';
            HISTORY = 'https://apiv3beta.endeksa.com';
        } else if (location.host === "preprod.endeksa.com") {
            NEW = "https://apiv3-preprod.endeksa.com";
            NEWCACHE = "https://appv3.endeksa.com";
            CACHE = 'https://app-preprod.endeksa.com'; //beta new api without cache
            NONCACHE = 'https://api-preprod.endeksa.com'; //beta new api without cache
            NONPROXIED = "https://api-preprod.endeksa.com";
            VALUATION = 'https://api-preprod.endeksa.com';
            REPORT = 'https://api-preprod.endeksa.com';
            HISTORY = 'https://apihistory.endeksa.com';
        }
        else {
            getEndpoints('prod');
        }

        app.value("appSettingsSvc", {
            base: "",
            brand: "Endeksa",
            title: "Endeksa",
            siteUrl: "",
            NEW: NEW,
            CACHE: CACHE,
            NEWCACHE: NEWCACHE,
            NONCACHE: NONCACHE,
            NONPROXIED: NONPROXIED,
            VALUATION: VALUATION,
            REPORT: REPORT,
            HISTORY: HISTORY
        });
    }
    setAPIUrl();
    app.filter("to_trusted", [
        "$sce",
        function ($sce) {
            return function (text) {
                return $sce.trustAsHtml(text);
            };
        },
    ]);
    app.filter("maskName", function () {
        return function (text) {
            var splits = text.split(" ");
            var last = splits[splits.length - 1];
            last = last[0] + "."; //last.substring(1).replace(/./g, "*");
            var rest = [];
            for (var i = 0; i < splits.length - 1; i++) {
                rest.push(splits[i]);
            }

            return rest.join(" ") + " " + last;
        };
    });

    app.filter("ifEmpty", function () {
        return function (input, defaultValue) {
            if (
                angular.isUndefined(input) ||
                input === null ||
                input === "" ||
                input === "0%" ||
                input === "%0" ||
                +input === 0 ||
                input === "%0,00"
            ) {
                return defaultValue;
            }

            return input;
        };
    });

    app.filter("makePositive", function () {
        return function (num) {
            return Math.abs(num);
        };
    });

    app.factory("jQuery", [
        "window",
        function (window) {
            return window.jQuery;
        },
    ]);

    app.filter("strReplace", function () {
        return function (input, from, to) {
            input = input || "";
            from = from || "";
            to = to || "";
            return input.replace(new RegExp(from, "g"), to);
        };
    });

    app.filter("numKeys", function () {
        return function (json) {
            if (!json) return 0;
            var keys = Object.keys(json);
            return keys.length;
        };
    });
    app.directive("tooltip", function () {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                if (attrs.trigger === 'click')
                    element.on('click',
                        function () {
                            element.tooltip("show");
                            setTimeout(function () { element.tooltip("hide"); }, 3000);
                        });
                else if (attrs.trigger === 'toggle')
                    element.on('click',
                        function () {
                            element.tooltip("toggle");
                        });
                else
                    element.hover(
                        function () {
                            // on mouseenter
                            element.tooltip("show");
                        },
                        function () {
                            // on mouseleave
                            element.tooltip("hide");
                        }
                    );
            },
        };
    });

    app.filter("capitalCase", function () {
        return function (text) {
            return text ? text.toUpperCase() : text;
        };
    });

    app.directive('crNumeric', ["$ocLazyLoad", function ($ocLazyLoad) {
        'use strict';
        // Declare a empty options object
        var options = {};
        return {
            // Require ng-model in the element attribute for watching changes.
            require: '?ngModel',
            // This directive only works when used in element's attribute (e.g: cr-numeric)
            restrict: 'A',
            compile: function (tElm, tAttrs) {
                var isTextInput = tElm.is('input:text');
                return function (scope, elm, attrs, controller) {
                    $ocLazyLoad.load('/assets/js/autonumeric.min.js').then(function () {
                        // Get instance-specific options.
                        var opts = angular.extend({}, options, scope.$eval(attrs.crNumeric));

                        // Helper method to update autoNumeric with new value.
                        var updateElement = function (element, newVal) {
                            // Only set value if value is numeric
                            if ($.isNumeric(newVal))
                                numericEl.set(newVal);
                            else if (angular.isUndefined(newVal) || newVal === null) {
                                numericEl.set('');
                            }
                        };

                        // Initialize element as autoNumeric with options.
                        // Bind to the linked element itself (not by id) and guard against
                        // re-init: stacked lazy-load callbacks after ng-if re-creations
                        // would otherwise attach duplicate keystroke handlers.
                        var numericEl = AutoNumeric.getAutoNumericElement(elm[0]) || new AutoNumeric(elm[0], opts);

                        // if element has controller, wire it (only for <input type="text" />)
                        if (controller && isTextInput) {
                            // render element as autoNumeric
                            controller.$render = function () {
                                updateElement(elm, controller.$viewValue);
                            };
                            elm.on('input', function (e) {
                                // if (e.which === 13) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                                // }
                            });
                            elm.on('keydown', function (e) {
                                // if (e.which === 13) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                                // }
                            });
                            // Detect changes on element and update model.
                            elm.on('change', function (e) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                            });
                        }
                        else {
                            // Listen for changes to value changes and re-render element.
                            // Useful when binding to a readonly input field.
                            if (isTextInput) {
                                attrs.$observe('value', function (val) {
                                    updateElement(elm, val);
                                });
                            }
                        }
                    });
                };
            } // compile
        }; // return
    }]);

    app.directive("showDuringResolve", [
        "$transitions",
        "$timeout",
        "$window",
        "$rootScope",
        function ($transitions, $timeout, $window, $rootScope) {
            return {
                link: function (scope, element) {
                    element.addClass("ng-hide");
                    $rootScope.showTopSearch = false;
                    $rootScope.indexTarget = true;
                    $rootScope.mapTarget = false;
                    $rootScope.ad = 0;

                    // var resolver = $('<div class="white-overlay"></div><div class="loader-inner"><div class="loader-line-wrap"><div class="loader-line"></div></div><div class="loader-line-wrap"><div class="loader-line"></div></div><div class="loader-line-wrap"><div class="loader-line"></div></div><span class="loading-endeksa-red"></span></div>');

                    $transitions.onCreate({}, function () {
                        // if (!element.find('.white-overlay').length) {
                        // element.append(resolver);

                        // if (!$rootScope.layoutInitiated)
                        element.removeClass("ng-hide");
                        // }
                        if (!$window.barLoaded)
                            $rootScope.hideBar = true;
                        $window.prerenderReady = false;
                    });

                    $transitions.onSuccess({}, function (transition) {
                        element.addClass("ng-hide");
                        $rootScope.hideBar = false;
                        $window.barLoaded = true;

                        //waiting for data causes long rendering times and causes prerender to timeout
                        // if (transition.to().name.indexOf('.value') === -1 &&
                        //     transition.to().name.indexOf('.demographics') === -1 &&
                        //     transition.to().name.indexOf('.agents') === -1 &&
                        //     transition.to().name.indexOf('.election') === -1 &&
                        //     transition.to().name.indexOf('.opportunity') === -1 &&
                        //     transition.to().name.indexOf('.projects') === -1 &&
                        //     transition.to().name.indexOf('.malls') === -1)
                        $timeout(function () {
                            $window.prerenderReady = true;
                        });
                    });

                    $transitions.onError({}, function (transition) {
                        var rejection = transition.error();
                        if (rejection.type === 5) {
                            element.addClass("ng-hide");
                            $rootScope.hideBar = false;
                            $window.barLoaded = true;
                            $timeout(function () {
                                $window.prerenderReady = true;
                            });
                        }
                    });
                }
            };
        },
    ]);

    app.directive("ngEnter", function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    });

    app.directive("ngFocusOut", function () {
        return function (scope, element, attrs) {
            element.bind("focusout", function (event) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngFocusOut);
                });
                event.preventDefault();
            });
        };
    });

    app.directive("ngTypeEnds", ["$timeout", function ($timeout) {
        return function (scope, element, attrs) {
            //setup before functions
            var typingTimer;                //
            element.bind("keyup", function (event) {
                if (typingTimer)
                    $timeout.cancel(typingTimer);
                if (angular.element(element)[0].value) {
                    typingTimer = $timeout(function () {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngTypeEnds);
                        });
                    }, 500);
                }

                event.preventDefault();
            });
        };
    }]);


    app.directive('jsonld', ['$filter', '$sce', function ($filter, $sce) {
        return {
            restrict: 'E',
            template: function () {
                return '<script type="application/ld+json" ng-bind-html="onGetJson()"></script>';
            },
            scope: {
                json: '=json'
            },
            link: function (scope, element, attrs) {
                scope.onGetJson = function () {
                    return $sce.trustAsHtml($filter('json')(scope.json));
                };
            },
            replace: true
        };
    }]);

    app.filter("emptyToEnd", function () {
        return function (array, key) {
            if (!angular.isArray(array)) return;
            var present = array.filter(function (item) {
                return item[key];
            });
            var empty = array.filter(function (item) {
                return !item[key];
            });
            return present.concat(empty);
        };
    });


    app.directive("lazyVideo", [
        "$window",
        function ($window) {
            return {
                restrict: "A",
                scope: {
                    lazy: "@lazy",
                },
                link: function (scope, element, attrs) {
                    function isScrolledIntoView(el) {
                        try {
                            var rect = el.getBoundingClientRect();
                            var elemTop = rect.top;
                            var elemBottom = rect.bottom;
                            var isVisible = elemTop >= 0 && elemBottom <= $window.innerHeight;
                            return isVisible;
                        }
                        catch (err) {
                            return false;
                        }
                    }
                    var promise;

                    function onVisibilityChange() {
                        var el = angular.element(element);
                        if (!el.length)
                            return false;

                        var visible = isScrolledIntoView(el[0]);
                        if (visible && !promise) {
                            var source = el.find('source');
                            source[0].src = source.attr('lazy').trim();
                            el[0].load();
                            promise = el[0].play();
                        }
                        else if (visible && promise) {
                            promise = el[0].play();
                        }
                        else {
                            if (promise) {
                                promise.then(function () {
                                    el[0].pause();
                                });
                            } else el[0].pause();
                        }
                    }
                    angular
                        .element($window)
                        .bind("DOMContentLoaded load resize scroll", onVisibilityChange);
                    var cleanUp = function () {
                        angular.element($window).unbind('DOMContentLoaded load resize scroll', onVisibilityChange);
                    };
                    scope.$on('$destroy', cleanUp);
                },
            };
        },
    ]);

    app.directive('errSrc', function () {
        return {
            link: function (scope, element, attrs) {
                element.bind('error', function () {
                    if (attrs.src != attrs.errSrc) {
                        if (attrs.errSrc)
                            attrs.$set('src', attrs.errSrc);
                    }
                });
            }
        };
    });

    // Check browser support for modern image formats (cached)
    var supportsAVIF = null;
    var supportsWebP = null;

    function checkAVIFSupport(callback) {
        if (supportsAVIF !== null) return callback(supportsAVIF);

        var avif = new Image();
        avif.onload = function () {
            supportsAVIF = (avif.width > 0 && avif.height > 0);
            callback(supportsAVIF);
        };
        avif.onerror = function () {
            supportsAVIF = false;
            callback(supportsAVIF);
        };
        avif.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
    }

    function checkWebPSupport(callback) {
        if (supportsWebP !== null) return callback(supportsWebP);

        var webp = new Image();
        webp.onload = function () {
            supportsWebP = (webp.width > 0 && webp.height > 0);
            callback(supportsWebP);
        };
        webp.onerror = function () {
            supportsWebP = false;
            callback(supportsWebP);
        };
        webp.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    }

    app.directive("lazyLoad", function () {
        return {
            restrict: "A",
            scope: {
                lazy: "@lazy",
            },
            link: function (scope, element, attrs) {
                if (IntersectionObserver) {
                    var observer = new IntersectionObserver(loadImg);
                    var img = angular.element(element)[0];
                    observer.observe(img);
                } else if (attrs.lazy) {
                    // Fallback for old browsers - load original
                    element.src = attrs.lazy.trim();
                    $(element).addClass("img-loaded");
                }

                function loadImg(changes) {
                    changes.forEach(function (change) {
                        if (change.intersectionRatio > 0 && attrs.lazy) {
                            var originalSrc = attrs.lazy.trim();

                            // Load original source directly (AVIF, WebP, JPG, PNG, SVG, GIF - whatever is specified)
                            change.target.src = originalSrc;
                            change.target.onload = function () {
                                change.target.classList.add("img-loaded");
                                observer.unobserve(change.target);
                            };

                            /* PREVIOUS APPROACH - COMMENTED OUT - Auto format detection
                            // Get base path without extension
                            var basePath = originalSrc.replace(/\.(jpg|jpeg|png|webp|avif)$/i, '');

                            // Check if it's a raster image that can have multiple formats
                            if (originalSrc.match(/\.(jpg|jpeg|png|webp)$/i)) {
                                // Try modern formats in order: AVIF → WebP → Original (JPG/PNG)
                                // Even if original is .avif, try AVIF first!
                                checkAVIFSupport(function (hasAVIF) {
                                    if (hasAVIF) {
                                        var avifSrc = basePath + '.avif';
                                        var testImg = new Image();
                                        testImg.onload = function () {
                                            change.target.src = avifSrc;
                                            change.target.onload = function () {
                                                change.target.classList.add("img-loaded");
                                                observer.unobserve(change.target);
                                            };
                                        };
                                        testImg.onerror = function () {
                                            tryWebP();
                                        };
                                        testImg.src = avifSrc;
                                    } else {
                                        tryWebP();
                                    }
                                });

                                function tryWebP() {
                                    // If original was already WebP, use it
                                    if (originalSrc.match(/\.avif$/i)) {
                                        loadOriginal();
                                        return;
                                    }

                                    checkWebPSupport(function (hasWebP) {
                                        if (hasWebP) {
                                            var webpSrc = basePath + '.avif';
                                            var testImg = new Image();
                                            testImg.onload = function () {
                                                change.target.src = webpSrc;
                                                change.target.onload = function () {
                                                    change.target.classList.add("img-loaded");
                                                    observer.unobserve(change.target);
                                                };
                                            };
                                            testImg.onerror = function () {
                                                // WebP not available, use original
                                                loadOriginal();
                                            };
                                            testImg.src = webpSrc;
                                        } else {
                                            loadOriginal();
                                        }
                                    });
                                }

                                function loadOriginal() {
                                    change.target.src = originalSrc;
                                    change.target.onload = function () {
                                        change.target.classList.add("img-loaded");
                                        observer.unobserve(change.target);
                                    };
                                }
                            } else {
                                // SVG, GIF, or already AVIF - load as-is
                                change.target.src = originalSrc;
                                change.target.onload = function () {
                                    change.target.classList.add("img-loaded");
                                    observer.unobserve(change.target);
                                };
                            }
                            */
                        }
                    });
                }
            },
        };
    });
    app.directive('trendLoading', [function () {
        return {
            restrict: 'EA',
            templateUrl: '/app/bolgesel-analiz/views/trend-loading.html',
            scope: {
                trendNo: '<'
            },
            link: function (scope) {
                scope.trendNo = Math.floor(Math.random() * 100);

                var selected = [
                    "ei-units",
                    "ei-hand-change",
                    "ei-calendar-time",
                    "ei-check"
                ];
                setTimeout(function () {
                    $('#barRatingLoad' + scope.trendNo).barrating({
                        theme: 'bars-pill',
                        readonly: true,
                        initialRating: 1
                    });
                    $('#barRatingLoad' + scope.trendNo).barrating('set', 1);
                });
                var interv = setInterval(function () {
                    $('#barRatingLoad' + scope.trendNo).barrating('set', window.loadingBarRating + 1);

                    $('#rotatingIcon' + scope.trendNo).attr('class', selected[window.loadingBarRating - 1]);

                    if (window.loadingBarRating > 4)
                        clearInterval(interv);
                }, 100);
            }
        };
    }]);
    app.directive('rotateValuation', ['$interval', '$timeout', '$translate',
        function ($interval, $timeout, $translate) {
            return {
                restrict: 'EA',
                scope: {
                    rotateTrend: '<',
                },
                link: function (scope, element, attrs) {
                    // scope.wordArr = ['Yakın mesafedeki benzer emsaller bulunuyor', 'Geçmiş tarihli benzer emsaller bulunuyor', 'Alan genişletilerek emsaller bulunuyor', 'Zaman düzeltmesi yapılıyor', 'Standart sapmalar hesaplanıyor', 'Mahalle seviyesinde değere etki eden faktörler hesaplanıyor', 'İlçe seviyesinde değere etki eden faktörler hesaplanıyor', 'İl seviyesinde değere etki eden faktörler hesaplanıyor', 'Benzer bölgelerdeki değer değişimi hesaplanıyor', 'Neredeyse bitti. İşlem tamamlanıyor'];

                    scope.wordArr = [];
                    if (!scope.rotateTrend) {
                        scope.wordArr.push($translate.instant('valuation_loading1'));
                        scope.wordArr.push($translate.instant('valuation_loading2'));
                        scope.wordArr.push($translate.instant('valuation_loading3'));
                        scope.wordArr.push($translate.instant('valuation_loading4'));
                        scope.wordArr.push($translate.instant('valuation_loading5'));
                        scope.wordArr.push($translate.instant('valuation_loading6'));
                        scope.wordArr.push($translate.instant('valuation_loading7'));
                        scope.wordArr.push($translate.instant('valuation_loading8'));
                        scope.wordArr.push($translate.instant('valuation_loading9'));
                        scope.wordArr.push($translate.instant('valuation_loading10'));
                    } else {
                        scope.wordArr.push($translate.instant('trend_loading1'));
                        scope.wordArr.push($translate.instant('trend_loading2'));
                        scope.wordArr.push($translate.instant('trend_loading3'));
                        scope.wordArr.push($translate.instant('trend_loading4'));
                        scope.wordArr.push($translate.instant('valuation_loading10'));
                    }

                    scope.dots = ['', '.', '..', '...'];


                    function generateRandom(min = 3000, max = 10000) {

                        if (scope.rotateTrend) {
                            min = 2000;
                            max = 3000;
                        }

                        let difference = max - min;
                        let rand = Math.random();
                        rand = Math.floor(rand * difference);
                        rand = rand + min;
                        return rand;
                    }

                    var current = scope.wordArr[0], stopDot, stopWord, j = 0;
                    function updateWord() {
                        j++;

                        if (window.valuationCompleted && !scope.rotateTrend)
                            j = 9;
                        else if (window.valuationCompleted && scope.rotateTrend)
                            j = 4;

                        element.text(scope.wordArr[j]);
                        current = scope.wordArr[j];

                        window.loadingBarRating = j;
                        $interval.cancel(stopDot);
                        stopDot = $interval(updateDot, 500);

                        if (j !== scope.wordArr.length - 1)
                            stopWord = $timeout(updateWord, generateRandom());
                    }

                    function updateDot(i) {
                        var t = i % 4;
                        element.text(current + scope.dots[t]);
                        if (window.valuationCompleted)
                            updateWord();
                    }

                    window.valuationCompleted = false;
                    window.loadingBarRating = 0;
                    element.text(current + scope.dots[0]);
                    stopDot = $interval(updateDot, 500);
                    stopWord = $timeout(updateWord, generateRandom());
                    element.on('$destroy', function () {
                        $timeout.cancel(stopWord);
                        $interval.cancel(stopDot);
                    });
                }
            };
        }]);


    app.directive('selectpicker', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (typeof $.fn.selectpicker === 'undefined') {
                    console.warn('selectpicker directive: bootstrap-select not loaded yet');
                    return;
                }

                $timeout(function () {
                    element.selectpicker($parse(attrs.selectpicker)());
                    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent))
                    //     element.selectpicker('mobile');
                    // else
                    element.selectpicker();
                }, 0);

                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    scope.$parent[attrs.ngModel] = newVal;

                    scope.$evalAsync(function () {
                        if (!attrs.ngOptions || /track by/.test(attrs.ngOptions))
                            element.val(newVal);
                        if (typeof $.fn.selectpicker !== 'undefined') {
                            element.selectpicker('refresh');
                        }
                    });
                });

                scope.$on('$destroy', function () {
                    scope.$evalAsync(function () {
                        if (typeof $.fn.selectpicker !== 'undefined') {
                            element.selectpicker('destroy');
                        }
                    });
                });
            }
        };
    }]);

    app.directive("lazyLoadTns", function () {
        return {
            restrict: "A",
            scope: {
                lazy: "@lazy",
            },
            link: function (scope, element, attrs) {
                if (IntersectionObserver) {
                    var observer = new IntersectionObserver(loadImg);
                    var img = angular.element(element)[0];
                    observer.observe(img);
                } else if (attrs.lazy) {
                    if ($(element).hasClass("loaded"))
                        element.src = attrs.lazy.trim();
                    else
                        element.setAttribute("data-src", attrs.lazy.trim());
                    $(element).addClass("img-loaded");
                }

                function loadImg(changes) {
                    changes.forEach(function (change) {

                        if (change.intersectionRatio > 0 && attrs.lazy) {
                            setTimeout(function () {
                                attrs.lazy = attrs.lazy || "/assets/img/empty_list.avif";
                                if ($(change.target).hasClass("loaded"))
                                    change.target.src = attrs.lazy.trim();
                                else
                                    change.target.setAttribute("data-src", attrs.lazy.trim());
                                change.target.onload = function () {
                                    change.target.classList.add("img-loaded");
                                };

                            }, 100);
                        }
                    });
                }
            },
        };
    });

    app.directive('formatNumber', ["$filter", function ($filter) {
        'use strict';

        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) {
                    return;
                }

                ctrl.$formatters.unshift(function () {
                    return $filter('number')(ctrl.$modelValue);
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[\,\.]/g, ''),
                        b = $filter('number')(plainNumber);

                    elem.val(b === '0' ? '' : b);

                    return plainNumber;
                });
            }
        };
    }]);

    // Custom cached partial loader - caches ALL translations after first load
    // Prevents duplicate CDN requests for the same translation files
    // angular.module('app')
    //     .factory('cachedPartialLoader', ['$http', '$q', '$translatePartialLoader', function ($http, $q, $translatePartialLoader) {
    //         // Cache for loaded translation data: cache[lang][part] = data
    //         var translationCache = {};
    //         // Cache for in-flight requests: promiseCache[lang][part] = promise
    //         var promiseCache = {};

    //         return function (options) {
    //             var lang = options.key;
    //             var parts = $translatePartialLoader.getRegisteredParts();

    //             // Initialize caches for this language if needed
    //             if (!translationCache[lang]) {
    //                 translationCache[lang] = {};
    //             }
    //             if (!promiseCache[lang]) {
    //                 promiseCache[lang] = {};
    //             }

    //             // Collect all parts that need to be loaded
    //             var partsToLoad = [];
    //             var cachedTranslations = {};
    //             var waitingPromises = [];

    //             // Check which parts are already cached or being loaded
    //             parts.forEach(function (part) {
    //                 if (translationCache[lang][part]) {
    //                     // Use cached version
    //                     angular.extend(cachedTranslations, translationCache[lang][part]);
    //                 } else if (promiseCache[lang][part]) {
    //                     // Already loading, wait for the existing promise
    //                     waitingPromises.push(
    //                         promiseCache[lang][part].then(function (data) {
    //                             return { part: part, data: data };
    //                         })
    //                     );
    //                 } else {
    //                     // Need to load from CDN
    //                     partsToLoad.push(part);
    //                 }
    //             });

    //             // If all parts are cached or being loaded, wait and return
    //             if (partsToLoad.length === 0) {
    //                 if (waitingPromises.length > 0) {
    //                     return $q.all(waitingPromises).then(function (results) {
    //                         results.forEach(function (result) {
    //                             angular.extend(cachedTranslations, result.data);
    //                         });
    //                         return cachedTranslations;
    //                     });
    //                 } else {
    //                     return $q.resolve(cachedTranslations);
    //                 }
    //             }

    //             // Build URL template based on environment
    //             var urlTemplate = "/assets/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             if (window.location.host === 'www.endeksa.com')
    //                 urlTemplate = "https://cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             else if (window.location.host === 'beta.endeksa.com')
    //                 urlTemplate = "https://beta-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             else if (window.location.host === 'preprod.endeksa.com')
    //                 urlTemplate = "https://preprod-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;

    //             // Load all uncached parts and cache the promises
    //             partsToLoad.forEach(function (part) {
    //                 var url = urlTemplate.replace('{lang}', lang).replace('{part}', part);

    //                 // Create and cache the promise
    //                 var promise = $http.get(url).then(function (response) {
    //                     // Cache the data
    //                     translationCache[lang][part] = response.data;
    //                     // Clear the promise from cache
    //                     delete promiseCache[lang][part];
    //                     return response.data;
    //                 }).catch(function (error) {
    //                     console.error('Failed to load translation part: ' + lang + '/' + part, error);
    //                     // Clear the promise from cache on error
    //                     delete promiseCache[lang][part];
    //                     return {};
    //                 });

    //                 // Cache the promise so other concurrent calls can wait for it
    //                 promiseCache[lang][part] = promise;
    //                 waitingPromises.push(promise.then(function (data) {
    //                     return { part: part, data: data };
    //                 }));
    //             });

    //             // Wait for all requests (new + in-flight) to complete
    //             return $q.all(waitingPromises).then(function (results) {
    //                 var allTranslations = angular.copy(cachedTranslations);
    //                 results.forEach(function (result) {
    //                     angular.extend(allTranslations, result.data);
    //                 });
    //                 return allTranslations;
    //             });
    //         };
    //     }])
    //     .config(['$translateProvider', function ($translateProvider) {
    //         // Use custom cached loader instead of default partial loader
    //         $translateProvider.useLoader('cachedPartialLoader');
    //     }]);
})();

/**
 * This file contains the runFunction that is executed when the AngularJS app is run.
 * It initializes various settings and configurations for the app.
 *
 * @module app.run
 * @requires $state
 * @requires $rootScope
 * @requires $location
 * @requires $timeout
 * @requires $interval
 * @requires appSettingsSvc
 * @requires $stateParams
 * @requires $window
 * @requires $transitions
 * @requires restoreUrlService
 * @requires $translate
 * @requires $http
 * @requires ngDialog
 * @requires CacheFactory
 * @requires MetaTags
 */
(function () {
    "use strict";

    angular.module("app").run(runFunction);

    runFunction.$inject = [
        "$state",
        "$rootScope",
        "$location",
        "$timeout",
        "$interval",
        // "$analytics",
        "appSettingsSvc",
        "$stateParams",
        "$window",
        "$transitions",
        "restoreUrlService",
        "$translate",
        "$http",
        "ngDialog",
        "CacheFactory",
        "MetaTags",
        "darkModeSvc",
        "thirdPartyLoader"
    ];
    function runFunction(
        $state,
        $rootScope,
        $location,
        $timeout,
        $interval,
        // $analytics,
        appSettingsSvc,
        $stateParams,
        $window,
        $transitions,
        restoreUrlService,
        $translate,
        $http,
        ngDialog,
        CacheFactory,
        MetaTags,
        darkModeSvc,
        thirdPartyLoader
    ) {
        // Initialize dark mode on app startup
        darkModeSvc.initialize();

        // Expose dark mode service to rootScope for easy access from templates
        $rootScope.darkModeSvc = darkModeSvc;

        // Initialize third-party script lazy loader
        thirdPartyLoader.init();

        if (!CacheFactory.get('defaultCache'))
            CacheFactory('defaultCache', {
                maxAge: 15 * 60 * 1000, // Items added to this cache expire after 15 minutes
                cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
                deleteOnExpire: 'aggressive', // Items will be deleted from this cache when they expire
                // storageMode: 'localStorage'
            });

        $http.defaults.cache = CacheFactory.get('defaultCache');

        if ($location.host() === "www.endeksa.com" || $location.host() === "preprod.endeksa.com") {
            $rootScope.downloadLink = "https://images.endeksa.com/";
        }
        else {
            $rootScope.downloadLink =
                "https://beta-images.endeksa.com/";
        }

        appSettingsSvc.siteUrl = $window.location.origin;

        // set language
        var keyLanguage = "en";
        try {
            keyLanguage = $window.localStorage.getItem("Language");
        } catch (err) {
            ngDialog.open({
                templateUrl: "app/shell/modal-error.html",
            });
            return false;
        }
        // var urlPath = $location.url();
        // if (urlPath.indexOf("/en/") === -1 && urlPath.indexOf("/tr/") === -1) {
        //     var urlPathString = urlPath.split("/");
        //     urlPathString[1] = keyLanguage;
        //     var path = urlPathString.join("/");
        //     if (path.indexOf('en/') === -1 && path.indexOf('tr/') === -1)
        //         path = path + '/';
        //     $window.redirected = "Location: " + $window.location.origin + path;
        //     $location.path(path);
        // }

        $state.defaultErrorHandler(function (error) {
            console.error(error);
        });

        $rootScope.MetaTags = MetaTags;

        $rootScope.lang = keyLanguage;
        $window.lang = keyLanguage;
        $window.wootricSettings = {
            account_token: "NPS-66c1ee71",
            language: keyLanguage.split('-')[0].toUpperCase(),
        };
        $window.ybug_settings.language_override = keyLanguage.split('-')[0];
        $window.ybug_settings.translations = {
            "tr": {
                "feedbackForm.Types.1": "Hata",
                "feedbackForm.Types.2": "Geliştirme",
                "feedbackForm.Types.3": "Soru",
                "feedbackForm.Types.4": "Geri Bildirim",
            }
        };
        document.tidioChatLang = keyLanguage === 'pt-PT' ? 'pt' : keyLanguage === 'es-ES' ? 'es' : keyLanguage;
        $http.defaults.headers.common["Accept-Language"] = keyLanguage;
        $stateParams.langcode = keyLanguage;
        $translate.use(keyLanguage);
        moment.locale(keyLanguage);
        $timeout(function () {
            moment.locale(keyLanguage);
        });

        $rootScope.assignCurrency();

        $rootScope.country = $rootScope.lang === 'pt-PT' ? 'portugal' : $rootScope.lang === 'es-ES' ? 'espana' : $rootScope.lang === 'tr' ? 'turkiye' : 'world';

        const isVideoaskMessage = message =>
            message.origin === "https://ask.endeksa.com" &&
            message.data &&
            message.data.type &&
            message.data.type.startsWith("videoask_");

        $window.addEventListener("message", message => {
            if (!isVideoaskMessage(message)) {
                return;
            }
            if (message.data.type === "videoask_contact_interacted") {
                if (window.location.href.indexOf('/properties/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_valuation_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else if (window.location.href.indexOf('/agents/') > -1 || window.location.href.indexOf('/danisman/') > -1 || window.location.href.indexOf('/agentes/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_agent_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else
                    window.dataLayer.push({
                        event: "lead_sale_other_display",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
            }
            else if (message.data.type === "videoask_contact_updated") {
                if (window.location.href.indexOf('/properties/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_valuation_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else if (window.location.href.indexOf('/agents/') > -1 || window.location.href.indexOf('/danisman/') > -1 || window.location.href.indexOf('/agentes/') > -1)
                    window.dataLayer.push({
                        event: "lead_sale_agent_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
                else
                    window.dataLayer.push({
                        event: "lead_sale_other_engage",
                        currency: window.currency,
                        language: window.lang.split('-')[0]
                    });
            }
        });

        window.gclid = localStorage.getItem('gclid') || undefined;
        window.gaclient = localStorage.getItem('gaclient') || undefined;


        function get_ga_clientid() {
            var cookie = {};
            document.cookie.split(';').forEach(function (el) {
                var splitCookie = el.split('=');
                var key = splitCookie[0].trim();
                var value = splitCookie[1];
                cookie[key] = value;
            });
            return cookie.hasOwnProperty("_ga") ? cookie["_ga"].substring(6) : null;
        }

        function getSessionData() {
            const pattern = /_ga_5ZVE5PY6T3=GS\d\.\d\.(.+?)(?:;|$)/;
            const match = document.cookie.match(pattern);
            const parts = match?.[1].split("$");

            let tryCount = 0;
            if (!parts) {
                if (tryCount >= 10) {
                    return;
                }
                window.setTimeout(() => {
                    tryCount++;
                    getSessionData();
                }, 200);
                return;
            }

            window.gasessionId = parts.shift();
            window.gasessionNumber = parts.shift();
        }

        $timeout(function () {
            getSessionData();
            const gclid = $location.search().gclid;
            if (gclid) {
                localStorage.setItem('gclid', gclid);
            }
            window.gclid = gclid || localStorage.getItem('gclid') || undefined;

            const gaclient = get_ga_clientid();
            if (gaclient && !window.gaclient) {
                localStorage.setItem('gaclient', gaclient);
                window.gaclient = gaclient;
            }
            else
                window.gaclient = localStorage.getItem('gaclient') || undefined;
        });


        // if (typeof $window.videoask !== 'undefined' && $window.lang === 'tr' && $window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1)
        //     $window.videoask.loadEmbed({
        //         "kind": "widget",
        //         "url": "https://ask.endeksa.com/ff8e0al58#gclid=" + window.gclid,
        //         "options": {
        //             "widgetType": "VideoThumbnailExtraLarge",
        //             "text": "Evinizi Güvenle Satın",
        //             "backgroundColor": "#00AEFF",
        //             "position": "bottom-left",
        //             "dismissible": true
        //         }
        //     });
        // else if ($window.lang === 'tr' && $window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1)
        //     $window.VIDEOASK_EMBED_CONFIG = {
        //         "kind": "widget",
        //         "url": "https://ask.endeksa.com/ff8e0al58#gclid=" + window.gclid,
        //         "options": {
        //             "widgetType": "VideoThumbnailExtraLarge",
        //             "text": "Evinizi Güvenle Satın",
        //             "backgroundColor": "#00AEFF",
        //             "position": "bottom-left",
        //             "dismissible": true
        //         }
        //     };

        // if ($window.location.href.indexOf('ad=') === -1 && $window.location.href.indexOf('top=') === -1 && $window.location.host === 'www.endeksa.com')
        // if ($window.lang === 'tr')
        //     OneSignal.push(["init", {
        //         appId: "2d42aaca-84b0-4db5-a121-4ee72f0c4bef",
        //         safari_web_id: "web.com.endeksa",
        //         autoRegister: true,
        //         welcomeNotification: {
        //             "title": "Endeksa Güncellemeleri",
        //             "message": "Güncellemeleri aldığınız için teşekkürler!"
        //         },
        //         notifyButton: {
        //             enable: false,
        //             size: 'medium',
        //             theme: 'default',
        //             position: 'bottom-left',
        //             offset: {
        //                 bottom: '0px',
        //                 left: '0px',
        //                 right: '0px'
        //             },
        //             prenotify: true,
        //             showCredit: false,
        //             text: {
        //                 'tip.state.unsubscribed': 'Güncellemelere üye ol',
        //                 'tip.state.subscribed': "Güncellemelere üye oldunuz",
        //                 'tip.state.blocked': "Güncellemeleri engellediniz",
        //                 'message.prenotify': 'Güncellemelere üye olmak için tıklayın',
        //                 'message.action.subscribed': "Güncellemeleri aldığınız için teşekkürler!",
        //                 'message.action.resubscribed': "Güncellemelere üye oldunuz",
        //                 'message.action.unsubscribed': "Artık güncelleme almayacaksınız",
        //                 'dialog.main.title': 'Endeksa Güncellemeleri',
        //                 'dialog.main.button.subscribe': 'Üye Ol',
        //                 'dialog.main.button.unsubscribe': 'Üyelikten Çık',
        //                 'dialog.blocked.title': 'Güncellemeleri engellemeyi bırak',
        //                 'dialog.blocked.message': "Güncellemeleri almak için adımları izleyin:"
        //             }
        //         },
        //         promptOptions: {
        //             actionMessage: "Size en son güncellemeleri ve haberleri iletmek istiyoruz.",
        //             acceptButtonText: "İzin Ver",
        //             cancelButtonText: "İstemiyorum"
        //         }
        //     }]);
        // else
        //     OneSignal.push(["init", {
        //         appId: "2d42aaca-84b0-4db5-a121-4ee72f0c4bef",
        //         safari_web_id: "web.com.endeksa",
        //         autoRegister: true,
        //         welcomeNotification: {
        //             "title": "Endeksa Updates",
        //             "message": "Thanks for getting our updates!"
        //         },
        //         notifyButton: {
        //             enable: false,
        //             size: 'medium',
        //             theme: 'default',
        //             position: 'bottom-left',
        //             offset: {
        //                 bottom: '0px',
        //                 left: '0px',
        //                 right: '0px'
        //             },
        //             prenotify: true,
        //             showCredit: false
        //         },
        //         promptOptions: {
        //             actionMessage: "We would like to send our latest updates to you.",
        //             acceptButtonText: "Allow",
        //             cancelButtonText: "No, Thanks"
        //         }
        //     }]);
        if ($window.location.host.indexOf('localhost') === -1) {
            var TIME_DIFF_CACHE_KEY = 'time_diff_data';
            var TIME_DIFF_TTL = 24 * 60 * 60 * 1000; // 24 saat

            (function fetchAndCacheTimeDiff() {
                var cachedTimeDiff = localStorage.getItem(TIME_DIFF_CACHE_KEY);
                if (cachedTimeDiff) {
                    try {
                        cachedTimeDiff = JSON.parse(cachedTimeDiff);
                        var age = new Date().getTime() - cachedTimeDiff.timestamp;
                        if (age < TIME_DIFF_TTL && cachedTimeDiff.time_diff !== undefined) {
                            localStorage.setItem('time_diff', cachedTimeDiff.time_diff);
                            return;
                        }
                    } catch (e) { }
                }
                $http.get('https://time.endeksa.com/', {
                    ignoreLoadingBar: true,
                    skipAuthorization: true
                }).then(function (res) {
                    var srv_time = res.data.epochSec;
                    var cli_time = Math.floor(new Date().getTime() / 1000);
                    var time_diff = cli_time - srv_time;
                    localStorage.setItem('time_diff', time_diff);
                    localStorage.setItem(TIME_DIFF_CACHE_KEY, JSON.stringify({
                        timestamp: new Date().getTime(),
                        time_diff: time_diff
                    }));
                });
            })();

            var stVer = localStorage.getItem('current_version');
            var lastCache = localStorage.getItem('current_cache');
            $http.get(appSettingsSvc.NONCACHE + "/version", {
                ignoreLoadingBar: true
            }).then(function (res) {
                var srv_version = res.data.Version.Label;
                var cache_updates = res.data.CacheUpdates;

                var changed = false;

                if (lastCache) {
                    lastCache = JSON.parse(lastCache);

                    if (lastCache.Trend !== cache_updates.Trend) {
                        CacheFactory.get('Indices') && CacheFactory.get('Indices').removeAll();
                        changed = true;
                    }
                    if (lastCache.Demography !== cache_updates.Demography) {
                        CacheFactory.get('Demographies') && CacheFactory.get('Demographies').removeAll();
                        changed = true;
                    }
                    if (lastCache.Agents !== cache_updates.Agents) {
                        CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                        CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                        CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                        changed = true;
                    }
                    if (lastCache.Malls !== cache_updates.Malls) {
                        CacheFactory.get('Malls') && CacheFactory.get('Malls').removeAll();
                        changed = true;
                    }
                    if (lastCache.Opportunity !== cache_updates.Opportunity) {
                        CacheFactory.get('OpportunitiesList') && CacheFactory.get('OpportunitiesList').removeAll();
                        CacheFactory.get('OpportunitiesGet') && CacheFactory.get('OpportunitiesGet').removeAll();
                        changed = true;
                    }
                    if (lastCache.Projects !== cache_updates.Projects) {
                        CacheFactory.get('ProjectsList') && CacheFactory.get('ProjectsList').removeAll();
                        CacheFactory.get('Projects') && CacheFactory.get('Projects').removeAll();
                        changed = true;
                    }

                }
                if (changed || !lastCache) {
                    console.log("TREND CACHE CLEANED");
                    localStorage.setItem('current_cache', JSON.stringify(cache_updates));
                }

                var vs = $("version").attr("content");
                var correctVersion =
                    stVer === $window.appVersion &&
                    vs === $window.appVersion &&
                    srv_version === $window.appVersion;

                if (!correctVersion) {
                    CacheFactory.clearAll();
                    localStorage.setItem('current_version', srv_version);
                    console.log("ALL CACHE CLEANED");
                }
            });
        }
        // Beamer Configuration with Dark Mode Support
        var isDarkMode = localStorage.getItem('darkMode') === 'true';
        $window.beamer_config = {
            product_id: "ETrLZbwu14939",
            selector: ".beamer-panel",
            language: $window.lang.toUpperCase(),
            lazy: true,
            embed: true,
            theme: isDarkMode ? 'dark' : 'default',
            // Custom filter for dark mode
            filter: isDarkMode ? 'dark-mode' : 'light-mode'
        };

        var checkBeamer = $interval(function () {
            if ($(".beamer-panel").length && $window.lang && $window.Beamer) {
                $window.Beamer.init();
                $interval.cancel(checkBeamer);
            }
        }, 100);

        // Listen for dark mode changes and update Beamer theme
        $rootScope.$on('darkMode:changed', function (event, data) {
            if ($window.Beamer) {
                var newTheme = data.enabled ? 'dark' : 'default';

                // Update Beamer config
                $window.beamer_config.theme = newTheme;
                $window.beamer_config.filter = data.enabled ? 'dark-mode' : 'light-mode';

                // Destroy and reinitialize Beamer with new theme
                if ($window.Beamer.destroy) {
                    $window.Beamer.destroy();
                }

                // Wait a bit before reinitializing
                $timeout(function () {
                    if ($(".beamer-panel").length) {
                        $window.Beamer.init();
                    }
                }, 100);
            }
        });


        var fixCanonRecursive = function (lang, path1, path2, path3, path1_o, path2_o, path3_o, path_solve, blog_path, listing_path) {

            if (blog_path) {
                path_solve = path_solve.replace(path_solve.split('/').pop(), blog_path);
            }
            if (listing_path) {
                path_solve = path_solve.replace(path_solve.split('/')[path_solve.split('/').length - 2], listing_path);
            }

            const satilik_o = $translate.instant('satilik');
            const kiralik_o = $translate.instant('kiralik');
            const konut_o = $translate.instant('konut');
            const arsa_o = $translate.instant('arsa');
            const arazi_o = $translate.instant('arazi');
            const ticari_o = $translate.instant('ticari');

            $translate(path1, {}, undefined, undefined, lang).then(function (path1_tr) {
                path_solve = path_solve.replace(path1_o, path1_tr);
                const path_lang = window.location.origin + path_solve;
                $("#lang_" + lang).attr("href", path_lang);
                // if (lang === 'en')
                //     $("#lang_x").attr("href", path_lang);

                if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                    $("#lang_" + lang).remove();
                    // if (lang === 'en')
                    //     $("#lang_x").remove();
                }
            });
            if (path2)
                $translate(path2, {}, undefined, undefined, lang).then(function (path2_tr) {
                    path_solve = path_solve.replace(path2_o, path2_tr);
                    const path_lang = window.location.origin + path_solve;
                    $("#lang_" + lang).attr("href", path_lang);
                    // if (lang === 'en')
                    //     $("#lang_x").attr("href", path_lang);

                    if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                        $("#lang_" + lang).remove();
                        // if (lang === 'en')
                        //     $("#lang_x").remove();
                    }
                });
            if (path3) {
                $translate(path3, {}, undefined, undefined, lang).then(function (path3_tr) {
                    path_solve = path_solve.replace(path3_o, path3_tr);
                    const path_lang = window.location.origin + path_solve;
                    $("#lang_" + lang).attr("href", path_lang);
                    // if (lang === 'en')
                    //     $("#lang_x").attr("href", path_lang);

                    if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                        $("#lang_" + lang).remove();
                        // if (lang === 'en')
                        //     $("#lang_x").remove();
                    }
                });
                if (path3 === 'value') {
                    $translate("satilik", {}, undefined, undefined, lang).then(function (satilik_tr) {
                        path_solve = path_solve.replace(satilik_o, satilik_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);


                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("kiralik", {}, undefined, undefined, lang).then(function (kiralik_tr) {
                        path_solve = path_solve.replace(kiralik_o, kiralik_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);


                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("konut", {}, undefined, undefined, lang).then(function (konut_tr) {
                        path_solve = path_solve.replace(konut_o, konut_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("arsa", {}, undefined, undefined, lang).then(function (arsa_tr) {
                        path_solve = path_solve.replace(arsa_o, arsa_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("arazi", {}, undefined, undefined, lang).then(function (arazi_tr) {
                        path_solve = path_solve.replace(arazi_o, arazi_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                    $translate("ticari", {}, undefined, undefined, lang).then(function (ticari_tr) {
                        path_solve = path_solve.replace(ticari_o, ticari_tr);
                        const path_lang = window.location.origin + path_solve;
                        $("#lang_" + lang).attr("href", path_lang);
                        // if (lang === 'en')
                        //     $("#lang_x").attr("href", path_lang);

                        if (path_lang.indexOf('delete-endeksa-marker') > -1) {
                            $("#lang_" + lang).remove();
                            // if (lang === 'en')
                            //     $("#lang_x").remove();
                        }
                    });
                }
            }
        };
        var fixCanonical = function (transition) {
            $timeout(function () {
                const current_name = transition.to().name;
                var current_params = angular.copy(transition.params('to'));
                const path1 = current_name.split('.')[0];
                const path2 = current_name.split('.')[1];
                const path3 = current_name.split('.')[2];

                const path1_o = $translate.instant(path1);
                const path2_o = $translate.instant(path2);
                const path3_o = $translate.instant(path3);


                var blog_tr, blog_en, blog_es, blog_pt;
                if (window.blogUrls) {
                    blog_tr = window.blogUrls.find(x => x.languageType === 1) ? window.blogUrls.find(x => x.languageType === 1).name : "delete-endeksa-marker";
                    blog_en = window.blogUrls.find(x => x.languageType === 2) ? window.blogUrls.find(x => x.languageType === 2).name : "delete-endeksa-marker";
                    blog_es = window.blogUrls.find(x => x.languageType === 3) ? window.blogUrls.find(x => x.languageType === 3).name : "delete-endeksa-marker";
                    blog_pt = window.blogUrls.find(x => x.languageType === 4) ? window.blogUrls.find(x => x.languageType === 4).name : "delete-endeksa-marker";
                    window.blogUrls = undefined;
                }
                var listing_tr, listing_en, listing_es, listing_pt;

                if (window.listingUrls) {
                    listing_tr = window.listingUrls.find(x => x.Language === 1) ? window.listingUrls.find(x => x.Language === 1).Url : "delete-endeksa-marker";
                    listing_en = window.listingUrls.find(x => x.Language === 2) ? window.listingUrls.find(x => x.Language === 2).Url : "delete-endeksa-marker";
                    listing_es = window.listingUrls.find(x => x.Language === 3) ? window.listingUrls.find(x => x.Language === 3).Url : "delete-endeksa-marker";
                    listing_pt = window.listingUrls.find(x => x.Language === 4) ? window.listingUrls.find(x => x.Language === 4).Url : "delete-endeksa-marker";
                    window.listingUrls = undefined;
                }


                current_params.langcode = 'tr';
                var path_solve = $state.href(current_name, current_params);
                fixCanonRecursive('tr', path1, path2, path3, path1_o, path2_o, path3_o, path_solve, blog_tr, listing_tr);

                current_params.langcode = 'en';
                var path_solve_en = $state.href(current_name, current_params);
                fixCanonRecursive('en', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_en, blog_en, listing_en);

                current_params.langcode = 'es-ES';
                var path_solve_es = $state.href(current_name, current_params);
                fixCanonRecursive('es-ES', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_es, blog_es, listing_es);

                current_params.langcode = 'pt-PT';
                var path_solve_pt = $state.href(current_name, current_params);
                fixCanonRecursive('pt-PT', path1, path2, path3, path1_o, path2_o, path3_o, path_solve_pt, blog_pt, listing_pt);
            }, 1000);
        };


        window.googletag = window.googletag || {};
        $rootScope.setAds = function (id) {
            if (window.lang === 'tr')
                var interv = $interval(function () {
                    if (window.googletag.apiReady) {
                        $interval.cancel(interv);
                        googletag.cmd = googletag.cmd || [];
                        // googletag.destroySlots();
                        googletag.cmd.push(function () {
                            if (id === "div-gpt-ad-1646319323246-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_anasayfa', [[728, 90], [970, 90], 'fluid'], 'div-gpt-ad-1646319323246-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319558735-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_anasayfa', [[320, 100], 'fluid'], 'div-gpt-ad-1646319558735-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319280660-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_blog_anasayfa', ['fluid', [728, 90], [970, 90]], 'div-gpt-ad-1646319280660-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319514606-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_blog_anasayfa', ['fluid', [320, 100]], 'div-gpt-ad-1646319514606-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319230642-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_blog_detay', [[728, 90], 'fluid'], 'div-gpt-ad-1646319230642-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319467089-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_blog_haberdetay', ['fluid', [320, 100]], 'div-gpt-ad-1646319467089-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319178221-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_edo', [[300, 250], 'fluid'], 'div-gpt-ad-1646319178221-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319412113-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_edo', [[320, 100], 'fluid'], 'div-gpt-ad-1646319412113-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319094131-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_w_kdh', [[300, 250], 'fluid'], 'div-gpt-ad-1646319094131-0')
                                    .addService(googletag.pubads());
                            else if (id === "div-gpt-ad-1646319372037-0")
                                googletag
                                    .defineSlot(
                                        '/21155722/endeksa_web/endeksa_m_kdh', ['fluid', [300, 250]], 'div-gpt-ad-1646319372037-0')
                                    .addService(googletag.pubads());
                            googletag.pubads().collapseEmptyDivs(true, true);
                            googletag.enableServices();
                        });
                        googletag.display(id);
                    }
                }, 0);
        };

        var absUrl;
        $rootScope.showTopSearch = false;
        $rootScope.indexTarget = true;
        $rootScope.mapTarget = false;
        $rootScope.ad = 0;


        $transitions.onStart({}, function () {
            if (googletag && googletag._loaded_ && typeof googletag.destroySlots === 'function') {
                googletag.destroySlots();
            }

            if (typeof window.tidioChatApi !== 'undefined')
                window.tidioChatApi.close();

            absUrl = !absUrl || absUrl !== 1 ? $location.absUrl() : 1;
            window.referrer = localStorage.getItem('referrer') || document.referrer;
            if (window.referrer)
                window.dataLayer.push({
                    referrer: window.referrer,
                    currency: window.currency,
                    language: window.lang.split('-')[0]
                });
        });

        $rootScope.version = $window.appVersion;

        window.onbeforeunload = function () {
            localStorage.removeItem('referrer');
        };

        // $transitions.onRetain({}, function (transition) {
        //     console.log(transition);
        // });


        var delayHandled = false;

        $transitions.onSuccess({}, function (transition) {
            $rootScope.isActiveRefBlog = false;
            $rootScope.isActiveRefCor = false;
            $rootScope.isActiveProf = false;
            $rootScope.isActiveRefVal = false;
            $rootScope.isActiveRefReg = false;

            $rootScope.ad = $location.search().ad;
            if (transition.to().name === "default") {
                $rootScope.showTopSearch = true;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = true;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else if (
                // transition.to().name === "hizmetler.region" ||
                // transition.to().name === "hizmetler.location" ||
                // transition.to().name === "hizmetler.guvenle-sat" ||
                // transition.to().name === "hizmetler.danisman" ||
                // transition.to().name === "hizmetler.otomatik" ||
                transition.to().name === "urunler.uyelik" ||
                transition.to().name === "startups" ||
                transition.to().name === "agent-detail" ||
                transition.to().name === "project-detail" ||
                transition.to().name === "mall-detail"
            ) {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = true;  // Pages with gradient heroes
            } else if (
                transition.to().name === "opportunity.listing"
            ) {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else if (transition.to().name === "oppor.listing") {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = true;
                $rootScope.heroPage = false;
            } else if (
                transition.to().name.indexOf("address") > -1 ||
                transition.to().name.indexOf("province") > -1 ||
                transition.to().name.indexOf("country") > -1 ||
                transition.to().name.indexOf("county") > -1 ||
                transition.to().name.indexOf("address") > -1 ||
                (transition.to().name.indexOf("block") > -1 && transition.to().name.indexOf("unblock") === -1) ||
                transition.to().name.indexOf("parcel") > -1 ||
                transition.to().name.indexOf("neighbourhood") > -1
            ) {
                $rootScope.showTopSearch = true;
                $rootScope.indexTarget = false;
                $rootScope.mapTarget = true;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = false;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            } else {
                $rootScope.showTopSearch = false;
                $rootScope.indexTarget = true;
                $rootScope.mapTarget = false;
                $rootScope.landingPage = false;
                $rootScope.valuationPageMobile = true;
                $rootScope.opportunity = false;
                $rootScope.heroPage = false;
            }

            if (transition.to().name.indexOf("profile") > -1 ||
                transition.to().name.indexOf("admin") > -1 ||
                transition.to().name.indexOf("localInfo") > -1 ||
                transition.to().name.indexOf("blog") > -1 ||
                transition.to().name.indexOf("Blog") > -1 ||
                transition.to().name.indexOf("satis") > -1 ||
                transition.to().name.indexOf("property") > -1
            ) {
                $rootScope.stateAccount = true;
                //this is for stateAccount only. dont put other tags here use the conditions above
            } else {
                $rootScope.stateAccount = false;
                //this is for stateAccount only. dont put other tags here use the conditions above
            }

            if (
                transition.to().name.indexOf("blog") > -1 ||
                transition.to().name.indexOf("Blog") > -1
            ) {
                $rootScope.isActiveRefBlog = true;
            }
            else if (
                transition.to().name.indexOf("cozumler") > -1 && transition.to().name.indexOf("uyelik") === -1
            ) {
                $rootScope.isActiveRefCor = true;
            }
            else if (
                transition.to().name.indexOf("profile") > -1
            ) {
                $rootScope.isActiveProf = true;
            }
            else if (
                transition.to().name.indexOf("valuation") > -1 || transition.to().name === "nasil" || transition.to().name === "hizmetler.danisman" || transition.to().name === "hizmetler.otomatik"
            ) {
                $rootScope.isActiveRefVal = true;
            }
            else if (
                (transition.to().name.indexOf("hizmetler") > -1 && transition.to().name !== "hizmetler.danisman" && transition.to().name !== "hizmetler.otomatik") || transition.to().name.indexOf("analysis") > -1
            ) {
                $rootScope.isActiveRefReg = true;
            }

            $window.localStorage.setItem("currentState", $state.current.name);
            $rootScope.params = transition.params();

            if (window.refMobile) $rootScope.params = Object.assign({ device: 'mobile' }, $rootScope.params);

            if (transition.to().name.indexOf('danisman') === -1)
                $rootScope.address = undefined;

            var abs = absUrl && absUrl !== 1 ? angular.copy(absUrl) : $location.absUrl();
            window.localStorage.setItem('referrer', abs);


            var current = $translate.use();
            if (!current || (transition.params().langcode && current !== transition.params().langcode))
                $translate.use(transition.params().langcode).then(function () {
                    fixCanonical(transition);
                });
            else
                fixCanonical(transition);

            // if (typeof $window.Intercom !== "undefined") $window.Intercom("update");

            var path = {
                'event': "page_change",
                'original_location': abs,
                'original_path': $location.url(),
                // 'original_title': document.title,
                'currency': window.currency,
                'language': window.lang.split('-')[0]
            };

            if (window.gclid)
                path.gclid = window.gclid;

            if (window.referrer)
                path.referrer = window.referrer;

            if (window.endeksa && window.endeksa.id)
                path.user_id = window.endeksa.id;

            if (window.endeksa && window.endeksa.email || window.endeksa && window.endeksa.phone) {
                path.user_data = {};
                if (window.endeksa && window.endeksa.email)
                    path.user_data.sha256_email_address = CryptoJS.SHA256(window.endeksa.email).toString();

                if (window.endeksa && window.endeksa.phone)
                    path.user_data.sha256_phone_number = CryptoJS.SHA256(window.endeksa.phone).toString();
            }

            window.dataLayer.push(path);
            absUrl = 1;
            // $window.gtag('set', {
            //     'currency': $rootScope.currency,
            //     'user_id': $window.endeksa ? $window.endeksa.id : undefined,
            //     'email': $window.endeksa ? $window.endeksa.email : undefined,
            // });

            if (typeof dengage !== 'undefined') {
                dengage('setNavigation', transition.to().name);
            }

            if (typeof gaconnector2 !== 'undefined') {
                gaconnector2.track("f3f4769b14ea4bac184d093eb9b66cf5");
            }

            if (typeof $window.hj !== "undefined" && $window.location.host === 'www.endeksa.com') {
                $window.hj("stateChange", $location.url());
            }

            if (!delayHandled) {
                //LOAD DELAYED SCRIPTS
                var autoLoadDuration = 10; //seconds
                var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
                var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
                eventList.forEach(function (event) {
                    window.addEventListener(event, triggerScripts, { passive: true });
                });
                function triggerScripts() {
                    runScripts();
                    clearTimeout(autoLoadTimeout);
                    eventList.forEach(function (event) {
                        window.removeEventListener(event, triggerScripts, { passive: true });
                    });
                }
                function runScripts() {
                    Array.from(document.querySelectorAll("script[delay]")).forEach(function (scriptTag) {
                        scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
                        scriptTag.removeAttribute("delay");
                    });

                    // $timeout(function () {
                    //     if (window.location.host === 'www.endeksa.com' && typeof window.TrackJS !== 'undefined')
                    //         window.TrackJS && TrackJS.install({
                    //             token: "d9788169264a439f8267134fe3ae08c0",
                    //             application: "endeksa"
                    //         });
                    // }, 1000);
                }
                delayHandled = true;
            }

            if (
                transition.to().name
            ) {
                restoreUrlService.saveLastState(
                    transition.to().name,
                    transition.params("to")
                );
            } else if (
                transition.from().name
            ) {
                restoreUrlService.saveLastState(
                    transition.from().name,
                    transition.params("from")
                );
            }
            //endeksa panel üzerinde son ziyaret edileni tutup ona göre default yönlendirmelerde panel sayfasında sekme açalım
            if (transition.to().name.indexOf('analysis.') > -1) {
                var params = angular.copy(transition.params("to")) || {};
                params.country = $rootScope.country;
                params.top = null;
                params.ref = null;
                params.e = null;
                params.t = null;
                params.d = null;
                params.ti = null;
                params.oi = null;
                params.l = null;

                var lastPanel = {
                    name: "analysis.country." + transition.to().name.split('.')[2],
                    param: params
                };
                $window.localStorage.setItem("lastVisitedPanel", JSON.stringify(lastPanel));
            }
            window.scrollTo(0, 0);
            //bazı sayfaların render süresi sarkabiliyor.
            $timeout(function () {
                window.scrollTo(0, 0);

                //check if user settings force language change
                const langChange = window.localStorage.getItem("ChangeLanguage");
                if (langChange) {
                    window.localStorage.removeItem("ChangeLanguage");
                    $rootScope.changeLanguageRoot(null, langChange);
                }
            });
        });
        $transitions.onError({}, function (transition) {
            var rejection = transition.error();

            // Handling different types of errors
            if (rejection.type === 6 && (!rejection.detail || !rejection.detail.message || rejection.detail.message.indexOf('Unable to load') === -1)) {
                // Error handling for specific type of error
                console.error("Transition name", transition.to().name);
                console.error("Transition error", transition.error());
                transition.abort();
                // Full page redirect to get proper 404 HTTP status code from server
                $window.location.replace("/" + ($window.lang || "en") + "/404");
            } else if (rejection.type === 6 && rejection.detail && rejection.detail.message && rejection.detail.message.indexOf('Unable to load') > -1) {
                // Error handling for another type of error
                transition.abort();
                $timeout(function () {
                    console.error("Lazyload error", rejection.detail.message);
                    $window.location.reload();
                }, 500);
            }
        });

        // documentClicked on document
        angular.element(document).on("click", function (e) {
            try {
                $rootScope.$broadcast("documentClicked", angular.element(e.target));
            }
            catch (err) {
                //ignored
            }
        });
    }
})();

(function () {
    "use strict";

    var controllerId = "TopNavController";

    angular
        .module("app.shell")
        .directive("headerScroll", ["$window", headerScroll])

        .controller(controllerId, [
            "$scope",
            "$rootScope",
            "userSvc",
            "$state",
            "guardSvc",
            "$timeout",
            TopNavController,
        ]);

    function TopNavController(
        $scope,
        $rootScope,
        userSvc,
        $state,
        guardSvc,
        $timeout
    ) {
        $scope.lang = $rootScope.lang;
        // $scope.version = $window.appVersion;
        if ($state.current.name.indexOf("property") === -1) $scope.showModalMobile = true;

        // Listen for property cleanup to ensure navigation state is reset
        $scope.$on('property:cleanup', function () {
            $timeout(function () {
                delete $rootScope.hideTopNavOnScroll;
                $scope.$digest();
            }, 0);
        });


        $scope.guardSvc = guardSvc;
        $scope.scrollTop = function () {
            if ($state.current.name.indexOf("default") > -1) window.scrollTo(0, 0);
        };

        $scope.activeMobileCurrency = false;
        $scope.mobileCurrency = function () {
            $scope.activeMobileCurrency = !$scope.activeMobileCurrency;
        };
        $scope.$on("documentClicked", function (event, element) {
            if ($scope.activeMobileCurrency && !element.hasClass('ei-language')) {
                $scope.activeMobileCurrency = false;
                $scope.$apply();
            }
        });

        $scope.handleAppBtn = function (platform = null) {
            window.dataLayer.push({
                event: "mobile_modal",
                action: platform === 'apple' ? 'App Store redirection' :
                    (platform === 'android' ? 'Google Play redirection' : 'Stay on the web'),
                platform: platform,
                language: window.lang.split('-')[0]
            });

            if (!platform) return;

            /* window.location.href = platform === 'apple' ?
            'https://apps.apple.com/us/app/endeksa-value-sell-property/id1272606231' :
            'https://play.google.com/store/apps/details?id=com.endeksa.app' */

            window.location.href = 'https://lsgt.adj.st?adj_t=1fhc5z7j&adj_deeplink_js=1&adj_fallback=https%3A%2F%2Fwww.endeksa.com%2F&adj_redirect_macos=https%3A%2F%2Fwww.endeksa.com%2F';


        };

        $scope.modalMobileShow = $rootScope.isMobileOrTablet() && !$rootScope.refMobile && !window.isHeadless() && window.location.href.indexOf('/atlas') === -1;

        $scope.initModalMobile = function () {
            $scope.platform = /iPad|iPhone|iPod/.test(navigator.userAgent) ? 'apple' : 'android';

        };

        // $scope.links = navigationSvc.getLinks();

        $rootScope.signOut = function () {
            userSvc.signOut().then(
                function () {
                    // $window.location = $state.href("default", {
                    //     langcode: $rootScope.lang,
                    // });
                    $state.go("default", {
                        langcode: $rootScope.lang,
                    });
                },
                function (rej) {
                    console.log(rej);
                }
            );
        };


        guardSvc.hasPackage([
            "eco-package",
            'seller-lead-package',
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package",
            "location-package"]).then(function (result) {
                $rootScope.isPro = result;
            });

        guardSvc.hasPackage([
            "eco-package",
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package",
            "location-package"]).then(function (result) {
                $rootScope.isProWithoutSellerLead = result;
            });

        guardSvc.hasPackage([
            "eco-package",
            'seller-lead-package',
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package"]).then(function (result) {
                $rootScope.isAgent = result;
            });

        $scope.$on("userSvc:signedInChanged", function () {
            $rootScope.SignedIn = userSvc.info.SignedIn;
            $rootScope.user = userSvc.info;
            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package",
                "location-package"]).then(function (result) {
                    $rootScope.isPro = result;
                });

            guardSvc.hasPackage([
                "eco-package",
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "terminal-package",
                "real-estate-package",
                "location-package"]).then(function (result) {
                    $rootScope.isProWithoutSellerLead = result;
                });

            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package"]).then(function (result) {
                    $rootScope.isAgent = result;
                });

        });
        $rootScope.user = userSvc.info;
        $rootScope.isMobile = function () { return window.isMobile(); };

        $scope.menuVisible = false;
        $scope.openMenu = function () {
            $("#mobile-menu").show();
            $scope.menuVisible = true;
            $timeout(function () {
                window.Beamer.init();
            });
        };

        $scope.closeMenu = function () {
            $("#mobile-menu").hide();
            $scope.menuVisible = false;
        };

    }

    function headerScroll($window) {
        var directive = {
            scope: {
                offset: "@",
            },
            link: function (scope, element) {
                var scheduledAnimationFrame = false;
                var lastScrollY = 0;
                var isActive = true;

                function readAndUpdatePage() {
                    if (!isActive) {
                        scheduledAnimationFrame = false;
                        return;
                    }

                    if (lastScrollY > 25) {
                        if (!element.hasClass("nav-scroll-target")) {
                            element.addClass("nav-scroll-target");
                        }
                    } else {
                        // Always remove nav-scroll-target when scrolled to top, unless on Renta
                        if (!$window.isRenta && element.hasClass("nav-scroll-target")) {
                            element.removeClass("nav-scroll-target");
                        }
                    }
                    scheduledAnimationFrame = false;
                }

                function onScroll() {
                    lastScrollY = window.scrollY || 0;

                    if (scheduledAnimationFrame) {
                        return;
                    }

                    scheduledAnimationFrame = true;
                    requestAnimationFrame(readAndUpdatePage);
                }

                // Bind scroll handler
                angular.element($window).bind("scroll", onScroll);

                // Listen for property cleanup event to reset state
                var propertyCleanupListener = scope.$root.$on('property:cleanup', function () {
                    // Force reset nav state
                    lastScrollY = 0;
                    element.removeClass("nav-scroll-target");
                    element.removeClass("hide-on-property-scroll");

                    // Re-trigger scroll check
                    setTimeout(function () {
                        onScroll();
                    }, 150);
                });

                // Clean up on destroy
                scope.$on('$destroy', function () {
                    isActive = false;
                    angular.element($window).unbind("scroll", onScroll);
                    if (propertyCleanupListener) {
                        propertyCleanupListener();
                    }
                });

                // Initial check
                setTimeout(function () {
                    onScroll();
                }, 100);
            },
        };
        return directive;
    }
})();

(function () {
    'use strict';

    angular.module('app')
        .directive('skMatches', [skMatches]);

    function skMatches() {
        var directive = {
            require: 'ngModel',
            link: link,
            restrict: 'A',
            transclude: true
        };

        $.getDeep = function (obj, path) {
            for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                if (obj) {
                    obj = obj[path[i]];
                } else {
                    return obj;
                }
            }
            return obj;
        };

        return directive;

        function link(scope, elem, attrs, ctrl) {
            var property1 = attrs.ngModel;
            var property2 = attrs.skMatches;

            scope.$watch(property1, matchValues);
            scope.$watch(property2, matchValues);

            function matchValues() {
                var val1 = $.getDeep(scope, property1);
                var val2 = $.getDeep(scope, property2);

                if (val1 === val2) {
                    ctrl.$setValidity('matches', true);
                } else {
                    ctrl.$setValidity('matches', false);
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('skAsyncValidators', skAsyncValidators);

    skAsyncValidators.$inject = ['$parse'];

    function skAsyncValidators($parse) {
        var directive = {
            require: 'ngModel',
            link: link,
            restrict: 'A'
        };

        return directive;

        function link(scope, element, attrs, ngModel) { 
            var asyncValidators = scope.$eval(attrs["skAsyncValidators"]);

            if (asyncValidators) {
                angular.extend(ngModel.$asyncValidators, asyncValidators);
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.common').directive('clickOff', ["$parse", "$document", function($parse, $document) {
        var dir = {
            compile: function($element, attr) {
                // Parse the expression to be executed
                // whenever someone clicks _off_ this element.
                var fn = $parse(attr.clickOff);
                return function(scope, element, attr) {
                    // add a click handler to the element that
                    // stops the event propagation.
                    element.bind("click", function(event) {
                        event.stopPropagation();
                    });
                    angular.element($document[0].body).bind("click",function(event) {
                        scope.$apply(function() {
                            fn(scope, {$event:event});
                        });
                    });
                };
            }
        };
        return dir;
    }]);

    angular.module('app.common').directive('bsTooltip', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).hover(function () {
                    // on mouseenter
                    $(element).tooltip('show');
                }, function () {
                    // on mouseleave
                    $(element).tooltip('hide');
                }); 
            }
        };
    });

})();

/**
 * Third-Party Script Lazy Loader
 * Delays loading of non-critical third-party scripts until user interaction
 * This improves Time to Interactive and reduces main thread blocking
 */
(function () {
    'use strict';

    angular
        .module('app.common')
        .factory('thirdPartyLoader', thirdPartyLoader);

    thirdPartyLoader.$inject = ['$window', '$timeout'];

    function thirdPartyLoader($window, $timeout) {
        var loaded = {};
        var hasUserInteracted = false;
        var tidioVisible = false;

        /**
         * Load a third-party script dynamically
         * @param {string} src - Script URL
         * @param {string} id - Unique identifier for the script
         * @param {object} options - Additional script attributes
         */
        function loadScript(src, id, options) {
            if (loaded[id]) {
                console.log('Third-party script already loaded:', id);
                return;
            }

            loaded[id] = true;
            console.log('Loading third-party script:', id);

            var script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.defer = true;

            // Add any additional attributes
            if (options) {
                Object.keys(options).forEach(function (key) {
                    script.setAttribute(key, options[key]);
                });
            }

            // Error handling
            script.onerror = function () {
                console.error('Failed to load third-party script:', id, src);
                loaded[id] = false;
            };

            document.body.appendChild(script);
        }

        /**
         * Load AND show Tidio chat widget after scroll (LCP optimization)
         * CRITICAL: Tidio script is NOT loaded until scroll to prevent LCP manipulation
         */
        function showTidio() {
            if (tidioVisible) return;
            tidioVisible = true;

            // Only load on desktop and non-quake mode
            var isDesktop = !$window.deviceType || $window.deviceType !== 'mobile';
            var isQuakeMode = $window.quake || false;

            if (!isDesktop || isQuakeMode) {
                console.log('Tidio skipped (mobile or quake mode)');
                return;
            }

            console.log('Scroll detected - loading Tidio script now (LCP-safe)');

            // Load Tidio script ONLY after scroll
            loadScript(
                'https://code.tidio.co/j5alrjdajkdksb5lhqle6ssooanm9dgf.js',
                'tidio',
                { 'fetchpriority': 'low' }
            );

            // Poll for Tidio element and make it visible
            var checkInterval = setInterval(function () {
                var tidioButton = document.getElementById('tidio-chat');

                if (tidioButton) {
                    clearInterval(checkInterval);

                    // Add fade-in class to show Tidio
                    tidioButton.classList.add('tidio-fade-in');
                    console.log('Tidio chat widget loaded and visible');

                    // Also show any wrapper divs
                    var tidioWrapper = document.querySelector('#tidio-chat-code + div');
                    if (tidioWrapper) {
                        tidioWrapper.classList.add('tidio-fade-in');
                    }
                }
            }, 100); // Check every 100ms

            // Timeout: Stop checking after 5 seconds
            $timeout(function () {
                clearInterval(checkInterval);
            }, 5000);
        }

        /**
         * Load all third-party scripts (including Tidio, but hidden via CSS)
         */
        function loadAllScripts() {
            if (hasUserInteracted) return;
            hasUserInteracted = true;

            console.log('User interaction detected - loading third-party scripts');


            // Only load on desktop and non-quake mode
            var isDesktop = !$window.deviceType || $window.deviceType !== 'mobile';
            var isQuakeMode = $window.quake || false;

            if (isDesktop && !isQuakeMode) {
                // Beamer - Product updates and announcements
                loadScript(
                    'https://app.getbeamer.com/js/beamer-embed.js',
                    'beamer',
                    { 'fetchpriority': 'low' }
                );

                // Tidio - NOT loaded here! Only loads after scroll (see showTidio function)
                // This prevents Tidio from manipulating DOM and affecting LCP
            }

            // Wootric - User feedback (load on all devices)
            loadScript(
                'https://cdn.wootric.com/wootric-sdk.js',
                'wootric',
                { 'fetchpriority': 'low' }
            );

            // Google Ads (DoubleClick)
            loadScript(
                'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
                'google-ads',
                {
                    'fetchpriority': 'low',
                    'unsafe-inline': true
                }
            );
        }

        /**
         * Initialize lazy loading
         * Waits for user interaction or timeout before loading scripts
         * CRITICAL: Delayed to prevent interfering with LCP measurement
         */
        function initLazyLoad() {
            // User interaction events (including scroll - loads all scripts)
            var events = ['scroll', 'mousemove', 'touchstart', 'touchmove', 'keydown', 'click'];

            // CRITICAL LCP FIX: Minimum delay of 3 seconds
            // LCP is typically measured within 2.5s - we wait 3s to be safe
            var minDelayForLCP = 3000; // 3 seconds minimum
            var timeoutDuration = 5000; // 5 seconds fallback
            var loadTriggered = false;
            var interactionTime = null;

            // Event handler to load scripts
            function onUserInteraction() {
                if (loadTriggered) return;

                interactionTime = Date.now();

                // Remove all event listeners
                events.forEach(function (eventName) {
                    $window.removeEventListener(eventName, onUserInteraction);
                });

                // CRITICAL: Wait minimum 3 seconds from page load before loading scripts
                // This prevents third-party scripts from manipulating DOM during LCP measurement
                var timeFromPageLoad = Date.now() - (window.performance && window.performance.timing ? window.performance.timing.navigationStart : 0);
                var remainingDelay = Math.max(0, minDelayForLCP - timeFromPageLoad);

                console.log('User interaction detected - waiting ' + remainingDelay + 'ms before loading third-party scripts (LCP protection)');

                $timeout(function () {
                    loadTriggered = true;
                    loadAllScripts();
                }, remainingDelay);
            }

            // Attach event listeners (passive for better performance)
            events.forEach(function (eventName) {
                $window.addEventListener(eventName, onUserInteraction, {
                    once: true,  // Automatically remove after first call
                    passive: true  // Doesn't block scrolling
                });
            });

            // Fallback timeout - also respects minimum LCP delay
            $timeout(function () {
                if (!loadTriggered) {
                    console.log('Timeout reached - loading third-party scripts');
                    loadTriggered = true;
                    loadAllScripts();
                }
            }, timeoutDuration);

            // Separate scroll handler to SHOW Tidio (script already loaded, just hidden)
            initTidioVisibility();

            console.log('Third-party lazy loader initialized (LCP-safe: 3s minimum delay)');
        }

        /**
         * Initialize Tidio visibility controller
         * Tidio script loads with other third-party, but visibility controlled ONLY by scroll
         */
        function initTidioVisibility() {
            var scrollThreshold = 300; // pixels (ONLY trigger - no timeout fallback)

            function onScroll() {
                var scrollY = $window.scrollY || $window.pageYOffset;

                if (scrollY > scrollThreshold) {
                    $window.removeEventListener('scroll', onScroll);
                    showTidio();
                }
            }

            // Listen for scroll events only (no timeout fallback)
            $window.addEventListener('scroll', onScroll, { passive: true });

            console.log('Tidio visibility controller initialized (scroll-only, threshold: ' + scrollThreshold + 'px)');
        }

        // Public API
        return {
            init: initLazyLoad,
            loadScript: loadScript,
            showTidio: showTidio  // Expose for manual triggering if needed
        };
    }
})();

(function () {
    "use strict";

    shareThis.$inject = ["$timeout", "$window"];
    angular.module("app.common").directive("shareThis", shareThis);

    shareThis.$injects = ["$timeout", "$window"];

    function shareThis($timeout, $window) {
        function createHtml(url, description, title) {
            return (
                // '<div class="sharethis-inline-share-buttons" ' +
                // 'data-url="' +
                // url +
                // '" ' +
                // 'data-description="' +
                // description +
                // '" ' +
                // 'data-title="' +
                // title +
                // '">' +
                //"</div>"
                '<div class="sharethis-inline-share-buttons"></div>'
            );
        }

        return {
            restrict: "EA",
            scope: {},
            link: function postLink(scope, element, attrs) {
                element.html(createHtml(attrs.url, attrs.description, attrs.title));
                $timeout(function () {
                    if ($window.__sharethis__) {
                        $window.__sharethis__.initialize();
                        // if (attrs.url) {
                        //     var url =
                        //         attrs.url.indexOf("http") > -1 ?
                        //         attrs.url :
                        //         "https://" + attrs.url;
                        //     $window.addthis.toolbox(
                        //         $(element).get(), {}, {
                        //             url: url,
                        //             title: attrs.title,
                        //             description: attrs.description,
                        //         }
                        //     );
                        // } else {
                        //     $window.addthis.toolbox($(element).get());
                        // }
                        // if ($window.addthis.layers.refresh) {
                        //     $window.addthis.layers.refresh();
                        // }
                    }
                }, 300);
            },
        };
    }
})();
angular.module('app.inArrayFilter', ['InArrayFilter']);

var inArrayFilter = angular.module('InArrayFilter', []);

inArrayFilter.filter('inArray', ["$filter", function($filter){
    return function(list, arrayFilter, element){
        if(arrayFilter){
            return $filter("filter")(list, function(listItem){
                return arrayFilter.indexOf(listItem[element]) != -1;
            });
        }
    };
}]);


(function () {
    'use strict';

    angular.module('app.common')
        .factory('mapOptionsService', ['$translate', mapOptionsService]);

    function mapOptionsService($translate) {
        var obj = {
            drawLayer: null,
            tempLayer: null,
            getDefaultOptions: getDefaultOptions,
            getDefaultOptionsSimple: getDefaultOptionsSimple,
            getOptions: getOptions,
            getOptionsRealEstate: getOptionsRealEstate,
            getOptionsPlatinum: getOptionsPlatinum,
            getOptionsPremium: getOptionsPremium,

            getOptionsLocation: getOptionsLocation,
            getOptionsWidget: getOptionsWidget,
            getOptionsAgent: getOptionsAgent,
            getMapOptionsNeighbors: getMapOptionsNeighbors,
            getLandingOptions: getLandingOptions,
            getOptionsQuake: getOptionsQuake,
            getMarker: getMarker,
            getDraw: drawControl,
            getOpportunityOptions: getOpportunityOptions,
            mapBoxToken: 'pk.eyJ1IjoiZW5kZWtzYSIsImEiOiJja21kdWZvcjMxdXk2MnBwaGVneHJjeXB3In0.jsYPQYIVhGIYF4AXFS5O7A'
        };

        var r2x = "@2x";

        if (!window.isHighDensity() && !window.isRetina()) {
            r2x = "";
        }

        return obj;

        function getLandingOptions() {
            return {
                defaults: {
                    zoomControlPosition: false,
                    attributionControl: false,
                    zoomControl: false,
                    zoom: 3,
                    scrollWheelZoom: false
                },
                layers: {
                    baselayers: {},
                    overlays: {
                        markers: {
                            name: 'Markers',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                    }
                }
            };
        }

        function getOpportunityOptions(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 7
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            }
                        }
                    }
                }
            };
        }

        function getDefaultOptions(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 19
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        }
                    },
                    overlays: {
                        // opportunities: {
                        //     name: $translate.instant('c_map10'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // agents: {
                        //     name: $translate.instant('c_map9'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // }
                    }
                }
            };
        }


        function getDefaultOptionsSimple(position) {
            return {
                detaildefaults: {
                    zoomControlPosition: position ? position : 'topleft',
                    attributionControl: false,
                    zoomControl: position === 'hide' ? false : true,
                    zoom: 19
                },
                detaillayers: {
                    baselayers: {
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=s@189&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            }
                        },
                        // mapbox_satellite: {
                        //     name: $translate.instant('c_map3'),
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     type: 'xyz',
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     }
                        // }
                    },
                    overlays: {

                        // opportunities: {
                        //     name: $translate.instant('c_map10'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // agents: {
                        //     name: $translate.instant('c_map9'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // quakes: {
                        //     name: $translate.instant('c_map8'),
                        //     type: 'markercluster',
                        //     visible: true,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // }
                    }
                }
            };
        }



        function getOptions() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pencil: {
                        //    name: window.lang === 'tr' ? 'Kara Kalem' : 'Pencil',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.pencil/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        //streeta: {
                        //    name: window.lang === 'tr' ? 'Açık Ton' : 'Light',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.light/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pastel: {
                        //    name: 'Pastel',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.wheatpaste/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},

                        //yandex: {
                        //    name: 'Yandex',
                        //    type: 'yandex',
                        //    layerOptions: {
                        //        attribution: "&copy; Yandex",
                        //        layerType: 'map'
                        //    }
                        //}

                    },
                    overlays: {
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        malls: {
                            name: $translate.instant('c_map20'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        projects: {
                            name: $translate.instant('c_map21'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                    }
                }
            };
        }

        function getOptionsPremium() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pencil: {
                        //    name: window.lang === 'tr' ? 'Kara Kalem' : 'Pencil',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.pencil/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        //streeta: {
                        //    name: window.lang === 'tr' ? 'Açık Ton' : 'Light',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.light/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },
                        //pastel: {
                        //    name: 'Pastel',
                        //    type: 'xyz',
                        //    visible: true,
                        //    url: 'https://api.mapbox.com/v4/mapbox.wheatpaste/{z}/{x}/{y}' + r2x + '.png?access_token=' + obj.mapBoxToken,
                        //    layerOptions: {
                        //        attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //        continuousWorld: true,
                        //        maxZoom: 22,
                        //        minZoom: 3
                        //    },
                        //    group: $translate.instant('c_map5')
                        //},

                        //yandex: {
                        //    name: 'Yandex',
                        //    type: 'yandex',
                        //    layerOptions: {
                        //        attribution: "&copy; Yandex",
                        //        layerType: 'map'
                        //    }
                        //}

                    },
                    overlays: {
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     }
                        // },
                    }
                }
            };
        }

        function getOptionsRealEstate() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        },

                    },
                    overlays: {
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },

                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },

                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        malls: {
                            name: $translate.instant('c_map20'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        projects: {
                            name: $translate.instant('c_map21'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                    }
                }
            };
        }


        function getOptionsPlatinum() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {

                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },

                        traffic: {
                            name: $translate.instant('c_map30'),
                            url: 'https://api.tomtom.com/traffic/map/4/tile/flow/absolute/{z}/{x}/{y}.png?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0',
                            type: 'xyz',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2021 TomTom",
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            }
                        },
                        street: {
                            name: $translate.instant('c_map22'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        tpi: {
                            name: $translate.instant('c_map31'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        isochrone: {
                            name: 'Isochrone',
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // }
                    }
                }
            };
        };

        function getOptionsAgent() {
            return {
                defaults: {
                    zoomControlPosition: 'bottomleft',
                    attributionControl: true,
                    zoom: 9
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        places: {
                            name: 'POI',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        }
                    }
                }
            };
        }

        function getOptionsQuake() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {
                        quakes: {
                            name: $translate.instant('c_map8'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        }
                    }
                }
            };
        }

        function getOptionsWidget() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        }
                        // mapbox: {
                        //     name: $translate.instant('c_map2'),
                        //     type: 'xyz',
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     },
                        //     group: $translate.instant('c_map5')
                        // }
                    },
                    overlays: {
                        places: {
                            name: 'POI',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9,
                                showOnSelector: false
                            }
                        },
                        quakes: {
                            name: $translate.instant('c_map8'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        }
                    }
                }
            };
        }

        function getOptionsLocation() {
            return {
                defaults: {
                    zoomControlPosition: 'topleft',
                    attributionControl: true,
                    zoom: 9
                },
                layercontrol: {
                    order: false,
                    // icons: {
                    //     uncheck: "fa ei-toggle-off",
                    //     check: "fa ei-toggle-on"
                    // }
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        google_satellite: {
                            name: $translate.instant('c_map1'),
                            url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map34'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true
                            },
                            group: $translate.instant('c_map4')
                        },
                        mapbox_satellite: {
                            name: $translate.instant('c_map3'),
                            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            }
                        },
                        mapbox: {
                            name: $translate.instant('c_map2'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_terrain: {
                            name: $translate.instant('c_map15'),
                            type: 'xyz',
                            url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,

                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        },
                        mapbox_dark: {
                            name: $translate.instant('c_map6'),
                            type: 'xyz',
                            visible: true,
                            url: 'https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                            layerOptions: {
                                attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3
                            },
                            group: $translate.instant('c_map5')
                        }
                    },
                    overlays: {

                        locations: {
                            name: $translate.instant('c_map36'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        },
                        sales: {
                            name: $translate.instant('c_map37'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        },
                        isochrone: {
                            name: 'Isochrone',
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        voronoi: {
                            name: 'Voronoi',
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false,

                            }
                        },
                        places: {
                            name: 'POI',
                            type: 'markerscanvas',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,

                            }
                        },
                        draw: {
                            name: $translate.instant('c_map35'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            }
                        },
                        heatmap: {
                            name: $translate.instant('c_map7'),
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                maxZoom: 22,
                                minZoom: 9
                            }
                        },

                        traffic: {
                            name: $translate.instant('c_map30'),
                            url: 'https://api.tomtom.com/traffic/map/4/tile/flow/absolute/{z}/{x}/{y}.png?key=xHAk40RiUkJsPXwXbk95NT7IvYZlWVr0',
                            type: 'xyz',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2021 TomTom",
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            }
                        },
                        street: {
                            name: $translate.instant('c_map22'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                maxZoom: 22,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        tpi: {
                            name: $translate.instant('c_map31'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentStore: {
                            name: $translate.instant('c_map23'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceStore: {
                            name: $translate.instant('c_map24'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialRentOffice: {
                            name: $translate.instant('c_map25'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        commercialPriceOffice: {
                            name: $translate.instant('c_map26'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map14')
                        },
                        salesCount: {
                            name: $translate.instant('c_map32'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propSalePrice: {
                            name: $translate.instant('c_map27'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRentPrice: {
                            name: $translate.instant('c_map28'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propRoom: {
                            name: $translate.instant('c_map17'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propArea: {
                            name: $translate.instant('c_map16'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propFloor: {
                            name: $translate.instant('c_map18'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        propAge: {
                            name: $translate.instant('c_map19'),
                            type: 'group',
                            visible: false,
                            layerOptions: {
                                attribution: "&copy; 2024 Endeksa",
                                continuousWorld: true,
                                maxZoom: 18,
                                minZoom: 9,
                                opacity: 0.5
                            },
                            group: $translate.instant('c_map13')
                        },
                        // malls: {
                        //     name: $translate.instant('c_map20'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        // projects: {
                        //     name: $translate.instant('c_map21'),
                        //     type: 'markercluster',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // },
                        opportunities: {
                            name: $translate.instant('c_map10'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        agents: {
                            name: $translate.instant('c_map9'),
                            type: 'markercluster',
                            visible: false,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        portfolio: {
                            name: $translate.instant('c_map11'),
                            type: 'markercluster',
                            visible: true,
                            layerOptions: {
                                showCoverageOnHover: false
                            },
                            group: $translate.instant('c_map12')
                        },
                        // megaProjects: {
                        //     name: window.lang === 'tr' ? 'Mega Projeler' : 'Mega Projects',
                        //     type: 'group',
                        //     visible: false,
                        //     layerOptions: {
                        //         showCoverageOnHover: false
                        //     },
                        //     group: $translate.instant('c_map12')
                        // }
                    }
                }
            };
        }

        function getMarker(lat, lng, message) {


            if (message && !isMobile())
                return {
                    m1: {
                        //layer: 'places',
                        lat: lat,
                        lng: lng,
                        message: message,
                        focus: true,
                        opacity: 1,
                        draggable: false,
                        zIndexOffset: -1,
                        icon: {
                            type: 'awesomeMarker',
                            prefix: 'ei',
                            icon: 'endeksa',
                            markerColor: "red",
                            iconColor: "#fff"
                        },
                        properties: {
                            distance: 0,
                            key: 'm1'
                        }
                    }
                };
            else
                return {
                    m1: {
                        lat: lat,
                        lng: lng,
                        focus: true,
                        opacity: 1,
                        draggable: false,
                        zIndexOffset: -1,
                        icon: {
                            type: 'awesomeMarker',
                            prefix: 'ei',
                            icon: 'endeksa',
                            markerColor: "red",
                            iconColor: "#fff"
                        },
                        properties: {
                            distance: 0,
                            key: 'm1'
                        }
                    }
                };
        }

        function drawControl() {
            return {
                //position: 'topleft',
                //edit: {
                //    featureGroup: obj.drawLayer,
                //},
                draw: {
                    polyline: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    polygon: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    circle: {
                        //guideLayers: [obj.drawLayer, obj.tempLayer],
                        allowIntersection: false,
                        shapeOptions: {
                            color: '#FF0550',
                            clickable: false
                        },
                        metric: true,
                        feet: false,
                        nautic: false
                    },
                    //rectangle: {
                    //    //guideLayers: [obj.drawLayer, obj.tempLayer],
                    //    allowIntersection: false,
                    //    shapeOptions: {
                    //        color: '#FF0550',
                    //        clickable: false
                    //    },
                    //    metric: true,
                    //    feet: false,
                    //    nautic: false
                    //},
                    rectangle: false,
                    marker: false,
                    circlemarker: false
                }
            };
        }

        function getMapOptionsNeighbors() {
            return {
                defaults: {
                    zoomControlPosition: 'bottomleft',
                    attributionControl: true
                },
                detaillayers: {
                    baselayers: {
                        google: {
                            name: 'Google',
                            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

                            type: 'xyz',
                            layerOptions: {
                                attribution: $translate.instant('c_map29'),
                                continuousWorld: true,
                                maxZoom: 22,
                                minZoom: 3,
                                subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                                detectRetina: true,
                                light: true
                            },
                            group: $translate.instant('c_map5')
                        }
                        // mapbox: {
                        //     name: $translate.instant('c_map2'),
                        //     type: 'xyz',
                        //     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}' + r2x + '?access_token=' + obj.mapBoxToken,
                        //     layerOptions: {
                        //         attribution: $translate.instant('© Mapbox © OpenStreetMap'),
                        //         continuousWorld: true,
                        //         maxZoom: 22,
                        //         minZoom: 3
                        //     },
                        //     group: $translate.instant('c_map5')
                        // }
                    },
                    overlays: {
                        places: {
                            name: 'İmleçler',
                            type: 'group',
                            visible: true,
                            layerOptions: {
                                continuousWorld: true,

                            }
                        }
                    }
                }
            };
        }

    }
})();

(function () {
    'use strict';

    var serviceId = 'parcelClientService';

    angular.module('app.common')
        .factory(serviceId, ['$http', '$q', 'appSettingsSvc', 'guardSvc', '$window', '$ocLazyLoad', parcelClientService]);

    function parcelClientService($http, $q, appSettingsSvc, guardSvc, $window, $ocLazyLoad) {

        var obj = {
            getCities: getCities,
            getCounties: getCounties,
            getNeighborhoods: getNeighborhoods,
            getParcelInfoById: getParcelInfoById,
            getParcelByValues: getParcelByValues,
            getParcelFromLocation: getParcelFromLocation,
            getParcelInfoByPropertyId: getParcelInfoByPropertyId,
            fixSelections: fixSelections,
            getBB: getBB,
            asignParcelProperties: asignParcelProperties
        };


        function fixSelections(data, officeRights, hasAdvance) {
            if ($window.parcelRecord && $window.parcelRecord.data.nitelik) {
                var nitelik = $window.parcelRecord.data.nitelik.toLowerCase();
                if (officeRights && (nitelik.indexOf('tarla') > -1 || nitelik.indexOf('çayır') > -1 || nitelik.indexOf('arazi') > -1)) {
                    data.PropertyCategory = 3;
                    data.PropertyType = 2;
                }
                else if (officeRights && nitelik.indexOf('arsa') > -1) {
                    data.PropertyCategory = 3;
                    data.PropertyType = 1;
                }
                else {
                    data.PropertyCategory = hasAdvance ? 2 : 1;
                }
            }
        }


        function getCities(cache) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/illiste', {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });
            return deferred.promise;
        }


        //$http cache'i 404'leri saklamadığı için blok isteğini promise bazında memoize ediyoruz (ES-4304)
        var blockRequests = {};

        function getBlock(cache, mahalle, ada, parsel) {
            if ($window.parcelRecord.data && ($window.parcelRecord.data.nitelik.toLowerCase().indexOf('arazi') > -1 || $window.parcelRecord.data.nitelik.toLowerCase().indexOf('tarla') > -1 || $window.parcelRecord.data.nitelik.toLowerCase().indexOf('çayır') > -1))
                return $q.resolve({
                    result: "success",
                    data: null
                });
            if (cache)
                return $q.resolve({
                    result: "success",
                    data: cache
                });
            var key = mahalle + '/' + ada + '/' + parsel;
            if (blockRequests[key])
                return blockRequests[key];
            blockRequests[key] = $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/blok/' + key, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    return {
                        result: "success",
                        data: response.data || null
                    };
                }).catch(
                    function (err) {
                        //Sadece 404 kalıcı; geçici hatalarda bir sonraki akış yeniden denesin
                        if (err.status !== 404)
                            delete blockRequests[key];
                        return {
                            result: "success",
                            data: null
                        };
                    });
            return blockRequests[key];
        }
        function getBB(cache, mahalle, ada, parsel, Block) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/bagimsizbolum/' + mahalle + '/' + ada + '/' + parsel + '/' + Block, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.resolve({
                            result: "success",
                            data: null
                        });
                }).catch(
                    function () {
                        deferred.resolve({
                            result: "success",
                            data: null
                        });
                    });
            return deferred.promise;
        }

        function getCounties(ilid, cache, pass) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/ilceliste/' + ilid, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });

            return deferred.promise;
        }

        function getNeighborhoods(ilceid, cache, pass) {
            var deferred = $q.defer();
            if (cache)
                deferred.resolve({
                    result: "success",
                    data: cache
                });
            //Proxy hizmeti normale dönene kadar cacheliyoruz
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=idariYapi/mahalleliste/' + ilceid, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (response) {
                    if (response.data)
                        deferred.resolve({
                            result: "success",
                            data: response.data
                        });
                    else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });
            return deferred.promise;
        }

        function getParcelByValues(mahalle, ada, parsel) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + mahalle + '/' + ada + '/' + parsel, {
                cache: true,
                skipAuthorization: true
            }).then(
                function (result) {
                    if (result.data) {
                        asignParcelProperties(result).then(function () {
                            getBlock(null, mahalle, ada, parsel).then(function (resb) {
                                if (resb.data)
                                    $window.parcelRecord.blocks = resb.data.features;
                                deferred.resolve({
                                    result: "success",
                                    data: $window.parcelRecord
                                });
                            });
                        });
                    } else
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                }).catch(
                    function () {
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    });


            return deferred.promise;
        }

        function asignParcelProperties(asign) {
            var deferred = $q.defer();
            $ocLazyLoad.load('/assets/js/polylabel.js?v=' + window.appVersion).then(function () {
                var geometry = asign.data ? asign.data.geometry : asign.geometry;
                var properties = asign.data ? asign.data.properties : asign.properties.parcelDetails.properties;
                var geoData = asign.data ? asign.data : asign.properties.parcelDetails;

                $window.parcelRecord = {
                    ilId: properties.ilId,
                    ilceId: properties.ilceId,
                    mahalleId: properties.mahalleId,
                    ada: properties.adaNo,
                    parselId: properties.parselId,
                    geo: geoData,
                    data: properties,
                    center: null
                };
                var geoms, center;
                if (!properties.gittigiParselSebep) {
                    geoms = geometry.coordinates;
                    if (geometry.type === "MultiPolygon") geoms = geometry.coordinates[0];
                    else if (geometry.type === "Polygon" && geoms[0][0].length > 2) geoms = geometry.coordinates[0][1];
                    else if (geometry.type === "GeometryCollection")
                        geoms = geometry.geometries[0].coordinates;
                    try {
                        center = polylabel(geoms, 1.0);
                        $window.parcelRecord.center = center;
                        $window.selectedLocation = $window.parcelRecord.center[0] + " " + $window.parcelRecord.center[1];
                        $window.gatheredLocation = $window.selectedLocation;
                    }
                    catch (err) {
                        console.error(err);
                    }
                } else {
                    alert(
                        "Bu parsel değiştirilmiştir. Açıklama: " +
                        properties.gittigiParselSebep +
                        ". Yeni parsele yönlendiriliyorsunuz..."
                    );
                    var gittigi = JSON.parse(properties.gittigiParselListe);
                    if (gittigi.features.length) {
                        $window.parcelRecord = {
                            ilId: gittigi.features[0].properties.ilId,
                            ilceId: gittigi.features[0].properties.ilceId,
                            mahalleId: gittigi.features[0].properties.mahalleId,
                            ada: gittigi.features[0].properties.adaNo,
                            parselId: gittigi.features[0].properties.parselId,
                            geo: gittigi.features[0],
                            data: gittigi.features[0].properties,
                            center: null,
                            bb: (gittigi.features[0].properties.bagimsizBolum ? JSON.parse(gittigi.features[0].properties.bagimsizBolum) : null)
                        };
                    }
                    else if (gittigi.properties) {
                        $window.parcelRecord = {
                            ilId: gittigi.properties.ilId,
                            ilceId: gittigi.properties.ilceId,
                            mahalleId: gittigi.properties.mahalleId,
                            ada: gittigi.properties.adaNo,
                            parselId: gittigi.properties.parselId,
                            geo: gittigi,
                            data: gittigi.properties,
                            center: null,
                            bb: (gittigi.properties.bagimsizBolum ? JSON.parse(gittigi.properties.bagimsizBolum) : null)
                        };
                    }
                    geoms = gittigi.features[0].geometry.coordinates;
                    if (gittigi.features[0].geometry.type === "MultiPolygon") geoms = gittigi.features[0].geometry.coordinates[0];
                    else if (gittigi.features[0].geometry.type === "Polygon" && geoms[0][0].length > 2) geoms = gittigi.features[0].geometry.coordinates[0][1];
                    else if (geometry && geometry.type === "GeometryCollection")
                        geoms = geometry.geometries[0].coordinates;
                    try {
                        center = polylabel(geoms, 1.0);
                        $window.parcelRecord.center = center;
                        $window.selectedLocation = $window.parcelRecord.center[0] + " " + $window.parcelRecord.center[1];
                        $window.gatheredLocation = $window.selectedLocation;
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                deferred.resolve();
            });
            return deferred.promise;
        }

        function getParcelFromLocation(lat, lng, pass) {
            var deferred = $q.defer();
            if ($window.parcelRecord && !$window.parcelRecord.bb || !$window.parcelRecord) {
                $window.parcelRecord = null;
                guardSvc.hasPackage().then(function (res) {
                    if (res || pass) {
                        $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + lat + '/' + lng, {
                            cache: true,
                            skipAuthorization: true
                        }).then(
                            function (result) {
                                if (result.data) {
                                    asignParcelProperties(result).then(function () {
                                        getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                            if (resb.data)
                                                $window.parcelRecord.blocks = resb.data.features;
                                            deferred.resolve({
                                                result: "success",
                                                data: $window.parcelRecord
                                            });
                                        });
                                    });
                                }
                                else
                                    deferred.reject({
                                        result: "failure",
                                        error: "Bir sorun ile karşılaştık."
                                    });
                            }).catch(
                                function () {
                                    $window.parcelRecord = null;
                                    deferred.reject({
                                        result: "failure",
                                        error: "Bir sorun ile karşılaştık."
                                    });
                                });
                    }
                    else {
                        $window.parcelRecord = null;
                        deferred.reject({
                            result: "failure",
                            error: "Bir sorun ile karşılaştık."
                        });
                    }
                });
            }
            else {
                $window.parcelRecord = null;
                deferred.reject({
                    result: "failure",
                    error: "Bir sorun ile karşılaştık."
                });
            }

            return deferred.promise;
        }

        function getParcelInfoById(parselid) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=parsel/' + parselid,
                //return $http.get('/api/endeks/ParselIdParselBilgisiGetir?id=' + parselid,
                {
                    cache: true,
                    skipAuthorization: true
                }).then(
                    function (result) {
                        if (result.data) {
                            asignParcelProperties(result).then(function () {
                                getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                    if (resb.data)
                                        $window.parcelRecord.blocks = resb.data.features;
                                    deferred.resolve({
                                        result: "success",
                                        data: $window.parcelRecord
                                    });
                                });
                            });
                        } else
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                    }).catch(
                        function () {
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                        });
            return deferred.promise;
        }

        function getParcelInfoByPropertyId(zeminid) {
            var deferred = $q.defer();
            $window.parcelRecord = null;
            $http.get(appSettingsSvc.CACHE + '/adaparsel?id=zemin//' + zeminid,
                {
                    cache: true,
                    skipAuthorization: true
                }).then(
                    function (result) {
                        if (result.data) {
                            asignParcelProperties(result).then(function () {
                                getBlock(null, result.data.properties.mahalleId, result.data.properties.adaNo, result.data.properties.parselNo).then(function (resb) {
                                    if (resb.data)
                                        $window.parcelRecord.blocks = resb.data.features;
                                    deferred.resolve({
                                        result: "success",
                                        data: $window.parcelRecord
                                    });
                                });
                            });
                        } else
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                    }).catch(
                        function () {
                            deferred.reject({
                                result: "failure",
                                error: "Bir sorun ile karşılaştık."
                            });
                        });
            return deferred.promise;
        }


        return obj;
    }


})();

(function () {
    'use strict';

    var serviceId = 'provinceListService';

    angular.module('app.common')
        .factory(serviceId, ['geoApi', provinceListService]);

    function provinceListService(geoApi) {

        var obj = {
            getProvinces: getProvinces,
            CountiesOfProvince: CountiesOfProvince,
            NeighbourhoodsOfCounty: NeighbourhoodsOfCounty,
            NeighbourhoodsOfQuarter: NeighbourhoodsOfQuarter
        };
        return obj;
        function getProvinces(id) {
            var geoAp = geoApi.getListById({
                level: 9,
                countryId: id
            });
            return geoAp.$promise;
        }

        function CountiesOfProvince(country, id) {
            var geoAp = geoApi.getListById({
                level: 1,
                cityId: id,
                countryId: country
            });
            return geoAp.$promise;
        }

        function NeighbourhoodsOfCounty(country, city, county) {
            var geoAp = geoApi.getListById({
                level: 2,
                cityId: city,
                countyId: county,
                countryId: country
            });
            return geoAp.$promise;
        }

        // Get neighbourhoods for Spain based on quarter - level 23
        function NeighbourhoodsOfQuarter(country, city, county, quarterId) {
            var geoAp = geoApi.getListById({
                level: 23,
                cityId: city,
                countyId: county,
                quarterId: quarterId,
                countryId: country
            });
            return geoAp.$promise;
        }


    }
})();

(function () {
    'use strict';

    var serviceId = 'searchParserService';

    angular.module('app.common')
        .factory(serviceId, ['$rootScope', '$state', 'locatorService', '$q', 'yandexReverseGeocode', '$window', 'parcelClientService', '$translate', '$ocLazyLoad', searchParserService]);

    function searchParserService($rootScope, $state, locatorService, $q, yandexReverseGeocode, $window, parcelClientService, $translate, $ocLazyLoad) {
        var obj = {
            parseSearchForController: parseSearchForController,
            parseSearch: parseSearch,
            useLocation: useLocation,
            useCity: useCity,
            storeAddress: storeAddress,
            parseSearchForOpportunity: parseSearchForOpportunity,
            centerInPoly: centerInPoly,
            rawAddress: ""
        };

        return obj;


        function parseSearchForOpportunity(opport) {
            var deferred = $q.defer();
            var location;
            if (opport.GeoLocation)
                location = opport.GeoLocation.Latitude.toString().replace('.', ',') + ";" + opport.GeoLocation.Longitude.toString().replace('.', ',');
            else
                location = opport.Latitude.toString().replace('.', ',') + ";" + opport.Longitude.toString().replace('.', ',');
            $rootScope.address = location;
            deferred.resolve(location);
            // locatorService.setPoint($rootScope.address, params).then(function (res) {
            //     deferred.resolve(res);
            // });
            return deferred.promise;
        }

        function parseSearchForController(params, transition) {
            var deferred = $q.defer();
            // var address;
            var storedLang = $window.lang || 'en';

            if (params.address &&
                !params.country &&
                !params.province &&
                !params.county &&
                !params.neighbourhood &&
                !params.block &&
                !params.parcel) {
                // address = angular.copy(params.address);
                // if ($rootScope.address !== address)
                //     $rootScope.address = address;
                if ($rootScope.address && isNaN($rootScope.address) && !params.address)
                    locatorService.setPoint($rootScope.address, params).then(function (res) {
                        deferred.resolve(res);
                    }, function () {
                        transition.abort();
                        transition.router.stateService.go("404", { langcode: storedLang });
                    });
                else if ((!$rootScope.address || isNaN($rootScope.address)) && params.address)
                    locatorService.setPoint(params.address, params).then(function (res) {
                        deferred.resolve(res);
                    }, function () {
                        transition.abort();
                        transition.router.stateService.go("404", { langcode: storedLang });
                    });
                else if ($rootScope.address)
                    parcelClientService.getParcelInfoByPropertyId($rootScope.address).then(function (result) {
                        // $rootScope.address = result.data.center[1].toString().replace('.', ',') + ';' + result.data.center[0].toString().replace('.', ',');
                        locatorService.setPoint($rootScope.address, params).then(function (res) {
                            deferred.resolve(res);
                        }, function () {
                            transition.abort();
                            transition.router.stateService.go("404", { langcode: storedLang });
                        });
                    });
                else {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                }
                //country
            }
            else if (params.country && !params.province && !params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointCountry(params.country).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
                //province
            }
            else if (params.country && params.province && !params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointProvince(params.country, params.province).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
                //county
            } else if (params.country && params.province && params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointCounty(params.country, params.province, params.county).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            } else if (params.country && params.province && params.county && params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointNeighbourhood(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' ')).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            else if (params.country && params.province && params.county && params.neighbourhood && params.block && !params.parcel) {
                var resolver = isSpain(params.country) ?
                    locatorService.setPointSpanishNeighbourhood(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block.replaceAllString('-', ' ')) :
                    locatorService.setPointBlock(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block);
                resolver.then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            else if (params.country && params.province && params.county && params.neighbourhood && params.block && params.parcel) {
                locatorService.setPointParcel(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block, params.parcel).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            return deferred.promise;
        }

        function useCity(isLanding, city, actionType) {
            var currentstate = $window.localStorage.getItem('currentState');
            var stateProp = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

            if ($rootScope.country === 'world' || city === 'city-district' || city === 'sehir' || city === 'distrito') {
                // if (isLanding)
                //     $rootScope.actionType($rootScope.country);
                // else
                if (actionType === 20)
                    $state.go('analysis.country.agents', { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });      
                else if (actionType === 30)
                    $state.go('analysis.country.investment', { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else if (!isLanding)
                    $state.go('analysis.country.' + stateProp, { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else
                    $state.go('valuation-wrapper', { langcode: $window.lang });
            }
            else {
                // if (isLanding)
                //     $rootScope.actionType($rootScope.country, city);
                // else
                if (actionType === 20)
                    $state.go('analysis.province.agents', { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
               
                else if (actionType === 30)
                    $state.go('analysis.province.investment', { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else if (!isLanding)
                    $state.go('analysis.province.' + stateProp, { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else
                    $state.go('valuation-wrapper', { langcode: $window.lang });
            }

        }

        function useLocation(isLanding, actionType) {
            if (navigator.geolocation) {
                $window.gatheredLocation = null;
                $window.selectedLocation = null;
                $rootScope.address = undefined;
                navigator.geolocation.getCurrentPosition(function (position) {
                    if (position) {
                        var location = position.coords.latitude.toString().replace('.', ',') + ";" + position.coords.longitude.toString().replace('.', ',');
                        yandexReverseGeocode.geocodeLatlng(position.coords.latitude, position.coords.longitude).then(function (formattedAdres) {
                            formattedAdres = formattedAdres.replace(', Türkiye', '').replaceAllString(',', '').replaceAllString(':', ' ').replace(/\./g, '').replaceAllString('/', ' ');
                            $rootScope.address = formattedAdres;
                        });
                        if (actionType && actionType === 20)
                            $state.go('analysis.address.agents', { langcode: $window.lang, address: location});
                        else if (actionType && actionType === 30)
                            $state.go('analysis.address.investment', { langcode: $window.lang, address: location});            
                        else if (isLanding)
                            $state.go('valuation-wrapper', { langcode: $window.lang, address: location });
                        else {
                            //get LanguageKey
                            var currentstate = $window.localStorage.getItem('currentState');
                            var stateProp = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

                            $state.go('analysis.address.' + stateProp, { address: location, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                        }

                    }
                }, function () { }, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            }
            return false;
        }

        function checkSurroundingStates(state) {
            if (state === 'education' || state === 'transportation' || state === 'health' || state === 'life' || state === 'entertainment')
                return 'value';
            else
                return state;
        }

        function centerInPoly(latlon) {
            if ($window.parcelRecord) {
                //Turf çok büyük bir paket gereksiz yere yüklemeyelim
                $ocLazyLoad.load('/assets/js/turf.min.js').then(function () {
                    var pt = turf.point([latlon.lon, latlon.lat]);
                    var isCenterInPoly = turf.booleanPointInPolygon(pt, $window.parcelRecord.geo);
                    // is it in the polygon
                    if (!isCenterInPoly) {
                        latlon.lat = $window.parcelRecord.geo.geometry.coordinates[0][0][1];
                        latlon.lon = $window.parcelRecord.geo.geometry.coordinates[0][0][0];
                    }
                });
            }

            return latlon;
        }

        function parseSearch(redirect, listing, force, opType, isLanding) {
            var direction = $rootScope.address;
            direction = direction ? direction : ($rootScope.country === 'turkiye') ? 'Türkiye' : undefined;
            $window.lastLevel = $window.lastLevel || $window.lastLevel === 0 ? $window.lastLevel : (force ? 9 : undefined);



            //TODO hata mesajı çıkarılabilir.
            if (!direction && !$window.parcelRecord) {
                return "";
            }

            if (direction) {
                direction = direction.replaceAllString(":", " ");
                direction = direction.replace(/\./g, '');
                direction = removeDiacritics(direction);
                direction = direction.toLowerCase();
            }

            // get LanguageKey
            var langKey = $window.lang || 'tr';
            var currentstate = $window.localStorage.getItem('currentState');
            var stateProp = listing ? listing : currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

            stateProp = checkSurroundingStates(stateProp);
            if (stateProp === 'comparables' && $window.lastLevel !== 8 && $window.lastLevel !== 0 )
                stateProp = 'value'

            //projectid is here
            if ($window.projectId && !listing) {
                if (redirect)
                    $state.go('project-detail', { langcode: langKey, id: $window.projectId, name: normalizeAddress(direction) });
                else
                    return $state.href('project-detail', { langcode: langKey, id: $window.projectId, name: normalizeAddress(direction) });
            }
            //endeksaid is here
            else if ($window.endeksaId && !listing) {
                if (redirect)
                    $state.go('property-detail', { langcode: langKey, id: $window.endeksaId, name: normalizeAddress(direction) });
                else
                    return $state.href('property-detail', { langcode: langKey, id: $window.endeksaId, name: normalizeAddress(direction) });
            }
            else if ($window.agentId && !listing) {
                var adr = normalizeAddress(direction);
                var name = adr.split('-')[0] + '-' + adr.split('-')[1];
                if (redirect)
                    $state.go('agent-detail', { langcode: langKey, path: ($rootScope.lang === 'tr' ? 'danisman' : 'agents'), id: $window.agentId, name: name });
                else
                    return $state.href('agent-detail', { langcode: langKey, path: ($rootScope.lang === 'tr' ? 'danisman' : 'agents'), id: $window.agentId, name: name });
            }
            //opport is here
            else if ($window.opportId && !listing) {
                var PortfolioId = $window.opportId.split('-')[0];
                var PropertyCategory = +$window.opportId.split('-')[1];
                var PropertyType = $window.opportId.split('-')[2];

                var CityName = direction.split(', ')[3];
                var CountyName = direction.split(', ')[2];
                // var DistrictName = direction.split(', ')[1];
                var Name = direction.split(', ')[0];

                var ev =
                    PropertyCategory === 2 ?
                        $translate.instant("ticari") : PropertyCategory === 3 ?
                            $translate.instant("arsa") : PropertyType === 'null' ?
                                $translate.instant("konut") :
                                +PropertyType === 10 ?
                                    $translate.instant("daire") :
                                    $translate.instant("mustakil-ev");

                var name = normalizeAddress(CityName + "-" + CountyName + "-" + Name) + "-" + $translate.instant("satilik") + "-" + ev;
                if (redirect) {
                    $state.go('localInfo.property', { langcode: langKey, name: name, id: PortfolioId });
                }
                else {
                    return $state.href('localInfo.property', { langcode: langKey, name: name, id: PortfolioId });
                }
            }
            //mallid is here
            else if ($window.mallId && !listing) {
                if (redirect)
                    $state.go('mall-detail', { langcode: langKey, id: $window.mallId, name: normalizeAddress(direction) });
                else
                    return $state.href('mall-detail', { langcode: langKey, id: $window.mallId, name: normalizeAddress(direction) });
            }
            //go to province
            else if ($window.regionId) {
                var region = 'reg-' + $window.regionId;
                if (redirect)
                    $state.go('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: region, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: region, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }
            //go to province
            else if ($window.lastLevel === 9 || $window.lastLevel === 10) {
                if (redirect)
                    $state.go('analysis.country.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.country.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to province
            else if ($window.lastLevel === 1) {
                var il = direction.indexOf(',') !== -1 ? direction.split(',')[0] : direction;
                if (redirect)
                    $state.go('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to county
            else if ($window.lastLevel === 2 && direction.split(',')[1]) {
                var il = direction.split(',')[1].trim();
                var ilce = direction.split(',')[0].trim();
                if (redirect)
                    $state.go('analysis.county.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.county.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to neighboor
            else if ($window.lastLevel === 3 && direction.split(',')[1]) {
                var il, ilce, mah;
                var splited = direction.split(',');
                if (splited.length > 3) {
                    il = splited[3].trim();
                    ilce = splited[2].trim();
                } else if (splited.length > 2) {
                    il = splited[2].trim();
                    ilce = splited[1].trim();
                } else if (splited.length > 1) {
                    il = splited[1].replace(' merkez', '').trim();
                    ilce = 'merkez';
                }

                mah = splited[0].trim();
                mah = mah.replace(' semti', '');
                mah = mah.replace(' mh', '');
                mah = mah.replace(' mahallesi', '');
                mah = mah.replace(' mah', '');
                mah = mah.replaceAllString(' ', '-');

                if (isSpain($rootScope.country) && splited.length > 3) {
                    var quarter = splited[1].trim().replaceAllString(' ', '-');
                    if (redirect)
                        $state.go('analysis.block.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: quarter, block: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                    else
                        return $state.href('analysis.block.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: quarter, block: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                }
                else if (redirect)
                    $state.go('analysis.neighbourhood.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.neighbourhood.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }
            else if ($window.gatheredLocation) {
                var cLat = +$window.gatheredLocation.split(' ')[0];
                var cLon = +$window.gatheredLocation.split(' ')[1]
                $ocLazyLoad.load('/assets/js/turf.min.js').then(function () {

                    var pt = turf.point([cLat, cLon]);

                    if ($window.parcelRecord) {
                        var isCenterInPoly = turf.booleanPointInPolygon(pt, $window.parcelRecord.geo);
                        // is it in the polygon
                        if (!isCenterInPoly)
                            $window.gatheredLocation = ($window.parcelRecord.geo.geometry.coordinates[0][0][0]).toString() +
                                ' ' + ($window.parcelRecord.geo.geometry.coordinates[0][0][1]).toString();
                    }

                    if ($window.rememberProperty) {
                        if ($window.rememberProperty.PropertyCategory === 2) {
                            $rootScope.konut = $translate.instant('ticari');
                        } else if ($window.rememberProperty.PropertyCategory === 3) {
                            $rootScope.konut = $translate.instant('arsa');
                        } else {
                            $rootScope.konut = $translate.instant('konut');
                        }

                        if ($window.rememberProperty.PropertyPriceType === 1) {
                            $rootScope.satilik = $translate.instant('satilik');
                        } else {
                            $rootScope.satilik = $translate.instant('kiralik');
                        }
                    }
                    else if ($window.parcelRecord && $window.parcelRecord.data) {
                        var nitelik = $window.parcelRecord.data.nitelik.toLowerCase();
                        if (nitelik.indexOf('tarla') > -1 || nitelik.indexOf('bahçe') > -1 || nitelik.indexOf('çayır') > -1 || nitelik.indexOf('arazi') > -1 || nitelik.indexOf('zeytinlik') > -1) {
                            $rootScope.konut = $translate.instant('arazi');
                            $window.lastestCategory = 3;
                            $window.lastestType = 2;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else if (nitelik.indexOf('arsa') > -1) {
                            $rootScope.konut = $translate.instant('arsa');
                            $window.lastestCategory = 3;
                            $window.lastestType = 1;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else if (nitelik.indexOf('ticari') > -1) {
                            $rootScope.konut = $translate.instant('ticari');
                            $window.lastestCategory = 2;
                            $window.lastestType = 5;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else {
                            $rootScope.konut = $translate.instant('konut');
                            $window.lastestCategory = 1;
                            $window.lastestType = 4;
                        }
                    }

                    var lat = $window.gatheredLocation.split(' ')[1];
                    var lng = $window.gatheredLocation.split(' ')[0];
                    if (opType === 20)
                        if (redirect)
                            $state.go('analysis.province.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                        else
                            return $state.href('analysis.province.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                    else
                        if (redirect)
                            $state.go('analysis.address.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                        else
                            return $state.href('analysis.address.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                });
            } else {
                // if (isLanding) {
                //     $rootScope.actionType($rootScope.country, null, null, null, normalizeAddress(direction));
                // }
                // else
                if (redirect)
                    $state.go('analysis.address.' + stateProp, { langcode: langKey, address: normalizeAddress(direction), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                else
                    return $state.href('analysis.address.' + stateProp, { langcode: langKey, address: normalizeAddress(direction), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
            }
        }

        // function parseSearchForRenta() {
        //     var direction = $rootScope.address;

        //     //TODO hata mesajı çıkarılabilir.
        //     if (!direction && !$window.parcelRecord) {
        //         return "";
        //     }

        //     direction = direction.replaceAllString(":", " ");
        //     direction = direction.replace(/\./g, '');
        //     direction = removeDiacritics(direction);
        //     direction = direction.toLowerCase();

        //     // get LanguageKey
        //     var langKey = window.lang || 'tr';

        //     return $state.href('renta', { langcode: langKey, address: normalizeAddress(direction) });
        // }

        function storeAddress(addr) {
            obj.rawAddress = addr;
        }

        function isSpain(country) {
            return +country === 2 || normalizeAddress(country) === 'espana';
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'eidsService';

    angular.module('app.common')
        .factory(serviceId, eidsService);
    eidsService.$inject = ['ngDialog', '$translate', '$cookies', 'user_factory', '$q', 'userSvc', 'notifierSvc'];

    function eidsService(ngDialog, $translate, $cookies, user_factory, $q, userSvc, notifierSvc) {
        var EXPIREMIN = 60;
        var eidsInfo = null;
        var opportunityPageDetails = {
            id: null,
            name: '',
            isRent: false,
            portfolioId: null
        };

        function setTaxNoWithExpiry(taxNo) {
            if (!taxNo) {
                $cookies.remove('taxNo');
            } else {
                var expiryDate = new Date();
                expiryDate.setMinutes(expiryDate.getMinutes() + EXPIREMIN);
                $cookies.put('taxNo', taxNo, { expires: expiryDate });
            }
        }
        function setOpportunityPageDetailsWithExpiry() {
            var expiryDate = new Date();
            expiryDate.setMinutes(expiryDate.getMinutes() + EXPIREMIN);
            $cookies.put('opportunityPageDetails', JSON.stringify(opportunityPageDetails), { expires: expiryDate });
        }
        function proceedEids(taxNo, userType) {
            if (userType === 'personal') taxNo = null;
            setTaxNoWithExpiry(taxNo);
            // https://eids.ticaret.gov.tr/oturum?firmaKodu=3D9D362F-D38D-4A49-9EA8-9AFA37B7DEA9
            window.location.href = "https://eids.ticaret.gov.tr/oturum?firmaKodu=3D9D362F-D38D-4A49-9EA8-9AFA37B7DEA9";
            // window.location.href = "http://localhost:8080/tr/publishlisting?yetkiKodu=mcWDVLbcb20LquC3Iu06&durum=Basarili"verifyEids('test');

        }
        function verifyEids(id, name, isRent, portfolioId) {
            opportunityPageDetails = {
                id,
                name,
                isRent,
                portfolioId
            };
            setOpportunityPageDetailsWithExpiry();
            function openDialog() {
                ngDialog.open({
                    templateUrl: 'app/common/eidsVerifyModal.html',
                    showClose: false,
                    closeByEscape: false,
                    closeByNavigation: false,
                    closeByDocument: false,
                    controller: ['$scope', ($scope) => {
                        $scope.onModal = true;
                        $scope.userTypes = ['personal', 'corporate'];
                        if (isCommercial) {
                            $scope.userType = $scope.userTypes[1];
                        } else {
                            $scope.userType = $scope.userTypes[0];
                        }
                        $scope.proceedEids = proceedEids;
                        $scope.taxNo = '';

                    }]
                });
            }
            var isCommercial = false;
            if (userSvc.info.Id) {
                user_factory.get_user_address({ userId: userSvc.info.Id }).$promise.then(function (result) {
                    var address = result[0];
                    isCommercial = address.isCommercial;
                }).finally(() => {
                    openDialog();
                });
            } else {
                openDialog();
            }
        }

        function checkEids() {
            var deferred = $q.defer();
            user_factory.eids_check().$promise.then(function (result) {
                if (!result.verifiedUserCode) {
                    return deferred.resolve(false);
                }
                eidsInfo = {
                    userCode: result.verifiedUserCode,
                    taxNo: result.taxNo || null
                };
                deferred.resolve(true);
            }, function (error) {
                console.log('error:', error);
                var msg;
                if (error.data.detail) {
                    msg = error.data.detail;
                } else {
                    msg = error.data;
                }
                notifierSvc.show({
                    // message: $translate.instant('eids_verify_failed'),
                    message: msg,
                    type: "error",
                });
                deferred.resolve(false);
            });
            return deferred.promise;
        }
        return {
            setTaxNo: setTaxNoWithExpiry,
            getTaxNo: function () {
                return $cookies.get('taxNo');
            },
            getOpportunityPageDetails: function () {
                return JSON.parse($cookies.get('opportunityPageDetails'));
            },
            getEidsInfo: function () {
                return eidsInfo;
            },
            setEidsInfo: function (info) {
                eidsInfo = info;
            },
            verifyEids,
            checkEids
        };

    }
})();

(function () {
    'use strict';

    var serviceId = 'historyService';

    angular.module('app.common')
        .factory(serviceId, [
            'history_factory',
            'history_factory_v3',
            'userSvc', 
            '$location', 
            '$q', 
            'geoApi',
            'agentApi',
            '$window',
            '$rootScope',
            'projectsApi',
            'mallsAPI',
            'opportListAPI',
            'valuationGETAPI',
            historyService
        ]);

    function historyService(
        history_factory,
        history_factory_v3,
        userSvc, 
        $location, 
        $q, 
        geoApi,
        agentApi,
        $window,
        $rootScope,
        projectsApi,
        mallsAPI,
        opportListAPI,
        valuationGETAPI
    ) {
        var service = {
            set: set,
            get: get,
            getGeoNames: getGeoNames,
            getAgents: getAgents,
            getProjects: getProjects,
            getMalls: getMalls,
            getOpportunities: getOpportunities,
            getValuations: getValuations,
            getAnalyses: getAnalyses,
            historyObj: {
                agent: [],
                project: [],
                opportunity: [],
                mall: [],
                valuation: [],
                analyse: []
            }
        };

        return service;

        function prepareHistory (history) {
            service.historyObj = {
                agent: [],
                project: [],
                opportunity: [],
                mall: [],
                valuation: [],
                analyse: []
            };
              angular.forEach(history, function (h) {
                switch (h.screenName) {
                  case 'agent':
                    let existingAgent = service.historyObj.agent.find(a => a.agentId === h.agentId);
                    if (!existingAgent)
                        service.historyObj.agent.push(h);
                    break;
                  case 'project':
                    let existingProject = service.historyObj.project.find(p => p.projectId === h.projectId);
                    if (!existingProject) {
                        service.historyObj.project.push(h);
                    }
                    break;
                  case 'opportunity':
                    let existingOpportunity = service.historyObj.opportunity.find(o => o.opportunityId === h.opportunityId);
                    if (!existingOpportunity) {
                        service.historyObj.opportunity.push(h);
                    }
                    break;
                  case 'mall':
                    let existingMall = service.historyObj.mall.find(m => m.mallId === h.mallId);
                    if (!existingMall)
                        service.historyObj.mall.push(h);
                    break;
                  case 'valuation':
                      if (service.historyObj.valuation.indexOf(h.valuationId) === -1)
                        service.historyObj.valuation.push(h);
                      break;
                  default:
                    service.historyObj.analyse.push(h);
                }
            });
        }

        function getAgents(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.agent.length) {
                let AgentIds = service.historyObj.agent.map(a => a.agentId);
                agentApi.agentsById({
                  CategoryId: 0,
                  Language: $window.langCode($rootScope.lang),
                  AgentIds: limit ? AgentIds.slice(0, limit) : AgentIds
                }).$promise.then( function (result) {
                    let agents = result.Results.map(a => {
                        a.UpdateDate = service.historyObj.agent.find(h => h.agentId === a.Id).createDate;
                        return a;
                    })
                  deferred.resolve(agents);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
            }
            return deferred.promise;
        }

        function getProjects(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.project.length) {
                let HousingProjectIds = service.historyObj.project.map(p => p.projectId);
                projectsApi.projectsById({
                  HousingProjectIds: limit ? HousingProjectIds.slice(0, limit) : HousingProjectIds
                }).$promise.then( function (result) {
                    let projects = result.Data.map(p => {
                        p.UpdateDate = service.historyObj.project.find(h => h.projectId === p.Id).createDate;
                        return p;
                    })
                  deferred.resolve(projects);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getMalls(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.mall.length) {
                let ShoppingCenterIds = service.historyObj.mall.map(m => m.mallId);
                mallsAPI.mallsById({
                  ShoppingCenterIds: limit ? ShoppingCenterIds.slice(0, limit) : ShoppingCenterIds
                }).$promise.then( function (result) {
                    let malls = result.Data.map( m => {
                        m.UpdateDate = service.historyObj.mall.find(h => h.mallId === m.Id).createDate;
                        return m;
                    })
                  deferred.resolve(malls);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getOpportunities(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.opportunity.length) {
                let PortfolioIds = service.historyObj.opportunity.map(o => o.opportunityId);
                opportListAPI.opportsById({
                  PortfolioIds: limit ? PortfolioIds.slice(0, limit) : PortfolioIds,
                  Language: $window.langCode($rootScope.lang)
                }).$promise.then( function (result) {
                    let opportunities = result.OpportunityList.map(o => {
                        o.UpdateDate = service.historyObj.opportunity.find(h => h.opportunityId === o.PortfolioId).createDate;
                        return o;
                    })
                  deferred.resolve(opportunities);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getValuations(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.valuation.length) {
                let valuationIds = service.historyObj.valuation.map(v => v.valuationId);
                valuationGETAPI.valuationsById({
                  valuationIds: limit ?  valuationIds.slice(0, limit) :  valuationIds,
                  Language: $window.langCode($rootScope.lang)
                }).$promise.then( function (result) {   
                   let valuations = result.Properties.map(v => {
                        v.FinalValuation.CreateDate = service.historyObj.valuation.find(h => h.valuationId === v.Id).createDate;
                        return v;
                    }); 
                  deferred.resolve(valuations);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getAnalyses(limit = 0) {
            return limit ? service.historyObj.analyse.slice(0, limit) : service.historyObj.analyse
        }

        function get(payload) {
            var deferred = $q.defer();
            history_factory_v3.get(payload).$promise.then(function (result) {
                if (result.length)
                    prepareHistory(result);
                else deferred.reject();
                deferred.resolve(service.historyObj);
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

        function set(screenName, id, geo) {
            if (window.isHeadless())
                return false;
            var projectId, agentId, opportunityId, mallId, valuationId;
            switch (screenName) {
                case 'project':
                    projectId = id;
                    break;
                case 'agent':
                    agentId = id;
                    break;
                case 'opportunity':
                    opportunityId = id;
                    break;
                case 'mall':
                    mallId = id;
                    break;
                case 'valuation':
                    valuationId = id;
                    break;
                default:
                    break;
            }

            var geoInfo = undefined;
            if (geo) {
                geoInfo = {
                    latitude: geo.latitude,
                    longitude: geo.longitude,
                    countryId: geo.CountryId,
                    cityId: geo.CityId,
                    countyId: geo.CountyId,
                    districtId: geo.DistrictId,
                    level: geo.level
                };
            }

            userSvc.getFinger().then(function (finger) {
                var data = {
                    fingerPrint: finger,
                    url: $location.absUrl(),
                    screenName: screenName,
                    valuationId: valuationId,
                    agentId: agentId,
                    opportunityId: opportunityId,
                    projectId: projectId,
                    mallId: mallId,
                    geoInfo: geoInfo
                };

                if (userSvc.info.Id) data.userId = userSvc.info.Id;

                history_factory.set(data);
            });
        }

        function getGeoNames (geoInfo) {
            var defer = $q.defer();
            geoApi.getNamesByCountryId({countryId: geoInfo.countryId}).$promise.then(function (result) {
              let cityObj = result.Cities.find((c) => c.CityId === geoInfo.cityId);
              let countyObj = cityObj && cityObj.Counties.find((c) => c.CountyId === geoInfo.countyId);
              let districtObj = countyObj && countyObj.Districts.find((c) => c.DistrictId === geoInfo.districtId);

              geoInfo = Object.assign(geoInfo, {
                country: result.Name, 
                city: cityObj && cityObj.Name,
                county: countyObj && countyObj.Name, 
                district: districtObj && districtObj.Name, 
              });
        
              defer.resolve();
            }, function () {
                defer.reject();
            });

            return defer.promise;
          }

    }
})();
(function () {
    "use strict";

    var serviceId = "leadService";

    angular
        .module("app.common")
        .factory(serviceId, ["userSvc", "ngDialog", "consultancy_factory", 'notifierSvc', '$translate', '$rootScope', '$q', leadService]);

    function leadService(userSvc, ngDialog, consultancy_factory, notifierSvc, $translate, $rootScope, $q) {
        var obj = {
            openLeadForm: openLeadForm,
            createInternalLead: createInternalLead
        };

        return obj;
        function openLeadForm(url, agentId = null, geo = null) {
            ngDialog.open({
                templateUrl: "app/history/seller-lead-modal.html",
                showClose: false,
                controller: [
                    "$scope", "$timeout",
                    function ($scope, $timeout) {
                        window.dataLayer.push({
                            'event': 'danismanlık_talebi_click',
                            'page_location': window.location.href
                        });
                        var consultancySourceUserId = null;
                        if (agentId) {
                            consultancySourceUserId = agentId;
                        }
                        $scope.agentSelected = agentId ? true : false;
                        $scope.sellerLead = {
                            name: '',
                            surname: '',
                            email: '',
                            phone: 0,
                            description: '',
                            language: window.langCode(),
                            googleClickId: window.gclid,
                            googleClientId: window.gaclient,
                            googleSessionId: window.gasessionId,
                            googleSessionNumber: window.gasessionNumber,
                            consultancySourceUserId: consultancySourceUserId,
                            url,
                            geoInfo: geo,
                            permissions: [140, 150, 160]
                        };
                        try {
                            $scope.sellerLead.email = userSvc.info.Email;
                            if (userSvc.info.Details && userSvc.info.Details.profile) {
                                $scope.sellerLead.name = userSvc.info.Details.profile.name;
                                $scope.sellerLead.surname = userSvc.info.Details.profile.surName;
                                $scope.sellerLead.phone = userSvc.info.Details.phoneNumber;
                            }
                        } catch (error) {
                            console.log("error:", error);
                        }

                        // Turnstile state
                        $scope.ETToken = null;
                        $scope.captchaVerified = false;
                        $scope.isTurkishPhone = true;
                        $scope.eimageCaptchaKey = null;
                        $scope.eimageCaptchaValue = null;

                        $scope.isPhoneVerified = false;

                        $scope.showName = true;
                        $scope.showSurname = true;
                        $scope.showPhone = true;
                        if ($scope.sellerLead.name) {
                            $scope.showName = false;
                        }
                        if ($scope.sellerLead.surname) {
                            $scope.showSurname = false;
                        }
                        if ($scope.sellerLead.email) {
                            $scope.showEmail = false;
                        }
                        if ($scope.sellerLead.phone && $scope.sellerLead.phone.length > 5) {
                            $scope.showPhone = false;
                            $scope.isPhoneVerified = true;
                        }
                        $scope.isDisabled = true;

                        $scope.privacyAccepted = false;
                        $scope.contactAccepted = false;

                        $scope.privacyModal = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/' + window.lang + '/lead.html',
                                controller: ['$scope', ($scope) => {
                                    $scope.onModal = true;
                                }]
                            });
                        };

                        $timeout(function () {
                            $('#firstInput').focus();
                        }, 100);

                        $scope.checkFields = function (input = null) {
                            // Telefon değiştiğinde doğrulamayı sıfırla
                            if ($scope.phoneValidation.changed) {
                                $scope.isPhoneVerified = false;
                            }
                            if ($scope.sellerLead.name && $scope.sellerLead.surname && $scope.sellerLead.phone) {
                                if ($scope.sellerLead.name.length < 2 || $scope.sellerLead.surname.length < 2 || $scope.privacyAccepted !== true || $scope.contactAccepted !== true) {
                                    $scope.isDisabled = true;
                                } else {
                                    $scope.isDisabled = false;
                                }
                            } else {
                                $scope.isDisabled = true;
                            }
                        };

                        // OTP onaylandığında çağrılacak callback
                        $scope.onPhoneVerified = function () {
                            $timeout(function () {
                                $scope.isPhoneVerified = true;
                            }, 100);
                        };

                        $scope.sendForm = function (isValid) {
                            if (!isValid) {
                                notifierSvc.show({ message: $translate.instant('not_valid'), type: 'error' });
                                return;
                            }
                            $scope.leadLoading = true;
                            userSvc
                                .getFinger()
                                .then(function (finger) {
                                    $scope.sellerLead.fingerPrint = finger;
                                    $scope.sellerLead.phone = $scope.sellerLead.phone ? $scope.sellerLead.phone.replace(/\s+/g, '') : null;

                                    consultancy_factory
                                        .createLead($scope.sellerLead)
                                        .$promise.then(function (res) {
                                            $scope.leadLoading = false;
                                            ngDialog.close();
                                            notifierSvc.show({
                                                message: $translate.instant(
                                                    "seller_lead_success"
                                                ),
                                                type: "success",
                                            });
                                        })
                                        .catch((err) => {
                                            console.log("lead form err:", err);
                                            notifierSvc.show({
                                                message: $translate.instant("seller_lead_error"),
                                                type: "error",
                                            });
                                            $scope.leadLoading = false;
                                            ngDialog.close();
                                        });
                                })
                                .catch(function (error) {
                                    console.log("lead form err:", error);
                                    $scope.leadLoading = false;
                                    notifierSvc.show({
                                        message: error.data.detail,
                                        type: "error",
                                    });
                                    ngDialog.close();
                                });
                        };
                    },
                ],
            });
        }

        function createInternalLead(lead) {
            var defer = $q.defer();
            consultancy_factory
                .createLead(lead)
                .$promise.then(function (res) {
                    ngDialog.close();
                    defer.resolve(res.value);
                })
                .catch((err) => {
                    console.log("lead form err:", err);
                    defer.reject(err);
                    ngDialog.close();
                });
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'locatorService';

    angular.module('app.common').factory(serviceId, locatorService);

    locatorService.$inject = ['$q', 'bolgeselDataService', '$window',
        'yandexGeocode', 'endeksaGeocode', 'guardSvc', '$translate', 'provinceListService'
    ];

    function locatorService($q, bolgeselDataService, $window,
        yandexGeocode, endeksaGeocode, guardSvc, $translate, provinceListService) {
        var service = {
            setPoint: setPoint,
            setPointCountry: setPointCountry,
            setPointProvince: setPointProvince,
            setPointCounty: setPointCounty,
            setPointNeighbourhood: setPointNeighbourhood,
            setPointSpanishNeighbourhood: setPointSpanishNeighbourhood,
            setPointBlock: setPointBlock,
            setPointParcel: setPointParcel
        };
        return service;

        function setPoint(address) {
            var deferred = $q.defer();

            if (address.indexOf('%252C') > -1) {
                address = address.replaceAllString('%252C', ',');
                address = address.replaceAllString('%253B35%252C', ';');
            }

            var lat;
            var lng;
            if (address.indexOf(';') > -1) {
                var latLon = address.split(';');
                lat = parseFloat(latLon[0].replace(",", "."));
                lng = parseFloat(latLon[1].replace(",", "."));
                bolgeselDataService.initialize(lat, lng, 0);
                deferred.resolve();
            } else if ($window.selectedLocation) {
                lat = +$window.selectedLocation.split(' ')[1];
                lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;

                bolgeselDataService.initialize(lat, lng, 0);
                deferred.resolve();
            } else {
                address = address.replaceAllString('-', ' ');
                // if ($rootScope.country === 'turkiye')
                yandexGeocode.geocodeAddress(address)
                    .then(function (latlng) {
                        var lat = latlng.lat();
                        var lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 0);
                        deferred.resolve();
                    }, function () {
                        deferred.reject(false);
                    });
                // else
                //     googleGeocode.geocodeAddress(address)
                //         .then(function (latlng) {
                //             bolgeselDataService.initialize(latlng.lat, latlng.lng, 0);
                //             deferred.resolve();
                //         }, function () {
                //             deferred.reject(false);
                //         });
            }
            return deferred.promise;
        }
        function setPointCountry(country) {
            var deferred = $q.defer();
            if (country === 'world') {
                bolgeselDataService.initialize(0, 0, 10);
                deferred.resolve({ Country: 'world' });
            }
            else {
                endeksaGeocode.geocodeUrl(country)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 9, null, latlng);
                        deferred.resolve({ Country: latlng.country });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointProvince(country, city) {
            var deferred = $q.defer();

            if ($window.selectedLocation) {
                const lat = +$window.selectedLocation.split(' ')[1];
                const lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;
                let level = 1;
                let region = "";
                if (city.toLocaleLowerCase2('tr-tr').includes("reg-")) {
                    level = 11;
                    region = city.split("reg-")[1];
                    $window.regionId = region;
                }
                bolgeselDataService.initialize(lat, lng, level, region);
                deferred.resolve({ Country: country.toLocaleProperCase2(), City: city.toLocaleProperCase2('tr-tr') });
            } else {
                endeksaGeocode.geocodeUrl(country, city)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();

                        let level = 1;
                        let region = "";
                        if (city.toLocaleLowerCase2('tr-tr').includes("reg-")) {
                            level = 11;
                            region = city.split("reg-")[1];
                            $window.regionId = region;
                        }
                        bolgeselDataService.initialize(lat, lng, level, region, latlng);
                        deferred.resolve({ Country: latlng.country, City: latlng.city });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointCounty(country, city, county) {
            var deferred = $q.defer();
            if ($window.selectedLocation) {
                const lat = +$window.selectedLocation.split(' ')[1];
                const lng = +$window.selectedLocation.split(' ')[0];
                $window.selectedLocation = null;
                bolgeselDataService.initialize(lat, lng, 2).then(function (stats) {
                    // deferred.resolve({ City: stats.features[0].properties.City, County: stats.features[0].properties.County });
                });
                deferred.resolve({ City: city.toLocaleProperCase2('tr-tr'), County: county.toLocaleProperCase2('tr-tr') });
            } else {
                endeksaGeocode.geocodeUrl(country, city, county)
                    .then((latlng) => {
                        const lat = latlng.lat();
                        const lng = latlng.lng();
                        bolgeselDataService.initialize(lat, lng, 2, null, latlng);
                        deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county });
                    })
                    .catch(() => {
                        deferred.reject(false);
                    });
            }
            return deferred.promise;
        }


        function setPointNeighbourhood(country, city, county, district) {
            var deferred = $q.defer();
            // Spain uses the neighbourhood URL segment as the quarter layer.
            if (isSpain(country)) {
                setPointQuarter(country, city, county, district, deferred);
                return deferred.promise;
            }
            guardSvc.hasPackage([
                "real-estate-package",
                "location-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package"
            ], true)
                .then((result) => {
                    const level = result ? 6 : 3;
                    if ($window.selectedLocation) {
                        const lat = +$window.selectedLocation.split(' ')[1];
                        const lng = +$window.selectedLocation.split(' ')[0];
                        $window.selectedLocation = null;
                        bolgeselDataService.initialize(lat, lng, level);
                        deferred.resolve({ Country: country.toLocaleProperCase2(), City: city.toLocaleProperCase2('tr-tr'), County: county.toLocaleProperCase2('tr-tr'), District: district.toLocaleProperCase2('tr-tr') });

                    } else {
                        endeksaGeocode.geocodeUrl(country, city, county, district)
                            .then((latlng) => {
                                const lat = latlng.lat();
                                const lng = latlng.lng();
                                bolgeselDataService.initialize(lat, lng, level, null, latlng);
                                deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, Population: latlng.population });

                            })
                            .catch(() => {
                                deferred.reject(false);
                            });
                    }
                });
            return deferred.promise;
        }

        // Resolves a Spain quarter URL segment and initializes the map with level 23.
        function setPointQuarter(country, city, county, quarterName, deferred) {
            getQuarterLocation(country, city, county, quarterName)
                .then(function (data) {
                    var latlng = data.latlng;
                    var quarter = data.quarter;
                    var quarterId = quarter.QuarterId || quarter.Id || quarter.DistrictId;
                    if (!quarterId) {
                        deferred.reject(false);
                        return;
                    }
                    bolgeselDataService.initialize(latlng.lat(), latlng.lng(), 23, null, {
                        countryId: latlng.countryId,
                        cityId: latlng.cityId,
                        countyId: latlng.countyId,
                        quarterId: quarterId,
                        quarter: quarter.QuarterName || quarter.Quarter || quarter.DistrictName || quarter.District,
                        country: latlng.country,
                        city: latlng.city,
                        county: latlng.county
                    });
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, Quarter: quarter.QuarterName || quarter.Quarter || quarter.DistrictName || quarter.District });
                })
                .catch(function () {
                    deferred.reject(false);
                });
        }

        function setPointSpanishNeighbourhood(country, city, county, quarterName, districtName) {
            var deferred = $q.defer();
            // Spain keeps the existing block route shape, but the last segment is a district name.
            getQuarterLocation(country, city, county, quarterName)
                .then(function (data) {
                    var quarterId = data.quarter.QuarterId || data.quarter.Id || data.quarter.DistrictId;
                    if (!quarterId) {
                        deferred.reject(false);
                        return;
                    }
                    return provinceListService.NeighbourhoodsOfQuarter(
                        data.latlng.countryId,
                        data.latlng.cityId,
                        data.latlng.countyId,
                        quarterId
                    ).then(function (response) {
                        var district = findByNormalized(response.List, districtName, ['DistrictName', 'District']);
                        var districtId = district && (district.DistrictId || district.Id);
                        if (!district) {
                            deferred.reject(false);
                            return;
                        }

                        bolgeselDataService.initialize(data.latlng.lat(), data.latlng.lng(), 3, null, {
                            countryId: data.latlng.countryId,
                            cityId: data.latlng.cityId,
                            countyId: data.latlng.countyId,
                            districtId: districtId,
                            quarterId: quarterId,
                            quarter: data.quarter.QuarterName || data.quarter.Quarter || data.quarter.DistrictName || data.quarter.District,
                            district: district.DistrictName || district.District,
                            country: data.latlng.country,
                            city: data.latlng.city,
                            county: data.latlng.county
                        });
                        deferred.resolve({
                            Country: data.latlng.country,
                            City: data.latlng.city,
                            County: data.latlng.county,
                            Quarter: data.quarter.QuarterName || data.quarter.Quarter || data.quarter.DistrictName || data.quarter.District,
                            District: district.DistrictName || district.District,
                            Population: district.Population
                        });
                    });
                })
                .catch(function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }

        // Finds the quarter id/name from county-level geo data before requesting its districts.
        function getQuarterLocation(country, city, county, quarterName) {
            return endeksaGeocode.geocodeUrl(country, city, county, null, null, null, quarterName)
                .then(function (latlng) {
                    return provinceListService.NeighbourhoodsOfCounty(latlng.countryId, latlng.cityId, latlng.countyId)
                        .then(function (response) {
                            var quarter = findByNormalized(response.List, quarterName, ['QuarterName', 'Quarter', 'DistrictName', 'District']);
                            if (!quarter) {
                                return $q.reject(false);
                            }
                            return {
                                latlng: latlng,
                                quarter: quarter
                            };
                        });
                });
        }

        // Compares URL-safe names with API names across known geo name fields.
        function findByNormalized(list, value, fields) {
            if (!list || !value) return null;
            var normalizedValue = normalizeAddress(value);
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < fields.length; j++) {
                    if (list[i][fields[j]] && normalizeAddress(list[i][fields[j]]) === normalizedValue) {
                        return list[i];
                    }
                }
            }
            return null;
        }

        // Spain is the only country that uses the quarter layer in this flow.
        function isSpain(country) {
            return +country === 2 || normalizeAddress(country) === 'espana';
        }

        function setPointBlock(country, city, county, district, block) {
            var deferred = $q.defer();
            endeksaGeocode.geocodeUrl(country, city, county, district, block)
                .then(function (latlng) {
                    var lat = latlng.lat();
                    var lng = latlng.lng();
                    bolgeselDataService.initialize(lat, lng, 7, null, latlng);
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, BlockId: latlng.BlockId, BlockNo: block });
                }, function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }
        function setPointParcel(country, city, county, district, block, parcel) {
            var deferred = $q.defer();
            endeksaGeocode.geocodeUrl(country, city, county, district, block, parcel)
                .then(function (latlng) {
                    var lat = latlng.lat();
                    var lng = latlng.lng();
                    bolgeselDataService.initialize(lat, lng, 8, null, latlng);
                    deferred.resolve({ Country: latlng.country, City: latlng.city, County: latlng.county, District: latlng.district, BlockId: latlng.BlockId, ParcelId: latlng.ParcelId, BlockNo: block, ParcelNo: parcel });

                }, function () {
                    deferred.reject(false);
                });
            return deferred.promise;
        }
    }
})();

(function () {
    "use strict";

    var serviceId = "bolgeselDataService";
    angular
        .module("app.common")
        .factory(serviceId, [
            "$window",
            "$rootScope",
            "$q",
            "appActivitySvc",
            "yandexReverseGeocode",
            "mapOptionsService",
            "$translate",
            "geoApi",
            "$location",
            // "megaProjectApi",
            "$timeout",
            "$interval",
            "parcelClientService",
            bolgeselDataService
        ]);

    function bolgeselDataService(
        $window,
        $rootScope,
        $q,
        appActivitySvc,
        yandexReverseGeocode,
        mapOptionsService,
        $translate,
        geoApi,
        $location,
        // megaProjectApi,
        $timeout,
        $interval,
        parcelClientService
    ) {
        var service = {
            stats: {},
            places: {},
            initialize: initialize,
            removeStyle: removeStyle,
            updateIndices: updateIndices,
            updateElections: updateElections,
            updateDemography: updateDemography,
            updateFellows: updateFellows,
            updatePortfolio: updatePortfolio,
            updateMalls: updateMalls,
            updateLocations: updateLocations,
            updateProjects: updateProjects,
            updateOpportunities: updateOpportunities,
            updateAgents: updateAgents,
            updateQuakes: updateQuakes,
            updateInvestments: updateInvestments,
            // restrictView: false,
            wktData: {},
            cleanAddress: {},
            nearLayer: null,
            revGeo: revGeo,
            center: {
                zoom: 3,
            },
            bounds: {
                // "northEast": {
                //     "lat": 42.10480080000019,
                //     "lng": 44.81603587600034
                // },
                // "southWest": {
                //     "lat": 35.808715305999954,
                //     "lng": 25.66549954000005
                // }
            },
            cityBounds: {},
            defaults: {
                lat: 39.1667,
                lng: 35.6667,
                level: 0,
            },
            legendValues: {
                min: 0,
                max: 0,
                marker: "x/m²",
                label: "Birim Fiyat",
            },
            markers: {},
            loaded: {
                //places: false,
                stats: false,
            },
            geojson: {
                data: [],
                style: null
            },
            zoomToBound: zoomToBound,
            currentMap: {},
            // megaProjects: {},
            registerObserverCallback: registerObserverCallback,
            registerInitObserver: registerInitObserver,
            debounceInitObserver: debounceInitObserver,
            context: {
                goText: null,
                menuClick: null,
                addMarker: null,
            },
            level: null,
            $$IsInside: $$IsInside,
            refresh: refresh
        };

        service.currentColors = [];

        //indices defaults to centralize
        service.lastQuery = {};
        service.defaultDynamicQuery = {
            //years
            FrontTimePeriod: 3, //front end timechange
            // Tip:  Konut:1 , Ticari:2, Arsa: 3
            PropertyCategory: 1,

            //  Durumu Satılık:1 - Kiralık:2
            PropertyPriceType: 1,

            //  Fiyat filtresi: Satılık m2 Fiyat:1 - Satılık Fiyat:2 - Amortisman Süresi:3
            PriceFilter: 1,

            //  Bina Yaşı 1-4:1 - 5-10:2 - 11-15:3 - 16 ve Üzeri:4 - hepsi:5
            BuildYear: 5,

            //  Oda Sayisi 1+1:1 - 2+1:2 - 3+1:3 - 4+1:4 - hepsi:5
            Rooms: 5,

            //Bulunduğu kat giriş altı:1 - giriş:2 - ara:3 - en üst:4 - hepsi:5
            FloorNumber: 5,

            // Isıtma Doğalgaz:1 - Merkezi:2 - Hepsi:3
            HeatType: 3,

            //Emlak kategori Apartman Dairesi:1 Rezidans :2 Müstakil:3 hepsi:4 -> 2 is not functioning for now
            PropertyType: 4,

            // Site durumu Tümü:null - Site İçi:1 - Site Dışı:0 (only Turkey + housing, dynamictrend only)
            ComplexCategory: null,

            //Lat: null,
            //Long: null,

            //Level 0: Point, Level 1: City, Level 2: County, Level 3: District, Level 4: Drawing, Level 5: Turkey, Level 23: Spain Quarter
            Level: 1,

            //send geometry object for drawing in Level 4
            Wkt: "",
            Static: true,
            Trend: true,
            Details: true,
            Types: true,
        };

        //obeserver operations to call dedicated callbacks
        var observerCallbacks = [];
        var notifyObservers = function (geojsonRefresh, megaProjectsRefresh) {
            var index, len;
            for (index = 0, len = observerCallbacks.length; index < len; ++index) {
                observerCallbacks[index](geojsonRefresh, megaProjectsRefresh);
            }
            // angular.forEach(observerCallbacks, function (callback) {
            //     callback(geojsonRefresh, megaProjectsRefresh);
            // });
        };
        function debounceObserver(callback) {
            if (observerCallbacks && observerCallbacks.indexOf(callback) === -1)
                return false;

            const index = observerCallbacks.indexOf(callback);
            if (index > -1) {
                observerCallbacks.splice(index, 1);
            }
        }
        function registerObserverCallback(callback) {
            if (observerCallbacks && observerCallbacks.indexOf(callback) > -1)
                return false;
            observerCallbacks.push(callback);
        }

        var initObservers = [];
        function registerInitObserver(callback) {
            if (initObservers && initObservers.indexOf(callback) > -1)
                return false;
            initObservers.push(callback);
        }
        function debounceInitObserver(callback) {
            if (initObservers && initObservers.indexOf(callback) === -1)
                return false;

            const index = initObservers.indexOf(callback);
            if (index > -1) {
                initObservers.splice(index, 1);
            }
        }
        var notifyInitObservers = function () {
            try {
                var index, len;
                for (index = 0, len = initObservers.length; index < len; ++index) {
                    initObservers[index]();
                }
            } catch (err) {
                console.log(err);
                //ignored
            }
        };

        var checkLoad = function () {
            var deferred = $q.defer();
            var stop = $interval(function () {
                if (typeof L !== 'undefined') {
                    $interval.cancel(stop);
                    deferred.resolve();
                }
            }, 1);
            return deferred.promise;
        };


        service.debounceObserver = debounceObserver;

        return service;

        //initialization operations
        function initialize(lat, lng, level, region, geocode) {
            var deferred = $q.defer();
            $rootScope.loadingGeometries = true;
            service.loaded.stats = false;

            checkLoad().then(function () {
                //set window label
                var lt = $window.userStorage.getItem('labeltype');
                if (lt && lt === 'true')
                    window.permanent = true;

                //default center
                service.defaults.lat = lat;
                service.defaults.lng = lng;
                service.defaults.level = +level;

                service.legendValues.max = 0;
                service.legendValues.min = 0;

                if (window.location.href.indexOf('quake') === -1)
                    placeMarker(lat, lng, level, geocode);

                //analize stats data
                loadStats(lat, lng, level, region, geocode).then(
                    function () {
                        $rootScope.loadingGeometries = false;

                        // var restrictions = $window.userStorage.getItem('map_restriction');
                        // restrictions = restrictions ? JSON.parse(restrictions) : [];

                        // var allowed = false;
                        // for (var y = 0; y < restrictions.length; y++) {
                        //     var current = restrictions[y];
                        //     var first = service.stats.features[0].properties;
                        //     if (current.city && first.CityId === +current.city.split(':')[0])
                        //         allowed = true;
                        //     if (current.county && first.CountyId === +current.county.split(':')[0])
                        //         allowed = true;
                        //     if (current.district && first.DistrictId === +current.district.split(':')[0])
                        //         allowed = true;
                        // }

                        // service.restrictView = restrictions.length > 0 ? !allowed : false;
                        service.loaded.stats = true;
                        // getMegaProjects();
                        deferred.resolve(service.stats);
                        notifyInitObservers();

                    },
                    function (error) {
                        $rootScope.loadingGeometries = false;
                        service.loaded.stats = true;
                        notifyObservers();
                        deferred.reject(error);
                    }
                );
            });
            return deferred.promise;
        }

        function placeMarker(lat, lng, type, geocode) {
            var key;
            var isSpainDistrict = geocode && (+geocode.countryId === 2) && type === 3;
            for (key in service.markers) {
                if (service.markers.hasOwnProperty(key)) {
                    delete service.markers[key];
                }
            }
            if (!isSpainDistrict && (type === 0 || type === 5 || type === 3 || type === 8)) {
                var a = mapOptionsService.getMarker(lat, lng, false);
                for (key in a) {
                    if (a.hasOwnProperty(key)) {
                        a.m1.draggable = true;
                        service.markers[key] = a[key];
                    }
                }
            }
            // if (type === 0 || type === 5) {
            //     //    var rootLoc = typeof $window.location.origin !== 'undefined' ?
            //     //        $window.location.origin : 'https://www.endeksa.com';
            //     //    if (rootLoc.indexOf('/undefined') > -1)
            //     //        rootLoc = rootLoc.replace('/undefined', '');

            //     //    var langKey = window.lang || 'tr';
            //     //    if (window.rememberProperty) {
            //     //        var url = makeValuation(window.rememberProperty);
            //     //        if (langKey === 'tr') {
            //     //            var message = '<a href="' + url + '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="landingicon-4"></i> İlanın Değerini Öğren</a>';
            //     //        } else if (langKey === 'en') {
            //     //            message = '<a href="' + url + '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="landingicon-4"></i> Evaluate This Listing</a>';
            //     //        }
            //     //    }
            //     //    else {
            //     //        if (langKey === 'tr') {
            //     //            var query = "evimin-degeri";
            //     //            var qlang = "Evimin Değeri";
            //     //            var ilang = "landingicon-4";
            //     //            if (params.konut === "arsa" || params.konut === "plot") {
            //     //                query = "arsamin-degeri";
            //     //                qlang = "Arsamın Değeri";
            //     //                ilang = "landingicon-5";
            //     //            }
            //     //            message = '<a href="' + rootLoc + '/tr/' + query + '/ogren/' +
            //     //                lat.toString().replace('.', ',') + ';' + lng.toString().replace('.', ',') +
            //     //                '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="' + ilang + '"></i> ' + qlang + '</a>';
            //     //        } else {
            //     //            query = "evimin-degeri";
            //     //            qlang = "Calculate House Value";
            //     //            ilang = "landingicon-4";
            //     //            if (params.konut === "arsa" || params.konut === "plot") {
            //     //                query = "arsamin-degeri";
            //     //                qlang = "Calculate Plot Value";
            //     //                ilang = "landingicon-5";
            //     //            }
            //     //            message = '<a href="' + rootLoc + '/en/' + query + '/ogren/' +
            //     //                lat.toString().replace('.', ',') + ';' + lng.toString().replace('.', ',') +
            //     //                '" target="_blank" style="color: white; font-size:14px; margin-left: 4px; padding-left: 4px; padding-top: 7px; padding-right: 14px;" class="landing-button closed"><i class="' + ilang + '"></i> ' + qlang + '</a>';
            //     //        }
            //     //    }

            //     //    message = message + '<style>.leaflet-popup-close-button { display: none; background: white !important; border-radius: 10px !important; padding: 2px !important; height: auto !important; width: auto !important; } .leaflet-popup-tip-container { display: none } .leaflet-popup-content { width: auto !important; padding:0 } .leaflet-popup-content-wrapper { background: transparent; box-shadow: none; padding:0; padding-left:7px; margin-left:3px; margin-bottom:-2px}</style>';

            //     //    if (isHiddenMessage)
            //     var message = false;

            //     a = mapOptionsService.getMarker(lat, lng, message);

            //     for (key in a) {
            //         if (a.hasOwnProperty(key)) {
            //             a.m1.draggable = true;
            //             service.markers[key] = a[key];
            //         }
            //     }
            // } else if (type === 3) {
            //     a = mapOptionsService.getMarker(lat, lng, false);
            //     for (key in a) {
            //         if (a.hasOwnProperty(key)) {
            //             a.m1.draggable = true;
            //             service.markers[key] = a[key];
            //         }
            //     }
            // }
        }

        function refresh() {
            bindLayer(service.stats, service.defaults.level, service.defaults.lat, service.defaults.lng);
        }

        function bindLayer(resb, level, lat, lng) {


            const countryId = resb.features[0].properties.CountryId;
            const countyId = resb.features[0].properties.CountyId;
            const cityId = resb.features[0].properties.CityId;
            const districtId = resb.features[0].properties.DistrictId;
            const quarterId = resb.features[0].properties.QuarterId;
            const parcelId = resb.features[0].properties.ParcelId;

            service.defaultDynamicQuery.Level = +level;
            if (+level === 0 || +level === 4 || +level === 5) {
                service.defaultDynamicQuery.Lat = lat;
                service.defaultDynamicQuery.Long = lng;
                delete service.defaultDynamicQuery.QuarterId;
            } else {
                // delete service.defaultDynamicQuery.Lat;
                // delete service.defaultDynamicQuery.Long;
                service.defaultDynamicQuery.CountryId = countryId;
                service.defaultDynamicQuery.CountyId = countyId;
                service.defaultDynamicQuery.CityId = cityId;
                // At Spain quarter level (23) the child features carry individual district IDs;
                // sending one of them as DistrictId would scope the query incorrectly.
                // QuarterId is the meaningful filter at this level.
                if (+level === 23) {
                    delete service.defaultDynamicQuery.DistrictId;
                    service.defaultDynamicQuery.QuarterId = quarterId;
                } else {
                    service.defaultDynamicQuery.DistrictId = districtId;
                    if (quarterId)
                        service.defaultDynamicQuery.QuarterId = quarterId;
                    else
                        delete service.defaultDynamicQuery.QuarterId;
                }
                // BlockId is not used by dynamictrend API
                service.defaultDynamicQuery.ParcelId = parcelId;
            }

            service.poly = null;
            var geo = L.geoJson(service.stats);

            var obounds = geo.getBounds();
            var lobounds = {
                northEast: {
                    lat: obounds._northEast.lat,
                    lng: obounds._northEast.lng,
                },
                southWest: {
                    lat: obounds._southWest.lat,
                    lng: obounds._southWest.lng,
                },
            };
            service.bounds = lobounds;

            if (level === 1 || level === 9) {
                service.country = normalizeAddress(resb.features[0].properties.Country);
                service.cityBounds = lobounds;
            }
            else if (level === 10) {
                service.country = 'world';
                service.cityBounds = {};
            }
            try {
                service.poly = geo.getLayers()[0]._latlngs[0];
            } catch (err) {
                console.error(err);
            }
            service.geojson.data = [service.stats];
            // service.geojson.style = style;

            removeStyle(true);




            service.geojson.pointToLayer = function (feature, latlng) {
                return null;
            };

            if (level === 8) {
                parcelClientService.asignParcelProperties(resb.features[0]);
            }

            if (level === 10)
                $rootScope.country = 'world';
            else
                $rootScope.country = normalizeAddress(resb.features[0].properties.Country);


            var altLevel = null;
            switch (+level) {
                case 9:
                    altLevel = 10;
                    break;
                case 0:
                case 3:
                case 6:
                case 5:
                    altLevel = 2;
                    break;
                case 7:
                    altLevel = 6;
                    break;
                case 8:
                    altLevel = 7;
                    break;
                case 2:
                    altLevel = 1;
                    break;
            }

            if (service.geoApAltCity)
                service.geoApAltCity.$cancelRequest();

            if (service.geoApAlt)
                service.geoApAlt.$cancelRequest();

            if (service.geoApAlt2)
                service.geoApAlt2.$cancelRequest();

            if (+level !== 10 && +level !== 9 && +level !== 1) {
                service.geoApAltCity = geoApi.get({
                    // Lat: +lat,
                    // Long: +lng,
                    level: 1,
                    countryId: countryId,
                    cityId: cityId,
                    subGeometries: true
                });
                service.geoApAltCity.$promise.then(
                    function (resa) {
                        var geo = L.geoJson(resa);
                        var bounds = geo.getBounds();
                        var lbounds = {
                            northEast: {
                                lat: bounds._northEast.lat,
                                lng: bounds._northEast.lng,
                            },
                            southWest: {
                                lat: bounds._southWest.lat,
                                lng: bounds._southWest.lng,
                            },
                            // name: resa.features[0].properties.City
                        };
                        service.country = normalizeAddress(resa.features[0].properties.Country);
                        service.cityBounds = lbounds;
                    },
                    function (result) {
                        if (result.xhrStatus !== 'abort')
                            console.log(result);
                    }
                );

            }

            if (+level !== 10 && +level !== 1 && +level !== 11 && altLevel !== null) {
                service.geoApAlt = geoApi.get({
                    // Lat: +lat,
                    // Long: +lng,
                    level: altLevel,
                    countryId: countryId,
                    cityId: cityId,
                    countyId: countyId,
                    districtId: districtId,
                    subGeometries: true
                });
                service.geoApAlt.$promise.then(
                    function (resa) {
                        var result = [];
                        for (var y = 0; y < resa.features.length; y++) {
                            resa.features[y].properties.description = $translate.instant(resa.features[y].properties.description);
                            if (
                                altLevel === 2 &&
                                (!resa.features[y].properties.DistrictId || resa.features[y].properties.DistrictId === districtId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 1 &&
                                (!resa.features[y].properties.CountyId || resa.features[y].properties.CountyId === countyId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 10 &&
                                (!resa.features[y].properties.CountryId || resa.features[y].properties.CountryId === countryId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 6 &&
                                (!resa.features[y].properties.BlockId || resa.features[y].properties.BlockId === blockId)
                            ) {
                                //pass this object
                            } else if (
                                altLevel === 7 &&
                                (!resa.features[y].properties.ParcelId || resa.features[y].properties.ParcelId === parcelId)
                            ) {
                                //pass this object
                            } else {
                                result.push(resa.features[y]);
                            }
                        }
                        var geo = L.geoJson(result, {
                            style: {
                                fillColor: "transparent",
                                weight: 0.7,
                                opacity: 1,
                                color: "#e5e5e5",
                                dashArray: "2",
                                fillOpacity: 0,

                            },
                            onEachFeature: function (feature, layer) {
                                var desc = feature.properties.description;
                                if (altLevel === 2)
                                    desc =
                                        desc + " (" + feature.properties.County + ")";
                                if (desc) layer.bindTooltip(desc, { sticky: window.permanent ? false : true, permanent: window.permanent, direction: window.permanent ? 'center' : null, className: window.permanent ? 'polygon-labels' : null });
                                layer.level = altLevel;
                                layer.on("click", function (e) {
                                    var data = {
                                        leafletObject: layer,
                                        leafletEvent: e,
                                        level: altLevel,
                                        alt: true,
                                    };
                                    if (!$window.hasAllowance)
                                        $rootScope.$broadcast(
                                            "leafletDirectiveGeoJson.main-map.click",
                                            data
                                        );
                                    if (layer._map) {
                                        layer._map.contextmenu.hide();
                                    }
                                });
                                layer.bindContextMenu({
                                    contextmenu: true,
                                    contextmenuItems: [{
                                        text:
                                            !$window.hasAllowance ?
                                                altLevel === 1 && feature.properties.County ?
                                                    $window.cekimEki(
                                                        feature.properties.County.split(
                                                            " ("
                                                        )[0],
                                                        "e"
                                                    ) + $translate.instant(" Git") :
                                                    altLevel === 2 && feature.properties.District ?
                                                        $window.cekimEki(
                                                            feature.properties.District.split(
                                                                " ("
                                                            )[0],
                                                            "e"
                                                        ) + $translate.instant(" Git") :
                                                        altLevel === 9 && feature.properties.City ?
                                                            $window.cekimEki(
                                                                feature.properties.City.split(
                                                                    " ("
                                                                )[0],
                                                                "e"
                                                            ) + $translate.instant(" Git") : altLevel === 6 && feature.properties.BlockNo ?
                                                                $window.cekimEki(
                                                                    feature.properties.BlockNo + " " + $translate.instant("Ada"),
                                                                    "e"
                                                                ) + $translate.instant(" Git") : altLevel === 7 && feature.properties.ParcelNo ?
                                                                    $window.cekimEki(
                                                                        feature.properties.BlockNo + '/' + feature.properties.ParcelNo + " " + $translate.instant("Parsel"),
                                                                        "e"
                                                                    ) + $translate.instant(" Git") :
                                                                    "" : "",
                                        iconCls:
                                            !$window.hasAllowance ?
                                                (altLevel === 1 ||
                                                    altLevel === 2 ||
                                                    altLevel === 9 ||
                                                    altLevel === 6 ||
                                                    altLevel === 7) ?
                                                    "ei-apartment" :
                                                    "" : "",
                                        callback: function (e) {
                                            var feature = e.relatedTarget.feature;
                                            service.context.goText(feature, altLevel);
                                        },
                                    },
                                    {
                                        text:
                                            !$window.hasAllowance ?
                                                $translate.instant("Konuma Git") : "",
                                        iconCls:
                                            !$window.hasAllowance ?
                                                "ei-location" : "",
                                        callback: function (e) {
                                            service.context.menuClick(e);
                                        },
                                    },
                                        "-",
                                    {
                                        text: $translate.instant("Yaklaş"),
                                        iconCls: "ei-zoom-in",
                                        callback: function (e) {
                                            var latlng = e.latlng;
                                            service.defaults.lat = latlng.lat;
                                            service.defaults.lng = latlng.lng;
                                            service.center.zoom = service.center.zoom + 1;
                                        },
                                    },
                                    {
                                        text: $translate.instant("Uzaklaş"),
                                        iconCls: "ei-zoom-out",
                                        callback: function (e) {
                                            var latlng = e.latlng;
                                            service.defaults.lat = latlng.lat;
                                            service.defaults.lng = latlng.lng;
                                            service.center.zoom = service.center.zoom - 1;
                                        },
                                    }
                                    ]
                                });
                            },
                        });
                        geo.addTo(service.nearLayer);

                        if (altLevel === 2) {
                            service.geoApAlt2 = geoApi.get({
                                // Lat: +lat,
                                // Long: +lng,
                                level: 1,
                                countryId: countryId,
                                cityId: cityId,
                                subGeometries: true
                            });
                            service.geoApAlt2.$promise.then(
                                function (resa) {
                                    var result = [];
                                    for (var y = 0; y < resa.features.length; y++) {
                                        resa.features[y].properties.description = $translate.instant(resa.features[y].properties.description);

                                        if (
                                            altLevel === 2 &&
                                            resa.features[y].properties.CountyId ===
                                            countyId
                                        ) {
                                            //pass this object
                                        } else {
                                            result.push(resa.features[y]);
                                        }
                                    }
                                    var geo = L.geoJson(result, {
                                        style: {
                                            fillColor: "transparent",
                                            weight: 0.7,
                                            opacity: 1,
                                            color: "#e5e5e5",
                                            dashArray: "2",
                                            fillOpacity: 0,

                                        },
                                        onEachFeature: function (feature, layer) {
                                            var desc = feature.properties.description;
                                            if (desc)
                                                layer.bindTooltip(desc, { sticky: window.permanent ? false : true, permanent: window.permanent, direction: window.permanent ? 'center' : null, className: window.permanent ? 'polygon-labels' : null });
                                            layer.level = 1;
                                            layer.on("click", function (e) {
                                                var data = {
                                                    leafletObject: layer,
                                                    leafletEvent: e,
                                                    level: 1,
                                                    alt: true,
                                                };
                                                if (!$window.hasAllowance)
                                                    $rootScope.$broadcast(
                                                        "leafletDirectiveGeoJson.main-map.click",
                                                        data
                                                    );
                                                if (layer._map) {
                                                    layer._map.contextmenu.hide();
                                                }
                                            });
                                            layer.bindContextMenu({
                                                contextmenu: true,
                                                contextmenuItems: [{
                                                    text:
                                                        !$window.hasAllowance ?
                                                            $window.cekimEki(
                                                                feature.properties.County.split(
                                                                    " ("
                                                                )[0], "e") + $translate.instant(" Git") : "",
                                                    iconCls:
                                                        !$window.hasAllowance ?
                                                            "ei-apartment" : "",
                                                    callback: function (e) {
                                                        var feature = e.relatedTarget.feature;
                                                        service.context.goText(feature, 1);
                                                    },
                                                },
                                                {
                                                    text:
                                                        !$window.hasAllowance ?
                                                            $translate.instant("Konuma Git") : "",
                                                    iconCls:
                                                        !$window.hasAllowance ?
                                                            "ei-location" : "",
                                                    callback: function (e) {
                                                        service.context.menuClick(e);
                                                    },
                                                },
                                                    "-",
                                                {
                                                    text: $translate.instant("Yaklaş"),
                                                    iconCls: "ei-zoom-in",
                                                    callback: function (e) {
                                                        var latlng = e.latlng;
                                                        service.defaults.lat = latlng.lat;
                                                        service.defaults.lng = latlng.lng;
                                                        service.center.zoom =
                                                            service.center.zoom + 1;
                                                    },
                                                },
                                                {
                                                    text: $translate.instant("Uzaklaş"),
                                                    iconCls: "ei-zoom-out",
                                                    callback: function (e) {
                                                        var latlng = e.latlng;
                                                        service.defaults.lat = latlng.lat;
                                                        service.defaults.lng = latlng.lng;
                                                        service.center.zoom =
                                                            service.center.zoom - 1;
                                                    },
                                                }
                                                ]
                                            });
                                        },
                                    });
                                    geo.addTo(service.nearLayer);
                                },
                                function (result) {
                                    if (result.xhrStatus !== 'abort')
                                        console.log(result);
                                }
                            );
                        }
                    },
                    function (result) {
                        if (result.xhrStatus !== 'abort')
                            console.log(result);
                    }
                );
            }
        }

        //internal operations
        function loadStats(lat, lng, level, region, geocode) {
            appActivitySvc.busy("bolgeselDataService");
            var deferred = $q.defer();

            // try {
            //     service.polyOld = null;
            //     var geo = L.geoJson(service.stats);
            //     service.polyOld = geo.getLayers()[0]._latlngs[0];
            // } catch (err) {
            //     //ignored
            // }

            if (service.geoAp)
                service.geoAp.$cancelRequest();

            $$IsInside(lat, lng, service.poly, level).then(function (inside) {
                if (!inside) {
                    if (service.nearLayer)
                        service.nearLayer.clearLayers();

                    service.level = level;

                    var payload = { level: level };
                    if (geocode) {
                        payload.countryId = geocode.countryId;
                        payload.cityId = geocode.cityId;
                        payload.countyId = geocode.countyId;
                        payload.districtId = geocode.districtId;
                        payload.quarterId = geocode.quarterId;
                        payload.parcelId = geocode.parcelId;
                        payload.blockId = geocode.blockId;
                        payload.subGeometries = true;
                    }
                    else {
                        payload.lat = +lat;
                        payload.long = +lng;
                    }

                    if (region)
                        payload.RegionId = region;

                    if (!service.preLoaded) {
                        service.geoAp = geoApi.get(payload);
                        service.geoAp.$promise
                            .then(
                                function (resb) {
                                    service.stats = resb;
                                    bindLayer(resb, level, lat, lng);
                                    deferred.resolve();
                                },
                                function (result) {
                                    if (result.xhrStatus !== 'abort')
                                        deferred.reject(result);
                                }
                            )["finally"](function () {
                                appActivitySvc.idle("bolgeselDataService");
                            });
                    }
                    else {
                        service.stats = angular.copy(service.preLoaded);
                        bindLayer(service.stats, level, lat, lng);
                        service.preLoaded = null;
                        deferred.resolve();
                    }
                } else {
                    appActivitySvc.idle("bolgeselDataService");
                    deferred.resolve();
                }
            });
            return deferred.promise;
        }

        // function getMegaProjects() {
        //     var query = {
        //         CityId: service.stats.features[0].properties.CityId,
        //         CountyId: service.stats.features[0].properties.CountyId,
        //         Level: 1,
        //         Lat: service.defaultDynamicQuery.Lat,
        //         Long: service.defaultDynamicQuery.Long,
        //     };

        //     var req2 = megaProjectApi.get(query);
        //     req2.$promise.then(function (response) {
        //         service.megaProjects = response;
        //         notifyObservers(false, true);
        //     });
        // }

        function continueRev(stat, formattedAdres, deferred) {
            const il = stat.features[0].properties.City.toLocaleUpperCase("tr-tr");
            const ilce = stat.features[0].properties.County.toLocaleUpperCase(
                "tr-tr"
            );
            const mah = stat.features[0].properties.District.toLocaleUpperCase(
                "tr-tr"
            );

            if (formattedAdres) {
                service.cleanAddress.address = formattedAdres;

                var regex = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + il + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex, "");

                var regex2 = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + ilce + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex2, "");

                var regex3 = new RegExp(
                    "(^|[^wığüşöçĞÜŞÖÇİ])(" + mah + ")([^wığüşöçĞÜŞÖÇİ]|$)",
                    "ig"
                );
                service.cleanAddress.address = service.cleanAddress.address
                    .toLocaleUpperCase("tr-tr")
                    .replace(regex3, "");

                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    ",",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "//",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "MH.",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "MAH.",
                    ""
                );
                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "LLESİ",
                    ""
                );

                service.cleanAddress.address = service.cleanAddress.address.replaceAllString(
                    "CİTY OF",
                    ""
                ).trim();

                service.cleanAddress.address = service.cleanAddress.address.toLocaleProperCase2("tr-tr");

                if (!service.cleanAddress.address)
                    service.cleanAddress.address = window.lang === 'tr' ? "Seçili Konum" : window.lang === 'es-ES' ? "Ubicación Seleccionada" : window.lang === 'pt-PT' ? "Local Selecionado" : "Selected Location";

                notifyObservers();
                deferred.resolve(service.cleanAddress);
            } else {
                service.cleanAddress.address = "";
                notifyObservers();
                deferred.resolve(service.cleanAddress.address);
            }
        }

        function revGeo(stat, lat, lng) {
            var deferred = $q.defer();
            if (window.isHeadless())
                continueRev(stat, "", deferred);
            else
                // if ($rootScope.country === 'turkiye')
                yandexReverseGeocode.geocodeLatlng(lat, lng).then(
                    function (formattedAdres) {
                        continueRev(stat, formattedAdres, deferred);
                    },
                    function () {
                        service.cleanAddress.address = $translate.instant('dataservice_unknown');
                        notifyObservers();
                        deferred.resolve(service.cleanAddress.address);
                    }
                );

            return deferred.promise;
        }

        // Matches a map feature id to a thematic API row by the current map level.
        // Spain county pages (level 2) list quarter features whose feature.id is a
        // QuarterId; thematic rows carry QuarterId > 0 only for Spain, so Turkey
        // keeps matching by DistrictId. Level 23 (Spain quarter page) features are
        // districts, so the DistrictId fallback stays correct there.
        function matchThematicRow(level, geoId, row) {
            if (level === 1) return geoId === row.CountyId;
            if (level === 10) return geoId === row.CountryId;
            if (level === 9) return geoId === row.CityId;
            if (level === 2 && row.QuarterId) return geoId === row.QuarterId;
            return geoId === row.DistrictId;
        }

        function updateDemography(data, graphType, data2, wholeData) {
            if (graphType === "hemsehrilik") return false;

            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            var marker = " " + $translate.instant("demographics_population_title");
            var label = $translate.instant("demographic_population");

            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                var key1 = y;
                if (!service.stats.features[key1].properties)
                    continue;

                if (!service.stats.features[key1].properties.defaultText) {
                    service.stats.features[key1].properties.defaultText =
                        service.stats.features[key1].properties.description;
                } else {
                    service.stats.features[key1].properties.description =
                        service.stats.features[key1].properties.defaultText;
                }
                if (data)
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (
                            geoId === 0 && service.defaults.level !== 1 && service.defaults.level !== 9 && service.defaults.level !== 10 ?
                                value1.properties.District.replace(' Köyü', '') === value2.RegionName :
                                matchThematicRow(service.defaults.level, geoId, value2)
                        ) {
                            var result;
                            if (graphType === "yas") {
                                result = value2.AgeGroupDensity;
                                service.stats.features[key1].properties.value = result;
                                //if (+result === 65)
                                //    marker = $translate.instant('above_age');
                                //else
                                //    marker = $translate.instant('between_age');
                                marker = $translate.instant("between_age");
                                label = $translate.instant("mostly_seen");
                            } else if (graphType === "medeni-hal") {
                                result = value2.MaritalDensity;
                                result = $translate.instant(result);
                                service.stats.features[key1].properties.value = result;
                                marker = "";
                                label = $translate.instant("demographics_pill3");
                            } else if (graphType === "ses") {
                                result = $translate.instant(value2.SESDensity);
                                service.stats.features[key1].properties.value = result;
                                marker = ""; //$translate.instant('demographic_group');
                                label = $translate.instant("demographics_pill5");
                            } else if (graphType === "egitim") {
                                result = $translate.instant(value2.EducationDensity);
                                service.stats.features[key1].properties.value = result;
                                marker = "";
                                label = $translate.instant("demographics_pill4");
                            } else if (graphType === "detay" || graphType === "gelir") {
                                service.stats.features[key1].properties.value =
                                    value2.HouseHold;
                                result = window.lang === 'tr' ? (+value2.HouseHold).formatMoney(0, ",", ".") : (+value2.HouseHold).formatMoney(0, ".", ",");
                                marker =
                                    " " + $translate.instant("demographics_population_title");
                                label = $translate.instant("demographics_subpill1");
                            } else if (graphType === "satis") {
                                service.stats.features[key1].properties.value =
                                    value2.TotalSale;
                                result = window.lang === 'tr' ? (+value2.TotalSale).formatMoney(0, ",", ".") : (+value2.TotalSale).formatMoney(0, ".", ",");
                                marker = " " + $translate.instant("demographics_piece");
                                label = $translate.instant("sales_count");
                            } else if (graphType === "konutisyeri") {
                                service.stats.features[key1].properties.value =
                                    value2.TotalEstate;
                                result = window.lang === 'tr' ? (+value2.TotalEstate).formatMoney(0, ",", ".") : (+value2.TotalEstate).formatMoney(0, ".", ",");
                                marker = " " + $translate.instant("demographics_piece");
                                label = $translate.instant("property_count");
                            } else if (graphType === "harcama") {
                                service.stats.features[key1].properties.value =
                                    value2.HouseIncome;
                                result = window.lang === 'tr' ? (+value2.HouseIncome).formatMoney(0, ",", ".") : (+value2.HouseIncome).formatMoney(0, ".", ",");
                                marker = " " + window.currencySymbol;
                                label = $translate
                                    .instant("demographics_perCapita")
                                    .toLocaleProperCase2('tr-tr');
                            } else if (graphType === "ecommerce") {
                                service.stats.features[key1].properties.value =
                                    value2.ECommerceDensity;
                                result = window.lang === 'tr' ? (+value2.ECommerceDensity).formatMoney(0, ",", ".") : (+value2.ECommerceDensity).formatMoney(0, ".", ",");
                                marker = " %";
                                label = $translate
                                    .instant("demographics_eCommerce")
                                    .toLocaleProperCase2('tr-tr');
                            } else {
                                service.stats.features[key1].properties.value =
                                    value2.PopulationTotal;
                                result = window.lang === 'tr' ? (+value2.PopulationTotal).formatMoney(0, ",", ".") : (+value2.PopulationTotal).formatMoney(0, ".", ",");
                                marker =
                                    " " + $translate.instant("demographics_population_title");
                                label = $translate.instant("demographics_pill1");
                            }
                            var text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result + marker;
                            }
                        }
                    }
                if (data2)
                    for (var ir = 0, lentr = data2.length; ir < lentr; ir++) {
                        var value22 = data2[ir];
                        var geoIdr = parseInt(value1.id);
                        if (
                            service.defaults.level === 1 ?
                                geoIdr === value22.CountyId :
                                service.defaults.level === 10 ?
                                    geoIdr === value22.CountryId :
                                    service.defaults.level === 9 ?
                                        geoIdr === value22.CityId :
                                        geoIdr === value22.DistrictId
                        ) {
                            // result = value22.MaritalDensity;
                            result = $translate.instant(value22.MaritalDensity);
                            service.stats.features[key1].properties.value = result;
                            label = $translate.instant("demographics_pill6");
                            text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result;
                            }
                        }
                    }
            }
            if (
                graphType === "yas" ||
                graphType === "medeni-hal" ||
                graphType === "ses" ||
                graphType === "egitim"
            ) {
                service.legendValues.max = 0;
                service.legendValues.min = 0;
                service.legendValues.marker = "";
                service.legendValues.label = "";

                var datas = [];
                for (var key in wholeData) {
                    if (wholeData[key] && typeof wholeData[key] === "object") {
                        datas.push({ key: key, data: wholeData[key].labels });
                    }
                }

                for (var p in service.stats.features) {
                    if (service.stats.features[p].properties) {
                        var searchFor = service.stats.features[p].properties.value;

                        var query = $translate.instant(searchFor);
                        var selected = datas.filter(function (item) {
                            return item.data && item.data.indexOf(query) > -1;
                        });
                        if (selected.length) {
                            var pIndex = selected[0].data.indexOf(searchFor);
                            service.stats.features[p].properties.color =
                                window.globalColors[pIndex];
                        }
                    }
                }

                //if (!analysisService.started)
                service.geojson.style = styleSelected;
                //else
                //    analysisService.oldStyle = styleSelected;
            } else {
                var minMaxArray = angular.copy(service.stats.features);
                minMaxArray.shift();
                minMaxArray = minMaxArray.filter(function (val) {
                    return val.properties.value && val.properties.value !== 0;
                });
                var min = Math.min.apply(
                    Math,
                    minMaxArray.map(function (item) {
                        return item.properties.value;
                    })
                );
                var max = Math.max.apply(
                    Math,
                    minMaxArray.map(function (item) {
                        return item.properties.value;
                    })
                );
                service.legendValues.max = max;
                service.legendValues.min = min;
                service.legendValues.marker = marker;
                service.legendValues.label = label;
                for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                    var value3 = service.stats.features[t];
                    value3.properties.min = min;
                    value3.properties.max = max;
                }
                //service.geojson.data = [service.stats];
                //if (!analysisService.started)
                service.geojson.style = style;
                //else
                //    analysisService.oldStyle = style;
            }
            notifyObservers(true);
        }

        function updateOpportunities(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result + " " + $translate.instant("dataservice_deals");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_deals");
            service.legendValues.label = $translate.instant("opport_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateAgents(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.RealtorCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_experts");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_experts");
            service.legendValues.label = $translate.instant("agent_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateQuakes(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.TweetCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_request");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_request");
            service.legendValues.label = $translate.instant("quake_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateProjects(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_projects");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = " Proje";
            service.legendValues.label = $translate.instant("projects_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateMalls(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("dataservice_malls");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_malls");
            service.legendValues.label = $translate.instant("mall_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateLocations(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result;
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_units");
            service.legendValues.label = $translate.instant("location_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            // service.geojson.onEachFeature = function (feature, layer) {
            //     L.marker(layer.getBounds().getCenter(), {
            //         icon: L.divIcon({
            //             className: 'label',
            //             html: feature.properties.description,
            //             iconSize: [100, 40]
            //         })
            //     }).addTo(service.currentMap);
            // }
            service.geojson.style = style;
            notifyObservers(true);
        }

        function updatePortfolio(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.PropertyCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result + " " + $translate.instant("dataservice_units");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("dataservice_units");
            service.legendValues.label = $translate.instant("portfolio_error_filter");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function updateFellows(data, graphType, wholeData) {
            if (graphType !== "hemsehrilik") return false;
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.CitizenCity;
                            service.stats.features[key1].properties.value = result;
                            var text = service.stats.features[key1].properties.defaultText;
                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text + " " + result;// + ")";
                            }
                        }
                    }
                }
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.legendValues.marker = "";
            service.legendValues.label = "";

            var datas = [];
            for (var key in wholeData) {
                if (wholeData[key] && typeof wholeData[key] === "object") {
                    datas.push({ key: key, data: wholeData[key].labels });
                }
            }
            for (var p in service.stats.features) {
                if (service.stats.features[p].properties) {
                    var searchFor = service.stats.features[p].properties.value;
                    var selected = datas.filter(function (item) {
                        return item.data && item.data.indexOf(searchFor) > -1;
                    });
                    if (selected.length) {
                        var pIndex = selected[0].data.indexOf(searchFor);
                        service.stats.features[p].properties.color =
                            window.globalColors[pIndex];
                    }
                }
            }

            //if (!analysisService.started)
            service.geojson.style = styleSelected;
            //else
            //    analysisService.oldStyle = styleSelected;

            notifyObservers(true);
        }

        function updateElections(data, hash, wholeData) {
            removeStyle();
            if (!data) return false;
            service.currentColorNumber = 0;
            service.currentColors = [];
            service.winners = data.Winners;
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                service.stats.features[y].properties.value = 0;
                if (!service.stats.features[y].properties.defaultText) {
                    service.stats.features[y].properties.defaultText =
                        service.stats.features[y].properties.description;
                } else {
                    service.stats.features[y].properties.description =
                        service.stats.features[y].properties.defaultText;
                }
                if (data.Winners)
                    for (var i = 0, lent = data.Winners.length; i < lent; i++) {
                        var value2 = data.Winners[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.Option;
                            service.stats.features[y].properties.value = result;
                            var text = service.stats.features[y].properties.defaultText;
                            if (result && text) {
                                service.stats.features[y].properties.description =
                                    text + " " + $translate.instant(result);// + ")";
                            }
                        }
                    }
            }

            hash = hash || "2011genelsecim";

            var datas = [];
            for (var t in wholeData) {
                for (var key in wholeData[t]) {
                    if (wholeData[t][key] && typeof wholeData[t][key] === "object") {
                        datas.push({
                            code: wholeData[t].Code,
                            key: key,
                            data: wholeData[t][key].labels,
                        });
                    }
                }
            }
            for (var p in service.stats.features) {
                if (service.stats.features[p].properties) {
                    var searchFor = service.stats.features[p].properties.value;
                    var selected = datas.filter(function (item) {
                        return (
                            item.data && item.data.indexOf(
                                searchFor === "AK Parti" ? "Ak Parti" : searchFor
                            ) > -1
                        );
                    });
                    if (selected.length) {
                        var filtered = selected.filter(function (item) {
                            return item.code === hash;
                        });
                        if (filtered.length) {
                            var pIndex = filtered[0].data.indexOf(
                                searchFor === "AK Parti" ? "Ak Parti" : searchFor
                            );
                            service.stats.features[p].properties.color =
                                window.globalColors[pIndex];
                        }
                    }
                }
            }

            //if (!analysisService.started)
            service.geojson.style = styleSelected;
            //else
            //    analysisService.oldStyle = styleSelected;

            notifyObservers(true);
        }

        function updateInvestments(data) {
            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            service.currentColorNumber = 0;
            service.currentColors = [];
            if (service.stats.features && data)
                for (var y = 0, len = service.stats.features.length; y < len; y++) {
                    var value1 = service.stats.features[y];
                    var key1 = y;
                    service.stats.features[key1].properties.value = 0;
                    if (!service.stats.features[key1].properties.defaultText) {
                        service.stats.features[key1].properties.defaultText =
                            service.stats.features[key1].properties.description;
                    } else {
                        service.stats.features[key1].properties.description =
                            service.stats.features[key1].properties.defaultText;
                    }
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (matchThematicRow(service.defaults.level, geoId, value2)) {
                            var result = value2.ComparableCount;

                            service.stats.features[key1].properties.value = result;

                            var text = service.stats.features[key1].properties.defaultText;

                            if (result && text) {
                                service.stats.features[key1].properties.description =
                                    text +
                                    " " +
                                    result
                                    + " " + $translate.instant("investment_thematic_piece");
                            }
                        }
                    }
                }

            var minMaxArray = angular.copy(service.stats.features);
            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });
            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            service.legendValues.max = max;
            service.legendValues.min = min;
            service.legendValues.marker = $translate.instant("investment_thematic_piece");
            service.legendValues.label = $translate.instant("investment_thematic_listing");
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;
            //else
            //    analysisService.oldStyle = style;
            notifyObservers(true);
        }

        function removeStyle(force) {
            service.currentColorNumber = 0;
            service.currentColors = [];
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            if (
                service.geojson &&
                service.geojson.data[0] &&
                service.geojson.data[0].features &&
                service.geojson.data[0].features.length
            ) {
                for (
                    var y = 0, len = service.geojson.data[0].features.length; y < len; y++
                ) {
                    service.geojson.data[0].features[y].properties.value = 0;
                    if (service.geojson.data[0].features[y].properties.defaultText)
                        service.geojson.data[0].features[y].properties.description =
                            service.geojson.data[0].features[y].properties.defaultText;

                    //translate city and country names;
                    service.geojson.data[0].features[y].properties.description = $translate.instant(service.geojson.data[0].features[y].properties.description);
                }
            }
            service.geojson.style = style;

            if (!force)
                notifyObservers(true);
        }

        function updateIndices(data, params, hideLabels) {
            service.legendValues.marker = window.currencySymbol + "/m²";

            removeStyle();
            service.legendValues.max = 0;
            service.legendValues.min = 0;
            var marker = window.currencySymbol + "/m²";
            var label = "m² " + $translate.instant("value_filter_analysis_1");
            var highLow = "";

            for (var y = 0, len = service.stats.features.length; y < len; y++) {
                var value1 = service.stats.features[y];
                var key1 = y;
                if (!service.stats.features[key1].properties)
                    continue;
                if (!service.stats.features[key1].properties.defaultText) {
                    service.stats.features[key1].properties.defaultText =
                        service.stats.features[key1].properties.description;
                } else {
                    service.stats.features[key1].properties.description =
                        service.stats.features[key1].properties.defaultText;
                }
                if (params.Level === 7 || params.Level === 8) {
                    value1.properties.defaultText = value1.properties.defaultText + " " + $translate.instant('Parsel');
                    value1.properties.description = value1.properties.defaultText;
                }
                else if (params.Level === 6 && value1.properties.BlockNo) {
                    value1.properties.defaultText = value1.properties.defaultText + " " + $translate.instant('Ada');
                    value1.properties.description = value1.properties.defaultText;
                }
                if (data)
                    for (var i = 0, lent = data.length; i < lent; i++) {
                        var value2 = data[i];
                        var geoId = parseInt(value1.id);
                        if (
                            params.Level === 6 ?
                                geoId === value2.BlockId :
                                params.Level === 7 ?
                                    geoId === value2.ParcelId :
                                    matchThematicRow(params.Level, geoId, value2)
                        ) {
                            var resultPrice = 0;
                            if (params.PriceFilter === 1) {
                                resultPrice =
                                    window.currencyConverter(params.PropertyPriceType === 1 ?
                                        value2.UnitPriceForSale :
                                        value2.UnitPriceForRent, value2.CurrencyId, 0, 0, 1);
                                marker = window.currencySymbol + "/m²";
                                label =
                                    params.PropertyPriceType === 1 ?
                                        "m² " + $translate.instant("value_filter_analysis_1") :
                                        "m² " + $translate.instant("value_filter_analysis_2");
                            } else if (params.PriceFilter === 2) {
                                resultPrice =
                                    window.currencyConverter(params.PropertyPriceType === 1 ?
                                        value2.PriceForSale :
                                        value2.PriceForRent, value2.CurrencyId, 0, 0, 1);
                                marker = window.currencySymbol;
                                label =
                                    params.PropertyPriceType === 1 ?
                                        $translate.instant("value_filter_analysis_3") :
                                        $translate.instant("value_filter_analysis_4");
                            } else if (params.PriceFilter === 3) {
                                resultPrice = value2.Amortization;
                                marker = $translate.instant("year");
                                label = $translate.instant("value_depreciation");
                            } else if (params.PriceFilter === 5) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        value2.IndexSale :
                                        value2.IndexRent;
                                marker = $translate.instant("points");
                                label =
                                    params.PropertyPriceType === 1 ?
                                        $translate.instant("value_filter_analysis_00") :
                                        $translate.instant("value_filter_analysis_01");
                            } else if (params.PriceFilter === 4) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.PriceChangeSale * 100).toFixed(2) :
                                        (value2.PriceChangeRent * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_6");
                            } else if (params.PriceFilter === 6) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.StockChangeSale * 100).toFixed(2) :
                                        (value2.StockChangeRent * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_6");
                            }
                            else if (params.PriceFilter === 7) {
                                resultPrice =
                                    params.PropertyPriceType === 1 ?
                                        (value2.UnitPriceSaleAnnualChange * 100).toFixed(2) :
                                        (value2.UnitPriceRentAnnualChange * 100).toFixed(2);

                                if (resultPrice > 0) {
                                    highLow = " <i class='ei-chevron-up'></i>";
                                } else if (resultPrice < 0) {
                                    highLow = " <i class='ei-chevron-down'></i>";
                                } else {
                                    highLow = "";
                                }
                                marker = "%";
                                label = $translate.instant("value_filter_analysis_8");
                            }
                            else if (params.PriceFilter === 8) {
                                resultPrice = value2.Yield ? value2.Yield.toFixed(2) : 0;
                                marker = "%";
                                label = $translate.instant("value_yield2");
                            }
                            if (
                                value2.Description === "NA" &&
                                service.stats.features[key1].properties.defaultText
                            ) {
                                value2.Description = service.stats.features[
                                    key1
                                ].properties.defaultText.toLocaleProperCase2("tr-tr");
                            }

                            service.stats.features[key1].properties.value = resultPrice;
                            var text = service.stats.features[key1].properties.defaultText; //value2.Description;
                            if (resultPrice && text && !hideLabels) {
                                if (params.PriceFilter === 3) {
                                    service.stats.features[key1].properties.description =
                                        text + " " + resultPrice + " " + marker;//+ ")";
                                } else if (
                                    params.PriceFilter === 4 ||
                                    params.PriceFilter === 6 ||
                                    params.PriceFilter === 7 ||
                                    params.PriceFilter === 8
                                ) {
                                    service.stats.features[key1].properties.description =
                                        window.lang === 'tr' ? text + " %" + resultPrice + highLow : text + " " + resultPrice + highLow + "%";
                                } else if (params.PriceFilter === 5) {
                                    service.stats.features[key1].properties.description =
                                        text + " " + resultPrice + " " + marker;// + ")";
                                } else {
                                    if (window.lang === 'tr')
                                        service.stats.features[key1].properties.description = text + ' (' + resultPrice.formatMoney(0, ',', '.') + ' ' + marker + ')';
                                    else
                                        service.stats.features[key1].properties.description = text + ' (' + resultPrice.formatMoney(0, '.', ',') + ' ' + marker + ')';
                                }
                            }
                        }
                    }
            }
            var minMaxArray = angular.copy(service.stats.features);

            minMaxArray.shift();
            minMaxArray = minMaxArray.filter(function (val) {
                return val.properties.value && val.properties.value !== 0;
            });

            var min = Math.min.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );
            var max = Math.max.apply(
                Math,
                minMaxArray.map(function (item) {
                    return item.properties.value;
                })
            );

            if (!hideLabels) {
                service.legendValues.max = max;
                service.legendValues.min = min;
                service.legendValues.marker = marker;
                service.legendValues.label = label;
            } else {
                service.legendValues.max = 0;
                service.legendValues.min = 0;
            }
            for (var t = 0, lenh = service.stats.features.length; t < lenh; t++) {
                var value3 = service.stats.features[t];
                value3.properties.min = min;
                value3.properties.max = max;
            }
            //service.geojson.data = [service.stats];
            //if (!analysisService.started)
            service.geojson.style = style;


            notifyObservers(true);
        }

        //stok ve aylık değişim için
        function getColorRange(d, min, max) {
            if (!d)
                return "transparent";
            const steps = (max - min) / 11;
            return +d >= max - steps ?
                "#a50026" :
                +d >= max - steps * 2 ?
                    "#d73027" :
                    +d >= max - steps * 3 ?
                        "#f46d43" :
                        +d >= max - steps * 4 ?
                            "#fdae61" :
                            +d >= max - steps * 5 ?
                                "#fee08b" :
                                +d >= max - steps * 6 ?
                                    "#ffffbf" :
                                    +d >= max - steps * 7 ?
                                        "#d9ef8b" :
                                        +d >= max - steps * 8 ?
                                            "#a6d96a" :
                                            +d >= max - steps * 9 ?
                                                "#66bd63" :
                                                +d >= max - steps * 10 ?
                                                    "#1a9850" :
                                                    "#006837";
        }

        function style(feature) {
            if (service.defaults.level === 0 || service.defaults.level === 3 || service.defaults.level === 8 || service.defaults.level === 5 || ($rootScope.country !== 'turkiye' && service.defaults.level === 6))
                return {
                    fillColor: "transparent",
                    weight: 2,
                    opacity: 1,
                    color: "#FF0550",
                    dashArray: "2",
                    fillOpacity: 0,

                };
            else {
                const color = getColorRange(
                    feature.properties.value,
                    feature.properties.min,
                    feature.properties.max
                );
                const zoom = service.currentMap.getZoom ? service.currentMap.getZoom() : service.center.zoom;
                return {
                    fillColor: color,
                    weight: 1.2,
                    color: (window.darkMode || zoom > 14) && color !== 'transparent' ? "#ddd" : (color === 'transparent' && zoom <= 14 && !window.darkMode) ? "rgb(132,134,136)" : "#eee", //: "rgb(232,234,236)", "rgb(93,94,96)", "rgb(125,143,155)", //"rgb(144,144,144)", //"rgb(181,181,181)"
                    dashArray: "1",
                    opacity: 1,
                    fillOpacity: 0.8

                };
            }
        }

        function styleSelected(feature) {
            if (service.defaults.level === 0 || service.defaults.level === 3 || service.defaults.level === 8 || service.defaults.level === 5 || ($rootScope.country !== 'turkiye' && service.defaults.level === 6))
                return {
                    fillColor: "transparent",
                    weight: 2,
                    opacity: 1,
                    color: "#FF0550",
                    dashArray: "2",
                    fillOpacity: 0,

                };
            else {
                const color = feature.properties.color;
                const zoom = service.currentMap.getZoom ? service.currentMap.getZoom() : service.center.zoom;
                return {
                    fillColor: color,
                    weight: 1.2,
                    opacity: 1,
                    color: (window.darkMode || zoom > 14) && color !== 'transparent' ? "#ddd" : (color === 'transparent' && zoom <= 14 && !window.darkMode) ? "rgb(132,134,136)" : "#eee",
                    dashArray: "1",
                    fillOpacity: 0.8,

                };
            }
        }

        function zoomToBound(map) {
            map = map || service.currentMap;
            if ($location.search().d) {
                var wkt = unescape($location.search().d);
                var wktr = new Wkt.Wkt();
                wktr.read(wkt);
                var tojs = wktr.toJson();
                var geo = L.geoJson(tojs);
                var bounds = geo.getBounds();
                var lbounds = {
                    northEast: {
                        lat: bounds._northEast.lat,
                        lng: bounds._northEast.lng,
                    },
                    southWest: {
                        lat: bounds._southWest.lat,
                        lng: bounds._southWest.lng,
                    },
                };
                // var centroid = bounds.getCenter();
                // service.center.lat = centroid.lat;
                // service.center.lng = centroid.lng;

                service.bounds = lbounds;
            } else if (service.defaults.level !== 0 && service.stats) {

                var geo = L.geoJson(service.stats);
                var bounds = geo.getBounds();
                var lbounds = {
                    northEast: {
                        lat: bounds._northEast.lat,
                        lng: bounds._northEast.lng,
                    },
                    southWest: {
                        lat: bounds._southWest.lat,
                        lng: bounds._southWest.lng,
                    },
                };

                // var centroid = bounds.getCenter();
                // service.center.lat = centroid.lat;
                // service.center.lng = centroid.lng;

                service.bounds = window.bounds_override ? window.bounds_override : lbounds;

                if (service.defaults.level === 1 || service.defaults.level === 9) {
                    service.cityBounds = service.bounds;
                }

            } else if (service.defaults.level === 0 && service.markers.m1) {
                service.defaults.lat = service.markers.m1.lat;
                service.defaults.lng = service.markers.m1.lng;
                var circle = L.circle([service.defaults.lat, service.defaults.lng], {
                    radius: window.r_override ? window.r_override : 150,
                });
                try {
                    circle.addTo(map);

                    var bounds = circle.getBounds();
                    var lbounds = {
                        northEast: {
                            lat: bounds._northEast.lat,
                            lng: bounds._northEast.lng,
                        },
                        southWest: {
                            lat: bounds._southWest.lat,
                            lng: bounds._southWest.lng,
                        },
                    };

                    // var centroid = bounds.getCenter();
                    // service.center.lat = centroid.lat;
                    // service.center.lng = centroid.lng;

                    service.bounds = lbounds;
                    circle.removeFrom(map);
                }
                catch (err) {
                    //ignored
                }
            }
            else {
                // var lbounds = {
                //     "northEast": {
                //         "lat": 42.10480080000019,
                //         "lng": 44.81603587600034
                //     },
                //     "southWest": {
                //         "lat": 35.808715305999954,
                //         "lng": 25.66549954000005
                //     }
                // };
                service.bounds = window.bounds_override ? window.bounds_override : {};
            }
            $timeout(function () {
                try {
                    map.invalidateSize();
                }
                catch (err) {
                    //ignored
                }
            }, 0);
        }

        function $$IsInside(lat, lng, poly, level) {
            var deferred = $q.defer();
            if (!level && !service.level)
                if (poly) {
                    var x = lat,
                        y = lng;
                    var inside = false;
                    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
                        var xi = poly[i].lat,
                            yi = poly[i].lng;
                        var xj = poly[j].lat,
                            yj = poly[j].lng;
                        var intersect =
                            yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
                        if (intersect) {
                            inside = true;
                            break;
                        }
                    }
                    deferred.resolve(inside);
                } else deferred.resolve(false);
            else
                deferred.resolve(false);
            return deferred.promise;
        }
    }
})();

(function () {
    "use strict";

    var serviceId = "poiService";
    angular
        .module("app.common")
        .factory(serviceId, [
            "$q",
            "poiAPICache",
            "$ocLazyLoad",
            "auth_factory",
            bolgeselDataService
        ]);

    function bolgeselDataService(
        $q,
        poiAPICache,
        $ocLazyLoad,
        auth_factory
    ) {
        var service = {
            getPOI: getPOI
        };

        return service;

        function getPOI(payload) {
            var deferred = $q.defer();

            var requester;

            var $cancelRequest = function () {
                if (requester)
                    requester.$cancelRequest();
            };
            requester = poiAPICache.get(Object.assign(payload, {captchaTokenCustom: window.ecSec()}));
            requester.$promise.then(
                function (response) {
                    return deferred.resolve(response);
                }, 
                function (err) {
                    return deferred.reject(err);
                }
            );


            return { $promise: deferred.promise, $cancelRequest: $cancelRequest };
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('turnstileSvc', ['$q', turnstileSvc]);

    function turnstileSvc($q) {
        var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        var TURNSTILE_SITE_KEY = isLocalhost ? '1x00000000000000000000AA' : '0x4AAAAAACNleg3E3Cw7A_b0';
        var scriptLoaded = false;

        function getToken() {
            var deferred = $q.defer();

            if (!window.turnstile && !scriptLoaded) {
                var script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.onload = function () {
                    scriptLoaded = true;
                    renderWidget(deferred);
                };
                script.onerror = function () { deferred.resolve(null); };
                document.head.appendChild(script);
            } else {
                renderWidget(deferred);
            }

            return deferred.promise;
        }

        function renderWidget(deferred) {
            var container = document.getElementById('turnstile-invisible-container');
            if (!container) {
                container = document.createElement('div');
                container.id = 'turnstile-invisible-container';
                container.style.position = 'fixed';
                container.style.top = '-9999px';
                container.style.left = '-9999px';
                container.style.width = '1px';
                container.style.height = '1px';
                container.style.overflow = 'hidden';
                document.body.appendChild(container);
            }
            container.innerHTML = '';

            try {
                window.turnstile.render(container, {
                    sitekey: TURNSTILE_SITE_KEY,
                    size: 'normal',
                    callback: function (token) { deferred.resolve(token); },
                    'error-callback': function () { deferred.resolve(null); }
                });
            } catch (e) {
                deferred.resolve(null);
            }
        }

        return { getToken: getToken };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('skeletonLoader', skeletonLoader);

    /**
     * Skeleton Loader Directive
     *
     * Usage:
     * <skeleton-loader></skeleton-loader>
     * <skeleton-loader width="100%" height="200px"></skeleton-loader>
     * <skeleton-loader shape="circle" size="50px"></skeleton-loader>
     * <skeleton-loader lines="3"></skeleton-loader>
     * <skeleton-loader lines="5" line-height="20px" line-spacing="15px"></skeleton-loader>
     *
     * Attributes:
     * - width: Width of skeleton (default: '100%')
     * - height: Height of skeleton (default: '20px')
     * - shape: 'rectangle' (default) or 'circle'
     * - size: For circle shape, sets both width and height
     * - lines: Number of skeleton lines to display
     * - line-height: Height of each line (default: '20px')
     * - line-spacing: Bottom margin between lines (default: '15px')
     * - border-radius: Custom border radius (default: '8px')
     */
    function skeletonLoader() {
        return {
            restrict: 'E',
            scope: {
                width: '@',
                height: '@',
                shape: '@',
                size: '@',
                lines: '@',
                lineHeight: '@',
                lineSpacing: '@',
                borderRadius: '@'
            },
            template: `
                <div class="skeleton-loader-wrapper">
                    <div ng-if="!vm.lines"
                         class="skeleton-loader-item animated-background"
                         ng-style="vm.getSingleStyle()">
                    </div>
                    <div ng-if="vm.lines">
                        <div ng-repeat="line in vm.getLineArray() track by $index"
                             class="skeleton-loader-item animated-background"
                             ng-style="vm.getLineStyle($index, $last)">
                        </div>
                    </div>
                </div>
            `,
            link: function (scope) {
                var vm = scope.vm = {};

                // Default values
                var defaults = {
                    width: '100%',
                    height: '20px',
                    lineHeight: '20px',
                    lineSpacing: '15px',
                    borderRadius: '8px'
                };

                /**
                 * Get style object for single skeleton
                 */
                vm.getSingleStyle = function () {
                    var style = {};

                    if (scope.shape === 'circle') {
                        var circleSize = scope.size || '50px';
                        style.width = circleSize;
                        style.height = circleSize;
                        style.borderRadius = '50%';
                    } else {
                        style.width = scope.width || defaults.width;
                        style.height = scope.height || defaults.height;
                        style.borderRadius = scope.borderRadius || defaults.borderRadius;
                    }

                    return style;
                };

                /**
                 * Get style object for line skeleton
                 */
                vm.getLineStyle = function (index, isLast) {
                    var style = {
                        width: scope.width || defaults.width,
                        height: scope.lineHeight || defaults.lineHeight,
                        borderRadius: scope.borderRadius || defaults.borderRadius
                    };

                    // Add spacing between lines (not on last line)
                    if (!isLast) {
                        style.marginBottom = scope.lineSpacing || defaults.lineSpacing;
                    }

                    // Optional: Make last line slightly shorter for visual effect
                    if (isLast && parseInt(scope.lines) > 1) {
                        style.width = '90%';
                    }

                    return style;
                };

                /**
                 * Generate array for ng-repeat based on lines count
                 */
                vm.getLineArray = function () {
                    var count = parseInt(scope.lines) || 1;
                    return new Array(count);
                };
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('phoneInputForm', phoneInputForm);

    function phoneInputForm() {
        //binding document: https://stackoverflow.com/a/37818829
        var directive = {
            templateUrl: '/app/common/phone-input.html',
            scope: {
                input: '=', // model connection
                isRegistered: '=', // returns registration status
                isRequired: '<', // check if required
                isValid: '=', // returns validation status
                phoneChanged: '=', // returns phone change status
                hasOtp: '<', //check if require OTP
                waitingOtp: '=', //check if OTP is waiting
                otpType: '@',
                name: '@',
                isDisabled: '=',
                selectionDisabled: '<', //disable country selection
                selectedCode: '@', //selected country code
                checkRegistered: '<', //check if registered
                handleOnChange: '&',
                handleOnBlur: '&',
                handleOnClick: '&',
                handleOtpVerify: '&',
                disableWarning: '<',
                showBubbleMessage: '<', //shows additional notifier messages
                hideRegisteredWarning: '<', //hides registered warning
                // Captcha bindings (active when hasOtp !== false)
                etToken: '=', // two-way binding for turnstile token
                captchaVerified: '=', // true when turnstile + eimage captcha are both valid
                isTurkishPhone: '=', // two-way binding for Turkish phone status
                eimageCaptchaKey: '=', // two-way binding for eimage captcha key
                eimageCaptchaValue: '=' // two-way binding for eimage captcha value
            },
            restrict: 'EA',
            controller: phoneInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elm, attrs) {
                if (attrs.selectedCode) {
                    setTimeout(function () {
                        scope.vm.selectedCountry = scope.vm.countries.find(c => c.callingCode === attrs.selectedCode);
                    });
                }

                // Initialize Bootstrap dropdown
                setTimeout(function () {
                    var $dropdown = elm.find('.dropdown');
                    var $button = elm.find('.country-dropdown-btn');
                    var $menu = elm.find('.dropdown-menu');

                    if ($button.length === 0) {
                        return;
                    }

                    // Manual dropdown toggle
                    $button.on('click', function (e) {
                        // Don't handle if button is disabled
                        if ($button.is(':disabled')) {
                            return;
                        }

                        e.preventDefault();
                        e.stopPropagation();

                        var isOpen = $dropdown.hasClass('open');

                        // Close all other dropdowns
                        $('.dropdown').removeClass('open');

                        // Toggle this dropdown
                        if (!isOpen) {
                            $dropdown.addClass('open');
                            $button.attr('aria-expanded', 'true');
                        } else {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }
                    });

                    // Close dropdown when clicking outside
                    $(document).on('click.phoneDropdown', function (e) {
                        // Don't close if clicking the button itself or its children
                        if ($button.is(e.target) || $button.has(e.target).length > 0) {
                            return;
                        }

                        // Close if clicking outside the dropdown
                        if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }
                    });

                    // Close dropdown when selecting a country
                    $menu.find('li a').on('click', function () {
                        setTimeout(function () {
                            $dropdown.removeClass('open');
                            $button.attr('aria-expanded', 'false');
                        }, 100);
                    });

                    // Cleanup on destroy
                    scope.$on('$destroy', function () {
                        $button.off('click');
                        $menu.find('li a').off('click');
                        $(document).off('click.phoneDropdown');
                    });
                }, 500);
            }
        };
        return directive;

    }

    phoneInputFormController.$inject = ['countriesCodesService', '$translate', 'notifierSvc', 'otpService', 'user_factory', '$rootScope', '$timeout', '$scope'];
    function phoneInputFormController(countriesCodesService, $translate, notifierSvc, otpService, user_factory, $rootScope, $timeout, $scope) {
        var vm = this;
        vm.countries = countriesCodesService;
        vm.phoneChanged = false;
        vm.showMenu = false;

        // Turnstile configuration
        var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        var TURNSTILE_SITE_KEY = isLocalhost ? '1x00000000000000000000AA' : '0x4AAAAAACNleg3E3Cw7A_b0';
        var turnstileWidgetId = null;
        var turnstileDebounceTimer = null; // Debounce timer for Turnstile initialization
        var TURNSTILE_DEBOUNCE_DELAY = 500; // 500ms debounce delay
        vm.turnstileContainerId = 'turnstile-container-' + $scope.$id; // Unique ID for each directive instance
        vm.isTurkishPhone = true; // Default to Turkish phone

        // Internal captcha states
        var turnstileVerified = false;
        vm.eimageCaptchaKey = null;
        vm.eimageCaptchaValue = null;
        vm.captchaRemainingAttempts = null;

        vm.updateCaptchaVerified = function (captchaValue) {
            if (typeof captchaValue !== 'undefined') {
                vm.eimageCaptchaValue = captchaValue;
            }
            vm.captchaVerified = turnstileVerified && !!vm.eimageCaptchaValue;
        };

        var initCountry;

        //bind country code
        setTimeout(function () {
            window.oldPhoneNumber = vm.input;
            var controlCountry;
            if (vm.input === '' || !vm.input || !vm.input.length) {
                vm.input = undefined;
            }
            else {
                for (var i = 5; i > 1; --i) {
                    var controlCode = vm.input.slice(0, i);
                    controlCountry = vm.countries.find(function (code) {
                        return code.callingCode === controlCode;
                    });
                    if (controlCountry) {
                        break;
                    }
                }
            }
            initCountry = controlCountry ? controlCountry : window.lang == 'tr' ? {
                "name": "Turkiye",
                "code": "TR",
                "callingCode": "+90"
            } : window.lang == 'es-ES' ? {
                "name": "Spain",
                "code": "ES",
                "callingCode": "+34"
            } : window.lang == 'pt-PT' ? {
                "name": "Portugal",
                "code": "PT",
                "callingCode": "+351"
            } : {
                "name": "United Kingdom",
                "code": "GB",
                "callingCode": "+44"
            };

            vm.selectedCountry = initCountry;


            vm.checkCallingCode();

            $('#phone-nput').focus(function () {
                var that = this;
                setTimeout(function () { that.selectionStart = that.selectionEnd = 10000; }, 0);
            });

        });


        vm.selectCountry = function (country) {
            vm.input = vm.input && vm.input.length ? vm.input.replace(vm.selectedCountry.callingCode, country.callingCode) : vm.input;
            vm.selectedCountry = country;

            var isValid = false;
            if (vm.input)
                isValid = window.libphonenumber.isValidPhoneNumber(vm.input, vm.selectedCountry.code);
            if (isValid)
                vm.input = window.libphonenumber.parsePhoneNumber(vm.input, vm.selectedCountry.code).formatInternational();
            vm.checkCallingCode();
        };

        vm.showRequireOtp = function () {
            return !vm.isDisabled && vm.hasOtp && vm.phoneChanged && !vm.isRegistered && vm.input && vm.input.length && vm.phoneChanged && vm.isValid && !vm.disableWarning && !vm.isFirstPhone;
        };

        vm.showError = function () {
            return !vm.isDisabled && vm.phoneChanged && (!vm.isValid || (vm.isRegistered && !vm.hideRegisteredWarning) || (!vm.input && vm.isRequired)) && !vm.disableWarning && !vm.isFirstPhone;
        };

        vm.checkCallingCode = function () {
            vm.isValid = true;
            if (typeof vm.isDisabled !== "undefined")
                vm.isDisabled = false;
            if (typeof vm.isRegistered !== "undefined")
                vm.isRegistered = false;

            vm.isFirstPhone = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isPhoneNumberFilled && !$rootScope.recommendedFieldsToFill.isPhoneConfirmed) ? false : (vm.input && window.oldPhoneNumber && vm.input.replaceAll(' ', '').replace('+', '') === window.oldPhoneNumber.replaceAll(' ', '').replace('+', ''));
            vm.phoneChanged = !vm.isFirstPhone;

            if ((!vm.input || vm.input.length === 0) && vm.isRequired) {
                vm.isValid = false;
                vm.phoneChanged = false;
                return;
            }

            if (vm.input) {
                vm.isValid = window.libphonenumber.isValidPhoneNumber(vm.input, vm.selectedCountry.code);
                vm.input = window.libphonenumber.parsePhoneNumber(vm.input, vm.selectedCountry.code).formatInternational();
            }
            else if (vm.isRequired) {
                vm.isValid = false;
            }

            if (vm.isValid && vm.checkRegistered && vm.input) {
                if (typeof vm.isDisabled !== "undefined")
                    vm.isDisabled = true;
                if (typeof vm.isRegistered !== "undefined")
                    vm.isRegistered = true;
                var checkPhone = user_factory.any({ phone: vm.input.replace(/\s/g, '') });
                checkPhone.$promise.then(function (response) {
                    if (response.result) {
                        if (vm.showBubbleMessage && !vm.hideRegisteredWarning)
                            $translate('valid_email21').then(function (translation2) {
                                notifierSvc.show({ message: translation2, type: "error" });
                            });
                        if ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isPhoneNumberFilled && !$rootScope.recommendedFieldsToFill.isPhoneConfirmed)
                            vm.isRegistered = false;
                    }
                    else {
                        if (typeof vm.isRegistered !== "undefined")
                            vm.isRegistered = false;
                    }
                }, function () {
                    if (typeof vm.isRegistered !== "undefined")
                        vm.isRegistered = false;
                }).finally(() => {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                });
            }
            vm.waitingOtp = vm.showRequireOtp();
            // if (window.oldPhoneNumber && window.oldPhoneNumber.length && (!vm.input || !vm.input.length)) {
            //     window.oldPhoneNumber = undefined;
            // }
            handleChange();
        };

        vm.updateCountryCode = function () {
            var controlCountry;
            if (vm.input === '' || !vm.input || !vm.input.length) {
                vm.input = undefined;
            }
            else
                for (var i = 5; i > 1; --i) {
                    var controlCode = vm.input.slice(0, i);
                    controlCountry = vm.countries.find(function (code) {
                        return code.callingCode === controlCode;
                    });
                    if (controlCountry) {
                        vm.selectedCountry = controlCountry;
                        break;
                    }
                }
        };

        vm.callOtp = function () {
            vm.loading = true;
            vm.phoneChanged = true;
            var ETToken = !vm.isTurkishPhone ? vm.etToken : null;
            var eimageCaptchaData = !vm.isTurkishPhone && vm.eimageCaptchaKey ? { key: vm.eimageCaptchaKey, value: vm.eimageCaptchaValue } : null;
            var otpType = vm.otpType || "profileUpdate";
            var verificationAddress = otpType === "loginAndRegister" ? vm.input : vm.input.replace("+", "");
            otpService.callOtp(otpType, 1, verificationAddress, null, null, ETToken, eimageCaptchaData).then(function (resp) {
                vm.loading = false;
                otpService.closeDialog();
                // Reset Turnstile token after use
                resetTurnstile();
                // Reset EImage-Captcha after use
                resetEimageCaptcha();
                if (!resp) {
                    return;
                }
                vm.phoneChanged = false;
                window.oldPhoneNumber = vm.input;
                vm.waitingOtp = vm.showRequireOtp();
                vm.handleOtpVerify({ response: resp });
            }, function (err) {
                otpService.closeDialog();
                vm.loading = false;
                // Handle captcha error from sevc endpoint
                if (err.data && typeof err.data.remainingAttempts !== 'undefined') {
                    vm.captchaRemainingAttempts = err.data.remainingAttempts;
                    vm.eimageCaptchaValue = null;
                    vm.updateCaptchaVerified();
                } else {
                    // Reset Turnstile token on error
                    resetTurnstile();
                    // Reset EImage-Captcha on non-captcha errors
                    resetEimageCaptcha();
                    if (err.validateRequest)
                        retryOTP(err.validateRequest);
                }
            }).finally(() => {
            });
        };

        function retryOTP(validateRequest) {
            vm.loading = true;
            vm.phoneChanged = true;
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    vm.loading = false;
                    otpService.closeDialog();
                    if (!resp) {
                        return;
                    }
                    vm.phoneChanged = false;
                    window.oldPhoneNumber = vm.input;
                    vm.waitingOtp = vm.showRequireOtp();
                    vm.handleOtpVerify({ response: resp });
                },
                function (err) {
                    otpService.closeDialog();
                    retryOTP(err.validateRequest);
                }
            );
        }



        var stopExecution = false;
        vm.reactivityForCountryCode = function () {
            function sleep() {
                return new Promise(function (resolve) {
                    setTimeout(resolve, 150);
                });
            }
            async function process() {
                while (!stopExecution) {
                    if (vm.input && vm.input.length && vm.input.startsWith(vm.selectedCountry.callingCode)) {
                        break;
                    }
                    await sleep();
                    await vm.updateCountryCode();
                }
            }
            process();
        };
        vm.reactivityForCountryCode();
        vm.$onDestroy = function () {
            stopExecution = true;
        };
        const handleChange = function () {
            if (vm.handleOnChange)
                vm.handleOnChange({ input: vm.input });

            // Always update Turkish phone status
            vm.isTurkishPhone = isTurkishNumber(vm.input);

            // Handle Turnstile for non-Turkish phones (active when hasOtp is not false)
            if (vm.hasOtp !== false) {
                // Cancel any pending debounce timer
                if (turnstileDebounceTimer) {
                    $timeout.cancel(turnstileDebounceTimer);
                    turnstileDebounceTimer = null;
                }

                // Only initialize Turnstile if phone is valid and not Turkish
                if (!vm.isTurkishPhone && vm.isValid) {
                    // Debounce Turnstile initialization
                    turnstileDebounceTimer = $timeout(function () {
                        initializeTurnstile();
                        turnstileDebounceTimer = null;
                    }, TURNSTILE_DEBOUNCE_DELAY);
                } else {
                    resetTurnstile();
                    resetEimageCaptcha();
                }
            }
        };
        vm.handleClick = function () {
            vm.handleOnClick();
        };
        vm.handleBlur = function () {
            vm.handleOnBlur({ input: vm.input });
        };

        // Turnstile Functions
        function isTurkishNumber(phoneNumber) {
            if (!phoneNumber) return true;
            var cleanNumber = phoneNumber.replace(/\s+/g, '');
            return cleanNumber.startsWith('+90');
        }

        function loadTurnstileScript() {
            return new Promise(function (resolve, reject) {
                if (window.turnstile) {
                    resolve();
                    return;
                }

                var script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.defer = true;
                script.onload = function () {
                    resolve();
                };
                script.onerror = function () {
                    reject(new Error('Failed to load Turnstile script'));
                };
                document.head.appendChild(script);
            });
        }

        function initializeTurnstile() {
            if (vm.hasOtp === false) return;

            loadTurnstileScript().then(function () {
                $timeout(function () {
                    var container = document.getElementById(vm.turnstileContainerId);
                    if (!container) return;

                    // Remove existing widget if any
                    if (turnstileWidgetId !== null) {
                        try {
                            window.turnstile.remove(turnstileWidgetId);
                        } catch (e) {
                            // Widget may already be removed
                        }
                        turnstileWidgetId = null;
                    }

                    // Clear container
                    container.innerHTML = '';

                    // Determine theme based on dark mode
                    var isDarkMode = window.darkMode || false;
                    var theme = isDarkMode ? 'dark' : 'light';

                    // Render new widget
                    turnstileWidgetId = window.turnstile.render(container, {
                        sitekey: TURNSTILE_SITE_KEY,
                        theme: theme,
                        size: 'normal',
                        callback: function (token) {
                            $scope.$apply(function () {
                                vm.etToken = token;
                                turnstileVerified = true;
                                vm.updateCaptchaVerified();
                            });
                        },
                        'expired-callback': function () {
                            $scope.$apply(function () {
                                vm.etToken = null;
                                turnstileVerified = false;
                                vm.updateCaptchaVerified();
                            });
                        },
                        'error-callback': function () {
                            $scope.$apply(function () {
                                vm.etToken = null;
                                turnstileVerified = false;
                                vm.updateCaptchaVerified();
                            });
                        }
                    });
                }, 50);
            });
        }

        function resetTurnstile() {
            turnstileVerified = false;
            vm.etToken = null;
            vm.updateCaptchaVerified();
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.remove(turnstileWidgetId);
                } catch (e) {
                    // Widget may already be removed
                }
                turnstileWidgetId = null;
            }
        }

        function resetEimageCaptcha() {
            vm.eimageCaptchaKey = null;
            vm.eimageCaptchaValue = null;
            vm.updateCaptchaVerified();
        }

        vm.resetTurnstileWidget = function () {
            turnstileVerified = false;
            vm.etToken = null;
            vm.updateCaptchaVerified();
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.reset(turnstileWidgetId);
                } catch (e) {
                    // If reset fails, re-initialize
                    initializeTurnstile();
                }
            }
        };

        // Listen for dark mode changes to update Turnstile theme
        var unbindDarkMode = $scope.$on('darkMode:changed', function (e, data) {
            if (vm.hasOtp !== false && !vm.isTurkishPhone && turnstileWidgetId !== null) {
                // Re-render Turnstile with new theme
                initializeTurnstile();
            }
        });

        // Cleanup on destroy
        vm.$onDestroy = function () {
            stopExecution = true;
            // Cancel debounce timer
            if (turnstileDebounceTimer) {
                $timeout.cancel(turnstileDebounceTimer);
                turnstileDebounceTimer = null;
            }
            // Clean up Turnstile widget
            if (turnstileWidgetId !== null && window.turnstile) {
                try {
                    window.turnstile.remove(turnstileWidgetId);
                } catch (e) {
                    // Widget may already be removed
                }
            }
            // Unbind dark mode listener
            if (unbindDarkMode) {
                unbindDarkMode();
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('eimageCaptcha', eimageCaptcha);

    function eimageCaptcha() {
        var directive = {
            templateUrl: '/app/common/eimage-captcha.html',
            scope: {
                captchaKey: '=',
                captchaValue: '=',
                onChange: '&',
                remainingAttempts: '='
            },
            restrict: 'EA',
            controller: eimageCaptchaController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    eimageCaptchaController.$inject = ['captcha_factory', '$scope', '$interval'];
    function eimageCaptchaController(captcha_factory, $scope, $interval) {
        var vm = this;
        vm.captchaImage = null;
        vm.userInput = '';
        vm.loading = false;
        vm.errorMessage = null;
        vm.expiresInSeconds = 0;
        var countdownInterval = null;
        var CAPTCHA_MIN_LENGTH = 5;

        vm.$onInit = function () {
            fetchCaptcha();
        };

        vm.fetchCaptcha = fetchCaptcha;
        vm.refreshCaptcha = refreshCaptcha;
        vm.formatTime = formatTime;

        vm.handleChange = function () {
            vm.remainingAttempts = null;
            if (vm.userInput && vm.userInput.length >= CAPTCHA_MIN_LENGTH) {
                vm.captchaValue = vm.userInput;
            } else {
                vm.captchaValue = null;
            }
            if (vm.onChange) vm.onChange({ value: vm.captchaValue });
        };


        function fetchCaptcha() {
            vm.loading = true;
            vm.errorMessage = null;
            vm.userInput = '';
            vm.captchaValue = null;
            if (vm.onChange) vm.onChange({ value: null });
            vm.captchaKey = null;
            vm.captchaImage = null;

            captcha_factory.getCaptcha().$promise.then(function (resp) {
                vm.loading = false;
                vm.captchaImage = resp.captchaImageBase64;
                vm.captchaKey = resp.captchaKey;
                vm.expiresInSeconds = resp.expiresInSeconds || 120;
                startCountdown();
            }, function (err) {
                vm.loading = false;
                vm.captchaImage = null;
                vm.errorMessage = 'eimage_captcha_load_error';
            });
        }

        function refreshCaptcha() {
            stopCountdown();
            fetchCaptcha();
        }

        function startCountdown() {
            stopCountdown();
            countdownInterval = $interval(function () {
                if (vm.expiresInSeconds > 0) {
                    vm.expiresInSeconds--;
                } else {
                    stopCountdown();
                    fetchCaptcha();
                }
            }, 1000);
        }

        function stopCountdown() {
            if (countdownInterval) {
                $interval.cancel(countdownInterval);
                countdownInterval = null;
            }
        }

        function formatTime() {
            var minutes = Math.floor(vm.expiresInSeconds / 60);
            var seconds = vm.expiresInSeconds % 60;
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        }

        // Cleanup on destroy
        $scope.$on('$destroy', function () {
            stopCountdown();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('mailInputForm', mailInputForm);

    function mailInputForm() {
        //binding document: https://stackoverflow.com/a/37818829
        var directive = {
            templateUrl: '/app/common/mail-input.html',
            scope: {
                input: '=', // model connection
                isRegistered: '=', // returns registration status
                isRequired: '<', // check if required
                isValid: '=', // returns validation status
                mailChanged: '=', // returns phone change status
                hasOtp: '<', //check if require OTP
                waitingOtp: '=', //check if OTP is waiting
                otpType: '@',
                isRequired: '<',
                name: '@',
                checkRegistered: '<', //check if registered
                isDisabled: '=',
                handleOnChange: '&',
                handleOnBlur: '&',
                handleOtpVerify: '&',
                disableWarning: '<',
                showBubbleMessage: '<', //shows additional notifier messages
                hideRegisteredWarning: '<' //hides registered warning
            },
            restrict: 'EA',
            controller: mailInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elm, attrs) {
                // console.log("link: ", scope)
                // console.log("elm: ", elm)
                // console.log("attrs: ", attrs)
            }
        };
        return directive;

    }

    mailInputFormController.$inject = ['userSvc', 'user_factory', '$translate', 'notifierSvc', 'otpService', '$timeout', '$rootScope'];
    function mailInputFormController(userSvc, user_factory, $translate, notifierSvc, otpService, $timeout, $rootScope) {
        var vm = this;

        $timeout(function () {
            window.oldMailAddress = vm.input;
            vm.checkEmail();
        }, 100);


        vm.showRequireOtp = function () {
            return !vm.isDisabled && vm.hasOtp && vm.mailChanged && vm.input && vm.input.length && vm.isValid && !vm.isRegistered && !vm.disableWarning && !vm.isFirstMail;
        };

        vm.showError = function () {
            return !vm.isDisabled && vm.mailChanged && (!vm.isValid || (vm.isRegistered && !vm.hideRegisteredWarning) || (!vm.input && vm.isRequired)) && !vm.disableWarning && !vm.isFirstMail;
        };


        vm.checkEmail = function () {
            if (vm.isDisabled) return;

            vm.isValid = true;
            if (typeof vm.isRegistered !== "undefined")
                vm.isRegistered = false;


            vm.isFirstMail = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isEmailFilled && !$rootScope.recommendedFieldsToFill.isEmailConfirmed) ? false : (vm.input && window.oldMailAddress && vm.input === window.oldMailAddress);
            vm.mailChanged = !vm.isFirstMail;

            if ((!vm.input || vm.input.length === 0) && vm.isRequired) {
                vm.isValid = false;
                vm.mailChanged = false;
                return;
            }

            var validated = validateEmail(vm.input);
            vm.isValid = vm.input && vm.input.length ? validated : true;
            if (validated) {
                if (typeof vm.isDisabled !== "undefined")
                    vm.isDisabled = true;

                // Additional check to prevent API call for bank users
                if ($rootScope.isBank) {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                    vm.isValid = true;
                    return;
                }

                userSvc.checkEmail(vm.input).then(function (result) {
                    if (typeof result.status !== "undefined" && result.status === 305) {
                        vm.isValid = false;
                    }
                    else {
                        vm.isValid = true;
                    }
                    if (vm.checkRegistered) {
                        if (vm.input) {
                            var checkEmail = user_factory.any({ email: vm.input });
                            checkEmail.$promise.then(function (response) {
                                if (response.result) {
                                    if (vm.showBubbleMessage && !vm.hideRegisteredWarning)
                                        $translate('valid_email21').then(function (translation2) {
                                            notifierSvc.show({ message: translation2, type: "error" });
                                        });
                                    if (typeof vm.isRegistered !== "undefined")
                                        vm.isRegistered = ($rootScope.recommendedFieldsToFill && $rootScope.recommendedFieldsToFill.isEmailFilled && !$rootScope.recommendedFieldsToFill.isEmailConfirmed) ? false : true;
                                }
                            }).finally(() => {
                                if (typeof vm.isDisabled !== "undefined")
                                    vm.isDisabled = false;
                            });
                        }
                        else {
                            if (typeof vm.isDisabled !== "undefined")
                                vm.isDisabled = false;
                        }
                    }
                    else {
                        if (typeof vm.isDisabled !== "undefined")
                            vm.isDisabled = false;
                    }
                }).finally(() => {
                    if (typeof vm.isDisabled !== "undefined")
                        vm.isDisabled = false;
                });
            }
            vm.waitingOtp = vm.showRequireOtp();
            // if (window.oldMailAddress && window.oldMailAddress.length && (!vm.input || !vm.input.length)) {
            //     window.oldMailAddress = undefined;
            // }
            handleChange();
        };


        function validateEmail(email) {
            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                email
            );
        }
        vm.onInit = function () {
            //console.log("onInit: ", vm)
        };
        vm.$onDestroy = function () {
        };

        let handleChange = function () {
            if (vm.handleOnChange)
                vm.handleOnChange({ input: vm.input });
        };
        vm.handleBlur = function () {
            vm.handleOnBlur({ input: vm.input });
        };
        vm.callOtp = function () {
            vm.mailChanged = true;
            vm.loading = true;
            otpService.callOtp(vm.otpType || "profileUpdate", 0, vm.input).then(function (resp) {
                vm.loading = false;
                otpService.closeDialog();
                if (!resp) {
                    return;
                }
                vm.mailChanged = false;
                window.oldMailAddress = vm.input;
                vm.waitingOtp = vm.showRequireOtp();
                vm.handleOtpVerify({ response: resp });
            }, function (err) {
                otpService.closeDialog();
                retryOTP(err.validateRequest);
            }).finally(() => {
            });
        };

        function retryOTP(validateRequest) {
            vm.mailChanged = true;
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    vm.loading = false;
                    otpService.closeDialog();
                    if (!resp) {
                        return;
                    }
                    vm.mailChanged = false;
                    window.oldMailAddress = vm.input;
                    vm.waitingOtp = vm.showRequireOtp();
                    vm.handleOtpVerify({ response: resp });
                },
                function (err) {
                    otpService.closeDialog();
                    retryOTP(err.validateRequest);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('notificationCenter', notificationCenter)
        .directive("whenScrolled", function () {
            return function (scope, elm, attr) {
                var raw = elm[0];
                elm.bind('scroll', function () {
                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                        scope.$apply(attr.whenScrolled);
                    }
                });
            };
        })
        .filter('notificationType', function () {
            return function (notifications, type, onlyUnread) {
                if (notifications)
                    switch (type) {
                        case -1:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 : n.key !== 50);
                        case 60:
                        case 70:
                        case 80:
                        case 90:
                        case 100:
                        case 110:
                        case 120:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 &&
                                (n.key === 60 || n.key === 70 || n.key === 80 || n.key === 90 || n.key === 100 || n.key === 110 ||
                                    n.key === 120) :
                                n.key !== 50 &&
                                (n.key === 60 || n.key === 70 || n.key === 80 || n.key === 90 || n.key === 100 || n.key === 110 ||
                                    n.key === 120));
                        default:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 && n.key === type :
                                n.key !== 50 && n.key === type);
                    }
            };
        });

    function notificationCenter() {
        var directive = {
            templateUrl: '/app/common/notification-center.html',
            scope: {
                input: '=',
                toggle: '=',
                isvisible: '='
            },
            restrict: 'EA',
            controller: notificationCenterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

    notificationCenterController.$inject = ['$scope', 'notificationService', 'userSvc', '$state', '$rootScope',
        '$window', '$timeout', '$interval'];
    function notificationCenterController($scope, notificationService, userSvc, $state, $rootScope,
        $window, $timeout, $interval) {
        var vm = this;
        vm.notifications = notificationService.notifications;
        vm.onlyUnread = false;

        vm.selectedTabId = -1;
        vm.changeTab = function (tabId) {
            vm.selectedTabId = tabId;

            // When switching to Beamer tab (80), apply dark mode if needed
            if (tabId === 80) {
                $timeout(function () {
                    applyBeamerDarkMode();
                }, 500);
            }
        };
        notificationService.params.page = 1;

        // Function to inject dark mode CSS into Beamer iframe
        function applyBeamerDarkMode() {
            var isDarkMode = localStorage.getItem('darkMode') === 'true';
            if (!isDarkMode) return;

            var beamerIframe = document.querySelector('.beamer-panel iframe');
            if (!beamerIframe) {
                // Retry if iframe not loaded yet
                var retryCount = 0;
                var retryInterval = $interval(function () {
                    beamerIframe = document.querySelector('.beamer-panel iframe');
                    retryCount++;

                    if (beamerIframe || retryCount > 10) {
                        $interval.cancel(retryInterval);
                        if (beamerIframe) {
                            injectDarkModeCSS(beamerIframe);
                        }
                    }
                }, 200);
                return;
            }

            injectDarkModeCSS(beamerIframe);
        }

        function injectDarkModeCSS(iframe) {
            try {
                var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                if (!iframeDoc) return;

                // Check if CSS already injected
                if (iframeDoc.getElementById('endeksa-dark-mode-injection')) return;

                var style = iframeDoc.createElement('style');
                style.id = 'endeksa-dark-mode-injection';
                style.textContent = `
                    /* Endeksa Dark Mode Injection for Beamer */
                    body {
                        background-color: #1e1e1e !important;
                        color: #ccc !important;
                    }

                    /* Headers */
                    h1, h2, h3, h4, h5, h6 {
                        color: #fff !important;
                    }

                    /* Cards/Posts */
                    .post, .beamer-post, [class*="post"] {
                        background-color: #2a2a2a !important;
                        border-color: rgba(80, 80, 80, 0.3) !important;
                    }

                    /* Links */
                    a {
                        color: #58B1FF !important;
                    }

                    /* Buttons */
                    button, .button {
                        background-color: #3a3a3a !important;
                        color: #fff !important;
                        border-color: rgba(80, 80, 80, 0.5) !important;
                    }

                    /* Input fields */
                    input, textarea, select {
                        background-color: #1a1a1a !important;
                        color: #ccc !important;
                        border-color: rgba(80, 80, 80, 0.5) !important;
                    }

                    /* Scrollbar */
                    ::-webkit-scrollbar-thumb {
                        background: rgba(255, 255, 255, 0.2) !important;
                    }

                    ::-webkit-scrollbar-track {
                        background: rgba(0, 0, 0, 0.2) !important;
                    }
                `;

                iframeDoc.head.appendChild(style);
                console.log('Beamer dark mode CSS injected successfully');
            } catch (e) {
                // Cross-origin iframe - can't inject CSS
                console.warn('Cannot inject CSS into Beamer iframe (cross-origin):', e);
            }
        }

        // Listen for dark mode changes
        $scope.$on('darkMode:changed', function (event, data) {
            if (vm.selectedTabId === 80) {
                if (data.enabled) {
                    applyBeamerDarkMode();
                } else {
                    // Remove injected CSS
                    var beamerIframe = document.querySelector('.beamer-panel iframe');
                    if (beamerIframe) {
                        try {
                            var iframeDoc = beamerIframe.contentDocument || beamerIframe.contentWindow.document;
                            var injectedStyle = iframeDoc.getElementById('endeksa-dark-mode-injection');
                            if (injectedStyle) {
                                injectedStyle.remove();
                            }
                        } catch (e) {
                            console.warn('Cannot remove CSS from Beamer iframe:', e);
                        }
                    }
                }
            }
        });

        $scope.$on('nc_visible', function () {
            if (userSvc.info.Id) {
                vm.signedIn = true;
                notificationService.params.page = 1;
                notificationService.getNotifications();
            } else {
                vm.signedIn = false;
                vm.selectedTabId = 80;
            }
        });

        $scope.$on('nc_visible_80', function () {
            vm.selectedTabId = 80;
        });

        vm.loadMore = function () {
            notificationService.params.page++;
            notificationService.list({ page: notificationService.params.page, itemsPerPage: notificationService.params.itemsPerPage }).then(function (result) {
                let notifications = result.map(function (n) {
                    let utc = new Date(n.createdDate);
                    var offset = utc.getTimezoneOffset($rootScope.lang);
                    var local = new Date(utc.getTime() - offset * 60000);
                    n.createdDate = local;
                    return n;
                });
                notificationService.notifications = notificationService.notifications.concat(notifications);
                vm.notifications = notificationService.notifications;
            });
        };

        vm.goToProfile = function () {
            $state.go('profile.company', { langcode: window.lang });
            vm.toggle();
        };

        vm.redirect = function (notification) {
            if (!notification.isRead)
                notificationService.read(notification);

            let agentName;
            switch (notification.key) {
                case 10:
                    $state.go('blogDetail', { name: notification.value, refresh: true, langcode: $window.lang }, { reload: true });
                    break;
                case 20:
                    $state.go("analysis.country.alarm", { idm: notification.value, langcode: $window.lang, country: 'world' }, { reload: true });
                    break;
                case 40:
                    let user = userSvc.info;
                    agentName = $rootScope.agentAddress(user);
                    $state.go("agent-detail", { langcode: $window.lang, id: user.Id, name: agentName });
                    break;
                case 60:
                case 80:
                case 100:
                case 110:
                case 120:
                    $state.go("lead", { langcode: $window.lang, id: notification.value });
                    break;
                case 130:
                    let propertyValue = JSON.parse(notification.value);
                    $state.go("property-detail",
                        {
                            langcode: $window.lang,
                            id: propertyValue.PropertyId,
                            name: $rootScope.normalizeAddress(propertyValue.PropertyTitle)
                        });
                    break;
                case 70:
                case 90:
                    let value = JSON.parse(notification.value);
                    agentName = $rootScope.agentAddress({ Details: { profile: { name: value.AgentName, surName: value.AgentSurname } } });
                    $state.go("agent-detail", { langcode: $window.lang, id: value.AgentId, name: agentName });
                    break;

                case 300:
                    $state.go("order-payment", { orderId: $rootScope.upcomingPayment.paymentOrderId, paymentPrice: $rootScope.upcomingPayment.unpaidPrice });
                    break;

            }
            vm.toggle();
        };

        vm.readAll = function () {
            notificationService.readAll();
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('provinceCountyDistrict', provinceCountyDistrict);

    function provinceCountyDistrict() {
        var directive = {
            templateUrl: '/app/common/province-county-district.html',
            scope: {
                input: '=',
                // selected : '=',
                isrequired: '=',
                // defaultval:'=',
                // minval: '<',
                // maxval: '<',
                // iszero: '@',
                // placeholder: '@',
                // label: '@',
                isdisabled: '=',
                // nullError: '=',
                // errorText: '@',
                // incrementRate: '<',
                // style: '@'
            },
            restrict: 'EA',
            controller: provinceCountyDistrictController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

    provinceCountyDistrictController.$inject = ['provinceListService', '$scope'];
    function provinceCountyDistrictController(provinceListService, $scope) {
        var vm = this;

        vm.selected = {};

        vm.selectCountry = (country) => {
            vm.input.geoIds.countryId = country.CountryId;
            vm.input.geoNames.countryName = country.CountryName;
            loadCities();
        }

        vm.selectCity = (city) => {
            vm.input.geoIds.cityId = city.CityId;
            vm.input.geoNames.cityName = city.CityName;
            loadCounties();
        }

        vm.selectCounty = (county) => {
            if (county) {
                vm.input.geoIds.countyId = county.CountyId;
                vm.input.geoNames.countyName = county.CountyName;
                loadDistricts();
            }
        }

        vm.selectDistrict = (district) => {
            if (district) {
                vm.input.geoIds.districtId = district.DistrictId;
                vm.input.geoNames.districtName = district.DistrictName;
            }
        }

        const loadCities = () => {
            provinceListService.getProvinces(vm.selected.country.CountryId).then(function (response) { vm.Cities = response.List; });
        }

        const loadCounties = () => {
            provinceListService.CountiesOfProvince(vm.selected.country.CountryId, vm.selected.city.CityId).then(function (response) { vm.Counties = response.List; });
        }

        const loadDistricts = function () {
            if (vm.selected.city && vm.selected.county) {
                provinceListService.NeighbourhoodsOfCounty(vm.selected.country.CountryId, vm.selected.city.CityId, vm.selected.county.CountyId).then(function (response) { vm.Districts = response.List; });
            }
        }

        vm.countryOptions = [
            {CountryName:'Türkiye', CountryId: 1},
            {CountryName:'İspanya', CountryId: 2},
            {CountryName:'Portekiz', CountryId: 3}
        ];

        const fillInputs = () => {
            if (vm.input.geoNames && vm.input.geoNames.countryName) {
                vm.selected.country = vm.countryOptions.find(c => c.CountryName === vm.input.geoNames.countryName);
                if (!vm.selected.country) return;
            } else {
                // Old records may carry city/county ids without a country name; they are Türkiye-era data.
                vm.selected.country = vm.countryOptions[0];
                vm.input.geoNames = vm.input.geoNames || {};
                vm.input.geoIds.countryId = vm.selected.country.CountryId;
                vm.input.geoNames.countryName = vm.selected.country.CountryName;
            }

            provinceListService.getProvinces(vm.selected.country.CountryId).then(citiesList => {
                vm.Cities = citiesList.List;
                vm.selected.city = citiesList.List.find(city => city.CityId === vm.input.geoIds.cityId);
                if (!vm.selected.city) return;
                provinceListService.CountiesOfProvince(vm.selected.country.CountryId, vm.selected.city.CityId).then(response => {
                    vm.Counties = response.List;
                    vm.selected.county = response.List.find(county => county.CountyId === vm.input.geoIds.countyId);
                    if (!vm.selected.county) return;
                    provinceListService.NeighbourhoodsOfCounty(vm.selected.country.CountryId, vm.selected.city.CityId, vm.selected.county.CountyId).then(res => {
                        vm.Districts = res.List;
                        vm.selected.district = res.List.find(district => district.DistrictId === vm.input.geoIds.districtId);
                    });
                });
            });
        }

        // county/district may be missing on old records; show whatever location data exists.
        const unwatchInput = $scope.$watch(() => vm.input && vm.input.geoIds, geoIds => {
            if (geoIds && geoIds.cityId) {
                unwatchInput();
                fillInputs();
            }
        });
    }
})();
(function () {
    'use strict';
    angular.module('app.common')
        .directive('opportunityCard', [function () {
            var directive = {
                templateUrl: '/app/common/opportunity-card.html',
                scope: {
                    opportunity: '<',
                    ordering: '<'
                },
                restrict: 'EA',
                bindToController: false,
                replace: false,
            };
            return directive;
        }]);
})();
(function () {
    'use strict';
    angular.module('app.common')
        .directive('agentCard', ['$timeout', function ($timeout) {
            var directive = {
                templateUrl: '/app/common/agent-card.html',
                scope: {
                    agent: '<'
                },
                restrict: 'EA',
                // bindToController: false,
                replace: false, 
                // priority: 1000, //this setting is important, see explanation below
                link: function(scope, element, attrs) {
                    scope.star = function (id, value) {
                        $timeout(function () {
                            var name = "#starRating" + id;
                            $(name).barrating({
                                theme: "fontawesome-stars",
                                readonly: true,
                                initialRating: value,
                                allowEmpty: true,
                                emptyValue: 0
                            });
                            $("a[data-rating-value='? undefined:undefined ?']").hide();
                        }, 0);
                    };

                    scope.region = scope.agent.Regions.length > 1 ? 
                        scope.agent.Regions.find((f) => f.isManuelRegion === false) :
                        scope.agent.Regions[0]
                }
            };
            return directive;
        }]);
})();
/**
 * Offline Indicator Directive
 * Shows connection status
 */
(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('offlineIndicator', offlineIndicator);

    offlineIndicator.$inject = ['$timeout', 'pwaSvc'];

    function offlineIndicator($timeout, pwaSvc) {
        return {
            restrict: 'E',
            template: `
                <div class="pwa-offline-indicator" ng-class="{online: isOnline, 'pwa-show': !isOnline}">
                    <span class="status-dot"></span>
                    <span ng-if="!isOnline">Çevrimdışı</span>
                    <span ng-if="isOnline">Çevrimiçi</span>
                </div>
            `,
            link: function (scope, element, attrs) {
                scope.isOnline = pwaSvc.isOnline;

                // Listen for online/offline events
                scope.$on('pwa:online', function () {
                    scope.isOnline = true;

                    // Auto-hide after 3 seconds when back online
                    $timeout(function () {
                        element.find('.pwa-offline-indicator').removeClass('pwa-show');
                    }, 3000);
                });

                scope.$on('pwa:offline', function () {
                    scope.isOnline = false;
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('ecFileDrop', ecFileDrop)
        .directive('ecFileSelect', ecFileSelect);

    /**
     * File Drop Directive
     * Handles drag and drop file uploads without using angular.element().scope()
     * which doesn't work in production builds.
     *
     * Usage:
     * <div ec-file-drop
     *      on-drop="handleDrop($files)"
     *      on-drag-over="handleDragOver()"
     *      on-drag-leave="handleDragLeave()">
     * </div>
     */
    function ecFileDrop() {
        return {
            restrict: 'A',
            scope: {
                onDrop: '&',
                onDragOver: '&',
                onDragLeave: '&'
            },
            link: function (scope, element) {
                element.on('dragover', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (scope.onDragOver) {
                        scope.$apply(function () {
                            scope.onDragOver();
                        });
                    }
                });

                element.on('dragleave', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (scope.onDragLeave) {
                        scope.$apply(function () {
                            scope.onDragLeave();
                        });
                    }
                });

                element.on('drop', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var files = event.originalEvent ?
                        event.originalEvent.dataTransfer.files :
                        event.dataTransfer.files;

                    if (scope.onDrop && files.length > 0) {
                        scope.$apply(function () {
                            scope.onDrop({ $files: files });
                        });
                    }
                });

                // Cleanup
                scope.$on('$destroy', function () {
                    element.off('dragover dragleave drop');
                });
            }
        };
    }

    /**
     * File Select Directive
     * Handles file input change events without using angular.element().scope()
     * which doesn't work in production builds.
     *
     * Usage:
     * <input type="file" ec-file-select on-select="handleFileSelect($files)">
     */
    function ecFileSelect() {
        return {
            restrict: 'A',
            scope: {
                onSelect: '&'
            },
            link: function (scope, element) {
                element.on('change', function (event) {
                    var files = event.target.files;

                    if (scope.onSelect && files && files.length > 0) {
                        scope.$apply(function () {
                            scope.onSelect({ $files: files });
                        });
                    }

                    // Reset input so same file can be selected again
                    element.val('');
                });

                // Cleanup
                scope.$on('$destroy', function () {
                    element.off('change');
                });
            }
        };
    }
})();

/**
 * Centralized Lazy Loading Service
 * Manages all code-splitting and lazy loading logic
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('lazyLoadSvc', lazyLoadSvc);

    lazyLoadSvc.$inject = [];

    function lazyLoadSvc() {
        var version = window.appVersion || '1.0.0';

        // Bundle configuration - centralized!
        var bundles = {
            // Blog module
            blog: {
                css: [
                    '/assets/css/main.blog.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Blog editor (heavier - separate bundle)
            blogEditor: {
                css: [
                    '/assets/css/main.blog.min.css?v=' + version,
                    '/assets/css/vendor.summernote.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Blog detail (blog + content CSS for richer layout)
            blogDetail: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/main.blog.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Admin module
            admin: {
                css: [
                    "/assets/css/vendor.summernote.min.css?v=" + version,
                    "/assets/css/vendor.rzslider.min.css?v=" + version,
                    "/assets/css/vendor.payment.min.css?" + version,
                    "/assets/css/main.payment.min.css?" + version,
                    "/assets/css/main.admin.min.css?" + version,
                    "/assets/css/main.profile.min.css?" + version
                ],
                js: [
                    "/assets/js/vendor.phone.min.js?v=" + version,  // Phone validation
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    "/assets/js/vendor.gantt.min.js?v=" + version,  // Gantt chart library (from frappe-gantt)
                    "/assets/js/vendor.summernote.min.js?v=" + version,
                    "/assets/js/vendor.rzslider.min.js?v=" + version,
                    "/assets/js/vendor.result.min.js?v=" + version,
                    "/assets/js/vendor.payment.min.js?v=" + version,
                    "/assets/js/vendor.upload.min.js?v=" + version,
                    "/assets/js/main.payment.min.js?v=" + version,
                    "/assets/js/vendor.chart.min.js?v=" + version,
                    "/assets/js/main.admin.min.js?v=" + version
                ],
            },

            // Valuation module (residential, commercial, field, land)
            valuation: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    '/assets/js/main.valuation.min.js?v=' + version,

                ]
            },

            // Commercial valuation (needs turf.js for polygon calculations)
            valuationCommercial: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    '/assets/js/main.valuation.min.js?v=' + version
                ]
            },

            // Valuation wrapper (simplified valuation selector)
            valuationWrapper: {
                css: [
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    '/assets/js/main.wrap.min.js?v=' + version
                ]
            },

            // Regional analysis - Main layout (loaded by abstract state)
            regionalAnalysis: {
                css: [
                    '/assets/css/introjs.min.css?v=' + version,
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.analysis.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll directive)
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters on value tab
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.intro.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.region.min.js?v=' + version,
                    '/assets/js/vendor.analysis.min.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version
                ]
            },

            // Regional analysis - Wizard (for alarm/notification setup)
            regionalAnalysisMember: {
                css: ["/assets/css/vendor.rzslider.min.css?v=" + version],
                js: [
                    "/assets/js/vendor.rzslider.min.js?v=" + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.phone.min.js?v=' + version
                ]
            },

            // Regional analysis + turf.js (for premium+ users)
            regionalAnalysisPremium: {
                css: [],
                js: [
                    '/assets/js/turf.min.js?v=' + version
                ]
            },

            // Regional analysis + advanced features (for platinum/real-estate users)
            regionalAnalysisPlatinum: {
                css: [
                    '/assets/css/vendor.analysis2.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.analysis2.min.js?v=' + version
                ]
            },
            // Regional analysis - Charts only (for child routes)
            regionalAnalysisCharts: {
                css: [],
                js: [
                    '/assets/js/vendor.chart.min.js?v=' + version
                ]
            },



            // Regional analysis - Listings (opportunity pages)
            regionalAnalysisListings: {
                css: [
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/simplify.min.js?v=' + version
                ]
            },

            // Regional analysis - Competition/Locations (premium feature)
            regionalAnalysisCompetition: {
                css: [],
                js: [
                    '/assets/js/vendor.analysis3.min.js?v=' + version
                ]
            },

            // Regional analysis - Transportation (needs Google Maps)
            regionalAnalysisTransport: {
                css: [],
                js: function () {
                    var lang = window.lang || 'en';
                    return [
                        'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + lang.split('-')[0]
                    ];
                }
            },

            // Leaflet maps
            leaflet: {
                css: [
                    '/assets/css/vendor.leaflet.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.leaflet.min.js?v=' + version
                ]
            },

            // Payment module
            payment: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version
                ],
            },

            // Payment with external auth (Apple ID)
            paymentExternal: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version
                ]
            },

            // Sales/Order payment (payment + admin components)
            salesPayment: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version,
                    '/assets/css/main.admin.min.css?v=' + version,
                    '/assets/css/main.profile.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version,
                    '/assets/js/main.admin.min.js?v=' + version
                ]
            },

            // Profile module
            profile: {
                css: [
                    '/assets/css/vendor.summernote.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.profile.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters on value tab
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone validation
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.profile.min.js?v=' + version,
                    '/assets/js/main.security.min.js?v=' + version
                ],
            },

            // Profile billing (needs payment libs)
            profileBilling: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version
                ]
            },

            // Profile company (needs results lib)
            profileCompany: {
                css: [],
                js: [
                    '/assets/js/vendor.result.min.js?v=' + version
                ]
            },

            // Landing page (homepage with maps and charts)
            landing: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-landing.min.js?v=' + version
                ]
            },
            // Security module (auth pages)
            security: {
                css: [],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone validation (register page)
                    '/assets/js/main.security.min.js?v=' + version
                ],
                serie: true
            },

            // Security with external auth (Apple ID, Google, etc.)
            securityExternal: {
                css: [],
                js: [
                    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                    '/assets/js/main.security.min.js?v=' + version,
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                ]
            },

            // Content pages (about, contact, how, etc.)
            contentPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-about.min.js?v=' + version
                ]
            },

            // Legal pages (terms, privacy, etc.)
            legalPages: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/main.content.min.js?v=' + version
                ]
            },

            // Services pages (with charts and content)
            servicesPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-services.min.js?v=' + version
                ]
            },

            // Products pages
            productsPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-products.min.js?v=' + version
                ]
            },

            // Solutions pages (with charts and maps)
            solutionsPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/vendor.chart.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll directive)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-users.min.js?v=' + version
                ]
            },

            // Services region page (needs maps)
            servicesRegion: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version
                ],
                js: [
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version
                ]
            },

            // Property detail page
            property: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/main.property.min.js?v=' + version
                ]
            },

            // Agent detail page (with maps and charts)
            agents: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version,
                    '/assets/css/main.agents.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.agents.min.js?v=' + version
                ]
            },

            // Bank integration page
            bank: {
                css: [],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/main.bank.min.js?v=' + version
                ]
            },

            // Geocoding/Address validation
            geocoding: {
                css: [
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.geocoding.min.js?v=' + version
                ]
            },

            // Lead/History page (similar to agents)
            leadHistory: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.history.min.js?v=' + version
                ]
            },

            // Projects detail page
            projects: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.projects.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.projects.min.js?v=' + version
                ]
            },

            // Malls detail page
            malls: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.projects.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.malls.min.js?v=' + version
                ]
            },

            // Local information/properties (listing)
            localInfo: {
                css: [
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.listing.min.js?v=' + version
                ]
            },

            // Neighbourhood detail page
            neighbourhood: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.neighbourhood.min.css?v=' + version
                ],
                js: [
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.neighbourhood.min.js?v=' + version
                ]
            },

            // Report verification page
            report: {
                css: [],
                js: [
                    '/assets/js/main.report.min.js?v=' + version
                ]
            },

            // Opportunity/listing pages
            opportunity: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.result.min.css?v=' + version,
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.result.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.result.min.js?v=' + version
                ]
            },

            // Share portfolio page
            share: {
                css: [
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/main.share.min.js?v=' + version
                ]
            },

            // Property detail (valuation results) - heavy with all features
            propertyDetail: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.summernote.min.css?v=' + version,
                    '/assets/css/vendor.result.min.css?v=' + version,
                    '/assets/css/introjs.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.result.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.intro.min.js?v=' + version,
                    '/assets/js/vendor.result.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.result.min.js?v=' + version
                ]
            },

            // Mortgage application
            mortgage: {
                css: [],
                js: [
                    'https://www.google.com/recaptcha/api.js?render=6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS',
                    '/assets/js/main.mortgage.min.js?v=' + version
                ]
            }
        };

        // Service API
        var service = {
            load: load,
            loadBundle: loadBundle,
            loadBundles: loadBundles,
            preload: preload
        };

        return service;

        ////////////////

        /**
         * Main lazy load function - use in route resolves
         * @param {object} $transition$ - UI Router transition
         * @param {string|array} bundleNames - Bundle name(s) to load
         * @param {object} options - Additional options
         */
        function load($transition$, bundleNames, options) {
            var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
            var $q = $transition$.injector().get('$q');

            options = options || {};

            // Ensure ngAnimate is available if needed
            if (options.animate !== false) {
                try {
                    $transition$.injector().get('$$animateJs');
                    $ocLazyLoad.inject('ngAnimate');
                } catch (e) {
                    // ngAnimate not needed or already loaded
                }
            }

            // Convert single bundle to array
            if (typeof bundleNames === 'string') {
                bundleNames = [bundleNames];
            }

            // Load all bundles
            var promises = bundleNames.map(function (bundleName) {
                return loadBundleInternal($ocLazyLoad, bundleName, options);
            });

            return $q.all(promises);
        }

        /**
         * Load a single bundle
         */
        function loadBundle($ocLazyLoad, bundleName, options) {
            return loadBundleInternal($ocLazyLoad, bundleName, options);
        }

        /**
         * Load multiple bundles
         */
        function loadBundles($ocLazyLoad, bundleNames, options) {
            var $q = angular.injector(['ng']).get('$q');
            var promises = bundleNames.map(function (name) {
                return loadBundleInternal($ocLazyLoad, name, options);
            });
            return $q.all(promises);
        }

        /**
         * Preload bundles in the background (low priority)
         */
        function preload(bundleNames) {
            if (!window.requestIdleCallback) {
                return; // Browser doesn't support, skip preloading
            }

            window.requestIdleCallback(function () {
                bundleNames.forEach(function (bundleName) {
                    var bundle = bundles[bundleName];
                    if (!bundle) return;

                    // Preload CSS
                    var css = typeof bundle.css === 'function' ? bundle.css() : bundle.css;
                    css.forEach(function (href) {
                        var link = document.createElement('link');
                        link.rel = 'preload';
                        link.as = 'style';
                        link.href = href;
                        document.head.appendChild(link);
                    });

                    // Preload JS
                    var js = typeof bundle.js === 'function' ? bundle.js() : bundle.js;
                    js.forEach(function (src) {
                        if (src.startsWith('js!')) {
                            src = src.substring(3);
                        }
                        var link = document.createElement('link');
                        link.rel = 'preload';
                        link.as = 'script';
                        link.href = src;
                        document.head.appendChild(link);
                    });
                });
            });
        }

        /**
         * Internal bundle loader
         */
        function loadBundleInternal($ocLazyLoad, bundleName, options) {
            options = options || {};
            var bundle = bundles[bundleName];

            if (!bundle) {
                console.warn('Bundle not found:', bundleName);
                return $ocLazyLoad.load([]); // Return resolved promise
            }

            var css = typeof bundle.css === 'function' ? bundle.css() : bundle.css;
            var js = typeof bundle.js === 'function' ? bundle.js() : bundle.js;

            // Load CSS first (non-blocking)
            if (css && css.length) {
                $ocLazyLoad.load(css);
            }

            // Load JS (blocking)
            if (js && js.length) {
                return $ocLazyLoad.load({
                    serie: options.serie !== undefined ? options.serie : false,
                    files: js,
                    insertBefore: options.insertBefore || '#last_script',
                    cache: options.cache !== undefined ? options.cache : true
                });
            }

            // No JS to load, return resolved promise
            return $ocLazyLoad.load([]);
        }
    }
})();

/**
 * Route Configuration Helpers
 * Reduces duplication in route configs
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('routeHelpers', routeHelpers);

    routeHelpers.$inject = ['lazyLoadSvc'];

    function routeHelpers(lazyLoadSvc) {
        var service = {
            // Lazy load helper
            lazyLoad: createLazyLoader,

            // Translation helper
            loadTranslations: loadTranslations,

            // Language protection helpers
            langProtect: langProtectResolve,
            langProtectTwoPath: langProtectTwoPathResolve,

            // Common resolves
            resolves: {
                hasPackage: hasPackageResolve,
                guardRole: guardRoleResolve,
                langProtect: langProtectResolve,
                langProtectTwoPath: langProtectTwoPathResolve
            }
        };

        return service;

        ////////////////

        /**
         * Create a lazy loader function for routes
         * @param {string|array} bundles - Bundle name(s) to load
         * @param {object} options - Additional options
         */
        function createLazyLoader(bundles, options) {
            return function($transition$) {
                return lazyLoadSvc.load($transition$, bundles, options);
            };
        }

        /**
         * Load translation parts
         * @param {string|array} parts - Translation part name(s)
         */
        function loadTranslations(parts) {
            if (typeof parts === 'string') {
                parts = [parts];
            }

            return ['$translatePartialLoader', '$translate', function($translatePartialLoader, $translate) {
                parts.forEach(function(part) {
                    $translatePartialLoader.addPart(part);
                });
                return $translate.refresh();
            }];
        }

        /**
         * Check if user has package
         */
        function hasPackageResolve() {
            return ['guardSvc', function(guardSvc) {
                return guardSvc.hasPackage();
            }];
        }

        /**
         * Guard route by role
         * @param {array} roles - Allowed role IDs
         */
        function guardRoleResolve(roles) {
            return ['guardSvc', function(guardSvc) {
                return guardSvc.guardRouteRole(roles);
            }];
        }

        /**
         * Language path protection (redirects to correct lang path)
         * For simple single-path routes
         * @param {string} stateNameKey - Optional translation key, defaults to state name
         */
        function langProtectResolve(stateNameKey) {
            return ['$transition$', '$translate', '$rootScope', '$timeout',
                function($transition$, $translate, $rootScope, $timeout) {
                    var path = $transition$.params().path;
                    var lang = $transition$.params().langcode;
                    var device = $transition$.params().device;

                    return $translate(stateNameKey || $transition$.to().name, {}, undefined, undefined, lang)
                        .then(function(translation) {
                            if (path !== translation) {
                                $timeout(function() {
                                    $rootScope.MetaTags.prerender.statusCode = 301;
                                    var newParams = { path: translation, langcode: lang };
                                    if (device !== undefined) {
                                        newParams.device = device;
                                    }
                                    var newUrl = $transition$.router.stateService.href(
                                        $transition$.to().name,
                                        angular.extend({}, $transition$.params(), newParams)
                                    );
                                    window.redirected = "Location: " + newUrl;
                                    $rootScope.MetaTags.prerender.header = window.redirected;
                                }, 0);

                                $transition$.abort();

                                var params = { path: translation, langcode: lang };
                                if (device !== undefined) {
                                    params.device = device;
                                }

                                $transition$.router.stateService.go(
                                    $transition$.to().name,
                                    angular.extend({}, $transition$.params(), params)
                                );
                            }
                        });
                }];
        }

        /**
         * Language path protection for nested states with two paths
         * For routes like: /services/automated-valuation (path + path2)
         */
        function langProtectTwoPathResolve() {
            return ['$transition$', '$translate', function($transition$, $translate) {
                var path = $transition$.params().path;
                var path2 = $transition$.params().path2;
                var lang = $transition$.params().langcode;
                var ad = $transition$.params().ad;
                var promo = $transition$.params().promo;

                // Check first path (parent state)
                return $translate($transition$.to().name.split('.')[0], {}, undefined, undefined, lang)
                    .then(function(translation) {
                        var redirect = 0;
                        if (path !== translation) {
                            path = translation;
                            redirect = 1;
                        }

                        // Check second path (child state)
                        return $translate($transition$.to().name.split('.')[1], {}, undefined, undefined, lang)
                            .then(function(translation2) {
                                if (path2 !== translation2) {
                                    path2 = translation2;
                                    redirect = 1;
                                }

                                if (redirect) {
                                    $transition$.abort();

                                    var params = {
                                        path: path,
                                        path2: path2,
                                        langcode: lang
                                    };

                                    // Preserve optional params
                                    if (ad !== undefined) params.ad = ad;
                                    if (promo !== undefined) params.promo = promo;

                                    $transition$.router.stateService.go(
                                        $transition$.to().name,
                                        params
                                    );
                                }
                            });
                    });
            }];
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'paymentService';

    angular.module('app.common')
        .factory(serviceId, paymentService);

    paymentService.$inject = ['$rootScope', '$state', 'ngDialog', '$q', 'userSvc', 'notifierSvc', 'guardSvc', '$translate', 'products_factory', 'report_factory', '$ocLazyLoad'];

    function paymentService($rootScope, $state, ngDialog, $q, userSvc, notifierSvc, guardSvc, $translate, products_factory, report_factory, $ocLazyLoad) {
        var obj = {
            basket: {
                orderId: undefined,
                userId: userSvc.info.Id,
                orderDetails: {
                    "promoCode": undefined,
                    "products": [],
                    "currency": 1,
                    "installmentCount": 1,
                    "installmentType": 10
                },
                billingInformation: {
                    "addressName": undefined,
                    "name": undefined,
                    "surName": undefined,
                    "email": undefined,
                    "title": undefined,
                    "details": undefined,
                    "isCommercial": false,
                    "taxName": undefined,
                    "taxNumber": undefined,
                    "telephone": undefined,
                    "geoIds": {
                        "countryId": undefined,
                        "cityId": undefined,
                        "countyId": undefined,
                        "districtId": undefined
                    },
                    "geoNames": {
                        "countryName": "",
                        "cityName": "",
                        "countyName": "",
                        "districtName": ""
                    }
                },
                options: {
                    "activateWhenPaymentCompleted": true,
                    "paymentDueDate": undefined,
                    "discount": 0,
                    "startDate": undefined
                },
                card: {
                    "cardId": undefined,
                    "details": {
                        "holderName": "",
                        "number": "",
                        "expireMonth": "",
                        "expireYear": "",
                        "cvc": ""
                    }
                },
                paymentProcessType: 10,
            },
            idNumberValidate: idNumberValidate,
            taxNumberValidate: taxNumberValidate,
            calculatePrice: calculatePrice,
            buyElectronicReport: buyElectronicReport,
            buyReportFromPropertyDetail: buyReportFromPropertyDetail,
            buyReportFromPropertyDetailAdmin: buyReportFromPropertyDetailAdmin,
            preparePayment: preparePayment,
            getProducts: getProducts,
            getProductsForFilter: getProductsForFilter,
            addToCart: addToCart,
            clearCart: clearCart,
            changePricesByCurrency: changePricesByCurrency,
            isPreparing: false
        };


        var savedCard = localStorage.getItem('shopingCard');

        try {
            obj.basket = savedCard ? JSON.parse(savedCard) : obj.basket;
        }
        catch (err) {
            localStorage.removeItem('shopingCard');
            obj.basket = obj.basket;
        }
        return obj;


        function clearCart() {
            localStorage.removeItem('shopingCard');
            obj.basket.billingInformation = {
                "addressName": undefined,
                "name": undefined,
                "surName": undefined,
                "email": undefined,
                "title": undefined,
                "details": undefined,
                "isCommercial": false,
                "taxName": undefined,
                "taxNumber": undefined,
                "telephone": undefined,
                "geoIds": {
                    "countryId": undefined,
                    "cityId": undefined,
                    "countyId": undefined,
                    "districtId": undefined
                },
                "geoNames": {
                    "cityName": "",
                    "countyName": "",
                    "districtName": "",
                    "countryName": "Türkiye"
                }
            };
            obj.basket.orderDetails = {
                "promoCode": undefined,
                "products": [],
                "currency": 1,
                "installmentCount": 1
            };
            obj.basket.card = {};
            obj.basket.card.details = {
                cvc: undefined,
                expire: undefined,
                expireMonth: undefined,
                expireYear: undefined,
                holderName: undefined,
                number: undefined
            };
        }

        function buyElectronicReport(product, house, isRent, selectedValuation = 0, adminReport = false) {
            var deffered = $q.defer();
            if (obj.isPreparing) {
                notifierSvc.show({ title: $translate.instant('payment_edr1'), message: $translate.instant('payment_edr2'), type: "info" });
                deffered.resolve(false);
                return false;
            }
            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package",
                "location-package",
            ]).then(function (HasPackage) {
                $ocLazyLoad.load(['/assets/css/main.payment.min.css']).then(function () {
                    ngDialog.open({
                        templateUrl: 'app/payment/edr-form.html',
                        showClose: false,
                        controller: ['$scope', '$timeout', 'LocaleService', 'endeksService', 's3Files', '$q', 'fileDragService', 'notifierSvc', '$translate', 'ngDialog', function ($scope, $timeout, LocaleService, endeksService, s3Files, $q, fileDragService, notifierSvc, $translate, ngDialog) {
                            $scope.house = house;
                            $scope.CountryId = house.CountryId;
                            $scope.userReportType = { WithDetail: HasPackage || (product.code === 'edr-commercial') };
                            $scope.HasPackage = HasPackage;
                            $scope.ValuationMethod = selectedValuation;
                            function getFileCategoryByType(file) {
                                if (file.FileType === 10) return 'image';
                                if (file.FileType === 20) return 'document';
                                return 'document';
                            }
                            function getFilesByCategory(category) {
                                return house.Files.filter(function (file) {
                                    return getFileCategoryByType(file) === category;
                                });
                            };

                            $scope.getFilesByCategory = getFilesByCategory;

                            // Initialize uploaded images and selected report files
                            $scope.uploadedImages = getFilesByCategory('image');
                            console.log($scope.uploadedImages, "uploadedImages");
                            $scope.selectedReportFiles = [];

                            // Drag & drop için state takibi - Service'ten oluşturuluyor
                            $scope.dragState = fileDragService.createDragState();
                            $scope.dragStateOverIndex = -1; // HTML'de kullanılıyor, dragState ile senkronize edilecek

                            // Log list event for dnd-draggable
                            $scope.logListEvent = function (action, index, external, type) {
                                fileDragService.logListEvent($scope.dragState, action, index, external, type);
                                $scope.dragStateOverIndex = $scope.dragState.dragStateOverIndex; // HTML için senkronize et
                            };

                            // Re-sort images for report - Service'ten çağrılıyor
                            $scope.reSortReportImages = function () {
                                var docList = getFilesByCategory('document');
                                fileDragService.reSortFiles($scope.uploadedImages, docList, function (files) {
                                    // Update house.Files
                                    $scope.house.Files = files;

                                    // Save to backend
                                    endeksService.changeFiles($scope.house.Id, files).then(function () {
                                        // Update uploadedImages after re-sort
                                        $scope.uploadedImages = files.filter(function (file) {
                                            return file.FileType === 10;
                                        });
                                    });
                                });
                            };

                            // Remove image from report
                            // Url bazlı karşılaştırma - Id henüz olmayabilir
                            $scope.removeReportImage = function (imageUrl) {
                                var index = $scope.house.Files.findIndex(function (file) {
                                    return file.Url === imageUrl;
                                });
                                if (index > -1) {
                                    $scope.house.Files.splice(index, 1);
                                    // Update uploadedImages after removal
                                    $scope.uploadedImages = getFilesByCategory('image');
                                    // Save to backend
                                    endeksService.changeFiles($scope.house.Id, $scope.house.Files);
                                }
                            };

                            // Confirm delete image
                            // Url bazlı karşılaştırma - Id henüz olmayabilir
                            $scope.confirmDeleteImage = function (imageUrl) {
                                ngDialog.openConfirm({
                                    template: '\
                                        <div class="modal-content modal-action-wrapper padding-10">\
                                            <div class="modal-body">\
                                                <div class="dark">\
                                                    <p><i class="ei-trash" style="color: #FF0550;"></i></p>\
                                                    <h4 translate="confirm_delete_image">Fotoğrafı silmek istediğinize emin misiniz?</h4>\
                                                </div>\
                                                <p class="text-center margin-top-40">\
                                                    <button ng-click="confirm()" type="button" class="btn btn-danger btn-md">\
                                                        <i class="ei-trash"></i>&nbsp;<span translate="delete">Sil</span>\
                                                    </button>\
                                                    <button ng-click="closeThisDialog()" type="button" class="btn btn-default btn-md">\
                                                        <span translate="cancel">Vazgeç</span>\
                                                    </button>\
                                                </p>\
                                            </div>\
                                        </div>',
                                    plain: true,
                                    className: 'ngdialog-theme-default',
                                    scope: $scope
                                }).then(function () {
                                    $scope.removeReportImage(imageUrl);
                                });
                            };

                            // Toggle image selection for report
                            $scope.toggleImageSelection = function (image) {
                                // Url bazlı karşılaştırma - Id henüz olmayabilir
                                var index = $scope.selectedReportFiles.findIndex(function (file) {
                                    return file.Url === image.Url;
                                });

                                if (index > -1) {
                                    $scope.selectedReportFiles.splice(index, 1);
                                } else {
                                    // Maksimum 6 resim seçilebilir
                                    if ($scope.selectedReportFiles.length >= 6) {
                                        notifierSvc.error($translate.instant('max_6_images_error'));
                                        return;
                                    }
                                    $scope.selectedReportFiles.push(image);
                                }
                            };

                            // Check if image is selected
                            $scope.isImageSelected = function (image) {
                                // Url bazlı karşılaştırma - Id henüz olmayabilir
                                return $scope.selectedReportFiles.some(function (file) {
                                    return file.Url === image.Url;
                                });
                            };

                            $scope.CoverImageType = 20;
                            $scope.PersonalMessage = null;
                            $scope.DedicationNote = null;
                            $scope.usePropertyNote = false;

                            // Capitalize first letter of each word (Turkish locale-aware)
                            $scope.capitalizeDedicationNote = function () {
                                if ($scope.DedicationNote) {
                                    // Use Turkish locale for proper i/İ and I/ı handling
                                    $scope.DedicationNote = $scope.DedicationNote
                                        .toLocaleLowerCase('tr-TR')
                                        .replace(/(?:^|\s)\S/g, function (char) {
                                            return char.toLocaleUpperCase('tr-TR');
                                        });
                                }
                            };

                            // Property note toggle
                            $scope.propertyNote = house.Note || '';
                            $scope.togglePropertyNote = function () {
                                // Toggle the checkbox manually
                                $scope.usePropertyNote = !$scope.usePropertyNote;

                                // Update the message based on new state
                                if ($scope.usePropertyNote) {
                                    // Limit to 1000 characters
                                    $scope.PersonalMessage = $scope.propertyNote.substring(0, 1000);
                                } else {
                                    $scope.PersonalMessage = '';
                                }
                            };

                            // Select uploaded cover image
                            $scope.selectUploadedCover = function () {
                                if ($scope.uploadedImages && $scope.uploadedImages.length > 0) {
                                    $scope.CoverImageType = 30;
                                } else {
                                    notifierSvc.show({ message: $translate.instant('cover_uploaded_no_image_warning'), type: "warning" });
                                    $scope.CoverImageType = 20;
                                }
                            };

                            // Open photo upload modal
                            $scope.openPhotoUploadModal = function () {
                                ngDialog.open({
                                    templateUrl: 'app/endeks/modal-photo-upload.html',
                                    scope: $scope,
                                    closeByDocument: false,
                                    closeByEscape: true,
                                    className: 'ngdialog-theme-default custom-photo-upload-modal',
                                    controller: [
                                        '$scope', '$window', '$timeout', 'notifierSvc', 's3Files', 'endeksService', '$q', '$translate',
                                        function ($scope, $window, $timeout, notifierSvc, s3Files, endeksService, $q, $translate) {

                                            // Modal scope değişkenleri
                                            $scope.onlyImage = true;
                                            $scope.selectedFiles = [];
                                            $scope.totalSize = 0;
                                            $scope.uploadProgress = 0;
                                            $scope.isUploading = false;
                                            $scope.isDragOver = false;

                                            // Güvenli $apply fonksiyonu
                                            $scope.safeApply = function (fn) {
                                                var phase = $scope.$root.$$phase;
                                                if (phase === '$apply' || phase === '$digest') {
                                                    if (fn && typeof fn === 'function') {
                                                        fn();
                                                    }
                                                } else {
                                                    $scope.$apply(fn);
                                                }
                                            };

                                            // Dosya seçme fonksiyonu
                                            $scope.triggerFileInput = function () {
                                                $timeout(function () {
                                                    var fileInput = document.getElementById('photo-file-input');
                                                    if (fileInput) {
                                                        // Input'un value'sunu temizle (aynı dosya tekrar seçilebilsin diye)
                                                        fileInput.value = '';
                                                        fileInput.click();
                                                    }
                                                }, 0);
                                            };

                                            // Dosya seçim handler
                                            $scope.handleFileSelect = function (files) {
                                                debugger;
                                                for (var i = 0; i < files.length; i++) {
                                                    var file = files[i];
                                                    if ($scope.validateFile(file)) {
                                                        $scope.addFileToList(file);
                                                    }
                                                }
                                                $scope.safeApply();
                                            };

                                            // Drag & Drop handlers
                                            $scope.handleDragOver = function (event) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = true;
                                                $scope.safeApply();
                                            };

                                            $scope.handleDragLeave = function (event) {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = false;
                                                $scope.safeApply();
                                            };

                                            $scope.handleDrop = function (event) {
                                                debugger;
                                                event.preventDefault();
                                                event.stopPropagation();
                                                $scope.isDragOver = false;

                                                var files = event.dataTransfer.files;
                                                $scope.handleFileSelect(files);
                                            };

                                            // Dosya validasyonu
                                            $scope.validateFile = function (file) {
                                                debugger;
                                                // Desteklenen dosya türleri
                                                var supportedTypes = [
                                                    // Images
                                                    'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
                                                ];

                                                // Dosya türü kontrolü
                                                if (supportedTypes.indexOf(file.type) === -1) {
                                                    notifierSvc.show({ message: $translate.instant('file_type_not_supported'), type: "error" });
                                                    return false;
                                                }

                                                // Dosya boyutu kontrolü (5MB)
                                                if (file.size > 5 * 1024 * 1024) {
                                                    notifierSvc.show({ message: $translate.instant('file_size_too_large'), type: "error" });
                                                    return false;
                                                }

                                                // Aynı dosya kontrolü (orijinal boyut ile karşılaştır)
                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    var existingFile = $scope.selectedFiles[i];
                                                    var existingSize = existingFile.originalSize || existingFile.size;
                                                    if (existingFile.name === file.name && existingSize === file.size) {
                                                        notifierSvc.show({ message: $translate.instant('file_already_selected'), type: "warning" });
                                                        return false;
                                                    }
                                                }

                                                return true;
                                            };

                                            $scope.resizeImageIfNeeded = function (dataUrl, fileName) {
                                                return new Promise(function (resolve, reject) {
                                                    var img = new Image();
                                                    img.onload = function () {
                                                        var canvas = document.createElement('canvas');
                                                        var ctx = canvas.getContext('2d');

                                                        var originalWidth = img.width;
                                                        var originalHeight = img.height;

                                                        // Yeni boyutları hesapla
                                                        var newWidth = originalWidth;
                                                        var newHeight = originalHeight;
                                                        var needsResize = false;

                                                        // Width kontrolü
                                                        if (originalWidth > 1200) {
                                                            newWidth = 1200;
                                                            newHeight = (originalHeight * 1200) / originalWidth;
                                                            needsResize = true;
                                                        }

                                                        // Height kontrolü (width resize sonrası yeni height'ı kontrol et)
                                                        if (newHeight > 600) {
                                                            var oldHeight = newHeight;
                                                            newHeight = 600;
                                                            newWidth = (newWidth * 600) / oldHeight;
                                                            needsResize = true;
                                                        }

                                                        if (!needsResize) {
                                                            resolve(dataUrl);
                                                            return;
                                                        }

                                                        // Canvas boyutlarını ayarla
                                                        canvas.width = Math.round(newWidth);
                                                        canvas.height = Math.round(newHeight);

                                                        // Resmi yeniden boyutlandır ve çiz
                                                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                                                        // Yeni data URL'i oluştur
                                                        var resizedDataUrl = canvas.toDataURL('image/jpeg', 0.85);

                                                        console.log('Resim boyutlandırıldı:', fileName);
                                                        console.log('Orijinal:', originalWidth + 'x' + originalHeight);
                                                        console.log('Yeni:', canvas.width + 'x' + canvas.height);

                                                        resolve(resizedDataUrl);
                                                    };

                                                    img.onerror = function () {
                                                        console.error('Resim yüklenirken hata oluştu:', fileName);
                                                        resolve(dataUrl); // Hata durumunda orijinal dosyayı kullan
                                                    };

                                                    img.src = dataUrl;
                                                });
                                            };

                                            $scope.calculateBase64Size = function (base64String) {
                                                var stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
                                                var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
                                                return Math.round(sizeInBytes);
                                            };

                                            // Dosya listesine ekle
                                            $scope.addFileToList = function (file) {

                                                var reader = new FileReader();
                                                reader.onload = function (e) {
                                                    $scope.resizeImageIfNeeded(e.target.result, file.name).then(function (resizedDataUrl) {
                                                        var fileObject = {
                                                            name: file.name,
                                                            size: $scope.calculateBase64Size(resizedDataUrl),
                                                            type: file.type,
                                                            category: 'image',
                                                            preview: resizedDataUrl,
                                                            file: file,
                                                            originalSize: file.size,
                                                            resized: resizedDataUrl !== e.target.result
                                                        };
                                                        $scope.selectedFiles.push(fileObject);
                                                        $scope.totalSize += fileObject.size;
                                                        $scope.safeApply();
                                                    });
                                                };
                                                reader.readAsDataURL(file);
                                            };

                                            // Dosya objesi ile silme
                                            $scope.removeFileByObject = function (fileToRemove) {
                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    if ($scope.selectedFiles[i] === fileToRemove) {
                                                        $scope.totalSize -= fileToRemove.size;
                                                        $scope.selectedFiles.splice(i, 1);
                                                        // Input'un value'sunu temizle (aynı dosya tekrar seçilebilsin diye)
                                                        var fileInput = document.getElementById('photo-file-input');
                                                        if (fileInput) {
                                                            fileInput.value = '';
                                                        }
                                                        $scope.safeApply();
                                                        break;
                                                    }
                                                }
                                            };

                                            // Dosya boyutunu formatla
                                            $scope.formatFileSize = function (bytes) {
                                                if (bytes === 0) return '0 Bytes';
                                                var k = 1024;
                                                var sizes = ['Bytes', 'KB', 'MB', 'GB'];
                                                var i = Math.floor(Math.log(bytes) / Math.log(k));
                                                return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
                                            };

                                            // Dosyaları yükle
                                            $scope.uploadFiles = function () {
                                                if ($scope.selectedFiles.length === 0) {
                                                    notifierSvc.show({ message: $translate.instant('please_select_at_least_one_file'), type: "warning" });
                                                    return;
                                                }

                                                $scope.isUploading = true;
                                                $scope.uploadProgress = 0;

                                                var uploadPromises = [];

                                                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                                                    var file = $scope.selectedFiles[i];
                                                    uploadPromises.push($scope.uploadSingleFile(file, i, $scope.selectedFiles[i].category));
                                                }

                                                $q.all(uploadPromises).then(
                                                    function (results) {
                                                        var successCount = 0;
                                                        var newFiles = [];

                                                        results.forEach(function (result, i) {
                                                            if (result.success) {
                                                                successCount++;
                                                                newFiles.push({
                                                                    Id: null,
                                                                    Url: result.url,
                                                                    FileOrder: i,
                                                                    FileType: 10
                                                                });
                                                            }
                                                        });

                                                        if (successCount > 0) {
                                                            // Parent scope'dan house'a erişim ve güncelleme
                                                            if (!$scope.$parent.house.Files) {
                                                                $scope.$parent.house.Files = [];
                                                            }
                                                            var allFiles = $scope.$parent.house.Files.concat(newFiles);

                                                            endeksService.changeFiles($scope.$parent.house.Id, allFiles).then(
                                                                function () {
                                                                    $scope.$parent.house.Files = angular.copy(allFiles);
                                                                    notifierSvc.show({
                                                                        message: $translate.instant('files_uploaded_success', { count: successCount }),
                                                                        type: "success"
                                                                    });

                                                                    // Uploaded images listesini güncelle
                                                                    var updatedFiles = $scope.$parent.house.Files || [];
                                                                    $scope.$parent.uploadedImages = updatedFiles.filter(function (file) {
                                                                        return file.FileType === 10;
                                                                    });
                                                                    $scope.closeThisDialog();
                                                                },
                                                                function (err) {
                                                                    var msg = err.data.Message || $translate.instant('files_uploaded_db_error');
                                                                    if (msg.includes('Maximum file limit')) {
                                                                        msg = $translate.instant('files_uploaded_max_error');
                                                                    }
                                                                    notifierSvc.show({
                                                                        message: msg,
                                                                        type: "error"
                                                                    });
                                                                }
                                                            );
                                                        } else {
                                                            notifierSvc.show({ message: $translate.instant('no_files_uploaded'), type: "error" });
                                                        }

                                                        $scope.isUploading = false;
                                                        $scope.uploadProgress = 0;
                                                    },
                                                    function (error) {
                                                        $scope.isUploading = false;
                                                        $scope.uploadProgress = 0;
                                                        notifierSvc.show({ message: $translate.instant('upload_error'), type: "error" });
                                                    }
                                                );
                                            };

                                            // Tek dosya yükleme
                                            $scope.uploadSingleFile = function (fileObj, index) {
                                                return new Promise(function (resolve, reject) {

                                                    function performUpload(base64Data) {
                                                        var object = {
                                                            "FileName": fileObj.name,
                                                            "Path": "properties/" + $scope.$parent.house.Id,
                                                        };
                                                        var uploadReq = null;

                                                        object.ImageBase64 = base64Data;
                                                        uploadReq = s3Files.uploadImg().query(object);

                                                        uploadReq.$promise.then(function (data) {
                                                            $scope.uploadProgress = ((index + 1) / $scope.selectedFiles.length) * 100;
                                                            $scope.safeApply();
                                                            resolve({ success: true, url: fileObj.category === 'image' ? data.ImageUrl : data.FileUrl, type: fileObj.category });
                                                        }).catch(function (error) {
                                                            resolve({ success: false, error: error });
                                                        });
                                                    }

                                                    // Eğer resim dosyası ise zaten preview var

                                                    performUpload(fileObj.preview);

                                                });
                                            };
                                        }
                                    ]
                                });
                            };

                            $scope.reportFeatures = {
                                "About": true,
                                "Certificates": true,
                                "TrendGraph": true,
                                "Comparables": true,
                                "LongtimeComparables": true,
                                "ShorttimeComparables": true,
                                "ComparablesSort": true,
                                "Demography": true,
                                "Expenses": true,
                                "Locations": true,
                                "ForSale": true,
                                "ForRent": true,
                                "Elections": true,
                                RiskLandG1: true,
                                //FidLandAttribute: true,
                                RiskLandForest: true,
                                RiskLandAgriculture: true,
                                RiskEnh: false,
                                //Enh: false,
                                RiskTransformer: false,
                                RiskFloodRiverNetwork: false,
                                FloodAttribute: false,
                                LandslideCode: false,
                                PGA10: false
                            };
                            $scope.reportFeaturesBasic = {
                                "TrendGraph": true,
                                "Comparables": true,
                                "Demography": true,
                                "Elections": true,
                            };
                            var sliceIndex = 12;
                            if ($scope.CountryId !== 1) {
                                delete $scope.reportFeatures["Demography"];
                                delete $scope.reportFeatures["Elections"];
                                delete $scope.reportFeatures["Expenses"];
                                delete $scope.reportFeatures["Locations"];
                                delete $scope.reportFeatures["RiskLandG1"];
                                delete $scope.reportFeatures["RiskLandForest"];
                                delete $scope.reportFeatures["RiskLandAgriculture"];
                                delete $scope.reportFeatures["RiskEnh"];
                                delete $scope.reportFeatures["RiskTransformer"];
                                delete $scope.reportFeatures["RiskFloodRiverNetwork"];
                                delete $scope.reportFeatures["FloodAttribute"];
                                delete $scope.reportFeatures["LandslideCode"];
                                // delete $scope.reportFeatures["ComparablesSort"];
                                // delete $scope.reportFeatures["LongtimeComparables"];
                                // delete $scope.reportFeatures["ShorttimeComparables"];
                                delete $scope.reportFeaturesBasic["Demography"];
                                delete $scope.reportFeaturesBasic["Elections"];
                                sliceIndex = 10;
                                if (selectedValuation === 30) {
                                    delete $scope.reportFeatures["Comparables"];
                                    delete $scope.reportFeaturesBasic["Comparables"];
                                }
                            } else {
                                if (selectedValuation === 30) {
                                    delete $scope.reportFeatures["Comparables"];
                                    delete $scope.reportFeaturesBasic["Comparables"];
                                }
                            }
                            var reportFeaturesKeys = Object.keys($scope.reportFeatures);
                            var reportFeaturesProfileLeftIndexFirst = reportFeaturesKeys.indexOf("About");
                            var reportFeaturesProfileLeftIndexLast = reportFeaturesKeys.indexOf("Certificates");
                            $scope.reportFeaturesProfileLeftCol = reportFeaturesKeys.slice(reportFeaturesProfileLeftIndexFirst, reportFeaturesProfileLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesProfileRightIndexFirst = reportFeaturesKeys.indexOf("Certificates");
                            var reportFeaturesProfileRightIndexLast = reportFeaturesKeys.indexOf("TrendGraph");
                            $scope.reportFeaturesProfileRightCol = reportFeaturesKeys.slice(reportFeaturesProfileRightIndexFirst, reportFeaturesProfileRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesComparableIndexFirst = reportFeaturesKeys.indexOf("TrendGraph");
                            var reportFeaturesComparableIndexLast = reportFeaturesKeys.indexOf("ShorttimeComparables");
                            $scope.reportFeaturesComparableLeftCol = reportFeaturesKeys.slice(reportFeaturesComparableIndexFirst, reportFeaturesComparableIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesComparableRightIndexFirst = reportFeaturesKeys.indexOf("ShorttimeComparables");
                            var reportFeaturesComparableRightIndexLast = reportFeaturesKeys.indexOf("Demography");
                            $scope.reportFeaturesComparableRightCol = reportFeaturesKeys.slice(reportFeaturesComparableRightIndexFirst, reportFeaturesComparableRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesLocationLeftIndexFirst = reportFeaturesKeys.indexOf("Demography");
                            var reportFeaturesLocationLeftIndexLast = reportFeaturesKeys.indexOf("ForSale");
                            $scope.reportFeaturesLocationLeftCol = reportFeaturesKeys.slice(reportFeaturesLocationLeftIndexFirst, reportFeaturesLocationLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesLocationRightIndexFirst = reportFeaturesKeys.indexOf("ForSale");
                            var reportFeaturesLocationRightIndexLast = reportFeaturesKeys.indexOf("RiskLandG1");
                            $scope.reportFeaturesLocationRightCol = reportFeaturesKeys.slice(reportFeaturesLocationRightIndexFirst, reportFeaturesLocationRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesRiskLeftIndexFirst = reportFeaturesKeys.indexOf("RiskLandG1");
                            var reportFeaturesRiskLeftIndexLast = reportFeaturesKeys.indexOf("RiskFloodRiverNetwork");
                            $scope.reportFeaturesRiskLeftCol = reportFeaturesKeys.slice(reportFeaturesRiskLeftIndexFirst, reportFeaturesRiskLeftIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            var reportFeaturesRiskRightIndexFirst = reportFeaturesKeys.indexOf("RiskFloodRiverNetwork");
                            var reportFeaturesRiskRightIndexLast = reportFeaturesKeys.length;
                            $scope.reportFeaturesRiskRightCol = reportFeaturesKeys.slice(reportFeaturesRiskRightIndexFirst, reportFeaturesRiskRightIndexLast).reduce((result, key) => {
                                result[key] = $scope.reportFeatures[key];
                                return result;
                            }, {});
                            $scope.selectedReportFeatures = angular.copy($scope.reportFeatures);
                            $scope.selectedReportFeaturesBasic = angular.copy($scope.reportFeaturesBasic);

                            // Wizard Control
                            $scope.wizardStep = 1;

                            $scope.nextStep = function () {
                                if ($scope.wizardStep < 2) {
                                    $scope.wizardStep++;
                                }
                            };

                            $scope.prevStep = function () {
                                if ($scope.wizardStep > 1) {
                                    $scope.wizardStep--;
                                }
                            };

                            var Lang = window.lang;
                            var language = 1;
                            $scope.isRent = isRent;


                            $scope.code = product.code;
                            switch (Lang) {
                                case 'tr':
                                    $scope.currentDisplayName = 'Türkçe';
                                    language = 1;
                                    break;
                                case 'en':
                                    $scope.currentDisplayName = 'English';
                                    language = 2;
                                    break;
                                case 'es-ES':
                                    $scope.currentDisplayName = 'Español';
                                    language = 3;
                                    break;
                                case 'pt-PT':
                                    $scope.currentDisplayName = 'Português';
                                    language = 4;
                                    break;
                            }
                            $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
                            $scope.localesExcludedCountries = $scope.localesDisplayNames.filter(n => n === 'Türkçe' || n === 'English');

                            $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

                            $scope.addFlag = function (localeDisplayName) {
                                var flag;
                                switch (localeDisplayName) {
                                    case 'Türkçe':
                                        flag = 'tr';
                                        break;
                                    case 'English':
                                        flag = 'us';
                                        break;
                                    case 'Español':
                                        flag = 'es';
                                        break;
                                    case 'Português':
                                        flag = 'pt';
                                        break;
                                    default:
                                        flag = 'tr';
                                }
                                return flag;
                            };

                            $scope.changeLanguage = function (locale) {
                                var localeKey;
                                console.log("changeLanguage", locale);
                                if (locale === 'Türkçe') {
                                    localeKey = 'tr';
                                    language = 1;
                                } else if (locale === 'English') {
                                    localeKey = 'en';
                                    language = 2;
                                } else if (locale === 'Español') {
                                    localeKey = 'es';
                                    language = 3;
                                } else if (locale === 'Português') {
                                    localeKey = 'pt';
                                    language = 4;
                                }
                                Lang = localeKey;
                            };
                            $scope.handleReportTypeClick = function () {
                                if (product.code === 'edr-commercial') {
                                    return;
                                }
                                if (HasPackage) {
                                    $scope.userReportType.WithDetail = true;
                                } else {
                                    $scope.userReportType.WithDetail = false;
                                }
                            };
                            $scope.accept = function () {
                                ngDialog.open({
                                    templateUrl: 'app/payment/payment-edr-modal.html'
                                });
                                obj.isPreparing = true;
                                var order = {
                                    TasinmazId: house.Id,
                                    ProductId: product.id.value,
                                    Lang: Lang,
                                    Language: language,
                                    IsRent: isRent,
                                    UserId: adminReport ? house.CreatorId : userSvc.info.Id,
                                    WithDetail: $scope.userReportType.WithDetail,
                                    CurrencyId: window.currencyEndeksaCode(window.currency),
                                    ReportFeatures: $scope.userReportType.WithDetail ? $scope.selectedReportFeatures : $scope.selectedReportFeaturesBasic,
                                    CoverImageType: $scope.CoverImageType || 10,
                                    PersonalMessage: $scope.PersonalMessage || '',
                                    DedicationNote: $scope.DedicationNote || '',
                                    ReportFiles: $scope.selectedReportFiles
                                };
                                console.log("order", order);

                                var orderResult = adminReport ? report_factory.getReportAdmin(order) : report_factory.getReport(order);
                                orderResult.$promise.then(function (response) {
                                    if (angular.isDefined(response.Data)) {
                                        $rootScope.showAdv = false;
                                        // $analytics.eventTrack('Downloading Report', {
                                        //     category: 'Report Download',
                                        //     nonInteraction: true,
                                        //     page: $location.path()
                                        // });
                                        ngDialog.close();
                                        obj.isPreparing = false;
                                        if (response.Error === true) {
                                            deffered.reject({ message: response.Description, type: "error" });
                                        }
                                        deffered.resolve(true);
                                    }
                                    else {
                                        ngDialog.close();
                                        obj.isPreparing = false;
                                        notifierSvc.show({ message: response.Message, type: "error" });
                                        deffered.resolve(false);
                                    }
                                }, function (response) {
                                    var message;
                                    if (response.Message) {
                                        message = response.Message;
                                    } else if (response.data && response.data.Message && response.data.Message.includes("only allows plain text")) {
                                        message = 'plain_text_error';
                                    } else if (response.data && response.data.Message) {
                                        message = response.data.Message;
                                    }
                                    if (message.indexOf('not EDR credit') !== -1) {
                                        message = 'payment_no_credit';
                                    }
                                    ngDialog.close();
                                    obj.isPreparing = false;
                                    notifierSvc.show({ message: $translate.instant(message), type: "error" });
                                    deffered.resolve(false);
                                });
                            };

                        }]
                    });
                });
            });
            return deffered.promise;
        }

        function calculatePrice(promoCode) {
            obj.basket.orderDetails.promoCode = promoCode;
            localStorage.setItem('shopingCard', JSON.stringify(obj.basket));
        }


        function taxNumberValidate(taxno) {
            if (taxno) {
                var taxStr = (taxno !== null && taxno !== undefined) ? taxno.toString() : '';
                var _error = false;
                var message = '';
                if (taxStr.length < 10 || taxStr.length > 11) {
                    _error = true;
                    message = $translate.instant('onepage_new_error13');
                };
                /* if (!window.isTaxNoValid(taxno.toString())) {
                    _error = true;
                    message = $translate.instant('onepage_new_error13');
                } */
                return {
                    'error': _error,
                    'message': message
                };
            }
            else
                return {
                    'error': true,
                    'message': ''
                };
        }


        function idNumberValidate(tckimlikno) {
            var _error = false;
            var message = '';
            if (!tckimlikno || !window.checkTcNum(tckimlikno)) {
                _error = true;
                message = "Geçerli bir kimlik numarası giriniz.";
            }
            if (tckimlikno && tckimlikno.length !== 11) {
                message = "TC kimlik numaranız 11 haneli olmalıdır.";
            }
            return {
                'error': _error,
                'message': message
            };
        }

        function makeReadyForPayment(product) {
            $state.go('odeme-onepage', { code: product.code, langcode: $rootScope.lang });
        }


        function preparePayment(product) {
            var langcode = window.lang || 'tr';
            $state.go('odeme-onepage', { langcode: langcode, code: product.code, ad: $rootScope.ad, promo: product.promo });
        }

        function addToCart(product) {
            obj.basket.orderDetails.products.push(product);
            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "add_to_cart",
                currency: window.currency,
                language: window.lang.split('-')[0],
                ecommerce: {
                    currency: window.currency,
                    currencyCode: window.currency,
                    items: [
                        {
                            "id": product.id.value,
                            "name": product.nameEnglish,
                            "brand": "Endeksa",
                            "category": product.productType === 10 ? 'Report' : product.productType === 40 ? 'Monthly Package' : product.productType === 20 ? 'Annual Package' : 'Other',
                            "sku": product.code,
                            "quantity": 1,
                            "price": product.productType === 40 ? product.monthlyPrice : product.productType === 20 ? product.yearlyPrice : product.singlePrice
                        }
                    ]
                }
            });
            // $window.gtag('event', 'add_to_cart', {
            //     "items": [
            //         {
            //             "id": product.id.value,
            //             "name": product.nameEnglish,
            //             "brand": "Endeksa",
            //             "category": product.productType === 10 ? 'Report' : product.productType === 40 ? 'Monthly Package' : product.productType === 20 ? 'Annual Package' : 'Other',
            //             "sku": product.code,
            //             "quantity": 1,
            //             "price": product.productType === 40 ? product.monthlyPrice : product.productType === 20 ? product.yearlyPrice : product.singlePrice
            //         }
            //     ]
            // });
            localStorage.setItem('shopingCard', JSON.stringify(obj.basket));
        }

        function buyReportFromPropertyDetail(product, house, valuation, isRent) {
            var deferred = $q.defer();
            var EDRPermission = guardSvc.checkCreditValue('edr-house');
            var EDRLandPermission = guardSvc.checkCreditValue('edr-plot');
            var EDRFieldPermission = guardSvc.checkCreditValue('edr-land');
            var EDRCommercialPermission = guardSvc.checkCreditValue('edr-commercial');
            var score = isRent ? valuation.QualityControlScoreRent : valuation.QualityControlScore;
            if (product.code === 'edr-house' && EDRPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent, valuation.ValuationMethod).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-plot' && EDRLandPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-land' && EDRFieldPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else if (product.code === 'edr-commercial' && EDRCommercialPermission) {
                if (score >= 50) {
                    obj.buyElectronicReport(product, house, isRent).then(function (refresh) {
                        deferred.resolve(refresh);
                    }).catch(e => {
                        deferred.reject(e);
                    });
                } else {
                    ngDialog.open({
                        templateUrl: 'app/endeks/modal-edr-star-error.html'
                    });
                    deferred.resolve(false);
                }
            } else {
                deferred.resolve(false);
                makeReadyForPayment(product, house, isRent);
            }
            return deferred.promise;
        }

        function buyReportFromPropertyDetailAdmin(product, house, isRent) {
            var deferred = $q.defer();
            if (product.code === 'edr-house') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-plot') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-land') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else if (product.code === 'edr-commercial') {

                obj.buyElectronicReport(product, house, isRent, 0, true).then(function (refresh) {
                    deferred.resolve(refresh);
                }).catch(e => {
                    deferred.reject(e);
                });
            } else {
                deferred.resolve(false);
                makeReadyForPayment(product, house, isRent);
            }
            return deferred.promise;
        }


        function getProducts() {
            var deferred = $q.defer();
            products_factory.list().$promise.then(
                function (response) {
                    if (response) {
                        deferred.resolve({
                            result: "success",
                            data: response
                        });
                    } else {
                        deferred.reject({
                            result: "failure"
                        });
                    }
                },
                function () {
                    deferred.reject({
                        result: "failure"
                    });
                }
            );
            return deferred.promise;
        }

        function getProductsForFilter() {
            var deferred = $q.defer();
            products_factory.listForFilter().$promise.then(
                function (response) {
                    if (response) {
                        deferred.resolve({
                            result: "success",
                            data: response
                        });
                    } else {
                        deferred.reject({
                            result: "failure"
                        });
                    }
                },
                function () {
                    deferred.reject({
                        result: "failure"
                    });
                }
            );
            return deferred.promise;
        }


        function changePricesByCurrency(products, currency) {
            products.forEach((p, i) => {
                let priceObj = p.prices.find(price => price.currency === currency);

                if (priceObj) {
                    products[i].monthlyContractedPrice = priceObj.monthlyContractedPrice;
                    products[i].monthlyPrice = priceObj.monthlyPrice;
                    products[i].singlePrice = priceObj.singlePrice;
                    products[i].yearlyContractedPrice = priceObj.yearlyContractedPrice;
                    products[i].yearlyPrice = priceObj.yearlyPrice;
                }

                return products;

            });
        }
    }
})();

(function () {
    "use strict";
    angular.module("app.common").directive("circlebar", circlebar);

    function circlebar() {
        var directive = {
            controller: [
                "$scope",
                controller,
            ],
            templateUrl: "/app/common/circlebar.directive.html",
            restrict: "EA",
            scope: {
                size: '@', //string - "md", "lg", "sm"
                value: '<',
                color: '@',
                background: '@'
            }
        };

        return directive;

        function controller($scope) {
            // Define investment color palette
            var investmentColors = {
                investmentVeryLow: '#FF4444',    // Very Low - Bright Red
                investmentLow: '#FF8800',        // Low - Orange
                investmentMedium: '#FFD700',     // Medium - Yellow
                investmentGood: '#90EE90',       // Good - Light Green
                investmentPerfect: '#4CAF50'     // Perfect - Dark Green
            };

            // Color interpolation function
            function interpolateColor(color1, color2, factor) {
                var hex1 = color1.replace('#', '');
                var hex2 = color2.replace('#', '');

                var r1 = parseInt(hex1.substr(0, 2), 16);
                var g1 = parseInt(hex1.substr(2, 2), 16);
                var b1 = parseInt(hex1.substr(4, 2), 16);

                var r2 = parseInt(hex2.substr(0, 2), 16);
                var g2 = parseInt(hex2.substr(2, 2), 16);
                var b2 = parseInt(hex2.substr(4, 2), 16);

                var r = Math.round(r1 + (r2 - r1) * factor);
                var g = Math.round(g1 + (g2 - g1) * factor);
                var b = Math.round(b1 + (b2 - b1) * factor);

                return '#' + r.toString(16).padStart(2, '0') +
                    g.toString(16).padStart(2, '0') +
                    b.toString(16).padStart(2, '0');
            }

            // Gradient position calculation function
            function getVisualPosition(score) {
                if (score <= 40) {
                    return (score / 40) * 25;
                } else if (score <= 50) {
                    return 25 + ((score - 40) / 10) * 20;
                } else if (score <= 60) {
                    return 45 + ((score - 50) / 10) * 20;
                } else if (score <= 70) {
                    return 65 + ((score - 60) / 10) * 20;
                } else {
                    return 85 + ((score - 70) / 30) * 15;
                }
            }

            // Color calculation function
            function calculateIndicatorColor(point) {
                var position = getVisualPosition(point);

                if (position <= 25) {
                    // Between red (0%) and orange (25%)
                    var factor = position / 25;
                    return interpolateColor(
                        investmentColors.investmentVeryLow,
                        investmentColors.investmentLow,
                        factor
                    );
                } else if (position <= 45) {
                    // Between orange (25%) and yellow (45%)
                    var factor = (position - 25) / 20;
                    return interpolateColor(
                        investmentColors.investmentLow,
                        investmentColors.investmentMedium,
                        factor
                    );
                } else if (position <= 65) {
                    // Between yellow (45%) and light green (65%)
                    var factor = (position - 45) / 20;
                    return interpolateColor(
                        investmentColors.investmentMedium,
                        investmentColors.investmentGood,
                        factor
                    );
                } else if (position <= 85) {
                    // Between light green (65%) and dark green (85%)
                    var factor = (position - 65) / 20;
                    return interpolateColor(
                        investmentColors.investmentGood,
                        investmentColors.investmentPerfect,
                        factor
                    );
                } else {
                    // Above 85% - solid dark green
                    return investmentColors.investmentPerfect;
                }
            }

            // Add color calculation function to scope
            $scope.getIndicatorColor = function (value) {
                if ($scope.color) {
                    return $scope.color;
                }
                return calculateIndicatorColor(value || 0);
            };
        }
    }
})();

(function () {
    "use strict";
    angular.module("app.common").directive("scorebar", scorebar);

    function scorebar() {
        var directive = {
            controller: [
                "$scope",
                controller,
            ],
            templateUrl: "/app/common/scorebar.directive.html",
            restrict: "EA",
            scope: {
                currentScore: '<', // Current investment score (0-100)
                showTitle: '<'     // Whether to show the title (default: false)
            }
        };

        return directive;

        function controller($scope) {
            // Default values
            $scope.showTitle = $scope.showTitle || false;

            // Investment color palette
            var investmentColors = {
                investmentVeryLow: '#FF4444',    // Very Low - Bright Red
                investmentLow: '#FF8800',        // Low - Orange
                investmentMedium: '#FFD700',     // Medium - Yellow
                investmentGood: '#90EE90',       // Good - Light Green
                investmentPerfect: '#4CAF50'     // Perfect - Dark Green
            };

            // Score ranges with labels (using translate keys)
            $scope.scoreRanges = [
                { range: '0-40', labelKey: 'very_low', color: investmentColors.investmentVeryLow },
                { range: '40-50', labelKey: 'low', color: investmentColors.investmentLow },
                { range: '50-60', labelKey: 'medium', color: investmentColors.investmentMedium },
                { range: '60-70', labelKey: 'good', color: investmentColors.investmentGood },
                { range: '70-100', labelKey: 'perfect', color: investmentColors.investmentPerfect }
            ];

            // Calculate position percentage for current score indicator based on visual zones
            function getVisualPosition(score) {
                // Visual zone mappings: [actual range] -> [visual range]
                if (score <= 40) {
                    // 0-40 -> 0-25%
                    return (score / 40) * 25;
                } else if (score <= 50) {
                    // 40-50 -> 25-45%
                    return 25 + ((score - 40) / 10) * 20;
                } else if (score <= 60) {
                    // 50-60 -> 45-65%
                    return 45 + ((score - 50) / 10) * 20;
                } else if (score <= 70) {
                    // 60-70 -> 65-85%
                    return 65 + ((score - 60) / 10) * 20;
                } else {
                    // 70-100 -> 85-100%
                    return 85 + ((score - 70) / 30) * 15;
                }
            }

            // Calculate indicator position
            $scope.getIndicatorPosition = function () {
                var score = $scope.currentScore || 0;
                var position = Math.min(Math.max(getVisualPosition(score), 0), 100);
                return position + '%';
            };

            // Milestone positions for separator lines
            $scope.milestones = [25, 45, 65, 85];

            // Zone positions for labels (centered in visually balanced zones)
            $scope.getZonePosition = function (index) {
                var zonePositions = [12.5, 35, 55, 75, 92.5];
                return zonePositions[index] + '%';
            };
        }
    }
})();

(function () {
    "use strict";
    angular.module("app.common").directive("search", search);

    function search() {
        var directive = {
            controller: [
                "$scope", "$rootScope", "parcelClientService", "searchEngine", "notifierSvc", "searchParserService", "$timeout", "$window", "addressAPI", "provinceListService", "$translate", "bolgeselDataService", "geoApi", "$state", "comparablesApi",
                controller,
            ],
            templateUrl: "/app/common/search.directive.html",
            restrict: "EA",
            scope: {
                actionType: '<',
                searchClass: '<',
                isLanding: '<'
            }
        };

        return directive;

        function controller($scope, $rootScope, parcelClientService, searchEngine, notifierSvc, searchParserService, $timeout, $window, addressAPI, provinceListService, $translate, bolgeselDataService, geoApi, $state, comparablesApi) {

            $scope.randomId = window.makeid(5);

            $scope.bindAutoComplete = function () {
                $rootScope.initAutoComplete('#' + $scope.randomId, '#' + $scope.randomId + '-btn');
            };

            $scope.initCities = function () {
                $scope.TKGMAddress.cityLoaded = false;
                $scope.TKGMAddress.cities = [];
                addressAPI.getCities().$promise.then(response => $scope.TKGMAddress.cities = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.cityLoaded = true);
            };

            $scope.cityTKGMChanged = function () {
                $scope.TKGMAddress.countyLoaded = false;
                $scope.TKGMAddress.counties = [];
                addressAPI.getCounties({ cityId: $scope.TKGMAddress.city }).$promise.then(response => $scope.TKGMAddress.counties = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.countyLoaded = true);
            };

            $scope.countyTKGMChanged = function () {
                $scope.TKGMAddress.districtLoaded = false;
                $scope.TKGMAddress.districts = [];
                addressAPI.getDistricts({ countyId: $scope.TKGMAddress.county }).$promise.then(response => $scope.TKGMAddress.districts = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.districtLoaded = true);
            };

            $scope.districtChanged = function () {
                $scope.TKGMAddress.streetLoaded = false;
                $scope.TKGMAddress.streets = [];
                addressAPI.getStreets({ districtId: $scope.TKGMAddress.district }).$promise.then(response => $scope.TKGMAddress.streets = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.streetLoaded = true);
            };

            $scope.streetChanged = function () {
                $scope.TKGMAddress.buildingLoaded = false;
                $scope.TKGMAddress.buildings = [];
                addressAPI.getBuildings({ streetId: $scope.TKGMAddress.street }).$promise.then(response => $scope.TKGMAddress.buildings = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.buildingLoaded = true);
            };

            $scope.TKGMAddress = {
                cities: [],
                counties: [],
                districts: [],
                neighborhoods: false,
                streets: [],
                buildings: false,
                loading: false,
                error: false,
                cityLoaded: false,
                countyLoaded: false,
                districtLoaded: false,
                neighborhoodLoaded: false,
                streetLoaded: false,
                buildingLoaded: false
            };

            $scope.searchterms = {
                cities: [],
                counties: [],
                city_loaded: false,
                county_loaded: false,
                districts: [],
                district_loaded: false,
                loading: false,
                error: false,
                coordinate: "",
                id: "",
                listing: "",
                listingNo: "",
                zemin: "",
                city: window.selectedCity,
                country: $rootScope.country
            };

            $scope.cityChanged = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.city_loaded = false;
                $scope.searchterms.county_loaded = false;
                $scope.searchterms.district_loaded = false;
                if ($scope.searchterms.city_parcel) {
                    $scope.searchterms.loading = true;
                    parcelClientService.getCounties($scope.searchterms.city_parcel).then(
                        function (result) {
                            $scope.searchterms.loading = false;
                            $scope.searchterms.counties = result.data.features;
                            $scope.searchterms.county_loaded = true;
                            $scope.searchterms.district_loaded = false;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    );
                }
            };

            $scope.countyChanged = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.district_loaded = false;
                if ($scope.searchterms.county && $scope.searchterms.county_loaded) {
                    $scope.searchterms.loading = true;
                    parcelClientService.getNeighborhoods($scope.searchterms.county).then(
                        function (result) {
                            $scope.searchterms.loading = false;
                            $scope.searchterms.districts = result.data.features;
                            $scope.searchterms.county_loaded = true;
                            $scope.searchterms.district_loaded = true;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    );
                }
            };
            var searchCoordinate = function () {
                searchEngine.searchCoordinate($scope.searchterms.coordinate);
                searchParserService.parseSearch(true, null, null, $scope.isLanding);
            };

            var searchId = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchUrl($scope.searchterms.listing).then(function (result) {
                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;
                    notifierSvc.remove();
                    notifierSvc.show({
                        message: $translate.instant('comparable_acquired'),
                        type: "success",
                    });
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);

                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var searchListingNo = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;

                comparablesApi.detail({ EndeksaId: $scope.searchterms.listingNo, captchaTokenCustom: $window.ecSec() }).$promise.then(function (result) {
                    $scope.searchterms.loading = false;
                    if (result && result.URL) {
                        if (result.ListingActive === false && result.Valuation) {
                            $scope.searchterms.error = true;
                            return;
                        }
                        var propertyName = result.URL.replace(/^\//, '');
                        $state.go('property', {
                            name: propertyName,
                            langcode: $translate.use()
                        });
                    } else {
                        $scope.searchterms.error = true;
                    }
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var searchAddressCode = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchAddressCode($scope.searchterms.id).then(function (result) {

                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            $scope.parcelChanged = parcelChanged;

            var searchTitleNo = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchTitleNo($scope.searchterms.zemin).then(function (result) {

                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;

                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var parcelChanged = function () {
                // Validate that required fields (city, county, district) are selected before making the query
                if (!$scope.searchterms.city_parcel || !$scope.searchterms.county || !$scope.searchterms.district) {
                    return;
                }

                $scope.parcelHandler = true;
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                if (!$scope.searchterms.ada)
                    $scope.searchterms.ada = 0;
                searchEngine.searchParcel($scope.searchterms.district, $scope.searchterms.ada, $scope.searchterms.parsel).then(function (result) {
                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;

                    $scope.searchterms.city_loaded = true;
                    $scope.searchterms.county_loaded = true;
                    $scope.searchterms.district_loaded = true;

                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;

                    $scope.searchterms.city_loaded = true;
                    $scope.searchterms.county_loaded = true;
                    $scope.searchterms.district_loaded = true;
                });
            };

            var geoap;
            var lastKnownCity;

            var countryCityChanged = function (city) {
                if (lastKnownCity === $scope.searchterms.city) {
                    $rootScope.selectedMethod = 1;
                } else {
                    lastKnownCity = $scope.searchterms.city;
                }
                $scope.searchterms.error = false;
                $scope.searchterms.loading = false;

                $scope.searchterms.city = city || $scope.searchterms.city;

                if ($scope.isLanding) {
                    if (geoap)
                        geoap.$cancelRequest();
                    const cityObj = $scope.searchterms.cities.find(m => $rootScope.normalizeAddress(m.CityName) === $scope.searchterms.city);
                    if (cityObj) {
                        geoap = geoApi.get({
                            cityId: cityObj.CityId,
                            countryId: $scope.searchterms.country,
                            level: 1
                        });
                        geoap.$promise.then(
                            function (resa) {
                                var geo = L.geoJson(resa);
                                var bounds = geo.getBounds();
                                var lbounds = {
                                    northEast: {
                                        lat: bounds._northEast.lat,
                                        lng: bounds._northEast.lng,
                                    },
                                    southWest: {
                                        lat: bounds._southWest.lat,
                                        lng: bounds._southWest.lng,
                                    },
                                    // name: resa.features[0].properties.City
                                };
                                bolgeselDataService.country = normalizeAddress(resa.features[0].properties.Country);
                                bolgeselDataService.cityBounds = lbounds;
                            },
                            function (result) {
                                if (result.xhrStatus !== 'abort')
                                    console.log(result);
                            }
                        );
                    }
                }
                searchParserService.useCity($scope.isLanding, $scope.searchterms.city, $scope.actionType);

            };
            $scope.countryCityChanged = countryCityChanged;


            var countryChanged = function (country) {
                if (country === undefined && $rootScope.country) {
                    country = $rootScope.country === 'espana' ? 2 : $rootScope.country === 'portugal' ? 3 : $rootScope.country === 'turkiye' ? 1 : 0;
                }
                $scope.searchterms.error = false;
                $scope.searchterms.loading = false;
                $scope.searchterms.country = country;
                $scope.searchterms.city_loaded = false;
                $rootScope.country = country == 2 ? 'espana' : country == 3 ? 'portugal' : country == 1 ? 'turkiye' : 'world';

                if (geoap)
                    geoap.$cancelRequest();

                if (country > 0) {
                    geoap = geoApi.get({
                        countryId: country,
                        level: 9
                    });
                    geoap.$promise.then(
                        function (resa) {
                            var geo = L.geoJson(resa);
                            var bounds = geo.getBounds();
                            var lbounds = {
                                northEast: {
                                    lat: bounds._northEast.lat,
                                    lng: bounds._northEast.lng,
                                },
                                southWest: {
                                    lat: bounds._southWest.lat,
                                    lng: bounds._southWest.lng,
                                },
                                // name: resa.features[0].properties.City
                            };
                            bolgeselDataService.country = normalizeAddress(resa.features[0].properties.Country);
                            bolgeselDataService.cityBounds = lbounds;
                        },
                        function (result) {
                            if (result.xhrStatus !== 'abort')
                                console.log(result);
                        }
                    );
                    $scope.searchterms.loading = true;
                    provinceListService.getProvinces(country).then(
                        function (result) {
                            $rootScope.cities = result.List;
                            $rootScope.cityLimit = $rootScope.country === 'espana' ? 9 : $rootScope.country === 'portugal' ? 3 : 14;

                            $scope.searchterms.loading = false;
                            $scope.searchterms.cities = [{ CityName: $translate.instant('rg_city'), CityId: 0 }];
                            result.List.forEach(function (item) {
                                $scope.searchterms.cities.push(item);
                            });
                            $scope.searchterms.city_loaded = true;
                            $scope.searchterms.county_loaded = $scope.parcelHandler || false;
                            $scope.searchterms.district_loaded = $scope.parcelHandler || false;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    ).finally(() => $scope.parcelHandler = false);
                }
            };
            $scope.countryChanged = countryChanged;

            countryChanged();

            $scope.useLocation = function () {
                $scope.searchterms.error = false;
                // $scope.searchterms.address = $window.lang === 'tr' ? "Yükleniyor..." : "Loading...";
                $scope.searchterms.loading = false;
                searchParserService.useLocation($scope.isLanding, $scope.actionType);
            };
            $rootScope.selectedMethod = $scope.isLanding ? 0 : $rootScope.selectedMethod ? $rootScope.selectedMethod : 0;

            $scope.saveSelectionTop = function () {
                $scope.searchterms.address = "";
                $scope.searchterms.coordinate = "";
                $scope.searchterms.id = "";
                $scope.searchterms.listing = "";
                $scope.searchterms.listingNo = "";
                $scope.searchterms.zemin = "";
                $scope.searchterms.error = false;
            };

            // $rootScope.$watch('address', function (val) {
            //   $scope.searchterms.address = val;
            // });


            $rootScope.$on("link_defined", function (event, data) {
                if ($state.current.name.indexOf('valuation') === -1) {
                    $rootScope.selectedMethod = 5;
                    $scope.searchterms.listing = data.query;
                    $window.lastLevel = 0;
                    searchId();
                }
            });

            $rootScope.$on("selected_city", function (event, data) {
                if (data.city)
                    $scope.searchterms.city = data.city;
                $scope.searchterms.country = data.country === 'espana' ? 2 : data.country === 'portugal' ? 3 : data.country === 'turkiye' ? 1 : 0;
                $rootScope.selectedMethod = ($rootScope.selectedMethod === 1 || $rootScope.selectedMethod === 0) ? ((typeof data.level === "undefined" || data.level === 10 || data.level === 9) ? 0 : 1) : $rootScope.selectedMethod;

                if (!data.city && data.country && data.country !== 'world' && $scope.searchterms.country !== data.country)
                    countryChanged();
            });

            $rootScope.$on('input_cleaned', function () {
                $scope.searchterms.address = null;
                $scope.searchterms.listing = null;
                $scope.searchterms.id = null;
                $scope.searchterms.coordinate = null;
                $scope.searchterms.zemin = null;
                $scope.searchterms.listingNo = null;
                $scope.searchterms.loading = false;
            });

            $scope.focusIn = function () {
                // $timeout(function () {
                $rootScope.searchFocused = 1;
                // }, 100);
            };

            $scope.focusOut = function () {
                $timeout(function () {
                    $rootScope.searchFocused = 0;
                }, 300);
            };

            $rootScope.parserSearchfromInputTop = function (section) {
                if (+section === 0) {
                    $window.lastLevel = 0;
                    countryCityChanged();
                } else if (+section === 1) {
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                } else if (+section === 2) {
                    $window.lastLevel = 0;
                    parcelChanged();
                } else if (+section === 3) {
                    $window.lastLevel = 0;
                    searchCoordinate();
                } else if (+section === 4) {
                    $window.lastLevel = 0;
                    searchAddressCode();
                } else if (+section === 5) {
                    $window.lastLevel = 0;
                    searchId();
                } else if (+section === 6) {
                    $window.lastLevel = 0;
                    searchTitleNo();
                } else if (+section === 7) {

                } else if (+section === 8) {
                    $window.lastLevel = 0;
                    searchListingNo();
                }
            };

            $scope.parserSearchfromInputTop = $rootScope.parserSearchfromInputTop;

            $scope.triggerTooltip = function () {
                const $tooltipEl = $('#search-error-tooltip');

                const hideTooltip = function () {
                    $tooltipEl.tooltip('hide');
                    $(document).off('click', hideTooltip);
                };

                $timeout(function () {
                    // Clean up any existing tooltips
                    $tooltipEl.tooltip('hide').tooltip('destroy');
                    $tooltipEl.removeData('bs.tooltip');
                    $('.tooltip').remove();

                    // Initialize a new tooltip after cleanup
                    $timeout(function () {
                        $tooltipEl.tooltip({ trigger: 'manual' }).tooltip('show');

                        // Hide tooltip when clicking outside
                        $(document).on('click', hideTooltip);

                        // Auto-hide tooltip after 4 seconds
                        $timeout(hideTooltip, 4000);
                    }, 50);
                }, 100);
            };
        }


    }
})();

(function () {
    'use strict';

    var serviceId = 'searchEngine';

    angular.module('app.common')
        .factory(serviceId, ['$q', 'yandexGeocode', 'Uavt', '$window', 'parcelClientService', 'urlSearchApi', 'searchParserService', searchEngine]);

    function searchEngine($q, yandexGeocode, Uavt, $window, parcelClientService, urlSearchApi, searchParserService) {
        var obj = {
            searchUrl: searchUrl,
            searchTitleNo: searchTitleNo,
            searchCoordinate: searchCoordinate,
            searchAddressCode: searchAddressCode,
            searchParcel: searchParcel,
            searchLocation: searchLocation,
            cleanRecords: cleanRecords
        };

        return obj;

        function cleanRecords() {
            $window.mallId = null;
            $window.endeksaId = null;
            $window.agentId = null;
            $window.opportId = null;
            $window.regionId = null;
            $window.projectId = null;
            $window.rememberProperty = null;
            $window.selectedLocation = null;
            $window.gatheredLocation = null;
            $window.parcelRecord = null;
        }


        function searchUrl(url) {
            var defer = $q.defer();
            window.dataLayer.push({
                event: "search",
                search_term: 'url',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var urlSearch = urlSearchApi.get({ ListingURL: url });
            urlSearch.$promise.then(function (res) {
                if (res.Lat) {
                    $window.rememberProperty = res;
                    $window.selectedLocation = res.Lon + ' ' + res.Lat;
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                } else {
                    defer.reject();
                }
            }, function (res) {
                if (res && res.data && res.data.Message)
                    defer.reject(res.data.Message);
                else
                    defer.reject();
            });
            return defer.promise;
        }

        function searchTitleNo(zemin) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'titledeed'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'titledeed',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            parcelClientService.getParcelInfoByPropertyId(zemin).then(
                function (result) {
                    $window.selectedLocation = result.data.center[0] + ' ' + result.data.center[1];
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                },
                function () {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        function searchCoordinate(coordinates) {
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'coordinate'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'coordinate',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var coords = coordinates.replaceAllString('#', '').replaceAllString('/ ', ' ').replaceAllString('/', ' ').replaceAllString(', ', ' ').replaceAllString(',', '').replaceAllString(';', ' ').replaceAllString(':', ' ').replace('parselsorgu.tkgm.gov.tr', '').replace('https', '').trim();
            var center = coords.split(' ');
            $window.selectedLocation = center[1] + ' ' + center[0];
            $window.gatheredLocation = $window.selectedLocation;
            var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
            return location;
        }
        function searchAddressCode(id) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'uavt'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'uavt',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            var uavt = Uavt.get({ id: id });
            uavt.$promise.then(function (res) {
                if (res.Location.Address) {
                    var address = res.Location.Address.replace(' TÜRKİYE', '').replace(' TURKEY', '');
                    yandexGeocode.geocodeAddress(address).then(function (location) {
                        $window.selectedLocation = location.lng() + ' ' + location.lat();
                        $window.gatheredLocation = $window.selectedLocation;;
                        var locationr = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                        defer.resolve(locationr);
                    }, function () {
                        defer.reject();
                    });
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            });

            return defer.promise;
        }

        function searchParcel(mahalle, ada, parsel) {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: 'parcel'
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'parcel',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            parcelClientService.getParcelByValues(mahalle, ada, parsel).then(function (result) {
                try {
                    result.data.center = searchParserService.centerInPoly(result.data.center)
                    $window.selectedLocation = result.data.center[0] + ' ' + result.data.center[1];
                    $window.gatheredLocation = $window.selectedLocation;
                    var location = $window.selectedLocation.split(' ')[1].replace('.', ',') + ";" + $window.selectedLocation.split(' ')[0].replace('.', ',');
                    defer.resolve(location);
                } catch (err) {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            });
            return defer.promise;
        }

        function searchLocation() {
            var defer = $q.defer();
            // if (typeof window.gtag !== 'undefined')
            //     window.gtag("event", "search", {
            //         search_term: "location"
            //     });
            window.dataLayer.push({
                event: "search",
                search_term: 'location',
                currency: window.currency,
                language: window.lang.split('-')[0]
            });
            if (typeof window.fbq != "undefined")
                try {
                    window.fbq('track', 'Search');
                } catch (err) { }
            cleanRecords();
            navigator.geolocation.getCurrentPosition(function (position) {
                console.log(position);
                if (position) {
                    var location = position.coords.latitude.toString().replace('.', ',') + ";" + position.coords.longitude.toString().replace('.', ',');
                    $window.selectedLocation = position.coords.longitude + ' ' + position.coords.latitude;
                    $window.gatheredLocation = $window.selectedLocation;
                    defer.resolve(location);
                }
                else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
            return defer.promise;
        }

    }
})();
(function () {
    'use strict';

    angular.module('ngtimeago', []);


    angular.module('ngtimeago').filter('timeago', function () {
        return function (input, p_allowFuture) {

            var substitute = function (stringOrFunction, number, strings) {
                var string = angular.isFunction(stringOrFunction) ? stringOrFunction(number, dateDifference) : stringOrFunction;
                var value = (strings.numbers && strings.numbers[number]) || number;
                return string.replace(/%d/i, value);
            },
                nowTime = (new Date()).getTime(),
                date = (new Date(input)).getTime(),
                //refreshMillis= 6e4, //A minute
                allowFuture = p_allowFuture || false,
                strings = {
                    prefixAgo: '',
                    prefixFromNow: '',
                    suffixAgo: window.lang === 'en' ? "ago" : "önce",
                    suffixFromNow: window.lang === 'en' ? "from now" : "sonra",
                    seconds: window.lang === 'en' ? "less then a minute" : "bir dakikadan az",
                    minute: window.lang === 'en' ? "a minute" : "bir dakika",
                    minutes: window.lang === 'en' ? "%d minutes" : "%d dakika",
                    hour: window.lang === 'en' ? "an hour" : "bir saat",
                    hours: window.lang === 'en' ? "%d hours" : "%d saat",
                    day: window.lang === 'en' ? "a day" : "1 gün",
                    days: window.lang === 'en' ? "%d days" : "%d gün",
                    month: window.lang === 'en' ? "a month" : "1 ay",
                    months: window.lang === 'en' ? "%d months" : "%d ay",
                    year: window.lang === 'en' ? "a year" : "1 yıl",
                    years: window.lang === 'en' ? "%d years" : "%d yıl"
                },
                dateDifference = nowTime - date,
                words,
                seconds = Math.abs(dateDifference) / 1000,
                minutes = seconds / 60,
                hours = minutes / 60,
                days = hours / 24,
                years = days / 365,
                separator = strings.wordSeparator === undefined ? " " : strings.wordSeparator,


                prefix = strings.prefixAgo,
                suffix = strings.suffixAgo;

            if (allowFuture) {
                if (dateDifference < 0) {
                    prefix = strings.prefixFromNow;
                    suffix = strings.suffixFromNow;
                }
            }

            words = seconds < 45 && substitute(strings.seconds, Math.round(seconds), strings) ||
                seconds < 90 && substitute(strings.minute, 1, strings) ||
                minutes < 45 && substitute(strings.minutes, Math.round(minutes), strings) ||
                minutes < 90 && substitute(strings.hour, 1, strings) ||
                hours < 24 && substitute(strings.hours, Math.round(hours), strings) ||
                hours < 42 && substitute(strings.day, 1, strings) ||
                days < 30 && substitute(strings.days, Math.round(days), strings) ||
                days < 45 && substitute(strings.month, 1, strings) ||
                days < 365 && substitute(strings.months, Math.round(days / 30), strings) ||
                years < 1.5 && substitute(strings.year, 1, strings) ||
                substitute(strings.years, Math.round(years), strings);
            prefix.replace(/ /g, '');
            words.replace(/ /g, '');
            suffix.replace(/ /g, '');
            return (prefix + ' ' + words + ' ' + suffix + ' ' + separator);

        };
    });

})();


(function () {
    'use strict';

    var serviceId = 'yandexGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$timeout', '$ocLazyLoad', '$rootScope', yandexGeocode]);

    function yandexGeocode($q, $http, $timeout, $ocLazyLoad, $rootScope) {
        var obj = {
            geocodeAddress: geocodeAddress
        };
        return obj;


        function ocLoadCheck(geocoDErest, deferred) {
            var counter = false;
            angular.element('script').filter(function (i, el) {
                var s = el.getAttribute('src');
                if (s && s.indexOf('maps.googleapis.com/maps') > -1) {
                    counter = true;
                }
            });
            if (!counter)
                $ocLazyLoad.load([
                    'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                ]).then(function () {
                    googleBackUp(geocoDErest, deferred);

                });
            else {
                googleBackUp(geocoDErest, deferred);
            }
        }

        function googleBackUp(geocoDErest, deferred) {
            if (typeof google !== 'undefined') {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode(geocoDErest, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        deferred.resolve(results[0].geometry.location);
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }
                });
            }
            else {
                deferred.reject({
                    lat: function () { return null; },
                    lng: function () { return null; },
                    data: 'Konum Bulunamadi',
                    errorType: 2
                });
            }
        }

        function geocodeAddress(address, type, skip) {
            var deferred = $q.defer();

            if (address === null || address === undefined || address === '') {
                deferred.reject({
                    lat: function () { return null; },
                    lng: function () { return null; },
                    data: 'Konum Bulunamadi',
                    errorType: 2
                });
            }

            const langu = $rootScope.lang === 'tr' ? 'tr_TR' : $rootScope.lang === 'es-ES' ? 'es_ES' : $rootScope.lang === 'pt-PT' ? 'pt_PT' : 'en_US';
            // const countryId = ($rootScope.country === 'turkiye') ? 1 : ($rootScope.country === 'espana') ? 2 : ($rootScope.country === 'portugal') ? 3 : 0;
            // const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

            var geocoDErest = {
                'address': address,

            };
            if ($rootScope.country === 'turkiye')
                geocoDErest.componentRestrictions = {
                    'country': 'TR'
                };
            else if ($rootScope.country === 'espana')
                geocoDErest.componentRestrictions = {
                    'country': 'ES'
                };
            else if ($rootScope.country === 'portugal')
                geocoDErest.componentRestrictions = {
                    'country': 'PT'
                };


            if (+type === 2 && $rootScope.country === 'turkiye')
                address = address + ' İlçesi';

            if (skip)
                $timeout(function () { deferred.resolve(null); }, 0);
            else {
                if ($rootScope.country !== 'turkiye')
                    ocLoadCheck(geocoDErest, deferred);
                else
                    $http({
                        dataType: 'json',
                        data: '',
                        method: 'GET',
                        url: 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&geocode=' + address + '&lang=' + langu + '&format=json'
                    }).then(
                        function (geocodeOk) {
                            if (+geocodeOk.status === 200) {
                                if (+geocodeOk.data.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.found === 0) {
                                    ocLoadCheck(geocoDErest, deferred);
                                }
                                else {
                                    deferred.resolve({
                                        lat: function () {
                                            var lat = parseFloat(geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.Point.pos.split(" ")[1]);
                                            if (lat - 40.965544 === 0) {
                                                lat = lat - 0.061;
                                            }

                                            return lat;
                                        },
                                        lng: function () {
                                            var lng = parseFloat(geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.Point.pos.split(" ")[0]);
                                            if (lng - 29.106000 === 0) {
                                                lng = lng + 0.000290;
                                            }
                                            else if (lng - 29.052037 === 0) {
                                                lng = lng - 0.01;
                                            }
                                            return lng;
                                        },
                                        name: geocodeOk.data.response.GeoObjectCollection.featureMember["0"].GeoObject.name
                                    });
                                }
                            }
                            else {
                                ocLoadCheck(geocoDErest, deferred);
                            }

                        }, function () {
                            ocLoadCheck(geocoDErest, deferred);
                        });
            }

            return deferred.promise;
        }
    }
})();



(function () {
    'use strict';

    var serviceId = 'yandexReverseGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$ocLazyLoad', '$rootScope', yandexReverseGeocode]);

    function yandexReverseGeocode($q, $http, $ocLazyLoad, $rootScope) {
        var obj = {
            geocodeLatlng: geocodeLatlng
        };

        function ocLoadCheck(lat, lng, deferred) {
            var counter = false;
            angular.element('script').filter(function (i, el) {
                var s = el.getAttribute('src');
                if (s && s.indexOf('maps.googleapis.com/maps') > -1) {
                    counter = true;
                }
            });
            if (!counter)
                $ocLazyLoad.load([
                    'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + window.lang
                ]).then(function () {
                    googleBackUp(lat, lng, deferred);

                });
            else {
                googleBackUp(lat, lng, deferred);
            }
        }

        function googleBackUp(lat, lng, deferred) {
            var geocoder = new google.maps.Geocoder;
            var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        var last = results[0].formatted_address.split(', ').pop();
                        var result = results[0].formatted_address.replace(last, '').replace('/', ', ').replace('Provincia De', '').replace('Unnamed Road', '').replace('district', '').replace('province', '');
                        var toBeremoved = [];
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            if (results[0].address_components[i].types.indexOf('political') > -1)
                                toBeremoved.push(results[0].address_components[i].long_name);
                        }
                        for (var i = 0; i < toBeremoved.length; i++) {
                            result = result.replace(toBeremoved[i], '');
                        }
                        result = result.replaceAll(' ,', '');

                        deferred.resolve(result);
                    } else {
                        deferred.reject();
                    }
                } else {
                    deferred.reject();
                }
            });
        }


        function geocodeLatlng(lat, lng) {
            var deferred = $q.defer();

            const langu = $rootScope.lang === 'tr' ? 'tr_TR' : $rootScope.lang === 'es-ES' ? 'es_ES' : $rootScope.lang === 'pt-PT' ? 'pt_PT' : 'en_US';
            // const countryId = ($rootScope.country === 'turkiye') ? 1 : ($rootScope.country === 'espana') ? 2 : ($rootScope.country === 'portugal') ? 3 : 0;
            // const langu = countryId === 1 ? 'tr_TR' : countryId === 2 ? 'es_ES' : countryId === 3 ? 'pt_PT' : 'en_US';

            if ($rootScope.country !== 'turkiye')
                ocLoadCheck(lat, lng, deferred);
            else
                $http({
                    method: 'GET',
                    dataType: 'json',
                    data: '',
                    url: 'https://geocode-maps.yandex.ru/1.x/?apikey=ea627200-e11e-49f5-b1b7-3c79067019c9&geocode=' + lng + ',' + lat + '&lang=' + langu + '&format=json'
                }).then(function (geocodeOk) {
                    if (geocodeOk.status === 200) {
                        try {
                            var addr1, addr = geocodeOk.data.response.GeoObjectCollection.featureMember[0].GeoObject;
                            if (geocodeOk.data.response.GeoObjectCollection.featureMember[1])
                                addr1 = geocodeOk.data.response.GeoObjectCollection.featureMember[1].GeoObject;

                            if (addr1 && (addr.description.indexOf(addr1.description) > -1 || addr1.description.indexOf(addr.description) > -1)) {
                                var result = addr.name + ", " + addr.description;
                                var pop = result.split(', ').pop();
                                result = result.replace(pop, '').replace('Provincia de ', '').replace('District', '').replace('Province', '');

                                if (result.slice(-2) === ', ')
                                    result = result.slice(0, -2);

                                deferred.resolve(result);
                            }
                            else {
                                ocLoadCheck(lat, lng, deferred);
                            }
                        }
                        catch (err) {
                            ocLoadCheck(lat, lng, deferred);
                        }
                    }
                    else {
                        ocLoadCheck(lat, lng, deferred);

                    }
                }, function () {
                    ocLoadCheck(lat, lng, deferred);
                });
            return deferred.promise;
        }

        return obj;
    }

})();

(function () {
    'use strict';

    var serviceId = 'endeksaGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$timeout', 'appSettingsSvc', 'CacheFactory', endeksaGeocode]);

    function endeksaGeocode($q, $http, $timeout, appSettingsSvc, CacheFactory) {

        var storageImpl = {
            getItem: function (key) { return localStorage.getItem(key); },
            setItem: function (key, value) {
                try {
                    return localStorage.setItem(key, value);
                } catch (err) {
                    const accessToken = localStorage.getItem('accessToken');
                    const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                    const refreshToken = localStorage.getItem('refreshToken');
                    const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                    localStorage.clear();
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('accessTokenExpires', accessTokenExpires);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                    window.userStorage.sync();
                    return localStorage.setItem(key, value);
                }
            },
            removeItem: function (key) { return localStorage.removeItem(key); },
        };
        if (!CacheFactory.get('GeoMap'))
            CacheFactory('GeoMap', {
                deleteOnExpire: 'aggressive',
                maxAge: 24 * 60 * 60 * 1000,
                storageImpl: storageImpl,
                //  storageMode: 'localStorage'
            });

        if (!CacheFactory.get('GeoMapAddress'))
            CacheFactory('GeoMapAddress', {
                deleteOnExpire: 'aggressive',
                maxAge: 24 * 60 * 60 * 1000,
                storageImpl: storageImpl,
                //  storageMode: 'localStorage'
            });

        var obj = {
            geocodeAddress: geocodeAddress,
            geocodeUrl: geocodeUrl
        };

        return obj;

        function geocodeAddress(address) {
            var deferred = $q.defer();
            var cache = CacheFactory.get('GeoMapAddress');
            $http({
                dataType: 'json',
                data: '',
                method: 'GET',
                cache: cache,
                timeout: deferred.promise,
                skipAuthorization: true,
                url: appSettingsSvc.CACHE + '/geo/coding?searchText=' + encodeURI(address) + '&language=' + window.langCode()
            }).then(
                function (geocodeOk) {
                    if (geocodeOk.data && geocodeOk.data.length) {
                        geocodeOk.data =  JSON.parse(window.encodeResponse(geocodeOk.data));
                        deferred.resolve({
                            lat: function () {
                                var lat = geocodeOk.data[0].Lat;
                                return lat;
                            },
                            lng: function () {
                                var lng = geocodeOk.data[0].Lon;
                                return lng;
                            },
                            cityId: geocodeOk.data[0].CityId,
                            city: geocodeOk.data[0].CityName,
                            countyId: geocodeOk.data[0].CountyId,
                            county: geocodeOk.data[0].CountyName,
                            districtId: geocodeOk.data[0].DistrictId,
                            district: geocodeOk.data[0].DistrictName
                        });
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }

                }, function () {
                    deferred.reject({
                        lat: function () { return null; },
                        lng: function () { return null; },
                        data: 'Konum Bulunamadi',
                        errorType: 2
                    });
                });

            return deferred.promise;
        }

        function doGeocode(country, city, county, district, block, parcel, deferred, quarter) {
            var cache = CacheFactory.get('GeoMap');

            if (block && block.indexOf('/') > -1 && !parcel) {
                parcel = block.split('/')[1];
                block = block.split('/')[0];
            }

            $http({
                dataType: 'json',
                method: 'GET',
                cache: cache,
                timeout: deferred.promise,
                skipAuthorization: true,
                url: appSettingsSvc.CACHE + '/geo/coding?countryname=' + normalizeAddress(country) + '&cityname=' + (city ? normalizeAddress(city) : '') + '&countyname=' + (county ? normalizeAddress(county) : '') + (quarter ? '&quartername=' + normalizeAddress(quarter) : '') + '&districtname=' + (district ? normalizeAddress(district) : '') + '&block=' + (block ? block : '') + '&parcel=' + (parcel ? parcel : '')
            }).then(
                function (geocodeOk) {
                    if (geocodeOk && geocodeOk.data) {
                        geocodeOk.data =  JSON.parse(window.encodeResponse(geocodeOk.data));
                        var result = {
                            lat: function () {
                                var lat = geocodeOk.data.Lat;
                                return lat;
                            },
                            lng: function () {
                                var lng = geocodeOk.data.Lon;
                                return lng;
                            },
                            countryId: geocodeOk.data.CountryId,
                            country: geocodeOk.data.CountryName,
                            cityId: geocodeOk.data.CityId,
                            city: geocodeOk.data.CityName,
                            county: geocodeOk.data.CountyName,
                            countyId: geocodeOk.data.CountyId,
                            district: geocodeOk.data.DistrictName,
                            districtId: geocodeOk.data.DistrictId,
                            parcelId: geocodeOk.data.ParcelId,
                            blockId: geocodeOk.data.BlockId,
                            population: geocodeOk.data.Population
                        }
                        deferred.resolve(result);
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }

                }, function (error) {
                    deferred.reject({
                        lat: function () { return null; },
                        lng: function () { return null; },
                        data: 'Konum Bulunamadi',
                        errorType: 2
                    });
                    // $timeout(function () { doGeocode(country, city, county, district, block, parcel, deferred); }, 2000);
                });
        }

        function geocodeUrl(country, city, county, district, block, parcel, quarter) {
            var deferred = $q.defer();
            if (city && city.toLocaleLowerCase2('tr-tr').indexOf("reg-") > -1 || city && city.toLocaleLowerCase2('tr-tr').indexOf("reg-") > -1) {
                deferred.resolve({
                    lat: function () {
                        var lat = 40.9833;
                        return lat;
                    },
                    lng: function () {
                        var lng = 29.1167;
                        return lng;
                    },
                    country: 'Türkiye'
                });
            }
            else
                doGeocode(country, city, county, district, block, parcel, deferred, quarter);

            return deferred.promise;
        }
    }
})();

(function () {
    "use strict";

    var serviceId = "notificationService";

    angular.module("app.common").factory(serviceId, notificationService);

    notificationService.$inject = [
        "$q",
        "notification_factory",
        "notifierSvc",
        "CacheFactory",
        "$rootScope",
        "moment",
        "$translate"
    ];

    function notificationService(
        $q,
        notification_factory,
        notifierSvc,
        CacheFactory,
        $rootScope,
        moment,
        $translate
    ) {
        var service = {
            list: list,
            read: read,
            readAll: readAll,
            purgeCache: purgeCache,
            getNotifications: getNotifications,
            notifications: [],
            params: {page: 1, itemsPerPage: 20},
        };

        function list(query) {
            var deferred = $q.defer();
            notification_factory.list(query).$promise.then(function (result) {
                deferred.resolve(result.mobileDeviceNotificationDtos);
            }, function (err) {
                console.error(err);
                deferred.reject();
            });

            return deferred.promise;
        }

        function getNotifications () {
            var deferred = $q.defer();
            $rootScope.unreadNotifications = 0;
            service.notifications.length = 0;
            service.list(service.params).then(function (result) {
                if ($rootScope.upcomingPayment && $rootScope.upcomingPayment.unpaidPrice > 0 && $rootScope.upcomingPayment.paymentDaysRemaining <= $rootScope.upcomingPayment.notificationTreshold) {
                    var productName = $rootScope.lang === 'tr'
                        ? $rootScope.upcomingPayment.product.nameTurkish
                        : $rootScope.upcomingPayment.product.nameEnglish;
                    var upcomingPayment = {
                            createdDate: $rootScope.upcomingPayment.notificationCreatedDate,
                            isRead: $rootScope.upcomingPayment.notificationIsRead,
                            key: 300,
                            content: (() => {
                                var translateKey;
                                if ($rootScope.upcomingPayment.paymentDaysRemaining > 0) {
                                    translateKey = 'n_payment_warning';
                                } else if ($rootScope.upcomingPayment.paymentDaysRemaining === 0) {
                                    translateKey = 'n_payment_warning_today';
                                } else {
                                    translateKey = 'n_payment_warning_past';
                                }
                                return $translate.instant(translateKey, {productName: productName, daysRemaining: Math.abs($rootScope.upcomingPayment.paymentDaysRemaining)}) + ' ' + $translate.instant('n_payment_warning_click');
                            })(),
                            title: "Payment Reminder",
                        };
                    result.unshift(upcomingPayment);
                }
                result.map(function (n) {
                        if (n.key !== 300) {
                            let utc = new Date(n.createdDate);
                            var offset = utc.getTimezoneOffset($rootScope.lang);
                            var local = new Date(utc.getTime() - offset * 60000);
                            n.createdDate = local;
                        }
                        if (n.key !== 50 && !n.isRead) $rootScope.unreadNotifications++;
                        service.notifications.push(n);
                });
                deferred.resolve(service.notifications);
            })
        }

        function read (notification) {
            var deferred = $q.defer();
            if (notification.key === 300) {
                if (!notification.isRead) {
                    $rootScope.upcomingPayment.notificationIsRead = true;
                    $rootScope.setUpcomingPaymentToCookie($rootScope.upcomingPayment);
                    if ($rootScope.unreadNotifications > 0) {
                        $rootScope.unreadNotifications--;
                    }
                }
                deferred.resolve();
                return deferred.promise;
            }
            notification_factory.read({notificationId: notification.id, isRead: true}).$promise
            .then(function () {
                service.purgeCache();
                service.getNotifications();
                deferred.resolve();
            }, function () {
                deferred.reject();
            })

            return deferred.promise;
        }

        function readAll () {
            var deferred = $q.defer();
            notification_factory.readAll().$promise
            .then(function () {
                service.purgeCache();
                service.getNotifications();
                deferred.resolve();
            }, function (err) {
                console.error(err);
                deferred.reject();
            })

            return deferred.promise;
        }

        function purgeCache () {
            CacheFactory.get('NotificationList') && CacheFactory.get('NotificationList').removeAll();
        }

        return service;
    }
})();
(function () {
	'use strict';

	angular
		.module('app.common')
		.directive('investment', Investment);

	function Investment() {
		var directive = {
			templateUrl: '/app/common/investment.html',
			scope: {
				valueIncrease: '=',
				rentIncrease: '=',
				forecastLoading: '=',
				rent: '=',
				sales: '=',
				land: '=',
				field: '=',
				propertyage: '=',
				tasinmazid: '='
			},
			restrict: 'EA',
			controller: investmentController,
			controllerAs: 'vm',
			bindToController: true
		};
		return directive;
	}
	investmentController.$inject = ['$timeout', '$rootScope',"$state"];
	function investmentController($timeout, $rootScope,$state) {
		var vm = this;
		vm.loanTerms = [
			{ value: 12, label: '1 yıl (12 ay)' },
			{ value: 24, label: '2 yıl (24 ay)' },
			{ value: 36, label: '3 yıl (36 ay)' },
			{ value: 48, label: '4 yıl (48 ay)' },
			{ value: 60, label: '5 yıl (60 ay)' },
			{ value: 72, label: '6 yıl (72 ay)' },
			{ value: 84, label: '7 yıl (84 ay)' },
			{ value: 96, label: '8 yıl (96 ay)' },
			{ value: 108, label: '9 yıl (108 ay)' },
			{ value: 120, label: '10 yıl (120 ay)' }
		];

/* 		vm.redirectToUrl = function () {
			var queryParams = {
				amount: vm.calculation.principal,
				installment: vm.calculation.payments,
				id: vm.tasinmazid,
				langcode: $rootScope.lang
			};
			$state.go('mortgage-akbank', queryParams);

		}; */

		var assignValuation = function () {
			vm.calculation.valueIncrease = +vm.valueIncrease;
			vm.calculation.rentIncrease = +vm.rentIncrease;
			vm.forecastLoading = false;

			vm.calculation.value = vm.sales;
			vm.calculation.declaredValue = vm.sales;
			vm.calculation.rent = vm.rent;
			vm.calculation.principal = !vm.land && !vm.field ? Math.floor(vm.calculation.value * vm.calculation.loanAllowance / 100, 0) : 0;
			vm.calculation.maintenance = vm.land || vm.field ? 0 : vm.calculation.maintenance;

			vm.calculation.deprecation = vm.land || vm.field ? 0 : calculateDeprecation(vm.calculation.deprecation, vm.propertyage);
			vm.calculation.valueIncrease = (vm.land || vm.field) && !vm.calculation.valueIncrease ? vm.calculation.inflation : vm.calculation.valueIncrease;
			vm.iterateReturn(1, 1);
		}
		$timeout(function () {
			assignValuation();
		});

		$rootScope.$on('forecastLoaded', function (e, data) {
			vm.valueIncrease = +data.valueIncrease;
			vm.rentIncrease = +data.rentIncrease;
			assignValuation();
		});

		vm.calculation = {
			value: 0,
			declaredValue: 0,
			rent: 0,

			principal: 0,
			rentIncrease: 35,
			valueIncrease: 50,
			inflation: 32.5,

			interest: 3.13,
			loanAllowance: 40,
			downPayment: 0,
			payments: 60,
			duration: 120,

			tax: 4,
			comission: 4,
			insurance: 0,

			maintenance: 2000,
			deprecation: 4,

			result: {
				isRent: false,

				monthlyPayment: 0,
				totalPayment: 0,
				totalInterest: 0,

				tax: 0,
				comission: 0,

				totalInvestment: 0,
				totalIncome: 0,
				totalNetIncome: 0,
				totalExpense: 0,
				totalProfit: 0,
			}
		}

		vm.showCalculated = true;
		var maxAmortization = 1200;
		vm.iterateReturn = function (x, force, deprecation, profit) {
			var breakeven = vm.calculation.result.totalProfit;
			if (profit == 1) {
				vm.calculation.result.isRent = false;
				breakeven = vm.calculation.result.totalProfit;
			}
			else if (profit == 2) {
				vm.calculation.result.isRent = true;
				breakeven = vm.calculation.result.totalNetIncome;
			}
			if (vm.calculation.rent <= 0) {
				vm.calculation.result.isRent = false;
				breakeven = vm.calculation.result.totalProfit;
			}
			if (x <= maxAmortization && breakeven < 0 || force) {
				vm.showCalculated = true;
				vm.calculation.duration = x;
				vm.calculateReturn(deprecation);
				x++;
				vm.iterateReturn(x, 0, deprecation, profit);
			} else if (x > maxAmortization) {
				vm.showCalculated = false;
			}
		}
		vm.numericValue = { currencySymbol: window.currencySymbol, currencySymbolPlacement: 's', decimalPlaces: 0, outputFormat: 'number', upDownStep: 250, modifyValueOnWheel: false, minimumValue: 0 };
		vm.numericRate = { suffixText: '%', decimalPlaces: 2, outputFormat: 'number', upDownStep: 0.01, modifyValueOnWheel: false, minimumValue: 0 };
		vm.numericMonth = { decimalPlaces: 0, outputFormat: 'number', upDownStep: 1, modifyValueOnWheel: false, maximumValue: maxAmortization, minimumValue: 0 };
		vm.numericMonthMin = { decimalPlaces: 0, outputFormat: 'number', upDownStep: 1, modifyValueOnWheel: false, maximumValue: maxAmortization, minimumValue: 1 };

		var calculateDeprecation = function (duration, actualAge) {
			var age = +(duration / 12 + actualAge);

			if (age <= 3) {
				return 4;
			} else if (age >= 4 && age <= 5) {
				return 6;
			} else if (age >= 6 && age <= 10) {
				return 10;
			} else if (age >= 11 && age <= 15) {
				return 15;
			} else if (age >= 16 && age <= 20) {
				return 20;
			} else if (age >= 21 && age <= 30) {
				return 25;
			} else if (age >= 31 && age <= 40) {
				return 32;
			} else if (age >= 41 && age <= 50) {
				return 40;
			} else if (age >= 51 && age <= 75) {
				return 50;
			} else if (age > 75) {
				return 60;
			} else {
				return 10;
			}
		}

		vm.calculateReturn = function (deprecation) {
			vm.calculation.loanAllowance = Math.floor(vm.calculation.principal / vm.calculation.value * 100, 0);
			vm.calculation.insurance = Math.floor(vm.calculation.principal * 3.5 / 100, 0);

			vm.calculation.downPayment = vm.calculation.value - vm.calculation.principal;

			if (!deprecation)
				vm.calculation.deprecation = vm.land || vm.field ? 0 : calculateDeprecation(vm.calculation.duration, vm.propertyage);


			//vm.calculation.interest = vm.calculation.payments <= interestValuesAkbank.rates[0].barrier ? interestValuesAkbank.rates[0].higherRate : interestValuesAkbank.rates[0].lowerRate
			vm.calculation.interest = window.getMortgageRate(window.interestValuesAkbank, 'insured', vm.calculation.payments);
			var principal = vm.calculation.principal;
			var interest = vm.calculation.interest > 0 ? vm.calculation.interest / 100 : 0;
			var payments = vm.calculation.payments;

			var x = Math.pow(1 + interest, payments);
			var monthly = principal * x * interest > 0 ? (principal * x * interest) / (x - 1) : principal / payments;

			vm.calculation.result.monthlyPayment = Math.round(monthly);
			vm.calculation.result.totalPayment = Math.round(monthly * payments);
			vm.calculation.result.totalInterest = Math.round((monthly * payments) - principal);

			vm.calculation.result.tax = Math.floor(vm.calculation.declaredValue * vm.calculation.tax / 100, 0);
			vm.calculation.result.comission = Math.floor(vm.calculation.value * vm.calculation.comission / 100, 0);

			vm.calculation.result.totalExpense = vm.calculation.insurance + vm.calculation.result.tax + vm.calculation.result.comission;
			vm.calculation.result.totalInvestment = vm.calculation.downPayment + vm.calculation.result.totalPayment + vm.calculation.result.totalExpense;

			vm.calculation.maintenance = vm.calculation.rent > 0 ? 2000 : 500;

			vm.calculation.result.totalMaintenance = calculateRentIncome(vm.calculation.maintenance * 12, vm.calculation.inflation, vm.calculation.duration);


			vm.calculation.result.totalValueIncome = addInflation(vm.calculation.value, vm.calculation.valueIncrease, vm.calculation.duration);
			vm.calculation.result.totalDeprecation = Math.abs(vm.calculation.result.totalValueIncome * vm.calculation.deprecation / 100);

			vm.calculation.result.totalRentIncome = calculateRentIncome(vm.calculation.rent * 12, vm.calculation.rentIncrease, vm.calculation.duration);
			vm.calculation.result.totalTax = vm.calculation.result.totalRentIncome > 0 ? vm.calculation.result.totalRentIncome / 12 : 0;

			vm.calculation.result.totalCost = vm.calculation.result.totalPayment + vm.calculation.result.totalMaintenance + vm.calculation.result.totalTax + addInflation(+(vm.calculation.downPayment + vm.calculation.result.totalExpense), vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.totalNetIncome = (vm.calculation.rent > 0 ? vm.calculation.result.totalRentIncome - vm.calculation.result.totalCost : 0);
			vm.calculation.result.totalNetIncomePV = calculatePresentValue(vm.calculation.result.totalNetIncome, vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.yield = +(vm.calculation.result.totalNetIncome / (vm.calculation.result.totalValueIncome - vm.calculation.result.totalDeprecation) * 100).toFixed(2);
			vm.calculation.result.totalLostOnInflation = addInflation(vm.calculation.value, vm.calculation.inflation, vm.calculation.duration);

			vm.calculation.result.totalProfit = vm.calculation.result.totalValueIncome - vm.calculation.result.totalLostOnInflation - vm.calculation.result.totalDeprecation + vm.calculation.result.totalNetIncome;
			vm.calculation.result.totalProfitPV = calculatePresentValue(vm.calculation.result.totalProfit, vm.calculation.inflation, vm.calculation.duration);
		}

		function calculatePresentValue(futureValue, inflationRate, months) {
			var years = months / 12;
			inflationRate = inflationRate > 0 ? inflationRate / 100 : 0;
			var discountRate = Math.pow(1 + inflationRate, years);
			var presentValue = futureValue / discountRate;
			return +(presentValue.toFixed(2));
		}

		function calculateRentIncome(initialRent, inflationRate, periods) {
			var i = inflationRate > 0 ? inflationRate / 100 : 0;
			var n = periods / 12;

			var rentIncome = initialRent * ((Math.pow(1 + i, n) - 1) / i);
			return +(rentIncome.toFixed(2));
		}

		function addInflation(originalAmount, inflationRate, months) {
			var i = inflationRate > 0 ? inflationRate / 100 : 0;
			var n = months / 12;
			return +((originalAmount * Math.pow(1 + i, n)).toFixed(2));
		}


	}
})();
(function () {
    'use strict';
    angular.module('app.common')
        .directive('investmentCardLanding', [function () {
            var directive = {
                templateUrl: '/app/common/investment-card.html',
                scope: {
                    data: '<'
                },
                restrict: 'EA',
                replace: false,
                link: function(scope, element, attrs) {                
                    scope.lastUpdateDate = function(investment) {
                        return investment.UpdateDate || investment.CreateDate;
                    };
                    
                    function calculateDaysPast (firstDate , lastDate) { 
                        var start = moment(firstDate); 
                        var end = moment(lastDate);
                        
                        var duration = Math.ceil(moment.duration(end.diff(start)).asDays());
                        
                        return duration
                    }
                    
                    // Calculate daysPast for current data - same logic as investmentController
                    if (scope.data) {
                        let lastDate;
                        if (scope.data.ListingActive) {
                            lastDate = new Date();
                        } else {
                            lastDate = new Date(scope.data.LastActivityDate);
                        }
                        
                        scope.data.daysPast = calculateDaysPast(scope.data.CreateDate, lastDate);
                    }
                }
            };
            return directive;
        }]);
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('investmentAnalysis', investmentAnalysis);


    function investmentAnalysis() {
        var directive = {
            templateUrl: '/app/common/investment-analysis.html',
            restrict: 'EA',
            scope: {
                property: '=',        // main property object (InvestmentAnalysis contains)
                showContainer: '=?',  // show/hide container style (optional)
                loading: '=?'         // Loading state (optional)
            },
            controller: ['$scope', InvestmentAnalysisController]
        };
        return directive;

        function InvestmentAnalysisController($scope) {
            // Math.abs helper
            $scope.abs = Math.abs;

            // Default showContainer to true if not provided
            if ($scope.showContainer === undefined) {
                $scope.showContainer = true;
            }
        }
    }
})();

/**
 * @ngdoc directive
 * @name app.endeks.directive:edInputForm
 * @element div
 * @description
 * Yeni değerleme sayfasında + ve - butonları ile number tipinde input elemanı oluşturur.
 * **Note:**
 * @example
 *<example module="endeks.app">
    <file name="index.html">
         <ed-input-form input="vm.odasayisi" minval="1" maxval="30" label="Oda Sayısı"></ed-input-form data>
    </file>
</example>
*/
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('edInputForm', edInputForm);

    function edInputForm() {
        var directive = {
            templateUrl: '/app/valuation/valuation-input.html',
            scope: {
                input: '=',
                defaultval: '=',
                minval: '<',
                maxval: '<',
                iszero: '@',
                placeholder: '@',
                label: '@',
                isfloat: '@',
                isdisabled: '@',
                required: '@',
                incrementRate: '<',
                startValue: '<',
                forcestyle: '@',
                handleOnChange: '&',
                warningText: '=',
                warningTextSecond: '=',
                warningRule: '<',
            },
            restrict: 'EA',
            controller: edInputFormController,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, element, attributes,ngModel){
                scope.required = attributes.$attr.required;
                
    
            }
        };
        return directive;

    }

    function edInputFormController() {
        var vm = this;
        vm.decreaseVal = decreaseVal;
        vm.increaseVal = increaseVal;
        vm.checkMinMax = checkDefaultValue;
        
        function checkDefaultValue(val) {
            if(!vm.isfloat && val)
                vm.input = Math.round(val);

            if (vm.defaultval && !val) {
                vm.input = vm.defaultval;
            }
            if (vm.input < vm.minval) {
                vm.input = vm.minval;
                vm.minvalError = true;
            }
            else if (vm.input > vm.maxval) {
                vm.input = vm.maxval;
                vm.maxvalError = true;
            }
            else {
                vm.minvalError = false;
                vm.maxvalError = false;
            }
        }

        function decreaseVal() {
            vm.maxvalError = false;
            if (!vm.input) {
                vm.input = 0;
            }
            if (vm.incrementRate) {
                var decnum = (+vm.incrementRate).countDecimals();
                vm.input = +((+vm.input - +vm.incrementRate).toFixed(decnum));
            }
            else {
                vm.input = +vm.input - 1;
            }

            if (vm.input < vm.minval) {
                vm.input = vm.minval;
                vm.minvalError = true;
                vm.handleChange(vm.input)
                return vm.input;
            }
            else {
                vm.minvalError = false;
                vm.handleChange(vm.input)
                return vm.input;
            }
        }

        function increaseVal() {
            vm.minvalError = false;
            if (!vm.input) {
                vm.input = vm.startValue || 0;
            }
            if (vm.incrementRate) {
                var decnum = (+vm.incrementRate).countDecimals();
                vm.input = +((+vm.input + +vm.incrementRate).toFixed(decnum));
            }
            else {
                vm.input = +vm.input + 1;
            }
            if (vm.input > vm.maxval) {
                vm.input = vm.maxval;
                vm.maxvalError = true;
                vm.handleChange(vm.input)
                return vm.input;
            }
            else {
                vm.maxvalError = false;
                vm.handleChange(vm.input)
                return vm.input;
            }
        }
        vm.handleChange = function() {
            vm.handleOnChange({input:vm.input})
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('checkboxPills', checkboxPills);

    checkboxPills.$inject = ['$timeout'];

    function checkboxPills($timeout) {
        return {
            restrict: 'E',
            scope: {
                items: '<',
                selectedItems: '=?',
                disabled: '=?',
                onChange: '&?'
            },
            templateUrl: '/app/common/checkbox-pills.html',
            link: function (scope) {
                // Initialize selected items if not provided
                if (!scope.selectedItems) {
                    scope.selectedItems = [];
                }

                // Toggle selection
                scope.toggleSelection = function (item) {
                    // Check if disabled globally or item is disabled
                    if (scope.disabled || item.disabled) return;

                    // Handle both Value property (0/1) and direct selection array
                    if (item.hasOwnProperty('Value')) {
                        item.Value = item.Value ? 0 : 1;
                    } else {
                        var idx = scope.selectedItems.indexOf(item.Id);
                        if (idx > -1) {
                            scope.selectedItems.splice(idx, 1);
                        } else {
                            scope.selectedItems.push(item.Id);
                        }
                    }

                    // Trigger onChange callback after digest cycle completes
                    if (scope.onChange) {
                        $timeout(function () {
                            scope.onChange({ item: item });
                        });
                    }
                };

                // Check if item or container is disabled
                scope.isDisabled = function (item) {
                    return scope.disabled || item.disabled;
                };

                // Check if item is selected
                scope.isSelected = function (item) {
                    if (item.hasOwnProperty('Value')) {
                        return item.Value === 1 || item.Value === true;
                    }
                    return scope.selectedItems.indexOf(item.Id) > -1;
                };

                // Check if item should be shown
                scope.shouldShow = function (item) {
                    // Always show items - pills should remain visible when unselected
                    return true;
                };
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('radioPills', radioPills);

    radioPills.$inject = ['$timeout'];

    function radioPills($timeout) {
        return {
            restrict: 'E',
            scope: {
                items: '<',
                selectedValue: '=ngModel',
                disabled: '=?',
                name: '@',
                required: '=?',
                onChange: '&?'
            },
            templateUrl: '/app/common/radio-pills.html',
            link: function (scope) {
                // Select item
                scope.selectItem = function (item) {
                    // Check if disabled globally or item is disabled
                    if (scope.disabled || item.disabled) return;

                    scope.selectedValue = item.Id;

                    // Trigger onChange callback after digest cycle completes
                    if (scope.onChange) {
                        $timeout(function () {
                            scope.onChange({ item: item, value: item.Id });
                        });
                    }
                };

                // Check if item or container is disabled
                scope.isDisabled = function (item) {
                    return scope.disabled || item.disabled;
                };

                // Check if item is selected
                scope.isSelected = function (item) {
                    return scope.selectedValue === item.Id;
                };

                // Check if item should be shown (active items only)
                scope.shouldShow = function (item) {
                    if (item.hasOwnProperty('isActive')) {
                        return item.isActive;
                    }
                    return true;
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('app.common').filter('unsafe', unsafeFunction);

    unsafeFunction.$inject = ['$sce'];

    function unsafeFunction($sce) {
        return function (val) {
            val = val && val.includes('&lt;') ? val.replaceAllString('&lt;','<').replaceAllString('&gt;','>') : val;
            return $sce.trustAsHtml(val);
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.shell')
        .directive('edFooter', edFooter);

    function edFooter() {
        var directive = {
            // controller: ['$scope', '$rootScope', '$state', controller],
            templateUrl: '/app/content/footer/edFooter.html',
            // restrict: 'EA',
            // scope: {
            //     language: '@language'
            // }
        };
        return directive;

        // function controller($scope, $rootScope, $state) {
        //     $scope.lang = $rootScope.lang;

        // }
    }

})();
(function () {
	'use strict';

	angular.module('app.shell').directive('edFooterSimple', [edFooterSimple]);

	function edFooterSimple() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterSimple.html',
			// restrict: 'EA',
			// scope: {},
		};
		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;


		// }
	}
})();

(function () {
	'use strict';

	angular.module('app.shell').directive('edFooterSimpler', [edFooterSimpler]);

	function edFooterSimpler() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterSimpler.html',
			// restrict: 'EA',
			// scope: {},
		};
		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;


		// }
	}
})();

(function() {
	'use strict';
	angular.module('app.shell').directive('edFooterInternal', edFooterInternal);

	function edFooterInternal() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterInternal.html',
			// restrict: 'EA',
			// scope: {}
		};

		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;
		// }
	}
})();

(function() {
	'use strict';
	angular.module('app.shell').directive('edFooterCopyright', edFooterCopyright);

	function edFooterCopyright() {
		var directive = {
			// controller: ['$scope', controller],
			templateUrl: '/app/content/footer/edFooterCopyright.html',
			// restrict: 'EA',
			// scope: {}
		};

		return directive;

		// function controller($scope) {}
	}
})();

(function () {
    'use strict';

    var serviceId = 'appActivitySvc';

    angular.module('app.core')
        .factory(serviceId, ['$rootScope', appActivitySvc]);

    function appActivitySvc($rootScope) {
        var service = {
            busy: busy,
            idle: idle,
            info: {
                isBusy: false
            },
            reset: reset
        };

        var activities = [];

        return service;

        function busy(name) {
            if (!name) {
                throw { name: 'Error', message: 'A valid activity name must be provided.' };
            }

            if (!activities[name]) {
                activities.push(name);
            }

            updateStatus();
        }

        function idle(name) {
            if (!name) {
                throw { name: 'Error', message: 'A valid activity name must be provided.' };
            }

            if (!activities[name]) {
                activities.pop(name);
            }

            updateStatus();
        }

        function updateStatus() {

            var newStatus = activities.length > 0;

            if (service.info.isBusy !== newStatus) {
                service.info.isBusy = newStatus;
                $rootScope.$broadcast("appActivitySvc:isBusyChanged", { busy: service.info.isBusy });
            }
        }

        function reset() {
            activities = [];
            updateStatus();
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'appStatusSvc';
   
    angular.module('app.core')
        .factory(serviceId, ['$q', appStatusSvc]);

    function appStatusSvc($q) {
        var deferreds = [];

        var service = {
            whenReady: whenReady,
            info:{
                ready: false
            },            
            isReady: isReady
        };

        return service;

        function isReady(value) {
            if (service.info.ready !== value) {
                service.info.ready = value;

                if (service.info.ready) {
                    resolvePromises();
                }
            }
        }

        function whenReady() {
            var deferred = $q.defer();
             
            if (service.info.ready) {
                deferred.resolve();
            } else {
                deferreds.push(deferred);
            }

            return deferred.promise;
        }

        function resolvePromises() {
            deferreds.forEach(function (deferred) {
                deferred.resolve();
            });

            deferreds.length = 0;
        }
    }
})();
(function () {
    'use strict';

    var serviceId = 'notifierSvc';

    var defaults = {
        source: "app",
        title: "",
        message: "",
        detail: "",
        type: "info",
        hideDuration: 5000,
    };

    angular.module('app.core')
        .factory(serviceId, [notifierSvc]);

    function notifierSvc() {
        var service = {
            show: show,
            clear: clear,
            remove: remove,
            verbose: true
        };

        return service;

        function remove() {
            toastr.remove();
        }

        function clear() {
            toastr.clear();
        }
        function show(options) {
            var opns = angular.copy(defaults);

            if (typeof options === "string") {
                opns.message = options;
            } else {
                opns = angular.extend(opns, options);
            }

            if (service.verbose && opns.detail.length > 0) {
                opns.message += " " + opns.detail;
            }

            toastr[opns.type](opns.message, opns.title);
        }
    }
})();
(function() {
    'use strict';

    angular.module('app.core')
        .directive('skDisableWhenBusy', ['$rootScope', skDisableWhenBusy]);
    
    function skDisableWhenBusy($rootScope) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                disableOn: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {
            var target = element,
              disable = setDisable(scope.disableOn),
              busy = false;

            scope.$watch("disableOn", function (value) {
                setDisable(value);
                updateDisabled();
            });

            $rootScope.$on("appActivitySvc:isBusyChanged", function (event, args) {
                busy = args.busy;
                updateDisabled();
            });

            function updateDisabled() {
                angular.element(target).prop('disabled', disable || busy);
            }

            function setDisable(boolArray) {
                var result = false;

                if (boolArray) {
                    boolArray.forEach(function (b) {
                        if (b) {
                            result = true;
                        }
                    });
                }

                disable = result;
            }
        }
    }
})();
/**
 * Local Storage Service
 * Wrapper for localStorage with fallback
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('storageSvc', storageSvc);

    storageSvc.$inject = ['$window'];

    function storageSvc($window) {
        var storage = $window.localStorage;
        var isAvailable = testStorage();

        var service = {
            get: get,
            set: set,
            remove: remove,
            clear: clear,
            isAvailable: isAvailable
        };

        return service;

        // ====================================================================

        function get(key, defaultValue) {
            if (!isAvailable) {
                return defaultValue;
            }

            try {
                var value = storage.getItem(key);
                if (value === null) {
                    return defaultValue;
                }

                // Try to parse JSON
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            } catch (e) {
                console.warn('[Storage] Failed to get item:', key, e);
                return defaultValue;
            }
        }

        function set(key, value) {
            if (!isAvailable) {
                return false;
            }

            try {
                var serialized = typeof value === 'string' ? value : JSON.stringify(value);
                storage.setItem(key, serialized);
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to set item:', key, e);
                return false;
            }
        }

        function remove(key) {
            if (!isAvailable) {
                return false;
            }

            try {
                storage.removeItem(key);
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to remove item:', key, e);
                return false;
            }
        }

        function clear() {
            if (!isAvailable) {
                return false;
            }

            try {
                storage.clear();
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to clear storage:', e);
                return false;
            }
        }

        function testStorage() {
            try {
                var test = '__storage_test__';
                storage.setItem(test, test);
                storage.removeItem(test);
                return true;
            } catch (e) {
                console.warn('[Storage] localStorage not available:', e);
                return false;
            }
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('darkModeSvc', darkModeSvc);

    darkModeSvc.$inject = ['$rootScope', '$window'];

    function darkModeSvc($rootScope, $window) {
        var STORAGE_KEY = 'endeksa-dark-mode';
        var service = {
            initialize: initialize,
            toggle: toggle,
            setDarkMode: setDarkMode,
            isDarkMode: isDarkMode,
            applyTheme: applyTheme
        };

        return service;

        /**
         * Initialize dark mode on app startup
         * Checks localStorage first, then device preference, then user profile
         */
        function initialize() {
            var darkModeEnabled = getDarkModePreference();
            applyTheme(darkModeEnabled);

            // Listen for device theme changes
            if ($window.matchMedia) {
                var darkModeMediaQuery = $window.matchMedia('(prefers-color-scheme: dark)');

                // Modern browsers
                if (darkModeMediaQuery.addEventListener) {
                    darkModeMediaQuery.addEventListener('change', function (e) {
                        // Only auto-update if user hasn't manually set preference
                        if (!hasManualPreference()) {
                            applyTheme(e.matches);
                        }
                    });
                }
                // Legacy browsers
                else if (darkModeMediaQuery.addListener) {
                    darkModeMediaQuery.addListener(function (e) {
                        if (!hasManualPreference()) {
                            applyTheme(e.matches);
                        }
                    });
                }
            }
        }

        /**
         * Toggle dark mode on/off
         */
        function toggle() {
            var currentMode = isDarkMode();
            var newMode = !currentMode;
            setDarkMode(newMode);
            return newMode;
        }

        /**
         * Set dark mode explicitly
         * @param {boolean} enabled - True to enable dark mode
         */
        function setDarkMode(enabled) {
            // Save to localStorage for persistence
            try {
                $window.localStorage.setItem(STORAGE_KEY, enabled ? 'dark' : 'light');
            } catch (e) {
                console.warn('Failed to save dark mode preference:', e);
            }

            applyTheme(enabled);

            // Broadcast event for other components to react
            $rootScope.$broadcast('darkMode:changed', { enabled: enabled });
        }

        /**
         * Check if dark mode is currently active
         * @returns {boolean}
         */
        function isDarkMode() {
            return document.documentElement.classList.contains('dark-mode');
        }

        /**
         * Apply or remove dark theme class
         * @param {boolean} enabled - True to enable dark mode
         */
        function applyTheme(enabled) {
            var htmlElement = document.documentElement;
            var bodyElement = document.body;

            if (enabled) {
                htmlElement.classList.add('dark-mode');
                bodyElement.classList.add('dark-mode');
                $window.darkMode = true;
            } else {
                htmlElement.classList.remove('dark-mode');
                bodyElement.classList.remove('dark-mode');
                $window.darkMode = false;
            }

            // Update rootScope theme if it exists
            if ($rootScope.theme) {
                $rootScope.theme.selected = enabled ? 2 : 1;
            }
        }

        /**
         * Get dark mode preference from various sources
         * Priority: localStorage > userProfile > device preference
         * @returns {boolean}
         */
        function getDarkModePreference() {
            // 1. Check localStorage (manual user preference)
            try {
                var storedPreference = $window.localStorage.getItem(STORAGE_KEY);
                if (storedPreference === 'dark') {
                    return true;
                }
                if (storedPreference === 'light') {
                    return false;
                }
            } catch (e) {
                console.warn('Failed to read dark mode preference from localStorage:', e);
            }

            // 2. Check if user profile has dark mode setting (when user is signed in)
            if ($rootScope.userSvc && $rootScope.userSvc.info && $rootScope.userSvc.info.SignedIn) {
                if ($rootScope.userSvc.info.Details &&
                    $rootScope.userSvc.info.Details.profile &&
                    $rootScope.userSvc.info.Details.profile.useDarkMode !== undefined) {
                    return $rootScope.userSvc.info.Details.profile.useDarkMode;
                }
            }

            // 3. Check device preference (system theme)
            if ($window.matchMedia && $window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return true;
            }

            // 4. Default to light mode
            return false;
        }

        /**
         * Check if user has manually set a preference in localStorage
         * @returns {boolean}
         */
        function hasManualPreference() {
            try {
                var storedPreference = $window.localStorage.getItem(STORAGE_KEY);
                return storedPreference === 'dark' || storedPreference === 'light';
            } catch (e) {
                return false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('darkModeToggle', darkModeToggle);

    darkModeToggle.$inject = ['darkModeSvc'];

    function darkModeToggle(darkModeSvc) {
        return {
            restrict: 'E',
            template: `
                <div class="dark-mode-toggle-wrapper" ng-click="toggleDarkMode()">
                    <button type="button" class="dark-mode-toggle-btn" 
                            title="{{ isDark ? ('Switch to Light Mode' | translate) : ('Switch to Dark Mode' | translate) }}">
                        <i class="ei-light" ng-show="isDark"></i>
                        <i class="ei-dark" ng-show="!isDark"></i>
                        <span class="toggle-text" ng-if="showText">{{ isDark ? ('Light Mode' | translate) : ('Dark Mode' | translate) }}</span>
                    </button>
                </div>
            `,
            scope: {
                showText: '=?' // Optional: show text label
            },
            link: function (scope, element, attrs) {
                // Initialize state
                scope.isDark = darkModeSvc.isDarkMode();

                // Toggle function
                scope.toggleDarkMode = function () {
                    scope.isDark = darkModeSvc.toggle();
                };

                // Listen for external dark mode changes
                scope.$on('darkMode:changed', function (event, data) {
                    scope.isDark = data.enabled;
                });
            }
        };
    }
})();


(function() {
    'use strict';

    /**
     * Bootstrap Select Dropup Scroll Fix
     * Prevents dropdown from expanding to window height when scrolling in dropup mode
     */

    // Wait for document ready
    angular.element(document).ready(function() {

        // Store original max-height when dropdown opens
        var dropupHeights = new WeakMap();

        // Override the scroll handler for dropup selects
        angular.element(window).on('scroll.bs-select-dropup-fix', function() {
            angular.element('.bootstrap-select.dropup.open').each(function() {
                var $select = angular.element(this);
                var $menu = $select.find('.dropdown-menu');

                // Store original height on first scroll
                if (!dropupHeights.has($menu[0])) {
                    var currentHeight = $menu.css('max-height');
                    if (currentHeight && currentHeight !== 'none') {
                        dropupHeights.set($menu[0], currentHeight);
                    }
                }

                // Reapply stored height to prevent expansion
                var storedHeight = dropupHeights.get($menu[0]);
                if (storedHeight) {
                    $menu.css({
                        'max-height': storedHeight,
                        'overflow-y': 'auto',
                        'position': 'absolute',
                        'bottom': '100%',
                        'top': 'auto'
                    });
                }
            });
        });

        // Clean up stored heights when dropdown closes
        angular.element(document).on('hidden.bs.dropdown', '.bootstrap-select.dropup', function() {
            var $menu = angular.element(this).find('.dropdown-menu');
            if ($menu[0] && dropupHeights.has($menu[0])) {
                dropupHeights.delete($menu[0]);
            }
        });

        // Prevent resize on scroll for dropup
        angular.element(document).on('shown.bs.dropdown', '.bootstrap-select.dropup', function() {
            var $select = angular.element(this);
            var $menu = $select.find('.dropdown-menu');

            // Lock the height when dropup is shown
            var currentHeight = $menu.outerHeight();
            if (currentHeight > 0) {
                $menu.css({
                    'max-height': Math.min(currentHeight, 300) + 'px',
                    'overflow-y': 'auto'
                });
                dropupHeights.set($menu[0], Math.min(currentHeight, 300) + 'px');
            }
        });

        // Additional fix: Disable scroll-triggered resize for dropup selects
        var originalSetSize = angular.element.fn.selectpicker && angular.element.fn.selectpicker.Constructor &&
                             angular.element.fn.selectpicker.Constructor.prototype.setSize;

        if (originalSetSize) {
            angular.element.fn.selectpicker.Constructor.prototype.setSize = function() {
                // Only call original setSize if not in dropup mode during scroll
                if (!this.$newElement.hasClass('dropup') || !this.$newElement.hasClass('open')) {
                    originalSetSize.apply(this, arguments);
                } else {
                    // For dropup that's already open, skip resize to prevent expansion
                    return;
                }
            };
        }
    });

})();

/**
 * PWA Service
 * Handles PWA install prompts, service worker updates, and offline detection
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('pwaSvc', pwaSvc);

    pwaSvc.$inject = ['$rootScope', '$timeout', '$window', 'storageSvc'];

    function pwaSvc($rootScope, $timeout, $window, storageSvc) {
        var service = {
            // Properties
            isInstalled: isInstalled,
            isOnline: navigator.onLine,
            canInstall: false,
            updateAvailable: false,

            // Methods
            promptInstall: promptInstall,
            dismissInstall: dismissInstall,
            updateServiceWorker: updateServiceWorker,
            clearCache: clearCache,
            getVersion: getVersion,
            registerBackgroundSync: registerBackgroundSync
        };

        var deferredPrompt = null;
        var registration = null;
        var installDismissed = storageSvc.get('pwa-install-dismissed', true);  // Default to dismissed (prefer native apps)

        // Multi-language translations for PWA notifications
        var translations = {
            'tr': {
                updateReady: 'Güncelleme Hazır',
                newVersionAvailable: 'Yeni bir sürüm mevcut',
                updateButton: 'Güncelle',
                laterButton: 'Sonra',
                backOnline: 'Çevrimiçi',
                goneOffline: 'Çevrimdışı',
                installPrompt: 'Endeksa\'yı Yükle',
                installDescription: 'Ana ekranınıza hızlı erişim ekleyin'
            },
            'en': {
                updateReady: 'Update Ready',
                newVersionAvailable: 'A new version is available',
                updateButton: 'Update',
                laterButton: 'Later',
                backOnline: 'Online',
                goneOffline: 'Offline',
                installPrompt: 'Install Endeksa',
                installDescription: 'Add quick access to your home screen'
            },
            'es-ES': {
                updateReady: 'Actualización Lista',
                newVersionAvailable: 'Una nueva versión está disponible',
                updateButton: 'Actualizar',
                laterButton: 'Más tarde',
                backOnline: 'En línea',
                goneOffline: 'Sin conexión',
                installPrompt: 'Instalar Endeksa',
                installDescription: 'Agregar acceso rápido a tu pantalla de inicio'
            },
            'pt-PT': {
                updateReady: 'Atualização Pronta',
                newVersionAvailable: 'Uma nova versão está disponível',
                updateButton: 'Atualizar',
                laterButton: 'Mais tarde',
                backOnline: 'Online',
                goneOffline: 'Offline',
                installPrompt: 'Instalar Endeksa',
                installDescription: 'Adicionar acesso rápido ao ecrã inicial'
            }
        };

        init();

        return service;

        // ====================================================================
        // LANGUAGE HELPERS
        // ====================================================================

        function getCurrentLanguage() {
            // Priority 1: Check $rootScope.lang (set by app)
            if ($rootScope.lang) {
                return $rootScope.lang;
            }

            // Priority 2: Check localStorage
            var storedLang = localStorage.getItem('endeksaLanguage') || localStorage.getItem('language');
            if (storedLang && translations[storedLang]) {
                return storedLang;
            }

            // Priority 3: Check URL path
            var path = $window.location.pathname;
            var urlLangMatch = path.match(/^\/(tr|en|es-ES|pt-PT)\//);
            if (urlLangMatch) {
                return urlLangMatch[1];
            }

            // Priority 4: Browser language
            var browserLang = navigator.language || navigator.userLanguage;
            if (browserLang) {
                if (translations[browserLang]) {
                    return browserLang;
                }
                var baseLang = browserLang.split('-')[0];
                if (baseLang === 'es') return 'es-ES';
                if (baseLang === 'pt') return 'pt-PT';
                if (baseLang === 'en') return 'en';
            }

            // Default: Turkish
            return 'tr';
        }

        function getTranslation(key) {
            var lang = getCurrentLanguage();
            return translations[lang][key] || translations['tr'][key] || key;
        }

        // ====================================================================
        // INITIALIZATION
        // ====================================================================

        function init() {
            // Listen for install prompt
            $window.addEventListener('beforeinstallprompt', handleInstallPrompt);

            // Listen for app installed
            $window.addEventListener('appinstalled', handleAppInstalled);

            // Listen for online/offline events
            $window.addEventListener('online', handleOnline);
            $window.addEventListener('offline', handleOffline);

            // Check for Service Worker updates
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.ready.then(function (reg) {
                    registration = reg;

                    // Check for updates every hour
                    setInterval(function () {
                        reg.update();
                    }, 60 * 60 * 1000);

                    // Listen for updates
                    reg.addEventListener('updatefound', handleUpdateFound);
                });

                // Listen for messages from SW
                navigator.serviceWorker.addEventListener('message', handleSWMessage);
            }

            console.log('[PWA] Service initialized');
        }

        // ====================================================================
        // INSTALL PROMPT
        // ====================================================================

        function handleInstallPrompt(e) {
            console.log('[PWA] Install prompt available');

            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();

            // Store the event for later use
            deferredPrompt = e;
            service.canInstall = true;

            // Don't auto-show install banner (prefer native apps)
            // Users can still manually install via browser menu or custom trigger
            // if (!installDismissed) {
            //     $timeout(function () {
            //         showInstallBanner();
            //     }, 3000);
            // }

            $rootScope.$broadcast('pwa:install-available');
        }

        function promptInstall() {
            if (!deferredPrompt) {
                console.log('[PWA] No install prompt available');
                return Promise.reject('No install prompt available');
            }

            // Show the install prompt
            deferredPrompt.prompt();

            // Wait for the user to respond
            return deferredPrompt.userChoice.then(function (choiceResult) {
                console.log('[PWA] User choice:', choiceResult.outcome);

                if (choiceResult.outcome === 'accepted') {
                    console.log('[PWA] User accepted install');
                    hideInstallBanner();
                } else {
                    console.log('[PWA] User dismissed install');
                }

                // Clear the deferred prompt
                deferredPrompt = null;
                service.canInstall = false;

                return choiceResult;
            });
        }

        function dismissInstall() {
            installDismissed = true;
            storageSvc.set('pwa-install-dismissed', true);
            hideInstallBanner();
            $rootScope.$broadcast('pwa:install-dismissed');
        }

        function handleAppInstalled() {
            console.log('[PWA] App installed successfully');
            hideInstallBanner();
            deferredPrompt = null;
            service.canInstall = false;
            $rootScope.$broadcast('pwa:installed');

            // Track installation
            if ($window.gtag) {
                $window.gtag('event', 'pwa_installed', {
                    event_category: 'PWA',
                    event_label: 'App Installed'
                });
            }
        }

        function isInstalled() {
            // Check if running in standalone mode
            return ($window.matchMedia('(display-mode: standalone)').matches) ||
                ($window.navigator.standalone) ||
                document.referrer.includes('android-app://');
        }

        // ====================================================================
        // SERVICE WORKER UPDATES
        // ====================================================================

        function handleUpdateFound() {
            console.log('[PWA] Service Worker update found');

            var newWorker = registration.installing;

            newWorker.addEventListener('statechange', function () {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    console.log('[PWA] New Service Worker ready');
                    service.updateAvailable = true;

                    $timeout(function () {
                        showUpdateNotification();
                        $rootScope.$broadcast('pwa:update-available');
                    });
                }
            });
        }

        function updateServiceWorker() {
            if (!registration || !registration.waiting) {
                console.log('[PWA] No waiting Service Worker');
                return Promise.reject('No waiting Service Worker');
            }

            // Tell the waiting SW to skip waiting and activate
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });

            // Reload the page when the new SW is activated
            navigator.serviceWorker.addEventListener('controllerchange', function () {
                console.log('[PWA] New Service Worker activated, reloading...');
                $window.location.reload();
            });

            return Promise.resolve();
        }

        function clearCache() {
            if (!navigator.serviceWorker.controller) {
                console.log('[PWA] No Service Worker controller');
                return Promise.reject('No Service Worker');
            }

            navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });

            return new Promise(function (resolve) {
                navigator.serviceWorker.addEventListener('message', function handler(event) {
                    if (event.data && event.data.type === 'CACHE_CLEARED') {
                        console.log('[PWA] Cache cleared');
                        navigator.serviceWorker.removeEventListener('message', handler);
                        resolve();
                    }
                });
            });
        }

        function getVersion() {
            if (!navigator.serviceWorker.controller) {
                return Promise.reject('No Service Worker');
            }

            var messageChannel = new MessageChannel();

            return new Promise(function (resolve, reject) {
                messageChannel.port1.onmessage = function (event) {
                    if (event.data && event.data.version) {
                        resolve(event.data.version);
                    } else {
                        reject('No version returned');
                    }
                };

                navigator.serviceWorker.controller.postMessage(
                    { type: 'GET_VERSION' },
                    [messageChannel.port2]
                );
            });
        }

        // ====================================================================
        // BACKGROUND SYNC
        // ====================================================================

        function registerBackgroundSync(tag) {
            if (!registration || !registration.sync) {
                console.log('[PWA] Background sync not supported');
                return Promise.reject('Background sync not supported');
            }

            return registration.sync.register(tag).then(function () {
                console.log('[PWA] Background sync registered:', tag);
            });
        }

        // ====================================================================
        // ONLINE/OFFLINE DETECTION
        // ====================================================================

        function handleOnline() {
            console.log('[PWA] Back online');
            service.isOnline = true;
            $timeout(function () {
                $rootScope.$broadcast('pwa:online');
            });
        }

        function handleOffline() {
            console.log('[PWA] Gone offline');
            service.isOnline = false;
            $timeout(function () {
                $rootScope.$broadcast('pwa:offline');
            });
        }

        // ====================================================================
        // SERVICE WORKER MESSAGES
        // ====================================================================

        function handleSWMessage(event) {
            console.log('[PWA] Message from SW:', event.data);

            if (event.data && event.data.type === 'CACHE_CLEARED') {
                $timeout(function () {
                    $rootScope.$broadcast('pwa:cache-cleared');
                });
            }
        }

        // ====================================================================
        // UI HELPERS
        // ====================================================================

        function hideInstallBanner() {
            var banner = document.getElementById('pwa-install-banner');
            if (banner) {
                banner.classList.remove('pwa-show');
                $timeout(function () {
                    banner.remove();
                }, 300);
            }
        }

        function showUpdateNotification() {
            // Create and show update notification with current language
            var notification = document.createElement('div');
            notification.id = 'pwa-update-notification';
            notification.className = 'pwa-update-notification';
            notification.innerHTML = `
                <div class="pwa-notification-content">
                    <div class="pwa-notification-icon">🔄</div>
                    <div class="pwa-notification-text">
                        <strong>` + getTranslation('updateReady') + `</strong>
                        <p>` + getTranslation('newVersionAvailable') + `</p>
                    </div>
                    <div class="pwa-notification-actions">
                        <button class="pwa-btn-update" onclick="angular.element(document.body).injector().get('pwaSvc').updateServiceWorker()">
                            ` + getTranslation('updateButton') + `
                        </button>
                        <button class="pwa-btn-later" onclick="this.parentElement.parentElement.parentElement.remove()">
                            ` + getTranslation('laterButton') + `
                        </button>
                    </div>
                </div>
            `;

            document.body.appendChild(notification);

            // Animate in
            $timeout(function () {
                notification.classList.add('pwa-show');
            }, 100);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('performanceOptimizationSvc', performanceOptimizationSvc);

    performanceOptimizationSvc.$inject = ['$timeout', '$window'];

    function performanceOptimizationSvc($timeout, $window) {
        var service = {
            batchChartUpdates: batchChartUpdates,
            deferredSliderInit: deferredSliderInit,
            debounce: debounce,
            throttle: throttle,
            requestAnimationFramePolyfill: requestAnimationFramePolyfill
        };

        return service;

        ////////////////

        /**
         * Batch update multiple Chart.js instances to minimize forced reflows
         * @param {Object} options - Configuration for chart updates
         * @param {boolean} options.isDarkMode - Whether dark mode is enabled
         * @param {Array} options.chartInstances - Specific chart instances to update (optional)
         */
        function batchChartUpdates(options) {
            var isDarkMode = options.isDarkMode || false;
            var chartInstances = options.chartInstances || null;

            // Update global defaults first (doesn't cause reflow)
            if (typeof Chart !== 'undefined') {
                Chart.defaults.global.defaultFontColor = isDarkMode ? '#ddd' : '#484848';
                Chart.defaults.global.color = isDarkMode ? '#ddd' : '#484848';
            }

            // Use requestAnimationFrame to batch all chart updates together
            requestAnimationFramePolyfill(function () {
                var charts = chartInstances;

                // If no specific instances provided, get all charts
                if (!charts && window.Chart && window.Chart.instances) {
                    charts = Object.keys(window.Chart.instances).map(function (key) {
                        return window.Chart.instances[key];
                    }).filter(function (instance) {
                        return instance && typeof instance.update === 'function';
                    });
                }

                if (!charts || charts.length === 0) {
                    return;
                }

                // Batch all option updates first (no DOM reads)
                charts.forEach(function (chartInstance) {
                    if (chartInstance && chartInstance.options) {
                        chartInstance.options.legend = chartInstance.options.legend || {};
                        chartInstance.options.legend.labels = chartInstance.options.legend.labels || {};
                        chartInstance.options.legend.labels.fontColor = isDarkMode ? '#ddd' : '#484848';

                        if (chartInstance.options.scales) {
                            if (chartInstance.options.scales.xAxes) {
                                chartInstance.options.scales.xAxes.forEach(function (axis) {
                                    if (axis.ticks) {
                                        axis.ticks.fontColor = isDarkMode ? '#ddd' : '#484848';
                                    }
                                    if (axis.gridLines) {
                                        axis.gridLines.color = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
                                    }
                                });
                            }
                            if (chartInstance.options.scales.yAxes) {
                                chartInstance.options.scales.yAxes.forEach(function (axis) {
                                    if (axis.ticks) {
                                        axis.ticks.fontColor = isDarkMode ? '#ddd' : '#484848';
                                    }
                                    if (axis.gridLines) {
                                        axis.gridLines.color = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
                                    }
                                });
                            }
                        }

                        if (chartInstance.options.tooltips) {
                            chartInstance.options.tooltips.backgroundColor = isDarkMode ? 'rgba(42, 42, 42, 0.9)' : 'rgba(0, 0, 0, 0.8)';
                            chartInstance.options.tooltips.borderColor = isDarkMode ? '#555' : '#ccc';
                        }
                    }
                });

                // Now batch all updates with animation disabled to prevent multiple reflows
                charts.forEach(function (chartInstance) {
                    if (chartInstance && typeof chartInstance.update === 'function') {
                        // Update with duration 0 to skip animation and reduce reflows
                        chartInstance.update({
                            duration: 0,
                            lazy: false
                        });
                    }
                });
            });
        }

        /**
         * Initialize tiny-slider with IntersectionObserver to defer until visible
         * @param {string} containerSelector - CSS selector for the slider container
         * @param {Object} sliderOptions - Options to pass to tns()
         * @param {Function} callback - Callback function that receives the slider instance
         */
        function deferredSliderInit(containerSelector, sliderOptions, callback) {
            var container = document.querySelector(containerSelector);

            if (!container) {
                console.warn('Slider container not found:', containerSelector);
                return;
            }

            // Check if container has valid children
            if (!container.children || container.children.length === 0) {
                console.warn('Slider container has no children:', containerSelector);
                return;
            }

            // Use IntersectionObserver to defer initialization until visible
            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            // Element is visible, initialize slider
                            observer.disconnect();

                            // Use requestAnimationFrame to defer to next frame
                            requestAnimationFramePolyfill(function () {
                                try {
                                    var slider = tns(sliderOptions);
                                    if (callback && typeof callback === 'function') {
                                        callback(slider);
                                    }
                                } catch (err) {
                                    console.error('Slider initialization failed:', err);
                                }
                            });
                        }
                    });
                }, {
                    rootMargin: '50px' // Start loading 50px before it comes into view
                });

                observer.observe(container);
            } else {
                // Fallback for browsers without IntersectionObserver
                $timeout(function () {
                    try {
                        var slider = tns(sliderOptions);
                        if (callback && typeof callback === 'function') {
                            callback(slider);
                        }
                    } catch (err) {
                        console.error('Slider initialization failed:', err);
                    }
                }, 100);
            }
        }

        /**
         * Debounce function to limit execution rate
         * @param {Function} func - Function to debounce
         * @param {number} wait - Milliseconds to wait
         * @param {boolean} immediate - Whether to execute immediately
         */
        function debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this;
                var args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                $timeout.cancel(timeout);
                timeout = $timeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        }

        /**
         * Throttle function to limit execution rate
         * @param {Function} func - Function to throttle
         * @param {number} limit - Milliseconds to limit
         */
        function throttle(func, limit) {
            var inThrottle;
            return function () {
                var context = this;
                var args = arguments;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    $timeout(function () {
                        inThrottle = false;
                    }, limit);
                }
            };
        }

        /**
         * RequestAnimationFrame polyfill with fallback
         * @param {Function} callback - Function to execute in next frame
         */
        function requestAnimationFramePolyfill(callback) {
            var raf = $window.requestAnimationFrame ||
                $window.webkitRequestAnimationFrame ||
                $window.mozRequestAnimationFrame ||
                function (cb) {
                    return $window.setTimeout(cb, 16); // ~60fps
                };

            return raf.call($window, callback);
        }
    }
})();

(function () {
    "use strict";

    var serviceId = "userSvc";

    angular.module("app.security").factory(serviceId, userSvc);

    userSvc.$inject = [
        "$rootScope",
        "$q",
        "$window",
        "auth_factory",
        "user_factory",
        "appActivitySvc",
        "notifierSvc",
        "ngDialog",
        "$timeout",
        "$translate",
        "$state",
        "leadAPI",
        "user_info",
        "$ocLazyLoad",
        "restoreUrlService",
        "$interval",
        "$cookies",
        "CacheFactory",
        "notificationService",
        "orders_factory",
        "mcpService"
    ];

    function userSvc(
        $rootScope,
        $q,
        $window,
        auth_factory,
        user_factory,
        appActivitySvc,
        notifierSvc,
        ngDialog,
        $timeout,
        $translate,
        $state,
        leadAPI,
        user_info,
        $ocLazyLoad,
        restoreUrlService,
        $interval,
        $cookies,
        CacheFactory,
        notificationService,
        orders_factory,
        mcpService
    ) {
        var service = {
            signIn: signIn,
            registerAndLogin: registerAndLogin,
            signInExternal: signInExternal,
            signInEmlakjet: signInEmlakjet,
            externalLoginConfirm: externalLoginConfirm,
            signOut: signOut,
            hardDelete: hardDelete,
            setUser: setUser,
            changePassword: changePassword,
            getUserInfo: getUserInfo,
            checkEmail: checkEmail,
            register: register,
            signInWithTokenResult: signInWithTokenResult,
            passwordStatus: passwordStatus,
            refreshClientId: refreshClientId,
            updateAvatar: updateAvatar,
            postCertFile: postCertFile,
            info: {
                Id: "",
                Email: "",
                AccessToken: "",
                Role: null,
                Products: [],
                SignedIn: false,
                Details: {
                    "email": null,
                    "phoneNumber": null,
                    "language": $window.langCode(),
                    "profile": {
                        "name": "",
                        "surName": "",
                        "avatarUrl": "",
                        "logoUrl": "",
                        "officeName": "",
                        "slogan": "",
                        "userType": 10,
                        // "RegisterReason": 10,
                        "useDarkMode": 1,
                        "companyId": null,
                        "registrationDate": null,
                        "lastLoginDate": null
                    },
                    "permissions": [],
                    // "registerReason": 10
                },
                TerminalProducts: []
            },
            finger_info: {
                // finger: null, //CACHING IMPLEMENTED
                prints: {}
            },
            upscopeInit: false,
            wootricInit: false,
            SendConfirmationEmail: SendConfirmationEmail,
            ConfirmEmail: ConfirmEmail,
            SendForgotPasswordEmail: SendForgotPasswordEmail,
            ResetPassword: ResetPassword,
            NewPassword: NewPassword,
            refresh: refresh,
            getLastLogins: getLastLogins,
            getLastFailedLogins: getLastFailedLogins,
            getLastSuccessLogins: getLastSuccessLogins,
            lastResult: null,
            setFingerLimit: setFingerLimit,
            getFingerLimit: getFingerLimit,
            getFinger: getFinger,
            refreshProducts: refreshProducts,
            setGA4UserProperties: setGA4UserProperties,
            ga4UserInfo: {
                user_type: null,
                user_register_reason: null,
                user_package: null,
                user_edr_count_konut: null,
                user_edr_count_arazi: null,
                user_edr_count_ticari: null,
                user_edr_count_arsa: null
            }
        };


        function refreshProducts() {
            var deferred = $q.defer();
            orders_factory.myProducts().$promise.then(function (response) {
                if (response && response.products) {
                    service.info.Products = response.products;
                    service.info.TerminalProducts = response.terminalProducts || [];
                }
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function refreshClientId(clickId, clientId, sessionId, sessionNumber) {
            let payload = {
                googleClickId: clickId,
                googleClientId: clientId,
                googleSessionId: sessionId,
                googleSessionNumber: sessionNumber,
                sending: false
            };
            if (window.gclid && (!clickId || window.gclid !== clickId)) {
                payload.googleClickId = window.gclid;
                payload.sending = true;
            }
            if (window.gaclient && (!clientId || window.gaclient !== clientId)) {
                payload.googleClientId = window.gaclient;
                payload.sending = true;
            }
            if (window.gasessionId && (!sessionId || window.gasessionId !== sessionId)) {
                payload.googleSessionId = window.gasessionId;
                payload.sending = true;
            }
            if (window.gasessionNumber && (!sessionNumber || window.gasessionNumber !== sessionNumber)) {
                payload.googleSessionNumber = window.gasessionNumber;
                payload.sending = true;
            }

            if (payload.sending)
                user_factory.refreshClientId(payload).$promise.then(function (result) {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                });
        }

        function updateAvatar(img) {
            var deferred = $q.defer();
            img.dst = $window.compressBase64Image(img.dst);
            var base64Data = img.dst.substr(img.dst.indexOf('base64,') + 'base64,'.length);
            user_factory.upload_avatar({ b64S: base64Data }).$promise.then(function (result) {
                CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();

                service.info.Details.profile.avatarUrl = result.savedUrl;
                deferred.resolve(service.info);
                notifierSvc.show({ message: $translate.instant('account_success'), type: "success" });
            }, function (response) {
                deferred.reject(response);
                if (response.data.detail && response.data.detail.includes('Profile picture can only be a photo')) {
                    notifierSvc.show({ message: $translate.instant('profile_avatar_error'), type: 'error' });
                } else {
                    notifierSvc.show({ message: response.data.detail ? response.data.detail : response.data.title, type: 'error' });
                }
            });
            return deferred.promise;
        }

        function postCertFile(file, certificate) {
            var deferred = $q.defer();
            var base64Data = file.src.substr(file.src.indexOf('base64,') + 'base64,'.length);
            user_factory.upload_certificate({ b64S: base64Data, userId: service.info.Id, fileExtention: file.mime }).$promise.then(function (result) {
                certificate.url = result.savedUrl;
                user_factory.submit_certificates({
                    userId: { value: service.info.Id },
                    userCertificateList: [certificate]
                }).$promise.then(function (response) {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                    CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                    CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                    CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                    //notifierSvc.show({ message: $translate.instant('account_success'), type: "success" });
                    deferred.resolve(certificate);
                }, function (err) {
                    notifierSvc.show({ message: err.data.detail ? err.data.detail : err.data.title, type: 'error' });
                    deferred.reject(err);
                }).finally(function () {
                    certificate = null;
                    file = null;
                });
            }, function (response) {
                notifierSvc.show({ message: response.data.detail ? response.data.detail : response.data.title, type: 'error' });
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function checkEmail(email) {
            var deferred = $q.defer();
            if (!email) {
                deferred.resolve({ result: true, status: 200 });
                return;
            }
            $.ajax({
                url: "https://api.email-validator.net/api/verify",
                type: "POST",
                cache: false,
                crossDomain: true,
                data: {
                    EmailAddress: email,
                    APIKey: "ev-45ed540646071ea3e34158619594088f",
                },
                dataType: "json",
                success: function (json) {
                    deferred.resolve(json);
                },
            });

            return deferred.promise;
        }

        function setGA4UserProperties() {
            if (service.info.SignedIn) {
                let user = service.lastResult;
                let registerReasons = [
                    { val: 10, name: 'Satmak İstiyorum' },
                    { val: 20, name: 'Kiraya Vereceğim' },
                    { val: 30, name: 'Almak İstiyorum' },
                    { val: 40, name: 'Kiralayacağım' },
                    { val: 50, name: 'Değerini Merak Ediyorum' },
                    { val: 60, name: 'Kirasını Merak Ediyorum' },
                    { val: 70, name: 'Sadece Değerine/Kirasına Bakacağım' }
                ];

                let userPropertiesObject = angular.copy(service.ga4UserInfo);

                userPropertiesObject = Object.assign(userPropertiesObject, {
                    user_type: user.isAgent ? 'Danışman' : 'Bireysel',
                    user_register_reason: registerReasons.find((r) => r.val === user.information.registerReason) ? registerReasons.find((r) => r.val === user.information.registerReason).name : null,
                    user_package: null
                });

                angular.forEach(user.products, (p) => {
                    if (p.code.indexOf('edr-') !== -1) {
                        if (p.code.indexOf('house') !== -1)
                            userPropertiesObject['user_edr_count_konut'] = p.count;
                        else if (p.code.indexOf('commercial') !== -1)
                            userPropertiesObject['user_edr_count_ticari'] = p.count;
                        else if (p.code.indexOf('plot') !== -1)
                            userPropertiesObject['user_edr_count_arsa'] = p.count;
                        else if (p.code.indexOf('land') !== -1)
                            userPropertiesObject['user_edr_count_arazi'] = p.count;
                    }

                    if (p.productType === 20 || p.productType === 40) {
                        userPropertiesObject['user_package'] = p.nameTurkish;
                    }
                });

                window.localStorage.setItem('ga4_user_properties', JSON.stringify(userPropertiesObject));
            } else {
                window.localStorage.setItem('ga4_user_properties', JSON.stringify(service.ga4UserInfo));
            }

        }

        var userInfo;
        var get_user_info = false;
        function setUser(user) {
            appActivitySvc.busy("userSvc");
            if (user) {
                if (!get_user_info) {
                    get_user_info = true;
                    service.info.Email = user.information.email;
                    service.info.SignedIn = true;
                    service.info.Id = user.information.id.value;
                    service.info.Role = user.information.role;
                    service.info.Products = user.products;
                    service.info.TerminalProducts = user.terminalProducts;
                    // user.information.profile.RegisterReason = service.info.Details.profile.RegisterReason;
                    service.info.Details = angular.copy(user.information);
                    $rootScope.recommendedFieldsToFill = user.information.recommendedFieldsToFill;

                    if ($window.dengage) {
                        $window.dengage("setContactKey", user.information.id.value.toUpperCase());
                        $window.dengage('setTrackingPermission', true);
                    }

                    if ($window.Upscope && !service.upscopeInit) {
                        $window.Upscope("init", {
                            uniqueId: user.information.id.value,
                            identities: [
                                user.information.profile.name + ' ' + user.information.profile.surName,
                                user.information.email,
                                user.information.role,
                                user.products.map(function (x) {
                                    return x.code;
                                }).toString()
                            ],
                        });
                        service.upscopeInit = true;
                    }

                    if (typeof $window.Ybug !== "undefined")
                        $window.Ybug.setUser({
                            id: user.information.id.value,
                            username: user.information.profile.name + ' ' + user.information.profile.surName,
                            email: user.information.email,
                            phone: user.information.phoneNumber,
                            products: user.products.map(function (x) {
                                return x.code;
                            }).toString()
                        });
                    else if (typeof $window.ybug_settings !== "undefined") {
                        $window.ybug_settings.user = {};
                        $window.ybug_settings.user.id = user.information.id.value;
                        $window.ybug_settings.user.username = user.information.profile.name + ' ' + user.information.profile.surName;
                        $window.ybug_settings.user.email = user.information.email;
                        $window.ybug_settings.user.phone = user.information.phoneNumber;
                        $window.ybug_settings.user.products = user.products.map(function (x) {
                            return x.code;
                        }).toString();
                    }

                    if (typeof $window.TrackJS !== "undefined")
                        $window.TrackJS.configure({
                            userId: user.information.email,
                            version: $window.appVersion
                        });


                    const langIso = window.langIso(user.information.language);

                    document.tidioChatLang = langIso === 'pt-PT' ? 'pt' : langIso === 'es-ES' ? 'es' : langIso;
                    document.tidioIdentify = {
                        distinct_id: user.information.id.value, // Unique visitor ID in your system
                        email: user.information.email, // visitor email
                        name: user.information.profile.name + ' ' + user.information.profile.surName, // Visitor name
                        phone: user.information.phoneNumber //Visitor phone
                    };

                    if (typeof $window.tidioChatApi !== 'undefined') {
                        $window.tidioChatApi.setVisitorData({
                            distinct_id: user.information.id.value, // Unique visitor ID in your system
                            email: user.information.email, // visitor email
                            name: user.information.profile.name + ' ' + user.information.profile.surName, // Visitor name
                            phone: user.information.phoneNumber
                        });
                    }
                    if (userInfo)
                        userInfo.$cancelRequest();

                    userInfo = user_info.get({ userid: user.information.id.value });
                    userInfo.$promise.then(function (result) {
                        if (typeof $window.Beamer !== 'undefined') {
                            $window.Beamer.update({
                                product_id: "ETrLZbwu14939",
                                selector: ".beamer",
                                language: $window.lang.toUpperCase(),
                                lazy: true,
                                user_firstname: user.information.profile.name,
                                user_lastname: user.information.profile.surName,
                                user_email: user.information.email,
                                user_id: user.information.id.value,
                                user_phone: user.information.phoneNumber,
                                package_name: result.PackageName,
                                previous_package_name: result.PreviousPackageName,
                                total_valuation: result.TotalValuation,
                                user_type: result.UserTypeDesc,
                                office_name: user.information.profile.officeName
                            });
                        }

                        window.gclid = localStorage.getItem('gclid') || undefined;
                        window.gaclient = localStorage.getItem('gaclient') || undefined;


                        if (typeof $window.tidioChatApi !== 'undefined') {
                            $window.tidioChatApi.setContactProperties({
                                office_name: user.information.profile.officeName,
                                package_create_date: moment(result.PackageCreateDate).format("DD.MM.YYYY"),
                                package_expire_date: moment(result.PackageExpireDate).format("DD.MM.YYYY"),
                                package_name: result.PackageName,
                                previous_package_name: result.PreviousPackageName,
                                create_date: moment(result.RegistrationDate).format("DD.MM.YYYY"),
                                seller_name: result.SellerName,
                                this_month_valuation: result.ThisMonthValuation,
                                last_month_valuation: result.LastMonthValuation,
                                commercial_valuation: result.TotalCommercialValuation,
                                house_valuation: result.TotalHouseValuation,
                                plot_valuation: result.TotalPlotValuation,
                                land_valuation: result.TotalLandValuation,
                                total_valuation: result.TotalValuation,
                                user_type: result.UserTypeDesc,
                                gclid: window.gclid,
                                gaclient: window.gaclient
                            });
                            if ($window.Upscope && !service.upscopeInit)
                                $window.Upscope('getWatchLink', function (link) {
                                    $window.tidioChatApi.setContactProperties({
                                        screen_share: link
                                    });
                                });
                        }
                        if (typeof $window.wootric !== 'undefined' && !service.wootricInit) {
                            $window.wootricSettings = {
                                email: user.information.email,
                                phone_number: user.information.phoneNumber,
                                external_id: user.information.id.value,
                                created_at: moment(user.information.profile.registrationDate).unix(),
                                account_token: "NPS-66c1ee71",
                                product_name: "Endeksa",
                                twitter_account: window.lang === 'es-ES' ? 'endeksa_es' : window.lang === 'pt-PT' ? 'endeksa_pt' : 'endeksa',
                                facebook_page: 'https://www.facebook.com/endeksa',
                                language: window.lang === 'pt-PT' ? 'PT_PT' : window.lang.split('-')[0].toUpperCase(),
                                ask_permission_to_share_feedback: true,
                                // scale_color: "gradient",
                                permission_labels: {
                                    EN: "I give permission to share my feedback on Endeksa's website and social media channels.",
                                    TR: "Endeksa'nın web sitesi ve sosyal medya kanallarında geri bildirimlerimi paylaşmasına izin veriyorum.",
                                    PT_PT: "Eu dou permissão para compartilhar meu feedback nos canais de mídia social e no site da Endeksa.",
                                    ES: "Doy permiso para compartir mis comentarios en los canales de redes sociales y en el sitio web de Endeksa."
                                },
                                properties: {
                                    name: user.information.profile.name + ' ' + user.information.profile.surName,
                                    office: user.information.profile.officeName,
                                    language: window.lang,
                                    role: result.UserTypeDesc,
                                    pricing_plan: result.PackageName,
                                    // total_purchase_amount: 12,
                                    last_order_date: moment(result.PackageCreateDate).unix(),
                                    items_array: result.TotalValuation,
                                }
                            };
                            service.wootricInit = true;
                            $window.wootric("run");
                        }
                        $cookies.put('login_status', true);
                        get_user_info = false;
                    });
                    appActivitySvc.idle("userSvc");
                    raiseEvent();
                }
            } else {
                $window.localStorage.removeItem("accessToken");
                $window.localStorage.removeItem("accessTokenExpires");
                $window.localStorage.removeItem("refreshToken");
                $window.localStorage.removeItem("refreshTokenExpires");
                $window.localStorage.removeItem("Endeks");
                $cookies.put('login_status', false);

                service.info.SignedIn = false;
                service.info.Role = null;
                service.info.Products = [];
                service.info.Permissions = [];
                service.info.Id = null;
                service.info.Details = {
                    "email": null,
                    "phoneNumber": null,
                    "language": $window.langCode(),
                    "profile": {
                        "name": "",
                        "surName": "",
                        "avatarUrl": "",
                        "logoUrl": "",
                        "officeName": "",
                        "slogan": "",
                        "userType": 10,
                        // "RegisterReason": 10,
                        "useDarkMode": 1,
                        "companyId": null,
                        "registrationDate": null,
                        "lastLoginDate": null
                    },

                    "permissions": [],
                    // "registerReason": 10
                };
                service.lastResult = null;

                // if (
                //     typeof $window.Intercom !== "undefined"
                // )
                //     $window.Intercom("shutdown");

                appActivitySvc.idle("userSvc");
                raiseEvent();
            }
            service.setGA4UserProperties();
        }

        function getLastLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var successLogins = response.succesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'success';
                    return login;
                });
                var failedLogins = response.unSuccesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'failed';
                    return login;
                });

                var logins = successLogins.concat(failedLogins);

                logins = logins.slice().sort(function (a, b) {
                    return b.loginDate.localeCompare(a.loginDate);
                });

                deferred.resolve(logins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getLastFailedLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var failedLogins = response.unSuccesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'failed';
                    return login;
                });

                deferred.resolve(failedLogins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getLastSuccessLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var successLogins = response.succesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'success';
                    return login;
                });

                deferred.resolve(successLogins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function signIn(user, isCampaign) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .login2fa(user)
                .$promise
                .then(
                    function (result) {
                        //isCampaign && restart password
                        if (isCampaign && result && (result.token || result.verificationToken)) {
                            var success = $translate.instant('email_forgot_pwd');
                            window.alert(success);
                            // notifierSvc.show({ message: success, type: "success" });
                            SendForgotPasswordEmail(result.email);
                        }
                        if (result && result.token) {
                            $window.localStorage.setItem("accessToken", result.token.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                                restoreUrlService.returnTo(false);
                            }, function (reject) {
                                deferred.reject();
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            });
                        }
                        else if (result && result.verificationToken) {
                            $window.localStorage.setItem("2faPhone", result.phone);
                            $window.localStorage.setItem("2faMail", result.email);
                            $window.localStorage.setItem("verificationToken", result.verificationToken);
                            $window.localStorage.setItem("verificationTokenExpiration", result.verificationTokenExpiration);
                            $window.localStorage.setItem("verificationTokenCreatedAt", result.serverTime);
                            $state.go("code", { langcode: $window.lang || "en" });
                            deferred.resolve();
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        if (reject.data.detail && reject.data.detail.indexOf('has not been confirmed') > -1)
                            $state.go("confirmEmail", { langcode: $window.lang || "en", email: user.email });
                        else if (!isCampaign) {
                            if (reject.data.detail && reject.data.detail.includes('password is incorrect')) {
                                notifierSvc.show({ message: $translate.instant('password_incorrect'), type: "warning" });
                            } else {
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            }
                        }
                        else {
                            notifierSvc.show({ message: $translate.instant('campaign_not_found'), type: "warning" });
                        }

                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return deferred.promise;
        }
        function registerAndLogin(user) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            user.language = $window.langCode();
            auth_factory
                .registerandlogin(Object.assign(user, { captchaTokenCustom: window.ecSec() }))
                .$promise
                .then(
                    function (result) {
                        if (result && result.token) {
                            $window.localStorage.setItem("accessToken", result.token.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                                restoreUrlService.returnTo(false);
                            }, function (reject) {
                                deferred.reject();
                                // notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            });
                        }
                        else if (result && result.verificationToken) {
                            $window.localStorage.setItem("2faPhone", result.phone);
                            $window.localStorage.setItem("2faMail", result.email);
                            $window.localStorage.setItem("verificationToken", result.verificationToken);
                            $window.localStorage.setItem("verificationTokenExpiration", result.verificationTokenExpiration);
                            $window.localStorage.setItem("verificationTokenCreatedAt", result.serverTime);
                            $state.go("code", { langcode: $window.lang || "en" });
                            deferred.resolve();
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        if (reject.data.detail && reject.data.detail.indexOf('has not been confirmed') > -1)
                            $state.go("confirmEmail", { langcode: $window.lang || "en", email: user.email });

                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return deferred.promise;
        }

        function signInWithTokenResult(result) {
            var deferred = $q.defer();

            if (result && result.token) {
                $window.localStorage.setItem("accessToken", result.token.accessToken);
                $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                notificationService.purgeCache();
                notificationService.getNotifications();
                getUserInfo(null, true).then(function () {
                    deferred.resolve(result);
                    restoreUrlService.returnTo(false);
                }, function (reject) {
                    deferred.reject(reject);
                    notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                });
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function hardDelete() {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            user_factory
                .delete()
                .$promise
                .then(
                    function () {
                        $ocLazyLoad.load([
                            'https://apis.google.com/js/platform.js'
                        ]).then(function () {
                            gapi.load('auth2', function () {
                                var auth2 = gapi.auth2.getAuthInstance();
                                if (auth2)
                                    auth2.signOut().then(function () {
                                        auth2.disconnect();
                                    });
                            });
                        });
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        window.endeksa = null;
                        service.setUser();
                        var stateKeys = ['tidio_state_PK', 'tidio_state_j5alrjdajkdksb5lhqle6ssooanm9dgf'];
                        stateKeys.forEach(function (stateKey) {
                            var state = JSON.parse(localStorage.getItem(stateKey));
                            if (state)
                                $window.localStorage.setItem(stateKey, JSON.stringify({}));
                        });
                        deferred.resolve();
                    },
                    function (reject) {
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function signOut() {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .logout()
                .$promise
                .then(
                    function (result) {
                        $ocLazyLoad.load([
                            'https://apis.google.com/js/platform.js'
                        ]).then(function () {
                            gapi.load('auth2', function () {
                                var auth2 = gapi.auth2.getAuthInstance();
                                if (auth2)
                                    auth2.signOut().then(function () {
                                        auth2.disconnect();
                                    });
                            });
                        });
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        // Clear upcomingPayment cookie on logout
                        $rootScope.deleteUpcomingPaymentFromCookie();
                        window.endeksa = null;
                        service.setUser();
                        var stateKeys = ['tidio_state_PK', 'tidio_state_j5alrjdajkdksb5lhqle6ssooanm9dgf'];
                        stateKeys.forEach(function (stateKey) {
                            var state = JSON.parse(localStorage.getItem(stateKey));
                            if (state)
                                $window.localStorage.setItem(stateKey, JSON.stringify({}));
                        });
                        deferred.resolve(result);
                    },
                    function (reject) {
                        // reject.errors.map(function (error) {
                        //     notifierSvc.show({ message: error.Message, type: "error" });
                        // });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function changePassword(args) {
            appActivitySvc.busy("userSvc");

            auth_factory
                .change_password(args)
                .$promise
                .then(
                    function (result) {
                        var changePwd = $translate.instant("change_pwd");
                        notifierSvc.show({ message: changePwd, type: "success" });
                        return result;
                    },
                    function (result) {
                        result.errors.map(function (error) {
                            notifierSvc.show({ message: error.Message, type: "error" });
                        });
                        return $q.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
        }


        function changeUser() {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            loginChange().then(function () {
                ngDialog.close();
                user_factory
                    .me()
                    .$promise
                    .then(
                        function (result) {
                            service.lastResult = result;
                            $window.endeksa = {
                                id: result.information.id.value,
                                email: result.information.email,
                                phone: result.information.phoneNumber
                            };
                            service.setUser(result);
                            $window.userStorage.sync();
                            defer.resolve(result);
                            $window.location.reload();
                        },
                        function (result) {
                            $window.endeksa = null;
                            service.setUser();
                            defer.reject(result);
                        }
                    )["finally"](function () {
                        notopen = true;
                        appActivitySvc.idle("userSvc");
                    });
            }, function () {
                defer.reject();
                exitUser();
            });
            return defer.promise;
        }

        function setWithExpiry(key, value, ttl) {
            const now = new Date();

            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire
            const item = {
                value: value,
                expiry: now.getTime() + ttl,
            };
            localStorage.setItem(key, JSON.stringify(item));
        }
        function getWithExpiry(key) {
            const itemStr = localStorage.getItem(key);
            // if the item doesn't exist, return null
            if (!itemStr) {
                return null;
            }
            const item = JSON.parse(itemStr);
            const now = new Date();
            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem(key);
                return null;
            }
            return item.value;
        }

        function getFinger() {
            var defer = $q.defer();
            const cacheKey = "__eVId__";
            const ttl = 24 * 60 * 60 * 1000; //24 hours
            const cachedFinger = getWithExpiry(cacheKey);
            if (!cachedFinger)
                if (window.isHeadless()) {
                    const code = "PRERENDER_" + window.makeid(10);
                    setWithExpiry(cacheKey, code, ttl);
                    defer.resolve(code);
                }
                else {
                    $ocLazyLoad.load([
                        'https://metrics.endeksa.com/web/v3/gU3h2z8EbwK2LC8xVW6H/umd.min.js'
                    ]).then(function () {
                        var fpPromise = FingerprintJS.load({
                            region: 'eu',
                            endpoint: ["https://metrics.endeksa.com", FingerprintJS.defaultEndpoint]
                        });

                        try {
                            fpPromise
                                .then(function (fp) { return fp.get(); }, function () {
                                    console.log('FP load error...');
                                    defer.resolve();
                                })
                                .then(function (result) {
                                    setWithExpiry(cacheKey, result.visitorId, ttl);
                                    defer.resolve(result.visitorId);
                                }, function () {
                                    console.log('FP load error...');
                                    defer.resolve();
                                });
                        } catch (error) {
                            console.log('FP load error...');
                            defer.resolve();
                        }
                    }, function () {
                        console.log('FP load error...');
                        defer.resolve();
                    });
                }
            else
                defer.resolve(cachedFinger);
            return defer.promise;
        }


        function getFingerLimit(page) {
            var defer = $q.defer();
            if (page) {
                service.finger_info.prints[page] = service.finger_info.prints[page] || {};
                if (!service.finger_info.prints[page].ip && !window.isHeadless())
                    getFinger().then(function (finger) {
                        if (finger) {
                            auth_factory.get_info_finger({ 'fingerPrint': finger, page: page }).$promise.then(
                                function (result) {
                                    if (result.length) {
                                        service.finger_info.prints[page] = result[0];
                                        if (service.finger_info.prints[page].limitReached) {
                                            $timeout(function () {
                                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                                            }, 1500);
                                        }
                                    }
                                    else {
                                        service.finger_info.prints = {};
                                        service.finger_info.prints[page] = {};
                                        service.finger_info.prints[page].page = page;
                                        service.finger_info.prints[page].limitReached = false;
                                        notifierSvc.remove();
                                        notifierSvc.show({ message: $translate.instant('access_permitted'), type: "info" });
                                    }
                                    defer.resolve();
                                },
                                function () {
                                    defer.resolve();
                                });
                        }
                        else {
                            service.finger_info.prints[page].page = page;
                            service.finger_info.prints[page].limitReached = true;
                            $timeout(function () {
                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                            }, 1500);
                            defer.resolve();
                        }
                    });
                else if (window.isHeadless())
                    defer.resolve();
                else {
                    if (service.finger_info.prints[page].limitReached) {
                        $timeout(function () {
                            $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                        }, 1500);
                    }
                    defer.resolve();
                }
            }
            else {
                if (!Object.keys(service.finger_info.prints).length && !window.isHeadless())
                    getFinger().then(function (finger) {
                        if (finger) {
                            auth_factory.get_info_finger({ 'fingerPrint': finger }).$promise.then(
                                function (result) {
                                    if (result.length)
                                        result.forEach(function (m) {
                                            service.finger_info.prints[m.page] = m;
                                            if (service.finger_info.prints[m.page].limitReached) {
                                                $timeout(function () {
                                                    $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[m.page]);
                                                }, 1500);
                                            }
                                        });
                                    else {
                                        service.finger_info.prints = {};
                                        notifierSvc.remove();
                                        notifierSvc.show({ message: $translate.instant('access_permitted'), type: "info" });
                                    }
                                    defer.resolve();
                                },
                                function () {
                                    defer.resolve();
                                });
                        }
                        else {
                            service.finger_info.prints[page].page = page;
                            service.finger_info.prints[page].limitReached = true;
                            $timeout(function () {
                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                            }, 1500);
                            defer.resolve();
                        }
                    });
                else {
                    defer.resolve();
                }
            }
            return defer.promise;
        }


        function setFingerLimit(page, maxFinger, maxIp) {
            var defer = $q.defer();
            service.finger_info.prints[page] = service.finger_info.prints[page] || {};
            if (!service.finger_info.prints[page].limitReached && !window.isHeadless())
                getFinger().then(function (finger) {
                    if (finger)
                        auth_factory.set_info_finger({ 'fingerPrint': finger, page: page, maxFingerPrint: maxFinger, maxIp: maxIp }).$promise.then(
                            function (result) {
                                service.finger_info.prints[page] = result;
                                if (service.finger_info.prints[page].limitReached) {
                                    $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                                    defer.reject();
                                }
                                else
                                    defer.resolve();
                            },
                            function () {
                                defer.resolve();
                            });
                    else {
                        service.finger_info.prints[page].page = page;
                        service.finger_info.prints[page].limitReached = true;
                        $timeout(function () {
                            $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                        }, 1500);
                        defer.reject();
                    }
                });
            else if (window.isHeadless())
                defer.resolve();
            else {
                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                defer.reject();
            }
            return defer.promise;
        }

        function loginControl() {
            var defer = $q.defer();
            getFinger().then(function (finger) {
                if (finger)
                    auth_factory.get_finger({ 'userfinger': finger }).$promise.then(
                        function (result) {
                            defer.resolve({
                                active: true,
                                data: result
                            });
                        },
                        function (result) {
                            defer.reject({
                                active: false,
                                data: result.data
                            });
                        });
                else
                    defer.resolve({
                        active: true,
                        data: null
                    });
            });
            return defer.promise;
        }

        function loginChange() {
            var defer = $q.defer();
            getFinger().then(function (finger) {
                if (finger)
                    auth_factory.set_finger({ 'userfinger': finger }).$promise.then(function (result) {
                        defer.resolve({
                            active: true,
                            data: result
                        });
                    }, function (result) {
                        defer.reject({
                            active: false,
                            data: result.data
                        });
                    });
                else
                    defer.resolve({
                        active: true,
                        data: null
                    });
            });
            return defer.promise;
        }
        var notopen2 = true;
        function exitUser() {
            ngDialog.close();
            if (notopen2) {
                notopen2 = false;
                ngDialog.open({
                    templateUrl: "app/shell/logincountmultiple.html",
                    controller: function () {
                    },
                    closeByNavigation: false,
                    closeByDocument: false,
                    closeByEscape: false,
                });
                if (service.lastResult) {
                    var title =
                        "Kullanıcının cihaz değişim hakkı bitti. Takip edilmesinde fayda olabilir.";
                    var content =
                        service.lastResult.information.profile.name +
                        " " +
                        service.lastResult.information.profile.surName +
                        " " +
                        service.lastResult.information.phoneNumber +
                        " " +
                        service.lastResult.information.email;
                    leadAPI.set({
                        Email: "satis@endeksa.com",
                        Source: "Potansiyel Kaçak Kullanım Tespiti",
                        Content: [{ Value: content, Title: title }],
                    });
                }
                $window.endeksa = null;
                service.setUser();
            }
        }


        var notopen = true;
        function checkUserIsAlive() {
            if (!notopen)
                return false;
            notopen = false;
            appActivitySvc.busy("userSvc");
            loginControl().then(function (result) {
                if (result.data.multipleUseDetected) {
                    ngDialog.open({
                        templateUrl: "app/shell/logincountexceeded.html",
                        controller: [
                            "$scope",
                            function ($scope) {
                                $scope.userAgent = result.data.sessions;
                                $scope.proceedLogout = changeUser;
                            },
                        ],
                        closeByNavigation: false,
                        closeByDocument: false,
                        closeByEscape: false,
                    });
                }
            }, function () {
                // exitUser(); //TODO: [EB-270] Finger control get ucunda bazı durumlarda 500 hatası alınıyor. İncelenmeli. Sistemin açılmasına izin vermiyor.
            })["finally"](function () {
                appActivitySvc.idle("userSvc");
            });
        }

        var getting_user = false;

        function getUserInfo(force, isLogin) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            service.setGA4UserProperties();
            if (!$cookies.get('login_status'))
                $cookies.put('login_status', false);
            const token = $window.localStorage.getItem("refreshToken");
            if (!token || (window.isHeadless() && !$rootScope.clientData)) {
                defer.reject();
                appActivitySvc.idle("userSvc");
            }
            else if (service.lastResult && !force) {
                defer.resolve(service.lastResult);
                appActivitySvc.idle("userSvc");
            } else if (!getting_user || force) {
                getting_user = true;
                user_factory
                    .me()
                    .$promise
                    .then(
                        function (result) {
                            service.refreshClientId(result.information.googleClickId, result.information.googleClientId, result.information.googleSessionId, result.information.googleSessionNumber);
                            if (!window.refMobile && (!result.information.profile.userType ||
                                !result.information.profile.name ||
                                !result.information.profile.name.length ||
                                result.information.profile.name === 'Guest' ||
                                !result.information.profile.surName ||
                                !result.information.profile.surName.length ||
                                result.information.profile.surName === 'Apple' ||
                                result.information.permissions.indexOf(120) === -1 ||
                                result.information.permissions.indexOf(110) === -1 ||
                                result.information.permissions.indexOf(60) === -1 ||
                                result.information.permissions.indexOf(130) === -1 ||
                                result.information.permissions.indexOf(140) === -1)) {
                                $rootScope.unRegisteredUser = true;
                                $timeout(function () { selectUserType(); }, 2000);
                            }
                            service.lastResult = result;
                            $window.endeksa = {
                                id: result.information.id.value,
                                email: result.information.email,
                                phone: result.information.phoneNumber
                            };

                            $window.userStorage.sync();
                            service.setUser(result);
                            var check_finger = false;
                            var products = result.products.map(function (m) {
                                return m.code;
                            });
                            ['location-package', 'real-estate-package', 'platinum-package', 'eco-package', 'seller-lead-package', 'premium-package', 'premiumplus-package', 'personal-package', 'basic-package', 'pro-ee-package', 'flex-package', 'gold-package', 'terminal-flex-package', 'terminal-pro-package', 'premium-ee-package', 'terminal-premium-package'].forEach(function (product) {
                                if (products.includes(product)) {
                                    check_finger = true;
                                }
                            });
                            if (check_finger && !window.refMobile && !$rootScope.isTop)
                                checkUserIsAlive();

                            if (isLogin) {
                                const langIso = window.langIso(result.information.language);
                                window.dataLayer.push({
                                    event: "login",
                                    currency: window.currency,
                                    language: langIso,
                                    login: {
                                        method: "Form"
                                    }
                                });
                                if (langIso !== window.lang)
                                    window.localStorage.setItem('ChangeLanguage', langIso);
                                //check after transition and do the translation when everything is ready
                            }
                            $rootScope.recommendedFieldsToFill = result.information.recommendedFieldsToFill;
                            $rootScope.recommendedFieldsToFill.isAgent = result.isAgent;

                            // Handle MCP OAuth flow after successful getUserInfo
                            // Try to initialize OAuth params from URL or session storage
                            var oauthParams = mcpService.initializeOAuthParams();
                            if (oauthParams && Object.keys(oauthParams).length > 0) {
                                console.log('[SignIn] OAuth params detected, starting consent flow');
                                mcpService.handleOAuthConsentFlow(oauthParams, true)
                                    .then(
                                        function () {
                                            console.log('[SignIn] OAuth flow completed successfully');
                                        },
                                        function (error) {
                                            console.error('[SignIn] OAuth flow failed:', error);
                                        }
                                    );
                            }

                            defer.resolve(result);

                        },
                        function (rej) {
                            service.setUser();
                            $window.endeksa = null;
                            defer.reject(rej);
                        }
                    )["finally"](function () {
                        getting_user = false;
                        appActivitySvc.idle("userSvc");
                    });
            }
            else if (getting_user) {
                var interv = $interval(function () {
                    if (!getting_user) {
                        if (service.lastResult) {
                            defer.resolve(service.lastResult);
                            appActivitySvc.idle("userSvc");
                        }
                        else {
                            service.setUser();
                            $window.endeksa = null;
                            defer.reject();
                            appActivitySvc.idle("userSvc");
                        }
                        $interval.cancel(interv);
                    }
                });
            }
            return defer.promise;
        }

        // function addLocalLogin(data) {
        //     return setPassword(data);
        // }

        //register a new user and if the registration is successful signIn
        // function registerExternal(registration) {
        //     appActivitySvc.busy("userSvc");

        //     return accountClientSvc
        //         .registerExternal(registration)["finally"](function () {
        //             if (typeof $window.ga !== "undefined")
        //                 $timeout(function () {
        //                     $analytics.eventTrack("Registration Complete", {
        //                         category: "Registration",
        //                         label: "Registration Social Media",
        //                         nonInteraction: true,
        //                         page: $location.path(),
        //                     });
        //                     $window.gtag("event", "sign_up", { method: "External" });
        //                 }, 600);
        //             if (typeof $window.fbq !== "undefined")
        //                 $window.fbq("track", "CompleteRegistration");

        //             //try { $window.__adroll.record_user({ "adroll_segments": "z9oi8qg7" }) } catch (err) { }
        //             appActivitySvc.idle("userSvc");
        //         });
        // }

        function passwordStatus() {
            var deferred = $q.defer();
            if (document.cookie.indexOf('password_status') === -1) {
                var passStatus = user_factory.password_status();
                passStatus.$promise.then(function (response) {
                    var now = new Date();
                    var time = now.getTime();
                    var expireTime = time + 1000 * 60 * 60 * 24 * 5;
                    now.setTime(expireTime);
                    document.cookie = 'password_status=cached;expires=' + now.toUTCString() + ';path=/';
                    deferred.resolve(response);
                }, function (reject) {
                    deferred.reject(reject);
                });
            } else {
                deferred.resolve({ expiredStatus: false });
            }
            return deferred.promise;
        }

        function register(registration) {
            var deferred = $q.defer();
            appActivitySvc.busy("userSvc");
            //grecaptcha.ready(function () {
            //grecaptcha.execute('6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS', { action: 'submit' }).then(function (token) {
            //registration.captchaToken = token;
            registration.RefUrl = window.referrer;
            registration.googleClickId = window.gclid;
            registration.googleClientId = window.gaclient;
            registration.googleSessionId = window.gasessionId;
            registration.googleSessionNumber = window.gasessionNumber;
            registration.captchaTokenCustom = window.ecSec();
            restoreUrlService.getLastState().then(function (res) {
                if (res && res.lastState && res.lastState.indexOf('valuation') > -1)
                    registration.RefFunc = 10;
                else if (res && res.lastState && res.lastState.indexOf('cozumler') > -1)
                    registration.RefFunc = 20;
                else if (res && res.lastState && res.lastState.indexOf('hizmetler') > -1)
                    registration.RefFunc = 30;
                else if (res && res.lastState && res.lastState.indexOf('analysis') > -1)
                    registration.RefFunc = 40;
                else
                    registration.RefFunc = 0;
            });
            user_factory
                .create(registration)
                .$promise
                .then(function (result) {
                    window.dataLayer.push({
                        event: "sign_up",
                        currency: window.currency,
                        language: window.lang.split('-')[0],
                        // referrer: window.referrer,
                        // gclid: window.gclid,
                        // visitorReason: registration.RegisterReason,
                        // referencePage: registration.RefFunc,
                        // visitorType: registration.userType,
                        login: {
                            method: "Form"
                        }
                    });
                    if (typeof $window.fbq !== "undefined") {
                        $window.fbq('track', 'Lead');
                        $window.fbq("track", "CompleteRegistration");
                    }
                    deferred.resolve(result);
                }, function (reject) {
                    deferred.reject(reject);
                })["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            //});
            //});

            return deferred.promise;
        }

        function refresh() {
            var deferred = $q.defer();
            appActivitySvc.busy("userSvc");

            const token = $window.localStorage.getItem("accessToken");
            const expire = $window.localStorage.getItem("accessTokenExpires");
            const refreshToken = $window.localStorage.getItem("refreshToken");
            const refreshTokenExpires = $window.localStorage.getItem("refreshTokenExpires");
            if (refreshToken && refreshTokenExpires && token && expire && !window.isHeadless())
                auth_factory
                    .refresh({ accessToken: token, refreshToken: refreshToken, accessTokenExpiration: expire, refreshTokenExpiration: refreshTokenExpires })
                    .$promise
                    .then(
                        function (result) {
                            deferred.resolve(result);
                        },
                        function (reject) {
                            deferred.reject(reject);
                        }
                    )["finally"](function () {
                        appActivitySvc.idle("userSvc");
                    });
            else {
                appActivitySvc.idle("userSvc");
                deferred.reject();
            }
            return deferred.promise;
        }

        function signInExternal(data) {
            data.language = $window.langCode();
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .verify_token(data)
                .$promise
                .then(
                    function (result) {
                        if (result && result.accessToken) {

                            $window.localStorage.setItem("accessToken", result.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.refreshTokenExpiration);
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                            }, function (reject) {
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                                deferred.reject(reject);
                            });
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function signInEmlakjet(tokenData) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();

            if (tokenData && tokenData.accessToken) {
                $window.localStorage.setItem("accessToken", tokenData.accessToken);
                $window.localStorage.setItem("accessTokenExpires", tokenData.accessTokenExpiration);
                $window.localStorage.setItem("refreshToken", tokenData.refreshToken);
                $window.localStorage.setItem("refreshTokenExpires", tokenData.refreshTokenExpiration);

                getUserInfo(null, true).then(
                    function () {
                        appActivitySvc.idle("userSvc");
                        deferred.resolve(tokenData);
                    },
                    function (reject) {
                        appActivitySvc.idle("userSvc");
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                );
            } else {
                appActivitySvc.idle("userSvc");
                deferred.reject({ error: 'invalid_token', message: 'Token bilgisi eksik' });
            }
            return deferred.promise;
        }

        function externalLoginConfirm(data) {
            var request = {
                provider: data.provider,
                token: data.token,
                email: data.email || null
            };
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .external_login_confirm(request)
                .$promise
                .then(
                    function (result) {
                        deferred.resolve(result.isRequired === true);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }


        function SendConfirmationEmail(email, token) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .get_confirm({ email: email, language: $window.langCode(), captchaToken: token })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "error" });
                        defer.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return defer.promise;
        }

        function ConfirmEmail(data) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .set_confirm(data)
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail, type: "error" });
                        // var storedLang =
                        //     $window.lang || "tr";
                        // $state.go("confirmEmail", { langcode: storedLang });

                        defer.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function SendForgotPasswordEmail(email) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .forgot_password({ email: email })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function ResetPassword(Email, Password, Token, Key) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .change_password({ email: Email, password: Password, token: Token, userId: Key })
                .$promise
                .then(
                    function (result) {
                        $window.location.href =
                            "/" + $rootScope.lang + "/signin?status=reset";
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function NewPassword(Email, Password, Token, Key) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .change_password({ email: Email, password: Password, token: Token, userId: Key })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function raiseEvent() {
            $rootScope.$broadcast("userSvc:signedInChanged", {
                SignedIn: service.info.SignedIn,
            });
            $rootScope.SignedIn = service.info.SignedIn;
        }
        var userSelectDialog;
        function selectUserType() {
            if (!userSelectDialog)
                userSelectDialog = ngDialog.open({
                    templateUrl: "app/security/complete-account.modal.html",
                    controller: selectUserTypeController,
                    closeByEscape: false,
                    className: "ngdialog-theme-default on-top",
                });

            selectUserTypeController.$inject = [
                "$scope",
                "$rootScope",
                "notifierSvc",
                "$translate",
                "geoApi",
                "provinceListService",
                "$timeout"
            ];

            function selectUserTypeController($scope, $rootScope, notifierSvc, $translate, geoApi, provinceListService, $timeout) {
                $scope.phoneVisible = false;
                if (!window.libphonenumber) {
                    $ocLazyLoad.load([
                        "/assets/js/vendor.phone.min.js?v=" + ($window.appVersion || Date.now())
                    ]).then(function () {
                        $scope.phoneVisible = true;
                    }, function () {
                        $scope.phoneVisible = false;
                    });
                } else {
                    $scope.phoneVisible = true;
                }
                $scope.updateMyProfile = updateMyProfile;
                $scope.userData = angular.copy(service.info);
                $scope.hasMail = $scope.userData.Details.email !== '' && $scope.userData.Details.email !== null;
                $scope.hasPhone = $scope.userData.Details.phoneNumber !== '' && $scope.userData.Details.phoneNumber !== null;
                if (!$scope.userData.Details.permissions.includes(40))
                    $scope.userData.Details.permissions.push(40);
                if (!$scope.userData.Details.permissions.includes(30))
                    $scope.userData.Details.permissions.push(30);
                $scope.userData.Details.canReceiveSystemNotification = true;
                $scope.userData.Details.canReceiveRealEstateNotification = true;

                $scope.userData.Details.profile.userType = $scope.userData.Details.profile.userType || 10;

                if ($scope.userData.Details.profile.name === 'Guest') {
                    $scope.userData.Details.profile.name = "";
                }
                if ($scope.userData.Details.profile.surName === 'Apple')
                    $scope.userData.Details.profile.surName = "";

                geoApi.getCountries({ language: window.langCode() }).$promise.then(function (result) {
                    $scope.nationality = result;
                    let code;
                    switch ($rootScope.country) {
                        case 'world':
                            code = 826;
                            break;
                        case 'turkiye':
                            code = 792;
                            break;
                        case 'espana':
                            code = 724;
                            break;
                        case 'portugal':
                            code = 620;
                            break;
                        default:
                            code = 792;
                    }
                    $scope.selectedCountry = result.find(c => c.CountryCode === code);
                    $scope.getCities();
                });

                $scope.getCities = function () {
                    let nationality;
                    switch ($scope.selectedCountry.CountryCode) {
                        case 792:
                            nationality = 1;
                            break;
                        case 724:
                            nationality = 2;
                            break;
                        case 620:
                            nationality = 3;
                            break;
                        default:
                            $scope.userCities = null;
                            $scope.selectedCity = null;
                            return;
                    }
                    provinceListService.getProvinces(nationality).then(function (response) {
                        $scope.userCities = response.List;
                        $scope.selectedCity = {};
                    });
                };


                $scope.mailValidation = {
                    valid: true,
                    registered: false,
                    changed: false,
                    waitingOtp: false
                };

                $scope.phoneValidation = {
                    valid: true,
                    registered: false,
                    changed: false,
                    waitingOtp: false
                };

                // Captcha state
                $scope.ETToken = null;
                $scope.captchaVerified = false;
                $scope.isTurkishPhone = true;
                $scope.eimageCaptchaKey = null;
                $scope.eimageCaptchaValue = null;

                $timeout(function () {
                    $scope.mailValidation.changed = false;
                    $scope.phoneValidation.changed = false;
                }, 1000);

                // $scope.sozlesmeKabul = $scope.userData.Details.permissions.indexOf(130) > -1;
                // $scope.gizlilikKabul = $scope.userData.Details.permissions.indexOf(110) > -1;
                // $scope.kisiselveriKabul = $scope.userData.Details.permissions.indexOf(140) > -1;

                function updateMyProfile(form) {
                    if (form.$valid && $scope.userData.Details.profile.userType && $scope.userData.Details.profile.name && $scope.userData.Details.profile.surName) {
                        if (!$scope.userData.Details.phoneNumber)
                            $scope.userData.Details.phoneNumber = null;
                        if ($scope.userData.Details.phoneNumber) {
                            $scope.userData.Details.phoneNumber = $scope.userData.Details.phoneNumber.replace(/\s+/g, '');
                        }
                        $scope.loading = true;
                        $scope.userData.Details.profile.lang = $rootScope.lang;
                        if ($scope.userData.Details.registerReason === 10 && $scope.userData.Details.contactAccepted) {
                            $scope.userData.Details.permissions.push(150, 160);
                        }
                        $scope.userData.Details.RefUrl = window.referrer;
                        restoreUrlService.getLastState().then(function (res) {
                            if (res && res.lastState && res.lastState.indexOf('valuation') > -1)
                                $scope.userData.Details.RefFunc = 10;
                            else if (res && res.lastState && res.lastState.indexOf('cozumler') > -1 || res && res.lastState && res.lastState.indexOf('solutions') > -1)
                                $scope.userData.Details.RefFunc = 20;
                            else if (res && res.lastState && res.lastState.indexOf('hizmetler') > -1 || res && res.lastState && res.lastState.indexOf('services') > -1)
                                $scope.userData.Details.RefFunc = 30;
                            else if (res && res.lastState && res.lastState.indexOf('analiz') > -1)
                                $scope.userData.Details.RefFunc = 40;
                            else
                                $scope.userData.Details.RefFunc = 0;
                        });
                        $scope.userData.Details.CountryId = $scope.userData.Details.countryId ? $scope.userData.Details.countryId : ($scope.selectedCountry.CountryId ? $scope.selectedCountry.CountryId : $scope.selectedCountry.CountryCode);
                        $scope.userData.Details.CountryName = $scope.userData.Details.countryName ? $scope.userData.Details.countryName : $scope.selectedCountry.CountryName;
                        $scope.userData.Details.CityId = $scope.userData.Details.cityId ? $scope.userData.Details.cityId : ($scope.selectedCity && $scope.selectedCity.hasOwnProperty('CityId') ? $scope.selectedCity.cityId : null);
                        $scope.userData.Details.CityName = $scope.userData.Details.cityName ? $scope.userData.Details.cityName : ($scope.selectedCity && $scope.selectedCity.hasOwnProperty('CityName') ? $scope.selectedCity.CityName : null);
                        $rootScope.unRegisteredUser = false;
                        if ($scope.userData.Details.permissions.indexOf(60) === -1) $scope.userData.Details.permissions.push(60);
                        if ($scope.userData.Details.permissions.indexOf(110) === -1) $scope.userData.Details.permissions.push(110);
                        if ($scope.userData.Details.permissions.indexOf(120) === -1) $scope.userData.Details.permissions.push(120);
                        if ($scope.userData.Details.permissions.indexOf(130) === -1) $scope.userData.Details.permissions.push(130);
                        if ($scope.userData.Details.permissions.indexOf(140) === -1) $scope.userData.Details.permissions.push(140);
                        user_factory.update($scope.userData.Details).$promise.then(
                            function (result) {
                                window.dataLayer.push({
                                    event: "sign_up",
                                    currency: window.currency,
                                    language: window.lang.split('-')[0],
                                    // referrer: window.referrer,
                                    // gclid: window.gclid,
                                    // visitorReason: $scope.userData.Details.registerReason,
                                    // referencePage: $scope.userData.Details.profile.RefFunc,
                                    // visitorType: $scope.userData.Details.profile.userType,
                                    login: {
                                        method: "External"
                                    }
                                });
                                CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;
                                getUserInfo(true, true).then(function () {
                                    $scope.loading = false;
                                    $scope.closeThisDialog();
                                }, function () {
                                    $scope.loading = false;
                                    var updateProfile2 = $translate.instant("update_myprofile2");
                                    notifierSvc.show({ message: updateProfile2, type: "error" });
                                });
                            },
                            function (err) {
                                $scope.loading = false;
                                if (err.data.detail.includes("updated with newer")) {
                                    notifierSvc.show({ message: $translate.instant('account_update_error'), type: "error" });
                                } else {
                                    var updateProfile2 = $translate.instant("update_myprofile2");
                                    notifierSvc.show({ message: updateProfile2, type: "error" });
                                }
                            }
                        );

                    } else {
                        $scope.formValid = false;
                    }
                }

                $scope.changePermission = (event, val) => {
                    if (event) {
                        $scope.userData.Details.permissions.push(val);
                    } else {
                        const index = $scope.userData.Details.permissions.indexOf(val);
                        $scope.userData.Details.permissions.splice(index, 1);
                    }
                };

                $scope.termsModal = function () {
                    ngDialog.open({
                        templateUrl: 'app/content/sozlesme/' + window.lang + '/kullanim.html',
                        controller: ['$scope', ($scope) => {
                            $scope.onModal = true;
                        }]
                    });
                };

                $scope.gizlilikModal = function () {
                    ngDialog.open({
                        templateUrl: 'app/content/sozlesme/' + window.lang + '/gizlilik.html',
                        controller: ['$scope', ($scope) => {
                            $scope.onModal = true;
                        }]
                    });
                };


            }
        }
        return service;
    }
})();

(function () {
    'use strict';

    var serviceId = 'externalAuthSvc';

    angular.module('app.security')
        .factory(serviceId, ['$location', '$q', 'appActivitySvc', 'notifierSvc', 'userSvc', 'restoreUrlService', '$state', '$translate', '$window', externalAuthSvc]);

    function externalAuthSvc($location, $q, appActivitySvc, notifierSvc, userSvc, restoreUrlService, $state, $translate, $window) {
        // var registrationInfo, associationInfo;

        var service = {
            handleAuthResponse: handleAuthResponse,
            // getRegistrationInfo: getRegistrationInfo,
            // getAssociationInfo: getAssociationInfo
        };

        return service;

        function handleAuthResponse() {
            appActivitySvc.busy("externalAuthSvc");
            var storedLang = $window.localStorage.getItem("Language") || 'tr';


            var locationPath = $location.path(),
                deferred = $q.defer();

            //login with Google or Facebook
            if (locationPath && locationPath.toLowerCase().indexOf("/externalauth") > -1) {
                var externalActionResult = parseResponse($location.hash());
                if (!externalActionResult || !externalActionResult.access_token) {
                    $translate('error_get_token').then(function (errorToken) {
                        notifierSvc.show({ message: errorToken, type: "error" });
                        appActivitySvc.idle("externalAuthSvc");
                        $state.go('signin', { langcode: storedLang });
                    });
                } else if (externalActionResult.error) {
                    $translate('confirm_error').then(function (confirmError) {
                        notifierSvc.show({ message: confirmError + externalActionResult.error, type: "error" });
                        appActivitySvc.idle("externalAuthSvc");
                        $state.go('signin', { langcode: storedLang });
                    });
                } else {
                    if (locationPath === "/externalauth/login") {
                        $window.localStorage.setItem("accessToken", externalActionResult.access_token);
                        $window.localStorage.setItem("refreshToken", externalActionResult.refresh_token);
                        $window.localStorage.setItem("accessTokenExpires", externalActionResult.access_token_expiration);
                        $window.localStorage.setItem("refreshTokenExpires", externalActionResult.refresh_token_expiration);
                    }
                    // else if (locationPath === "/externalauth/register") {
                    //     localStorage.setItem("accessToken", externalActionResult.access_token, false);
                    //     registrationInfo = externalActionResult;
                    // } else if (locationPath === "/externalauth/association") {
                    //     associationInfo = { externalAccessToken: externalActionResult.access_token };
                    // }
                    userSvc.getUserInfo()
                        .then(function (result) {
                            if (result.information) {
                                restoreUrlService.returnTo(true);
                            } else {
                                if (result.title || result.detail)
                                    notifierSvc.show({ message: result.detail ? result.detail : result.title, type: "error" });
                                $state.go("signin", { langcode: storedLang });
                            }
                        }, function (result) {
                            if (result.title || result.detail)
                                notifierSvc.show({ message: result.detail ? result.detail : result.title, type: "error" });
                            $state.go("signin", { langcode: storedLang });
                        })['finally'](
                            function () {
                                appActivitySvc.idle("externalAuthSvc");
                                deferred.resolve();
                            });
                }
            } else if (locationPath && locationPath.toLowerCase().indexOf('/confirmuser') > -1) {
                var confirmParams = {};
                window.localStorage.setItem("Language", storedLang);
                window.localStorage.setItem("NG_TRANSLATE_LANG_KEY", storedLang);
                if ($location.search().email && $location.search().token) {
                    confirmParams.email = $location.search().email;//.replaceAllString(' ', '+');
                    confirmParams.token = $location.search().token;//.replaceAllString(' ', '+');
                    userSvc.ConfirmEmail(confirmParams)
                        .then(
                            function () {
                                $state.go('signin', { status: 'activated', langcode: storedLang });
                            },
                            function (reject) {
                                if (reject.data.detail.indexOf('already') > -1)
                                    $state.go('signin', { status: 'activated', langcode: storedLang });
                                else
                                    $state.go('confirmEmail', { langcode: storedLang, email: confirmParams.email });
                            })['finally'](
                                function () {
                                    appActivitySvc.idle("externalAuthSvc");
                                    deferred.resolve();
                                });
                } else {
                    //redirect
                    appActivitySvc.idle("externalAuthSvc");
                    deferred.resolve();
                    $location.path('/' + storedLang + '/');
                }

            } else {
                appActivitySvc.idle("externalAuthSvc");
                deferred.reject();
            }
            return deferred.promise;
        }

        // function associateLogin() {
        //     var deferred = $.defer();
        //     userSvc.addExternalLogin(associationInfo)
        //         .then(
        //             function (result) {
        //                 //success
        //                 if (result && result.data && result.data.Succeeded) {
        //                     var associateLogin = $translate.instant('associate_login');
        //                     notifierSvc.show({ message: associateLogin, type: "info" });
        //                     restoreUrlService.returnTo();
        //                     $q.resolve(result);
        //                     //$state.go('profile.account', { langcode: storedLang });
        //                 } else {
        //                     if (result && result.data && result.data.Errors)
        //                         result.data.Errors.map(function (error) {
        //                             notifierSvc.show({ message: error.Message, type: "error" });
        //                         });
        //                     else
        //                         notifierSvc.show({ message: result.error, type: "error" });
        //                     $q.reject(result.error);
        //                 }
        //             },
        //             function (result) {
        //                 $translate('associate_login2').then(function (associateLogin2) {
        //                     notifierSvc.show({ message: associateLogin2, type: "error" });
        //                     deferred.reject(result);
        //                 });
        //             })['finally'](
        //                 function always() {
        //                     appActivitySvc.idle("externalAuthSvc");
        //                 });
        //     return deferred.promise;
        // }

        //function registerExternal(registerInfo) {
        //    ngDialog.open({
        //        template: '/app/security/register-loading.html',
        //        showClose: false,
        //        closeByEscape: false,
        //        data: {
        //            Message: 'Hesabınız Oluşturuluyor'
        //        }
        //    });
        //    userSvc.registerExternal(registerInfo).then(
        //        function () {
        //            ngDialog.close();
        //            ngDialog.open({
        //                template: '/app/security/register-loading.html',
        //                showClose: false,
        //                closeByEscape: false,
        //                data: {
        //                    Message: 'Giriş Yapılıyor'
        //                }
        //            });
        //            userSvc.signInExternal(registerInfo.LoginProvider).then(
        //                function (signInExternalResult) {
        //                    $window.location.href = signInExternalResult.data.Url;
        //                    ngDialog.close();
        //                },
        //                function (signInExternalResult) {
        //                    //error
        //                    ngDialog.close();
        //                    notifierSvc.show({ message: "Bir hata oluştu " + result.error, type: "error" });
        //                }
        //            );
        //        },
        //        function (registerExternalResult) {
        //            ngDialog.close();
        //            $location.path("/giris").hash('');
        //            registerExternalResult.errors.map(function (error) {
        //                notifierSvc.show({ message: error.Message, type: "error" });
        //            });
        //        });
        //}


        // function getRegistrationInfo() {
        //     return registrationInfo;
        // }

        // function getAssociationInfo() {
        //     return associationInfo;
        //}

        function parseResponse(response) {
            var result = {};

            var urlParts = response.split("&");

            urlParts.forEach(function (item) {
                var i = item.indexOf('=');
                var splitItem = [item.slice(0, i), item.slice(i + 1)];
                result[splitItem[0]] = decodeURIComponent(splitItem[1]);
            });

            return result;
        }
    }
})();
(function () {
    'use strict';

    var controllerId = 'ExternalSignInController';

    angular.module('app.core')
        .controller(controllerId, ['$scope', '$window', 'notifierSvc', 'appActivitySvc', '$translate', '$state', '$timeout', 'ngDialog', 'auth_factory', 'userSvc', ExternalSignInController]);

    function ExternalSignInController($scope, $window, notifierSvc, appActivitySvc, $translate, $state, $timeout, ngDialog, auth_factory, userSvc) {
        $scope.authProviders = undefined;
        $scope.loginExternal = {
            apple: false,
            google: false,
            other: false,
            emlakjet: false
        };
        $scope.login = login;
        $scope.loginWithEmlakjet = loginWithEmlakjet;
        $scope.confirmEjMerge = confirmExternalLoginAdditionalConfirmation;

        var pendingExternalLoginData = null;
        var pendingExternalLoginProviderKey = null;
        var externalLoginConfirmationDialog = null;

        getAuthProviders();

        AppleID.auth.init({
            clientId: 'com.endeksa.ios.client',
            scope: 'name email',
            redirectURI: 'https://' + location.host + '/' + window.lang + '/signin',
            state: 'origin:web',
            usePopup: true
        });

        $scope.loginWithApple = function () {
            $timeout(function () {
                $scope.loginExternal.apple = true;
            });
            const data = AppleID.auth.signIn().then(data => {
                console.log(data);
                if (data.user) {
                    var email = data.user.email ? data.user.email : null;
                    var name = data.user.name ? data.user.name.firstName : null;
                    var lastName = data.user.name ? data.user.name.lastName : null;

                    appleSignin(data.authorization.id_token, name, lastName, email);
                } else {
                    appleSignin(data.authorization.id_token);
                }
            }).catch(e => {
                $timeout(function () {
                    $scope.loginExternal.apple = false;
                });
                console.log(e);
            });
        };

        function onSignin() {
            gapi.load('auth2', function () {
                // Retrieve the singleton for the GoogleAuth library and set up the client.
                gapi.auth2.init({
                    client_id: '760143033845-7vhleskmthauri8uq2kfn45dr0frga3b.apps.googleusercontent.com',
                    cookiepolicy: 'single_host_origin',
                    // Request scopes in addition to 'profile' and 'email'
                    //scope: 'additional_scope'
                }).then(function (auth2) {
                    attachSignin(document.getElementById('endeksa-signin2'), auth2);
                }, function (error) {
                    console.log(error);
                });

            });
        }

        function appleSignin(token, name = null, lastName = null, email = null) {
            signInExternalWithConfirmation({ provider: 'Apple', token: token, name: name, surName: lastName, email: email }, 'apple');
        }

        function signInExternalWithConfirmation(data, providerKey) {
            userSvc.externalLoginConfirm(data).then(
                function (isRequired) {
                    if (isRequired === true) {
                        setExternalLoginLoading(providerKey, false);
                        openExternalLoginAdditionalConfirmationDialog(data, providerKey);
                        return;
                    }
                    completeExternalSignIn(data, providerKey);
                },
                function () {
                    setExternalLoginLoading(providerKey, false);
                }
            );
        }

        function openExternalLoginAdditionalConfirmationDialog(data, providerKey) {
            pendingExternalLoginData = angular.copy(data);
            pendingExternalLoginProviderKey = providerKey;
            externalLoginConfirmationDialog = ngDialog.open({
                templateUrl: 'app/security/ej-merge-confirmation.modal.html',
                scope: $scope,
                showClose: false,
                closeByEscape: false,
                closeByDocument: false,
                closeByNavigation: false
            });
        }

        function confirmExternalLoginAdditionalConfirmation(isConfirmed) {
            if (!pendingExternalLoginData || !pendingExternalLoginProviderKey) {
                return;
            }

            pendingExternalLoginData.IsEjMergeConfirmed = isConfirmed;
            if (externalLoginConfirmationDialog) {
                externalLoginConfirmationDialog.close();
                externalLoginConfirmationDialog = null;
            }

            var data = pendingExternalLoginData;
            var providerKey = pendingExternalLoginProviderKey;
            pendingExternalLoginData = null;
            pendingExternalLoginProviderKey = null;
            setExternalLoginLoading(providerKey, true);
            completeExternalSignIn(data, providerKey);
        }

        function completeExternalSignIn(data, providerKey) {
            userSvc.signInExternal(data).then(
                function () {
                    setExternalLoginLoading(providerKey, false);
                    $window.location.reload();
                },
                function () {
                    setExternalLoginLoading(providerKey, false);
                }
            );
        }

        function setExternalLoginLoading(providerKey, isLoading) {
            $timeout(function () {
                $scope.loginExternal[providerKey] = isLoading;
            });
        }

        function attachSignin(element, auth2) {
            auth2.attachClickHandler(element, {},
                function (googleUser) {
                    $scope.loginExternal.google = true;
                    $scope.$apply();
                    var dataObj = {
                        provider: 'Google',
                        isMobile: false,
                        token: googleUser.getAuthResponse().id_token
                    };
                    signInExternalWithConfirmation(dataObj, 'google');
                }, function (error) {
                    $timeout(function () {
                        $scope.loginExternal.google = false;
                    });
                    console.log(JSON.stringify(error, undefined, 2));
                });
        }


        function login(url) {
            // ngDialog.close();
            // ngDialog.open({
            //     templateUrl: 'app/shell/modal-wait.html'
            // });
            $state.go('signin', { langcode: $window.lang }); //added to remember the state, otherwise it doesnt realisethe state change
            $timeout(function () {
                $window.location.href = url;
            }, 500);
        }

        function loginWithEmlakjet() {
            $timeout(function () {
                $scope.loginExternal.emlakjet = true;
            });
            auth_factory.emlakjetLogin().$promise.then(
                function (result) {
                    if (result && result.authorizeUrl) {
                        $window.location.href = result.authorizeUrl;
                    } else {
                        $timeout(function () {
                            $scope.loginExternal.emlakjet = false;
                        });
                        notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    }
                },
                function (error) {
                    console.log(error);
                    $timeout(function () {
                        $scope.loginExternal.emlakjet = false;
                    });
                    notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                }
            );
        }

        function getAuthProviders() {
            appActivitySvc.busy("ExternalSignInController");
            $scope.loadingExternalButtons = true;

            auth_factory.externallogins().$promise.then(
                function (result) {
                    $scope.authProviders = result;
                    onSignin();
                },
                function (reject) {
                    var account = $translate.instant('external_account_client');
                    notifierSvc.show({ message: account, type: "error" });
                }
            )['finally'](
                function () {
                    appActivitySvc.idle("ExternalSignInController");
                    $scope.loadingExternalButtons = false;
                });
        }
    }
})();

(function () {
    'use strict';

    var controllerId = 'SignInController';

    angular.module('app.core').controller(controllerId, SignInController);

    SignInController.$inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$translate',
        'userSvc',
        '$state',
        'ngDialog',
        '$window',
        "restoreUrlService",
        "$timeout",
        "otpService",
        "notifierSvc",
        "mcpService"
    ];

    function SignInController(
        $rootScope,
        $scope,
        $stateParams,
        $translate,
        userSvc,
        $state,
        ngDialog,
        $window,
        restoreUrlService,
        $timeout,
        otpService,
        notifierSvc,
        mcpService
    ) {
        // Captcha state (managed by phone-input directive)
        $scope.captchaVerified = false;
        $scope.ETToken = null;
        $scope.isTurkishPhone = true; // Updated by directive via two-way binding
        $scope.eimageCaptchaKey = null;
        $scope.eimageCaptchaValue = null;

        // Emlakjet OAuth callback handling
        handleEmlakjetCallback();

        function handleEmlakjetCallback() {
            var emlakjetParams = mcpService.checkEmlakjetCallback();

            if (emlakjetParams) {
                // If params incomplete, show error immediately
                if (emlakjetParams.hasError) {
                    notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    return;
                }

                $scope.emlakjetLoading = true;

                mcpService.handleEmlakjetCallback(emlakjetParams).then(
                    function (result) {
                        if (result && result.token) {
                            userSvc.signInEmlakjet(result.token).then(
                                function () {
                                    $scope.emlakjetLoading = false;
                                    $window.location.reload();
                                },
                                function () {
                                    $scope.emlakjetLoading = false;
                                }
                            );
                        } else {
                            $scope.emlakjetLoading = false;
                            notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                        }
                    },
                    function (err) {
                        $scope.emlakjetLoading = false;
                        notifierSvc.show({ message: $translate.instant('emlakjet_signin_error'), type: "error" });
                    }
                );
            }
        }

        //** navigation manipulation */

        if ($(".toggle-map-wrapper").length > 0) {
            var filterVal = "blur(5px)";
            $(".toggle-map-wrapper")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
            $(".navbar")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
            $(".ed-wrap")
                .css("filter", filterVal)
                .css("webkitFilter", filterVal)
                .css("mozFilter", filterVal)
                .css("oFilter", filterVal)
                .css("msFilter", filterVal);
        }


        $scope.message = {
            info: $stateParams.info,
            infoType: $stateParams.type
        };

        if ($stateParams.status === 'reset') {
            $scope.message.info = $translate.instant('reset_info');
        } else if ($stateParams.status === 'activated') {
            $scope.message.info = $translate.instant('activate_info');
        } else if ($stateParams.status === 'valuation') {
            $scope.message.info = $translate.instant('l_warning2');
        } else if ($stateParams.status === 'multiuser') {
            $scope.message.info = $translate.instant('multiuser_info');
        } else if ($stateParams.status === 'guard') {
            $scope.message.info = (window.lang === "tr" ? "Bu sayfayı görüntülemek için yetkili bir hesap ile giriş yapmalısınız." : "You should sign in with an authorized account to view this page.");
        } else if ($stateParams.status === 'renta') {
            $scope.message.info = (window.lang === "tr" ? "KiraTrink için lütfen giriş yapınız.<br>Ücretsiz Kaydol seçeneği ile hemen ücretsiz hesap<br>oluşturabilirsiniz." : "You should sign in for KiraTrink.<br>You can create your account free of charge<br>by following Create Account link.");
        }

        $scope.$on('$translateLoadingEnd', function () {
            if ($stateParams.status === 'reset') {
                $scope.message.info = $translate.instant('reset_info');
            } else if ($stateParams.status === 'activated') {
                $scope.message.info = $translate.instant('activate_info');
            } else if ($stateParams.status === 'multiuser') {
                $scope.message.info = $translate.instant('multiuser_info');
            }
        });

        $scope.loginLoading = false;
        $scope.syncLoading = false;

        $scope.user = {
            email: '',
            password: '',
            phoneNumber: ''
        };


        if ($rootScope.isBank && $rootScope.clientData.phoneNumber)
            $scope.user = Object.assign($scope.user, $rootScope.clientData);




        //password visibilityu
        $scope.showPassword = false;
        $scope.passwordVisibility = function () {
            $scope.showPassword = !$scope.showPassword;
        };

        //email or phone login
        var isMail = localStorage.getItem('isMailLogin') && !$rootScope.isTop;
        if (isMail === "true") {
            $scope.isMail = true;
        } else {
            $scope.isMail = false;
        }
        $scope.toggleMailLogin = function () {
            $scope.isMail = !$scope.isMail;
            window.localStorage.setItem('isMailLogin', JSON.stringify($scope.isMail));
            if (!$scope.isMail) {
                $scope.user.email = null;
            }
            if (!$scope.isMail) {
                $timeout(function () {
                    var phoneInput = document.getElementById('phone-nput');
                    if (phoneInput) {
                        phoneInput.focus();
                    }
                }, 100);
            }
        };


        //<- CAMPAIGN BLOCK STARTS
        $scope.isCampaign = $stateParams.status === 'campaign' && $stateParams.code;
        $scope.checks = {
            first: false,
            second: false,
            third: false
        };

        if ($scope.isCampaign) {
            $scope.user.password = $stateParams.code;
            $scope.user.email = $stateParams.email;
        }
        $scope.termsModal = function () {
            ngDialog.open({
                templateUrl: 'app/content/sozlesme/' + window.lang + '/kullanim.html',
                controller: ['$scope', ($scope) => {
                    $scope.onModal = true;
                }]
            });
        };
        $scope.gizlilikModal = function () {
            ngDialog.open({
                templateUrl: 'app/content/sozlesme/' + window.lang + '/gizlilik.html',
                controller: ['$scope', ($scope) => {
                    $scope.onModal = true;
                }]
            });
        };

        //CAMPAIGN BLOCK ENDS ->

        if ($rootScope.SignedIn)
            restoreUrlService.returnTo();


        // sign in block starts

        $scope.signInEmail = signInEmail;
        function signInEmail() {
            $scope.loginLoading = true;
            $scope.user.language = $window.langCode();
            userSvc.signIn($scope.user, $scope.isCampaign)
                .then(
                    function (result) {
                        ngDialog.close();
                        if (result.data === "202") {
                            $state.go("activateEmail", { langcode: $rootScope.lang, email: result.email });
                        } else {
                            $scope.loginLoading = false;
                        }
                    },
                    function () {
                        $scope.loginLoading = false;
                    });
        }

        $scope.signInPhone = signInPhone;
        $scope.confirmEjMerge = confirmEjMerge;
        var pendingAdditionalConfirmationResult = null;
        var ejMergeConfirmationDialog = null;

        function signInPhone() {
            // Require captcha for non-Turkish phone numbers
            if (!$scope.isTurkishPhone && (!$scope.captchaVerified || !$scope.ETToken)) {
                notifierSvc.show({ message: $translate.instant('turnstile_required'), type: "warning" });
                return;
            }

            $scope.loginLoading = true;
            $scope.user.IsEjMergeConfirmed = undefined;
            // Pass turnstile token for non-Turkish phone numbers
            var ETToken = !$scope.isTurkishPhone ? $scope.ETToken : null;
            var eimageCaptchaData = !$scope.isTurkishPhone && $scope.eimageCaptchaKey ? { key: $scope.eimageCaptchaKey, value: $scope.eimageCaptchaValue } : null;

            otpService.callOtp("loginAndRegister", 1, $scope.user.phoneNumber, null, null, ETToken, eimageCaptchaData).then(function (result) {
                decideSyncing(result);
            }, function (err) {
                $scope.loginLoading = false;
                $scope.captchaVerified = false;
                $scope.ETToken = null;
                if ($('.ngdialog').length === 0)
                    $translate(otpService.purifyOtpError(err)).then(function (message) {
                        notifierSvc.show({ message: message, type: "warning" });
                    });
                if (err.validateRequest) {
                    retryOTP(err.validateRequest);
                }
            });
        }

        function decideSyncing(result) {
            //OTP closed, canceled by user
            if (!result) {
                $scope.loginLoading = false;
                return;
            }

            if (result.requiresAdditionalConfirmation && typeof $scope.user.IsEjMergeConfirmed === "undefined") {
                openAdditionalConfirmationDialog(result);
                return;
            }

            //continue syncing decision. continue with e-mail or skip synching
            $scope.user.validateRequest = result.validateRequest;
            if (result.registered) {
                $scope.loginLoading = false;
                if (result.registeredUsers && result.registeredUsers.registeredAddresses && result.registeredUsers.registeredAddresses.length > 1) {
                    $scope.mailAddresses = result.registeredUsers.registeredAddresses;
                    openSyncingDialog();
                } else {
                    registerAndLogin();
                }
            } else {
                $scope.loginLoading = false;
                if ($rootScope.isBank)
                    registerAndLogin();
                else
                    openSyncingDialog();
            }
        }

        function openSyncingDialog() {
            ngDialog.open({
                templateUrl: 'app/security/mail-dialog.modal.html',
                scope: $scope,
            });
        }

        function openAdditionalConfirmationDialog(result) {
            $scope.loginLoading = false;
            pendingAdditionalConfirmationResult = result;
            ejMergeConfirmationDialog = ngDialog.open({
                templateUrl: 'app/security/ej-merge-confirmation.modal.html',
                scope: $scope,
                showClose: false,
                closeByEscape: false,
                closeByDocument: false,
                closeByNavigation: false
            });
        }

        function confirmEjMerge(isConfirmed) {
            $scope.user.IsEjMergeConfirmed = isConfirmed;
            if (ejMergeConfirmationDialog) {
                ejMergeConfirmationDialog.close();
                ejMergeConfirmationDialog = null;
            }
            var result = pendingAdditionalConfirmationResult;
            pendingAdditionalConfirmationResult = null;
            decideSyncing(result);
        }

        function registerAndLogin() {
            $scope.loginLoading = true;
            if ($scope.user.phoneNumber)
                $scope.user.phoneNumber = $scope.user.phoneNumber.replace(/\s+/g, '').replaceAll(' ', '');
            // TODO: should we give default permissions?
            $scope.user.permissions = [30, 40, 50, 60, 110, 120, 130, 140];
            userSvc.registerAndLogin($scope.user).then(
                function () {
                    ngDialog.close();
                    $scope.loginLoading = false;
                },
                function (err) {
                    $scope.loginLoading = false;
                    // if ($('.ngdialog').length === 0)
                    $translate(otpService.purifyOtpError(err)).then(function (message) {
                        notifierSvc.show({ message: message, type: "warning" });
                    });
                }
            );
        }

        function skipSyncing() {
            $scope.user.email = null;
            if (confirm($translate.instant('migrating_warning'))) {
                registerAndLogin();
            }
        }
        $scope.skipSyncing = skipSyncing;


        function retryOTP(validateRequest) {
            otpService.callOtp('retry', validateRequest.verificationType, validateRequest.verificationAddress, validateRequest.codeExpireDate, validateRequest.verificationToken).then(
                function (resp) {
                    if ($scope.isStep2) {
                        $scope.user.validateRequest = resp.validateRequest;
                        registerAndLogin();
                    } else {
                        decideSyncing(resp);
                    }
                },
                function (err) {
                    $scope.loginLoading = false;
                    otpService.closeDialog();
                    if (err.validateRequest) {
                        retryOTP(err.validateRequest);
                    }
                }
            );
        }

        $scope.syncLoading = false;
        $scope.validations = {
            emailInUse: false,
            emailValid: false
        };
        $scope.syncAccounts = function () {
            if ($scope.checkingEmail)
                return;
            $scope.syncLoading = true;
            if ($scope.user.email && !$scope.mailAddresses) {

                //if email is not in use, proceed to login
                if (!$scope.validations.emailInUse) {
                    registerAndLogin();
                    $scope.syncLoading = false;
                    return;
                }

                //if email is in use, proceed to syncing
                otpService.callOtp("loginAndRegister", 0, $scope.user.email).then(function (result) {
                    if (!result) {
                        $scope.syncLoading = false;
                        return;
                    }
                    $scope.user.validateRequest = result.validateRequest;

                    $scope.syncLoading = false;
                    registerAndLogin();
                }, function (err) {
                    otpService.closeDialog();
                    $scope.syncLoading = false;
                    if (err.validateRequest) {
                        retryOTP(err.validateRequest);
                    }
                });
            } else {
                registerAndLogin();
                $scope.syncLoading = false;
            }

        };

        // Close modal and handle navigation
        $scope.closeModal = function () {
            ngDialog.close();

            // Check if there's navigation history
            if ($window.history.length > 1) {
                $window.history.back();
            } else {
                // No history, navigate to landing page
                $state.go('default', { langcode: $rootScope.lang });
            }
        };

        // Cleanup event listeners on scope destroy
        // Note: Do NOT call ngDialog.close() here as it causes infinite recursion
        // The dialog is already being destroyed when $destroy fires
        // Turnstile cleanup is handled by phone-input directive
        //signin block ends

    }
})();

/**
 * MCP OAuth 2.1 Service
 * Handles OAuth URL parsing and parameter validation
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('mcpService', mcpService);

    mcpService.$inject = ['$window', '$rootScope', '$q', '$timeout', 'ngDialog', 'notifierSvc', 'oauth_factory', 'auth_factory', '$location'];

    function mcpService($window, $rootScope, $q, $timeout, ngDialog, notifierSvc, oauth_factory, auth_factory, $location) {
        var service = {
            mcpState: false, // MCP OAuth flow state flag
            emlakjetState: false, // Emlakjet OAuth flow state flag
            checkMcpFromResourceUrl: checkMcpFromResourceUrl,
            parseOAuthParams: parseOAuthParams,
            initializeOAuthParams: initializeOAuthParams,
            saveOAuthParams: saveOAuthParams,
            restoreOAuthParams: restoreOAuthParams,
            clearOAuthParams: clearOAuthParams,
            checkConsent: checkConsent,
            getConsentInfo: getConsentInfo,
            approve: approve,
            deny: deny,
            redirectToCallback: redirectToCallback,
            handleOAuthConsentFlow: handleOAuthConsentFlow,
            checkEmlakjetCallback: checkEmlakjetCallback,
            handleEmlakjetCallback: handleEmlakjetCallback
        };

        return service;

        // ====================================================================

        /**
         * Check resource parameter from URL and set MCP state
         * @returns {boolean} True if MCP OAuth request, false otherwise
         */
        function checkMcpFromResourceUrl() {
            // If already set to true, don't change it (persist OAuth flow)
            if (service.mcpState === true) {
                return true;
            }

            var resource = $window.getUrlParameter('resource', true);

            if (resource) {
                // Check if resource contains 'mcp' (emlakjet temporarily disabled)
                var hasMcp = resource.toLowerCase().indexOf('mcp') !== -1;

                if (hasMcp) {
                    service.mcpState = true;
                    return true;
                } else {
                    service.mcpState = false;
                    return false;
                }
            }
        }

        /**
         * Parse all OAuth parameters from URL
         * @returns {Object} OAuth parameters
         */
        function parseOAuthParams() {

            var params = {
                response_type: $window.getUrlParameter('response_type', true),
                client_id: $window.getUrlParameter('client_id', true),
                redirect_uri: $window.getUrlParameter('redirect_uri', true),
                state: $window.getUrlParameter('state', true),
                scope: $window.getUrlParameter('scope', true),
                code_challenge: $window.getUrlParameter('code_challenge', true),
                code_challenge_method: $window.getUrlParameter('code_challenge_method', true),
                prompt: $window.getUrlParameter('prompt', true),
                resource: $window.getUrlParameter('resource', true)
            };

            // Clean up - remove null/undefined values
            for (var key in params) {
                if (!params[key]) {
                    delete params[key];
                }
            }

            return params;
        }

        /**
         * Initialize OAuth parameters - handles parsing, saving, and restoring logic
         * @returns {Object} OAuth parameters or null
         */
        function initializeOAuthParams() {
            var oauthParams = null;

            if (service.mcpState) {
                // MCP is active, parse and save OAuth params from URL
                oauthParams = parseOAuthParams();
                if (oauthParams && Object.keys(oauthParams).length > 0) {
                    saveOAuthParams(oauthParams);
                }
            } else {
                // Try to restore OAuth params from session storage
                oauthParams = restoreOAuthParams();
                if (oauthParams) {
                    service.mcpState = true;
                }
            }

            return oauthParams;
        }

        function saveOAuthParams(params) {
            if (params && Object.keys(params).length > 0) {
                $window.sessionStorage.setItem('mcp_oauth_params', JSON.stringify(params));
            }
        }

        function restoreOAuthParams() {
            var savedParams = $window.sessionStorage.getItem('mcp_oauth_params');
            if (savedParams) {
                try {
                    return JSON.parse(savedParams);
                } catch (e) {
                    console.error('[mcpService] Error parsing saved OAuth params:', e);
                    return null;
                }
            }
            return null;
        }

        function clearOAuthParams() {
            $window.sessionStorage.removeItem('mcp_oauth_params');
            service.mcpState = false; // Reset MCP state when clearing OAuth params
        }

        /**
         * Check if user has already given consent for this client
         * @param {Object} oauthParams - OAuth parameters
         * @returns {Promise} Check consent response with hasConsent and approvalData
         */
        function checkConsent(oauthParams) {
            var deferred = $q.defer();

            if (!$rootScope.SignedIn) {
                console.error('[mcpService] User not signed in');
                deferred.reject({ error: 'login_required', error_description: 'User not authenticated' });
                return deferred.promise;
            }

            oauth_factory.checkConsent(oauthParams).$promise.then(
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    console.error('[mcpService] Error checking consent:', error);
                    deferred.reject(error.data || { error: 'server_error' });
                }
            );

            return deferred.promise;
        }

        /**
         * Get consent info from backend
         * @param {Object} oauthParams - OAuth parameters
         * @returns {Promise} Consent data
         */
        function getConsentInfo(oauthParams) {
            var deferred = $q.defer();

            if (!$rootScope.SignedIn) {
                console.error('[mcpService] User not signed in');
                deferred.reject({ error: 'login_required', error_description: 'User not authenticated' });
                return deferred.promise;
            }

            oauth_factory.oauthAuthorize(oauthParams).$promise.then(
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    console.error('[mcpService] Error getting consent:', error);
                    deferred.reject(error.data || { error: 'server_error' });
                }
            );

            return deferred.promise;
        }

        function approve(oauthParams) {
            var deferred = $q.defer();

            if (!$rootScope.SignedIn) {
                console.error('[mcpService] User not signed in');
                deferred.reject({ error: 'login_required' });
                return deferred.promise;
            }

            oauth_factory.oauthApprove(oauthParams).$promise.then(
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    console.error('[mcpService] Error approving:', error);
                    deferred.reject(error.data || { error: 'server_error' });
                }
            );

            return deferred.promise;
        }

        function deny(oauthParams) {
            var deferred = $q.defer();

            if (!$rootScope.SignedIn) {
                console.error('[mcpService] User not signed in');
                deferred.reject({ error: 'login_required' });
                return deferred.promise;
            }

            oauth_factory.oauthDeny(oauthParams).$promise.then(
                function (response) {
                    deferred.resolve(response);
                },
                function (error) {
                    console.error('[mcpService] Error denying:', error);
                    deferred.reject(error.data || { error: 'server_error' });
                }
            );

            return deferred.promise;
        }

        function redirectToCallback(response) {
            if (!response || !response.redirect_uri) {
                console.error('[mcpService] Invalid redirect response:', response);
                return;
            }

            // Clear OAuth params and reset MCP state before redirect
            clearOAuthParams();

            var redirectUri = response.redirect_uri;
            var params = [];

            // Success: authorization code
            if (response.code) {
                params.push('code=' + encodeURIComponent(response.code));
                if (response.state) {
                    params.push('state=' + encodeURIComponent(response.state));
                }
            }
            // Error: access denied or other error
            else if (response.error) {
                params.push('error=' + encodeURIComponent(response.error));
                if (response.error_description) {
                    params.push('error_description=' + encodeURIComponent(response.error_description));
                }
                if (response.state) {
                    params.push('state=' + encodeURIComponent(response.state));
                }
            }

            var separator = redirectUri.indexOf('?') > -1 ? '&' : '?';
            var finalUrl = redirectUri + separator + params.join('&');

            $window.location.href = finalUrl;
        }

        /**
         * Centralized OAuth consent flow handler
         * @param {Object} oauthParams - OAuth parameters
         * @param {boolean} closeExistingModals - Whether to close existing modals before opening consent modal
         * @returns {Promise} Promise that resolves when flow is complete
         */
        function handleOAuthConsentFlow(oauthParams, closeExistingModals) {
            var deferred = $q.defer();

            if (!oauthParams || !Object.keys(oauthParams).length) {
                console.error('[mcpService] No OAuth params provided');
                deferred.reject({ error: 'invalid_request', error_description: 'No OAuth parameters' });
                return deferred.promise;
            }

            // Close existing modals if requested
            if (closeExistingModals) {
                ngDialog.close();

                // Wait for modal close animation to complete before making API call
                $timeout(function() {
                    proceedWithOAuthFlow();
                }, 300);
            } else {
                proceedWithOAuthFlow();
            }

            function proceedWithOAuthFlow() {
                // First get consent information (client details, scopes, etc.)
                service.getConsentInfo(oauthParams).then(
                    function (consentData) {
                        // Now check if user has already given consent for this client
                        service.checkConsent(oauthParams).then(
                            function (checkResponse) {
                                // If user has already consented, redirect directly with approval data
                                if (checkResponse.hasConsent && checkResponse.approvalData) {
                                    service.redirectToCallback(checkResponse.approvalData);
                                    deferred.resolve(checkResponse.approvalData);
                                    return;
                                }

                                // User hasn't consented yet, show consent modal
                                openConsentModal(consentData);
                            },
                            function (error) {
                                console.error('[mcpService] Error checking consent, proceeding with consent modal:', error);
                                // If check fails, proceed with normal consent flow
                                openConsentModal(consentData);
                            }
                        );
                    },
                    function (error) {
                        console.error('[mcpService] Error getting consent info:', error);

                        // Redirect with error if redirect_uri exists
                        if (error.error && oauthParams.redirect_uri) {
                            service.redirectToCallback({
                                redirect_uri: oauthParams.redirect_uri,
                                error: error.error,
                                error_description: error.error_description || error.message,
                                state: oauthParams.state
                            });
                        }

                        deferred.reject(error);
                    }
                );
            }

            function openConsentModal(consentData) {
                // Open consent modal with centralized scope
                var dialog = ngDialog.open({
                    template: 'app/security/auth-signin/oauth-consent.modal.html',
                    closeByDocument: false,
                    closeByEscape: false,
                    controller: ['$scope', '$rootScope', '$window', '$timeout', '$state', function($scope, $rootScope, $window, $timeout, $state) {
                        $scope.oauthConsent = consentData;
                        $scope.oauthLoading = false;
                        $scope.oauthError = null;

                        // Approve handler
                        $scope.approveOAuth = function () {
                            $scope.oauthLoading = true;
                            service.approve(oauthParams).then(
                                function (response) {
                                    $scope.oauthLoading = false;
                                    ngDialog.close();
                                    service.redirectToCallback(response);
                                    deferred.resolve(response);
                                },
                                function (error) {
                                    console.error('[mcpService] Error approving:', error);
                                    $scope.oauthError = error;
                                    $scope.oauthLoading = false;

                                    // Redirect with error even if approve fails
                                    service.redirectToCallback({
                                        redirect_uri: oauthParams.redirect_uri,
                                        error: 'server_error',
                                        error_description: error.error_description || 'Authorization failed',
                                        state: oauthParams.state
                                    });

                                    deferred.reject(error);
                                }
                            );
                        };

                        // Deny handler
                        $scope.denyOAuth = function () {
                            $scope.oauthLoading = true;
                            service.deny(oauthParams).then(
                                function (response) {
                                    $scope.oauthLoading = false;
                                    ngDialog.close();
                                    service.redirectToCallback(response);
                                    deferred.resolve(response);
                                },
                                function (error) {
                                    console.error('[mcpService] Error denying:', error);
                                    $scope.oauthLoading = false;

                                    // Redirect with error even if deny fails
                                    service.redirectToCallback({
                                        redirect_uri: oauthParams.redirect_uri,
                                        error: 'access_denied',
                                        error_description: 'User denied authorization',
                                        state: oauthParams.state
                                    });

                                    deferred.reject(error);
                                }
                            );
                        };

                        // Terms modal handler
                        $scope.termsModal = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/' + window.lang + '/kullanim.html',
                                controller: ['$scope', function($scope) {
                                    $scope.onModal = true;
                                }]
                            });
                        };

                        // Privacy modal handler
                        $scope.gizlilikModal = function () {
                            ngDialog.open({
                                templateUrl: 'app/content/sozlesme/' + window.lang + '/gizlilik.html',
                                controller: ['$scope', function($scope) {
                                    $scope.onModal = true;
                                }]
                            });
                        };

                        // Switch account handler
                        $scope.switchAccount = function () {
                            // Close modal and sign out
                            ngDialog.close();

                            // Sign out
                            $rootScope.signOut();

                            // Wait for signOut to complete, then redirect to signin
                            $timeout(function() {
                                var signInUrl = '/' + $rootScope.lang + '/signin';
                                $window.location.href = signInUrl;
                            }, 500);
                        };
                    }]
                });
            }

            return deferred.promise;
        }

        // ====================================================================
        // Emlakjet OAuth Callback Handling
        // ====================================================================

         /**
         * Check if current URL contains Emlakjet OAuth callback parameters
         * @returns {Object|null} Emlakjet callback params or null
         */
        function checkEmlakjetCallback() {
            var code = $window.getUrlParameter('code', true);
            var state = $window.getUrlParameter('state', true);
            var resource = $window.getUrlParameter('resource', true);

            var isEmlakjetCallback = resource && resource.indexOf('emlakjet.com') !== -1;

            if (!isEmlakjetCallback) {
                return null;
            }

            // Return params even if incomplete - let handleEmlakjetCallback show error
            return {
                code: code,
                state: state,
                hasError: !code || !state
            };
        }


        /**
         * Handle Emlakjet OAuth callback
         * @param {Object} params - Callback parameters (code, state)
         * @returns {Promise} Promise that resolves with callback result
         */
        function handleEmlakjetCallback(params) {
            var deferred = $q.defer();

            if (!params || !params.code || !params.state) {
                deferred.reject({ error: 'invalid_request', error_description: 'Missing code or state parameter' });
                return deferred.promise;
            }

            service.emlakjetState = true;

            auth_factory.emlakjetCallback({ code: params.code, state: params.state }).$promise.then(
                function (result) {
                    service.emlakjetState = false;
                    clearEmlakjetUrlParams();
                    deferred.resolve(result);
                },
                function (error) {
                    service.emlakjetState = false;
                    clearEmlakjetUrlParams();
                    console.error('[mcpService] Emlakjet callback error:', error);
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        /**
         * Clear Emlakjet callback parameters from URL
         */
        function clearEmlakjetUrlParams() {
            var url = new URL($window.location.href);
            url.searchParams.delete('code');
            url.searchParams.delete('state');
            url.searchParams.delete('resource');
            $window.history.replaceState({}, document.title, url.toString());
        }

    }
})();

(function () {
    'use strict';

    var serviceId = 'guardSvc';

    angular
        .module('app.security')
        .factory(serviceId, [
            '$translate',
            '$window',
            '$q',
            'userSvc',
            'appStatusSvc',
            '$state',
            '$rootScope',
            guardSvc
        ]);

    function guardSvc($translate, $window, $q, userSvc, appStatusSvc, $state, $rootScope) {
        var service = {
            guardRoute: guardRoute,
            guardRouteRenta: guardRouteRenta,
            guardRouteRole: guardRouteRole,
            authorized: authorized,
            hasRole: hasRole,
            checkCreditValue: checkCreditValue,
            checkCreditValueAsync: checkCreditValueAsync,
            checkCredit: checkCredit,
            hasPackage: hasPackage,
            hasRocket: hasRocket,
            hasDemo: hasDemo,
            monthlyPackage: monthlyPackage
        };

        function guardRouteRenta() {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = authorize();
                if (authResult.authorized) {
                    deferred.resolve(authResult.authorized);
                } else {
                    $state.go('signin', {
                        status: 'renta',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function guardRoute(requiredRoles, blockMonthly) {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = authorize(requiredRoles);
                if (authResult.authorized && !blockMonthly) {
                    deferred.resolve(authResult.authorized);
                } else {
                    $state.go('signin', {
                        status: 'guard',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function guardRouteRole(requiredRoles) {
            var storedLang = $window.lang || 'tr';
            var deferred = $q.defer();
            appStatusSvc.whenReady()['finally'](function () {
                var authResult = hasRole(requiredRoles);
                if (authResult) {
                    deferred.resolve(authResult);
                } else {
                    $state.go('signin', {
                        status: 'guard',
                        langcode: storedLang
                    });
                }
            });
            return deferred.promise;
        }

        function authorized(requiredRoles) {
            return authorize(requiredRoles).authorized;
        }
        function authorize(requiredRoles) {
            if (userSvc.info.SignedIn) {
                if (requiredRoles && requiredRoles.length > 0) {
                    if (userHasProduct(requiredRoles)) {
                        return {
                            authorized: true,
                            message: ''
                        };
                    } else {
                        return {
                            authorized: false,
                            message: $translate.instant('auth_roles')
                        };
                    }
                } else {
                    return {
                        authorized: true,
                        message: ''
                    };
                }
            } else {
                return {
                    authorized: false,
                    message: $translate.instant('auth_roles2')
                };
            }
        }
        // const roles = [
        // 	{ val: 0, name: 'Banlanmış' },
        // 	{ val: 5, name: 'Potansiyel Müşteri (Lead)' },
        // 	{ val: 10, name: 'Müşteri' },
        // 	{ val: 15, name: 'API' },
        // 	{ val: 20, name: 'Destek' },
        // 	{ val: 25, name: 'Satış' },
        // 	{ val: 30, name: 'Satış Takım Lideri' },
        // 	{ val: 40, name: 'Blog İçerik Üreticisi' },
        // 	{ val: 50, name: 'Admin' },
        // 	{ val: 55, name: 'Tenant' },
        // 	{ val: 60, name: 'Şirket İçi' },
        // 	{ val: 70, name: 'Satış Müdürü' },
        // 	{ val: 80, name: 'Tahsilat' }
        // ];
        function hasRole(pack) {
            if (pack.includes(userSvc.info.Role)) {
                return true;
            }
            return false;
        }

        function monthlyPackage() {
            var deferred = $q.defer();
            userSvc.getUserInfo().then(function (result) {
                var products = result.products.filter(function (m) {
                    //return m.productType === 20 && !m.isExpired && (m.subscriptionModel === 30 || m.code === 'basic-package');
                    return m.productType === 40 && !m.isExpired;
                })[0];
                deferred.resolve(products);
            }, function () {
                deferred.resolve(null);
            });
            return deferred.promise;
        }

        function hasDemo(page) {
            var deferred = $q.defer();
            userSvc.getFingerLimit(page).then(function () {
                if (userSvc.finger_info.prints[page])
                    deferred.resolve(!userSvc.finger_info.prints[page].limitReached);
                else
                    deferred.resolve(false);
            });
            return deferred.promise;
        }

        function hasRocket(rocket, force) {
            var deferred = $q.defer();
            userSvc.getUserInfo(force).then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });
                if (!rocket) {
                    rocket = ['unlimited-comparable', 'listing-rocket', 'region-rocket'];
                }
                deferred.resolve(userHasProduct(rocket, products));
            }, function () {
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function hasPackage(pack, force) {
            var deferred = $q.defer();
            userSvc.getUserInfo(force).then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });

                if (result.terminalProducts) {
                    var terminalProducts = result.terminalProducts.map(function (m) {
                        return m.code;
                    });
                    products = products.concat(terminalProducts);
                }

                if (!pack) {
                    pack = ['location-package', 'real-estate-package', 'platinum-package', 'eco-package', 'seller-lead-package','premium-package', 'premiumplus-package', 'personal-package', 'basic-package', 'terminal-package', 'pro-ee-package', 'flex-package', 'gold-package', 'terminal-flex-package', 'terminal-pro-package', 'premium-ee-package', 'terminal-premium-package'];
                }
                deferred.resolve(userHasProduct(pack, products));
            }, function () {
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function userHasProduct(requiredRoles, products) {
            products = products ? products : userSvc.info.Products.map(function (m) {
                return m.code;
            });

            if (userSvc.info.TerminalProducts) {
                var terminalProducts = userSvc.info.TerminalProducts.map(function (m) {
                    return m.code;
                });
                products = products.concat(terminalProducts);
            }

            var result = false;
            requiredRoles.forEach(function (product) {
                if (products.includes(product)) {
                    result = true;
                }
            });
            return result;
        }


        function checkCreditValue(creditId) {
            var selectedProducts = userSvc.info.Products.filter(function (product) {
                return product.code === creditId;
            });
            if (userSvc.info.TerminalProducts) {
                var selectedTerminalProducts = userSvc.info.TerminalProducts.filter(function (product) {
                    return product.code === creditId;
                });
                selectedProducts = selectedProducts.concat(selectedTerminalProducts);
            }
            var result = selectedProducts.reduce(function (a, b) {
                return a + b.count;
            }, 0);
            return result;
        }

        function checkCreditValueAsync(creditId, propertyType) {
            var deferred = $q.defer();
            userSvc.refreshProducts().then(function (result) {
                var selectedProducts = result.products.filter(function (product) {
                    return product.code === creditId && (!propertyType || product.type === 0 || (product.types || []).indexOf(propertyType) > -1);
                });

                if (result.terminalProducts) {
                    var selectedTerminalProducts = result.terminalProducts.filter(function (product) {
                        return product.code === creditId;
                    });
                    selectedProducts = selectedProducts.concat(selectedTerminalProducts);
                }

                var result = selectedProducts.reduce(function (a, b) {
                    return a + b.count;
                }, 0);
                deferred.resolve(result > 0 ? result : 0);
            }, function () {
                $rootScope.SignedIn = false;
                deferred.resolve(0);
            });
            return deferred.promise;
        }


        function checkCredit(creditId) {
            var deferred = $q.defer();
            userSvc.refreshProducts().then(function (result) {
                var products = result.products.map(function (m) {
                    return m.code;
                });

                if (result.terminalProducts) {
                    var terminalProducts = result.terminalProducts.map(function (m) {
                        return m.code;
                    });
                    products = products.concat(terminalProducts);
                }

                deferred.resolve(products.indexOf(creditId) > -1);
            }, function () {
                $rootScope.SignedIn = false;
                deferred.resolve(false);
            });
            return deferred.promise;
        }


        return service;
    }
})();

(function () {
    'use strict';

    var serviceId = 'restoreUrlService';

    angular.module('app.security')
        .factory(serviceId, ['localStorageService', '$q', '$window', '$state', restoreUrlService]);

    function restoreUrlService(localStorageService, $q, $window, $state) {
        var service = {
            returnTo: returnTo,
            getLastState: getLastState,
            saveLastState: saveLastState,
            removeLastState: removeLastState
        };
        var fromState, fromParams;
        return service;

        function getLastState() {
            var deferred = $q.defer();

            fromState = localStorageService.get('fromState');
            fromParams = localStorageService.get('fromParams');
            deferred.resolve({
                lastState: fromState,
                lastParams: fromParams
            });

            return deferred.promise;

        }

        function returnTo(force_restart) {
            console.log("start getting last state");
            service.getLastState().then(function (res) {
                console.log("finish getting last state", res);
                var storedLang = $window.lang || 'en';
                console.log("stored lang", storedLang);
                //TODO: [EB-271] Externalauth (Google) redirection bazı durumlarda sayfasına 404 sayfasına gidiyor.
                force_restart = force_restart || !res.lastState || res.lastState === "" || res.lastState === "externalauth" || res.lastState === "confirmoop" || res.lastState === "renew";
                console.log("stored lang", force_restart);
                console.log("start getting ivaluateProperty");
                if (window.localStorage.getItem('ivaluateProperty')) {
                    console.log("finish getting ivaluateProperty");
                    window.localStorage.removeItem('ivaluateProperty');
                    console.log("topKey", window.topKey);
                    if (!force_restart)
                        $state.go('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateLand')) {
                    window.localStorage.removeItem('ivaluateLand');
                    if (!force_restart)
                        $state.go('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateField')) {
                    window.localStorage.removeItem('ivaluateField');
                    if (!force_restart)
                        $state.go('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateCommercial')) {
                    window.localStorage.removeItem('ivaluateCommercial');
                    if (!force_restart)
                        $state.go('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "field-valuation.step4") {
                    if (!force_restart)
                        $state.go('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "land-valuation.step4") {
                    if (!force_restart)
                        $state.go('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "resident-valuation.step4") {
                    if (!force_restart)
                        $state.go('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "commercial-valuation.step4") {
                    if (!force_restart)
                        $state.go('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-commercial.step5', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "confirmEmail" ||
                    res.lastState === "register" ||
                    res.lastState === "404" ||
                    res.lastState === "signin" ||
                    res.lastState === "default" ||
                    res.lastState === "forgotPassword" ||
                    res.lastState === "newPassword" ||
                    res.lastState === "resetPassword" ||
                    res.lastState === "confirmuser" ||
                    res.lastState === "activateEmail" ||
                    res.lastState === "unblock" ||
                    res.lastState === "sso") {
                    if (!force_restart)
                        $state.go('default', { langcode: storedLang, force: 'redirect' });
                    else
                        $window.location.href = $state.href('default', { langcode: storedLang, force: 'redirect' });
                }
                else {
                    var hrefer = $state.href(res.lastState, res.lastParams);
                    if (hrefer) {
                        if (!force_restart)
                            $state.go(res.lastState, res.lastParams);
                        else
                            $window.location.href = $state.href(res.lastState, res.lastParams);
                    } else {
                        if (!force_restart)
                            $state.go('default', { langcode: storedLang, force: 'redirect' });
                        else
                            $window.location.href = $state.href('default', { langcode: storedLang, force: 'redirect' });
                    }
                }
                // service.removeLastState();
            });
        }

        function saveLastState(state, params) {
            if (state === "confirmEmail" ||
                state === "register" ||
                state === "default" ||
                state === "signin" ||
                state === "forgotPassword" ||
                state === "newPassword" ||
                state === "resetPassword" ||
                state === "code" ||
                state === "confirmuser" ||
                state === "activateEmail") {
                //do nothing
            }
            else {
                localStorageService.set('fromState', state);
                localStorageService.set('fromParams', params);
            }
        }

        function removeLastState() {
            localStorageService.remove('fromState');
            localStorageService.remove('fromParams');
        }

    }

})();

(function () {
    'use strict';

    var serviceId = 'otpService';

    angular.module('app.core')
        .factory(serviceId, ['$q', 'user_factory', 'ngDialog', '$timeout', 'auth_factory', otpService]);

    function otpService($q, user_factory, ngDialog, $timeout, auth_factory) {
        var isActive = true;
        var service = {
            openOtpDialog: openOtpDialog,
            callOtp: callOtp,
            purifyOtpError: purifyOtpError,
            otpError: null,
            verifyOtp: verifyOtp,
            dialog: null,
            closeDialog: closeDialog
        };
        return service;


        function closeDialog() {
            if (service.dialog) {
                service.dialog.close();
            }
        }

        function openOtpDialog(otpType, codeExpireDate, verificationToken, verificationType, verificationAddress) {
            var deferred = $q.defer();
            var stopped
            service.dialog = ngDialog.open({
                template: "app/security/phone-otp.modal.html",
                controller: ['$scope', function ($scope) {
                    $scope.otpError = service.otpError;
                    $scope.verificationToken = verificationToken
                    $scope.verificationCode = '';
                    $scope.verificationType = verificationType;
                    $scope.verificationAddress = verificationAddress;

                    var currentDate = new Date();
                    var stop = function () {
                        $timeout.cancel(stopped);
                    };
                    function getTime() {
                        if (!codeExpireDate) {
                            return 300
                        }
                        let expires = moment(codeExpireDate);
                        let created = moment(currentDate);
                        return expires.diff(created, 'seconds');
                    }

                    var time = getTime() > 0 ? getTime() : 0;

                    $scope.timing = function () {
                        var minutes = Math.floor(time / 60);
                        var seconds = time - minutes * 60;
                        return {
                            minutes: minutes,
                            seconds: seconds
                        }
                    }

                    function verificationTimeout() {
                        if (time <= 0) {
                            service.closeDialog();
                            deferred.resolve();
                            stop();
                        }

                    }

                    var countdown = function () {
                        stopped = time > 0 ? $timeout(function () {
                            time--;
                            if (time <= 0)
                                verificationTimeout();
                            countdown();
                        }, 1000) : null;
                    };

                    countdown();
                    $scope.verifyOTP = function (verificationCode, verificationToken) {
                        service.otpError = undefined
                        $scope.otpLoading = true
                        // Broadcast the event
                        var obj = {
                            verificationAddress: verificationAddress,
                            verificationType: verificationType,
                            verificationCode: verificationCode,
                            verificationToken: verificationToken,
                            codeExpireDate: codeExpireDate
                        }
                        service.verifyOtp(otpType, obj).then(function (resp) {
                            $scope.otpLoading = false
                            service.otpError = purifyOtpError(resp);
                            deferred.resolve(resp)
                        }, function (err) {
                            $scope.otpLoading = false
                            service.otpError = purifyOtpError(err);
                            deferred.reject(err)
                        })
                    };
                    $scope.closeDialogWithReject = function () {
                        service.otpError = undefined
                        service.closeDialog();
                        deferred.resolve();
                    };
                }],
                showClose: true,
                closeByEscape: false,
                closeByNavigation: false,
                closeByDocument: false,
                preCloseCallback: function () {
                    $timeout.cancel(stopped)
                },
            });

            return deferred.promise;
        }
        function callOtp(otpType, verificationType, verificationAddress, expireDate, token, ETToken, eimageCaptcha) {
            var deferred = $q.defer();
            if (!isActive && otpType === "profileUpdateAdmin") {
                deferred.resolve({ success: true });
                return deferred.promise;
            }
            if (verificationType === 1) {
                verificationAddress = verificationAddress.replace(/\s+/g, '');
            }
            if (otpType === "profileUpdate" || otpType === "profileUpdateAdmin") {
                service.otpError = undefined;
                var updatePhoneParams = { verificationType: verificationType, verificationAddress: verificationAddress, language: window.langCode(), captchaTokenCustom: window.ecSec() };
                if (ETToken) {
                    updatePhoneParams.ETToken = ETToken;
                }
                if (eimageCaptcha) {
                    updatePhoneParams.EImageCaptchaKey = eimageCaptcha.key;
                    updatePhoneParams.EImageCaptchaValue = eimageCaptcha.value;
                }
                user_factory.update_phone(updatePhoneParams).$promise.then(function (resp) {
                    openOtpDialog(otpType, resp.codeExpireDate, resp.verificationToken, verificationType, verificationAddress).then(function (resp) {
                        deferred.resolve(resp);
                    }, function (err) {
                        deferred.reject(err);
                    })
                }, function (err) {
                    deferred.reject(err);
                })
            } else if (otpType === "loginAndRegister") {
                service.otpError = undefined;
                var sendcodeParams = { verificationType: verificationType, verificationAddress: verificationAddress, language: window.langCode(), captchaTokenCustom: window.ecSec() };
                if (ETToken) {
                    sendcodeParams.ETToken = ETToken;
                }
                if (eimageCaptcha) {
                    sendcodeParams.EImageCaptchaKey = eimageCaptcha.key;
                    sendcodeParams.EImageCaptchaValue = eimageCaptcha.value;
                }
                auth_factory.sendcode(sendcodeParams).$promise.then(function (resp) {
                    openOtpDialog(otpType, resp.codeExpireDate, resp.verificationToken, verificationType, verificationAddress).then(function (resp) {
                        if (resp)
                            service.closeDialog();
                        deferred.resolve(resp);
                    }, function (err) {
                        service.closeDialog();
                        deferred.reject(err);
                    })
                }, function (err) {
                    deferred.reject(err);
                });
            } else if (otpType === "retry") {
                openOtpDialog(otpType, expireDate, token, verificationType, verificationAddress).then(function (resp) {
                    if (resp)
                        service.closeDialog();
                    deferred.resolve(resp);
                }, function (err) {
                    service.closeDialog();
                    deferred.reject(err);
                })
            }
            return deferred.promise;
        }
        function verifyOtp(otpType, obj) {
            var deferred = $q.defer();
            if (otpType === "profileUpdate" || otpType === "profileUpdateAdmin") {
                user_factory.verify_phone({ verificationToken: obj.verificationToken, code: obj.verificationCode.toString() }).$promise.then(function (resp) {
                    resp.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        verificationToken: obj.verificationToken,
                        code: obj.verificationCode.toString()
                    }
                    if (resp.success == false) {
                        deferred.reject(resp);
                    } else {
                        deferred.resolve(resp);
                    }
                }, function (err) {
                    err.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationToken: obj.verificationToken,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        code: obj.verificationCode.toString()
                    }

                    deferred.reject(err);
                })
            } else {
                auth_factory.checkuserandverifycode({ verificationToken: obj.verificationToken, code: obj.verificationCode.toString(), captchaTokenCustom: window.ecSec() }).$promise.then(function (resp) {
                    resp.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        verificationToken: obj.verificationToken,
                        code: obj.verificationCode.toString()
                    }
                    if (resp.success == false) {
                        deferred.reject(resp);
                    } else {
                        deferred.resolve(resp);
                    }
                }, function (err) {
                    err.validateRequest = {
                        verificationAddress: obj.verificationAddress,
                        verificationToken: obj.verificationToken,
                        verificationType: obj.verificationType,
                        codeExpireDate: obj.codeExpireDate,
                        code: obj.verificationCode.toString()
                    }
                    deferred.reject(err);
                })
            }
            return deferred.promise;
        }
        function purifyOtpError(err) {
            if (err.data) {
                if (err.data.title) {
                    if (err.data.title.indexOf("Request is exceed") > -1) {
                        return "otp_err_lmt_exceed";
                    } else if (err.data.title.indexOf("code entered is incorrect") > -1) {
                        return "otp_err_invalid_code";
                    } else if (err.data.title.indexOf("One or more validation") > -1) {
                        return "otp_err_validation";
                    } else if (err.data.title.indexOf("token has expired") > -1) {
                        return "otp_err_expired";
                    } else if (err.data.detail) {
                        if (err.data.detail.indexOf("Invalid Em") > -1) {
                            return "otp_err_invalid_email";
                        } else {
                            return "otp_generic_err";
                        }
                    } else {
                        return "otp_generic_err";
                    }
                } else {
                    if (err.data.indexOf("Request is exceed") > -1) {
                        return "otp_err_lmt_exceed";
                    } else if (err.data.indexOf("code entered is incorrect") > -1) {
                        return "otp_err_invalid_code";
                    } else if (err.data.indexOf("token has expired") > -1) {
                        return "otp_err_expired";
                    } else if (err.data.indexOf("user_cancel") > -1) {
                        return "otp_err_user_cancelled";
                    } else {
                        return "otp_generic_err";
                    }
                }
            } else if (err.failureReason) {
                if (err.failureReason.indexOf("Request is exceed") > -1) {
                    return "otp_err_lmt_exceed";
                } else if (err.failureReason.indexOf("code entered is incorrect") > -1) {
                    return "otp_err_invalid_code";
                } else if (err.failureReason.indexOf("verification code") > -1) {
                    return "otp_err_invalid_code";
                } else if (err.failureReason.indexOf("token has expired") > -1) {
                    return "otp_err_expired";
                } else {
                    return "otp_generic_err";
                }
            } else {
                return "otp_generic_err";
            }
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'restoreUserSvc';

    angular.module('app.security')
        .factory(serviceId, restoreUserSvc);

    restoreUserSvc.$inject = ['$location', '$q', 'appActivitySvc', 'userSvc'];
    function restoreUserSvc($location, $q, appActivitySvc, userSvc) {

        var service = {
            restore: restore
        };

        return service;

        function restore() {
            var deferred = $q.defer();
            var storedLang = window.lang || 'tr';
            appActivitySvc.busy("restoreUserSvc");
            var refreshToken = localStorage.getItem("refreshToken");
            if (refreshToken && !window.isHeadless()) {
                userSvc.getUserInfo().then(
                    function (result) {
                        if (result.information) {
                            deferred.resolve(true);
                        } else {
                            $location.path('/' + storedLang + "/signin");
                        }
                    },
                    function () {
                        deferred.reject(false);
                    })
                ['finally'](
                    function () {
                        appActivitySvc.idle("restoreUserSvc");
                    });
            } else {
                appActivitySvc.idle("restoreUserSvc");
                deferred.reject(false);
            }
            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';

    var id = 'secureHttpInterceptor';

    angular.module('app')
        .factory(id, ['$injector', '$q', '$window', '$rootScope', secureHttpInterceptor]);

    function secureHttpInterceptor($injector, $q, $window, $rootScope) {
        var interceptor = {
            request: request,
            responseError: responseError,
            firstRequest: true
        };

        return interceptor;

        function request(config) {
            var queryString = new URL(window.location.toString()).searchParams;

            if (interceptor.firstRequest) {
                interceptor.firstRequest = false;


                if (queryString.get("device")) {
                    $rootScope.refMobile = queryString.get("device") === "mobile";
                    window.refMobile = queryString.get("device") === "mobile";
                }
                if (queryString.get('at') &&
                    queryString.get('at_exp') &&
                    queryString.get('rt') &&
                    queryString.get('rt_exp')) {

                    window.localStorage.setItem("accessToken", decodeURIComponent(queryString.get('at').replace(/ /g, '+')));
                    window.localStorage.setItem("accessTokenExpires", decodeURIComponent(queryString.get('at_exp').replace(/ /g, '+')));
                    window.localStorage.setItem("refreshToken", decodeURIComponent(queryString.get('rt').replace(/ /g, '+')));
                    window.localStorage.setItem("refreshTokenExpires", decodeURIComponent(queryString.get('rt_exp').replace(/ /g, '+')));
                    var userSvc = $injector.get('userSvc');
                    userSvc.getUserInfo(null, true).then(function () {
                        //console.log()
                    }).finally(function () {
                        window.refMobile = true;
                        $rootScope.refMobile = true;

                        if (config.params && config.params.captchaTokenCustom) {
                            config.headers['Captcha-Token'] = config.params.captchaTokenCustom;
                            delete config.params.captchaTokenCustom;
                        }
                        else if (config.data && config.data.captchaTokenCustom) {
                            config.headers['Captcha-Token'] = config.data.captchaTokenCustom;
                            delete config.data.captchaTokenCustom;
                        }

                        if (config.params && config.params.ETToken) {
                            config.headers['ET-Token'] = config.params.ETToken;
                            delete config.params.ETToken;
                        }
                        else if (config.data && config.data.ETToken) {
                            config.headers['ET-Token'] = config.data.ETToken;
                            delete config.data.ETToken;
                        }

                        // EImage-Captcha headers for /auth/sevc and /verification/sevc endpoints
                        if (config.params && config.params.EImageCaptchaKey) {
                            config.headers['EImage-Captcha-Key'] = config.params.EImageCaptchaKey;
                            config.headers['EImage-Captcha-Value'] = config.params.EImageCaptchaValue;
                            delete config.params.EImageCaptchaKey;
                            delete config.params.EImageCaptchaValue;
                        }
                        else if (config.data && config.data.EImageCaptchaKey) {
                            config.headers['EImage-Captcha-Key'] = config.data.EImageCaptchaKey;
                            config.headers['EImage-Captcha-Value'] = config.data.EImageCaptchaValue;
                            delete config.data.EImageCaptchaKey;
                            delete config.data.EImageCaptchaValue;
                        }

                        config.headers["Content-Language"] = window.lang;
                        const token = $window.localStorage.getItem("accessToken");
                        const expire = $window.localStorage.getItem("accessTokenExpires");
                        if (!config.skipAuthorization && config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1 && token && new Date(expire).getTime() > new Date().getTime()) {
                            config.headers.Authorization = "Bearer " + token;
                        }
                        return config;
                    });
                }
            }
            if (config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1) {
                if (config.params && config.params.captchaTokenCustom) {
                    config.headers['Captcha-Token'] = config.params.captchaTokenCustom;
                    delete config.params.captchaTokenCustom;
                }
                else if (config.data && config.data.captchaTokenCustom) {
                    config.headers['Captcha-Token'] = config.data.captchaTokenCustom;
                    delete config.data.captchaTokenCustom;
                }

                // Turnstile token for sendcode and update_phone endpoints
                if (config.params && config.params.ETToken) {
                    config.headers['ET-Token'] = config.params.ETToken;
                    delete config.params.ETToken;
                }
                else if (config.data && config.data.ETToken) {
                    config.headers['ET-Token'] = config.data.ETToken;
                    delete config.data.ETToken;
                }

                // EImage-Captcha headers for /auth/sevc and /verification/sevc endpoints
                if (config.params && config.params.EImageCaptchaKey) {
                    config.headers['EImage-Captcha-Key'] = config.params.EImageCaptchaKey;
                    config.headers['EImage-Captcha-Value'] = config.params.EImageCaptchaValue;
                    delete config.params.EImageCaptchaKey;
                    delete config.params.EImageCaptchaValue;
                }
                else if (config.data && config.data.EImageCaptchaKey) {
                    config.headers['EImage-Captcha-Key'] = config.data.EImageCaptchaKey;
                    config.headers['EImage-Captcha-Value'] = config.data.EImageCaptchaValue;
                    delete config.data.EImageCaptchaKey;
                    delete config.data.EImageCaptchaValue;
                }

                /* if (config.data && config.data.source) {
                    config.headers['UserChannel'] = config.data.source;
                    delete config.data.source;
                } */

                // Check if user registration request from HangiKredi campaign
                if ($rootScope.isHangiKrediCampaign) {
                    config.headers['UserChannel'] = '11';
                }

                if ($rootScope.isBank) {
                    config.headers['UserChannel'] = $rootScope.clientData.source;
                }
            }

            config.headers["Content-Language"] = window.lang;
            const token = $window.localStorage.getItem("accessToken");
            const expire = $window.localStorage.getItem("accessTokenExpires");
            if (!config.skipAuthorization && config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1 && token && new Date(expire).getTime() > new Date().getTime()) {
                config.headers.Authorization = "Bearer " + token;
            }
            return config;
        }

        //ÖNEMLİ: RefreshToken'ı loading mantığı ile engellemek lifecycle sorunlarına neden oluyor. Yapmayalım.
        function responseError(response) {
            var deferred = $q.defer();
            if (!response.config)
                deferred.reject(response);
            else {
                const url = response.config.url.toLowerCase();
                if (response.status === 401 && url.indexOf("externallogin") === -1) {
                    var userSvc = $injector.get('userSvc');
                    const refreshToken = $window.localStorage.getItem("refreshToken");
                    const refreshTokenExpires = $window.localStorage.getItem("refreshTokenExpires");
                    if (refreshToken && new Date(refreshTokenExpires).getTime() > new Date().getTime()) {
                        userSvc.refresh().then(
                            function (res) {
                                if (res && res.accessToken) {
                                    $window.localStorage.setItem('accessToken', res.accessToken);
                                    $window.localStorage.setItem('accessTokenExpires', res.accessTokenExpiration);
                                    $window.localStorage.setItem('refreshToken', res.refreshToken);
                                    $window.localStorage.setItem('refreshTokenExpires', res.refreshTokenExpiration);

                                    response.config.headers.Authorization = "Bearer " + res.accessToken;

                                    var $http = $injector.get('$http');
                                    $http(response.config).then(function (result) {
                                        deferred.resolve(result);
                                    }, function () {
                                        deferred.reject(response);
                                    });
                                } else {
                                    userSvc.setUser();
                                    deferred.reject(response);
                                }
                            },
                            function () {
                                userSvc.setUser();
                                deferred.reject(response);
                            });
                    } else {
                        userSvc.setUser();
                        deferred.reject(response);
                    }
                } else {
                    deferred.reject(response);
                }
            }
            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'endeksService';

    angular.module('app.core').factory(serviceId, endeksService);

    endeksService.$inject = ['$q', 'notifierSvc', 'yandexGeocode', 'mapOptionsService', 'valuationGETAPI', "valuationPOSTAPI", 'userSvc', '$interval', '$rootScope', '$compile', 'CacheFactory', '$timeout', 'guardSvc', '$translate',
        'ngDialog'
    ];

    function endeksService($q, notifierSvc, yandexGeocode, mapOptionsService, valuationGETAPI, valuationPOSTAPI, userSvc, $interval, $rootScope, $compile, CacheFactory, $timeout, guardSvc, $translate,
        ngDialog
    ) {
        var service = {
            EndeksList: [],
            EndeksDetail: {},
            Valuations: {},
            cachedLimits: null,
            checkLimits: checkLimits,
            loadEndeksDetail: loadEndeksDetail,
            deleteEndeks: deleteEndeks,
            loadValuations: loadValuations,
            loadComparables: loadComparables,
            makeValuation: makeValuation,
            reValuate: reValuate,
            loadHistory: loadHistory,
            selectValuation: selectValuation,
            changeName: changeName,
            changeNote: changeNote,
            getNote: getNote,
            changeFiles: changeFiles,
            getFiles: getFiles,
            changeState: changeState,
            getAutoValuationInfo: getAutoValuationInfo,
            createAutoValuationInfo: createAutoValuationInfo,
            deleteAutoValuationInfo: deleteAutoValuationInfo,

            setDetailMarker: setDetailMarker,
            listOlanak: listOlanak,
            listManzara: listManzara,
            listManzaraArsa: listManzaraArsa,
            listOlanakArsa: listOlanakArsa,
            listManzaraTicari: listManzaraTicari,
            listOlanakTicari: listOlanakTicari,
            listReklamTicari: listReklamTicari,
            // listReportStatus: listReportStatus,
            fetchData: fetchData,
            listCephe: listCephe,
            listTasinmazTipi: listTasinmazTipi,
            listArsaTipi: listArsaTipi,
            listAraziTipi: listAraziTipi,
            listDaireTipi: listDaireTipi,
            listTicariTipi: listTicariTipi,
            listIsinmaDurumu: listIsinmaDurumu,
            listIsinmaDurumuTicari: listIsinmaDurumuTicari,
            listEnrgCertType: listEnrgCertType,
            listUsageStatus: listUsageStatus,
            listStructureCondition: listStructureCondition,

            listTicariTipiLight: listTicariTipiLight,
            listTicariTipiSelectionTemp: listTicariTipiSelectionTemp,


            listRoad: listRoad,
            listSea: listSea,

            listAltTipi: listAltTipi,
            listTicariKonumTipi: listTicariKonumTipi,
            listTicariKotFarkiTipi: listTicariKotFarkiTipi,
            listKatTipi: listKatTipi,
            listYapininDurumu: listYapininDurumu,


            listTicariBinaTipi: listTicariBinaTipi,
            listeEndustriTipi: listeEndustriTipi,
            listTicariOfisTipi: listTicariOfisTipi,


            listUrun: listUrun,
            listEgim: listEgim,
            listOlanakTarla: listOlanakTarla,

            resolveAddress: resolveAddress,
            setTempEndeks: setTempEndeks,
            retrieveTempEndeks: retrieveTempEndeks,
            clearTempEndeks: clearTempEndeks,
            originalEndeks: {
                Id: null,
                OnlyValuation: false,
                Address: "",
                Age: null,
                FloorCount: null,
                FloorNumber: null,
                Latitude: null,
                Longitude: null,
                Name: null,
                Room: null,
                LivingRoom: 1,
                BathRoom: 1,
                Type: 10,
                Area: null,
                ExtraArea: null,
                Possibilities: [],
                Faces: [],
                Views: [],
                HeatType: null,
                tempFaces: {},
                tempViews: [],
                tempApartmentTypes: [],
                tempPossibilities: {},
                AdsCapabilities: null,
                tempHeatTypes: [],
                UsageStatus: 30,
                StructureCondition: 20
            },
            tempEndeks: {
                Id: null,
                OnlyValuation: false,
                Address: "",
                Age: null,
                FloorCount: null,
                FloorNumber: null,
                Latitude: null,
                Longitude: null,
                Name: null,
                Room: null,
                LivingRoom: null,
                BathRoom: null,
                Type: null,
                Area: null,
                ExtraArea: null,
                Possibilities: [],
                Faces: [],
                Views: [],
                HeatType: null,
                tempFaces: {},
                tempViews: [],
                tempApartmentTypes: [],
                tempPossibilities: {},
                AdsCapabilities: null,
                tempHeatTypes: [],
                UsageStatus: 30,
                StructureCondition: 20
            },

            checkIfAvailable: checkIfAvailable,

            // getPublicEndeks: getPublicEndeks,
            toggleInfo: toggleInfo
        };

        return service;

        function checkLimits(fieldType, min, max) {
            return fieldType === null || isNaN(fieldType) || fieldType > max || fieldType < min;
        };
        function checkIfAvailable(lat, lng) {
            var deferred = $q.defer();
            userSvc.getUserInfo().then(function (account) {
                var objData = {
                    DataLevel: 0,
                    UserId: account.information.id.value,
                    OrderBy: 1,
                    Sort: 2,
                    ItemSize: 10,
                    ActivePageNumber: 1,
                    PropertyCategory: 0,
                    PropertyType: 4,
                    Lat: lat,
                    Long: lng,
                    Radius: 20
                };
                var valuation = valuationGETAPI.list(objData);
                valuation.$promise.then(function (response) {
                    if (response.TotalCount)
                        if (!$rootScope.isBank)
                            notifierSvc.show({ message: $translate.instant("revaluate_warning1") + " <a style='text-decoration:underline;font-weight:500' href='https://www.endeksa.com/" + window.lang + "/" + $translate.instant("analysis") + "/l/" + lat.toString().replace('.', ',') + ";" + lng.toString().replace('.', ',') + "/portfolio'>" + $translate.instant("n_myWorkPlace") + "</a> " + $translate.instant("revaluate_warning2"), type: "info", hideDuration: 10000 });
                        else
                            ngDialog.open({
                                templateUrl: 'app/endeks/valuation-exist-modal.html',
                                data: {
                                    lat: lat,
                                    lng: lng,
                                    lang: window.lang
                                }
                            });
                    deferred.resolve(response.TotalCount);
                }, function (err) {
                    deferred.reject(err);
                });
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }


        function loadEndeksDetail(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.details({ propertyid: id });
            valuation.$promise.then(function (response) {
                service.EndeksDetail = response;
                deferred.resolve(service.EndeksDetail);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function loadValuations(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.get({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function getAutoValuationInfo(propertyId) {
            var deferred = $q.defer();
            valuationGETAPI.getAutoValuationInfo({ propertyId: propertyId }).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function createAutoValuationInfo(data) {
            var deferred = $q.defer();
            valuationPOSTAPI.createAutoValuationInfo(data).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function deleteAutoValuationInfo(data) {
            var deferred = $q.defer();
            valuationPOSTAPI.deleteAutoValuationInfo(data).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function loadHistory(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.history({ propertyid: id, history: true });
            valuation.$promise.then(function (response) {
                service.Valuations = response.History;
                deferred.resolve(service.Valuations);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function selectValuation(id, isSales) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.select({ valuationid: id, isSales: isSales });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }


        function loadComparables(id, property) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.comparables({ valuationid: id, propertyid: property });
            valuation.$promise.then(function (resp) {
                deferred.resolve(resp.Comparables);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function deleteEndeks(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.delete({ id: id });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (result) {
                if (result.errors)
                    result.errors.map(function (error) {
                        notifierSvc.show({ message: error.Message, type: "error" });
                    });
                else
                    notifierSvc.show({ message: result.error, type: "error" });
                deferred.reject(result);
            });
            return deferred.promise;
        }

        function cleanCache() {
            CacheFactory.get('Valuations') && CacheFactory.get('Valuations').removeAll();
            CacheFactory.get('ValuationsHistory') && CacheFactory.get('ValuationsHistory').removeAll();
            CacheFactory.get('ValuationsThematic') && CacheFactory.get('ValuationsThematic').removeAll();
            CacheFactory.get('ValuationsAssets') && CacheFactory.get('ValuationsAssets').removeAll();

            CacheFactory.get('ValuationsDetail') && CacheFactory.get('ValuationsDetail').removeAll();
            CacheFactory.get('ValuationsInside') && CacheFactory.get('ValuationsInside').removeAll();
            CacheFactory.get('ValuationsComparable') && CacheFactory.get('ValuationsComparable').removeAll();
            CacheFactory.get('ValuationsSimple') && CacheFactory.get('ValuationsSimple').removeAll();

            CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
            CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
            CacheFactory.get('AgentsThematic') && CacheFactory.get('AgentsThematic').removeAll();

            CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
            CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
            CacheFactory.get('UserProducts') && CacheFactory.get('UserProducts').removeAll();
        };

        function makeValuation(data, force, fromDetail = false) {
            var deferred = $q.defer();
            window.valuationCompleted = false;

            guardSvc.hasPackage().then(function (response) {
                if (!response && !force) {
                    $timeout(function () {
                        $rootScope.askMembership(true, fromDetail);
                    }, 1000);
                    window.valuationCompleted = true;
                    deferred.reject();
                }
                else if (!data.CreatorId)
                    userSvc.getUserInfo().then(function (account) {
                        if (account && account.information.id.value) {
                            data.CreatorId = account.information.id.value;
                            var valuation = valuationPOSTAPI.setQueue(data);
                            valuation.$promise.then(function (response) {
                                var try_Count = 20;
                                var intr = $interval(function () {
                                    var que = valuationGETAPI.getQueue({ propertyId: response.PropertyId });
                                    que.$promise.then(function (final) {
                                        try_Count--;
                                        if (final.IsValuated) {
                                            window.valuationCompleted = true;
                                            $interval.cancel(intr);
                                            localStorage.removeItem('Endeks');
                                            clearTempEndeks();
                                            var array = [];
                                            array.push({ PropertyId: final.PropertyId });
                                            cleanCache();
                                            $timeout(function () {
                                                deferred.resolve(array);
                                            }, 500);
                                        }
                                        if (!try_Count) {
                                            $interval.cancel(intr);
                                            cleanCache();
                                            deferred.reject();
                                        }
                                    }, function (err) {
                                        cleanCache();
                                        $interval.cancel(intr);
                                        deferred.reject(err);
                                    });
                                }, 30000);
                            }, function (err) {
                                deferred.reject(err);
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
                else {
                    var valuation = valuationPOSTAPI.setQueue(data);
                    valuation.$promise.then(function (response) {
                        var intr = $interval(function () {
                            var try_Count = 20;
                            var que = valuationGETAPI.getQueue({ propertyId: response.PropertyId });
                            que.$promise.then(function (final) {
                                try_Count--;
                                if (final.IsValuated) {
                                    $interval.cancel(intr);
                                    localStorage.removeItem('Endeks');
                                    clearTempEndeks();
                                    var array = [];
                                    array.push({ PropertyId: final.PropertyId });
                                    cleanCache();
                                    deferred.resolve(array);
                                }
                                if (!try_Count) {
                                    $interval.cancel(intr);
                                    cleanCache();
                                    deferred.reject();
                                }
                            }, function (err) {
                                cleanCache();
                                $interval.cancel(intr);
                                deferred.reject(err);
                            });
                        }, 30000);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }
            });
            return deferred.promise;
        }

        function changeName(id, name) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.changeName({ propertyid: id, name: name });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeNote(id, note) {
            var deferred = $q.defer();
            var valuation = valuationPOSTAPI.addNote({ propertyid: id, note: note });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getNote(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.getNote({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeState(id, value, date, status, statemenDate, rentStatementValue, salesStatementValue, valuationType) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.updateState({ propertyid: id, value: value, date: date, status: status, statementDate: statemenDate, rentStatementValue: rentStatementValue, salesStatementValue: salesStatementValue, valuationType: valuationType });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeFiles(id, files) {
            var deferred = $q.defer();
            var valuation = valuationPOSTAPI.changeFiles({ propertyid: id, files: files });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getFiles(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.getFiles({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function reValuate(id, isAuto, wkt) {
            var data = {
                OnlyValuation: true,
                Id: id,
                IsAuto: isAuto,
                wkt: wkt
            };
            var deferred = $q.defer();
            window.valuationCompleted = false;
            userSvc.getUserInfo(true).then(function (account) {
                if (account && account.information.id.value) {
                    // guardSvc.hasPackage().then(function (response) {
                    //     if (!response) {
                    //         $timeout(function () {
                    //             $rootScope.askMembership(true,true);
                    //         }, 1000);
                    //         window.valuationCompleted = true;
                    //         deferred.reject();
                    //     }
                    //     else {
                    //     }
                    // });
                    var creator = account.information.id.value;
                    data.CreatorId = creator;
                    var valuation = valuationPOSTAPI.set(data);
                    valuation.$promise.then(function (response) {
                        cleanCache();
                        window.valuationCompleted = true;
                        $timeout(function () {
                            deferred.resolve(response);
                        }, 500);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function setTempEndeks(obj) {

            for (var key in obj) {
                service.tempEndeks[key] = obj[key];
            }
            // console.log("set", service.tempEndeks);
            localStorage.setItem('tempEndeks', JSON.stringify(service.tempEndeks));
        }

        function retrieveTempEndeks() {
            var deferred = $q.defer();
            var item = localStorage.getItem('tempEndeks');
            if (!item) {
                localStorage.setItem('tempEndeks', JSON.stringify(service.tempEndeks));
            } else {
                try {
                    service.tempEndeks = JSON.parse(item);
                }
                catch (err) {
                    localStorage.removeItem('tempEndeks');
                }
            }
            // console.log("get", service.tempEndeks);
            deferred.resolve(service.tempEndeks);
            return deferred.promise;
        }

        function clearTempEndeks() {
            service.tempEndeks = angular.copy(service.originalEndeks);
            window.rememberProperty = null;
            localStorage.removeItem('tempEndeks');
        }


        // function listReportStatus() {
        //     appActivitySvc.busy("endeksService");

        //     return endeksClientService.ListReportStatus()
        //         .then(
        //             function (result) {
        //                 //notifierSvc.show({ message: "Cepheler yüklendi" });
        //                 return result;
        //             },
        //             function (result) {
        //                 notifierSvc.show({ message: result.error, type: "error" });
        //                 return $q.reject(result);
        //             })['finally'](
        //                 function () {
        //                     appActivitySvc.idle("endeksService");
        //                 });
        // }


        // function getPublicEndeks(id) {
        //     return $http({
        //         method: 'GET',
        //         url: appSettingsSvc.CACHE + '/tasinmazsimple?propertyid=' + id
        //     }, { ignoreLoadingBar: true }).then(
        //         function (response) {
        //             if (response && response.data && response.data.PropertyDetails) {
        //                 return {
        //                     result: "success",
        //                     data: response.data
        //                 };
        //             } else {
        //                 return $q.reject({
        //                     result: "failure",
        //                     errors: response.data.OperationResult.Errors
        //                 });
        //             }
        //         },
        //         function (result) {
        //             return $q.reject({
        //                 result: "failure",
        //                 error: "Konut yüklenemedi."
        //             });
        //         }
        //     );
        // }

        function listOlanak() {
            return [
                { Name: 'Anayol Üzeri', Id: 10 },
                { Name: 'Cadde Üzeri', Id: 15 },
                { Name: 'Site İçerisinde', Id: 20 },
                { Name: 'Spor Sahası/Salonu', Id: 30 },
                { Name: 'Çocuk Oyun Parkı', Id: 40 },
                { Name: 'Asansör', Id: 50 },
                { Name: 'Jeneratör', Id: 60 },
                { Name: 'Bina/Site Görevlisi', Id: 70 },
                { Name: 'Güvenlik', Id: 80 },
                { Name: 'Otopark', Id: 90 },
                { Name: 'Kapalı Otopark', Id: 100 },
                { Name: 'Havuz', Id: 110 },
                { Name: 'Kapalı Havuz', Id: 120 },
                { Name: 'Isı Yalıtımı', Id: 130 },
                { Name: 'Klima', Id: 150 },
                { Name: 'Şömine', Id: 155 },
                { Name: 'Yeşil Alan', Id: 360 },
                { Name: 'Balkon', Id: 370 }
            ];
        }

        function listManzara() {
            return [
                { Name: 'İstinat Duvarı', Id: 10 },
                { Name: 'Yan Bina', Id: 20 },
                { Name: 'Cadde/Sokak', Id: 30 },
                { Name: 'Bahçe', Id: 40 },
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listEnrgCertType() {
            return [
                { Name: 'A+', Id: 9 },
                { Name: 'A', Id: 1 },
                { Name: 'B', Id: 2 },
                { Name: 'B-', Id: 10 },
                { Name: 'C', Id: 3 },
                { Name: 'D', Id: 4 },
                { Name: 'E', Id: 5 },
                { Name: 'F', Id: 6 },
                { Name: 'G', Id: 7 },
                { Name: 'In Process', Id: 11 },
                { Name: 'Exempt', Id: 8 },
                { Name: 'Unknown', Id: -1 }
            ];
        }

        function listUsageStatus() {
            return [
                { Name: 'step2_owner', Id: 10 },
                { Name: 'step2_with_tenant', Id: 20 },
                { Name: 'step2_empty', Id: 30 }
            ];
        }

        function listStructureCondition() {
            return [
                { Name: 'step2_renovated', Id: 10 },
                { Name: 'step2_standard', Id: 20 },
                { Name: 'step2_needs_renovation', Id: 30 }
            ];
        }

        function listManzaraArsa() {
            return [
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listManzaraTicari() {
            return [
                { Name: 'Bahçe', Id: 40 },
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listOlanakArsa() {
            return [
                { Name: 'Elektrik', Id: 170 },
                { Name: 'Su', Id: 175 },
                { Name: 'Yolu Açık', Id: 180 },
                { Name: 'Köşe Parsel', Id: 185 },
                { Name: 'İfraz Görmüş', Id: 190 },
                { Name: 'Denize Sıfır', Id: 195 },
                { Name: 'Denize Yakın', Id: 200 }
            ];
        }


        function listOlanakTarla() {
            return [
                { Name: 'Elektrik', Id: 170 },
                { Name: 'Su', Id: 175 },
                { Name: 'Yolu Açık', Id: 180 },
                { Name: 'Doğalgaz', Id: 210 },
                { Name: 'Telefon', Id: 220 },
                { Name: 'Kanalizasyon', Id: 230 },
                { Name: 'Zemin Etüdü', Id: 240 },
                { Name: 'Yola Yakın', Id: 250 },
                { Name: 'Denize Sıfır', Id: 195 },
                { Name: 'Denize Yakın', Id: 200 }
            ];
        }

        function listOlanakTicari() {
            return [
                { Name: 'Anayol Üzeri', Id: 10 },
                { Name: 'Cadde Üzeri', Id: 15 },
                { Name: 'Site İçerisinde', Id: 20 },
                { Name: 'Asansör', Id: 50 },
                { Name: 'Hidrofor', Id: 280 },
                { Name: 'Jeneratör', Id: 60 },
                { Name: 'Su Deposu', Id: 290 },
                { Name: 'Telefon Hattı', Id: 220 },
                { Name: 'Hırsız Alarmı', Id: 300 },
                { Name: 'Açık Otopark', Id: 90 },
                { Name: 'Yangın Alarmı', Id: 310 },
                { Name: 'Güvenlik', Id: 80 },
                { Name: 'İnternet Altyapısı', Id: 320 },
                { Name: 'Yangın Merdiveni', Id: 330 },
                { Name: 'Güvenlik Kamerası', Id: 340 },
                { Name: 'TV-Uydu Altyapısı', Id: 350 },
                { Name: 'Kapalı Otopark', Id: 100 },
                { Name: 'Köşe Parselde Konumlu', Id: 185 },
                { Name: 'Isı Yalıtımı', Id: 130 },
                { Name: 'Tır Manevra Alanı', Id: 380 },
                { Name: 'Endüstriyel Sarmal Kapı', Id: 390 },
                { Name: 'Yangın Söndürme', Id: 400 },
                { Name: 'Yükleme Rampası', Id: 410 }
            ];
        }

        function listReklamTicari() {
            return [
                { Name: 'Tabela Caddeden/Bulvardan Görülebilir', Id: 10, isActive: true },
                { Name: 'Tabela Sokaktan Görülebilir', Id: 20, isActive: true },
                { Name: 'Tabela Görülemez ya da Tabela İzni Yok', Id: 30, isActive: true }
            ];
        }

        function listSea() {
            return [
                { Name: 'Denizle İlişkisi Yok', Id: 30 },
                { Name: 'Denize Yakın', Id: 20 },
                { Name: 'Denize Sıfır', Id: 10 },
            ];
        }

        function listRoad() {
            return [
                { Name: 'Sokak Üzerinde', Id: 10 },
                { Name: 'Cadde Üzerinde', Id: 20 },
                { Name: 'Anayol Üzerinde', Id: 30 }
            ];
        }



        function listCephe() {
            return [
                { Name: 'Kuzey', Id: 10 },
                { Name: 'Güney', Id: 20 },
                { Name: 'Doğu', Id: 30 },
                { Name: 'Batı', Id: 40 }
            ];
        }

        function listTasinmazTipi() {
            return [
                { Name: 'Apartman', Id: 10 },
                { Name: 'Müstakil', Id: 20 }
            ];
        }

        function listAraziTipi() {
            return [
                { Name: 'Tarla', Id: 230 },
                { Name: 'Bağ, Bahçe', Id: 235 },
                { Name: 'zeytinlik', Id: 225 }
            ];
        }


        function listArsaTipi() {
            return [
                { Name: 'Konut', Id: 210 },
                { Name: 'Konut + Ticari', Id: 220 },
                { Name: 'Villa Parseli', Id: 280 },
                { Name: 'zoned_land_village', Id: 290 },
                { Name: 'ticari_imarli', Id: 240 }
            ];
        }


        function listDaireTipi() {
            return [
                { Name: 'Daire', Id: 10, Type: 'Apartment' },
                { Name: 'Teras Dubleks', Id: 20, Type: 'Apartment' },
                { Name: 'Ara Kat Dubleks', Id: 30, Type: 'Apartment' },
                { Name: 'Bahçe Dubleks', Id: 40, Type: 'Apartment' },
                { Name: 'Ters Dubleks', Id: 50, Type: 'Apartment' },
                { Name: 'Penthouse', Id: 60, Type: 'Apartment' },
                { Name: 'Studio Daire', Id: 70, Type: 'Apartment' },
                { Name: 'Dubleks', Id: 80, Type: 'Apartment' },
                { Name: 'Müstakil Ev', Id: 90, Type: 'House' },
                { Name: 'Kır Evi', Id: 100, Type: 'House' },
                { Name: 'Yarı Müstakil Ev', Id: 110, Type: 'House' },
                { Name: 'Teraslı Ev', Id: 120, Type: 'House' },
                { Name: 'Köy Evi', Id: 130, Type: 'House' },
                { Name: 'Emlak', Id: 140, Type: 'House' }
            ];
        }


        function listTicariTipiLight() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                { Name: 'Ticari Bina', Id: 390 }
            ];
        }


        function listTicariTipi() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                { Name: 'Ticari Bina', Id: 390 },
                { Name: 'Endüstriyel', Id: 370 },
                { Name: 'Tesisler ve Kompleksler', Id: 380 },
                { Name: 'Tesisler', Id: 380 }
            ];
        }

        function listTicariTipiSelectionTemp() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Depo/Antrepo', Id: 410 },
                // { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                // { Name: 'Ticari Bina', Id: 390 },
                // { Name: 'Endüstriyel', Id: 370 },
                // { Name: 'Tesisler ve Kompleksler', Id: 380 },
                // { Name: 'Tesisler', Id: 380 }
            ];
        }

        function listAltTipi() {
            return [
                { Name: 'Bağımsız Bölüm', Id: 10 },
                { Name: 'Müstakil', Id: 20 }
            ];
        }

        function listTicariKonumTipi() {
            return [
                { Name: 'Sanayi Bölgesi veya Sitesi İçerisinde Değil', Id: 10 },
                { Name: 'Organize Sanayi Bölgesi (OSB) İçerisinde', Id: 20 },
                { Name: 'Küçük Sanayi Sitesi (KSS) İçerisinde', Id: 30 }
            ];
        }
        function listTicariKotFarkiTipi() {
            return [
                { Name: 'Cadde/Sokak seviyesinde/üzerinde', Id: 10 },
                { Name: 'Cadde/Sokak seviyesi altında', Id: 20 },
                { Name: 'İş Hanı/pasaj İçerisinde', Id: 30 }
            ];
        }

        function listKatTipi() {
            return [
                { Name: 'Tek Katlı', Id: 10 },
                { Name: 'Çok Katlı', Id: 20 }
            ];
        }

        function listYapininDurumu() {
            return [
                { Name: 'step3_helpers_brandNew', Id: 40 },
                { Name: 'step3_helpers_used', Id: 50 }
            ];
        }


        function listTicariOfisTipi() {
            return [
                { Name: 'Plaza/İşhanı Ofis/Büro', Id: 120, isActive: true },
                { Name: 'İş Hanında', Id: 20, isActive: false },
                { Name: 'Apartman Dairesi Ofis/Büro', Id: 130, isActive: true },
                { Name: 'Müstakil Ofis/Büro', Id: 140, isActive: true },
                { Name: 'Konut Bulunan Binada', Id: 120, isActive: false }
            ];
        }


        function listTicariBinaTipi() {
            return [
                { Name: 'Plaza', Id: 10 },
                { Name: 'İş Hanı', Id: 20 },
                { Name: 'AVM', Id: 30 }
            ];
        }

        function listeEndustriTipi() {
            return [
                { Name: 'Fabrika ve Arsası ', Id: 50 },
                { Name: 'Üretim Kompleksi', Id: 60 }
            ];
        }


        function listEgim() {
            return [
                { Name: 'Düz Arazi (%0-3)', Id: 1 },
                { Name: 'Az Eğimli (%4-15)', Id: 2 },
                { Name: 'Eğimli (%15+)', Id: 3 }
            ];
        }

        function listUrun() {
            return [
                { Name: 'Tahıl', Id: 100 },
                { Name: 'Baklagil', Id: 200 },
                { Name: 'Yağ/Lif/Nişasta/Şeker', Id: 300 },
                { Name: 'Tıbbi/Aromatik', Id: 400 },
                { Name: 'Sebze', Id: 500 },
                { Name: 'Nadas', Id: 600 }
            ];
        }

        function listIsinmaDurumu() {
            return [
                { Name: 'Yok', Id: 10 },
                { Name: 'Soba', Id: 20 },
                { Name: 'Doğalgaz Sobası', Id: 30 },
                { Name: 'Kat Kaloriferi', Id: 40 },
                { Name: 'Doğalgaz/Kombi', Id: 50 },
                { Name: 'Merkezi Sistem', Id: 60 },
                { Name: 'Merkezi Isı Pay Ölçer', Id: 70 },
                { Name: 'Yerden Isıtma', Id: 80 },
                { Name: 'Klima Sistemi', Id: 90 },
                { Name: 'Jeotermal Isınma', Id: 100 },
                { Name: 'Güneş Enerjisi', Id: 110 },
                { Name: 'VRF', Id: 130 },
                { Name: 'FanCoil', Id: 140 },
                { Name: 'Akaryakıt', Id: 150 },
                { Name: 'Elektrik', Id: 160 },
                { Name: 'Propan/Butan Gazı', Id: 170 },
                { Name: 'Diğer', Id: 120 }
            ];
        }

        function listIsinmaDurumuTicari() {
            return [
                { Name: 'Yok', Id: 10 },
                { Name: 'Soba', Id: 20 },
                { Name: 'Doğalgaz Sobası', Id: 30 },
                { Name: 'Kat Kaloriferi', Id: 40 },
                { Name: 'Doğalgaz/Kombi', Id: 50 },
                { Name: 'Merkezi Sistem', Id: 60 },
                { Name: 'Merkezi Isı Pay Ölçer', Id: 70 },
                { Name: 'Yerden Isıtma', Id: 80 },
                { Name: 'Klima Sistemi', Id: 90 },
                { Name: 'Jeotermal Isınma', Id: 100 },
                { Name: 'Güneş Enerjisi', Id: 110 },
                { Name: 'VRF (VRV)', Id: 130 },
                { Name: 'Fan-coil', Id: 140 },
                { Name: 'Diğer', Id: 120 }
            ];
        }

        function resolveAddress(address) {
            var lat, lon, latLon;
            var deferred = $q.defer();
            if (!address) {
                deferred.resolve(null);
            } else if (address.indexOf('%252C') > -1) {
                latLon = address.split('%253B35%252C');
                lat = parseFloat(latLon[0].replace("%252C", "."));
                lon = parseFloat(latLon[1].replace("%252C", "."));
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
            } else if (address.indexOf(';') > -1) {
                latLon = address.split(';');
                lat = parseFloat(latLon[0].replace(",", "."));
                lon = parseFloat(latLon[1].replace(",", "."));
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
                //process(lat, lon);
            }
            //typeahead zaten lokasyonu almış
            else if (window.selectedLocation) {
                lat = +window.selectedLocation.split(' ')[1];
                lon = +window.selectedLocation.split(' ')[0];
                window.selectedLocation = null;
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
            } else {
                address = address.replaceAllString('-', ' ');
                yandexGeocode.geocodeAddress(address)
                    .then(function (latlng) {
                        lat = latlng.lat();
                        lon = latlng.lng();
                        deferred.resolve({
                            lat: lat,
                            lon: lon
                        });
                        //process(lat, lon);
                    }, function (reject) {
                        notifierSvc.show({ message: reject.data, type: "error" });
                        deferred.reject({
                            lat: 39,
                            lng: 10,
                            zoom: 3
                        });

                    });
            }
            return deferred.promise;
        }

        function setDetailMarker(lat, lng, address) {
            return mapOptionsService.getMarker(parseFloat(lat), parseFloat(lng), address);
        }

        function fetchData(detailName, list) {
            var array = [];
            var arrayDiff = [];
            detailName.forEach(function (name) {
                list.forEach(function (item) {
                    if (item.Id === name.Olanak || item.Id === name.Manzara || item.Id === name.BinaGirisCephesi) {
                        array.push(item);
                    }
                });
            });

            arrayDiff = list.diff(array);
            arrayDiff.forEach(function (itemDiff) {
                itemDiff.selected = false;
            });
            array.forEach(function (item) {
                item.selected = true;
            });
            array = arrayDiff.concat(array);

            return array;
        }

        function toggleInfo() {

            $('.ed-input-info').slidePanel({
                useCssTransforms3d: true,
                useCssTransforms: true,
                useCssTransitions: true,
                mouseDrag: false,
                touchDrag: false,
                pointerDrag: false,
                //closeSelector: '.slidePanel-close',
                contentFilter(content, object) {
                    return $compile(content)($rootScope);
                },
                afterLoad: function () {
                    this.$panel.find('.' + this.options.classes.base).asScrollable({
                        namespace: 'scrollable',
                        contentSelector: '>',
                        containerSelector: '>'

                    });
                },

                afterShow: function () {
                    setTimeout(function () {
                        $(".slidePanel-close").on("click", function () {
                            $.slidePanel.hide();
                        });
                    }, 300);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    var serviceId = 'countriesCodesService';

    angular.module('app.common')
        .factory(serviceId, [countriesCodesService]);

    function countriesCodesService() {

        return [
            {
                "name": "Aruba",
                "code": "AW",
                "callingCode": "+297"
            },
            {
                "name": "Afghanistan",
                "code": "AF",
                "callingCode": "+93"
            },
            {
                "name": "Angola",
                "code": "AO",
                "callingCode": "+244"
            },
            {
                "name": "Anguilla",
                "code": "AI",
                "callingCode": "+1264"
            },
            {
                "name": "Ãland Islands",
                "code": "AX",
                "callingCode": "+358"
            },
            {
                "name": "Albania",
                "code": "AL",
                "callingCode": "+355"
            },
            {
                "name": "Andorra",
                "code": "AD",
                "callingCode": "+376"
            },
            {
                "name": "United Arab Emirates",
                "code": "AE",
                "callingCode": "+971"
            },
            {
                "name": "Argentina",
                "code": "AR",
                "callingCode": "+54"
            },
            {
                "name": "Armenia",
                "code": "AM",
                "callingCode": "+374"
            },
            {
                "name": "American Samoa",
                "code": "AS",
                "callingCode": "+1684"
            },
            {
                "name": "Antigua and Barbuda",
                "code": "AG",
                "callingCode": "+1268"
            },
            {
                "name": "Australia",
                "code": "AU",
                "callingCode": "+61"
            },
            {
                "name": "Austria",
                "code": "AT",
                "callingCode": "+43"
            },
            {
                "name": "Azerbaijan",
                "code": "AZ",
                "callingCode": "+994"
            },
            {
                "name": "Burundi",
                "code": "BI",
                "callingCode": "+257"
            },
            {
                "name": "Belgium",
                "code": "BE",
                "callingCode": "+32"
            },
            {
                "name": "Benin",
                "code": "BJ",
                "callingCode": "+229"
            },
            {
                "name": "Burkina Faso",
                "code": "BF",
                "callingCode": "+226"
            },
            {
                "name": "Bangladesh",
                "code": "BD",
                "callingCode": "+880"
            },
            {
                "name": "Bulgaria",
                "code": "BG",
                "callingCode": "+359"
            },
            {
                "name": "Bahrain",
                "code": "BH",
                "callingCode": "+973"
            },
            {
                "name": "Bahamas",
                "code": "BS",
                "callingCode": "+1242"
            },
            {
                "name": "Bosnia and Herzegovina",
                "code": "BA",
                "callingCode": "+387"
            },
            {
                "name": "Saint BarthÃ©lemy",
                "code": "BL",
                "callingCode": "+590"
            },
            {
                "name": "Belarus",
                "code": "BY",
                "callingCode": "+375"
            },
            {
                "name": "Belize",
                "code": "BZ",
                "callingCode": "+501"
            },
            {
                "name": "Bermuda",
                "code": "BM",
                "callingCode": "+1441"
            },
            {
                "name": "Bolivia",
                "code": "BO",
                "callingCode": "+591"
            },
            {
                "name": "Brazil",
                "code": "BR",
                "callingCode": "+55"
            },
            {
                "name": "Barbados",
                "code": "BB",
                "callingCode": "+1246"
            },
            {
                "name": "Brunei",
                "code": "BN",
                "callingCode": "+673"
            },
            {
                "name": "Bhutan",
                "code": "BT",
                "callingCode": "+975"
            },
            {
                "name": "Botswana",
                "code": "BW",
                "callingCode": "+267"
            },
            {
                "name": "Central African Republic",
                "code": "CF",
                "callingCode": "+236"
            },
            {
                "name": "Canada",
                "code": "CA",
                "callingCode": "+1"
            },
            {
                "name": "Cocos (Keeling) Islands",
                "code": "CC",
                "callingCode": "+61"
            },
            {
                "name": "Switzerland",
                "code": "CH",
                "callingCode": "+41"
            },
            {
                "name": "Chile",
                "code": "CL",
                "callingCode": "+56"
            },
            {
                "name": "China",
                "code": "CN",
                "callingCode": "+86"
            },
            {
                "name": "Ivory Coast",
                "code": "CI",
                "callingCode": "+225"
            },
            {
                "name": "Cameroon",
                "code": "CM",
                "callingCode": "+237"
            },
            {
                "name": "DR Congo",
                "code": "CD",
                "callingCode": "+243"
            },
            {
                "name": "Republic of the Congo",
                "code": "CG",
                "callingCode": "+242"
            },
            {
                "name": "Cook Islands",
                "code": "CK",
                "callingCode": "+682"
            },
            {
                "name": "Colombia",
                "code": "CO",
                "callingCode": "+57"
            },
            {
                "name": "Comoros",
                "code": "KM",
                "callingCode": "+269"
            },
            {
                "name": "Cape Verde",
                "code": "CV",
                "callingCode": "+238"
            },
            {
                "name": "Costa Rica",
                "code": "CR",
                "callingCode": "+506"
            },
            {
                "name": "Cuba",
                "code": "CU",
                "callingCode": "+53"
            },
            {
                "name": "CuraÃ§ao",
                "code": "CW",
                "callingCode": "+5999"
            },
            {
                "name": "Christmas Island",
                "code": "CX",
                "callingCode": "+61"
            },
            {
                "name": "Cayman Islands",
                "code": "KY",
                "callingCode": "+1345"
            },
            {
                "name": "Cyprus",
                "code": "CY",
                "callingCode": "+357"
            },
            {
                "name": "Czechia",
                "code": "CZ",
                "callingCode": "+420"
            },
            {
                "name": "Germany",
                "code": "DE",
                "callingCode": "+49"
            },
            {
                "name": "Djibouti",
                "code": "DJ",
                "callingCode": "+253"
            },
            {
                "name": "Dominica",
                "code": "DM",
                "callingCode": "+1767"
            },
            {
                "name": "Denmark",
                "code": "DK",
                "callingCode": "+45"
            },
            {
                "name": "Dominican Republic",
                "code": "DO",
                "callingCode": "+1809"
            },
            {
                "name": "Dominican Republic",
                "code": "DO",
                "callingCode": "+1829"
            },
            {
                "name": "Dominican Republic",
                "code": "DO",
                "callingCode": "+1849"
            },
            {
                "name": "Algeria",
                "code": "DZ",
                "callingCode": "+213"
            },
            {
                "name": "Ecuador",
                "code": "EC",
                "callingCode": "+593"
            },
            {
                "name": "Egypt",
                "code": "EG",
                "callingCode": "+20"
            },
            {
                "name": "Eritrea",
                "code": "ER",
                "callingCode": "+291"
            },
            {
                "name": "Western Sahara",
                "code": "EH",
                "callingCode": "+212"
            },
            {
                "name": "Spain",
                "code": "ES",
                "callingCode": "+34"
            },
            {
                "name": "Estonia",
                "code": "EE",
                "callingCode": "+372"
            },
            {
                "name": "Ethiopia",
                "code": "ET",
                "callingCode": "+251"
            },
            {
                "name": "Finland",
                "code": "FI",
                "callingCode": "+358"
            },
            {
                "name": "Fiji",
                "code": "FJ",
                "callingCode": "+679"
            },
            {
                "name": "Falkland Islands",
                "code": "FK",
                "callingCode": "+500"
            },
            {
                "name": "France",
                "code": "FR",
                "callingCode": "+33"
            },
            {
                "name": "Faroe Islands",
                "code": "FO",
                "callingCode": "+298"
            },
            {
                "name": "Micronesia",
                "code": "FM",
                "callingCode": "+691"
            },
            {
                "name": "Gabon",
                "code": "GA",
                "callingCode": "+241"
            },
            {
                "name": "United Kingdom",
                "code": "GB",
                "callingCode": "+44"
            },
            {
                "name": "Georgia",
                "code": "GE",
                "callingCode": "+995"
            },
            {
                "name": "Guernsey",
                "code": "GG",
                "callingCode": "+44"
            },
            {
                "name": "Ghana",
                "code": "GH",
                "callingCode": "+233"
            },
            {
                "name": "Gibraltar",
                "code": "GI",
                "callingCode": "+350"
            },
            {
                "name": "Guinea",
                "code": "GN",
                "callingCode": "+224"
            },
            {
                "name": "Guadeloupe",
                "code": "GP",
                "callingCode": "+590"
            },
            {
                "name": "Gambia",
                "code": "GM",
                "callingCode": "+220"
            },
            {
                "name": "Guinea-Bissau",
                "code": "GW",
                "callingCode": "+245"
            },
            {
                "name": "Equatorial Guinea",
                "code": "GQ",
                "callingCode": "+240"
            },
            {
                "name": "Greece",
                "code": "GR",
                "callingCode": "+30"
            },
            {
                "name": "Grenada",
                "code": "GD",
                "callingCode": "+1473"
            },
            {
                "name": "Greenland",
                "code": "GL",
                "callingCode": "+299"
            },
            {
                "name": "Guatemala",
                "code": "GT",
                "callingCode": "+502"
            },
            {
                "name": "French Guiana",
                "code": "GF",
                "callingCode": "+594"
            },
            {
                "name": "Guam",
                "code": "GU",
                "callingCode": "+1671"
            },
            {
                "name": "Guyana",
                "code": "GY",
                "callingCode": "+592"
            },
            {
                "name": "Hong Kong",
                "code": "HK",
                "callingCode": "+852"
            },
            {
                "name": "Honduras",
                "code": "HN",
                "callingCode": "+504"
            },
            {
                "name": "Croatia",
                "code": "HR",
                "callingCode": "+385"
            },
            {
                "name": "Haiti",
                "code": "HT",
                "callingCode": "+509"
            },
            {
                "name": "Hungary",
                "code": "HU",
                "callingCode": "+36"
            },
            {
                "name": "Indonesia",
                "code": "ID",
                "callingCode": "+62"
            },
            {
                "name": "Isle of Man",
                "code": "IM",
                "callingCode": "+44"
            },
            {
                "name": "India",
                "code": "IN",
                "callingCode": "+91"
            },
            {
                "name": "British Indian Ocean Territory",
                "code": "IO",
                "callingCode": "+246"
            },
            {
                "name": "Ireland",
                "code": "IE",
                "callingCode": "+353"
            },
            {
                "name": "Iran",
                "code": "IR",
                "callingCode": "+98"
            },
            {
                "name": "Iraq",
                "code": "IQ",
                "callingCode": "+964"
            },
            {
                "name": "Iceland",
                "code": "IS",
                "callingCode": "+354"
            },
            {
                "name": "Israel",
                "code": "IL",
                "callingCode": "+972"
            },
            {
                "name": "Italy",
                "code": "IT",
                "callingCode": "+39"
            },
            {
                "name": "Jamaica",
                "code": "JM",
                "callingCode": "+1876"
            },
            {
                "name": "Jersey",
                "code": "JE",
                "callingCode": "+44"
            },
            {
                "name": "Jordan",
                "code": "JO",
                "callingCode": "+962"
            },
            {
                "name": "Japan",
                "code": "JP",
                "callingCode": "+81"
            },
            {
                "name": "Kazakhstan",
                "code": "KZ",
                "callingCode": "+76"
            },
            {
                "name": "Kazakhstan",
                "code": "KZ",
                "callingCode": "+77"
            },
            {
                "name": "Kenya",
                "code": "KE",
                "callingCode": "+254"
            },
            {
                "name": "Kyrgyzstan",
                "code": "KG",
                "callingCode": "+996"
            },
            {
                "name": "Cambodia",
                "code": "KH",
                "callingCode": "+855"
            },
            {
                "name": "Kiribati",
                "code": "KI",
                "callingCode": "+686"
            },
            {
                "name": "Saint Kitts and Nevis",
                "code": "KN",
                "callingCode": "+1869"
            },
            {
                "name": "South Korea",
                "code": "KR",
                "callingCode": "+82"
            },
            {
                "name": "Kosovo",
                "code": "XK",
                "callingCode": "+383"
            },
            {
                "name": "Kuwait",
                "code": "KW",
                "callingCode": "+965"
            },
            {
                "name": "Laos",
                "code": "LA",
                "callingCode": "+856"
            },
            {
                "name": "Lebanon",
                "code": "LB",
                "callingCode": "+961"
            },
            {
                "name": "Liberia",
                "code": "LR",
                "callingCode": "+231"
            },
            {
                "name": "Libya",
                "code": "LY",
                "callingCode": "+218"
            },
            {
                "name": "Saint Lucia",
                "code": "LC",
                "callingCode": "+1758"
            },
            {
                "name": "Liechtenstein",
                "code": "LI",
                "callingCode": "+423"
            },
            {
                "name": "Sri Lanka",
                "code": "LK",
                "callingCode": "+94"
            },
            {
                "name": "Lesotho",
                "code": "LS",
                "callingCode": "+266"
            },
            {
                "name": "Lithuania",
                "code": "LT",
                "callingCode": "+370"
            },
            {
                "name": "Luxembourg",
                "code": "LU",
                "callingCode": "+352"
            },
            {
                "name": "Latvia",
                "code": "LV",
                "callingCode": "+371"
            },
            {
                "name": "Macau",
                "code": "MO",
                "callingCode": "+853"
            },
            {
                "name": "Saint Martin",
                "code": "MF",
                "callingCode": "+590"
            },
            {
                "name": "Morocco",
                "code": "MA",
                "callingCode": "+212"
            },
            {
                "name": "Monaco",
                "code": "MC",
                "callingCode": "+377"
            },
            {
                "name": "Moldova",
                "code": "MD",
                "callingCode": "+373"
            },
            {
                "name": "Madagascar",
                "code": "MG",
                "callingCode": "+261"
            },
            {
                "name": "Maldives",
                "code": "MV",
                "callingCode": "+960"
            },
            {
                "name": "Mexico",
                "code": "MX",
                "callingCode": "+52"
            },
            {
                "name": "Marshall Islands",
                "code": "MH",
                "callingCode": "+692"
            },
            {
                "name": "Macedonia",
                "code": "MK",
                "callingCode": "+389"
            },
            {
                "name": "Mali",
                "code": "ML",
                "callingCode": "+223"
            },
            {
                "name": "Malta",
                "code": "MT",
                "callingCode": "+356"
            },
            {
                "name": "Myanmar",
                "code": "MM",
                "callingCode": "+95"
            },
            {
                "name": "Montenegro",
                "code": "ME",
                "callingCode": "+382"
            },
            {
                "name": "Mongolia",
                "code": "MN",
                "callingCode": "+976"
            },
            {
                "name": "Northern Mariana Islands",
                "code": "MP",
                "callingCode": "+1670"
            },
            {
                "name": "Mozambique",
                "code": "MZ",
                "callingCode": "+258"
            },
            {
                "name": "Mauritania",
                "code": "MR",
                "callingCode": "+222"
            },
            {
                "name": "Montserrat",
                "code": "MS",
                "callingCode": "+1664"
            },
            {
                "name": "Martinique",
                "code": "MQ",
                "callingCode": "+596"
            },
            {
                "name": "Mauritius",
                "code": "MU",
                "callingCode": "+230"
            },
            {
                "name": "Malawi",
                "code": "MW",
                "callingCode": "+265"
            },
            {
                "name": "Malaysia",
                "code": "MY",
                "callingCode": "+60"
            },
            {
                "name": "Mayotte",
                "code": "YT",
                "callingCode": "+262"
            },
            {
                "name": "Namibia",
                "code": "NA",
                "callingCode": "+264"
            },
            {
                "name": "New Caledonia",
                "code": "NC",
                "callingCode": "+687"
            },
            {
                "name": "Niger",
                "code": "NE",
                "callingCode": "+227"
            },
            {
                "name": "Norfolk Island",
                "code": "NF",
                "callingCode": "+672"
            },
            {
                "name": "Nigeria",
                "code": "NG",
                "callingCode": "+234"
            },
            {
                "name": "Nicaragua",
                "code": "NI",
                "callingCode": "+505"
            },
            {
                "name": "Niue",
                "code": "NU",
                "callingCode": "+683"
            },
            {
                "name": "Netherlands",
                "code": "NL",
                "callingCode": "+31"
            },
            {
                "name": "Norway",
                "code": "NO",
                "callingCode": "+47"
            },
            {
                "name": "Nepal",
                "code": "NP",
                "callingCode": "+977"
            },
            {
                "name": "Nauru",
                "code": "NR",
                "callingCode": "+674"
            },
            {
                "name": "New Zealand",
                "code": "NZ",
                "callingCode": "+64"
            },
            {
                "name": "Oman",
                "code": "OM",
                "callingCode": "+968"
            },
            {
                "name": "Pakistan",
                "code": "PK",
                "callingCode": "+92"
            },
            {
                "name": "Panama",
                "code": "PA",
                "callingCode": "+507"
            },
            {
                "name": "Pitcairn Islands",
                "code": "PN",
                "callingCode": "+64"
            },
            {
                "name": "Peru",
                "code": "PE",
                "callingCode": "+51"
            },
            {
                "name": "Philippines",
                "code": "PH",
                "callingCode": "+63"
            },
            {
                "name": "Palau",
                "code": "PW",
                "callingCode": "+680"
            },
            {
                "name": "Papua New Guinea",
                "code": "PG",
                "callingCode": "+675"
            },
            {
                "name": "Poland",
                "code": "PL",
                "callingCode": "+48"
            },
            {
                "name": "Puerto Rico",
                "code": "PR",
                "callingCode": "+1787"
            },
            {
                "name": "Puerto Rico",
                "code": "PR",
                "callingCode": "+1939"
            },
            {
                "name": "North Korea",
                "code": "KP",
                "callingCode": "+850"
            },
            {
                "name": "Portugal",
                "code": "PT",
                "callingCode": "+351"
            },
            {
                "name": "Paraguay",
                "code": "PY",
                "callingCode": "+595"
            },
            {
                "name": "Palestine",
                "code": "PS",
                "callingCode": "+970"
            },
            {
                "name": "French Polynesia",
                "code": "PF",
                "callingCode": "+689"
            },
            {
                "name": "Qatar",
                "code": "QA",
                "callingCode": "+974"
            },
            {
                "name": "RÃ©union",
                "code": "RE",
                "callingCode": "+262"
            },
            {
                "name": "Romania",
                "code": "RO",
                "callingCode": "+40"
            },
            {
                "name": "Russia",
                "code": "RU",
                "callingCode": "+7"
            },
            {
                "name": "Rwanda",
                "code": "RW",
                "callingCode": "+250"
            },
            {
                "name": "Saudi Arabia",
                "code": "SA",
                "callingCode": "+966"
            },
            {
                "name": "Sudan",
                "code": "SD",
                "callingCode": "+249"
            },
            {
                "name": "Senegal",
                "code": "SN",
                "callingCode": "+221"
            },
            {
                "name": "Singapore",
                "code": "SG",
                "callingCode": "+65"
            },
            {
                "name": "South Georgia",
                "code": "GS",
                "callingCode": "+500"
            },
            {
                "name": "Svalbard and Jan Mayen",
                "code": "SJ",
                "callingCode": "+4779"
            },
            {
                "name": "Solomon Islands",
                "code": "SB",
                "callingCode": "+677"
            },
            {
                "name": "Sierra Leone",
                "code": "SL",
                "callingCode": "+232"
            },
            {
                "name": "El Salvador",
                "code": "SV",
                "callingCode": "+503"
            },
            {
                "name": "San Marino",
                "code": "SM",
                "callingCode": "+378"
            },
            {
                "name": "Somalia",
                "code": "SO",
                "callingCode": "+252"
            },
            {
                "name": "Saint Pierre and Miquelon",
                "code": "PM",
                "callingCode": "+508"
            },
            {
                "name": "Serbia",
                "code": "RS",
                "callingCode": "+381"
            },
            {
                "name": "South Sudan",
                "code": "SS",
                "callingCode": "+211"
            },
            {
                "name": "SÃ£o TomÃ© and PrÃ­ncipe",
                "code": "ST",
                "callingCode": "+239"
            },
            {
                "name": "Suriname",
                "code": "SR",
                "callingCode": "+597"
            },
            {
                "name": "Slovakia",
                "code": "SK",
                "callingCode": "+421"
            },
            {
                "name": "Slovenia",
                "code": "SI",
                "callingCode": "+386"
            },
            {
                "name": "Sweden",
                "code": "SE",
                "callingCode": "+46"
            },
            {
                "name": "Swaziland",
                "code": "SZ",
                "callingCode": "+268"
            },
            {
                "name": "Sint Maarten",
                "code": "SX",
                "callingCode": "+1721"
            },
            {
                "name": "Seychelles",
                "code": "SC",
                "callingCode": "+248"
            },
            {
                "name": "Syria",
                "code": "SY",
                "callingCode": "+963"
            },
            {
                "name": "Turks and Caicos Islands",
                "code": "TC",
                "callingCode": "+1649"
            },
            {
                "name": "Chad",
                "code": "TD",
                "callingCode": "+235"
            },
            {
                "name": "Togo",
                "code": "TG",
                "callingCode": "+228"
            },
            {
                "name": "Thailand",
                "code": "TH",
                "callingCode": "+66"
            },
            {
                "name": "Tajikistan",
                "code": "TJ",
                "callingCode": "+992"
            },
            {
                "name": "Tokelau",
                "code": "TK",
                "callingCode": "+690"
            },
            {
                "name": "Turkmenistan",
                "code": "TM",
                "callingCode": "+993"
            },
            {
                "name": "Timor-Leste",
                "code": "TL",
                "callingCode": "+670"
            },
            {
                "name": "Tonga",
                "code": "TO",
                "callingCode": "+676"
            },
            {
                "name": "Trinidad and Tobago",
                "code": "TT",
                "callingCode": "+1868"
            },
            {
                "name": "Tunisia",
                "code": "TN",
                "callingCode": "+216"
            },
            {
                "name": "Turkiye",
                "code": "TR",
                "callingCode": "+90"
            },
            {
                "name": "Tuvalu",
                "code": "TV",
                "callingCode": "+688"
            },
            {
                "name": "Taiwan",
                "code": "TW",
                "callingCode": "+886"
            },
            {
                "name": "Tanzania",
                "code": "TZ",
                "callingCode": "+255"
            },
            {
                "name": "Uganda",
                "code": "UG",
                "callingCode": "+256"
            },
            {
                "name": "Ukraine",
                "code": "UA",
                "callingCode": "+380"
            },
            {
                "name": "Uruguay",
                "code": "UY",
                "callingCode": "+598"
            },
            {
                "name": "United States",
                "code": "US",
                "callingCode": "+1"
            },
            {
                "name": "Uzbekistan",
                "code": "UZ",
                "callingCode": "+998"
            },
            {
                "name": "Vatican City",
                "code": "VA",
                "callingCode": "+379"
            },
            {
                "name": "Saint Vincent and the Grenadines",
                "code": "VC",
                "callingCode": "+1784"
            },
            {
                "name": "Venezuela",
                "code": "VE",
                "callingCode": "+58"
            },
            {
                "name": "British Virgin Islands",
                "code": "VG",
                "callingCode": "+1284"
            },
            {
                "name": "United States Virgin Islands",
                "code": "VI",
                "callingCode": "+1340"
            },
            {
                "name": "Vietnam",
                "code": "VN",
                "callingCode": "+84"
            },
            {
                "name": "Vanuatu",
                "code": "VU",
                "callingCode": "+678"
            },
            {
                "name": "Wallis and Futuna",
                "code": "WF",
                "callingCode": "+681"
            },
            {
                "name": "Samoa",
                "code": "WS",
                "callingCode": "+685"
            },
            {
                "name": "Yemen",
                "code": "YE",
                "callingCode": "+967"
            },
            {
                "name": "South Africa",
                "code": "ZA",
                "callingCode": "+27"
            },
            {
                "name": "Zambia",
                "code": "ZM",
                "callingCode": "+260"
            },
            {
                "name": "Zimbabwe",
                "code": "ZW",
                "callingCode": "+263"
            }
        ];
    }
})();
/**
 * @file Language Select Directive
 * @description This file contains the implementation of language select directive in an AngularJS application.
 * The directive allows the user to select a language from a dropdown menu and change the language of the application.
 * It also includes functions to convert language codes to locale keys and vice versa.
 * The file also includes a run block that handles language change events and updates the user's language preference.
 * @module app.locale
 */
(function () {
    'use strict';

    // WebView detection utility function
    window.isWebView = function() {
        // iOS WebView detection (Banking apps like Yapı Kredi, İşCep)
        if (window.webkit && window.webkit.messageHandlers) {
            return true;
        }
        
        // Android WebView detection (Banking apps like Yapı Kredi, İşCep)
        if (window.miniapp || window.myJSHandler) {
            return true;
        }
        
        return false;
    };

    window.langCode = function (_localeKey) {
        switch (_localeKey || window.lang) {
            case 'tr':
                return 1;
            case 'en':
                return 2;
            case 'es-ES':
                return 3;
            case 'pt-PT':
                return 4;
            default:
                return 1;
        }
    };
    window.langIso = function (backend_key) {
        switch (backend_key) {
            case 1:
                return 'tr';
            case 2:
                return 'en';
            case 3:
                return 'es-ES';
            case 4:
                return 'pt-PT';
            default:
                return 'tr';
        }
    };

    window.countryIso = function (backend_key) {
        switch (backend_key) {
            case 1:
                return 'turkiye';
            case 2:
                return 'espana';
            case 3:
                return 'portugal';
            default:
                return 'turkiye';
        }
    };

    angular.module("app.locale").run(['user_factory', '$state', 'LocaleService', '$rootScope', '$interval', '$stateParams', '$translate', 'userSvc', '$q', 'CacheFactory', '$timeout', function (user_factory, $state, LocaleService, $rootScope, $interval, $stateParams, $translate, userSvc, $q, CacheFactory, $timeout) {
        $rootScope.changeLanguageRoot = function (locale, code) {
            var localeKey;
            if (!code) {
                if (locale === 'Türkçe') {
                    localeKey = 'tr';
                } else if (locale === 'English') {
                    localeKey = 'en';
                } else if (locale === 'Español') {
                    localeKey = 'es-ES';
                } else if (locale === 'Português') {
                    localeKey = 'pt-PT';
                }
            }
            else {
                localeKey = code;
                if (localeKey === 'tr') {
                    locale = 'Türkçe';
                } else if (localeKey === 'en') {
                    locale = 'English';
                } else if (localeKey === 'es-ES') {
                    locale = 'Español';
                } else if (localeKey === 'pt-PT') {
                    locale = 'Português';
                }
            }

            if (localeKey === $translate.use()) return;


            $rootScope.changeCurrency(localeKey === "tr" ? "TRY" : "EUR", true);

            $rootScope.country = localeKey === 'pt-PT' ? 'portugal' : localeKey === 'es-ES' ? 'espana' : localeKey === 'tr' ? 'turkiye' : 'world';

            var updatedUser = updateLang(localeKey);
            updatedUser.then(function () {
                var clone = angular.copy($stateParams);
                clone.langcode = localeKey;
                window.localStorage.setItem('Language', localeKey);

                var translated = 0;
                LocaleService.setLocaleByDisplayName(locale).then(function () {
                    const name = $state.current.name.split('.')[0];
                    $timeout(function () {
                        if (clone.path) {
                            $translate(name).then(function (translation) {
                                clone.path = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                        if (clone.path2) {
                            const name2 = $state.current.name.split('.')[1];
                            $translate(name2).then(function (translation) {
                                clone.path2 = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                        if (clone.path3) {
                            const name3 = $state.current.name.split('.')[2];
                            $translate(name3).then(function (translation) {
                                clone.path3 = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;

                        if (clone.satilik) {
                            $translate(clone.satilik).then(function (translation) {
                                clone.satilik = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;

                        if (clone.konut) {
                            $translate(clone.konut).then(function (translation) {
                                clone.konut = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                    });

                    if (name !== "publishlisting")
                        var inter = $interval(function () {
                            if (translated === 5) {
                                $interval.cancel(inter);
                                if (name === "analysis" || name === 'atlas') {
                                    // Check if coming from banking app WebView
                                    if (window.isWebView()) {
                                        return;
                                    } else {
                                        // Normal browser: use window.location.href (required for map rendering)
                                        window.location.href = $state.href($state.current.name, clone);
                                    }
                                }
                                else {
                                    $state.go($state.current.name, clone, { notify: true, reload: true, inherit: false });
                                }
                            }
                        });
                });
                $rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
            });
        };

        function updateLang(_localeKey) {
            var deferred = $q.defer();
            const code = window.langCode(_localeKey);
            if (userSvc.info.SignedIn && userSvc.info.Details.language !== code) {
                userSvc.info.Details.language = code;
                user_factory.language({ language: code }).$promise.then(null,
                    function () {
                        userSvc.info.SignedIn = false;
                        $rootScope.SignedIn = false;
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                    }
                ).finally(function () {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        $rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();

    }]);



    angular.module('app.locale')
        .directive('languageSelect', [languageSelect]);

    angular.module('app.locale')
        .directive('languageSelectTop', [languageSelectTop]);

    function languageSelect() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<div id="mtranslateMenu">' +
                '<select selectpicker class="select-lang" ng-model="$root.currentLocaleDisplayName"' +
                'ng-change="$root.changeLanguageRoot($root.currentLocaleDisplayName)">' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'English\'" value="English" data-content="<span class=\'flag-icon flag-icon-us\'></span> <span class=\'couname\'>English</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Español\'" value="Español" data-content="<span class=\'flag-icon flag-icon-es\'></span> <span class=\'couname\'>Español</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Português\'" value="Português" data-content="<span class=\'flag-icon flag-icon-pt\'></span> <span class=\'couname\'>Português</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Türkçe\'" value="Türkçe" data-content="<span class=\'flag-icon flag-icon-tr\'></span> <span class=\'couname\'>Türkçe</span>"></option>' +
                '</select>' +
                '</div>'
        };

        return directive;
    }

    function languageSelectTop() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<ul class="subnav" id="translateMenu">' +
                '<li class="{{$root.currentLocaleDisplayName == \'English\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'English\')"><span class="flag-icon flag-icon-us"></span> <span class="couname">English</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Español\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Español\')"><span class="flag-icon flag-icon-es"></span> <span class="couname">Español</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Português\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Português\')"><span class="flag-icon flag-icon-pt"></span> <span class="couname">Português</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Türkçe\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Türkçe\')"><span class="flag-icon flag-icon-tr"></span> <span class="couname">Türkçe</span></a></li>' +
                '</ul>'
        };

        return directive;
    }
})();
/**
 * This file contains AngularJS filters and utility functions related to currency conversion and formatting.
 * 
 * @module app.locale
 * @requires angular
 * @requires app.locale
 * @requires $window
 * @requires moment
 * @requires Exchange
 * @requires $rootScope
 * @requires $state
 * @requires userSvc
 * @requires user_factory
 * @requires CacheFactory
 */
(function () {

    angular.module('app.locale')
        .filter("currencyConverter", ['$window', function ($window) {
            return function (value, currentCurrency, showSymbol, decimalPlaces, isNumber, autoRemoveDecimal, formatLargeNumber) {
                return $window.currencyConverter(value, currentCurrency, showSymbol, decimalPlaces, isNumber, autoRemoveDecimal, formatLargeNumber);
            };
        }]);

    angular.module('app.locale')
        .filter("currencyConverterTrend", ['$window', function ($window) {
            return function (value, currentCurrency, month, year) {
                return (+$window.currencyConverterTrend(value, currentCurrency, month, year)).toLocaleString($window.lang);
            };
        }]);

    angular.module('app.locale')
        .filter("percentConverter", ['$window', function ($window) {
            return function (percent, currentCurrency, month, year, monthBack, price) {
                return $window.percentConverter(percent, currentCurrency, month, year, monthBack, price);
            };
        }]);

    angular.module('app.locale')
        .filter("percent", [function () {
            return function (value, decimalPlaces) {
                value = value || 0;
                decimalPlaces = decimalPlaces || 0;
                return value.toFixed(decimalPlaces) !== 0 ? window.lang !== 'tr' ? (+value.toFixed(decimalPlaces) + '%') : ('%' + value.toFixed(decimalPlaces).replace('.', ',')) : 0;
            };
        }]);

    angular.module('app.locale')
        .filter("decimal", [function () {
            return function (value, decimalPlaces) {
                value = value || 0;
                decimalPlaces = decimalPlaces || 0;
                if (+value % 1 === 0)
                    return window.lang === 'tr' ? (+value).formatMoney(0, ",", ".") : (+value).formatMoney(0, ".", ",");
                else
                    return window.lang === 'tr' ? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(decimalPlaces, ".", ",");
            };
        }]);

    window.currencyIso = function (code) {
        switch (code) {
            case 1:
                return 'TRY';
            case 2:
                return 'USD';
            case 3:
                return 'EUR';
            default:
                return 'TRY';
        }
    };
    window.currencyEndeksaCode = function (code) {
        switch (code) {
            case 'TRY':
                return 1;
            case 'USD':
                return 2;
            case 'EUR':
                return 3;
            default:
                return 1;
        }
    };
    window.currencySymbolByIsoCode = function (code) {
        switch (code) {
            case 'TRY':
                return '₺';
            case 'USD':
                return '$';
            case 'EUR':
                return '€';
            default:
                return '₺';
        }
    };

    window.currencySymbolByEndeksaCode = function (code) {
        switch (code) {
            case 1:
                return '₺';
            case 2:
                return '$';
            case 3:
                return '€';
            default:
                return '₺';
        }
    };

    function formatLargeNumberTr(value, decimalPlaces) {
        function million(){
            return window.lang === "pt-PT" ? "mi" : "M"
        }
        function billion(){
            return window.lang === "pt-PT" ? "bi" : window.lang==="es-ES" ? "MRD" : window.lang === "tr" ? "Mr" : "B"
        }
        function trillion(){
            return window.lang === "pt-PT" ? "tri" : window.lang==="es-ES" ? "B" : window.lang === "tr" ? "Tn" : "T"
        }
        if (+value >= 1e12) {
            return (window.lang === 'tr'? (+value / 1e12).formatMoney(2, ",", ".") : (+value / 1e12).formatMoney(2, ".", ",")) + trillion();
        } else if (+value >= 1e9) {
            return (window.lang === 'tr'? (+value / 1e9).formatMoney(2, ",", ".") : (+value / 1e9).formatMoney(2, ".", ",")) + billion();
        } else if (+value >= 1e6) {
            return (window.lang === 'tr'? (+value / 1e6).formatMoney(2, ",", ".") : (+value / 1e6).formatMoney(2, ".", ",")) + million() ;
        } else {
            return window.lang === 'tr'? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(decimalPlaces, ".", ",");
        }
    }

    // Path: client/app/currencyConverter.js
    // Usage: {{ 100 | currencyConverter:'USD':false:2:true:true }}
    window.currencyConverter = function (value, currentCurrency, addSymbolAfter, decimalPlaces, returnNumber, autoRemoveDecimal, formatLargeNumber) {
        value = value || 0;
        decimalPlaces = decimalPlaces || 0;
        formatLargeNumber = formatLargeNumber || 0;

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        if (window.currencyRates && currentCurrency !== value)
            if (currentCurrency === "TRY") {
                if (window.currency === "USD")
                    value = value / window.currencyRates.usd;
                else if (window.currency === "EUR")
                    value = value / window.currencyRates.eur;
                else
                    value = value;
            }
            else if (currentCurrency === "USD") {
                if (window.currency === "TRY")
                    value = value * window.currencyRates.usd;
                else if (window.currency === "EUR")
                    value = value * window.currencyRates.usd / window.currencyRates.eur;
                else
                    value = value;
            }
            else if (currentCurrency === "EUR") {
                if (window.currency === "TRY")
                    value = value * window.currencyRates.eur;
                else if (window.currency === "USD")
                    value = value * window.currencyRates.eur / window.currencyRates.usd;
                else
                    value = value;
            }

        if (returnNumber)
            return +value.toFixed(decimalPlaces);
        else {
            var result;
            if (autoRemoveDecimal && +value % 1 === 0)
                result = formatLargeNumber && window.currency === "TRY" ? formatLargeNumberTr(+value,0) : window.lang === 'tr' ? (+value).formatMoney(0, ",", ".") : (+value).formatMoney(0, ".", ",");
            else
                result = formatLargeNumber && window.currency === "TRY" ? formatLargeNumberTr(+value,decimalPlaces) : window.lang === 'tr' ? (+value).formatMoney(decimalPlaces, ",", ".") : (+value).formatMoney(0, ".", ",");
            if (addSymbolAfter)
                result = window.lang === 'tr' ? result + ' ' + window.currencySymbol : window.currencySymbol + result;
            return result;
        }
    };

    window.getDatedCurrency = function (month, year) {
        if (window.currencyRatesTrend && window.currencyRatesTrend.length) {
            var found = window.currencyRatesTrend.find(function (item) {
                const rateMonth = +moment(item.rateDate).format("MM");
                const rateYear = +moment(item.rateDate).format("YYYY");
                return rateMonth === month && rateYear === year;
            });
            if (!found) {
                if (+moment(window.currencyRatesTrend[0].rateDate).format("YYYY") >= year)
                    found = window.currencyRatesTrend[0];
                else
                    found = window.currencyRatesTrend[window.currencyRatesTrend.length - 1];
            }
            return found;
        }
        else
            return window.currencyRates;
    };

    window.percentConverter = function (percent, currentCurrency, month, year, monthBack, price) {
        var previous_price = price / (1 + percent / 100);

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        const getDatedCurrency = window.getDatedCurrency(month, year);
        const minusYear = Math.floor(monthBack / 12);
        const minusMonth = monthBack % 12;

        const getPastDatedCurrency = window.getDatedCurrency(month - minusMonth, year - minusYear);

        if (currentCurrency === "TRY") {
            if (window.currency === "USD") {
                price = price / getDatedCurrency.usd;
                previous_price = previous_price / getPastDatedCurrency.usd;
            }
            else if (window.currency === "EUR") {
                price = price / getDatedCurrency.eur;
                previous_price = previous_price / getPastDatedCurrency.eur;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        else if (currentCurrency === "USD") {
            if (window.currency === "TRY") {
                price = price * getDatedCurrency.usd;
                previous_price = previous_price * getPastDatedCurrency.usd;
            }
            else if (window.currency === "EUR") {
                price = price * getDatedCurrency.usd / getDatedCurrency.eur;
                previous_price = previous_price * getPastDatedCurrency.usd / getPastDatedCurrency.eur;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        else if (currentCurrency === "EUR") {
            if (window.currency === "TRY") {
                price = price * getDatedCurrency.eur;
                previous_price = previous_price * getPastDatedCurrency.eur;
            }
            else if (window.currency === "USD") {
                price = price * getDatedCurrency.eur / getDatedCurrency.usd;
                previous_price = previous_price * getPastDatedCurrency.eur / getPastDatedCurrency.usd;
            }
            else {
                price = price;
                previous_price = previous_price;
            }
        }
        return  (price / previous_price - 1) * 100;
    }

    window.currencyConverterTrend = function (value, currentCurrency, month, year) {
        value = value || 0;

        if (typeof currentCurrency === 'number') {
            currentCurrency = window.currencyIso(currentCurrency);
        }
        currentCurrency = currentCurrency || "TRY";

        if (window.currencyRatesTrend) {

            const getDatedCurrency = window.getDatedCurrency(month, year);

            if (getDatedCurrency)
                if (currentCurrency === "TRY") {
                    if (window.currency === "USD")
                        value = value / getDatedCurrency.usd;
                    else if (window.currency === "EUR")
                        value = value / getDatedCurrency.eur;
                    else
                        value = value;
                }
                else if (currentCurrency === "USD") {
                    if (window.currency === "TRY")
                        value = value * getDatedCurrency.usd;
                    else if (window.currency === "EUR")
                        value = value * getDatedCurrency.usd / getDatedCurrency.usd;
                    else
                        value = value;
                }
                else if (currentCurrency === "EUR") {
                    if (window.currency === "TRY")
                        value = value * getDatedCurrency.eur;
                    else if (window.currency === "USD")
                        value = value * getDatedCurrency.eur / getDatedCurrency.usd;
                    else
                        value = value;
                }
        }
        return value.toFixed(0);
    };

    angular.module("app.locale").run(['$rootScope', '$window', 'Exchange', '$state', 'userSvc', 'user_factory', 'CacheFactory', function ($rootScope, $window, Exchange, $state, userSvc, user_factory, CacheFactory) {
        $rootScope.assignCurrency = function () {
            var currency = $window.localStorage.getItem('Currency');
            if (!currency) {
                currency = window.lang === 'tr' ? 'TRY' : window.lang === 'en' ? 'USD' : 'EUR';
                $window.localStorage.setItem('Currency', currency);
            }
            $rootScope.currency = currency;
            $rootScope.currencyKey = window.currencyEndeksaCode(currency);
            $rootScope.currencySymbol = window.currencySymbolByIsoCode(currency);
            $window.currencySymbol = $rootScope.currencySymbol
            $window.currency = $rootScope.currency;

            $rootScope.currencySymbolByEndeksaCode = window.currencySymbolByEndeksaCode;

            var date = moment().format('DD.MM.YYYY');
            if (!$window.currencyRates && date) {
                Exchange.currency({ date: date }).$promise.then(function (value) {
                    $window.currencyRates = value;
                });
            }
            if (!$window.currencyRatesTrend) {
                Exchange.trend().$promise.then(function (value) {
                    $window.currencyRatesTrend = value;
                });
            }
            if (userSvc.info.SignedIn) {
                userSvc.info.Details.currency = $rootScope.currencyKey;
                user_factory.currency({ currency: $rootScope.currencyKey }).$promise.finally(function () {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                });
            }
        }

        $rootScope.changeCurrency = function (locale, withoutReload) {
            $window.localStorage.setItem('Currency', locale);
            $rootScope.assignCurrency();
            if (!withoutReload) {
                $state.reload();
            }
        };
    }]);

    angular.module('app.locale')
        .directive('currency', [currency]);

    angular.module('app.locale')
        .directive('currencyTop', [currencyTop]);

    function currency() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<div id="mcurrencyMenu">' +
                '<select selectpicker  ng-model="$root.currency" ng-change="$root.changeCurrency($root.currency)">' +
                '<option ng-selected="$root.currency == \'EUR\'" value="EUR" data-content="<span class=\'currency currency-eur\'>€</span> <span class=\'couname\'>EUR</span>"></option>' +
                '<option ng-selected="$root.currency == \'TRY\'" value="TRY" data-content="<span class=\'currency currency-try\'>₺</span> <span class=\'couname\'>TRY</span>"></option>' +
                '<option ng-selected="$root.currency == \'USD\'" value="USD" data-content="<span class=\'currency currency-usd\'>$</span> <span class=\'couname\'>USD</span>"></option>' +
                '</select>' +
                '</div>'
        };

        return directive;
    }

    function currencyTop() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<ul class="subnav" id="currencyMenu">' +
                '<li class="{{$root.currency == \'EUR\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'EUR\')"><span class="currency currency-eur">€</span> <span class="couname">EUR</span></a></li>' +
                '<li class="{{$root.currency == \'TRY\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'TRY\')"><span class="currency currency-try">₺</span> <span class="couname">TRY</span></a></li>' +
                '<li class="{{$root.currency == \'USD\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeCurrency(\'USD\')"><span class="currency currency-usd">$</span> <span class="couname">USD</span></a></li>' +
                '</ul>'
        };

        return directive;
    }
})();
angular.module('ui.bootstrap.tabindex', [])

  .directive('uibTabindexToggle', function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        attrs.$observe('disabled', function (disabled) {
          attrs.$set('tabindex', disabled ? -1 : null);
        });
      }
    };
  });
angular.module('ui.bootstrap.paging', [])
  /**
   * Helper internal service for generating common controller code between the
   * pager and pagination components
   */
  .factory('uibPaging', ['$parse', '$rootScope', '$timeout', function ($parse, $rootScope, $timeout) {
    return {
      create: function (ctrl, $scope, $attrs) {
        ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
        ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
        ctrl._watchers = [];

        ctrl.init = function (ngModelCtrl, config) {
          ctrl.ngModelCtrl = ngModelCtrl;
          ctrl.config = config;

          ngModelCtrl.$render = function () {
            ctrl.render();

            //SEO HACK! CANONICAL LINKS FOR PAGED CONTENT
            const lastPage = $scope.totalPages;
            const currentPage = $scope.page;
            $rootScope.hasNextPage = currentPage && currentPage < lastPage;
            $rootScope.hasPreviousPage = currentPage && currentPage > 1;
            $timeout(function () {
              var attr = $('#next_Can').attr('href');
              var attr2 = $('#prev_Can').attr('href');

              if (attr || attr2)
                if ($rootScope.hasNextPage && !$rootScope.hasPreviousPage) {
                  attr = window.updateQueryStringParameter(attr, 'p', currentPage + 1);
                  $('#next_Can').attr('href', attr);
                }
                else if ($rootScope.hasNextPage && $rootScope.hasPreviousPage) {
                  attr = window.updateQueryStringParameter(attr, 'p', currentPage + 1);
                  $('#next_Can').attr('href', attr);

                  attr2 = window.updateQueryStringParameter(attr2, 'p', currentPage - 1 === 1 ? undefined : currentPage - 1);
                  $('#prev_Can').attr('href', attr2);
                }
                else if (!$rootScope.hasNextPage && $rootScope.hasPreviousPage) {
                  attr2 = window.updateQueryStringParameter(attr2, 'p', currentPage - 1 === 1 ? undefined : currentPage - 1);
                  $('#prev_Can').attr('href', attr2);
                }
            });
            //SEO HACK! ENDED
          };

          if ($attrs.itemsPerPage) {
            ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
              ctrl.itemsPerPage = parseInt(value, 10);
              // $scope.totalPages = ctrl.calculateTotalPages();
              // ctrl.updatePage();
            }));
          } else {
            ctrl.itemsPerPage = config.itemsPerPage;
          }

          ctrl._watchers.push($scope.$watch('totalItems', function (newTotal, oldTotal) {
            if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
              $scope.totalPages = ctrl.calculateTotalPages();
              ctrl.updatePage();
            }
          }));
        };

        ctrl.calculateTotalPages = function () {
          var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
          return Math.max(totalPages || 0, 1);
        };

        ctrl.render = function () {
          $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
        };

        $scope.selectPage = function (page, evt) {
          if (evt) {
            evt.preventDefault();
          }

          var clickAllowed = !$scope.ngDisabled || !evt;
          if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
            if (evt && evt.target) {
              evt.target.blur();
            }
            ctrl.ngModelCtrl.$setViewValue(page);
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.getText = function (key) {
          return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
        };

        $scope.noPrevious = function () {
          return $scope.page === 1;
        };

        $scope.noNext = function () {
          return $scope.page === $scope.totalPages;
        };

        ctrl.updatePage = function () {
          ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

          if ($scope.page > $scope.totalPages) {
            $scope.selectPage($scope.totalPages);
          } else {
            ctrl.ngModelCtrl.$render();
          }
        };

        $scope.$on('$destroy', function () {
          $rootScope.hasNextPage = 0;
          $rootScope.hasPreviousPage = 0;
          while (ctrl._watchers.length) {
            ctrl._watchers.shift()();
          }
        });
      }
    };
  }]);
angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
  .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
    var ctrl = this;
    // Setup configuration parameters
    var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) { return $scope.$parent.$eval($attrs.pageLabel, { $page: idx }); } : angular.identity;
    $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
    $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
    $attrs.$set('role', 'menu');

    uibPaging.create(this, $scope, $attrs);

    if ($attrs.maxSize) {
      ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
        maxSize = parseInt(value, 10);
        ctrl.render();
      }));
    }

    // Create page object used in template
    function makePage(number, text, isActive) {
      return {
        number: number,
        text: text,
        active: isActive
      };
    }

    function getPages(currentPage, totalPages) {
      var pages = [];

      // Default page limits
      var startPage = 1, endPage = totalPages;
      var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

      // recompute if maxSize
      if (isMaxSized) {
        if (rotate) {
          // Current page is displayed in the middle of the visible ones
          startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
          endPage = startPage + maxSize - 1;

          // Adjust if limit is exceeded
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = endPage - maxSize + 1;
          }
        } else {
          // Visible pages are paginated with maxSize
          startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

          // Adjust last page if limit is exceeded
          endPage = Math.min(startPage + maxSize - 1, totalPages);
        }
      }

      // Add page number links
      for (var number = startPage; number <= endPage; number++) {
        var page = makePage(number, pageLabel(number), number === currentPage);
        pages.push(page);
      }

      // Add links to move between page sets
      if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
        if (startPage > 1) {
          if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }
          if (boundaryLinkNumbers) {
            if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
              var secondPageLink = makePage(2, '2', false);
              pages.unshift(secondPageLink);
            }
            //add the first page
            var firstPageLink = makePage(1, '1', false);
            pages.unshift(firstPageLink);
          }
        }

        if (endPage < totalPages) {
          if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
          if (boundaryLinkNumbers) {
            if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
              var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
              pages.push(secondToLastPageLink);
            }
            //add the last page
            var lastPageLink = makePage(totalPages, totalPages, false);
            pages.push(lastPageLink);
          }
        }
      }
      return pages;
    }

    var originalRender = this.render;
    this.render = function () {
      originalRender();
      if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
        $scope.pages = getPages($scope.page, $scope.totalPages);
      }
    };
  }])

  .constant('uibPaginationConfig', {
    itemsPerPage: 10,
    boundaryLinks: false,
    boundaryLinkNumbers: false,
    directionLinks: true,
    firstText: 'First',
    previousText: 'Previous',
    nextText: 'Next',
    lastText: 'Last',
    rotate: true,
    forceEllipses: false
  })

  .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
    return {
      scope: {
        totalItems: '=',
        firstText: '@',
        previousText: '@',
        nextText: '@',
        lastText: '@',
        ngDisabled: '='
      },
      require: ['uibPagination', '?ngModel'],
      restrict: 'A',
      controller: 'UibPaginationController',
      controllerAs: 'pagination',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || '/app/common/pagination.html';
      },
      link: function (scope, element, attrs, ctrls) {
        element.addClass('pagination');
        var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
      }
    };
  }]);